"use strict";
(self["webpackChunkapp_bedrock_rdk"] = self["webpackChunkapp_bedrock_rdk"] || []).push([[427],{

/***/ 37791:
/***/ ((module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _object_spread = __webpack_require__(76247);
var _set = __webpack_require__(81364);
var _to_consumable_array = __webpack_require__(30005);
var _type_of = __webpack_require__(99010);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
/**
 * Lightning v2.9.0
 *
 * https://github.com/rdkcentral/Lightning
 */ (function(global1, factory) {
     true ? module.exports = factory() : 0;
})(void 0, function() {
    "use strict";
    var StageUtils = /*#__PURE__*/ function() {
        function StageUtils() {
            _class_call_check._(this, StageUtils);
        }
        _create_class._(StageUtils, null, [
            {
                key: "mergeNumbers",
                value: function mergeNumbers(v1, v2, p) {
                    return v1 * p + v2 * (1 - p);
                }
            },
            {
                key: "rgb",
                value: function rgb(r, g, b) {
                    return (r << 16) + (g << 8) + b + 255 * 16777216;
                }
            },
            {
                key: "rgba",
                value: function rgba(r, g, b, a) {
                    return (r << 16) + (g << 8) + b + (a * 255 | 0) * 16777216;
                }
            },
            {
                key: "getRgbString",
                value: function getRgbString(color) {
                    var r = (color / 65536 | 0) % 256;
                    var g = (color / 256 | 0) % 256;
                    var b = color % 256;
                    return "rgb(" + r + "," + g + "," + b + ")";
                }
            },
            {
                key: "getRgbaString",
                value: function getRgbaString(color) {
                    var r = (color / 65536 | 0) % 256;
                    var g = (color / 256 | 0) % 256;
                    var b = color % 256;
                    var a = (color / 16777216 | 0) / 255;
                    return "rgba(" + r + "," + g + "," + b + "," + a.toFixed(4) + ")";
                }
            },
            {
                key: "getRgbaStringFromArray",
                value: function getRgbaStringFromArray(color) {
                    var r = Math.floor(color[0] * 255);
                    var g = Math.floor(color[1] * 255);
                    var b = Math.floor(color[2] * 255);
                    var a = Math.floor(color[3] * 255) / 255;
                    return "rgba(" + r + "," + g + "," + b + "," + a.toFixed(4) + ")";
                }
            },
            {
                key: "getRgbaComponentsNormalized",
                value: function getRgbaComponentsNormalized(argb) {
                    var r = (argb / 65536 | 0) % 256;
                    var g = (argb / 256 | 0) % 256;
                    var b = argb % 256;
                    var a = argb / 16777216 | 0;
                    return [
                        r / 255,
                        g / 255,
                        b / 255,
                        a / 255
                    ];
                }
            },
            {
                key: "getRgbComponentsNormalized",
                value: function getRgbComponentsNormalized(argb) {
                    var r = (argb / 65536 | 0) % 256;
                    var g = (argb / 256 | 0) % 256;
                    var b = argb % 256;
                    return [
                        r / 255,
                        g / 255,
                        b / 255
                    ];
                }
            },
            {
                key: "getRgbaComponents",
                value: function getRgbaComponents(argb) {
                    var r = (argb / 65536 | 0) % 256;
                    var g = (argb / 256 | 0) % 256;
                    var b = argb % 256;
                    var a = argb / 16777216 | 0;
                    return [
                        r,
                        g,
                        b,
                        a
                    ];
                }
            },
            {
                key: "getArgbNumber",
                value: function getArgbNumber(rgba) {
                    rgba[0] = Math.max(0, Math.min(255, rgba[0]));
                    rgba[1] = Math.max(0, Math.min(255, rgba[1]));
                    rgba[2] = Math.max(0, Math.min(255, rgba[2]));
                    rgba[3] = Math.max(0, Math.min(255, rgba[3]));
                    var v = ((rgba[3] | 0) << 24) + ((rgba[0] | 0) << 16) + ((rgba[1] | 0) << 8) + (rgba[2] | 0);
                    if (v < 0) {
                        v = 0xFFFFFFFF + v + 1;
                    }
                    return v;
                }
            },
            {
                key: "mergeColors",
                value: function mergeColors(c1, c2, p) {
                    var r1 = (c1 / 65536 | 0) % 256;
                    var g1 = (c1 / 256 | 0) % 256;
                    var b1 = c1 % 256;
                    var a1 = c1 / 16777216 | 0;
                    var r2 = (c2 / 65536 | 0) % 256;
                    var g2 = (c2 / 256 | 0) % 256;
                    var b2 = c2 % 256;
                    var a2 = c2 / 16777216 | 0;
                    var r = r1 * p + r2 * (1 - p);
                    var g = g1 * p + g2 * (1 - p);
                    var b = b1 * p + b2 * (1 - p);
                    var a = a1 * p + a2 * (1 - p);
                    return Math.round(a) * 16777216 + Math.round(r) * 65536 + Math.round(g) * 256 + Math.round(b);
                }
            },
            {
                key: "mergeMultiColors",
                value: function mergeMultiColors(c, p) {
                    var r = 0, g = 0, b = 0, a = 0, t = 0;
                    var n = c.length;
                    for(var i = 0; i < n; i++){
                        var r1 = (c[i] / 65536 | 0) % 256;
                        var g1 = (c[i] / 256 | 0) % 256;
                        var b1 = c[i] % 256;
                        var a1 = c[i] / 16777216 | 0;
                        r += r1 * p[i];
                        g += g1 * p[i];
                        b += b1 * p[i];
                        a += a1 * p[i];
                        t += p[i];
                    }
                    t = 1 / t;
                    return Math.round(a * t) * 16777216 + Math.round(r * t) * 65536 + Math.round(g * t) * 256 + Math.round(b * t);
                }
            },
            {
                key: "mergeMultiColorsEqual",
                value: function mergeMultiColorsEqual(c) {
                    var r = 0, g = 0, b = 0, a = 0, t = 0;
                    var n = c.length;
                    for(var i = 0; i < n; i++){
                        var r1 = (c[i] / 65536 | 0) % 256;
                        var g1 = (c[i] / 256 | 0) % 256;
                        var b1 = c[i] % 256;
                        var a1 = c[i] / 16777216 | 0;
                        r += r1;
                        g += g1;
                        b += b1;
                        a += a1;
                        t += 1.0;
                    }
                    t = 1 / t;
                    return Math.round(a * t) * 16777216 + Math.round(r * t) * 65536 + Math.round(g * t) * 256 + Math.round(b * t);
                }
            },
            {
                key: "mergeColorAlpha",
                value: function mergeColorAlpha(c, alpha) {
                    var a = (c / 16777216 | 0) * alpha | 0;
                    return ((c >> 16 & 0xff) * a / 255 & 0xff) + ((c & 0xff00) * a / 255 & 0xff00) + (((c & 0xff) << 16) * a / 255 & 0xff0000) + (a << 24);
                }
            },
            {
                key: "rad",
                value: function rad(deg) {
                    return deg * (Math.PI / 180);
                }
            },
            {
                key: "getTimingBezier",
                value: function getTimingBezier(a, b, c, d) {
                    var xc = 3.0 * a;
                    var xb = 3.0 * (c - a) - xc;
                    var xa = 1.0 - xc - xb;
                    var yc = 3.0 * b;
                    var yb = 3.0 * (d - b) - yc;
                    var ya = 1.0 - yc - yb;
                    return function(time) {
                        if (time >= 1.0) {
                            return 1;
                        }
                        if (time <= 0) {
                            return 0;
                        }
                        var t = 0.5, cbx, cbxd, dx;
                        for(var it = 0; it < 20; it++){
                            cbx = t * (t * (t * xa + xb) + xc);
                            dx = time - cbx;
                            if (dx > -1e-8 && dx < 1e-8) {
                                return t * (t * (t * ya + yb) + yc);
                            }
                            cbxd = t * (t * (3 * xa) + 2 * xb) + xc;
                            if (cbxd > 1e-10 && cbxd < 1e-10) {
                                break;
                            }
                            t += dx / cbxd;
                        }
                        var minT = 0;
                        var maxT = 1;
                        for(var it1 = 0; it1 < 20; it1++){
                            t = 0.5 * (minT + maxT);
                            cbx = t * (t * (t * xa + xb) + xc);
                            dx = time - cbx;
                            if (dx > -1e-8 && dx < 1e-8) {
                                return t * (t * (t * ya + yb) + yc);
                            }
                            if (dx < 0) {
                                maxT = t;
                            } else {
                                minT = t;
                            }
                        }
                    };
                }
            },
            {
                key: "getTimingFunction",
                value: function getTimingFunction(str) {
                    switch(str){
                        case "linear":
                            return function(time) {
                                return time;
                            };
                        case "ease":
                            return StageUtils.getTimingBezier(0.25, 0.1, 0.25, 1.0);
                        case "ease-in":
                            return StageUtils.getTimingBezier(0.42, 0, 1.0, 1.0);
                        case "ease-out":
                            return StageUtils.getTimingBezier(0, 0, 0.58, 1.0);
                        case "ease-in-out":
                            return StageUtils.getTimingBezier(0.42, 0, 0.58, 1.0);
                        case "step-start":
                            return function() {
                                return 1;
                            };
                        case "step-end":
                            return function(time) {
                                return time === 1 ? 1 : 0;
                            };
                        default:
                            var s = "cubic-bezier(";
                            if (str && str.indexOf(s) === 0) {
                                var parts = str.substr(s.length, str.length - s.length - 1).split(",");
                                if (parts.length !== 4) {
                                    console.warn("[Lightning] Unknown timing function: " + str);
                                    return function(time) {
                                        return time;
                                    };
                                }
                                var a = parseFloat(parts[0]);
                                var b = parseFloat(parts[1]);
                                var c = parseFloat(parts[2]);
                                var d = parseFloat(parts[3]);
                                if (isNaN(a) || isNaN(b) || isNaN(c) || isNaN(d)) {
                                    console.warn("[Lightning] Unknown timing function: " + str);
                                    return function(time) {
                                        return time;
                                    };
                                }
                                return StageUtils.getTimingBezier(a, b, c, d);
                            } else {
                                console.warn("[Lightning] Unknown timing function: " + str);
                                return function(time) {
                                    return time;
                                };
                            }
                    }
                }
            }
        ]);
        return StageUtils;
    }();
    var Utils = /*#__PURE__*/ function() {
        function Utils() {
            _class_call_check._(this, Utils);
        }
        _create_class._(Utils, null, [
            {
                key: "isFunction",
                value: function isFunction(value) {
                    return typeof value === "function";
                }
            },
            {
                key: "isNumber",
                value: function isNumber(value) {
                    return typeof value === "number";
                }
            },
            {
                key: "isInteger",
                value: function isInteger(value) {
                    return typeof value === "number" && value % 1 === 0;
                }
            },
            {
                key: "isBoolean",
                value: function isBoolean(value) {
                    return value === true || value === false;
                }
            },
            {
                key: "isString",
                value: function isString(value) {
                    return typeof value === "string";
                }
            },
            {
                key: "clone",
                value: function clone(v) {
                    if (Utils.isObjectLiteral(v) || Array.isArray(v)) {
                        return Utils.getDeepClone(v);
                    } else {
                        return v;
                    }
                }
            },
            {
                key: "cloneObjShallow",
                value: function cloneObjShallow(obj) {
                    var keys = Object.keys(obj);
                    var clone = {};
                    for(var i = 0; i < keys.length; i++){
                        clone[keys[i]] = obj[keys[i]];
                    }
                    return clone;
                }
            },
            {
                key: "merge",
                value: function merge(obj1, obj2) {
                    var keys = Object.keys(obj2);
                    for(var i = 0; i < keys.length; i++){
                        obj1[keys[i]] = obj2[keys[i]];
                    }
                    return obj1;
                }
            },
            {
                key: "isObject",
                value: function isObject(value) {
                    var type = typeof value === "undefined" ? "undefined" : _type_of._(value);
                    return !!value && (type === "object" || type === "function");
                }
            },
            {
                key: "isPlainObject",
                value: function isPlainObject(value) {
                    var type = typeof value === "undefined" ? "undefined" : _type_of._(value);
                    return !!value && type === "object";
                }
            },
            {
                key: "isObjectLiteral",
                value: function isObjectLiteral(value) {
                    return typeof value === "object" && value && value.constructor === Object;
                }
            },
            {
                key: "getArrayIndex",
                value: function getArrayIndex(index, arr) {
                    return Utils.getModuloIndex(index, arr.length);
                }
            },
            {
                key: "getModuloIndex",
                value: function getModuloIndex(index, len) {
                    if (len === 0) return index;
                    while(index < 0){
                        index += Math.ceil(-index / len) * len;
                    }
                    index = index % len;
                    return index;
                }
            },
            {
                key: "getDeepClone",
                value: function getDeepClone(obj) {
                    var i, c;
                    if (Utils.isFunction(obj)) {
                        return obj;
                    }
                    if (Array.isArray(obj)) {
                        c = [];
                        var keys = Object.keys(obj);
                        for(i = 0; i < keys.length; i++){
                            c[keys[i]] = Utils.getDeepClone(obj[keys[i]]);
                        }
                        return c;
                    } else if (Utils.isObject(obj)) {
                        c = {};
                        var keys1 = Object.keys(obj);
                        for(i = 0; i < keys1.length; i++){
                            c[keys1[i]] = Utils.getDeepClone(obj[keys1[i]]);
                        }
                        return c;
                    } else {
                        return obj;
                    }
                }
            },
            {
                key: "equalValues",
                value: function equalValues(v1, v2) {
                    if ((typeof v1 === "undefined" ? "undefined" : _type_of._(v1)) !== (typeof v2 === "undefined" ? "undefined" : _type_of._(v2))) return false;
                    if (Utils.isObjectLiteral(v1)) {
                        return Utils.isObjectLiteral(v2) && Utils.equalObjectLiterals(v1, v2);
                    } else if (Array.isArray(v1)) {
                        return Array.isArray(v2) && Utils.equalArrays(v1, v2);
                    } else {
                        return v1 === v2;
                    }
                }
            },
            {
                key: "equalObjectLiterals",
                value: function equalObjectLiterals(obj1, obj2) {
                    var keys1 = Object.keys(obj1);
                    var keys2 = Object.keys(obj2);
                    if (keys1.length !== keys2.length) {
                        return false;
                    }
                    for(var i = 0, n = keys1.length; i < n; i++){
                        var k1 = keys1[i];
                        var k2 = keys2[i];
                        if (k1 !== k2) {
                            return false;
                        }
                        var v1 = obj1[k1];
                        var v2 = obj2[k2];
                        if (!Utils.equalValues(v1, v2)) {
                            return false;
                        }
                    }
                    return true;
                }
            },
            {
                key: "equalArrays",
                value: function equalArrays(v1, v2) {
                    if (v1.length !== v2.length) {
                        return false;
                    }
                    for(var i = 0, n = v1.length; i < n; i++){
                        if (!this.equalValues(v1[i], v2[i])) {
                            return false;
                        }
                    }
                    return true;
                }
            },
            {
                key: "setToArray",
                value: function setToArray(s) {
                    var result = [];
                    s.forEach(function(value) {
                        result.push(value);
                    });
                    return result;
                }
            },
            {
                key: "iteratorToArray",
                value: function iteratorToArray(iterator) {
                    var result = [];
                    var iteratorResult = iterator.next();
                    while(!iteratorResult.done){
                        result.push(iteratorResult.value);
                        iteratorResult = iterator.next();
                    }
                    return result;
                }
            },
            {
                key: "isUcChar",
                value: function isUcChar(charcode) {
                    return charcode >= 65 && charcode <= 90;
                }
            }
        ]);
        return Utils;
    }();
    Utils.isWeb = typeof window !== "undefined" && typeof sparkscene === "undefined";
    Utils.isWPE = Utils.isWeb && navigator.userAgent.indexOf("WPE") !== -1;
    Utils.isSpark = typeof sparkscene !== "undefined";
    Utils.isNode = typeof window === "undefined" || Utils.isSpark;
    Utils.isPS4 = Utils.isWeb && navigator.userAgent.indexOf("PlayStation 4") !== -1;
    Utils.isZiggo = Utils.isWeb && (navigator.userAgent.indexOf("EOSSTB") !== -1 || navigator.userAgent.indexOf("HZNSTB") !== -1);
    var Base = /*#__PURE__*/ function() {
        function Base() {
            _class_call_check._(this, Base);
        }
        _create_class._(Base, null, [
            {
                key: "defaultSetter",
                value: function defaultSetter(obj, name, value) {
                    obj[name] = value;
                }
            },
            {
                key: "patchObject",
                value: function patchObject(obj, settings) {
                    if (!Utils.isObjectLiteral(settings)) {
                        console.error("[Lightning] Settings must be object literal");
                    } else {
                        var names = Object.keys(settings);
                        for(var i = 0, n = names.length; i < n; i++){
                            var name = names[i];
                            this.patchObjectProperty(obj, name, settings[name]);
                        }
                    }
                }
            },
            {
                key: "patchObjectProperty",
                value: function patchObjectProperty(obj, name, value) {
                    var setter = obj.setSetting || Base.defaultSetter;
                    if (name.charAt(0) === "_") {
                        if (name !== "__create") {
                            console.error("[Lightning] Patch of private property '" + name + "' is not allowed");
                        }
                    } else if (name !== "type") {
                        if (Utils.isFunction(value) && value.__local) {
                            value = value.__local(obj);
                        }
                        setter(obj, name, value);
                    }
                }
            },
            {
                key: "local",
                value: function local(func) {
                    func.__local = true;
                }
            }
        ]);
        return Base;
    }();
    var SpacingCalculator = /*#__PURE__*/ function() {
        function SpacingCalculator() {
            _class_call_check._(this, SpacingCalculator);
        }
        _create_class._(SpacingCalculator, null, [
            {
                key: "getSpacing",
                value: function getSpacing(mode, numberOfItems, remainingSpace) {
                    var itemGaps = numberOfItems - 1;
                    var spacePerGap;
                    var spacingBefore, spacingBetween;
                    switch(mode){
                        case "flex-start":
                            spacingBefore = 0;
                            spacingBetween = 0;
                            break;
                        case "flex-end":
                            spacingBefore = remainingSpace;
                            spacingBetween = 0;
                            break;
                        case "center":
                            spacingBefore = remainingSpace / 2;
                            spacingBetween = 0;
                            break;
                        case "space-between":
                            spacingBefore = 0;
                            spacingBetween = Math.max(0, remainingSpace) / itemGaps;
                            break;
                        case "space-around":
                            if (remainingSpace < 0) {
                                return this.getSpacing("center", numberOfItems, remainingSpace);
                            } else {
                                spacePerGap = remainingSpace / (itemGaps + 1);
                                spacingBefore = 0.5 * spacePerGap;
                                spacingBetween = spacePerGap;
                            }
                            break;
                        case "space-evenly":
                            if (remainingSpace < 0) {
                                return this.getSpacing("center", numberOfItems, remainingSpace);
                            } else {
                                spacePerGap = remainingSpace / (itemGaps + 2);
                                spacingBefore = spacePerGap;
                                spacingBetween = spacePerGap;
                            }
                            break;
                        case "stretch":
                            spacingBefore = 0;
                            spacingBetween = 0;
                            break;
                        default:
                            throw new Error("Unknown mode: " + mode);
                    }
                    return {
                        spacingBefore: spacingBefore,
                        spacingBetween: spacingBetween
                    };
                }
            }
        ]);
        return SpacingCalculator;
    }();
    var ContentAligner = /*#__PURE__*/ function() {
        function ContentAligner(layout) {
            _class_call_check._(this, ContentAligner);
            this._layout = layout;
            this._totalCrossAxisSize = 0;
        }
        _create_class._(ContentAligner, [
            {
                key: "_lines",
                get: function get() {
                    return this._layout._lines;
                }
            },
            {
                key: "init",
                value: function init() {
                    this._totalCrossAxisSize = this._getTotalCrossAxisSize();
                }
            },
            {
                key: "align",
                value: function align() {
                    var crossAxisSize = this._layout.crossAxisSize;
                    var remainingSpace = crossAxisSize - this._totalCrossAxisSize;
                    var _this__getSpacing = this._getSpacing(remainingSpace), spacingBefore = _this__getSpacing.spacingBefore, spacingBetween = _this__getSpacing.spacingBetween;
                    var lines = this._lines;
                    var mode = this._layout._flexContainer.alignContent;
                    var growSize = 0;
                    if (mode === "stretch" && lines.length && remainingSpace > 0) {
                        growSize = remainingSpace / lines.length;
                    }
                    var currentPos = spacingBefore;
                    for(var i = 0, n = lines.length; i < n; i++){
                        var crossAxisLayoutOffset = currentPos;
                        var aligner = lines[i].createItemAligner();
                        var finalCrossAxisLayoutSize = lines[i].crossAxisLayoutSize + growSize;
                        aligner.setCrossAxisLayoutSize(finalCrossAxisLayoutSize);
                        aligner.setCrossAxisLayoutOffset(crossAxisLayoutOffset);
                        aligner.align();
                        if (aligner.recursiveResizeOccured) {
                            lines[i].setItemPositions();
                        }
                        currentPos += finalCrossAxisLayoutSize;
                        currentPos += spacingBetween;
                    }
                }
            },
            {
                key: "totalCrossAxisSize",
                get: function get() {
                    return this._totalCrossAxisSize;
                }
            },
            {
                key: "_getTotalCrossAxisSize",
                value: function _getTotalCrossAxisSize() {
                    var lines = this._lines;
                    var total = 0;
                    for(var i = 0, n = lines.length; i < n; i++){
                        var line = lines[i];
                        total += line.crossAxisLayoutSize;
                    }
                    return total;
                }
            },
            {
                key: "_getSpacing",
                value: function _getSpacing(remainingSpace) {
                    var mode = this._layout._flexContainer.alignContent;
                    var numberOfItems = this._lines.length;
                    return SpacingCalculator.getSpacing(mode, numberOfItems, remainingSpace);
                }
            }
        ]);
        return ContentAligner;
    }();
    var FlexUtils = /*#__PURE__*/ function() {
        function FlexUtils() {
            _class_call_check._(this, FlexUtils);
        }
        _create_class._(FlexUtils, null, [
            {
                key: "getParentAxisSizeWithPadding",
                value: function getParentAxisSizeWithPadding(item, horizontal) {
                    var target = item.target;
                    var parent = target.getParent();
                    if (!parent) {
                        return 0;
                    } else {
                        var flexParent = item.flexParent;
                        if (flexParent) {
                            return this.getAxisLayoutSize(flexParent, horizontal) + this.getTotalPadding(flexParent, horizontal);
                        } else {
                            return horizontal ? parent.w : parent.h;
                        }
                    }
                }
            },
            {
                key: "getRelAxisSize",
                value: function getRelAxisSize(item, horizontal) {
                    if (horizontal) {
                        if (item.funcW) {
                            if (this._allowRelAxisSizeFunction(item, true)) {
                                return item.funcW(this.getParentAxisSizeWithPadding(item, true));
                            } else {
                                return 0;
                            }
                        } else {
                            return item.originalWidth;
                        }
                    } else {
                        if (item.funcH) {
                            if (this._allowRelAxisSizeFunction(item, false)) {
                                return item.funcH(this.getParentAxisSizeWithPadding(item, false));
                            } else {
                                return 0;
                            }
                        } else {
                            return item.originalHeight;
                        }
                    }
                }
            },
            {
                key: "_allowRelAxisSizeFunction",
                value: function _allowRelAxisSizeFunction(item, horizontal) {
                    var flexParent = item.flexParent;
                    if (flexParent && flexParent._flex._layout.isAxisFitToContents(horizontal)) {
                        return false;
                    }
                    return true;
                }
            },
            {
                key: "isZeroAxisSize",
                value: function isZeroAxisSize(item, horizontal) {
                    if (horizontal) {
                        return !item.originalWidth && !item.funcW;
                    } else {
                        return !item.originalHeight && !item.funcH;
                    }
                }
            },
            {
                key: "getAxisLayoutPos",
                value: function getAxisLayoutPos(item, horizontal) {
                    return horizontal ? item.x : item.y;
                }
            },
            {
                key: "getAxisLayoutSize",
                value: function getAxisLayoutSize(item, horizontal) {
                    return horizontal ? item.w : item.h;
                }
            },
            {
                key: "setAxisLayoutPos",
                value: function setAxisLayoutPos(item, horizontal, pos) {
                    if (horizontal) {
                        item.x = pos;
                    } else {
                        item.y = pos;
                    }
                }
            },
            {
                key: "setAxisLayoutSize",
                value: function setAxisLayoutSize(item, horizontal, size) {
                    if (horizontal) {
                        item.w = size;
                    } else {
                        item.h = size;
                    }
                }
            },
            {
                key: "getAxisMinSize",
                value: function getAxisMinSize(item, horizontal) {
                    var minSize = this.getPlainAxisMinSize(item, horizontal);
                    var flexItemMinSize = 0;
                    if (item.isFlexItemEnabled()) {
                        flexItemMinSize = item._flexItem._getMinSizeSetting(horizontal);
                    }
                    var hasLimitedMinSize = flexItemMinSize > 0;
                    if (hasLimitedMinSize) {
                        minSize = Math.max(minSize, flexItemMinSize);
                    }
                    return minSize;
                }
            },
            {
                key: "getPlainAxisMinSize",
                value: function getPlainAxisMinSize(item, horizontal) {
                    if (item.isFlexEnabled()) {
                        return item._flex._layout.getAxisMinSize(horizontal);
                    } else {
                        var isShrinkable = item.flexItem.shrink !== 0;
                        if (isShrinkable) {
                            return 0;
                        } else {
                            return this.getRelAxisSize(item, horizontal);
                        }
                    }
                }
            },
            {
                key: "resizeAxis",
                value: function resizeAxis(item, horizontal, size) {
                    if (item.isFlexEnabled()) {
                        var isMainAxis = item._flex._horizontal === horizontal;
                        if (isMainAxis) {
                            item._flex._layout.resizeMainAxis(size);
                        } else {
                            item._flex._layout.resizeCrossAxis(size);
                        }
                    } else {
                        this.setAxisLayoutSize(item, horizontal, size);
                    }
                }
            },
            {
                key: "getPaddingOffset",
                value: function getPaddingOffset(item, horizontal) {
                    if (item.isFlexEnabled()) {
                        var flex = item._flex;
                        if (horizontal) {
                            return flex.paddingLeft;
                        } else {
                            return flex.paddingTop;
                        }
                    } else {
                        return 0;
                    }
                }
            },
            {
                key: "getTotalPadding",
                value: function getTotalPadding(item, horizontal) {
                    if (item.isFlexEnabled()) {
                        var flex = item._flex;
                        if (horizontal) {
                            return flex.paddingRight + flex.paddingLeft;
                        } else {
                            return flex.paddingTop + flex.paddingBottom;
                        }
                    } else {
                        return 0;
                    }
                }
            },
            {
                key: "getMarginOffset",
                value: function getMarginOffset(item, horizontal) {
                    var flexItem = item.flexItem;
                    if (flexItem) {
                        if (horizontal) {
                            return flexItem.marginLeft;
                        } else {
                            return flexItem.marginTop;
                        }
                    } else {
                        return 0;
                    }
                }
            },
            {
                key: "getTotalMargin",
                value: function getTotalMargin(item, horizontal) {
                    var flexItem = item.flexItem;
                    if (flexItem) {
                        if (horizontal) {
                            return flexItem.marginRight + flexItem.marginLeft;
                        } else {
                            return flexItem.marginTop + flexItem.marginBottom;
                        }
                    } else {
                        return 0;
                    }
                }
            }
        ]);
        return FlexUtils;
    }();
    var SizeShrinker = /*#__PURE__*/ function() {
        function SizeShrinker(line) {
            _class_call_check._(this, SizeShrinker);
            this._line = line;
            this._amountRemaining = 0;
            this._shrunkSize = 0;
        }
        _create_class._(SizeShrinker, [
            {
                key: "shrink",
                value: function shrink(amount) {
                    this._shrunkSize = 0;
                    this._amountRemaining = amount;
                    var totalShrinkAmount = this._getTotalShrinkAmount();
                    if (totalShrinkAmount) {
                        var items = this._line.items;
                        do {
                            var amountPerShrink = this._amountRemaining / totalShrinkAmount;
                            for(var i = this._line.startIndex; i <= this._line.endIndex; i++){
                                var item = items[i];
                                var flexItem = item.flexItem;
                                var shrinkAmount = flexItem.shrink;
                                var isShrinkableItem = shrinkAmount > 0;
                                if (isShrinkableItem) {
                                    var shrink = shrinkAmount * amountPerShrink;
                                    var minSize = flexItem._getMainAxisMinSize();
                                    var size = flexItem._getMainAxisLayoutSize();
                                    if (size > minSize) {
                                        var maxShrink = size - minSize;
                                        var isFullyShrunk = shrink >= maxShrink;
                                        if (isFullyShrunk) {
                                            shrink = maxShrink;
                                            totalShrinkAmount -= shrinkAmount;
                                        }
                                        var finalSize = size - shrink;
                                        flexItem._resizeMainAxis(finalSize);
                                        this._shrunkSize += shrink;
                                        this._amountRemaining -= shrink;
                                        if (Math.abs(this._amountRemaining) < 10e-6) {
                                            return;
                                        }
                                    }
                                }
                            }
                        }while (totalShrinkAmount && Math.abs(this._amountRemaining) > 10e-6);
                    }
                }
            },
            {
                key: "_getTotalShrinkAmount",
                value: function _getTotalShrinkAmount() {
                    var total = 0;
                    var items = this._line.items;
                    for(var i = this._line.startIndex; i <= this._line.endIndex; i++){
                        var item = items[i];
                        var flexItem = item.flexItem;
                        if (flexItem.shrink) {
                            var minSize = flexItem._getMainAxisMinSize();
                            var size = flexItem._getMainAxisLayoutSize();
                            if (size > minSize) {
                                total += flexItem.shrink;
                            }
                        }
                    }
                    return total;
                }
            },
            {
                key: "getShrunkSize",
                value: function getShrunkSize() {
                    return this._shrunkSize;
                }
            }
        ]);
        return SizeShrinker;
    }();
    var SizeGrower = /*#__PURE__*/ function() {
        function SizeGrower(line) {
            _class_call_check._(this, SizeGrower);
            this._line = line;
            this._amountRemaining = 0;
            this._grownSize = 0;
        }
        _create_class._(SizeGrower, [
            {
                key: "grow",
                value: function grow(amount) {
                    this._grownSize = 0;
                    this._amountRemaining = amount;
                    var totalGrowAmount = this._getTotalGrowAmount();
                    if (totalGrowAmount) {
                        var items = this._line.items;
                        do {
                            var amountPerGrow = this._amountRemaining / totalGrowAmount;
                            for(var i = this._line.startIndex; i <= this._line.endIndex; i++){
                                var item = items[i];
                                var flexItem = item.flexItem;
                                var growAmount = flexItem.grow;
                                var isGrowableItem = growAmount > 0;
                                if (isGrowableItem) {
                                    var grow = growAmount * amountPerGrow;
                                    var maxSize = flexItem._getMainAxisMaxSizeSetting();
                                    var size = flexItem._getMainAxisLayoutSize();
                                    if (maxSize > 0) {
                                        if (size >= maxSize) {
                                            grow = 0;
                                        } else {
                                            var maxGrow = maxSize - size;
                                            var isFullyGrown = grow >= maxGrow;
                                            if (isFullyGrown) {
                                                grow = maxGrow;
                                                totalGrowAmount -= growAmount;
                                            }
                                        }
                                    }
                                    if (grow > 0) {
                                        var finalSize = size + grow;
                                        flexItem._resizeMainAxis(finalSize);
                                        this._grownSize += grow;
                                        this._amountRemaining -= grow;
                                        if (Math.abs(this._amountRemaining) < 10e-6) {
                                            return;
                                        }
                                    }
                                }
                            }
                        }while (totalGrowAmount && Math.abs(this._amountRemaining) > 10e-6);
                    }
                }
            },
            {
                key: "_getTotalGrowAmount",
                value: function _getTotalGrowAmount() {
                    var total = 0;
                    var items = this._line.items;
                    for(var i = this._line.startIndex; i <= this._line.endIndex; i++){
                        var item = items[i];
                        var flexItem = item.flexItem;
                        if (flexItem.grow) {
                            var maxSize = flexItem._getMainAxisMaxSizeSetting();
                            var size = flexItem._getMainAxisLayoutSize();
                            if (maxSize === 0 || size < maxSize) {
                                total += flexItem.grow;
                            }
                        }
                    }
                    return total;
                }
            },
            {
                key: "getGrownSize",
                value: function getGrownSize() {
                    return this._grownSize;
                }
            }
        ]);
        return SizeGrower;
    }();
    var ItemPositioner = /*#__PURE__*/ function() {
        function ItemPositioner(lineLayout) {
            _class_call_check._(this, ItemPositioner);
            this._line = lineLayout;
        }
        _create_class._(ItemPositioner, [
            {
                key: "_layout",
                get: function get() {
                    return this._line._layout;
                }
            },
            {
                key: "position",
                value: function position() {
                    var _this__getSpacing = this._getSpacing(), spacingBefore = _this__getSpacing.spacingBefore, spacingBetween = _this__getSpacing.spacingBetween;
                    var currentPos = spacingBefore;
                    var items = this._line.items;
                    for(var i = this._line.startIndex; i <= this._line.endIndex; i++){
                        var item = items[i];
                        item.flexItem._setMainAxisLayoutPos(currentPos);
                        currentPos += item.flexItem._getMainAxisLayoutSizeWithPaddingAndMargin();
                        currentPos += spacingBetween;
                    }
                }
            },
            {
                key: "_getSpacing",
                value: function _getSpacing() {
                    var remainingSpace = this._line._availableSpace;
                    var mode = this._layout._flexContainer.justifyContent;
                    var numberOfItems = this._line.numberOfItems;
                    return SpacingCalculator.getSpacing(mode, numberOfItems, remainingSpace);
                }
            }
        ]);
        return ItemPositioner;
    }();
    var ItemAligner = /*#__PURE__*/ function() {
        function ItemAligner(line) {
            _class_call_check._(this, ItemAligner);
            this._line = line;
            this._crossAxisLayoutSize = 0;
            this._crossAxisLayoutOffset = 0;
            this._alignItemsSetting = null;
            this._recursiveResizeOccured = false;
            this._isCrossAxisFitToContents = false;
        }
        _create_class._(ItemAligner, [
            {
                key: "_layout",
                get: function get() {
                    return this._line._layout;
                }
            },
            {
                key: "_flexContainer",
                get: function get() {
                    return this._layout._flexContainer;
                }
            },
            {
                key: "setCrossAxisLayoutSize",
                value: function setCrossAxisLayoutSize(size) {
                    this._crossAxisLayoutSize = size;
                }
            },
            {
                key: "setCrossAxisLayoutOffset",
                value: function setCrossAxisLayoutOffset(offset) {
                    this._crossAxisLayoutOffset = offset;
                }
            },
            {
                key: "align",
                value: function align() {
                    this._alignItemsSetting = this._flexContainer.alignItems;
                    this._isCrossAxisFitToContents = this._layout.isAxisFitToContents(!this._flexContainer._horizontal);
                    this._recursiveResizeOccured = false;
                    var items = this._line.items;
                    for(var i = this._line.startIndex; i <= this._line.endIndex; i++){
                        var item = items[i];
                        this._alignItem(item);
                    }
                }
            },
            {
                key: "recursiveResizeOccured",
                get: function get() {
                    return this._recursiveResizeOccured;
                }
            },
            {
                key: "_alignItem",
                value: function _alignItem(item) {
                    var flexItem = item.flexItem;
                    var align = flexItem.alignSelf || this._alignItemsSetting;
                    if (align === "stretch" && this._preventStretch(flexItem)) {
                        align = "flex-start";
                    }
                    if (align !== "stretch" && !this._isCrossAxisFitToContents) {
                        if (flexItem._hasRelCrossAxisSize()) {
                            flexItem._resetCrossAxisLayoutSize();
                        }
                    }
                    switch(align){
                        case "flex-start":
                            this._alignItemFlexStart(flexItem);
                            break;
                        case "flex-end":
                            this._alignItemFlexEnd(flexItem);
                            break;
                        case "center":
                            this._alignItemFlexCenter(flexItem);
                            break;
                        case "stretch":
                            this._alignItemStretch(flexItem);
                            break;
                    }
                }
            },
            {
                key: "_alignItemFlexStart",
                value: function _alignItemFlexStart(flexItem) {
                    flexItem._setCrossAxisLayoutPos(this._crossAxisLayoutOffset);
                }
            },
            {
                key: "_alignItemFlexEnd",
                value: function _alignItemFlexEnd(flexItem) {
                    var itemCrossAxisSize = flexItem._getCrossAxisLayoutSizeWithPaddingAndMargin();
                    flexItem._setCrossAxisLayoutPos(this._crossAxisLayoutOffset + (this._crossAxisLayoutSize - itemCrossAxisSize));
                }
            },
            {
                key: "_alignItemFlexCenter",
                value: function _alignItemFlexCenter(flexItem) {
                    var itemCrossAxisSize = flexItem._getCrossAxisLayoutSizeWithPaddingAndMargin();
                    var center = (this._crossAxisLayoutSize - itemCrossAxisSize) / 2;
                    flexItem._setCrossAxisLayoutPos(this._crossAxisLayoutOffset + center);
                }
            },
            {
                key: "_alignItemStretch",
                value: function _alignItemStretch(flexItem) {
                    flexItem._setCrossAxisLayoutPos(this._crossAxisLayoutOffset);
                    var mainAxisLayoutSizeBeforeResize = flexItem._getMainAxisLayoutSize();
                    var size = this._crossAxisLayoutSize - flexItem._getCrossAxisMargin() - flexItem._getCrossAxisPadding();
                    var crossAxisMinSizeSetting = flexItem._getCrossAxisMinSizeSetting();
                    if (crossAxisMinSizeSetting > 0) {
                        size = Math.max(size, crossAxisMinSizeSetting);
                    }
                    var crossAxisMaxSizeSetting = flexItem._getCrossAxisMaxSizeSetting();
                    var crossAxisMaxSizeSettingEnabled = crossAxisMaxSizeSetting > 0;
                    if (crossAxisMaxSizeSettingEnabled) {
                        size = Math.min(size, crossAxisMaxSizeSetting);
                    }
                    flexItem._resizeCrossAxis(size);
                    var mainAxisLayoutSizeAfterResize = flexItem._getMainAxisLayoutSize();
                    var recursiveResize = mainAxisLayoutSizeAfterResize !== mainAxisLayoutSizeBeforeResize;
                    if (recursiveResize) {
                        this._recursiveResizeOccured = true;
                    }
                }
            },
            {
                key: "_preventStretch",
                value: function _preventStretch(flexItem) {
                    var hasFixedCrossAxisSize = flexItem._hasFixedCrossAxisSize();
                    var forceStretch = flexItem.alignSelf === "stretch";
                    return hasFixedCrossAxisSize && !forceStretch;
                }
            }
        ]);
        return ItemAligner;
    }();
    var LineLayout = /*#__PURE__*/ function() {
        function LineLayout(layout, startIndex, endIndex, availableSpace) {
            _class_call_check._(this, LineLayout);
            this._layout = layout;
            this.items = layout.items;
            this.startIndex = startIndex;
            this.endIndex = endIndex;
            this._availableSpace = availableSpace;
        }
        _create_class._(LineLayout, [
            {
                key: "performLayout",
                value: function performLayout() {
                    this._setItemSizes();
                    this.setItemPositions();
                    this._calcLayoutInfo();
                }
            },
            {
                key: "_setItemSizes",
                value: function _setItemSizes() {
                    if (this._availableSpace > 0) {
                        this._growItemSizes(this._availableSpace);
                    } else if (this._availableSpace < 0) {
                        this._shrinkItemSizes(-this._availableSpace);
                    }
                }
            },
            {
                key: "_growItemSizes",
                value: function _growItemSizes(amount) {
                    var grower = new SizeGrower(this);
                    grower.grow(amount);
                    this._availableSpace -= grower.getGrownSize();
                }
            },
            {
                key: "_shrinkItemSizes",
                value: function _shrinkItemSizes(amount) {
                    var shrinker = new SizeShrinker(this);
                    shrinker.shrink(amount);
                    this._availableSpace += shrinker.getShrunkSize();
                }
            },
            {
                key: "setItemPositions",
                value: function setItemPositions() {
                    var positioner = new ItemPositioner(this);
                    positioner.position();
                }
            },
            {
                key: "createItemAligner",
                value: function createItemAligner() {
                    return new ItemAligner(this);
                }
            },
            {
                key: "_calcLayoutInfo",
                value: function _calcLayoutInfo() {
                    this._calcCrossAxisMaxLayoutSize();
                }
            },
            {
                key: "getMainAxisMinSize",
                value: function getMainAxisMinSize() {
                    var mainAxisMinSize = 0;
                    for(var i = this.startIndex; i <= this.endIndex; i++){
                        var item = this.items[i];
                        mainAxisMinSize += item.flexItem._getMainAxisMinSizeWithPaddingAndMargin();
                    }
                    return mainAxisMinSize;
                }
            },
            {
                key: "numberOfItems",
                get: function get() {
                    return this.endIndex - this.startIndex + 1;
                }
            },
            {
                key: "crossAxisLayoutSize",
                get: function get() {
                    var noSpecifiedCrossAxisSize = this._layout.isCrossAxisFitToContents() && !this._layout.resizingCrossAxis;
                    var shouldFitToContents = this._layout.isWrapping() || noSpecifiedCrossAxisSize;
                    if (shouldFitToContents) {
                        return this._crossAxisMaxLayoutSize;
                    } else {
                        return this._layout.crossAxisSize;
                    }
                }
            },
            {
                key: "_calcCrossAxisMaxLayoutSize",
                value: function _calcCrossAxisMaxLayoutSize() {
                    this._crossAxisMaxLayoutSize = this._getCrossAxisMaxLayoutSize();
                }
            },
            {
                key: "_getCrossAxisMaxLayoutSize",
                value: function _getCrossAxisMaxLayoutSize() {
                    var crossAxisMaxSize = 0;
                    for(var i = this.startIndex; i <= this.endIndex; i++){
                        var item = this.items[i];
                        crossAxisMaxSize = Math.max(crossAxisMaxSize, item.flexItem._getCrossAxisLayoutSizeWithPaddingAndMargin());
                    }
                    return crossAxisMaxSize;
                }
            }
        ]);
        return LineLayout;
    }();
    var LineLayouter = /*#__PURE__*/ function() {
        function LineLayouter(layout) {
            _class_call_check._(this, LineLayouter);
            this._layout = layout;
            this._mainAxisMinSize = -1;
            this._crossAxisMinSize = -1;
            this._mainAxisContentSize = 0;
        }
        _create_class._(LineLayouter, [
            {
                key: "lines",
                get: function get() {
                    return this._lines;
                }
            },
            {
                key: "mainAxisMinSize",
                get: function get() {
                    if (this._mainAxisMinSize === -1) {
                        this._mainAxisMinSize = this._getMainAxisMinSize();
                    }
                    return this._mainAxisMinSize;
                }
            },
            {
                key: "crossAxisMinSize",
                get: function get() {
                    if (this._crossAxisMinSize === -1) {
                        this._crossAxisMinSize = this._getCrossAxisMinSize();
                    }
                    return this._crossAxisMinSize;
                }
            },
            {
                key: "mainAxisContentSize",
                get: function get() {
                    return this._mainAxisContentSize;
                }
            },
            {
                key: "layoutLines",
                value: function layoutLines() {
                    this._setup();
                    var items = this._layout.items;
                    var wrap = this._layout.isWrapping();
                    var startIndex = 0;
                    var i;
                    var n = items.length;
                    for(i = 0; i < n; i++){
                        var item = items[i];
                        this._layoutFlexItem(item);
                        var itemMainAxisSize = item.flexItem._getMainAxisLayoutSizeWithPaddingAndMargin();
                        if (wrap && i > startIndex) {
                            var isOverflowing = this._curMainAxisPos + itemMainAxisSize > this._mainAxisSize;
                            if (isOverflowing) {
                                this._layoutLine(startIndex, i - 1);
                                this._curMainAxisPos = 0;
                                startIndex = i;
                            }
                        }
                        this._addToMainAxisPos(itemMainAxisSize);
                    }
                    if (startIndex < i) {
                        this._layoutLine(startIndex, i - 1);
                    }
                }
            },
            {
                key: "_layoutFlexItem",
                value: function _layoutFlexItem(item) {
                    if (item.isFlexEnabled()) {
                        item.flexLayout.updateTreeLayout();
                    } else {
                        item.flexItem._resetLayoutSize();
                    }
                }
            },
            {
                key: "_setup",
                value: function _setup() {
                    this._mainAxisSize = this._layout.mainAxisSize;
                    this._curMainAxisPos = 0;
                    this._maxMainAxisPos = 0;
                    this._lines = [];
                    this._mainAxisMinSize = -1;
                    this._crossAxisMinSize = -1;
                    this._mainAxisContentSize = 0;
                }
            },
            {
                key: "_addToMainAxisPos",
                value: function _addToMainAxisPos(itemMainAxisSize) {
                    this._curMainAxisPos += itemMainAxisSize;
                    if (this._curMainAxisPos > this._maxMainAxisPos) {
                        this._maxMainAxisPos = this._curMainAxisPos;
                    }
                }
            },
            {
                key: "_layoutLine",
                value: function _layoutLine(startIndex, endIndex) {
                    var availableSpace = this._getAvailableMainAxisLayoutSpace();
                    var line = new LineLayout(this._layout, startIndex, endIndex, availableSpace);
                    line.performLayout();
                    this._lines.push(line);
                    if (this._mainAxisContentSize === 0 || this._curMainAxisPos > this._mainAxisContentSize) {
                        this._mainAxisContentSize = this._curMainAxisPos;
                    }
                }
            },
            {
                key: "_getAvailableMainAxisLayoutSpace",
                value: function _getAvailableMainAxisLayoutSpace() {
                    if (!this._layout.resizingMainAxis && this._layout.isMainAxisFitToContents()) {
                        return 0;
                    } else {
                        return this._mainAxisSize - this._curMainAxisPos;
                    }
                }
            },
            {
                key: "_getCrossAxisMinSize",
                value: function _getCrossAxisMinSize() {
                    var crossAxisMinSize = 0;
                    var items = this._layout.items;
                    for(var i = 0, n = items.length; i < n; i++){
                        var item = items[i];
                        var itemCrossAxisMinSize = item.flexItem._getCrossAxisMinSizeWithPaddingAndMargin();
                        crossAxisMinSize = Math.max(crossAxisMinSize, itemCrossAxisMinSize);
                    }
                    return crossAxisMinSize;
                }
            },
            {
                key: "_getMainAxisMinSize",
                value: function _getMainAxisMinSize() {
                    if (this._lines.length === 1) {
                        return this._lines[0].getMainAxisMinSize();
                    } else {
                        return this._layout.mainAxisSize;
                    }
                }
            }
        ]);
        return LineLayouter;
    }();
    var ItemCoordinatesUpdater = /*#__PURE__*/ function() {
        function ItemCoordinatesUpdater(layout) {
            _class_call_check._(this, ItemCoordinatesUpdater);
            this._layout = layout;
            this._isReverse = this._flexContainer._reverse;
            this._horizontalPaddingOffset = this._layout._getHorizontalPaddingOffset();
            this._verticalPaddingOffset = this._layout._getVerticalPaddingOffset();
        }
        _create_class._(ItemCoordinatesUpdater, [
            {
                key: "_flexContainer",
                get: function get() {
                    return this._layout._flexContainer;
                }
            },
            {
                key: "finalize",
                value: function finalize() {
                    var parentFlex = this._layout.getParentFlexContainer();
                    if (parentFlex) {
                        var updater = new ItemCoordinatesUpdater(parentFlex._layout);
                        updater._finalizeItemAndChildren(this._flexContainer.item);
                    } else {
                        this._finalizeRoot();
                        this._finalizeItems();
                    }
                }
            },
            {
                key: "_finalizeRoot",
                value: function _finalizeRoot() {
                    var item = this._flexContainer.item;
                    var x = FlexUtils.getAxisLayoutPos(item, true);
                    var y = FlexUtils.getAxisLayoutPos(item, false);
                    var w = FlexUtils.getAxisLayoutSize(item, true);
                    var h = FlexUtils.getAxisLayoutSize(item, false);
                    w += this._layout._getHorizontalPadding();
                    h += this._layout._getVerticalPadding();
                    item.clearRecalcFlag();
                    item.setLayout(x, y, w, h);
                }
            },
            {
                key: "_finalizeItems",
                value: function _finalizeItems() {
                    var items = this._layout.items;
                    for(var i = 0, n = items.length; i < n; i++){
                        var item = items[i];
                        var validCache = this._validateItemCache(item);
                        this._finalizeItem(item);
                        if (!validCache) {
                            this._finalizeItemChildren(item);
                        }
                    }
                }
            },
            {
                key: "_validateItemCache",
                value: function _validateItemCache(item) {
                    if (item.recalc === 0) {
                        if (item.isFlexEnabled()) {
                            var layout = item._flex._layout;
                            var dimensionsMatchPreviousResult = item.w === item.target.w && item.h === item.target.h;
                            if (dimensionsMatchPreviousResult) {
                                return true;
                            } else {
                                var crossAxisSize = layout.crossAxisSize;
                                layout.performResizeMainAxis(layout.mainAxisSize);
                                layout.performResizeCrossAxis(crossAxisSize);
                            }
                        }
                    }
                    return false;
                }
            },
            {
                key: "_finalizeItemAndChildren",
                value: function _finalizeItemAndChildren(item) {
                    this._finalizeItem(item);
                    this._finalizeItemChildren(item);
                }
            },
            {
                key: "_finalizeItem",
                value: function _finalizeItem(item) {
                    if (this._isReverse) {
                        this._reverseMainAxisLayoutPos(item);
                    }
                    var x = FlexUtils.getAxisLayoutPos(item, true);
                    var y = FlexUtils.getAxisLayoutPos(item, false);
                    var w = FlexUtils.getAxisLayoutSize(item, true);
                    var h = FlexUtils.getAxisLayoutSize(item, false);
                    x += this._horizontalPaddingOffset;
                    y += this._verticalPaddingOffset;
                    var flex = item.flex;
                    if (flex) {
                        w += item._flex._layout._getHorizontalPadding();
                        h += item._flex._layout._getVerticalPadding();
                    }
                    var flexItem = item.flexItem;
                    if (flexItem) {
                        x += flexItem._getHorizontalMarginOffset();
                        y += flexItem._getVerticalMarginOffset();
                    }
                    item.clearRecalcFlag();
                    item.setLayout(x, y, w, h);
                }
            },
            {
                key: "_finalizeItemChildren",
                value: function _finalizeItemChildren(item) {
                    var flex = item._flex;
                    if (flex) {
                        var updater = new ItemCoordinatesUpdater(flex._layout);
                        updater._finalizeItems();
                    }
                }
            },
            {
                key: "_reverseMainAxisLayoutPos",
                value: function _reverseMainAxisLayoutPos(item) {
                    var endPos = item.flexItem._getMainAxisLayoutPos() + item.flexItem._getMainAxisLayoutSizeWithPaddingAndMargin();
                    var reversedPos = this._layout.mainAxisSize - endPos;
                    item.flexItem._setMainAxisLayoutPos(reversedPos);
                }
            }
        ]);
        return ItemCoordinatesUpdater;
    }();
    var FlexLayout = /*#__PURE__*/ function() {
        function FlexLayout(flexContainer) {
            _class_call_check._(this, FlexLayout);
            this._flexContainer = flexContainer;
            this._lineLayouter = new LineLayouter(this);
            this._resizingMainAxis = false;
            this._resizingCrossAxis = false;
            this._cachedMainAxisSizeAfterLayout = 0;
            this._cachedCrossAxisSizeAfterLayout = 0;
            this._shrunk = false;
        }
        _create_class._(FlexLayout, [
            {
                key: "shrunk",
                get: function get() {
                    return this._shrunk;
                }
            },
            {
                key: "recalc",
                get: function get() {
                    return this.item.recalc;
                }
            },
            {
                key: "layoutTree",
                value: function layoutTree() {
                    var isSubTree = this.item.flexParent !== null;
                    if (isSubTree) {
                        this._updateSubTreeLayout();
                    } else {
                        this.updateTreeLayout();
                    }
                    this.updateItemCoords();
                }
            },
            {
                key: "updateTreeLayout",
                value: function updateTreeLayout() {
                    if (this.recalc) {
                        this._performUpdateLayoutTree();
                    } else {
                        this._performUpdateLayoutTreeFromCache();
                    }
                }
            },
            {
                key: "_performUpdateLayoutTree",
                value: function _performUpdateLayoutTree() {
                    this._setInitialAxisSizes();
                    this._layoutAxes();
                    this._refreshLayoutCache();
                }
            },
            {
                key: "_refreshLayoutCache",
                value: function _refreshLayoutCache() {
                    this._cachedMainAxisSizeAfterLayout = this.mainAxisSize;
                    this._cachedCrossAxisSizeAfterLayout = this.crossAxisSize;
                }
            },
            {
                key: "_performUpdateLayoutTreeFromCache",
                value: function _performUpdateLayoutTreeFromCache() {
                    var sizeMightHaveChanged = this.item.funcW || this.item.funcH;
                    if (sizeMightHaveChanged) {
                        this.item.enableLocalRecalcFlag();
                        this._performUpdateLayoutTree();
                    } else {
                        this.mainAxisSize = this._cachedMainAxisSizeAfterLayout;
                        this.crossAxisSize = this._cachedCrossAxisSizeAfterLayout;
                    }
                }
            },
            {
                key: "updateItemCoords",
                value: function updateItemCoords() {
                    var updater = new ItemCoordinatesUpdater(this);
                    updater.finalize();
                }
            },
            {
                key: "_updateSubTreeLayout",
                value: function _updateSubTreeLayout() {
                    var crossAxisSize = this.crossAxisSize;
                    this._layoutMainAxis();
                    this.performResizeCrossAxis(crossAxisSize);
                }
            },
            {
                key: "_setInitialAxisSizes",
                value: function _setInitialAxisSizes() {
                    if (this.item.isFlexItemEnabled()) {
                        this.item.flexItem._resetLayoutSize();
                    } else {
                        this.mainAxisSize = this._getMainAxisBasis();
                        this.crossAxisSize = this._getCrossAxisBasis();
                    }
                    this._resizingMainAxis = false;
                    this._resizingCrossAxis = false;
                    this._shrunk = false;
                }
            },
            {
                key: "_layoutAxes",
                value: function _layoutAxes() {
                    this._layoutMainAxis();
                    this._layoutCrossAxis();
                }
            },
            {
                key: "_layoutMainAxis",
                value: function _layoutMainAxis() {
                    this._layoutLines();
                    this._fitMainAxisSizeToContents();
                }
            },
            {
                key: "_layoutLines",
                value: function _layoutLines() {
                    this._lineLayouter.layoutLines();
                }
            },
            {
                key: "_lines",
                get: function get() {
                    return this._lineLayouter.lines;
                }
            },
            {
                key: "_fitMainAxisSizeToContents",
                value: function _fitMainAxisSizeToContents() {
                    if (!this._resizingMainAxis) {
                        if (this.isMainAxisFitToContents()) {
                            this.mainAxisSize = this._lineLayouter.mainAxisContentSize;
                        }
                    }
                }
            },
            {
                key: "_layoutCrossAxis",
                value: function _layoutCrossAxis() {
                    var aligner = new ContentAligner(this);
                    aligner.init();
                    this._totalCrossAxisSize = aligner.totalCrossAxisSize;
                    this._fitCrossAxisSizeToContents();
                    aligner.align();
                }
            },
            {
                key: "_fitCrossAxisSizeToContents",
                value: function _fitCrossAxisSizeToContents() {
                    if (!this._resizingCrossAxis) {
                        if (this.isCrossAxisFitToContents()) {
                            this.crossAxisSize = this._totalCrossAxisSize;
                        }
                    }
                }
            },
            {
                key: "isWrapping",
                value: function isWrapping() {
                    return this._flexContainer.wrap;
                }
            },
            {
                key: "isAxisFitToContents",
                value: function isAxisFitToContents(horizontal) {
                    if (this._horizontal === horizontal) {
                        return this.isMainAxisFitToContents();
                    } else {
                        return this.isCrossAxisFitToContents();
                    }
                }
            },
            {
                key: "isMainAxisFitToContents",
                value: function isMainAxisFitToContents() {
                    return !this.isWrapping() && !this._hasFixedMainAxisBasis();
                }
            },
            {
                key: "isCrossAxisFitToContents",
                value: function isCrossAxisFitToContents() {
                    return !this._hasFixedCrossAxisBasis();
                }
            },
            {
                key: "_hasFixedMainAxisBasis",
                value: function _hasFixedMainAxisBasis() {
                    return !FlexUtils.isZeroAxisSize(this.item, this._horizontal);
                }
            },
            {
                key: "_hasFixedCrossAxisBasis",
                value: function _hasFixedCrossAxisBasis() {
                    return !FlexUtils.isZeroAxisSize(this.item, !this._horizontal);
                }
            },
            {
                key: "getAxisMinSize",
                value: function getAxisMinSize(horizontal) {
                    if (this._horizontal === horizontal) {
                        return this._getMainAxisMinSize();
                    } else {
                        return this._getCrossAxisMinSize();
                    }
                }
            },
            {
                key: "_getMainAxisMinSize",
                value: function _getMainAxisMinSize() {
                    return this._lineLayouter.mainAxisMinSize;
                }
            },
            {
                key: "_getCrossAxisMinSize",
                value: function _getCrossAxisMinSize() {
                    return this._lineLayouter.crossAxisMinSize;
                }
            },
            {
                key: "resizeMainAxis",
                value: function resizeMainAxis(size) {
                    if (this.mainAxisSize !== size) {
                        if (this.recalc > 0) {
                            this.performResizeMainAxis(size);
                        } else {
                            if (this._checkValidCacheMainAxisResize()) {
                                this.mainAxisSize = size;
                                this._fitCrossAxisSizeToContents();
                            } else {
                                this.item.enableLocalRecalcFlag();
                                this.performResizeMainAxis(size);
                            }
                        }
                    }
                }
            },
            {
                key: "_checkValidCacheMainAxisResize",
                value: function _checkValidCacheMainAxisResize(size) {
                    var isFinalMainAxisSize = size === this.targetMainAxisSize;
                    if (isFinalMainAxisSize) {
                        return true;
                    }
                    var canIgnoreCacheMiss = !this.isCrossAxisFitToContents();
                    if (canIgnoreCacheMiss) {
                        return true;
                    }
                    return false;
                }
            },
            {
                key: "performResizeMainAxis",
                value: function performResizeMainAxis(size) {
                    var isShrinking = size < this.mainAxisSize;
                    this._shrunk = isShrinking;
                    this.mainAxisSize = size;
                    this._resizingMainAxis = true;
                    this._layoutAxes();
                    this._resizingMainAxis = false;
                }
            },
            {
                key: "resizeCrossAxis",
                value: function resizeCrossAxis(size) {
                    if (this.crossAxisSize !== size) {
                        if (this.recalc > 0) {
                            this.performResizeCrossAxis(size);
                        } else {
                            this.crossAxisSize = size;
                        }
                    }
                }
            },
            {
                key: "performResizeCrossAxis",
                value: function performResizeCrossAxis(size) {
                    this.crossAxisSize = size;
                    this._resizingCrossAxis = true;
                    this._layoutCrossAxis();
                    this._resizingCrossAxis = false;
                }
            },
            {
                key: "targetMainAxisSize",
                get: function get() {
                    return this._horizontal ? this.item.target.w : this.item.target.h;
                }
            },
            {
                key: "targetCrossAxisSize",
                get: function get() {
                    return this._horizontal ? this.item.target.h : this.item.target.w;
                }
            },
            {
                key: "getParentFlexContainer",
                value: function getParentFlexContainer() {
                    return this.item.isFlexItemEnabled() ? this.item.flexItem.ctr : null;
                }
            },
            {
                key: "_getHorizontalPadding",
                value: function _getHorizontalPadding() {
                    return FlexUtils.getTotalPadding(this.item, true);
                }
            },
            {
                key: "_getVerticalPadding",
                value: function _getVerticalPadding() {
                    return FlexUtils.getTotalPadding(this.item, false);
                }
            },
            {
                key: "_getHorizontalPaddingOffset",
                value: function _getHorizontalPaddingOffset() {
                    return FlexUtils.getPaddingOffset(this.item, true);
                }
            },
            {
                key: "_getVerticalPaddingOffset",
                value: function _getVerticalPaddingOffset() {
                    return FlexUtils.getPaddingOffset(this.item, false);
                }
            },
            {
                key: "_getMainAxisBasis",
                value: function _getMainAxisBasis() {
                    return FlexUtils.getRelAxisSize(this.item, this._horizontal);
                }
            },
            {
                key: "_getCrossAxisBasis",
                value: function _getCrossAxisBasis() {
                    return FlexUtils.getRelAxisSize(this.item, !this._horizontal);
                }
            },
            {
                key: "_horizontal",
                get: function get() {
                    return this._flexContainer._horizontal;
                }
            },
            {
                key: "_reverse",
                get: function get() {
                    return this._flexContainer._reverse;
                }
            },
            {
                key: "item",
                get: function get() {
                    return this._flexContainer.item;
                }
            },
            {
                key: "items",
                get: function get() {
                    return this.item.items;
                }
            },
            {
                key: "resizingMainAxis",
                get: function get() {
                    return this._resizingMainAxis;
                }
            },
            {
                key: "resizingCrossAxis",
                get: function get() {
                    return this._resizingCrossAxis;
                }
            },
            {
                key: "numberOfItems",
                get: function get() {
                    return this.items.length;
                }
            },
            {
                key: "mainAxisSize",
                get: function get() {
                    return FlexUtils.getAxisLayoutSize(this.item, this._horizontal);
                },
                set: function set(v) {
                    FlexUtils.setAxisLayoutSize(this.item, this._horizontal, v);
                }
            },
            {
                key: "crossAxisSize",
                get: function get() {
                    return FlexUtils.getAxisLayoutSize(this.item, !this._horizontal);
                },
                set: function set(v) {
                    FlexUtils.setAxisLayoutSize(this.item, !this._horizontal, v);
                }
            }
        ]);
        return FlexLayout;
    }();
    var FlexContainer = /*#__PURE__*/ function() {
        function FlexContainer(item) {
            _class_call_check._(this, FlexContainer);
            this._item = item;
            this._layout = new FlexLayout(this);
            this._horizontal = true;
            this._reverse = false;
            this._wrap = false;
            this._alignItems = "stretch";
            this._justifyContent = "flex-start";
            this._alignContent = "flex-start";
            this._paddingLeft = 0;
            this._paddingTop = 0;
            this._paddingRight = 0;
            this._paddingBottom = 0;
        }
        _create_class._(FlexContainer, [
            {
                key: "item",
                get: function get() {
                    return this._item;
                }
            },
            {
                key: "_changedDimensions",
                value: function _changedDimensions() {
                    this._item.changedDimensions();
                }
            },
            {
                key: "_changedContents",
                value: function _changedContents() {
                    this._item.changedContents();
                }
            },
            {
                key: "direction",
                get: function get() {
                    return (this._horizontal ? "row" : "column") + (this._reverse ? "-reverse" : "");
                },
                set: function set(f) {
                    if (this.direction === f) return;
                    this._horizontal = f === "row" || f === "row-reverse";
                    this._reverse = f === "row-reverse" || f === "column-reverse";
                    this._changedContents();
                }
            },
            {
                key: "wrap",
                get: function get() {
                    return this._wrap;
                },
                set: function set(v) {
                    this._wrap = v;
                    this._changedContents();
                }
            },
            {
                key: "alignItems",
                get: function get() {
                    return this._alignItems;
                },
                set: function set(v) {
                    if (this._alignItems === v) return;
                    if (FlexContainer.ALIGN_ITEMS.indexOf(v) === -1) {
                        throw new Error("Unknown alignItems, options: " + FlexContainer.ALIGN_ITEMS.join(","));
                    }
                    this._alignItems = v;
                    this._changedContents();
                }
            },
            {
                key: "alignContent",
                get: function get() {
                    return this._alignContent;
                },
                set: function set(v) {
                    if (this._alignContent === v) return;
                    if (FlexContainer.ALIGN_CONTENT.indexOf(v) === -1) {
                        throw new Error("Unknown alignContent, options: " + FlexContainer.ALIGN_CONTENT.join(","));
                    }
                    this._alignContent = v;
                    this._changedContents();
                }
            },
            {
                key: "justifyContent",
                get: function get() {
                    return this._justifyContent;
                },
                set: function set(v) {
                    if (this._justifyContent === v) return;
                    if (FlexContainer.JUSTIFY_CONTENT.indexOf(v) === -1) {
                        throw new Error("Unknown justifyContent, options: " + FlexContainer.JUSTIFY_CONTENT.join(","));
                    }
                    this._justifyContent = v;
                    this._changedContents();
                }
            },
            {
                key: "padding",
                get: function get() {
                    return this.paddingLeft;
                },
                set: function set(v) {
                    this.paddingLeft = v;
                    this.paddingTop = v;
                    this.paddingRight = v;
                    this.paddingBottom = v;
                }
            },
            {
                key: "paddingLeft",
                get: function get() {
                    return this._paddingLeft;
                },
                set: function set(v) {
                    this._paddingLeft = v;
                    this._changedDimensions();
                }
            },
            {
                key: "paddingTop",
                get: function get() {
                    return this._paddingTop;
                },
                set: function set(v) {
                    this._paddingTop = v;
                    this._changedDimensions();
                }
            },
            {
                key: "paddingRight",
                get: function get() {
                    return this._paddingRight;
                },
                set: function set(v) {
                    this._paddingRight = v;
                    this._changedDimensions();
                }
            },
            {
                key: "paddingBottom",
                get: function get() {
                    return this._paddingBottom;
                },
                set: function set(v) {
                    this._paddingBottom = v;
                    this._changedDimensions();
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    Base.patchObject(this, settings);
                }
            }
        ]);
        return FlexContainer;
    }();
    FlexContainer.ALIGN_ITEMS = [
        "flex-start",
        "flex-end",
        "center",
        "stretch"
    ];
    FlexContainer.ALIGN_CONTENT = [
        "flex-start",
        "flex-end",
        "center",
        "space-between",
        "space-around",
        "space-evenly",
        "stretch"
    ];
    FlexContainer.JUSTIFY_CONTENT = [
        "flex-start",
        "flex-end",
        "center",
        "space-between",
        "space-around",
        "space-evenly"
    ];
    var FlexItem = /*#__PURE__*/ function() {
        function FlexItem(item) {
            _class_call_check._(this, FlexItem);
            this._ctr = null;
            this._item = item;
            this._grow = 0;
            this._shrink = FlexItem.SHRINK_AUTO;
            this._alignSelf = undefined;
            this._minWidth = 0;
            this._minHeight = 0;
            this._maxWidth = 0;
            this._maxHeight = 0;
            this._marginLeft = 0;
            this._marginTop = 0;
            this._marginRight = 0;
            this._marginBottom = 0;
        }
        _create_class._(FlexItem, [
            {
                key: "item",
                get: function get() {
                    return this._item;
                }
            },
            {
                key: "grow",
                get: function get() {
                    return this._grow;
                },
                set: function set(v) {
                    if (this._grow === v) return;
                    this._grow = parseInt(v) || 0;
                    this._changed();
                }
            },
            {
                key: "shrink",
                get: function get() {
                    if (this._shrink === FlexItem.SHRINK_AUTO) {
                        return this._getDefaultShrink();
                    }
                    return this._shrink;
                },
                set: function set(v) {
                    if (this._shrink === v) return;
                    this._shrink = parseInt(v) || 0;
                    this._changed();
                }
            },
            {
                key: "_getDefaultShrink",
                value: function _getDefaultShrink() {
                    if (this.item.isFlexEnabled()) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            },
            {
                key: "alignSelf",
                get: function get() {
                    return this._alignSelf;
                },
                set: function set(v) {
                    if (this._alignSelf === v) return;
                    if (v === undefined) {
                        this._alignSelf = undefined;
                    } else {
                        if (FlexContainer.ALIGN_ITEMS.indexOf(v) === -1) {
                            throw new Error("Unknown alignSelf, options: " + FlexContainer.ALIGN_ITEMS.join(","));
                        }
                        this._alignSelf = v;
                    }
                    this._changed();
                }
            },
            {
                key: "minWidth",
                get: function get() {
                    return this._minWidth;
                },
                set: function set(v) {
                    this._minWidth = Math.max(0, v);
                    this._item.changedDimensions(true, false);
                }
            },
            {
                key: "minHeight",
                get: function get() {
                    return this._minHeight;
                },
                set: function set(v) {
                    this._minHeight = Math.max(0, v);
                    this._item.changedDimensions(false, true);
                }
            },
            {
                key: "maxWidth",
                get: function get() {
                    return this._maxWidth;
                },
                set: function set(v) {
                    this._maxWidth = Math.max(0, v);
                    this._item.changedDimensions(true, false);
                }
            },
            {
                key: "maxHeight",
                get: function get() {
                    return this._maxHeight;
                },
                set: function set(v) {
                    this._maxHeight = Math.max(0, v);
                    this._item.changedDimensions(false, true);
                }
            },
            {
                key: "margin",
                get: function get() {
                    return this.marginLeft;
                },
                set: function set(v) {
                    this.marginLeft = v;
                    this.marginTop = v;
                    this.marginRight = v;
                    this.marginBottom = v;
                }
            },
            {
                key: "marginLeft",
                get: function get() {
                    return this._marginLeft;
                },
                set: function set(v) {
                    this._marginLeft = v;
                    this._changed();
                }
            },
            {
                key: "marginTop",
                get: function get() {
                    return this._marginTop;
                },
                set: function set(v) {
                    this._marginTop = v;
                    this._changed();
                }
            },
            {
                key: "marginRight",
                get: function get() {
                    return this._marginRight;
                },
                set: function set(v) {
                    this._marginRight = v;
                    this._changed();
                }
            },
            {
                key: "marginBottom",
                get: function get() {
                    return this._marginBottom;
                },
                set: function set(v) {
                    this._marginBottom = v;
                    this._changed();
                }
            },
            {
                key: "_changed",
                value: function _changed() {
                    if (this.ctr) this.ctr._changedContents();
                }
            },
            {
                key: "ctr",
                get: function get() {
                    return this._ctr;
                },
                set: function set(v) {
                    this._ctr = v;
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    Base.patchObject(this, settings);
                }
            },
            {
                key: "_resetLayoutSize",
                value: function _resetLayoutSize() {
                    this._resetHorizontalAxisLayoutSize();
                    this._resetVerticalAxisLayoutSize();
                }
            },
            {
                key: "_resetCrossAxisLayoutSize",
                value: function _resetCrossAxisLayoutSize() {
                    if (this.ctr._horizontal) {
                        this._resetVerticalAxisLayoutSize();
                    } else {
                        this._resetHorizontalAxisLayoutSize();
                    }
                }
            },
            {
                key: "_resetHorizontalAxisLayoutSize",
                value: function _resetHorizontalAxisLayoutSize() {
                    var w = FlexUtils.getRelAxisSize(this.item, true);
                    if (this._minWidth) {
                        w = Math.max(this._minWidth, w);
                    }
                    if (this._maxWidth) {
                        w = Math.min(this._maxWidth, w);
                    }
                    FlexUtils.setAxisLayoutSize(this.item, true, w);
                }
            },
            {
                key: "_resetVerticalAxisLayoutSize",
                value: function _resetVerticalAxisLayoutSize() {
                    var h = FlexUtils.getRelAxisSize(this.item, false);
                    if (this._minHeight) {
                        h = Math.max(this._minHeight, h);
                    }
                    if (this._maxHeight) {
                        h = Math.min(this._maxHeight, h);
                    }
                    FlexUtils.setAxisLayoutSize(this.item, false, h);
                }
            },
            {
                key: "_getCrossAxisMinSizeSetting",
                value: function _getCrossAxisMinSizeSetting() {
                    return this._getMinSizeSetting(!this.ctr._horizontal);
                }
            },
            {
                key: "_getCrossAxisMaxSizeSetting",
                value: function _getCrossAxisMaxSizeSetting() {
                    return this._getMaxSizeSetting(!this.ctr._horizontal);
                }
            },
            {
                key: "_getMainAxisMaxSizeSetting",
                value: function _getMainAxisMaxSizeSetting() {
                    return this._getMaxSizeSetting(this.ctr._horizontal);
                }
            },
            {
                key: "_getMinSizeSetting",
                value: function _getMinSizeSetting(horizontal) {
                    if (horizontal) {
                        return this._minWidth;
                    } else {
                        return this._minHeight;
                    }
                }
            },
            {
                key: "_getMaxSizeSetting",
                value: function _getMaxSizeSetting(horizontal) {
                    if (horizontal) {
                        return this._maxWidth;
                    } else {
                        return this._maxHeight;
                    }
                }
            },
            {
                key: "_getMainAxisMinSize",
                value: function _getMainAxisMinSize() {
                    return FlexUtils.getAxisMinSize(this.item, this.ctr._horizontal);
                }
            },
            {
                key: "_getCrossAxisMinSize",
                value: function _getCrossAxisMinSize() {
                    return FlexUtils.getAxisMinSize(this.item, !this.ctr._horizontal);
                }
            },
            {
                key: "_getMainAxisLayoutSize",
                value: function _getMainAxisLayoutSize() {
                    return FlexUtils.getAxisLayoutSize(this.item, this.ctr._horizontal);
                }
            },
            {
                key: "_getMainAxisLayoutPos",
                value: function _getMainAxisLayoutPos() {
                    return FlexUtils.getAxisLayoutPos(this.item, this.ctr._horizontal);
                }
            },
            {
                key: "_setMainAxisLayoutPos",
                value: function _setMainAxisLayoutPos(pos) {
                    return FlexUtils.setAxisLayoutPos(this.item, this.ctr._horizontal, pos);
                }
            },
            {
                key: "_setCrossAxisLayoutPos",
                value: function _setCrossAxisLayoutPos(pos) {
                    return FlexUtils.setAxisLayoutPos(this.item, !this.ctr._horizontal, pos);
                }
            },
            {
                key: "_getCrossAxisLayoutSize",
                value: function _getCrossAxisLayoutSize() {
                    return FlexUtils.getAxisLayoutSize(this.item, !this.ctr._horizontal);
                }
            },
            {
                key: "_resizeCrossAxis",
                value: function _resizeCrossAxis(size) {
                    return FlexUtils.resizeAxis(this.item, !this.ctr._horizontal, size);
                }
            },
            {
                key: "_resizeMainAxis",
                value: function _resizeMainAxis(size) {
                    return FlexUtils.resizeAxis(this.item, this.ctr._horizontal, size);
                }
            },
            {
                key: "_getMainAxisPadding",
                value: function _getMainAxisPadding() {
                    return FlexUtils.getTotalPadding(this.item, this.ctr._horizontal);
                }
            },
            {
                key: "_getCrossAxisPadding",
                value: function _getCrossAxisPadding() {
                    return FlexUtils.getTotalPadding(this.item, !this.ctr._horizontal);
                }
            },
            {
                key: "_getMainAxisMargin",
                value: function _getMainAxisMargin() {
                    return FlexUtils.getTotalMargin(this.item, this.ctr._horizontal);
                }
            },
            {
                key: "_getCrossAxisMargin",
                value: function _getCrossAxisMargin() {
                    return FlexUtils.getTotalMargin(this.item, !this.ctr._horizontal);
                }
            },
            {
                key: "_getHorizontalMarginOffset",
                value: function _getHorizontalMarginOffset() {
                    return FlexUtils.getMarginOffset(this.item, true);
                }
            },
            {
                key: "_getVerticalMarginOffset",
                value: function _getVerticalMarginOffset() {
                    return FlexUtils.getMarginOffset(this.item, false);
                }
            },
            {
                key: "_getMainAxisMinSizeWithPaddingAndMargin",
                value: function _getMainAxisMinSizeWithPaddingAndMargin() {
                    return this._getMainAxisMinSize() + this._getMainAxisPadding() + this._getMainAxisMargin();
                }
            },
            {
                key: "_getCrossAxisMinSizeWithPaddingAndMargin",
                value: function _getCrossAxisMinSizeWithPaddingAndMargin() {
                    return this._getCrossAxisMinSize() + this._getCrossAxisPadding() + this._getCrossAxisMargin();
                }
            },
            {
                key: "_getMainAxisLayoutSizeWithPaddingAndMargin",
                value: function _getMainAxisLayoutSizeWithPaddingAndMargin() {
                    return this._getMainAxisLayoutSize() + this._getMainAxisPadding() + this._getMainAxisMargin();
                }
            },
            {
                key: "_getCrossAxisLayoutSizeWithPaddingAndMargin",
                value: function _getCrossAxisLayoutSizeWithPaddingAndMargin() {
                    return this._getCrossAxisLayoutSize() + this._getCrossAxisPadding() + this._getCrossAxisMargin();
                }
            },
            {
                key: "_hasFixedCrossAxisSize",
                value: function _hasFixedCrossAxisSize() {
                    return !FlexUtils.isZeroAxisSize(this.item, !this.ctr._horizontal);
                }
            },
            {
                key: "_hasRelCrossAxisSize",
                value: function _hasRelCrossAxisSize() {
                    return !!(this.ctr._horizontal ? this.item.funcH : this.item.funcW);
                }
            }
        ]);
        return FlexItem;
    }();
    FlexItem.SHRINK_AUTO = -1;
    var FlexTarget = /*#__PURE__*/ function() {
        function FlexTarget(target) {
            _class_call_check._(this, FlexTarget);
            this._target = target;
            this._recalc = 0;
            this._enabled = false;
            this.x = 0;
            this.y = 0;
            this.w = 0;
            this.h = 0;
            this._originalX = 0;
            this._originalY = 0;
            this._originalWidth = 0;
            this._originalHeight = 0;
            this._flex = null;
            this._flexItem = null;
            this._flexItemDisabled = false;
            this._items = null;
        }
        _create_class._(FlexTarget, [
            {
                key: "flexLayout",
                get: function get() {
                    return this.flex ? this.flex._layout : null;
                }
            },
            {
                key: "layoutFlexTree",
                value: function layoutFlexTree() {
                    if (this.isFlexEnabled() && this.isChanged()) {
                        this.flexLayout.layoutTree();
                    }
                }
            },
            {
                key: "target",
                get: function get() {
                    return this._target;
                }
            },
            {
                key: "flex",
                get: function get() {
                    return this._flex;
                },
                set: function set(v) {
                    if (!v) {
                        if (this.isFlexEnabled()) {
                            this._disableFlex();
                        }
                    } else {
                        if (!this.isFlexEnabled()) {
                            this._enableFlex();
                        }
                        this._flex.patch(v);
                    }
                }
            },
            {
                key: "flexItem",
                get: function get() {
                    if (this._flexItemDisabled) {
                        return false;
                    }
                    this._ensureFlexItem();
                    return this._flexItem;
                },
                set: function set(v) {
                    if (v === false) {
                        if (!this._flexItemDisabled) {
                            var parent = this.flexParent;
                            this._flexItemDisabled = true;
                            this._checkEnabled();
                            if (parent) {
                                parent._clearFlexItemsCache();
                                parent.changedContents();
                            }
                        }
                    } else {
                        this._ensureFlexItem();
                        this._flexItem.patch(v);
                        if (this._flexItemDisabled) {
                            this._flexItemDisabled = false;
                            this._checkEnabled();
                            var parent1 = this.flexParent;
                            if (parent1) {
                                parent1._clearFlexItemsCache();
                                parent1.changedContents();
                            }
                        }
                    }
                }
            },
            {
                key: "_enableFlex",
                value: function _enableFlex() {
                    this._flex = new FlexContainer(this);
                    this._checkEnabled();
                    this.changedDimensions();
                    this._enableChildrenAsFlexItems();
                }
            },
            {
                key: "_disableFlex",
                value: function _disableFlex() {
                    this.changedDimensions();
                    this._flex = null;
                    this._checkEnabled();
                    this._disableChildrenAsFlexItems();
                }
            },
            {
                key: "_enableChildrenAsFlexItems",
                value: function _enableChildrenAsFlexItems() {
                    var children = this._target._children;
                    if (children) {
                        for(var i = 0, n = children.length; i < n; i++){
                            var child = children[i];
                            child.layout._enableFlexItem();
                        }
                    }
                }
            },
            {
                key: "_disableChildrenAsFlexItems",
                value: function _disableChildrenAsFlexItems() {
                    var children = this._target._children;
                    if (children) {
                        for(var i = 0, n = children.length; i < n; i++){
                            var child = children[i];
                            child.layout._disableFlexItem();
                        }
                    }
                }
            },
            {
                key: "_enableFlexItem",
                value: function _enableFlexItem() {
                    this._ensureFlexItem();
                    var flexParent = this._target._parent._layout;
                    this._flexItem.ctr = flexParent._flex;
                    flexParent.changedContents();
                    this._checkEnabled();
                }
            },
            {
                key: "_disableFlexItem",
                value: function _disableFlexItem() {
                    if (this._flexItem) {
                        this._flexItem.ctr = null;
                    }
                    this._checkEnabled();
                    this._resetOffsets();
                }
            },
            {
                key: "_resetOffsets",
                value: function _resetOffsets() {
                    this.x = 0;
                    this.y = 0;
                }
            },
            {
                key: "_ensureFlexItem",
                value: function _ensureFlexItem() {
                    if (!this._flexItem) {
                        this._flexItem = new FlexItem(this);
                    }
                }
            },
            {
                key: "_checkEnabled",
                value: function _checkEnabled() {
                    var enabled = this.isEnabled();
                    if (this._enabled !== enabled) {
                        if (enabled) {
                            this._enable();
                        } else {
                            this._disable();
                        }
                        this._enabled = enabled;
                    }
                }
            },
            {
                key: "_enable",
                value: function _enable() {
                    this._setupTargetForFlex();
                    this._target.enableFlexLayout();
                }
            },
            {
                key: "_disable",
                value: function _disable() {
                    this._restoreTargetToNonFlex();
                    this._target.disableFlexLayout();
                }
            },
            {
                key: "isEnabled",
                value: function isEnabled() {
                    return this.isFlexEnabled() || this.isFlexItemEnabled();
                }
            },
            {
                key: "isFlexEnabled",
                value: function isFlexEnabled() {
                    return this._flex !== null;
                }
            },
            {
                key: "isFlexItemEnabled",
                value: function isFlexItemEnabled() {
                    return this.flexParent !== null;
                }
            },
            {
                key: "_restoreTargetToNonFlex",
                value: function _restoreTargetToNonFlex() {
                    var target = this._target;
                    target.x = this._originalX;
                    target.y = this._originalY;
                    target.setDimensions(this._originalWidth, this._originalHeight);
                }
            },
            {
                key: "_setupTargetForFlex",
                value: function _setupTargetForFlex() {
                    var target = this._target;
                    this._originalX = target._x;
                    this._originalY = target._y;
                    this._originalWidth = target._w;
                    this._originalHeight = target._h;
                }
            },
            {
                key: "setParent",
                value: function setParent(from, to) {
                    if (from && from.isFlexContainer()) {
                        from._layout._changedChildren();
                    }
                    if (to && to.isFlexContainer()) {
                        this._enableFlexItem();
                        to._layout._changedChildren();
                    }
                    this._checkEnabled();
                }
            },
            {
                key: "flexParent",
                get: function get() {
                    if (this._flexItemDisabled) {
                        return null;
                    }
                    var parent = this._target._parent;
                    if (parent && parent.isFlexContainer()) {
                        return parent._layout;
                    }
                    return null;
                }
            },
            {
                key: "setVisible",
                value: function setVisible(v) {
                    var parent = this.flexParent;
                    if (parent) {
                        parent._changedChildren();
                    }
                }
            },
            {
                key: "items",
                get: function get() {
                    if (!this._items) {
                        this._items = this._getFlexItems();
                    }
                    return this._items;
                }
            },
            {
                key: "_getFlexItems",
                value: function _getFlexItems() {
                    var items = [];
                    var children = this._target._children;
                    if (children) {
                        for(var i = 0, n = children.length; i < n; i++){
                            var item = children[i];
                            if (item.visible) {
                                if (item.isFlexItem()) {
                                    items.push(item.layout);
                                }
                            }
                        }
                    }
                    return items;
                }
            },
            {
                key: "_changedChildren",
                value: function _changedChildren() {
                    this._clearFlexItemsCache();
                    this.changedContents();
                }
            },
            {
                key: "_clearFlexItemsCache",
                value: function _clearFlexItemsCache() {
                    this._items = null;
                }
            },
            {
                key: "setLayout",
                value: function setLayout(x, y, w, h) {
                    var originalX = this._originalX;
                    var originalY = this._originalY;
                    if (this.funcX) {
                        originalX = this.funcX(FlexUtils.getParentAxisSizeWithPadding(this, true));
                    }
                    if (this.funcY) {
                        originalY = this.funcY(FlexUtils.getParentAxisSizeWithPadding(this, false));
                    }
                    if (this.isFlexItemEnabled()) {
                        this.target.setLayout(x + originalX, y + originalY, w, h);
                    } else {
                        this.target.setLayout(originalX, originalY, w, h);
                    }
                }
            },
            {
                key: "changedDimensions",
                value: function changedDimensions() {
                    var changeWidth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, changeHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                    this._updateRecalc(changeWidth, changeHeight);
                }
            },
            {
                key: "changedContents",
                value: function changedContents() {
                    this._updateRecalc();
                }
            },
            {
                key: "forceLayout",
                value: function forceLayout() {
                    this._updateRecalc();
                }
            },
            {
                key: "isChanged",
                value: function isChanged() {
                    return this._recalc > 0;
                }
            },
            {
                key: "_updateRecalc",
                value: function _updateRecalc() {
                    var changeExternalWidth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, changeExternalHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    if (this.isFlexEnabled()) {
                        var layout = this._flex._layout;
                        changeExternalWidth = changeExternalWidth || layout.isAxisFitToContents(true);
                        changeExternalHeight = changeExternalHeight || layout.isAxisFitToContents(false);
                    }
                    var recalc = 1 + (changeExternalWidth ? 2 : 0) + (changeExternalHeight ? 4 : 0);
                    var newRecalcFlags = this.getNewRecalcFlags(recalc);
                    this._recalc |= recalc;
                    if (newRecalcFlags > 1) {
                        if (this.flexParent) {
                            this.flexParent._updateRecalcBottomUp(recalc);
                        } else {
                            this._target.triggerLayout();
                        }
                    } else {
                        this._target.triggerLayout();
                    }
                }
            },
            {
                key: "getNewRecalcFlags",
                value: function getNewRecalcFlags(flags) {
                    return 7 - this._recalc & flags;
                }
            },
            {
                key: "_updateRecalcBottomUp",
                value: function _updateRecalcBottomUp(childRecalc) {
                    var newRecalc = this._getRecalcFromChangedChildRecalc(childRecalc);
                    var newRecalcFlags = this.getNewRecalcFlags(newRecalc);
                    this._recalc |= newRecalc;
                    if (newRecalcFlags > 1) {
                        var flexParent = this.flexParent;
                        if (flexParent) {
                            flexParent._updateRecalcBottomUp(newRecalc);
                        } else {
                            this._target.triggerLayout();
                        }
                    } else {
                        this._target.triggerLayout();
                    }
                }
            },
            {
                key: "_getRecalcFromChangedChildRecalc",
                value: function _getRecalcFromChangedChildRecalc(childRecalc) {
                    var layout = this._flex._layout;
                    var mainAxisRecalcFlag = layout._horizontal ? 1 : 2;
                    var crossAxisRecalcFlag = layout._horizontal ? 2 : 1;
                    var crossAxisDimensionsChangedInChild = childRecalc & crossAxisRecalcFlag;
                    if (!crossAxisDimensionsChangedInChild) {
                        var mainAxisDimensionsChangedInChild = childRecalc & mainAxisRecalcFlag;
                        if (mainAxisDimensionsChangedInChild) {
                            var mainAxisIsWrapping = layout.isWrapping();
                            if (mainAxisIsWrapping) {
                                var crossAxisIsFitToContents = layout.isCrossAxisFitToContents();
                                if (crossAxisIsFitToContents) {
                                    childRecalc += crossAxisRecalcFlag;
                                }
                            }
                        }
                    }
                    var isWidthDynamic = layout.isAxisFitToContents(true);
                    var isHeightDynamic = layout.isAxisFitToContents(false);
                    if (layout.shrunk) {
                        if (layout._horizontal) {
                            isWidthDynamic = true;
                        } else {
                            isHeightDynamic = true;
                        }
                    }
                    var localRecalc = 1 + (isWidthDynamic ? 2 : 0) + (isHeightDynamic ? 4 : 0);
                    var combinedRecalc = childRecalc & localRecalc;
                    return combinedRecalc;
                }
            },
            {
                key: "recalc",
                get: function get() {
                    return this._recalc;
                }
            },
            {
                key: "clearRecalcFlag",
                value: function clearRecalcFlag() {
                    this._recalc = 0;
                }
            },
            {
                key: "enableLocalRecalcFlag",
                value: function enableLocalRecalcFlag() {
                    this._recalc = 1;
                }
            },
            {
                key: "originalX",
                get: function get() {
                    return this._originalX;
                }
            },
            {
                key: "setOriginalXWithoutUpdatingLayout",
                value: function setOriginalXWithoutUpdatingLayout(v) {
                    this._originalX = v;
                }
            },
            {
                key: "originalY",
                get: function get() {
                    return this._originalY;
                }
            },
            {
                key: "setOriginalYWithoutUpdatingLayout",
                value: function setOriginalYWithoutUpdatingLayout(v) {
                    this._originalY = v;
                }
            },
            {
                key: "originalWidth",
                get: function get() {
                    return this._originalWidth;
                },
                set: function set(v) {
                    if (this._originalWidth !== v) {
                        this._originalWidth = v;
                        this.changedDimensions(true, false);
                    }
                }
            },
            {
                key: "originalHeight",
                get: function get() {
                    return this._originalHeight;
                },
                set: function set(v) {
                    if (this._originalHeight !== v) {
                        this._originalHeight = v;
                        this.changedDimensions(false, true);
                    }
                }
            },
            {
                key: "funcX",
                get: function get() {
                    return this._target.funcX;
                }
            },
            {
                key: "funcY",
                get: function get() {
                    return this._target.funcY;
                }
            },
            {
                key: "funcW",
                get: function get() {
                    return this._target.funcW;
                }
            },
            {
                key: "funcH",
                get: function get() {
                    return this._target.funcH;
                }
            }
        ]);
        return FlexTarget;
    }();
    var TextureSource = /*#__PURE__*/ function() {
        function TextureSource(manager) {
            var loader = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            _class_call_check._(this, TextureSource);
            this.id = TextureSource.id++;
            this.manager = manager;
            this.stage = manager.stage;
            this.textures = new Set();
            this._activeTextureCount = 0;
            this.loader = loader;
            this.lookupId = null;
            this._cancelCb = null;
            this.loadingSince = 0;
            this.w = 0;
            this.h = 0;
            this._nativeTexture = null;
            this.permanent = false;
            this.renderInfo = null;
            this._isResultTexture = !this.loader;
            this._loadError = null;
            this._imageRef = null;
            this._hasAlpha = false;
        }
        _create_class._(TextureSource, [
            {
                key: "hasAlpha",
                get: function get() {
                    return this._hasAlpha;
                }
            },
            {
                key: "loadError",
                get: function get() {
                    return this._loadError;
                }
            },
            {
                key: "addTexture",
                value: function addTexture(v) {
                    if (!this.textures.has(v)) {
                        this.textures.add(v);
                    }
                }
            },
            {
                key: "removeTexture",
                value: function removeTexture(v) {
                    this.textures.delete(v);
                }
            },
            {
                key: "incActiveTextureCount",
                value: function incActiveTextureCount() {
                    this._activeTextureCount++;
                    if (this._activeTextureCount === 1) {
                        this.becomesUsed();
                    }
                }
            },
            {
                key: "decActiveTextureCount",
                value: function decActiveTextureCount() {
                    this._activeTextureCount--;
                    if (this._activeTextureCount === 0) {
                        this.becomesUnused();
                    }
                }
            },
            {
                key: "isResultTexture",
                get: function get() {
                    return this._isResultTexture;
                },
                set: function set(v) {
                    this._isResultTexture = v;
                }
            },
            {
                key: "forEachEnabledElement",
                value: function forEachEnabledElement(cb) {
                    this.textures.forEach(function(texture) {
                        texture.elements.forEach(cb);
                    });
                }
            },
            {
                key: "hasEnabledElements",
                value: function hasEnabledElements() {
                    return this.textures.size > 0;
                }
            },
            {
                key: "forEachActiveElement",
                value: function forEachActiveElement(cb) {
                    this.textures.forEach(function(texture) {
                        texture.elements.forEach(function(element) {
                            if (element.active) {
                                cb(element);
                            }
                        });
                    });
                }
            },
            {
                key: "getRenderWidth",
                value: function getRenderWidth() {
                    return this.w;
                }
            },
            {
                key: "getRenderHeight",
                value: function getRenderHeight() {
                    return this.h;
                }
            },
            {
                key: "allowCleanup",
                value: function allowCleanup() {
                    return !this.permanent && !this.isUsed();
                }
            },
            {
                key: "becomesUsed",
                value: function becomesUsed() {
                    this.load();
                }
            },
            {
                key: "becomesUnused",
                value: function becomesUnused() {
                    this.cancel();
                }
            },
            {
                key: "cancel",
                value: function cancel() {
                    if (this.isLoading()) {
                        if (this._cancelCb) {
                            this._cancelCb(this);
                            this._cancelCb = null;
                        }
                        this.loadingSince = 0;
                    }
                }
            },
            {
                key: "isLoaded",
                value: function isLoaded() {
                    return !!this._nativeTexture;
                }
            },
            {
                key: "isLoading",
                value: function isLoading() {
                    return this.loadingSince > 0;
                }
            },
            {
                key: "isError",
                value: function isError() {
                    return !!this._loadError;
                }
            },
            {
                key: "reload",
                value: function reload() {
                    this.free();
                    if (this.isUsed()) {
                        this.load();
                    }
                }
            },
            {
                key: "load",
                value: function load() {
                    var forceSync = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    var _this = this;
                    if (this.isResultTexture) {
                        return;
                    }
                    if (!this._nativeTexture && !this.isLoading()) {
                        this.loadingSince = new Date().getTime();
                        this._cancelCb = this.loader(function(err, options) {
                            if (_this.isLoading()) {
                                _this._cancelCb = null;
                                if (_this.manager.stage.destroyed) {
                                    return;
                                }
                                if (err) {
                                    _this.onError(err);
                                } else if (options && options.source) {
                                    if (!_this.stage.isUpdatingFrame() && !forceSync && options.throttle !== false) {
                                        var textureThrottler = _this.stage.textureThrottler;
                                        _this._cancelCb = textureThrottler.genericCancelCb;
                                        textureThrottler.add(_this, options);
                                    } else {
                                        _this.processLoadedSource(options);
                                    }
                                }
                            }
                        }, this);
                    }
                }
            },
            {
                key: "processLoadedSource",
                value: function processLoadedSource(options) {
                    this.loadingSince = 0;
                    this.setSource(options);
                }
            },
            {
                key: "setSource",
                value: function setSource(options) {
                    var source = options.source;
                    this._hasAlpha = options ? options.hasAlpha || false : false;
                    this.w = source.width || options && options.w || 0;
                    this.h = source.height || options && options.h || 0;
                    if (options && options.renderInfo) {
                        this.renderInfo = options.renderInfo;
                    }
                    this.permanent = !!options.permanent;
                    if (options && options.imageRef) this._imageRef = options.imageRef;
                    if (options && options.flipTextureY) {
                        this._flipTextureY = options.flipTextureY;
                    } else {
                        this._flipTextureY = false;
                    }
                    if (this._isNativeTexture(source)) {
                        this._nativeTexture = source;
                        this.w = this.w || source.w;
                        this.h = this.h || source.h;
                        this.permanent = options.hasOwnProperty("permanent") ? options.permanent : true;
                    } else {
                        this.manager.uploadTextureSource(this, options);
                    }
                    this._loadError = null;
                    this.onLoad();
                }
            },
            {
                key: "isUsed",
                value: function isUsed() {
                    return this._activeTextureCount > 0;
                }
            },
            {
                key: "onLoad",
                value: function onLoad() {
                    if (this.isUsed()) {
                        this.textures.forEach(function(texture) {
                            texture.onLoad();
                        });
                    }
                }
            },
            {
                key: "forceRenderUpdate",
                value: function forceRenderUpdate() {
                    if (this._nativeTexture) {
                        this._nativeTexture.update = this.stage.frameCounter;
                    }
                    this.forEachActiveElement(function(element) {
                        element.forceRenderUpdate();
                    });
                }
            },
            {
                key: "forceUpdateRenderCoords",
                value: function forceUpdateRenderCoords() {
                    this.forEachActiveElement(function(element) {
                        element._updateTextureCoords();
                    });
                }
            },
            {
                key: "nativeTexture",
                get: function get() {
                    return this._nativeTexture;
                }
            },
            {
                key: "clearNativeTexture",
                value: function clearNativeTexture() {
                    this._nativeTexture = null;
                    this._imageRef = null;
                }
            },
            {
                key: "replaceNativeTexture",
                value: function replaceNativeTexture(newNativeTexture, w, h) {
                    var prevNativeTexture = this._nativeTexture;
                    this._nativeTexture = newNativeTexture;
                    this.w = w;
                    this.h = h;
                    if (!prevNativeTexture && this._nativeTexture) {
                        this.forEachActiveElement(function(element) {
                            return element.onTextureSourceLoaded();
                        });
                    }
                    if (!this._nativeTexture) {
                        this.forEachActiveElement(function(element) {
                            return element._setDisplayedTexture(null);
                        });
                    }
                    this.forEachEnabledElement(function(element) {
                        return element._updateDimensions();
                    });
                }
            },
            {
                key: "onError",
                value: function onError(e) {
                    this._loadError = e;
                    this.loadingSince = 0;
                    console.error("[Lightning] texture load error", e, this.lookupId);
                    this.forEachActiveElement(function(element) {
                        return element.onTextureSourceLoadError(e);
                    });
                }
            },
            {
                key: "free",
                value: function free() {
                    if (this.isLoaded()) {
                        this.manager.freeTextureSource(this);
                    }
                }
            },
            {
                key: "_isNativeTexture",
                value: function _isNativeTexture(source) {
                    if (Utils.isNode) {
                        return source.constructor.name === "WebGLTexture";
                    }
                    if ("WebGLTexture" in window) {
                        return source instanceof WebGLTexture;
                    }
                    return false;
                }
            }
        ]);
        return TextureSource;
    }();
    TextureSource.prototype.isTextureSource = true;
    TextureSource.id = 1;
    var ElementTexturizer = /*#__PURE__*/ function() {
        function ElementTexturizer(elementCore) {
            _class_call_check._(this, ElementTexturizer);
            this._element = elementCore.element;
            this._core = elementCore;
            this.ctx = this._core.ctx;
            this._enabled = false;
            this.lazy = false;
            this._colorize = false;
            this._renderTexture = null;
            this._renderTextureReused = false;
            this._resultTextureSource = null;
            this._renderOffscreen = false;
            this.empty = false;
        }
        _create_class._(ElementTexturizer, [
            {
                key: "enabled",
                get: function get() {
                    return this._enabled;
                },
                set: function set(v) {
                    this._enabled = v;
                    this._core.updateRenderToTextureEnabled();
                }
            },
            {
                key: "renderOffscreen",
                get: function get() {
                    return this._renderOffscreen;
                },
                set: function set(v) {
                    this._renderOffscreen = v;
                    this._core.setHasRenderUpdates(1);
                    this._core._setRecalc(6);
                }
            },
            {
                key: "colorize",
                get: function get() {
                    return this._colorize;
                },
                set: function set(v) {
                    if (this._colorize !== v) {
                        this._colorize = v;
                        this._core.setHasRenderUpdates(1);
                    }
                }
            },
            {
                key: "_getTextureSource",
                value: function _getTextureSource() {
                    if (!this._resultTextureSource) {
                        this._resultTextureSource = new TextureSource(this._element.stage.textureManager);
                        this.updateResultTexture();
                    }
                    return this._resultTextureSource;
                }
            },
            {
                key: "hasResultTexture",
                value: function hasResultTexture() {
                    return !!this._resultTextureSource;
                }
            },
            {
                key: "resultTextureInUse",
                value: function resultTextureInUse() {
                    return this._resultTextureSource && this._resultTextureSource.hasEnabledElements();
                }
            },
            {
                key: "updateResultTexture",
                value: function updateResultTexture() {
                    var resultTexture = this.getResultTexture();
                    if (this._resultTextureSource) {
                        if (this._resultTextureSource.nativeTexture !== resultTexture) {
                            var w = resultTexture ? resultTexture.w : 0;
                            var h = resultTexture ? resultTexture.h : 0;
                            this._resultTextureSource.replaceNativeTexture(resultTexture, w, h);
                        }
                        this._resultTextureSource.forEachEnabledElement(function(element) {
                            element._updateDimensions();
                            element.core.setHasRenderUpdates(3);
                        });
                    }
                }
            },
            {
                key: "mustRenderToTexture",
                value: function mustRenderToTexture() {
                    if (this._enabled && !this.lazy) {
                        return true;
                    } else if (this._enabled && this.lazy && this._core._hasRenderUpdates < 3) {
                        return true;
                    }
                    return false;
                }
            },
            {
                key: "deactivate",
                value: function deactivate() {
                    this.release();
                }
            },
            {
                key: "renderTextureReused",
                get: function get() {
                    return this._renderTextureReused;
                }
            },
            {
                key: "release",
                value: function release() {
                    this.releaseRenderTexture();
                }
            },
            {
                key: "releaseRenderTexture",
                value: function releaseRenderTexture() {
                    if (this._renderTexture) {
                        if (!this._renderTextureReused) {
                            this.ctx.releaseRenderTexture(this._renderTexture);
                        }
                        this._renderTexture = null;
                        this._renderTextureReused = false;
                        this.updateResultTexture();
                    }
                }
            },
            {
                key: "reuseTextureAsRenderTexture",
                value: function reuseTextureAsRenderTexture(nativeTexture) {
                    if (this._renderTexture !== nativeTexture) {
                        this.releaseRenderTexture();
                        this._renderTexture = nativeTexture;
                        this._renderTextureReused = true;
                    }
                }
            },
            {
                key: "hasRenderTexture",
                value: function hasRenderTexture() {
                    return !!this._renderTexture;
                }
            },
            {
                key: "getRenderTexture",
                value: function getRenderTexture() {
                    if (!this._renderTexture) {
                        this._renderTexture = this.ctx.allocateRenderTexture(this._core._w, this._core._h);
                        this._renderTextureReused = false;
                    }
                    return this._renderTexture;
                }
            },
            {
                key: "getResultTexture",
                value: function getResultTexture() {
                    return this._renderTexture;
                }
            }
        ]);
        return ElementTexturizer;
    }();
    var ElementCore = /*#__PURE__*/ function() {
        function ElementCore(element) {
            _class_call_check._(this, ElementCore);
            this._element = element;
            this.ctx = element.stage.ctx;
            this._recalc = 0;
            this._parent = null;
            this._onUpdate = null;
            this._pRecalc = 0;
            this._worldContext = new ElementCoreContext();
            this._hasUpdates = false;
            this._localAlpha = 1;
            this._onAfterCalcs = null;
            this._onAfterUpdate = null;
            this._localPx = 0;
            this._localPy = 0;
            this._localTa = 1;
            this._localTb = 0;
            this._localTc = 0;
            this._localTd = 1;
            this._isComplex = false;
            this._dimsUnknown = false;
            this._clipping = false;
            this._zSort = false;
            this._outOfBounds = 0;
            this._displayedTextureSource = null;
            this._zContextUsage = 0;
            this._children = null;
            this._hasRenderUpdates = 0;
            this._zIndexedChildren = null;
            this._renderContext = this._worldContext;
            this.renderState = this.ctx.renderState;
            this._scissor = null;
            this._shaderOwner = null;
            this._updateTreeOrder = 0;
            this._colorUl = this._colorUr = this._colorBl = this._colorBr = 0xFFFFFFFF;
            this._x = 0;
            this._y = 0;
            this._w = 0;
            this._h = 0;
            this._optFlags = 0;
            this._funcX = null;
            this._funcY = null;
            this._funcW = null;
            this._funcH = null;
            this._scaleX = 1;
            this._scaleY = 1;
            this._pivotX = 0.5;
            this._pivotY = 0.5;
            this._mountX = 0;
            this._mountY = 0;
            this._rotation = 0;
            this._alpha = 1;
            this._visible = true;
            this._ulx = 0;
            this._uly = 0;
            this._brx = 1;
            this._bry = 1;
            this._zIndex = 0;
            this._forceZIndexContext = false;
            this._zParent = null;
            this._isRoot = false;
            this._zIndexResort = false;
            this._shader = null;
            this._renderToTextureEnabled = false;
            this._texturizer = null;
            this._useRenderToTexture = false;
            this._boundsMargin = null;
            this._recBoundsMargin = null;
            this._withinBoundsMargin = false;
            this._viewport = null;
            this._clipbox = true;
            this.render = this._renderSimple;
            this._layout = null;
        }
        _create_class._(ElementCore, [
            {
                key: "offsetX",
                get: function get() {
                    if (this._funcX) {
                        return this._funcX;
                    } else {
                        if (this.hasFlexLayout()) {
                            return this._layout.originalX;
                        } else {
                            return this._x;
                        }
                    }
                },
                set: function set(v) {
                    if (Utils.isFunction(v)) {
                        this.funcX = v;
                    } else {
                        this._disableFuncX();
                        if (this.hasFlexLayout()) {
                            this.x += v - this._layout.originalX;
                            this._layout.setOriginalXWithoutUpdatingLayout(v);
                        } else {
                            this.x = v;
                        }
                    }
                }
            },
            {
                key: "x",
                get: function get() {
                    return this._x;
                },
                set: function set(v) {
                    if (v !== this._x) {
                        this._updateLocalTranslateDelta(v - this._x, 0);
                        this._x = v;
                    }
                }
            },
            {
                key: "funcX",
                get: function get() {
                    return this._optFlags & 1 ? this._funcX : null;
                },
                set: function set(v) {
                    if (this._funcX !== v) {
                        this._optFlags |= 1;
                        this._funcX = v;
                        if (this.hasFlexLayout()) {
                            this._layout.setOriginalXWithoutUpdatingLayout(0);
                            this.layout.forceLayout();
                        } else {
                            this._x = 0;
                            this._triggerRecalcTranslate();
                        }
                    }
                }
            },
            {
                key: "_disableFuncX",
                value: function _disableFuncX() {
                    this._optFlags = this._optFlags & 0xFFFF - 1;
                    this._funcX = null;
                }
            },
            {
                key: "offsetY",
                get: function get() {
                    if (this._funcY) {
                        return this._funcY;
                    } else {
                        if (this.hasFlexLayout()) {
                            return this._layout.originalY;
                        } else {
                            return this._y;
                        }
                    }
                },
                set: function set(v) {
                    if (Utils.isFunction(v)) {
                        this.funcY = v;
                    } else {
                        this._disableFuncY();
                        if (this.hasFlexLayout()) {
                            this.y += v - this._layout.originalY;
                            this._layout.setOriginalYWithoutUpdatingLayout(v);
                        } else {
                            this.y = v;
                        }
                    }
                }
            },
            {
                key: "y",
                get: function get() {
                    return this._y;
                },
                set: function set(v) {
                    if (v !== this._y) {
                        this._updateLocalTranslateDelta(0, v - this._y);
                        this._y = v;
                    }
                }
            },
            {
                key: "funcY",
                get: function get() {
                    return this._optFlags & 2 ? this._funcY : null;
                },
                set: function set(v) {
                    if (this._funcY !== v) {
                        this._optFlags |= 2;
                        this._funcY = v;
                        if (this.hasFlexLayout()) {
                            this._layout.setOriginalYWithoutUpdatingLayout(0);
                            this.layout.forceLayout();
                        } else {
                            this._y = 0;
                            this._triggerRecalcTranslate();
                        }
                    }
                }
            },
            {
                key: "_disableFuncY",
                value: function _disableFuncY() {
                    this._optFlags = this._optFlags & 0xFFFF - 2;
                    this._funcY = null;
                }
            },
            {
                key: "funcW",
                get: function get() {
                    return this._optFlags & 4 ? this._funcW : null;
                },
                set: function set(v) {
                    if (this._funcW !== v) {
                        this._optFlags |= 4;
                        this._funcW = v;
                        if (this.hasFlexLayout()) {
                            this._layout._originalWidth = 0;
                            this.layout.changedDimensions(true, false);
                        } else {
                            this._w = 0;
                            this._triggerRecalcTranslate();
                        }
                    }
                }
            },
            {
                key: "disableFuncW",
                value: function disableFuncW() {
                    this._optFlags = this._optFlags & 0xFFFF - 4;
                    this._funcW = null;
                }
            },
            {
                key: "funcH",
                get: function get() {
                    return this._optFlags & 8 ? this._funcH : null;
                },
                set: function set(v) {
                    if (this._funcH !== v) {
                        this._optFlags |= 8;
                        this._funcH = v;
                        if (this.hasFlexLayout()) {
                            this._layout._originalHeight = 0;
                            this.layout.changedDimensions(false, true);
                        } else {
                            this._h = 0;
                            this._triggerRecalcTranslate();
                        }
                    }
                }
            },
            {
                key: "disableFuncH",
                value: function disableFuncH() {
                    this._optFlags = this._optFlags & 0xFFFF - 8;
                    this._funcH = null;
                }
            },
            {
                key: "w",
                get: function get() {
                    return this._w;
                }
            },
            {
                key: "getRenderWidth",
                value: function getRenderWidth() {
                    if (this.hasFlexLayout()) {
                        return this._layout.originalWidth;
                    } else {
                        return this._w;
                    }
                }
            },
            {
                key: "h",
                get: function get() {
                    return this._h;
                }
            },
            {
                key: "getRenderHeight",
                value: function getRenderHeight() {
                    if (this.hasFlexLayout()) {
                        return this._layout.originalHeight;
                    } else {
                        return this._h;
                    }
                }
            },
            {
                key: "scaleX",
                get: function get() {
                    return this._scaleX;
                },
                set: function set(v) {
                    if (this._scaleX !== v) {
                        this._scaleX = v;
                        this._updateLocalTransform();
                    }
                }
            },
            {
                key: "scaleY",
                get: function get() {
                    return this._scaleY;
                },
                set: function set(v) {
                    if (this._scaleY !== v) {
                        this._scaleY = v;
                        this._updateLocalTransform();
                    }
                }
            },
            {
                key: "scale",
                get: function get() {
                    return this.scaleX;
                },
                set: function set(v) {
                    if (this._scaleX !== v || this._scaleY !== v) {
                        this._scaleX = v;
                        this._scaleY = v;
                        this._updateLocalTransform();
                    }
                }
            },
            {
                key: "pivotX",
                get: function get() {
                    return this._pivotX;
                },
                set: function set(v) {
                    if (this._pivotX !== v) {
                        this._pivotX = v;
                        this._updateLocalTranslate();
                    }
                }
            },
            {
                key: "pivotY",
                get: function get() {
                    return this._pivotY;
                },
                set: function set(v) {
                    if (this._pivotY !== v) {
                        this._pivotY = v;
                        this._updateLocalTranslate();
                    }
                }
            },
            {
                key: "pivot",
                get: function get() {
                    return this._pivotX;
                },
                set: function set(v) {
                    if (this._pivotX !== v || this._pivotY !== v) {
                        this._pivotX = v;
                        this._pivotY = v;
                        this._updateLocalTranslate();
                    }
                }
            },
            {
                key: "mountX",
                get: function get() {
                    return this._mountX;
                },
                set: function set(v) {
                    if (this._mountX !== v) {
                        this._mountX = v;
                        this._updateLocalTranslate();
                    }
                }
            },
            {
                key: "mountY",
                get: function get() {
                    return this._mountY;
                },
                set: function set(v) {
                    if (this._mountY !== v) {
                        this._mountY = v;
                        this._updateLocalTranslate();
                    }
                }
            },
            {
                key: "mount",
                get: function get() {
                    return this._mountX;
                },
                set: function set(v) {
                    if (this._mountX !== v || this._mountY !== v) {
                        this._mountX = v;
                        this._mountY = v;
                        this._updateLocalTranslate();
                    }
                }
            },
            {
                key: "rotation",
                get: function get() {
                    return this._rotation;
                },
                set: function set(v) {
                    if (this._rotation !== v) {
                        this._rotation = v;
                        this._updateLocalTransform();
                    }
                }
            },
            {
                key: "alpha",
                get: function get() {
                    return this._alpha;
                },
                set: function set(v) {
                    v = v > 1 ? 1 : v < 1e-14 ? 0 : v;
                    if (this._alpha !== v) {
                        var prev = this._alpha;
                        this._alpha = v;
                        this._updateLocalAlpha();
                        if (prev === 0 !== (v === 0)) {
                            this._element._updateEnabledFlag();
                        }
                    }
                }
            },
            {
                key: "visible",
                get: function get() {
                    return this._visible;
                },
                set: function set(v) {
                    if (this._visible !== v) {
                        this._visible = v;
                        this._updateLocalAlpha();
                        this._element._updateEnabledFlag();
                        if (this.hasFlexLayout()) {
                            this.layout.setVisible(v);
                        }
                    }
                }
            },
            {
                key: "_updateLocalTransform",
                value: function _updateLocalTransform() {
                    if (this._rotation !== 0 && this._rotation % (2 * Math.PI)) {
                        var _sr = Math.sin(this._rotation);
                        var _cr = Math.cos(this._rotation);
                        this._setLocalTransform(_cr * this._scaleX, -_sr * this._scaleY, _sr * this._scaleX, _cr * this._scaleY);
                    } else {
                        this._setLocalTransform(this._scaleX, 0, 0, this._scaleY);
                    }
                    this._updateLocalTranslate();
                }
            },
            {
                key: "_updateLocalTranslate",
                value: function _updateLocalTranslate() {
                    this._recalcLocalTranslate();
                    this._triggerRecalcTranslate();
                }
            },
            {
                key: "_recalcLocalTranslate",
                value: function _recalcLocalTranslate() {
                    var pivotXMul = this._pivotX * this._w;
                    var pivotYMul = this._pivotY * this._h;
                    var px = this._x - (pivotXMul * this._localTa + pivotYMul * this._localTb) + pivotXMul;
                    var py = this._y - (pivotXMul * this._localTc + pivotYMul * this._localTd) + pivotYMul;
                    px -= this._mountX * this._w;
                    py -= this._mountY * this._h;
                    this._localPx = px;
                    this._localPy = py;
                }
            },
            {
                key: "_updateLocalTranslateDelta",
                value: function _updateLocalTranslateDelta(dx, dy) {
                    this._addLocalTranslate(dx, dy);
                }
            },
            {
                key: "_updateLocalAlpha",
                value: function _updateLocalAlpha() {
                    this._setLocalAlpha(this._visible ? this._alpha : 0);
                }
            },
            {
                key: "setHasRenderUpdates",
                value: function setHasRenderUpdates(type) {
                    if (this._worldContext.alpha) {
                        var p = this;
                        p._hasRenderUpdates = Math.max(type, p._hasRenderUpdates);
                        while((p = p._parent) && p._hasRenderUpdates !== 3){
                            p._hasRenderUpdates = 3;
                        }
                    }
                }
            },
            {
                key: "_setRecalc",
                value: function _setRecalc(type) {
                    this._recalc |= type;
                    this._setHasUpdates();
                    if (this._parent) {
                        this._parent.setHasRenderUpdates(3);
                    }
                }
            },
            {
                key: "_setHasUpdates",
                value: function _setHasUpdates() {
                    var p = this;
                    while(p && !p._hasUpdates){
                        p._hasUpdates = true;
                        p = p._parent;
                    }
                }
            },
            {
                key: "getParent",
                value: function getParent() {
                    return this._parent;
                }
            },
            {
                key: "setParent",
                value: function setParent(parent) {
                    if (parent !== this._parent) {
                        var prevIsZContext = this.isZContext();
                        var prevParent = this._parent;
                        this._parent = parent;
                        if (this._layout || parent && parent.isFlexContainer()) {
                            this.layout.setParent(prevParent, parent);
                        }
                        if (prevParent) {
                            prevParent.setHasRenderUpdates(3);
                        }
                        this._setRecalc(1 + 2 + 4);
                        if (this._parent) {
                            this._parent._setHasUpdates();
                        }
                        if (this._zIndex === 0) {
                            this.setZParent(parent);
                        } else {
                            this.setZParent(parent ? parent.findZContext() : null);
                        }
                        if (prevIsZContext !== this.isZContext()) {
                            if (!this.isZContext()) {
                                this.disableZContext();
                            } else {
                                this.enableZContext(prevParent.findZContext());
                            }
                        }
                        this._zIndexResort = true;
                        if (this._zParent) {
                            this._zParent.enableZSort();
                        }
                        if (!this._shader) {
                            var newShaderOwner = parent && !parent._renderToTextureEnabled ? parent._shaderOwner : null;
                            if (newShaderOwner !== this._shaderOwner) {
                                this.setHasRenderUpdates(1);
                                this._setShaderOwnerRecursive(newShaderOwner);
                            }
                        }
                    }
                }
            },
            {
                key: "enableZSort",
                value: function enableZSort() {
                    var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    if (!this._zSort && this._zContextUsage > 0) {
                        this._zSort = true;
                        if (force) {
                            this.ctx.forceZSort(this);
                        }
                    }
                }
            },
            {
                key: "addChildAt",
                value: function addChildAt(index, child) {
                    if (!this._children) this._children = [];
                    this._children.splice(index, 0, child);
                    child.setParent(this);
                }
            },
            {
                key: "setChildAt",
                value: function setChildAt(index, child) {
                    if (!this._children) this._children = [];
                    this._children[index].setParent(null);
                    this._children[index] = child;
                    child.setParent(this);
                }
            },
            {
                key: "removeChildAt",
                value: function removeChildAt(index) {
                    var child = this._children[index];
                    this._children.splice(index, 1);
                    child.setParent(null);
                }
            },
            {
                key: "removeChildren",
                value: function removeChildren() {
                    if (this._children) {
                        for(var i = 0, n = this._children.length; i < n; i++){
                            this._children[i].setParent(null);
                        }
                        this._children.splice(0);
                        if (this._zIndexedChildren) {
                            this._zIndexedChildren.splice(0);
                        }
                    }
                }
            },
            {
                key: "syncChildren",
                value: function syncChildren(removed, added, order) {
                    this._children = order;
                    for(var i = 0, n = removed.length; i < n; i++){
                        removed[i].setParent(null);
                    }
                    for(var i1 = 0, n1 = added.length; i1 < n1; i1++){
                        added[i1].setParent(this);
                    }
                }
            },
            {
                key: "moveChild",
                value: function moveChild(fromIndex, toIndex) {
                    var c = this._children[fromIndex];
                    this._children.splice(fromIndex, 1);
                    this._children.splice(toIndex, 0, c);
                    this._zIndexResort = true;
                    if (this._zParent) {
                        this._zParent.enableZSort();
                    }
                }
            },
            {
                key: "_setLocalTransform",
                value: function _setLocalTransform(a, b, c, d) {
                    this._setRecalc(4);
                    this._localTa = a;
                    this._localTb = b;
                    this._localTc = c;
                    this._localTd = d;
                    this._isComplex = b !== 0 || c !== 0 || a < 0 || d < 0;
                }
            },
            {
                key: "_addLocalTranslate",
                value: function _addLocalTranslate(dx, dy) {
                    this._localPx += dx;
                    this._localPy += dy;
                    this._triggerRecalcTranslate();
                }
            },
            {
                key: "_setLocalAlpha",
                value: function _setLocalAlpha(a) {
                    if (!this._worldContext.alpha && this._parent && this._parent._worldContext.alpha && a) {
                        this._setRecalc(1 + 128);
                    } else {
                        this._setRecalc(1);
                    }
                    if (a < 1e-14) {
                        a = 0;
                    }
                    this._localAlpha = a;
                }
            },
            {
                key: "setDimensions",
                value: function setDimensions(w, h) {
                    var isEstimate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this._dimsUnknown;
                    this._dimsUnknown = isEstimate;
                    if (this.hasFlexLayout()) {
                        this._layout.originalWidth = w;
                        this._layout.originalHeight = h;
                    } else {
                        if (this._w !== w || this._h !== h) {
                            this._updateDimensions(w, h);
                            return true;
                        }
                    }
                    return false;
                }
            },
            {
                key: "_updateDimensions",
                value: function _updateDimensions(w, h) {
                    if (this._w !== w || this._h !== h) {
                        this._w = w;
                        this._h = h;
                        this._triggerRecalcTranslate();
                        if (this._texturizer) {
                            this._texturizer.releaseRenderTexture();
                            this._texturizer.updateResultTexture();
                        }
                        this._updateLocalTranslate();
                    }
                }
            },
            {
                key: "setTextureCoords",
                value: function setTextureCoords(ulx, uly, brx, bry) {
                    this.setHasRenderUpdates(3);
                    this._ulx = ulx;
                    this._uly = uly;
                    this._brx = brx;
                    this._bry = bry;
                }
            },
            {
                key: "displayedTextureSource",
                get: function get() {
                    return this._displayedTextureSource;
                }
            },
            {
                key: "setDisplayedTextureSource",
                value: function setDisplayedTextureSource(textureSource) {
                    this.setHasRenderUpdates(3);
                    this._displayedTextureSource = textureSource;
                }
            },
            {
                key: "isRoot",
                get: function get() {
                    return this._isRoot;
                }
            },
            {
                key: "setAsRoot",
                value: function setAsRoot() {
                    this._parent = new ElementCore(this._element);
                    this._parent._hasRenderUpdates = 3;
                    this._parent._hasUpdates = true;
                    this._isRoot = true;
                    this.ctx.root = this;
                    this._parent._viewport = [
                        0,
                        0,
                        this.ctx.stage.coordsWidth,
                        this.ctx.stage.coordsHeight
                    ];
                    this._parent._scissor = this._parent._viewport;
                    this._parent._recBoundsMargin = null;
                    this._setRecalc(1 + 2 + 4);
                }
            },
            {
                key: "isAncestorOf",
                value: function isAncestorOf(c) {
                    var p = c;
                    while(p = p._parent){
                        if (this === p) {
                            return true;
                        }
                    }
                    return false;
                }
            },
            {
                key: "isZContext",
                value: function isZContext() {
                    return this._forceZIndexContext || this._renderToTextureEnabled || this._zIndex !== 0 || this._isRoot || !this._parent;
                }
            },
            {
                key: "findZContext",
                value: function findZContext() {
                    if (this.isZContext()) {
                        return this;
                    } else {
                        return this._parent.findZContext();
                    }
                }
            },
            {
                key: "setZParent",
                value: function setZParent(newZParent) {
                    if (this._zParent !== newZParent) {
                        if (this._zParent !== null) {
                            if (this._zIndex !== 0) {
                                this._zParent.decZContextUsage();
                            }
                            this._zParent.enableZSort();
                        }
                        if (newZParent !== null) {
                            var hadZContextUsage = newZParent._zContextUsage > 0;
                            if (this._zIndex !== 0) {
                                newZParent.incZContextUsage();
                            }
                            if (newZParent._zContextUsage > 0) {
                                if (!hadZContextUsage && this._parent === newZParent) ;
                                else {
                                    newZParent._zIndexedChildren.push(this);
                                }
                                newZParent.enableZSort();
                            }
                        }
                        this._zParent = newZParent;
                        this._zIndexResort = true;
                    }
                }
            },
            {
                key: "incZContextUsage",
                value: function incZContextUsage() {
                    this._zContextUsage++;
                    if (this._zContextUsage === 1) {
                        if (!this._zIndexedChildren) {
                            this._zIndexedChildren = [];
                        }
                        if (this._children) {
                            for(var i = 0, n = this._children.length; i < n; i++){
                                this._zIndexedChildren.push(this._children[i]);
                            }
                            this._zSort = false;
                        }
                    }
                }
            },
            {
                key: "decZContextUsage",
                value: function decZContextUsage() {
                    this._zContextUsage--;
                    if (this._zContextUsage === 0) {
                        this._zSort = false;
                        this._zIndexedChildren.splice(0);
                    }
                }
            },
            {
                key: "zIndex",
                get: function get() {
                    return this._zIndex;
                },
                set: function set(zIndex) {
                    if (this._zIndex !== zIndex) {
                        this.setHasRenderUpdates(1);
                        var newZParent = this._zParent;
                        var prevIsZContext = this.isZContext();
                        if (zIndex === 0 && this._zIndex !== 0) {
                            if (this._parent === this._zParent) {
                                if (this._zParent) {
                                    this._zParent.decZContextUsage();
                                }
                            } else {
                                newZParent = this._parent;
                            }
                        } else if (zIndex !== 0 && this._zIndex === 0) {
                            newZParent = this._parent ? this._parent.findZContext() : null;
                            if (newZParent === this._zParent) {
                                if (this._zParent) {
                                    this._zParent.incZContextUsage();
                                    this._zParent.enableZSort();
                                }
                            }
                        } else if (zIndex !== this._zIndex) {
                            if (this._zParent && this._zParent._zContextUsage) {
                                this._zParent.enableZSort();
                            }
                        }
                        if (newZParent !== this._zParent) {
                            this.setZParent(null);
                        }
                        this._zIndex = zIndex;
                        if (newZParent !== this._zParent) {
                            this.setZParent(newZParent);
                        }
                        if (prevIsZContext !== this.isZContext()) {
                            if (!this.isZContext()) {
                                this.disableZContext();
                            } else {
                                this.enableZContext(this._parent.findZContext());
                            }
                        }
                        this._zIndexResort = true;
                        if (this._zParent) {
                            this._zParent.enableZSort();
                        }
                    }
                }
            },
            {
                key: "forceZIndexContext",
                get: function get() {
                    return this._forceZIndexContext;
                },
                set: function set(v) {
                    this.setHasRenderUpdates(1);
                    var prevIsZContext = this.isZContext();
                    this._forceZIndexContext = v;
                    if (prevIsZContext !== this.isZContext()) {
                        if (!this.isZContext()) {
                            this.disableZContext();
                        } else {
                            this.enableZContext(this._parent.findZContext());
                        }
                    }
                }
            },
            {
                key: "enableZContext",
                value: function enableZContext(prevZContext) {
                    var _this = this;
                    if (prevZContext && prevZContext._zContextUsage > 0) {
                        var results = this._getZIndexedDescs();
                        results.forEach(function(c) {
                            if (_this.isAncestorOf(c) && c._zIndex !== 0) {
                                c.setZParent(_this);
                            }
                        });
                    }
                }
            },
            {
                key: "_getZIndexedDescs",
                value: function _getZIndexedDescs() {
                    var results = [];
                    if (this._children) {
                        for(var i = 0, n = this._children.length; i < n; i++){
                            this._children[i]._getZIndexedDescsRec(results);
                        }
                    }
                    return results;
                }
            },
            {
                key: "_getZIndexedDescsRec",
                value: function _getZIndexedDescsRec(results) {
                    if (this._zIndex) {
                        results.push(this);
                    } else if (this._children && !this.isZContext()) {
                        for(var i = 0, n = this._children.length; i < n; i++){
                            this._children[i]._getZIndexedDescsRec(results);
                        }
                    }
                }
            },
            {
                key: "disableZContext",
                value: function disableZContext() {
                    if (this._zContextUsage > 0) {
                        var newZParent = this._parent.findZContext();
                        if (this._zSort) {
                            this.sortZIndexedChildren();
                        }
                        this._zIndexedChildren.slice().forEach(function(c) {
                            if (c._zIndex !== 0) {
                                c.setZParent(newZParent);
                            }
                        });
                    }
                }
            },
            {
                key: "colorUl",
                get: function get() {
                    return this._colorUl;
                },
                set: function set(color) {
                    if (this._colorUl !== color) {
                        this.setHasRenderUpdates(this._displayedTextureSource ? 3 : 1);
                        this._colorUl = color;
                    }
                }
            },
            {
                key: "colorUr",
                get: function get() {
                    return this._colorUr;
                },
                set: function set(color) {
                    if (this._colorUr !== color) {
                        this.setHasRenderUpdates(this._displayedTextureSource ? 3 : 1);
                        this._colorUr = color;
                    }
                }
            },
            {
                key: "colorBl",
                get: function get() {
                    return this._colorBl;
                },
                set: function set(color) {
                    if (this._colorBl !== color) {
                        this.setHasRenderUpdates(this._displayedTextureSource ? 3 : 1);
                        this._colorBl = color;
                    }
                }
            },
            {
                key: "colorBr",
                get: function get() {
                    return this._colorBr;
                },
                set: function set(color) {
                    if (this._colorBr !== color) {
                        this.setHasRenderUpdates(this._displayedTextureSource ? 3 : 1);
                        this._colorBr = color;
                    }
                }
            },
            {
                key: "onUpdate",
                set: function set(f) {
                    this._onUpdate = f;
                    this._setRecalc(7);
                }
            },
            {
                key: "onAfterUpdate",
                set: function set(f) {
                    this._onAfterUpdate = f;
                    this._setRecalc(7);
                }
            },
            {
                key: "onAfterCalcs",
                set: function set(f) {
                    this._onAfterCalcs = f;
                    this._setRecalc(7);
                }
            },
            {
                key: "shader",
                get: function get() {
                    return this._shader;
                },
                set: function set(v) {
                    this.setHasRenderUpdates(1);
                    var prevShader = this._shader;
                    this._shader = v;
                    if (!v && prevShader) {
                        var newShaderOwner = this._parent && !this._parent._renderToTextureEnabled ? this._parent._shaderOwner : null;
                        this._setShaderOwnerRecursive(newShaderOwner);
                    } else if (v) {
                        this._setShaderOwnerRecursive(this);
                    }
                }
            },
            {
                key: "activeShader",
                get: function get() {
                    return this._shaderOwner ? this._shaderOwner.shader : this.renderState.defaultShader;
                }
            },
            {
                key: "activeShaderOwner",
                get: function get() {
                    return this._shaderOwner;
                }
            },
            {
                key: "clipping",
                get: function get() {
                    return this._clipping;
                },
                set: function set(v) {
                    if (this._clipping !== v) {
                        this._clipping = v;
                        this._setRecalc(1 + 2);
                    }
                }
            },
            {
                key: "clipbox",
                get: function get() {
                    return this._clipbox;
                },
                set: function set(v) {
                    this._clipbox = v;
                }
            },
            {
                key: "_setShaderOwnerRecursive",
                value: function _setShaderOwnerRecursive(elementCore) {
                    this._shaderOwner = elementCore;
                    if (this._children && !this._renderToTextureEnabled) {
                        for(var i = 0, n = this._children.length; i < n; i++){
                            var c = this._children[i];
                            if (!c._shader) {
                                c._setShaderOwnerRecursive(elementCore);
                                c._hasRenderUpdates = 3;
                            }
                        }
                    }
                }
            },
            {
                key: "_setShaderOwnerChildrenRecursive",
                value: function _setShaderOwnerChildrenRecursive(elementCore) {
                    if (this._children) {
                        for(var i = 0, n = this._children.length; i < n; i++){
                            var c = this._children[i];
                            if (!c._shader) {
                                c._setShaderOwnerRecursive(elementCore);
                                c._hasRenderUpdates = 3;
                            }
                        }
                    }
                }
            },
            {
                key: "_hasRenderContext",
                value: function _hasRenderContext() {
                    return this._renderContext !== this._worldContext;
                }
            },
            {
                key: "renderContext",
                get: function get() {
                    return this._renderContext;
                }
            },
            {
                key: "updateRenderToTextureEnabled",
                value: function updateRenderToTextureEnabled() {
                    var v = this.texturizer._enabled;
                    if (v) {
                        this._enableRenderToTexture();
                    } else {
                        this._disableRenderToTexture();
                        this._texturizer.releaseRenderTexture();
                    }
                }
            },
            {
                key: "_enableRenderToTexture",
                value: function _enableRenderToTexture() {
                    if (!this._renderToTextureEnabled) {
                        var prevIsZContext = this.isZContext();
                        this._renderToTextureEnabled = true;
                        this._renderContext = new ElementCoreContext();
                        this._setShaderOwnerChildrenRecursive(null);
                        if (!prevIsZContext) {
                            this.enableZContext(this._parent ? this._parent.findZContext() : null);
                        }
                        this.setHasRenderUpdates(3);
                        this._setRecalc(7);
                        this.render = this._renderAdvanced;
                    }
                }
            },
            {
                key: "_disableRenderToTexture",
                value: function _disableRenderToTexture() {
                    if (this._renderToTextureEnabled) {
                        this._renderToTextureEnabled = false;
                        this._setShaderOwnerChildrenRecursive(this._shaderOwner);
                        this._renderContext = this._worldContext;
                        if (!this.isZContext()) {
                            this.disableZContext();
                        }
                        this._setRecalc(7);
                        this.setHasRenderUpdates(3);
                        this.render = this._renderSimple;
                    }
                }
            },
            {
                key: "isWhite",
                value: function isWhite() {
                    return this._colorUl === 0xFFFFFFFF && this._colorUr === 0xFFFFFFFF && this._colorBl === 0xFFFFFFFF && this._colorBr === 0xFFFFFFFF;
                }
            },
            {
                key: "hasSimpleTexCoords",
                value: function hasSimpleTexCoords() {
                    return this._ulx === 0 && this._uly === 0 && this._brx === 1 && this._bry === 1;
                }
            },
            {
                key: "_stashTexCoords",
                value: function _stashTexCoords() {
                    this._stashedTexCoords = [
                        this._ulx,
                        this._uly,
                        this._brx,
                        this._bry
                    ];
                    this._ulx = 0;
                    this._uly = 0;
                    this._brx = 1;
                    this._bry = 1;
                }
            },
            {
                key: "_unstashTexCoords",
                value: function _unstashTexCoords() {
                    this._ulx = this._stashedTexCoords[0];
                    this._uly = this._stashedTexCoords[1];
                    this._brx = this._stashedTexCoords[2];
                    this._bry = this._stashedTexCoords[3];
                    this._stashedTexCoords = null;
                }
            },
            {
                key: "_stashColors",
                value: function _stashColors() {
                    this._stashedColors = [
                        this._colorUl,
                        this._colorUr,
                        this._colorBr,
                        this._colorBl
                    ];
                    this._colorUl = 0xFFFFFFFF;
                    this._colorUr = 0xFFFFFFFF;
                    this._colorBr = 0xFFFFFFFF;
                    this._colorBl = 0xFFFFFFFF;
                }
            },
            {
                key: "_unstashColors",
                value: function _unstashColors() {
                    this._colorUl = this._stashedColors[0];
                    this._colorUr = this._stashedColors[1];
                    this._colorBr = this._stashedColors[2];
                    this._colorBl = this._stashedColors[3];
                    this._stashedColors = null;
                }
            },
            {
                key: "isVisible",
                value: function isVisible() {
                    return this._localAlpha > 1e-14;
                }
            },
            {
                key: "outOfBounds",
                get: function get() {
                    return this._outOfBounds;
                }
            },
            {
                key: "boundsMargin",
                get: function get() {
                    return this._boundsMargin;
                },
                set: function set(v) {
                    this._boundsMargin = v ? v.slice() : null;
                    this._triggerRecalcTranslate();
                }
            },
            {
                key: "update",
                value: function update() {
                    this._recalc |= this._parent._pRecalc;
                    if (this._layout && this._layout.isEnabled()) {
                        if (this._recalc & 256) {
                            this._layout.layoutFlexTree();
                        }
                    } else if (this._recalc & 2 && this._optFlags) {
                        this._applyRelativeDimFuncs();
                    }
                    if (this._onUpdate) {
                        this._hasUpdates = true;
                        this._onUpdate(this.element, this);
                    }
                    var pw = this._parent._worldContext;
                    var w = this._worldContext;
                    var visible = pw.alpha && this._localAlpha;
                    if (this._hasUpdates || this._recalc && visible || w.alpha && !visible) {
                        var recalc = this._recalc;
                        if (recalc & 1) {
                            if (!w.alpha && visible) {
                                this._hasRenderUpdates = 3;
                            }
                            w.alpha = pw.alpha * this._localAlpha;
                            if (w.alpha < 1e-14) {
                                w.alpha = 0;
                            }
                        }
                        if (recalc & 6) {
                            w.px = pw.px + this._localPx * pw.ta;
                            w.py = pw.py + this._localPy * pw.td;
                            if (pw.tb !== 0) w.px += this._localPy * pw.tb;
                            if (pw.tc !== 0) w.py += this._localPx * pw.tc;
                        }
                        if (recalc & 4) {
                            w.ta = this._localTa * pw.ta;
                            w.tb = this._localTd * pw.tb;
                            w.tc = this._localTa * pw.tc;
                            w.td = this._localTd * pw.td;
                            if (this._isComplex) {
                                w.ta += this._localTc * pw.tb;
                                w.tb += this._localTb * pw.ta;
                                w.tc += this._localTc * pw.td;
                                w.td += this._localTb * pw.tc;
                            }
                        }
                        var pr = this._parent._renderContext;
                        if (this._parent._hasRenderContext()) {
                            var init = this._renderContext === this._worldContext;
                            if (init) {
                                this._renderContext = new ElementCoreContext();
                            }
                            var r = this._renderContext;
                            if (init || recalc & 1) {
                                r.alpha = pr.alpha * this._localAlpha;
                                if (r.alpha < 1e-14) {
                                    r.alpha = 0;
                                }
                            }
                            if (init || recalc & 6) {
                                r.px = pr.px + this._localPx * pr.ta;
                                r.py = pr.py + this._localPy * pr.td;
                                if (pr.tb !== 0) r.px += this._localPy * pr.tb;
                                if (pr.tc !== 0) r.py += this._localPx * pr.tc;
                            }
                            if (init) {
                                recalc |= 2;
                            }
                            if (init || recalc & 4) {
                                r.ta = this._localTa * pr.ta;
                                r.tb = this._localTd * pr.tb;
                                r.tc = this._localTa * pr.tc;
                                r.td = this._localTd * pr.td;
                                if (this._isComplex) {
                                    r.ta += this._localTc * pr.tb;
                                    r.tb += this._localTb * pr.ta;
                                    r.tc += this._localTc * pr.td;
                                    r.td += this._localTb * pr.tc;
                                }
                            }
                        } else {
                            this._renderContext = this._worldContext;
                        }
                        if (this.ctx.updateTreeOrder === -1) {
                            this.ctx.updateTreeOrder = this._updateTreeOrder + 1;
                        } else {
                            this._updateTreeOrder = this.ctx.updateTreeOrder++;
                        }
                        var useRenderToTexture = this._renderToTextureEnabled && this._texturizer.mustRenderToTexture();
                        if (this._useRenderToTexture !== useRenderToTexture) {
                            this._recalc |= 2 + 4;
                            recalc |= 2;
                            if (!this._useRenderToTexture) {
                                this._texturizer.release();
                            }
                        }
                        this._useRenderToTexture = useRenderToTexture;
                        var r1 = this._renderContext;
                        var bboxW = this._dimsUnknown ? 2048 : this._w;
                        var bboxH = this._dimsUnknown ? 2048 : this._h;
                        var sx, sy, ex, ey;
                        var rComplex = r1.tb !== 0 || r1.tc !== 0 || r1.ta < 0 || r1.td < 0;
                        if (rComplex) {
                            sx = Math.min(0, bboxW * r1.ta, bboxW * r1.ta + bboxH * r1.tb, bboxH * r1.tb) + r1.px;
                            ex = Math.max(0, bboxW * r1.ta, bboxW * r1.ta + bboxH * r1.tb, bboxH * r1.tb) + r1.px;
                            sy = Math.min(0, bboxW * r1.tc, bboxW * r1.tc + bboxH * r1.td, bboxH * r1.td) + r1.py;
                            ey = Math.max(0, bboxW * r1.tc, bboxW * r1.tc + bboxH * r1.td, bboxH * r1.td) + r1.py;
                        } else {
                            sx = r1.px;
                            ex = r1.px + r1.ta * bboxW;
                            sy = r1.py;
                            ey = r1.py + r1.td * bboxH;
                        }
                        if (this._dimsUnknown && (rComplex || this._localTa < 1 || this._localTb < 1)) {
                            var nx = this._x * pr.ta + this._y * pr.tb + pr.px;
                            var ny = this._x * pr.tc + this._y * pr.td + pr.py;
                            if (nx < sx) sx = nx;
                            if (ny < sy) sy = ny;
                            if (nx > ex) ex = nx;
                            if (ny > ey) ey = ny;
                        }
                        if (recalc & 6 || !this._scissor) {
                            if (this._clipping && r1.isSquare()) {
                                var area = this._parent._useRenderToTexture ? this._parent._viewport : this._parent._scissor;
                                if (area) {
                                    var lx = Math.max(area[0], sx);
                                    var ly = Math.max(area[1], sy);
                                    this._scissor = [
                                        lx,
                                        ly,
                                        Math.min(area[2] + area[0], ex) - lx,
                                        Math.min(area[3] + area[1], ey) - ly
                                    ];
                                } else {
                                    this._scissor = [
                                        sx,
                                        sy,
                                        ex - sx,
                                        ey - sy
                                    ];
                                }
                            } else {
                                this._scissor = this._parent._useRenderToTexture ? this._parent._viewport : this._parent._scissor;
                            }
                        }
                        if (this._boundsMargin) {
                            this._recBoundsMargin = this._boundsMargin;
                        } else {
                            this._recBoundsMargin = this._parent._recBoundsMargin;
                        }
                        if (this._onAfterCalcs) {
                            if (this._onAfterCalcs(this.element)) {
                                if (rComplex) {
                                    sx = Math.min(0, bboxW * r1.ta, bboxW * r1.ta + bboxH * r1.tb, bboxH * r1.tb) + r1.px;
                                    ex = Math.max(0, bboxW * r1.ta, bboxW * r1.ta + bboxH * r1.tb, bboxH * r1.tb) + r1.px;
                                    sy = Math.min(0, bboxW * r1.tc, bboxW * r1.tc + bboxH * r1.td, bboxH * r1.td) + r1.py;
                                    ey = Math.max(0, bboxW * r1.tc, bboxW * r1.tc + bboxH * r1.td, bboxH * r1.td) + r1.py;
                                } else {
                                    sx = r1.px;
                                    ex = r1.px + r1.ta * bboxW;
                                    sy = r1.py;
                                    ey = r1.py + r1.td * bboxH;
                                }
                                if (this._dimsUnknown && (rComplex || this._localTa < 1 || this._localTb < 1)) {
                                    var nx1 = this._x * pr.ta + this._y * pr.tb + pr.px;
                                    var ny1 = this._x * pr.tc + this._y * pr.td + pr.py;
                                    if (nx1 < sx) sx = nx1;
                                    if (ny1 < sy) sy = ny1;
                                    if (nx1 > ex) ex = nx1;
                                    if (ny1 > ey) ey = ny1;
                                }
                            }
                        }
                        if (this._parent._outOfBounds === 2) {
                            this._outOfBounds = 2;
                            if (this._withinBoundsMargin) {
                                this._withinBoundsMargin = false;
                                this.element._disableWithinBoundsMargin();
                            }
                        } else {
                            if (recalc & 6) {
                                this._outOfBounds = 0;
                                var withinMargin = true;
                                if (!this._renderToTextureEnabled || !this._texturizer || !this._texturizer.renderOffscreen) {
                                    if (this._scissor && (this._scissor[2] <= 0 || this._scissor[3] <= 0)) {
                                        this._outOfBounds = 2;
                                    } else {
                                        if (this._scissor[0] > ex || this._scissor[1] > ey || sx > this._scissor[0] + this._scissor[2] || sy > this._scissor[1] + this._scissor[3]) {
                                            this._outOfBounds = 1;
                                        }
                                        if (this._outOfBounds) {
                                            if (this._clipping || this._useRenderToTexture || this._clipbox && bboxW && bboxH) {
                                                this._outOfBounds = 2;
                                            }
                                        }
                                    }
                                    withinMargin = this._outOfBounds === 0;
                                    if (!withinMargin) {
                                        if (this._recBoundsMargin) {
                                            withinMargin = !(ex < this._scissor[0] - this._recBoundsMargin[2] || ey < this._scissor[1] - this._recBoundsMargin[3] || sx > this._scissor[0] + this._scissor[2] + this._recBoundsMargin[0] || sy > this._scissor[1] + this._scissor[3] + this._recBoundsMargin[1]);
                                        } else {
                                            withinMargin = !(ex < this._scissor[0] - 100 || ey < this._scissor[1] - 100 || sx > this._scissor[0] + this._scissor[2] + 100 || sy > this._scissor[1] + this._scissor[3] + 100);
                                        }
                                        if (withinMargin && this._outOfBounds === 2) {
                                            this._outOfBounds = 1;
                                        }
                                    }
                                }
                                if (this._withinBoundsMargin !== withinMargin) {
                                    this._withinBoundsMargin = withinMargin;
                                    if (this._withinBoundsMargin) {
                                        this._hasUpdates = true;
                                        var recalc1 = this._recalc;
                                        this._recalc = 0;
                                        this.element._enableWithinBoundsMargin();
                                        if (this._recalc) {
                                            return this.update();
                                        }
                                        this._recalc = recalc1;
                                    } else {
                                        this.element._disableWithinBoundsMargin();
                                    }
                                }
                            }
                        }
                        if (this._useRenderToTexture) {
                            if (this._viewport) {
                                this._viewport[2] = bboxW;
                                this._viewport[3] = bboxH;
                            } else {
                                this._viewport = [
                                    0,
                                    0,
                                    bboxW,
                                    bboxH
                                ];
                            }
                        }
                        this._pRecalc = this._recalc & 135;
                        this._recalc = 0;
                        this._hasUpdates = false;
                        if (this._outOfBounds < 2) {
                            if (this._useRenderToTexture) {
                                if (this._worldContext.isIdentity()) {
                                    this._renderContext = this._worldContext;
                                } else {
                                    this._renderContext = ElementCoreContext.IDENTITY;
                                }
                            }
                            if (this._children) {
                                for(var i = 0, n = this._children.length; i < n; i++){
                                    this._children[i].update();
                                }
                            }
                            if (this._useRenderToTexture) {
                                this._renderContext = r1;
                            }
                        } else {
                            if (this._children) {
                                for(var i1 = 0, n1 = this._children.length; i1 < n1; i1++){
                                    if (this._children[i1]._hasUpdates) {
                                        this._children[i1].update();
                                    } else {
                                        this._children[i1]._recalc |= this._pRecalc;
                                        this._children[i1].updateOutOfBounds();
                                    }
                                }
                            }
                        }
                        if (this._onAfterUpdate) {
                            this._onAfterUpdate(this.element);
                        }
                    } else {
                        if (this.ctx.updateTreeOrder === -1 || this._updateTreeOrder >= this.ctx.updateTreeOrder) {
                            this.ctx.updateTreeOrder = -1;
                        } else {
                            this.updateTreeOrder();
                        }
                    }
                }
            },
            {
                key: "_applyRelativeDimFuncs",
                value: function _applyRelativeDimFuncs() {
                    if (this._optFlags & 1) {
                        var x = this._funcX(this._parent.w);
                        if (x !== this._x) {
                            this._localPx += x - this._x;
                            this._x = x;
                        }
                    }
                    if (this._optFlags & 2) {
                        var y = this._funcY(this._parent.h);
                        if (y !== this._y) {
                            this._localPy += y - this._y;
                            this._y = y;
                        }
                    }
                    var changedDims = false;
                    if (this._optFlags & 4) {
                        var w = this._funcW(this._parent.w);
                        if (w !== this._w) {
                            this._w = w;
                            changedDims = true;
                        }
                    }
                    if (this._optFlags & 8) {
                        var h = this._funcH(this._parent.h);
                        if (h !== this._h) {
                            this._h = h;
                            changedDims = true;
                        }
                    }
                    if (changedDims) {
                        this._recalcLocalTranslate();
                        this.element.onDimensionsChanged(this._w, this._h);
                    }
                }
            },
            {
                key: "updateOutOfBounds",
                value: function updateOutOfBounds() {
                    if (this._outOfBounds !== 2 && this._renderContext.alpha > 0) {
                        this._outOfBounds = 2;
                        if (this._withinBoundsMargin) {
                            this._withinBoundsMargin = false;
                            this.element._disableWithinBoundsMargin();
                        }
                        if (this._children) {
                            for(var i = 0, n = this._children.length; i < n; i++){
                                this._children[i].updateOutOfBounds();
                            }
                        }
                    }
                }
            },
            {
                key: "updateTreeOrder",
                value: function updateTreeOrder() {
                    if (this._localAlpha && this._outOfBounds !== 2) {
                        this._updateTreeOrder = this.ctx.updateTreeOrder++;
                        if (this._children) {
                            for(var i = 0, n = this._children.length; i < n; i++){
                                this._children[i].updateTreeOrder();
                            }
                        }
                    }
                }
            },
            {
                key: "_renderSimple",
                value: function _renderSimple() {
                    this._hasRenderUpdates = 0;
                    if (this._zSort) {
                        this.sortZIndexedChildren();
                    }
                    if (this._outOfBounds < 2 && this._renderContext.alpha) {
                        var renderState = this.renderState;
                        if (this._outOfBounds === 0 && this._displayedTextureSource) {
                            renderState.setShader(this.activeShader, this._shaderOwner);
                            renderState.setScissor(this._scissor);
                            this.renderState.addQuad(this);
                        }
                        if (this._children) {
                            if (this._zContextUsage) {
                                for(var i = 0, n = this._zIndexedChildren.length; i < n; i++){
                                    this._zIndexedChildren[i].render();
                                }
                            } else {
                                for(var i1 = 0, n1 = this._children.length; i1 < n1; i1++){
                                    if (this._children[i1]._zIndex === 0) {
                                        this._children[i1].render();
                                    }
                                }
                            }
                        }
                    }
                }
            },
            {
                key: "_renderAdvanced",
                value: function _renderAdvanced() {
                    var hasRenderUpdates = this._hasRenderUpdates;
                    this._hasRenderUpdates = 0;
                    if (this._zSort) {
                        this.sortZIndexedChildren();
                    }
                    if (this._outOfBounds < 2 && this._renderContext.alpha) {
                        var renderState = this.renderState;
                        var mustRenderChildren = true;
                        var renderTextureInfo;
                        var prevRenderTextureInfo;
                        if (this._useRenderToTexture) {
                            if (this._w === 0 || this._h === 0) {
                                return;
                            } else if (!this._texturizer.hasRenderTexture() || hasRenderUpdates >= 3) {
                                this.ctx.renderToTextureCount++;
                                renderState.setShader(renderState.defaultShader, this);
                                prevRenderTextureInfo = renderState.renderTextureInfo;
                                renderTextureInfo = {
                                    nativeTexture: null,
                                    offset: 0,
                                    w: this._w,
                                    h: this._h,
                                    empty: true,
                                    cleared: false,
                                    ignore: false,
                                    cache: false
                                };
                                if (this._texturizer.hasResultTexture() || !renderState.isCachingTexturizer && hasRenderUpdates < 3) {
                                    renderTextureInfo.cache = true;
                                    renderState.isCachingTexturizer = true;
                                }
                                if (!this._texturizer.hasResultTexture()) {
                                    this._texturizer.releaseRenderTexture();
                                }
                                renderState.setRenderTextureInfo(renderTextureInfo);
                                renderState.setScissor(null);
                                if (this._displayedTextureSource) {
                                    var r = this._renderContext;
                                    this._renderContext = ElementCoreContext.IDENTITY;
                                    this.renderState.addQuad(this);
                                    this._renderContext = r;
                                }
                            } else {
                                mustRenderChildren = false;
                            }
                        } else {
                            if (this._outOfBounds === 0 && this._displayedTextureSource) {
                                renderState.setShader(this.activeShader, this._shaderOwner);
                                renderState.setScissor(this._scissor);
                                this.renderState.addQuad(this);
                            }
                        }
                        if (mustRenderChildren && this._children) {
                            if (this._zContextUsage) {
                                for(var i = 0, n = this._zIndexedChildren.length; i < n; i++){
                                    this._zIndexedChildren[i].render();
                                }
                            } else {
                                for(var i1 = 0, n1 = this._children.length; i1 < n1; i1++){
                                    if (this._children[i1]._zIndex === 0) {
                                        this._children[i1].render();
                                    }
                                }
                            }
                        }
                        if (this._useRenderToTexture) {
                            var updateResultTexture = false;
                            if (mustRenderChildren) {
                                renderState.finishedRenderTexture();
                                this._texturizer.empty = renderTextureInfo.empty;
                                if (renderTextureInfo.empty) {
                                    this._texturizer.releaseRenderTexture();
                                } else if (renderTextureInfo.nativeTexture) {
                                    this._texturizer.reuseTextureAsRenderTexture(renderTextureInfo.nativeTexture);
                                    renderTextureInfo.ignore = true;
                                } else {
                                    if (this._texturizer.renderTextureReused) {
                                        this._texturizer.releaseRenderTexture();
                                    }
                                    renderTextureInfo.nativeTexture = this._texturizer.getRenderTexture();
                                }
                                renderState.setRenderTextureInfo(prevRenderTextureInfo);
                                updateResultTexture = true;
                            }
                            if (!this._texturizer.empty) {
                                var resultTexture = this._texturizer.getResultTexture();
                                if (updateResultTexture) {
                                    if (resultTexture) {
                                        resultTexture.update = renderState.stage.frameCounter;
                                    }
                                    this._texturizer.updateResultTexture();
                                }
                                if (!this._texturizer.renderOffscreen) {
                                    renderState.setShader(this.activeShader, this._shaderOwner);
                                    renderState.setScissor(this._scissor);
                                    var cache = !renderTextureInfo || renderTextureInfo.cache;
                                    renderState.setTexturizer(this._texturizer, cache);
                                    this._stashTexCoords();
                                    if (!this._texturizer.colorize) this._stashColors();
                                    this.renderState.addQuad(this, true);
                                    if (!this._texturizer.colorize) this._unstashColors();
                                    this._unstashTexCoords();
                                    renderState.setTexturizer(null);
                                }
                            }
                        }
                        if (renderTextureInfo && renderTextureInfo.cache) {
                            renderState.isCachingTexturizer = false;
                        }
                    }
                }
            },
            {
                key: "zSort",
                get: function get() {
                    return this._zSort;
                }
            },
            {
                key: "sortZIndexedChildren",
                value: function sortZIndexedChildren() {
                    var n = this._zIndexedChildren.length;
                    var ptr = 0;
                    var a = this._zIndexedChildren;
                    var b = [];
                    for(var i = 0; i < n; i++){
                        if (a[i]._zParent === this) {
                            if (a[i]._zIndexResort) {
                                b.push(a[i]);
                            } else {
                                if (ptr !== i) {
                                    a[ptr] = a[i];
                                }
                                ptr++;
                            }
                        }
                    }
                    var m = b.length;
                    if (m) {
                        for(var j = 0; j < m; j++){
                            b[j]._zIndexResort = false;
                        }
                        b.sort(ElementCore.sortZIndexedChildren);
                        var n1 = ptr;
                        if (!n1) {
                            ptr = 0;
                            var j1 = 0;
                            do {
                                a[ptr++] = b[j1++];
                            }while (j1 < m);
                            if (a.length > ptr) {
                                a.splice(ptr);
                            }
                        } else {
                            ptr = 0;
                            var i1 = 0;
                            var j2 = 0;
                            var mergeResult = [];
                            do {
                                var v = a[i1]._zIndex === b[j2]._zIndex ? a[i1]._updateTreeOrder - b[j2]._updateTreeOrder : a[i1]._zIndex - b[j2]._zIndex;
                                var add = v > 0 ? b[j2++] : a[i1++];
                                if (ptr === 0 || mergeResult[ptr - 1] !== add) {
                                    mergeResult[ptr++] = add;
                                }
                                if (i1 >= n1) {
                                    do {
                                        var add1 = b[j2++];
                                        if (ptr === 0 || mergeResult[ptr - 1] !== add1) {
                                            mergeResult[ptr++] = add1;
                                        }
                                    }while (j2 < m);
                                    break;
                                } else if (j2 >= m) {
                                    do {
                                        var add2 = a[i1++];
                                        if (ptr === 0 || mergeResult[ptr - 1] !== add2) {
                                            mergeResult[ptr++] = add2;
                                        }
                                    }while (i1 < n1);
                                    break;
                                }
                            }while (true);
                            this._zIndexedChildren = mergeResult;
                        }
                    } else {
                        if (a.length > ptr) {
                            a.splice(ptr);
                        }
                    }
                    this._zSort = false;
                }
            },
            {
                key: "localTa",
                get: function get() {
                    return this._localTa;
                }
            },
            {
                key: "localTb",
                get: function get() {
                    return this._localTb;
                }
            },
            {
                key: "localTc",
                get: function get() {
                    return this._localTc;
                }
            },
            {
                key: "localTd",
                get: function get() {
                    return this._localTd;
                }
            },
            {
                key: "element",
                get: function get() {
                    return this._element;
                }
            },
            {
                key: "renderUpdates",
                get: function get() {
                    return this._hasRenderUpdates;
                }
            },
            {
                key: "texturizer",
                get: function get() {
                    if (!this._texturizer) {
                        this._texturizer = new ElementTexturizer(this);
                    }
                    return this._texturizer;
                }
            },
            {
                key: "getCornerPoints",
                value: function getCornerPoints() {
                    var w = this._worldContext;
                    return [
                        w.px,
                        w.py,
                        w.px + this._w * w.ta,
                        w.py + this._w * w.tc,
                        w.px + this._w * w.ta + this._h * w.tb,
                        w.py + this._w * w.tc + this._h * w.td,
                        w.px + this._h * w.tb,
                        w.py + this._h * w.td
                    ];
                }
            },
            {
                key: "getRenderTextureCoords",
                value: function getRenderTextureCoords(relX, relY) {
                    var r = this._renderContext;
                    return [
                        r.px + r.ta * relX + r.tb * relY,
                        r.py + r.tc * relX + r.td * relY
                    ];
                }
            },
            {
                key: "getAbsoluteCoords",
                value: function getAbsoluteCoords(relX, relY) {
                    var w = this._renderContext;
                    return [
                        w.px + w.ta * relX + w.tb * relY,
                        w.py + w.tc * relX + w.td * relY
                    ];
                }
            },
            {
                key: "collectAtCoord",
                value: function collectAtCoord(x, y, children) {
                    if (this._renderContext.alpha === 0) {
                        return;
                    }
                    if (this.inBound(x, y)) {
                        if (this._scissor) {
                            if (this.inScissor()) {
                                children.push(this);
                            }
                        } else {
                            children.push(this);
                        }
                    }
                    if (this._children) {
                        var j = this._children.length;
                        for(var i = 0; i < j; i++){
                            this._children[i].collectAtCoord(x, y, children);
                        }
                    }
                    return children.sort(ElementCore.sortZIndexedChildren);
                }
            },
            {
                key: "inBound",
                value: function inBound(tx, ty) {
                    var c = this.getCornerPoints();
                    return tx > c[0] && tx < c[2] && ty > c[1] && ty < c[7];
                }
            },
            {
                key: "inScissor",
                value: function inScissor() {
                    var sc = this._scissor;
                    var c = this.getCornerPoints();
                    return c[2] >= sc[0] && c[0] <= sc[0] + sc[2] && c[7] >= sc[1] && c[1] <= sc[1] + sc[3];
                }
            },
            {
                key: "layout",
                get: function get() {
                    this._ensureLayout();
                    return this._layout;
                }
            },
            {
                key: "flex",
                get: function get() {
                    return this._layout ? this._layout.flex : null;
                },
                set: function set(v) {
                    this.layout.flex = v;
                }
            },
            {
                key: "flexItem",
                get: function get() {
                    return this._layout ? this._layout.flexItem : null;
                },
                set: function set(v) {
                    this.layout.flexItem = v;
                }
            },
            {
                key: "isFlexItem",
                value: function isFlexItem() {
                    return !!this._layout && this._layout.isFlexItemEnabled();
                }
            },
            {
                key: "isFlexContainer",
                value: function isFlexContainer() {
                    return !!this._layout && this._layout.isFlexEnabled();
                }
            },
            {
                key: "enableFlexLayout",
                value: function enableFlexLayout() {
                    this._ensureLayout();
                }
            },
            {
                key: "_ensureLayout",
                value: function _ensureLayout() {
                    if (!this._layout) {
                        this._layout = new FlexTarget(this);
                    }
                }
            },
            {
                key: "disableFlexLayout",
                value: function disableFlexLayout() {
                    this._triggerRecalcTranslate();
                }
            },
            {
                key: "hasFlexLayout",
                value: function hasFlexLayout() {
                    return this._layout && this._layout.isEnabled();
                }
            },
            {
                key: "setLayout",
                value: function setLayout(x, y, w, h) {
                    this.x = x;
                    this.y = y;
                    this._updateDimensions(w, h);
                }
            },
            {
                key: "triggerLayout",
                value: function triggerLayout() {
                    this._setRecalc(256);
                }
            },
            {
                key: "_triggerRecalcTranslate",
                value: function _triggerRecalcTranslate() {
                    this._setRecalc(2);
                }
            }
        ]);
        return ElementCore;
    }();
    var ElementCoreContext = /*#__PURE__*/ function() {
        function ElementCoreContext() {
            _class_call_check._(this, ElementCoreContext);
            this.alpha = 1;
            this.px = 0;
            this.py = 0;
            this.ta = 1;
            this.tb = 0;
            this.tc = 0;
            this.td = 1;
        }
        _create_class._(ElementCoreContext, [
            {
                key: "isIdentity",
                value: function isIdentity() {
                    return this.alpha === 1 && this.px === 0 && this.py === 0 && this.ta === 1 && this.tb === 0 && this.tc === 0 && this.td === 1;
                }
            },
            {
                key: "isSquare",
                value: function isSquare() {
                    return this.tb === 0 && this.tc === 0;
                }
            }
        ]);
        return ElementCoreContext;
    }();
    ElementCoreContext.IDENTITY = new ElementCoreContext();
    ElementCore.sortZIndexedChildren = function(a, b) {
        return a._zIndex === b._zIndex ? a._updateTreeOrder - b._updateTreeOrder : a._zIndex - b._zIndex;
    };
    var EventEmitter = /*#__PURE__*/ function() {
        function EventEmitter() {
            _class_call_check._(this, EventEmitter);
            this._hasEventListeners = false;
        }
        _create_class._(EventEmitter, [
            {
                key: "on",
                value: function on(name, listener) {
                    if (!this._hasEventListeners) {
                        this._eventFunction = {};
                        this._eventListeners = {};
                        this._hasEventListeners = true;
                    }
                    var current = this._eventFunction[name];
                    if (!current) {
                        this._eventFunction[name] = listener;
                    } else {
                        if (this._eventFunction[name] !== EventEmitter.combiner) {
                            this._eventListeners[name] = [
                                this._eventFunction[name],
                                listener
                            ];
                            this._eventFunction[name] = EventEmitter.combiner;
                        } else {
                            this._eventListeners[name].push(listener);
                        }
                    }
                }
            },
            {
                key: "once",
                value: function once(name, listener) {
                    var _this = this;
                    var wrapper = function(arg1, arg2, arg3) {
                        listener(arg1, arg2, arg3);
                        _this.off(name, wrapper);
                    };
                    wrapper.__originalFunc = listener;
                    this.on(name, wrapper);
                }
            },
            {
                key: "has",
                value: function has(name, listener) {
                    if (this._hasEventListeners) {
                        var current = this._eventFunction[name];
                        if (current) {
                            if (current === EventEmitter.combiner) {
                                var listeners = this._eventListeners[name];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var l = _step.value;
                                        if (l === listener || l.__originalFunc == listener) {
                                            return true;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            } else if (this._eventFunction[name] === listener || this._eventFunction[name].__originalFunc === listener) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
            },
            {
                key: "off",
                value: function off(name, listener) {
                    if (this._hasEventListeners) {
                        var current = this._eventFunction[name];
                        if (current) {
                            if (current === EventEmitter.combiner) {
                                var listeners = this._eventListeners[name];
                                var index = listeners.indexOf(listener);
                                if (index >= 0) {
                                    listeners.splice(index, 1);
                                }
                                index = listeners.map(function(l) {
                                    return l.__originalFunc;
                                }).indexOf(listener);
                                if (index >= 0) {
                                    listeners.splice(index, 1);
                                }
                                if (listeners.length === 1) {
                                    this._eventFunction[name] = listeners[0];
                                    this._eventListeners[name] = undefined;
                                }
                            } else if (this._eventFunction[name] === listener || this._eventFunction[name].__originalFunc === listener) {
                                this._eventFunction[name] = undefined;
                            }
                        }
                    }
                }
            },
            {
                key: "removeListener",
                value: function removeListener(name, listener) {
                    this.off(name, listener);
                }
            },
            {
                key: "emit",
                value: function emit(name, arg1, arg2, arg3) {
                    if (this._hasEventListeners) {
                        var func = this._eventFunction[name];
                        if (func) {
                            if (func === EventEmitter.combiner) {
                                func(this, name, arg1, arg2, arg3);
                            } else {
                                func(arg1, arg2, arg3);
                            }
                        }
                    }
                }
            },
            {
                key: "listenerCount",
                value: function listenerCount(name) {
                    if (this._hasEventListeners) {
                        var func = this._eventFunction[name];
                        if (func) {
                            if (func === EventEmitter.combiner) {
                                return this._eventListeners[name].length;
                            } else {
                                return 1;
                            }
                        }
                    }
                    return 0;
                }
            },
            {
                key: "removeAllListeners",
                value: function removeAllListeners(name) {
                    if (this._hasEventListeners) {
                        delete this._eventFunction[name];
                        delete this._eventListeners[name];
                    }
                }
            }
        ]);
        return EventEmitter;
    }();
    EventEmitter.combiner = function(object, name, arg1, arg2, arg3) {
        var listeners = object._eventListeners[name];
        if (listeners) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _to_consumable_array._(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var listener = _step.value;
                    listener(arg1, arg2, arg3);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
    EventEmitter.addAsMixin = function(cls) {
        cls.prototype.on = EventEmitter.prototype.on;
        cls.prototype.once = EventEmitter.prototype.once;
        cls.prototype.has = EventEmitter.prototype.has;
        cls.prototype.off = EventEmitter.prototype.off;
        cls.prototype.removeListener = EventEmitter.prototype.removeListener;
        cls.prototype.emit = EventEmitter.prototype.emit;
        cls.prototype.listenerCount = EventEmitter.prototype.listenerCount;
        cls.prototype.removeAllListeners = EventEmitter.prototype.removeAllListeners;
    };
    var Shader = /*#__PURE__*/ function() {
        function Shader(coreContext) {
            _class_call_check._(this, Shader);
            this._initialized = false;
            this.ctx = coreContext;
            this._elements = new Set();
        }
        _create_class._(Shader, [
            {
                key: "addElement",
                value: function addElement(elementCore) {
                    this._elements.add(elementCore);
                }
            },
            {
                key: "removeElement",
                value: function removeElement(elementCore) {
                    this._elements.delete(elementCore);
                    if (!this._elements) {
                        this.cleanup();
                    }
                }
            },
            {
                key: "redraw",
                value: function redraw() {
                    this._elements.forEach(function(elementCore) {
                        elementCore.setHasRenderUpdates(2);
                    });
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    Base.patchObject(this, settings);
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return false;
                }
            },
            {
                key: "addEmpty",
                value: function addEmpty() {
                    return false;
                }
            },
            {
                key: "cleanup",
                value: function cleanup() {}
            },
            {
                key: "isShader",
                get: function get() {
                    return true;
                }
            }
        ], [
            {
                key: "create",
                value: function create(stage, v) {
                    var shader;
                    if (Utils.isObjectLiteral(v)) {
                        if (v.type) {
                            shader = stage.renderer.createShader(stage.ctx, v);
                        } else {
                            shader = this.shader;
                        }
                        if (shader) {
                            Base.patchObject(shader, v);
                        }
                    } else if (v === null) {
                        shader = stage.ctx.renderState.defaultShader;
                    } else if (v === undefined) {
                        shader = null;
                    } else {
                        if (v.isShader) {
                            if (!stage.renderer.isValidShaderType(v.constructor)) {
                                console.error("[Lightning] Invalid shader type");
                                v = null;
                            }
                            shader = v;
                        } else {
                            console.error("[Lightning] Please specify a shader type.");
                            return;
                        }
                    }
                    return shader;
                }
            },
            {
                key: "getWebGL",
                value: function getWebGL() {
                    return undefined;
                }
            },
            {
                key: "getC2d",
                value: function getC2d() {
                    return undefined;
                }
            }
        ]);
        return Shader;
    }();
    var Texture = /*#__PURE__*/ function() {
        function Texture(stage) {
            _class_call_check._(this, Texture);
            this.stage = stage;
            this.manager = this.stage.textureManager;
            this.id = Texture.id++;
            this.elements = new Set();
            this._activeCount = 0;
            this._source = null;
            this._resizeMode = null;
            this._x = 0;
            this._y = 0;
            this._w = 0;
            this._h = 0;
            this._precision = 1;
            this.mw = 0;
            this.mh = 0;
            this.clipping = false;
            this._mustUpdate = true;
        }
        _create_class._(Texture, [
            {
                key: "source",
                get: function get() {
                    if (this._mustUpdate || this.stage.hasUpdateSourceTexture(this)) {
                        this._performUpdateSource(true);
                        this.stage.removeUpdateSourceTexture(this);
                    }
                    return this._source;
                }
            },
            {
                key: "addElement",
                value: function addElement(v) {
                    if (!this.elements.has(v)) {
                        this.elements.add(v);
                        if (this.elements.size === 1) {
                            if (this._source) {
                                this._source.addTexture(this);
                            }
                        }
                        if (v.active) {
                            this.incActiveCount();
                        }
                    }
                }
            },
            {
                key: "removeElement",
                value: function removeElement(v) {
                    if (this.elements.delete(v)) {
                        if (this.elements.size === 0) {
                            if (this._source) {
                                this._source.removeTexture(this);
                            }
                        }
                        if (v.active) {
                            this.decActiveCount();
                        }
                    }
                }
            },
            {
                key: "incActiveCount",
                value: function incActiveCount() {
                    var source = this.source;
                    if (source) {
                        this._checkForNewerReusableTextureSource();
                    }
                    this._activeCount++;
                    if (this._activeCount === 1) {
                        this.becomesUsed();
                    }
                }
            },
            {
                key: "decActiveCount",
                value: function decActiveCount() {
                    var source = this.source;
                    this._activeCount--;
                    if (!this._activeCount) {
                        this.becomesUnused();
                    }
                }
            },
            {
                key: "becomesUsed",
                value: function becomesUsed() {
                    if (this.source) {
                        this.source.incActiveTextureCount();
                    }
                }
            },
            {
                key: "onLoad",
                value: function onLoad() {
                    if (this._resizeMode) {
                        this._applyResizeMode();
                    }
                    this.elements.forEach(function(element) {
                        if (element.active) {
                            element.onTextureSourceLoaded();
                        }
                    });
                }
            },
            {
                key: "_checkForNewerReusableTextureSource",
                value: function _checkForNewerReusableTextureSource() {
                    var source = this.source;
                    if (!source.isLoaded()) {
                        var reusable = this._getReusableTextureSource();
                        if (reusable && reusable.isLoaded() && reusable !== source) {
                            this._replaceTextureSource(reusable);
                        }
                    } else {
                        if (this._resizeMode) {
                            this._applyResizeMode();
                        }
                    }
                }
            },
            {
                key: "becomesUnused",
                value: function becomesUnused() {
                    if (this.source) {
                        this.source.decActiveTextureCount();
                    }
                }
            },
            {
                key: "isUsed",
                value: function isUsed() {
                    return this._activeCount > 0;
                }
            },
            {
                key: "_getLookupId",
                value: function _getLookupId() {
                    return null;
                }
            },
            {
                key: "_getSourceLoader",
                value: function _getSourceLoader() {
                    throw new Error("Texture.generate must be implemented.");
                }
            },
            {
                key: "isValid",
                get: function get() {
                    return this._getIsValid();
                }
            },
            {
                key: "_getIsValid",
                value: function _getIsValid() {
                    return true;
                }
            },
            {
                key: "_changed",
                value: function _changed() {
                    if (this.isUsed()) {
                        this._updateSource();
                    } else {
                        this._mustUpdate = true;
                    }
                }
            },
            {
                key: "_updateSource",
                value: function _updateSource() {
                    this.stage.addUpdateSourceTexture(this);
                }
            },
            {
                key: "_performUpdateSource",
                value: function _performUpdateSource() {
                    var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    if (force || this.isUsed()) {
                        this._mustUpdate = false;
                        var source = this._getTextureSource();
                        this._replaceTextureSource(source);
                    }
                }
            },
            {
                key: "_getTextureSource",
                value: function _getTextureSource() {
                    var source = null;
                    if (this._getIsValid()) {
                        var lookupId = this._getLookupId();
                        source = this._getReusableTextureSource(lookupId);
                        if (!source) {
                            source = this.manager.getTextureSource(this._getSourceLoader(), lookupId);
                        }
                    }
                    return source;
                }
            },
            {
                key: "_getReusableTextureSource",
                value: function _getReusableTextureSource() {
                    var lookupId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._getLookupId();
                    if (this._getIsValid()) {
                        if (lookupId) {
                            return this.manager.getReusableTextureSource(lookupId);
                        }
                    }
                    return null;
                }
            },
            {
                key: "_replaceTextureSource",
                value: function _replaceTextureSource() {
                    var newSource = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    var _this = this;
                    var oldSource = this._source;
                    this._source = newSource;
                    if (this.elements.size) {
                        if (oldSource) {
                            if (this._activeCount) {
                                oldSource.decActiveTextureCount();
                            }
                            oldSource.removeTexture(this);
                            if (this["text"] && !oldSource.isUsed()) {
                                this.manager.freeTextureSource(oldSource);
                            }
                        }
                        if (newSource) {
                            newSource.addTexture(this);
                            if (this._activeCount) {
                                newSource.incActiveTextureCount();
                            }
                        }
                    }
                    if (this.isUsed()) {
                        if (newSource) {
                            if (newSource.isLoaded()) {
                                if (this._resizeMode) {
                                    this._applyResizeMode();
                                }
                                this.elements.forEach(function(element) {
                                    if (element.active) {
                                        element._setDisplayedTexture(_this);
                                    }
                                });
                            } else {
                                var loadError = newSource.loadError;
                                if (loadError) {
                                    this.elements.forEach(function(element) {
                                        if (element.active) {
                                            element.onTextureSourceLoadError(loadError);
                                        }
                                    });
                                }
                            }
                        } else {
                            this.elements.forEach(function(element) {
                                if (element.active) {
                                    element._setDisplayedTexture(null);
                                }
                            });
                        }
                    }
                }
            },
            {
                key: "load",
                value: function load() {
                    if (this.source) {
                        if (!this.isLoaded()) {
                            this.source.load(true);
                        }
                    }
                }
            },
            {
                key: "isLoaded",
                value: function isLoaded() {
                    return this._source && this._source.isLoaded();
                }
            },
            {
                key: "loadError",
                get: function get() {
                    return this._source && this._source.loadError;
                }
            },
            {
                key: "free",
                value: function free() {
                    if (this._source) {
                        this._source.free();
                    }
                }
            },
            {
                key: "resizeMode",
                get: function get() {
                    return this._resizeMode;
                },
                set: function set(param) {
                    var _param_type = param.type, type = _param_type === void 0 ? "cover" : _param_type, _param_w = param.w, w = _param_w === void 0 ? 0 : _param_w, _param_h = param.h, h = _param_h === void 0 ? 0 : _param_h, _param_clipX = param.clipX, clipX = _param_clipX === void 0 ? 0.5 : _param_clipX, _param_clipY = param.clipY, clipY = _param_clipY === void 0 ? 0.5 : _param_clipY;
                    this._resizeMode = {
                        type: type,
                        w: w,
                        h: h,
                        clipX: clipX,
                        clipY: clipY
                    };
                    if (this.isLoaded()) {
                        this._applyResizeMode();
                    }
                }
            },
            {
                key: "_clearResizeMode",
                value: function _clearResizeMode() {
                    this._resizeMode = null;
                }
            },
            {
                key: "_applyResizeMode",
                value: function _applyResizeMode() {
                    if (this._resizeMode.type === "cover") {
                        this._applyResizeCover();
                    } else if (this._resizeMode.type === "contain") {
                        this._applyResizeContain();
                    }
                    this._updatePrecision();
                    this._updateClipping();
                }
            },
            {
                key: "_applyResizeCover",
                value: function _applyResizeCover() {
                    var scaleX = this._resizeMode.w / this._source.w;
                    var scaleY = this._resizeMode.h / this._source.h;
                    var scale = Math.max(scaleX, scaleY);
                    if (!scale) return;
                    this._precision = 1 / scale;
                    if (scaleX && scaleX < scale) {
                        var desiredSize = this._precision * this._resizeMode.w;
                        var choppedOffPixels = this._source.w - desiredSize;
                        this._x = choppedOffPixels * this._resizeMode.clipX;
                        this._w = this._source.w - choppedOffPixels;
                    }
                    if (scaleY && scaleY < scale) {
                        var desiredSize1 = this._precision * this._resizeMode.h;
                        var choppedOffPixels1 = this._source.h - desiredSize1;
                        this._y = choppedOffPixels1 * this._resizeMode.clipY;
                        this._h = this._source.h - choppedOffPixels1;
                    }
                }
            },
            {
                key: "_applyResizeContain",
                value: function _applyResizeContain() {
                    var scaleX = this._resizeMode.w / this._source.w;
                    var scaleY = this._resizeMode.h / this._source.h;
                    var scale = scaleX;
                    if (!scale || scaleY < scale) {
                        scale = scaleY;
                    }
                    if (!scale) return;
                    this._precision = 1 / scale;
                }
            },
            {
                key: "enableClipping",
                value: function enableClipping(x, y, w, h) {
                    this._clearResizeMode();
                    x *= this._precision;
                    y *= this._precision;
                    w *= this._precision;
                    h *= this._precision;
                    if (this._x !== x || this._y !== y || this._w !== w || this._h !== h) {
                        this._x = x;
                        this._y = y;
                        this._w = w;
                        this._h = h;
                        this._updateClipping(true);
                    }
                }
            },
            {
                key: "disableClipping",
                value: function disableClipping() {
                    this._clearResizeMode();
                    if (this._x || this._y || this._w || this._h) {
                        this._x = 0;
                        this._y = 0;
                        this._w = 0;
                        this._h = 0;
                        this._updateClipping();
                    }
                }
            },
            {
                key: "_updateClipping",
                value: function _updateClipping() {
                    this.clipping = !!(this._x || this._y || this._w || this._h);
                    var self1 = this;
                    this.elements.forEach(function(element) {
                        if (element.displayedTexture === self1) {
                            element.onDisplayedTextureClippingChanged();
                        }
                    });
                }
            },
            {
                key: "_updatePrecision",
                value: function _updatePrecision() {
                    var self1 = this;
                    this.elements.forEach(function(element) {
                        if (element.displayedTexture === self1) {
                            element.onPrecisionChanged();
                        }
                    });
                }
            },
            {
                key: "getNonDefaults",
                value: function getNonDefaults() {
                    var nonDefaults = {};
                    nonDefaults["type"] = this.constructor.name;
                    if (this.x !== 0) nonDefaults["x"] = this.x;
                    if (this.y !== 0) nonDefaults["y"] = this.y;
                    if (this.w !== 0) nonDefaults["w"] = this.w;
                    if (this.h !== 0) nonDefaults["h"] = this.h;
                    if (this.precision !== 1) nonDefaults["precision"] = this.precision;
                    return nonDefaults;
                }
            },
            {
                key: "px",
                get: function get() {
                    return this._x;
                }
            },
            {
                key: "py",
                get: function get() {
                    return this._y;
                }
            },
            {
                key: "pw",
                get: function get() {
                    return this._w;
                }
            },
            {
                key: "ph",
                get: function get() {
                    return this._h;
                }
            },
            {
                key: "x",
                get: function get() {
                    return this._x / this._precision;
                },
                set: function set(v) {
                    this._clearResizeMode();
                    v = v * this._precision;
                    if (this._x !== v) {
                        this._x = v;
                        this._updateClipping();
                    }
                }
            },
            {
                key: "y",
                get: function get() {
                    return this._y / this._precision;
                },
                set: function set(v) {
                    this._clearResizeMode();
                    v = v * this._precision;
                    if (this._y !== v) {
                        this._y = v;
                        this._updateClipping();
                    }
                }
            },
            {
                key: "w",
                get: function get() {
                    return this._w / this._precision;
                },
                set: function set(v) {
                    this._clearResizeMode();
                    v = v * this._precision;
                    if (this._w !== v) {
                        this._w = v;
                        this._updateClipping();
                    }
                }
            },
            {
                key: "h",
                get: function get() {
                    return this._h / this._precision;
                },
                set: function set(v) {
                    this._clearResizeMode();
                    v = v * this._precision;
                    if (this._h !== v) {
                        this._h = v;
                        this._updateClipping();
                    }
                }
            },
            {
                key: "precision",
                get: function get() {
                    return this._precision;
                },
                set: function set(v) {
                    this._clearResizeMode();
                    if (this._precision !== v) {
                        this._precision = v;
                        this._updatePrecision();
                    }
                }
            },
            {
                key: "isAutosizeTexture",
                value: function isAutosizeTexture() {
                    return true;
                }
            },
            {
                key: "getRenderWidth",
                value: function getRenderWidth() {
                    if (!this.isAutosizeTexture()) {
                        return 0;
                    }
                    return (this._w || (this._source ? this._source.getRenderWidth() - this._x : 0)) / this._precision;
                }
            },
            {
                key: "getRenderHeight",
                value: function getRenderHeight() {
                    if (!this.isAutosizeTexture()) {
                        return 0;
                    }
                    return (this._h || (this._source ? this._source.getRenderHeight() - this._y : 0)) / this._precision;
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    Base.patchObject(this, settings);
                }
            }
        ]);
        return Texture;
    }();
    Texture.prototype.isTexture = true;
    Texture.id = 0;
    var ImageTexture = /*#__PURE__*/ function(Texture) {
        _inherits._(ImageTexture, Texture);
        var _super = _create_super._(ImageTexture);
        function ImageTexture(stage) {
            _class_call_check._(this, ImageTexture);
            var _this;
            _this = _super.call(this, stage);
            _this._src = undefined;
            _this._hasAlpha = false;
            return _this;
        }
        _create_class._(ImageTexture, [
            {
                key: "src",
                get: function get() {
                    return this._src;
                },
                set: function set(v) {
                    if (this._src !== v) {
                        this._src = v;
                        this._changed();
                    }
                }
            },
            {
                key: "hasAlpha",
                get: function get() {
                    return this._hasAlpha;
                },
                set: function set(v) {
                    if (this._hasAlpha !== v) {
                        this._hasAlpha = v;
                        this._changed();
                    }
                }
            },
            {
                key: "_getIsValid",
                value: function _getIsValid() {
                    return !!this._src;
                }
            },
            {
                key: "_getLookupId",
                value: function _getLookupId() {
                    return this._src;
                }
            },
            {
                key: "_getSourceLoader",
                value: function _getSourceLoader() {
                    var _this = this;
                    var src = this._src;
                    var hasAlpha = this._hasAlpha;
                    if (this.stage.getOption("srcBasePath")) {
                        var fc = src.charCodeAt(0);
                        if (src.indexOf("//") === -1 && (fc >= 65 && fc <= 90 || fc >= 97 && fc <= 122 || fc == 46)) {
                            src = this.stage.getOption("srcBasePath") + src;
                        }
                    }
                    return function(cb) {
                        return _this.stage.platform.loadSrcTexture({
                            src: src,
                            hasAlpha: hasAlpha
                        }, cb);
                    };
                }
            },
            {
                key: "getNonDefaults",
                value: function getNonDefaults() {
                    var obj = _get._(_get_prototype_of._(ImageTexture.prototype), "getNonDefaults", this).call(this);
                    if (this._src) {
                        obj.src = this._src;
                    }
                    return obj;
                }
            }
        ]);
        return ImageTexture;
    }(Texture);
    function getFontSetting(fontFace, fontStyle, fontSize, precision, defaultFontFace) {
        var ff = fontFace;
        if (!Array.isArray(ff)) {
            ff = [
                ff
            ];
        }
        var ffs = [];
        for(var i = 0, n = ff.length; i < n; i++){
            var curFf = ff[i];
            if (curFf === null) {
                curFf = defaultFontFace;
            }
            if (curFf === "serif" || curFf === "sans-serif") {
                ffs.push(curFf);
            } else {
                ffs.push('"'.concat(curFf, '"'));
            }
        }
        return "".concat(fontStyle, " ").concat(fontSize * precision, "px ").concat(ffs.join(","));
    }
    var TextTextureRenderer = /*#__PURE__*/ function() {
        function TextTextureRenderer(stage, canvas, settings) {
            _class_call_check._(this, TextTextureRenderer);
            this._stage = stage;
            this._canvas = canvas;
            this._context = this._canvas.getContext("2d");
            this._settings = settings;
        }
        _create_class._(TextTextureRenderer, [
            {
                key: "getPrecision",
                value: function getPrecision() {
                    return this._settings.precision;
                }
            },
            {
                key: "setFontProperties",
                value: function setFontProperties() {
                    this._context.font = getFontSetting(this._settings.fontFace, this._settings.fontStyle, this._settings.fontSize, this.getPrecision(), this._stage.getOption("defaultFontFace"));
                    this._context.textBaseline = this._settings.textBaseline;
                }
            },
            {
                key: "_load",
                value: function _load() {
                    var _this = this;
                    if (Utils.isWeb && document.fonts) {
                        var fontSetting = getFontSetting(this._settings.fontFace, this._settings.fontStyle, this._settings.fontSize, this.getPrecision(), this._stage.getOption("defaultFontFace"));
                        try {
                            if (!document.fonts.check(fontSetting, this._settings.text)) {
                                return document.fonts.load(fontSetting, this._settings.text).catch(function(err) {
                                    console.warn("[Lightning] Font load error", err, fontSetting);
                                }).then(function() {
                                    if (!document.fonts.check(fontSetting, _this._settings.text)) {
                                        console.warn("[Lightning] Font not found", fontSetting);
                                    }
                                });
                            }
                        } catch (e) {
                            console.warn("[Lightning] Can't check font loading for " + fontSetting);
                        }
                    }
                }
            },
            {
                key: "draw",
                value: function draw() {
                    var _this = this;
                    var loadPromise = this._load();
                    if (!loadPromise) {
                        return Utils.isSpark ? this._stage.platform.drawText(this) : this._draw();
                    } else {
                        return loadPromise.then(function() {
                            return Utils.isSpark ? _this._stage.platform.drawText(_this) : _this._draw();
                        });
                    }
                }
            },
            {
                key: "_calculateRenderInfo",
                value: function _calculateRenderInfo() {
                    var renderInfo = {};
                    var precision = this.getPrecision();
                    var paddingLeft = this._settings.paddingLeft * precision;
                    var paddingRight = this._settings.paddingRight * precision;
                    var fontSize = this._settings.fontSize * precision;
                    var offsetY = this._settings.offsetY === null ? null : this._settings.offsetY * precision;
                    var lineHeight = this._settings.lineHeight * precision;
                    var w = this._settings.w * precision;
                    var h = this._settings.h * precision;
                    var wordWrapWidth = this._settings.wordWrapWidth * precision;
                    var cutSx = this._settings.cutSx * precision;
                    var cutEx = this._settings.cutEx * precision;
                    var cutSy = this._settings.cutSy * precision;
                    var cutEy = this._settings.cutEy * precision;
                    var letterSpacing = (this._settings.letterSpacing || 0) * precision;
                    var textIndent = this._settings.textIndent * precision;
                    this.setFontProperties();
                    var width = w || 2048 / this.getPrecision();
                    var innerWidth = width - paddingLeft;
                    if (innerWidth < 10) {
                        width += 10 - innerWidth;
                        innerWidth = 10;
                    }
                    if (!wordWrapWidth) {
                        wordWrapWidth = innerWidth;
                    }
                    if (this._settings.textOverflow && !this._settings.wordWrap) {
                        var suffix;
                        switch(this._settings.textOverflow){
                            case "clip":
                                suffix = "";
                                break;
                            case "ellipsis":
                                suffix = this._settings.maxLinesSuffix;
                                break;
                            default:
                                suffix = this._settings.textOverflow;
                        }
                        this._settings.text = this.wrapWord(this._settings.text, wordWrapWidth - textIndent, suffix);
                    }
                    var linesInfo;
                    if (this._settings.wordWrap) {
                        linesInfo = this.wrapText(this._settings.text, wordWrapWidth, letterSpacing, textIndent);
                    } else {
                        linesInfo = {
                            l: this._settings.text.split(/(?:\r\n|\r|\n)/),
                            n: []
                        };
                        var n = linesInfo.l.length;
                        for(var i = 0; i < n - 1; i++){
                            linesInfo.n.push(i);
                        }
                    }
                    var lines = linesInfo.l;
                    if (this._settings.maxLines && lines.length > this._settings.maxLines) {
                        var usedLines = lines.slice(0, this._settings.maxLines);
                        var otherLines = null;
                        if (this._settings.maxLinesSuffix) {
                            var w1 = this._settings.maxLinesSuffix ? this.measureText(this._settings.maxLinesSuffix) : 0;
                            var al = this.wrapText(usedLines[usedLines.length - 1], wordWrapWidth - w1, letterSpacing, textIndent);
                            usedLines[usedLines.length - 1] = al.l[0] + this._settings.maxLinesSuffix;
                            otherLines = [
                                al.l.length > 1 ? al.l[1] : ""
                            ];
                        } else {
                            otherLines = [
                                ""
                            ];
                        }
                        var i1, n1 = lines.length;
                        var j = 0;
                        var m = linesInfo.n.length;
                        for(i1 = this._settings.maxLines; i1 < n1; i1++){
                            otherLines[j] += (otherLines[j] ? " " : "") + lines[i1];
                            if (i1 + 1 < m && linesInfo.n[i1 + 1]) {
                                j++;
                            }
                        }
                        renderInfo.remainingText = otherLines.join("\n");
                        renderInfo.moreTextLines = true;
                        lines = usedLines;
                    } else {
                        renderInfo.moreTextLines = false;
                        renderInfo.remainingText = "";
                    }
                    var maxLineWidth = 0;
                    var lineWidths = [];
                    for(var i2 = 0; i2 < lines.length; i2++){
                        var lineWidth = this.measureText(lines[i2], letterSpacing) + (i2 === 0 ? textIndent : 0);
                        lineWidths.push(lineWidth);
                        maxLineWidth = Math.max(maxLineWidth, lineWidth);
                    }
                    renderInfo.lineWidths = lineWidths;
                    if (!w) {
                        width = maxLineWidth + paddingLeft + paddingRight;
                        innerWidth = maxLineWidth;
                    }
                    lineHeight = lineHeight || fontSize;
                    var height;
                    if (h) {
                        height = h;
                    } else {
                        var baselineOffset = this._settings.textBaseline != "bottom" ? 0.5 * fontSize : 0;
                        height = lineHeight * (lines.length - 1) + baselineOffset + Math.max(lineHeight, fontSize) + offsetY;
                    }
                    if (offsetY === null) {
                        offsetY = fontSize;
                    }
                    renderInfo.w = width;
                    renderInfo.h = height;
                    renderInfo.lines = lines;
                    renderInfo.precision = precision;
                    if (!width) {
                        width = 1;
                    }
                    if (!height) {
                        height = 1;
                    }
                    if (cutSx || cutEx) {
                        width = Math.min(width, cutEx - cutSx);
                    }
                    if (cutSy || cutEy) {
                        height = Math.min(height, cutEy - cutSy);
                    }
                    renderInfo.width = width;
                    renderInfo.innerWidth = innerWidth;
                    renderInfo.height = height;
                    renderInfo.fontSize = fontSize;
                    renderInfo.cutSx = cutSx;
                    renderInfo.cutSy = cutSy;
                    renderInfo.cutEx = cutEx;
                    renderInfo.cutEy = cutEy;
                    renderInfo.lineHeight = lineHeight;
                    renderInfo.lineWidths = lineWidths;
                    renderInfo.offsetY = offsetY;
                    renderInfo.paddingLeft = paddingLeft;
                    renderInfo.paddingRight = paddingRight;
                    renderInfo.letterSpacing = letterSpacing;
                    renderInfo.textIndent = textIndent;
                    return renderInfo;
                }
            },
            {
                key: "_draw",
                value: function _draw() {
                    var renderInfo = this._calculateRenderInfo();
                    var precision = this.getPrecision();
                    this._canvas.width = Math.ceil(renderInfo.width + this._stage.getOption("textRenderIssueMargin"));
                    this._canvas.height = Math.ceil(renderInfo.height);
                    this.setFontProperties();
                    if (renderInfo.fontSize >= 128) {
                        this._context.globalAlpha = 0.01;
                        this._context.fillRect(0, 0, 0.01, 0.01);
                        this._context.globalAlpha = 1.0;
                    }
                    if (renderInfo.cutSx || renderInfo.cutSy) {
                        this._context.translate(-renderInfo.cutSx, -renderInfo.cutSy);
                    }
                    var linePositionX;
                    var linePositionY;
                    var drawLines = [];
                    for(var i = 0, n = renderInfo.lines.length; i < n; i++){
                        linePositionX = i === 0 ? renderInfo.textIndent : 0;
                        linePositionY = i * renderInfo.lineHeight + renderInfo.offsetY;
                        if (this._settings.verticalAlign == "middle") {
                            linePositionY += (renderInfo.lineHeight - renderInfo.fontSize) / 2;
                        } else if (this._settings.verticalAlign == "bottom") {
                            linePositionY += renderInfo.lineHeight - renderInfo.fontSize;
                        }
                        if (this._settings.textAlign === "right") {
                            linePositionX += renderInfo.innerWidth - renderInfo.lineWidths[i];
                        } else if (this._settings.textAlign === "center") {
                            linePositionX += (renderInfo.innerWidth - renderInfo.lineWidths[i]) / 2;
                        }
                        linePositionX += renderInfo.paddingLeft;
                        drawLines.push({
                            text: renderInfo.lines[i],
                            x: linePositionX,
                            y: linePositionY,
                            w: renderInfo.lineWidths[i]
                        });
                    }
                    if (this._settings.highlight) {
                        var color = this._settings.highlightColor || 0x00000000;
                        var hlHeight = this._settings.highlightHeight * precision || renderInfo.fontSize * 1.5;
                        var offset = this._settings.highlightOffset * precision;
                        var hlPaddingLeft = this._settings.highlightPaddingLeft !== null ? this._settings.highlightPaddingLeft * precision : renderInfo.paddingLeft;
                        var hlPaddingRight = this._settings.highlightPaddingRight !== null ? this._settings.highlightPaddingRight * precision : renderInfo.paddingRight;
                        this._context.fillStyle = StageUtils.getRgbaString(color);
                        for(var i1 = 0; i1 < drawLines.length; i1++){
                            var drawLine = drawLines[i1];
                            this._context.fillRect(drawLine.x - hlPaddingLeft, drawLine.y - renderInfo.offsetY + offset, drawLine.w + hlPaddingRight + hlPaddingLeft, hlHeight);
                        }
                    }
                    var prevShadowSettings = null;
                    if (this._settings.shadow) {
                        prevShadowSettings = [
                            this._context.shadowColor,
                            this._context.shadowOffsetX,
                            this._context.shadowOffsetY,
                            this._context.shadowBlur
                        ];
                        this._context.shadowColor = StageUtils.getRgbaString(this._settings.shadowColor);
                        this._context.shadowOffsetX = this._settings.shadowOffsetX * precision;
                        this._context.shadowOffsetY = this._settings.shadowOffsetY * precision;
                        this._context.shadowBlur = this._settings.shadowBlur * precision;
                    }
                    this._context.fillStyle = StageUtils.getRgbaString(this._settings.textColor);
                    for(var i2 = 0, n1 = drawLines.length; i2 < n1; i2++){
                        var drawLine1 = drawLines[i2];
                        if (renderInfo.letterSpacing === 0) {
                            this._context.fillText(drawLine1.text, drawLine1.x, drawLine1.y);
                        } else {
                            var textSplit = drawLine1.text.split("");
                            var x = drawLine1.x;
                            for(var i3 = 0, j = textSplit.length; i3 < j; i3++){
                                this._context.fillText(textSplit[i3], x, drawLine1.y);
                                x += this.measureText(textSplit[i3], renderInfo.letterSpacing);
                            }
                        }
                    }
                    if (prevShadowSettings) {
                        this._context.shadowColor = prevShadowSettings[0];
                        this._context.shadowOffsetX = prevShadowSettings[1];
                        this._context.shadowOffsetY = prevShadowSettings[2];
                        this._context.shadowBlur = prevShadowSettings[3];
                    }
                    if (renderInfo.cutSx || renderInfo.cutSy) {
                        this._context.translate(renderInfo.cutSx, renderInfo.cutSy);
                    }
                    this.renderInfo = renderInfo;
                }
            },
            {
                key: "wrapWord",
                value: function wrapWord(word, wordWrapWidth, suffix) {
                    var suffixWidth = this._context.measureText(suffix).width;
                    var wordLen = word.length;
                    var wordWidth = this._context.measureText(word).width;
                    if (wordWidth <= wordWrapWidth) {
                        return word;
                    }
                    var cutoffIndex = Math.floor(wordWrapWidth * wordLen / wordWidth);
                    var truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
                    if (truncWordWidth > wordWrapWidth) {
                        while(cutoffIndex > 0){
                            truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
                            if (truncWordWidth > wordWrapWidth) {
                                cutoffIndex -= 1;
                            } else {
                                break;
                            }
                        }
                    } else {
                        while(cutoffIndex < wordLen){
                            truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
                            if (truncWordWidth < wordWrapWidth) {
                                cutoffIndex += 1;
                            } else {
                                cutoffIndex -= 1;
                                break;
                            }
                        }
                    }
                    return word.substring(0, cutoffIndex) + (wordWrapWidth >= suffixWidth ? suffix : "");
                }
            },
            {
                key: "wrapText",
                value: function wrapText(text, wordWrapWidth, letterSpacing) {
                    var indent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                    var lines = text.split(/\r?\n/g);
                    var allLines = [];
                    var realNewlines = [];
                    for(var i = 0; i < lines.length; i++){
                        var resultLines = [];
                        var result = "";
                        var spaceLeft = wordWrapWidth - indent;
                        var words = lines[i].split(" ");
                        for(var j = 0; j < words.length; j++){
                            var wordWidth = this.measureText(words[j], letterSpacing);
                            var wordWidthWithSpace = wordWidth + this.measureText(" ", letterSpacing);
                            if (j === 0 || wordWidthWithSpace > spaceLeft) {
                                if (j > 0) {
                                    resultLines.push(result);
                                    result = "";
                                }
                                result += words[j];
                                spaceLeft = wordWrapWidth - wordWidth - (j === 0 ? indent : 0);
                            } else {
                                spaceLeft -= wordWidthWithSpace;
                                result += " " + words[j];
                            }
                        }
                        resultLines.push(result);
                        result = "";
                        allLines = allLines.concat(resultLines);
                        if (i < lines.length - 1) {
                            realNewlines.push(allLines.length);
                        }
                    }
                    return {
                        l: allLines,
                        n: realNewlines
                    };
                }
            },
            {
                key: "measureText",
                value: function measureText(word) {
                    var space = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                    var _this = this;
                    if (!space) {
                        return this._context.measureText(word).width;
                    }
                    return word.split("").reduce(function(acc, char) {
                        return acc + _this._context.measureText(char).width + space;
                    }, 0);
                }
            }
        ]);
        return TextTextureRenderer;
    }();
    var TextTextureRendererAdvanced = /*#__PURE__*/ function() {
        function TextTextureRendererAdvanced(stage, canvas, settings) {
            _class_call_check._(this, TextTextureRendererAdvanced);
            this._stage = stage;
            this._canvas = canvas;
            this._context = this._canvas.getContext("2d");
            this._settings = settings;
        }
        _create_class._(TextTextureRendererAdvanced, [
            {
                key: "getPrecision",
                value: function getPrecision() {
                    return this._settings.precision;
                }
            },
            {
                key: "setFontProperties",
                value: function setFontProperties() {
                    var font = getFontSetting(this._settings.fontFace, this._settings.fontStyle, this._settings.fontSize, this.getPrecision(), this._stage.getOption("defaultFontFace"));
                    this._context.font = font;
                    this._context.textBaseline = this._settings.textBaseline;
                    return font;
                }
            },
            {
                key: "_load",
                value: function _load() {
                    var _this = this;
                    if (Utils.isWeb && document.fonts) {
                        var fontSetting = getFontSetting(this._settings.fontFace, this._settings.fontStyle, this._settings.fontSize, this.getPrecision(), this._stage.getOption("defaultFontFace"));
                        try {
                            if (!document.fonts.check(fontSetting, this._settings.text)) {
                                return document.fonts.load(fontSetting, this._settings.text).catch(function(err) {
                                    console.warn("Font load error", err, fontSetting);
                                }).then(function() {
                                    if (!document.fonts.check(fontSetting, _this._settings.text)) {
                                        console.warn("Font not found", fontSetting);
                                    }
                                });
                            }
                        } catch (e) {
                            console.warn("Can't check font loading for " + fontSetting);
                        }
                    }
                }
            },
            {
                key: "draw",
                value: function draw() {
                    var _this = this;
                    var loadPromise = this._load();
                    if (!loadPromise) {
                        return Utils.isSpark ? this._stage.platform.drawText(this) : this._draw();
                    } else {
                        return loadPromise.then(function() {
                            return Utils.isSpark ? _this._stage.platform.drawText(_this) : _this._draw();
                        });
                    }
                }
            },
            {
                key: "_calculateRenderInfo",
                value: function _calculateRenderInfo() {
                    var _this = this;
                    var _Math;
                    var renderInfo = {};
                    var precision = this.getPrecision();
                    var paddingLeft = this._settings.paddingLeft * precision;
                    var paddingRight = this._settings.paddingRight * precision;
                    var fontSize = this._settings.fontSize * precision;
                    var lineHeight = this._settings.lineHeight * precision || fontSize;
                    var w = this._settings.w != 0 ? this._settings.w * precision : 2048 / precision;
                    var wordWrapWidth = this._settings.wordWrapWidth * precision;
                    var cutSx = this._settings.cutSx * precision;
                    var cutEx = this._settings.cutEx * precision;
                    var cutSy = this._settings.cutSy * precision;
                    var cutEy = this._settings.cutEy * precision;
                    var letterSpacing = this._settings.letterSpacing || 0;
                    renderInfo.baseFont = this.setFontProperties();
                    renderInfo.w = w;
                    renderInfo.width = w;
                    renderInfo.text = this._settings.text;
                    renderInfo.precision = precision;
                    renderInfo.fontSize = fontSize;
                    renderInfo.fontBaselineRatio = this._settings.fontBaselineRatio;
                    renderInfo.lineHeight = lineHeight;
                    renderInfo.letterSpacing = letterSpacing;
                    renderInfo.textAlign = this._settings.textAlign;
                    renderInfo.textColor = this._settings.textColor;
                    renderInfo.verticalAlign = this._settings.verticalAlign;
                    renderInfo.highlight = this._settings.highlight;
                    renderInfo.highlightColor = this._settings.highlightColor;
                    renderInfo.highlightHeight = this._settings.highlightHeight;
                    renderInfo.highlightPaddingLeft = this._settings.highlightPaddingLeft;
                    renderInfo.highlightPaddingRight = this._settings.highlightPaddingRight;
                    renderInfo.highlightOffset = this._settings.highlightOffset;
                    renderInfo.paddingLeft = this._settings.paddingLeft;
                    renderInfo.paddingRight = this._settings.paddingRight;
                    renderInfo.maxLines = this._settings.maxLines;
                    renderInfo.maxLinesSuffix = this._settings.maxLinesSuffix;
                    renderInfo.textOverflow = this._settings.textOverflow;
                    renderInfo.wordWrap = this._settings.wordWrap;
                    renderInfo.wordWrapWidth = wordWrapWidth;
                    renderInfo.shadow = this._settings.shadow;
                    renderInfo.shadowColor = this._settings.shadowColor;
                    renderInfo.shadowOffsetX = this._settings.shadowOffsetX;
                    renderInfo.shadowOffsetY = this._settings.shadowOffsetY;
                    renderInfo.shadowBlur = this._settings.shadowBlur;
                    renderInfo.cutSx = cutSx;
                    renderInfo.cutEx = cutEx;
                    renderInfo.cutSy = cutSy;
                    renderInfo.cutEy = cutEy;
                    renderInfo.textIndent = this._settings.textIndent * precision;
                    renderInfo.wordBreak = this._settings.wordBreak;
                    var text = renderInfo.text;
                    var wrapWidth = renderInfo.wordWrap ? renderInfo.wordWrapWidth || renderInfo.width : renderInfo.width;
                    if (renderInfo.textOverflow && !renderInfo.wordWrap) {
                        var suffix;
                        switch(this._settings.textOverflow){
                            case "clip":
                                suffix = "";
                                break;
                            case "ellipsis":
                                suffix = this._settings.maxLinesSuffix;
                                break;
                            default:
                                suffix = this._settings.textOverflow;
                        }
                        text = this.wrapWord(text, wordWrapWidth || renderInfo.w, suffix);
                    }
                    text = this.tokenize(text);
                    text = this.parse(text);
                    text = this.measure(text, letterSpacing, renderInfo.baseFont);
                    if (renderInfo.textIndent) {
                        text = this.indent(text, renderInfo.textIndent);
                    }
                    if (renderInfo.wordBreak) {
                        text = text.reduce(function(acc, t) {
                            return acc.concat(_this.wordBreak(t, wrapWidth, renderInfo.baseFont));
                        }, []);
                        this.resetFontStyle();
                    }
                    var x = paddingLeft;
                    var lineNo = 0;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t = _step.value;
                            if (renderInfo.wordWrap && x + t.width > wrapWidth || t.text == "\n") {
                                x = paddingLeft;
                                lineNo += 1;
                            }
                            t.lineNo = lineNo;
                            if (t.text == "\n") {
                                continue;
                            }
                            t.x = x;
                            x += t.width;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    renderInfo.lineNum = lineNo + 1;
                    if (this._settings.h) {
                        renderInfo.h = this._settings.h;
                    } else if (renderInfo.maxLines && renderInfo.maxLines < renderInfo.lineNum) {
                        renderInfo.h = renderInfo.maxLines * renderInfo.lineHeight + fontSize / 2;
                    } else {
                        renderInfo.h = renderInfo.lineNum * renderInfo.lineHeight + fontSize / 2;
                    }
                    var baselineOffsetInPx = renderInfo.fontBaselineRatio * renderInfo.fontSize;
                    var vaOffset = 0;
                    if (renderInfo.verticalAlign == "top" && this._context.textBaseline == "alphabetic") {
                        vaOffset = -baselineOffsetInPx;
                    } else if (renderInfo.verticalAlign == "middle") {
                        vaOffset = (renderInfo.lineHeight - renderInfo.fontSize - baselineOffsetInPx) / 2;
                    } else if (this._settings.verticalAlign == "bottom") {
                        vaOffset = renderInfo.lineHeight - renderInfo.fontSize;
                    }
                    renderInfo.lines = [];
                    for(var i = 0; i < renderInfo.lineNum; i++){
                        renderInfo.lines[i] = {
                            width: 0,
                            x: 0,
                            y: renderInfo.lineHeight * i + vaOffset,
                            text: []
                        };
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = text[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var t1 = _step1.value;
                            renderInfo.lines[t1.lineNo].text.push(t1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = renderInfo.lines[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var l = _step2.value;
                            if (l.text.length == 0) {
                                continue;
                            }
                            var firstWord = l.text[0].text;
                            var lastWord = l.text[l.text.length - 1].text;
                            if (firstWord == "\n") {
                                l.text.shift();
                            }
                            if (lastWord == " " || lastWord == "\n") {
                                l.text.pop();
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = renderInfo.lines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var l1 = _step3.value;
                            l1.width = l1.text.reduce(function(acc, t) {
                                return acc + t.width;
                            }, 0);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    renderInfo.width = this._settings.w != 0 ? this._settings.w * precision : (_Math = Math).max.apply(_Math, _to_consumable_array._(renderInfo.lines.map(function(l) {
                        return l.width;
                    }))) + paddingRight;
                    renderInfo.w = renderInfo.width;
                    if (renderInfo.maxLines && renderInfo.lineNum > renderInfo.maxLines && renderInfo.maxLinesSuffix) {
                        var index = renderInfo.maxLines - 1;
                        var lastLineText = text.filter(function(t) {
                            return t.lineNo == index;
                        });
                        var suffix1 = renderInfo.maxLinesSuffix;
                        suffix1 = this.tokenize(suffix1);
                        suffix1 = this.parse(suffix1);
                        suffix1 = this.measure(suffix1, renderInfo.letterSpacing, renderInfo.baseFont);
                        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                        try {
                            for(var _iterator4 = suffix1[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                var s = _step4.value;
                                s.lineNo = index;
                                s.x = 0;
                                lastLineText.push(s);
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                    _iterator4.return();
                                }
                            } finally{
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                        var spl = suffix1.length + 1;
                        var _w = lastLineText.reduce(function(acc, t) {
                            return acc + t.width;
                        }, 0);
                        while(_w > renderInfo.width || lastLineText[lastLineText.length - spl].text == " "){
                            lastLineText.splice(lastLineText.length - spl, 1);
                            _w = lastLineText.reduce(function(acc, t) {
                                return acc + t.width;
                            }, 0);
                            if (lastLineText.length < spl) {
                                break;
                            }
                        }
                        this.alignLine(lastLineText, lastLineText[0].x);
                        renderInfo.lines[index].text = lastLineText;
                        renderInfo.lines[index].width = _w;
                    }
                    if (renderInfo.textAlign == "center") {
                        var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                        try {
                            for(var _iterator5 = renderInfo.lines[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                var l2 = _step5.value;
                                l2.x = (renderInfo.width - l2.width - paddingLeft) / 2;
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                    _iterator5.return();
                                }
                            } finally{
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }
                    } else if (renderInfo.textAlign == "right") {
                        var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                        try {
                            for(var _iterator6 = renderInfo.lines[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                var l3 = _step6.value;
                                l3.x = renderInfo.width - l3.width - paddingLeft;
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                                    _iterator6.return();
                                }
                            } finally{
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    }
                    return renderInfo;
                }
            },
            {
                key: "_draw",
                value: function _draw() {
                    var renderInfo = this._calculateRenderInfo();
                    var precision = this.getPrecision();
                    var paddingLeft = renderInfo.paddingLeft * precision;
                    var canvasWidth = renderInfo.w || renderInfo.width;
                    if (renderInfo.cutSx || renderInfo.cutEx) {
                        canvasWidth = Math.min(renderInfo.w, renderInfo.cutEx - renderInfo.cutSx);
                    }
                    var canvasHeight = renderInfo.h;
                    if (renderInfo.cutSy || renderInfo.cutEy) {
                        canvasHeight = Math.min(renderInfo.h, renderInfo.cutEy - renderInfo.cutSy);
                    }
                    this._canvas.width = Math.ceil(canvasWidth + this._stage.getOption("textRenderIssueMargin"));
                    this._canvas.height = Math.ceil(canvasHeight);
                    this.setFontProperties();
                    if (renderInfo.fontSize >= 128) {
                        this._context.globalAlpha = 0.01;
                        this._context.fillRect(0, 0, 0.01, 0.01);
                        this._context.globalAlpha = 1.0;
                    }
                    if (renderInfo.cutSx || renderInfo.cutSy) {
                        this._context.translate(-renderInfo.cutSx, -renderInfo.cutSy);
                    }
                    if (renderInfo.highlight) {
                        var hlColor = renderInfo.highlightColor || 0x00000000;
                        var hlHeight = renderInfo.highlightHeight ? renderInfo.highlightHeight * precision : renderInfo.fontSize * 1.5;
                        var hlOffset = renderInfo.highlightOffset ? renderInfo.highlightOffset * precision : 0;
                        var hlPaddingLeft = renderInfo.highlightPaddingLeft !== null ? renderInfo.highlightPaddingLeft * precision : renderInfo.paddingLeft;
                        var hlPaddingRight = renderInfo.highlightPaddingRight !== null ? renderInfo.highlightPaddingRight * precision : renderInfo.paddingRight;
                        this._context.fillStyle = StageUtils.getRgbaString(hlColor);
                        var lineNum = renderInfo.maxLines ? Math.min(renderInfo.maxLines, renderInfo.lineNum) : renderInfo.lineNum;
                        for(var i = 0; i < lineNum; i++){
                            var l = renderInfo.lines[i];
                            this._context.fillRect(l.x - hlPaddingLeft + paddingLeft, l.y + hlOffset, l.width + hlPaddingLeft + hlPaddingRight, hlHeight);
                        }
                    }
                    var prevShadowSettings = null;
                    if (this._settings.shadow) {
                        prevShadowSettings = [
                            this._context.shadowColor,
                            this._context.shadowOffsetX,
                            this._context.shadowOffsetY,
                            this._context.shadowBlur
                        ];
                        this._context.shadowColor = StageUtils.getRgbaString(this._settings.shadowColor);
                        this._context.shadowOffsetX = this._settings.shadowOffsetX * precision;
                        this._context.shadowOffsetY = this._settings.shadowOffsetY * precision;
                        this._context.shadowBlur = this._settings.shadowBlur * precision;
                    }
                    var defaultColor = StageUtils.getRgbaString(this._settings.textColor);
                    var currentColor = defaultColor;
                    this._context.fillStyle = defaultColor;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = renderInfo.lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var line = _step.value;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = line.text[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var t = _step1.value;
                                    var lx = 0;
                                    if (t.text == "\n") {
                                        continue;
                                    }
                                    if (renderInfo.maxLines && t.lineNo >= renderInfo.maxLines) {
                                        continue;
                                    }
                                    if (t.color != currentColor) {
                                        currentColor = t.color;
                                        this._context.fillStyle = currentColor;
                                    }
                                    this._context.font = t.fontStyle;
                                    if (t.letters) {
                                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                        try {
                                            for(var _iterator2 = t.letters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                                var l1 = _step2.value;
                                                var _x = renderInfo.lines[t.lineNo].x + t.x + lx;
                                                this._context.fillText(l1.text, _x, renderInfo.lines[t.lineNo].y + renderInfo.fontSize);
                                                lx += l1.width;
                                            }
                                        } catch (err) {
                                            _didIteratorError2 = true;
                                            _iteratorError2 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                    _iterator2.return();
                                                }
                                            } finally{
                                                if (_didIteratorError2) {
                                                    throw _iteratorError2;
                                                }
                                            }
                                        }
                                    } else {
                                        var _x1 = renderInfo.lines[t.lineNo].x + t.x;
                                        this._context.fillText(t.text, _x1, renderInfo.lines[t.lineNo].y + renderInfo.fontSize);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (prevShadowSettings) {
                        this._context.shadowColor = prevShadowSettings[0];
                        this._context.shadowOffsetX = prevShadowSettings[1];
                        this._context.shadowOffsetY = prevShadowSettings[2];
                        this._context.shadowBlur = prevShadowSettings[3];
                    }
                    if (renderInfo.cutSx || renderInfo.cutSy) {
                        this._context.translate(renderInfo.cutSx, renderInfo.cutSy);
                    }
                    renderInfo.lines = renderInfo.lines.map(function(l) {
                        return l.text.reduce(function(acc, v) {
                            return acc + v.text;
                        }, "");
                    });
                    if (renderInfo.maxLines) {
                        renderInfo.lines = renderInfo.lines.slice(0, renderInfo.maxLines);
                    }
                    this.renderInfo = renderInfo;
                }
            },
            {
                key: "measureText",
                value: function measureText(word) {
                    var space = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                    var _this = this;
                    if (!space) {
                        return this._context.measureText(word).width;
                    }
                    return word.split("").reduce(function(acc, char) {
                        return acc + _this._context.measureText(char).width + space;
                    }, 0);
                }
            },
            {
                key: "tokenize",
                value: function tokenize(text) {
                    var re = / |\n|<i>|<\/i>|<b>|<\/b>|<color=0[xX][0-9a-fA-F]{8}>|<\/color>/g;
                    var delimeters = text.match(re) || [];
                    var words = text.split(re) || [];
                    var final = [];
                    for(var i = 0; i < words.length; i++){
                        final.push(words[i], delimeters[i]);
                    }
                    final.pop();
                    return final.filter(function(word) {
                        return word != "";
                    });
                }
            },
            {
                key: "parse",
                value: function parse(tokens) {
                    var italic = 0;
                    var bold = 0;
                    var colorStack = [
                        StageUtils.getRgbaString(this._settings.textColor)
                    ];
                    var color = 0;
                    var colorRegexp = /<color=(0[xX][0-9a-fA-F]{8})>/;
                    return tokens.map(function(t) {
                        if (t == "<i>") {
                            italic += 1;
                            t = "";
                        } else if (t == "</i>" && italic > 0) {
                            italic -= 1;
                            t = "";
                        } else if (t == "<b>") {
                            bold += 1;
                            t = "";
                        } else if (t == "</b>" && bold > 0) {
                            bold -= 1;
                            t = "";
                        } else if (t == "</color>") {
                            if (colorStack.length > 1) {
                                color -= 1;
                                colorStack.pop();
                            }
                            t = "";
                        } else if (colorRegexp.test(t)) {
                            var matched = colorRegexp.exec(t);
                            colorStack.push(StageUtils.getRgbaString(parseInt(matched[1])));
                            color += 1;
                            t = "";
                        }
                        return {
                            text: t,
                            italic: italic,
                            bold: bold,
                            color: colorStack[color]
                        };
                    }).filter(function(o) {
                        return o.text != "";
                    });
                }
            },
            {
                key: "applyFontStyle",
                value: function applyFontStyle(word, baseFont) {
                    var font = baseFont;
                    if (word.bold) {
                        font = "bold " + font;
                    }
                    if (word.italic) {
                        font = "italic " + font;
                    }
                    this._context.font = font;
                    word.fontStyle = font;
                }
            },
            {
                key: "resetFontStyle",
                value: function resetFontStyle(baseFont) {
                    this._context.font = baseFont;
                }
            },
            {
                key: "measure",
                value: function measure(parsed) {
                    var letterSpacing = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, baseFont = arguments.length > 2 ? arguments[2] : void 0;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = parsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var p = _step.value;
                            this.applyFontStyle(p, baseFont);
                            p.width = this.measureText(p.text, letterSpacing);
                            if (letterSpacing > 0) {
                                p.letters = p.text.split("").map(function(l) {
                                    return {
                                        text: l
                                    };
                                });
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = p.letters[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var l = _step1.value;
                                        l.width = this.measureText(l.text, letterSpacing);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.resetFontStyle(baseFont);
                    return parsed;
                }
            },
            {
                key: "indent",
                value: function indent(parsed, textIndent) {
                    parsed.splice(0, 0, {
                        text: "",
                        width: textIndent
                    });
                    return parsed;
                }
            },
            {
                key: "wrapWord",
                value: function wrapWord(word, wordWrapWidth, suffix) {
                    var suffixWidth = this._context.measureText(suffix).width;
                    var wordLen = word.length;
                    var wordWidth = this._context.measureText(word).width;
                    if (wordWidth <= wordWrapWidth) {
                        return word;
                    }
                    var cutoffIndex = Math.floor(wordWrapWidth * wordLen / wordWidth);
                    var truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
                    if (truncWordWidth > wordWrapWidth) {
                        while(cutoffIndex > 0){
                            truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
                            if (truncWordWidth > wordWrapWidth) {
                                cutoffIndex -= 1;
                            } else {
                                break;
                            }
                        }
                    } else {
                        while(cutoffIndex < wordLen){
                            truncWordWidth = this._context.measureText(word.substring(0, cutoffIndex)).width + suffixWidth;
                            if (truncWordWidth < wordWrapWidth) {
                                cutoffIndex += 1;
                            } else {
                                cutoffIndex -= 1;
                                break;
                            }
                        }
                    }
                    return word.substring(0, cutoffIndex) + (wordWrapWidth >= suffixWidth ? suffix : "");
                }
            },
            {
                key: "_getBreakIndex",
                value: function _getBreakIndex(word, width) {
                    var wordLen = word.length;
                    var wordWidth = this.measureText(word);
                    if (wordWidth <= width) {
                        return {
                            breakIndex: word.length,
                            truncWordWidth: wordWidth
                        };
                    }
                    var breakIndex = Math.floor(width * wordLen / wordWidth);
                    var truncWordWidth = this.measureText(word.substring(0, breakIndex));
                    if (truncWordWidth > width) {
                        while(breakIndex > 0){
                            truncWordWidth = this.measureText(word.substring(0, breakIndex));
                            if (truncWordWidth > width) {
                                breakIndex -= 1;
                            } else {
                                break;
                            }
                        }
                    } else {
                        while(breakIndex < wordLen){
                            truncWordWidth = this.measureText(word.substring(0, breakIndex));
                            if (truncWordWidth < width) {
                                breakIndex += 1;
                            } else {
                                breakIndex -= 1;
                                truncWordWidth = this.measureText(word.substring(0, breakIndex));
                                break;
                            }
                        }
                    }
                    return {
                        breakIndex: breakIndex,
                        truncWordWidth: truncWordWidth
                    };
                }
            },
            {
                key: "wordBreak",
                value: function wordBreak(word, width, baseFont) {
                    if (!word.text) {
                        return word;
                    }
                    this.applyFontStyle(word, baseFont);
                    var parts = [];
                    var text = word.text;
                    if (!word.letters) {
                        while(true){
                            var _this__getBreakIndex = this._getBreakIndex(text, width), breakIndex = _this__getBreakIndex.breakIndex, truncWordWidth = _this__getBreakIndex.truncWordWidth;
                            parts.push(_object_spread._({}, word));
                            parts[parts.length - 1].text = text.slice(0, breakIndex);
                            parts[parts.length - 1].width = truncWordWidth;
                            if (breakIndex === text.length) {
                                break;
                            }
                            text = text.slice(breakIndex);
                        }
                    } else {
                        var totalWidth = 0;
                        var letters = [];
                        var breakIndex1 = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = word.letters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var l = _step.value;
                                if (totalWidth + l.width >= width) {
                                    parts.push(_object_spread._({}, word));
                                    parts[parts.length - 1].text = text.slice(0, breakIndex1);
                                    parts[parts.length - 1].width = totalWidth;
                                    parts[parts.length - 1].letters = letters;
                                    text = text.slice(breakIndex1);
                                    totalWidth = 0;
                                    letters = [];
                                    breakIndex1 = 0;
                                } else {
                                    breakIndex1 += 1;
                                    letters.push(l);
                                    totalWidth += l.width;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (totalWidth > 0) {
                            parts.push(_object_spread._({}, word));
                            parts[parts.length - 1].text = text.slice(0, breakIndex1);
                            parts[parts.length - 1].width = totalWidth;
                            parts[parts.length - 1].letters = letters;
                        }
                    }
                    return parts;
                }
            },
            {
                key: "alignLine",
                value: function alignLine(parsed) {
                    var initialX = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                    var prevWidth = 0;
                    var prevX = initialX;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = parsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var word = _step.value;
                            if (word.text == "\n") {
                                continue;
                            }
                            word.x = prevX + prevWidth;
                            prevX = word.x;
                            prevWidth = word.width;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ]);
        return TextTextureRendererAdvanced;
    }();
    var TextTexture = /*#__PURE__*/ function(Texture) {
        _inherits._(TextTexture, Texture);
        var _super = _create_super._(TextTexture);
        function TextTexture(stage) {
            _class_call_check._(this, TextTexture);
            var _this;
            _this = _super.call(this, stage);
            _this._precision = _this.stage.getOption("precision");
            return _this;
        }
        _create_class._(TextTexture, [
            {
                key: "text",
                get: function get() {
                    return this._text;
                },
                set: function set(v) {
                    if (this._text !== v) {
                        this._text = "" + v;
                        this._changed();
                    }
                }
            },
            {
                key: "w",
                get: function get() {
                    return this._w;
                },
                set: function set(v) {
                    if (this._w !== v) {
                        this._w = v;
                        this._changed();
                    }
                }
            },
            {
                key: "h",
                get: function get() {
                    return this._h;
                },
                set: function set(v) {
                    if (this._h !== v) {
                        this._h = v;
                        this._changed();
                    }
                }
            },
            {
                key: "fontStyle",
                get: function get() {
                    return this._fontStyle;
                },
                set: function set(v) {
                    if (this._fontStyle !== v) {
                        this._fontStyle = v;
                        this._changed();
                    }
                }
            },
            {
                key: "fontBaselineRatio",
                get: function get() {
                    return this._fontBaselineRatio;
                },
                set: function set(v) {
                    if (this._fontBaselineRatio !== v) {
                        this._fontBaselineRatio = v;
                        this._changed();
                    }
                }
            },
            {
                key: "fontSize",
                get: function get() {
                    return this._fontSize;
                },
                set: function set(v) {
                    if (this._fontSize !== v) {
                        this._fontSize = v;
                        this._changed();
                    }
                }
            },
            {
                key: "fontFace",
                get: function get() {
                    return this._fontFace;
                },
                set: function set(v) {
                    if (this._fontFace !== v) {
                        this._fontFace = v;
                        this._changed();
                    }
                }
            },
            {
                key: "wordWrap",
                get: function get() {
                    return this._wordWrap;
                },
                set: function set(v) {
                    if (this._wordWrap !== v) {
                        this._wordWrap = v;
                        this._changed();
                    }
                }
            },
            {
                key: "wordWrapWidth",
                get: function get() {
                    return this._wordWrapWidth;
                },
                set: function set(v) {
                    if (this._wordWrapWidth !== v) {
                        this._wordWrapWidth = v;
                        this._changed();
                    }
                }
            },
            {
                key: "wordBreak",
                get: function get() {
                    return this._wordBreak;
                },
                set: function set(v) {
                    if (this._wordBreak !== v) {
                        this._wordBreak = v;
                        this._changed();
                    }
                }
            },
            {
                key: "textOverflow",
                get: function get() {
                    return this._textOverflow;
                },
                set: function set(v) {
                    if (v != this._textOverflow) {
                        this._textOverflow = v;
                        this._changed();
                    }
                }
            },
            {
                key: "lineHeight",
                get: function get() {
                    return this._lineHeight;
                },
                set: function set(v) {
                    if (this._lineHeight !== v) {
                        this._lineHeight = v;
                        this._changed();
                    }
                }
            },
            {
                key: "textBaseline",
                get: function get() {
                    return this._textBaseline;
                },
                set: function set(v) {
                    if (this._textBaseline !== v) {
                        this._textBaseline = v;
                        this._changed();
                    }
                }
            },
            {
                key: "textAlign",
                get: function get() {
                    return this._textAlign;
                },
                set: function set(v) {
                    if (this._textAlign !== v) {
                        this._textAlign = v;
                        this._changed();
                    }
                }
            },
            {
                key: "verticalAlign",
                get: function get() {
                    return this._verticalAlign;
                },
                set: function set(v) {
                    if (this._verticalAlign !== v) {
                        this._verticalAlign = v;
                        this._changed();
                    }
                }
            },
            {
                key: "offsetY",
                get: function get() {
                    return this._offsetY;
                },
                set: function set(v) {
                    if (this._offsetY !== v) {
                        this._offsetY = v;
                        this._changed();
                    }
                }
            },
            {
                key: "maxLines",
                get: function get() {
                    return this._maxLines;
                },
                set: function set(v) {
                    if (this._maxLines !== v) {
                        this._maxLines = v;
                        this._changed();
                    }
                }
            },
            {
                key: "maxLinesSuffix",
                get: function get() {
                    return this._maxLinesSuffix;
                },
                set: function set(v) {
                    if (this._maxLinesSuffix !== v) {
                        this._maxLinesSuffix = v;
                        this._changed();
                    }
                }
            },
            {
                key: "textColor",
                get: function get() {
                    return this._textColor;
                },
                set: function set(v) {
                    if (this._textColor !== v) {
                        this._textColor = v;
                        this._changed();
                    }
                }
            },
            {
                key: "paddingLeft",
                get: function get() {
                    return this._paddingLeft;
                },
                set: function set(v) {
                    if (this._paddingLeft !== v) {
                        this._paddingLeft = v;
                        this._changed();
                    }
                }
            },
            {
                key: "paddingRight",
                get: function get() {
                    return this._paddingRight;
                },
                set: function set(v) {
                    if (this._paddingRight !== v) {
                        this._paddingRight = v;
                        this._changed();
                    }
                }
            },
            {
                key: "shadow",
                get: function get() {
                    return this._shadow;
                },
                set: function set(v) {
                    if (this._shadow !== v) {
                        this._shadow = v;
                        this._changed();
                    }
                }
            },
            {
                key: "shadowColor",
                get: function get() {
                    return this._shadowColor;
                },
                set: function set(v) {
                    if (this._shadowColor !== v) {
                        this._shadowColor = v;
                        this._changed();
                    }
                }
            },
            {
                key: "shadowOffsetX",
                get: function get() {
                    return this._shadowOffsetX;
                },
                set: function set(v) {
                    if (this._shadowOffsetX !== v) {
                        this._shadowOffsetX = v;
                        this._changed();
                    }
                }
            },
            {
                key: "shadowOffsetY",
                get: function get() {
                    return this._shadowOffsetY;
                },
                set: function set(v) {
                    if (this._shadowOffsetY !== v) {
                        this._shadowOffsetY = v;
                        this._changed();
                    }
                }
            },
            {
                key: "shadowBlur",
                get: function get() {
                    return this._shadowBlur;
                },
                set: function set(v) {
                    if (this._shadowBlur !== v) {
                        this._shadowBlur = v;
                        this._changed();
                    }
                }
            },
            {
                key: "highlight",
                get: function get() {
                    return this._highlight;
                },
                set: function set(v) {
                    if (this._highlight !== v) {
                        this._highlight = v;
                        this._changed();
                    }
                }
            },
            {
                key: "highlightHeight",
                get: function get() {
                    return this._highlightHeight;
                },
                set: function set(v) {
                    if (this._highlightHeight !== v) {
                        this._highlightHeight = v;
                        this._changed();
                    }
                }
            },
            {
                key: "highlightColor",
                get: function get() {
                    return this._highlightColor;
                },
                set: function set(v) {
                    if (this._highlightColor !== v) {
                        this._highlightColor = v;
                        this._changed();
                    }
                }
            },
            {
                key: "highlightOffset",
                get: function get() {
                    return this._highlightOffset;
                },
                set: function set(v) {
                    if (this._highlightOffset !== v) {
                        this._highlightOffset = v;
                        this._changed();
                    }
                }
            },
            {
                key: "highlightPaddingLeft",
                get: function get() {
                    return this._highlightPaddingLeft;
                },
                set: function set(v) {
                    if (this._highlightPaddingLeft !== v) {
                        this._highlightPaddingLeft = v;
                        this._changed();
                    }
                }
            },
            {
                key: "highlightPaddingRight",
                get: function get() {
                    return this._highlightPaddingRight;
                },
                set: function set(v) {
                    if (this._highlightPaddingRight !== v) {
                        this._highlightPaddingRight = v;
                        this._changed();
                    }
                }
            },
            {
                key: "cutSx",
                get: function get() {
                    return this._cutSx;
                },
                set: function set(v) {
                    if (this._cutSx !== v) {
                        this._cutSx = v;
                        this._changed();
                    }
                }
            },
            {
                key: "cutEx",
                get: function get() {
                    return this._cutEx;
                },
                set: function set(v) {
                    if (this._cutEx !== v) {
                        this._cutEx = v;
                        this._changed();
                    }
                }
            },
            {
                key: "cutSy",
                get: function get() {
                    return this._cutSy;
                },
                set: function set(v) {
                    if (this._cutSy !== v) {
                        this._cutSy = v;
                        this._changed();
                    }
                }
            },
            {
                key: "cutEy",
                get: function get() {
                    return this._cutEy;
                },
                set: function set(v) {
                    if (this._cutEy !== v) {
                        this._cutEy = v;
                        this._changed();
                    }
                }
            },
            {
                key: "advancedRenderer",
                get: function get() {
                    return this._advancedRenderer;
                },
                set: function set(v) {
                    if (this._advancedRenderer !== v) {
                        this._advancedRenderer = v;
                        this._changed();
                    }
                }
            },
            {
                key: "letterSpacing",
                get: function get() {
                    return this._letterSpacing;
                },
                set: function set(v) {
                    if (this._letterSpacing !== v) {
                        this._letterSpacing = v;
                        this._changed();
                    }
                }
            },
            {
                key: "textIndent",
                get: function get() {
                    return this._textIndent;
                },
                set: function set(v) {
                    if (this._textIndent !== v) {
                        this._textIndent = v;
                        this._changed();
                    }
                }
            },
            {
                key: "precision",
                get: function get() {
                    return _get._(_get_prototype_of._(TextTexture.prototype), "precision", this);
                },
                set: function set(v) {
                    if (this.precision !== v) {
                        _set._(_get_prototype_of._(TextTexture.prototype), "precision", v, this, true);
                        this._changed();
                    }
                }
            },
            {
                key: "_getIsValid",
                value: function _getIsValid() {
                    return !!this.text;
                }
            },
            {
                key: "_getLookupId",
                value: function _getLookupId() {
                    var parts = [];
                    if (this.w !== 0) parts.push("w " + this.w);
                    if (this.h !== 0) parts.push("h " + this.h);
                    if (this.fontStyle !== "normal") parts.push("fS" + this.fontStyle);
                    if (this.fontSize !== 40) parts.push("fs" + this.fontSize);
                    if (this.fontBaselineRatio !== 0) parts.push("fb" + this.fontBaselineRatio);
                    if (this.fontFace !== null) parts.push("ff" + (Array.isArray(this.fontFace) ? this.fontFace.join(",") : this.fontFace));
                    if (this.wordWrap !== true) parts.push("wr" + (this.wordWrap ? 1 : 0));
                    if (this.wordWrapWidth !== 0) parts.push("ww" + this.wordWrapWidth);
                    if (this.wordBreak !== false) parts.push("wb" + this.wordBreak ? 1 : 0);
                    if (this.textOverflow != "") parts.push("to" + this.textOverflow);
                    if (this.lineHeight !== null) parts.push("lh" + this.lineHeight);
                    if (this.textBaseline !== "alphabetic") parts.push("tb" + this.textBaseline);
                    if (this.textAlign !== "left") parts.push("ta" + this.textAlign);
                    if (this.verticalAlign !== "top") parts.push("va" + this.verticalAlign);
                    if (this.offsetY !== null) parts.push("oy" + this.offsetY);
                    if (this.maxLines !== 0) parts.push("ml" + this.maxLines);
                    if (this.maxLinesSuffix !== "..") parts.push("ms" + this.maxLinesSuffix);
                    parts.push("pc" + this.precision);
                    if (this.textColor !== 0xffffffff) parts.push("co" + this.textColor.toString(16));
                    if (this.paddingLeft !== 0) parts.push("pl" + this.paddingLeft);
                    if (this.paddingRight !== 0) parts.push("pr" + this.paddingRight);
                    if (this.shadow !== false) parts.push("sh" + (this.shadow ? 1 : 0));
                    if (this.shadowColor !== 0xff000000) parts.push("sc" + this.shadowColor.toString(16));
                    if (this.shadowOffsetX !== 0) parts.push("sx" + this.shadowOffsetX);
                    if (this.shadowOffsetY !== 0) parts.push("sy" + this.shadowOffsetY);
                    if (this.shadowBlur !== 5) parts.push("sb" + this.shadowBlur);
                    if (this.highlight !== false) parts.push("hL" + (this.highlight ? 1 : 0));
                    if (this.highlightHeight !== 0) parts.push("hh" + this.highlightHeight);
                    if (this.highlightColor !== 0xff000000) parts.push("hc" + this.highlightColor.toString(16));
                    if (this.highlightOffset !== null) parts.push("ho" + this.highlightOffset);
                    if (this.highlightPaddingLeft !== null) parts.push("hl" + this.highlightPaddingLeft);
                    if (this.highlightPaddingRight !== null) parts.push("hr" + this.highlightPaddingRight);
                    if (this.letterSpacing !== null) parts.push("ls" + this.letterSpacing);
                    if (this.textIndent !== null) parts.push("ti" + this.textIndent);
                    if (this.cutSx) parts.push("csx" + this.cutSx);
                    if (this.cutEx) parts.push("cex" + this.cutEx);
                    if (this.cutSy) parts.push("csy" + this.cutSy);
                    if (this.cutEy) parts.push("cey" + this.cutEy);
                    if (this.advancedRenderer) parts.push("aR" + this.advancedRenderer ? 1 : 0);
                    var id = "TX$" + parts.join("|") + ":" + this.text;
                    return id;
                }
            },
            {
                key: "_getSourceLoader",
                value: function _getSourceLoader() {
                    var args = this.cloneArgs();
                    var gl = this.stage.gl;
                    return function(cb) {
                        var _this = this;
                        var canvas = this.stage.platform.getDrawingCanvas();
                        var renderer = args.advancedRenderer ? new TextTextureRendererAdvanced(this.stage, canvas, args) : new TextTextureRenderer(this.stage, canvas, args);
                        var p = renderer.draw();
                        var texParams = {};
                        var sharpCfg = this.stage.getOption("fontSharp");
                        var sharpen = false;
                        if (Utils.isBoolean(sharpCfg)) {
                            sharpen = sharpCfg;
                        } else if (Utils.isObject(sharpCfg)) {
                            var precision = this.stage.getRenderPrecision();
                            sharpen = precision <= sharpCfg.precision && args.fontSize <= sharpCfg.fontSize;
                        }
                        if (gl && sharpen) {
                            texParams[gl.TEXTURE_MAG_FILTER] = gl.NEAREST;
                        }
                        if (p) {
                            p.then(function() {
                                cb(null, Object.assign({
                                    renderInfo: renderer.renderInfo,
                                    throttle: false,
                                    texParams: texParams
                                }, _this.stage.platform.getTextureOptionsForDrawingCanvas(canvas)));
                            }).catch(function(err) {
                                cb(err);
                            });
                        } else {
                            cb(null, Object.assign({
                                renderInfo: renderer.renderInfo,
                                throttle: false,
                                texParams: texParams
                            }, this.stage.platform.getTextureOptionsForDrawingCanvas(canvas)));
                        }
                    };
                }
            },
            {
                key: "getNonDefaults",
                value: function getNonDefaults() {
                    var nonDefaults = _get._(_get_prototype_of._(TextTexture.prototype), "getNonDefaults", this).call(this);
                    if (this.text !== "") nonDefaults["text"] = this.text;
                    if (this.w !== 0) nonDefaults["w"] = this.w;
                    if (this.h !== 0) nonDefaults["h"] = this.h;
                    if (this.fontStyle !== "normal") nonDefaults["fontStyle"] = this.fontStyle;
                    if (this.fontSize !== 40) nonDefaults["fontSize"] = this.fontSize;
                    if (this.fontBaselineRatio !== 0) nonDefaults["fontBaselineRatio"] = this.fontBaselineRatio;
                    if (this.fontFace !== null) nonDefaults["fontFace"] = this.fontFace;
                    if (this.wordWrap !== true) nonDefaults["wordWrap"] = this.wordWrap;
                    if (this.wordWrapWidth !== 0) nonDefaults["wordWrapWidth"] = this.wordWrapWidth;
                    if (this.wordBreak !== false) nonDefaults["wordBreak"] = this.wordBreak;
                    if (this.textOverflow != "") nonDefaults["textOverflow"] = this.textOverflow;
                    if (this.lineHeight !== null) nonDefaults["lineHeight"] = this.lineHeight;
                    if (this.textBaseline !== "alphabetic") nonDefaults["textBaseline"] = this.textBaseline;
                    if (this.textAlign !== "left") nonDefaults["textAlign"] = this.textAlign;
                    if (this.verticalAlign !== "top") nonDefaults["verticalAlign"] = this.verticalAlign;
                    if (this.offsetY !== null) nonDefaults["offsetY"] = this.offsetY;
                    if (this.maxLines !== 0) nonDefaults["maxLines"] = this.maxLines;
                    if (this.maxLinesSuffix !== "..") nonDefaults["maxLinesSuffix"] = this.maxLinesSuffix;
                    if (this.precision !== this.stage.getOption("precision")) nonDefaults["precision"] = this.precision;
                    if (this.textColor !== 0xffffffff) nonDefaults["textColor"] = this.textColor;
                    if (this.paddingLeft !== 0) nonDefaults["paddingLeft"] = this.paddingLeft;
                    if (this.paddingRight !== 0) nonDefaults["paddingRight"] = this.paddingRight;
                    if (this.shadow !== false) nonDefaults["shadow"] = this.shadow;
                    if (this.shadowColor !== 0xff000000) nonDefaults["shadowColor"] = this.shadowColor;
                    if (this.shadowOffsetX !== 0) nonDefaults["shadowOffsetX"] = this.shadowOffsetX;
                    if (this.shadowOffsetY !== 0) nonDefaults["shadowOffsetY"] = this.shadowOffsetY;
                    if (this.shadowBlur !== 5) nonDefaults["shadowBlur"] = this.shadowBlur;
                    if (this.highlight !== false) nonDefaults["highlight"] = this.highlight;
                    if (this.highlightHeight !== 0) nonDefaults["highlightHeight"] = this.highlightHeight;
                    if (this.highlightColor !== 0xff000000) nonDefaults["highlightColor"] = this.highlightColor;
                    if (this.highlightOffset !== 0) nonDefaults["highlightOffset"] = this.highlightOffset;
                    if (this.highlightPaddingLeft !== 0) nonDefaults["highlightPaddingLeft"] = this.highlightPaddingLeft;
                    if (this.highlightPaddingRight !== 0) nonDefaults["highlightPaddingRight"] = this.highlightPaddingRight;
                    if (this.letterSpacing !== 0) nonDefaults["letterSpacing"] = this.letterSpacing;
                    if (this.textIndent !== 0) nonDefaults["textIndent"] = this.textIndent;
                    if (this.cutSx) nonDefaults["cutSx"] = this.cutSx;
                    if (this.cutEx) nonDefaults["cutEx"] = this.cutEx;
                    if (this.cutSy) nonDefaults["cutSy"] = this.cutSy;
                    if (this.cutEy) nonDefaults["cutEy"] = this.cutEy;
                    if (this.advancedRenderer) nonDefaults["renderer"] = this.advancedRenderer;
                    return nonDefaults;
                }
            },
            {
                key: "cloneArgs",
                value: function cloneArgs() {
                    var obj = {};
                    obj.text = this._text;
                    obj.w = this._w;
                    obj.h = this._h;
                    obj.fontStyle = this._fontStyle;
                    obj.fontSize = this._fontSize;
                    obj.fontBaselineRatio = this._fontBaselineRatio;
                    obj.fontFace = this._fontFace;
                    obj.wordWrap = this._wordWrap;
                    obj.wordWrapWidth = this._wordWrapWidth;
                    obj.wordBreak = this._wordBreak;
                    obj.textOverflow = this._textOverflow;
                    obj.lineHeight = this._lineHeight;
                    obj.textBaseline = this._textBaseline;
                    obj.textAlign = this._textAlign;
                    obj.verticalAlign = this._verticalAlign;
                    obj.offsetY = this._offsetY;
                    obj.maxLines = this._maxLines;
                    obj.maxLinesSuffix = this._maxLinesSuffix;
                    obj.precision = this._precision;
                    obj.textColor = this._textColor;
                    obj.paddingLeft = this._paddingLeft;
                    obj.paddingRight = this._paddingRight;
                    obj.shadow = this._shadow;
                    obj.shadowColor = this._shadowColor;
                    obj.shadowOffsetX = this._shadowOffsetX;
                    obj.shadowOffsetY = this._shadowOffsetY;
                    obj.shadowBlur = this._shadowBlur;
                    obj.highlight = this._highlight;
                    obj.highlightHeight = this._highlightHeight;
                    obj.highlightColor = this._highlightColor;
                    obj.highlightOffset = this._highlightOffset;
                    obj.highlightPaddingLeft = this._highlightPaddingLeft;
                    obj.highlightPaddingRight = this._highlightPaddingRight;
                    obj.letterSpacing = this._letterSpacing;
                    obj.textIndent = this._textIndent;
                    obj.cutSx = this._cutSx;
                    obj.cutEx = this._cutEx;
                    obj.cutSy = this._cutSy;
                    obj.cutEy = this._cutEy;
                    obj.advancedRenderer = this._advancedRenderer;
                    return obj;
                }
            }
        ], [
            {
                key: "renderer",
                value: function renderer(stage, canvas, settings) {
                    if (this.advancedRenderer) {
                        return new TextTextureRendererAdvanced(stage, canvas, settings);
                    } else {
                        return new TextTextureRenderer(stage, canvas, settings);
                    }
                }
            }
        ]);
        return TextTexture;
    }(Texture);
    var proto = TextTexture.prototype;
    proto._text = "";
    proto._w = 0;
    proto._h = 0;
    proto._fontStyle = "normal";
    proto._fontSize = 40;
    proto._fontFace = null;
    proto._wordWrap = true;
    proto._wordWrapWidth = 0;
    proto._wordBreak = false;
    proto._textOverflow = "";
    proto._lineHeight = null;
    proto._textBaseline = "alphabetic";
    proto._textAlign = "left";
    proto._verticalAlign = "top";
    proto._offsetY = null;
    proto._maxLines = 0;
    proto._maxLinesSuffix = "..";
    proto._textColor = 0xFFFFFFFF;
    proto._paddingLeft = 0;
    proto._paddingRight = 0;
    proto._shadow = false;
    proto._shadowColor = 0xFF000000;
    proto._shadowOffsetX = 0;
    proto._shadowOffsetY = 0;
    proto._shadowBlur = 5;
    proto._highlight = false;
    proto._highlightHeight = 0;
    proto._highlightColor = 0xFF000000;
    proto._highlightOffset = 0;
    proto._highlightPaddingLeft = 0;
    proto._highlightPaddingRight = 0;
    proto._letterSpacing = 0;
    proto._textIndent = 0;
    proto._cutSx = 0;
    proto._cutEx = 0;
    proto._cutSy = 0;
    proto._cutEy = 0;
    proto._advancedRenderer = false;
    proto._fontBaselineRatio = 0;
    var SourceTexture = /*#__PURE__*/ function(Texture) {
        _inherits._(SourceTexture, Texture);
        var _super = _create_super._(SourceTexture);
        function SourceTexture(stage) {
            _class_call_check._(this, SourceTexture);
            var _this;
            _this = _super.call(this, stage);
            _this._textureSource = undefined;
            return _this;
        }
        _create_class._(SourceTexture, [
            {
                key: "textureSource",
                get: function get() {
                    return this._textureSource;
                },
                set: function set(v) {
                    if (v !== this._textureSource) {
                        if (v.isResultTexture) {
                            this._precision = this.stage.getRenderPrecision();
                        }
                        this._textureSource = v;
                        this._changed();
                    }
                }
            },
            {
                key: "_getTextureSource",
                value: function _getTextureSource() {
                    return this._textureSource;
                }
            }
        ]);
        return SourceTexture;
    }(Texture);
    var Transition = /*#__PURE__*/ function(EventEmitter) {
        _inherits._(Transition, EventEmitter);
        var _super = _create_super._(Transition);
        function Transition(manager, settings, element, property) {
            _class_call_check._(this, Transition);
            var _this;
            _this = _super.call(this);
            _this.manager = manager;
            _this._settings = settings;
            _this._element = element;
            _this._getter = element.constructor.getGetter(property);
            _this._setter = element.constructor.getSetter(property);
            _this._merger = settings.merger;
            if (!_this._merger) {
                _this._merger = element.constructor.getMerger(property);
            }
            _this._startValue = _this._getter(_this._element);
            _this._targetValue = _this._startValue;
            _this._p = 1;
            _this._delayLeft = 0;
            return _this;
        }
        _create_class._(Transition, [
            {
                key: "start",
                value: function start(targetValue) {
                    this._startValue = this._getter(this._element);
                    if (!this.isAttached()) {
                        this._targetValue = targetValue;
                        this._p = 1;
                        this._updateDrawValue();
                    } else {
                        if (targetValue === this._startValue) {
                            this.reset(targetValue, 1);
                        } else {
                            this._targetValue = targetValue;
                            this._p = 0;
                            this._delayLeft = this._settings.delay;
                            this.emit("start");
                            this.add();
                        }
                    }
                }
            },
            {
                key: "finish",
                value: function finish() {
                    if (this._p < 1) {
                        this._p = 1;
                    }
                }
            },
            {
                key: "stop",
                value: function stop() {
                    this.emit("stop");
                    this.manager.removeActive(this);
                }
            },
            {
                key: "pause",
                value: function pause() {
                    this.stop();
                }
            },
            {
                key: "play",
                value: function play() {
                    this.manager.addActive(this);
                }
            },
            {
                key: "reset",
                value: function reset(targetValue, p) {
                    if (!this.isAttached()) {
                        this._startValue = this._getter(this._element);
                        this._targetValue = targetValue;
                        this._p = 1;
                        this._updateDrawValue();
                    } else {
                        this._startValue = this._getter(this._element);
                        this._targetValue = targetValue;
                        this._p = p;
                        this.add();
                    }
                }
            },
            {
                key: "_updateDrawValue",
                value: function _updateDrawValue() {
                    this._setter(this._element, this.getDrawValue());
                }
            },
            {
                key: "add",
                value: function add() {
                    this.manager.addActive(this);
                }
            },
            {
                key: "isAttached",
                value: function isAttached() {
                    return this._element.attached;
                }
            },
            {
                key: "isRunning",
                value: function isRunning() {
                    return this._p < 1.0;
                }
            },
            {
                key: "progress",
                value: function progress(dt) {
                    if (!this.isAttached()) {
                        this._p = 1;
                    }
                    if (this.p < 1) {
                        if (this.delayLeft > 0) {
                            this._delayLeft -= dt;
                            if (this.delayLeft < 0) {
                                dt = -this.delayLeft;
                                this._delayLeft = 0;
                                this.emit("delayEnd");
                            } else {
                                return;
                            }
                        }
                        if (this._settings.duration == 0) {
                            this._p = 1;
                        } else {
                            this._p += dt / this._settings.duration;
                        }
                        if (this._p >= 1) {
                            this._p = 1;
                        }
                    }
                    this._updateDrawValue();
                    this.invokeListeners();
                }
            },
            {
                key: "invokeListeners",
                value: function invokeListeners() {
                    this.emit("progress", this.p);
                    if (this.p === 1) {
                        this.emit("finish");
                    }
                }
            },
            {
                key: "updateTargetValue",
                value: function updateTargetValue(targetValue) {
                    var t = this._settings.timingFunctionImpl(this.p);
                    if (t === 1) {
                        this._targetValue = targetValue;
                    } else if (t === 0) {
                        this._startValue = this._targetValue;
                        this._targetValue = targetValue;
                    } else {
                        this._startValue = targetValue - (targetValue - this._targetValue) / (1 - t);
                        this._targetValue = targetValue;
                    }
                }
            },
            {
                key: "getDrawValue",
                value: function getDrawValue() {
                    if (this.p >= 1) {
                        return this.targetValue;
                    } else {
                        var v = this._settings._timingFunctionImpl(this.p);
                        return this._merger(this.targetValue, this.startValue, v);
                    }
                }
            },
            {
                key: "skipDelay",
                value: function skipDelay() {
                    this._delayLeft = 0;
                }
            },
            {
                key: "startValue",
                get: function get() {
                    return this._startValue;
                }
            },
            {
                key: "targetValue",
                get: function get() {
                    return this._targetValue;
                }
            },
            {
                key: "p",
                get: function get() {
                    return this._p;
                }
            },
            {
                key: "delayLeft",
                get: function get() {
                    return this._delayLeft;
                }
            },
            {
                key: "element",
                get: function get() {
                    return this._element;
                }
            },
            {
                key: "settings",
                get: function get() {
                    return this._settings;
                },
                set: function set(v) {
                    this._settings = v;
                }
            }
        ]);
        return Transition;
    }(EventEmitter);
    Transition.prototype.isTransition = true;
    var ObjectList = /*#__PURE__*/ function() {
        function ObjectList() {
            _class_call_check._(this, ObjectList);
            this._items = [];
            this._refs = {};
        }
        _create_class._(ObjectList, [
            {
                key: "get",
                value: function get() {
                    return this._items;
                }
            },
            {
                key: "first",
                get: function get() {
                    return this._items[0];
                }
            },
            {
                key: "last",
                get: function get() {
                    return this._items.length ? this._items[this._items.length - 1] : undefined;
                }
            },
            {
                key: "add",
                value: function add(item) {
                    this.addAt(item, this._items.length);
                }
            },
            {
                key: "addAt",
                value: function addAt(item, index) {
                    if (index >= 0 && index <= this._items.length) {
                        var currentIndex = this._items.indexOf(item);
                        if (currentIndex === index) {
                            return item;
                        }
                        if (Utils.isObjectLiteral(item)) {
                            var o = item;
                            item = this.createItem(o);
                            item.patch(o);
                        }
                        if (currentIndex != -1) {
                            this.setAt(item, index);
                        } else {
                            if (item.ref) {
                                this._refs[item.ref] = item;
                            }
                            this._items.splice(index, 0, item);
                            this.onAdd(item, index);
                        }
                    } else {
                        throw new Error("addAt: The index " + index + " is out of bounds " + this._items.length);
                    }
                }
            },
            {
                key: "replaceByRef",
                value: function replaceByRef(item) {
                    if (item.ref) {
                        var existingItem = this.getByRef(item.ref);
                        if (!existingItem) {
                            throw new Error("replaceByRef: no item found with reference: " + item.ref);
                        }
                        this.replace(item, existingItem);
                    } else {
                        throw new Error("replaceByRef: no ref specified in item");
                    }
                    this.addAt(item, this._items.length);
                }
            },
            {
                key: "replace",
                value: function replace(item, prevItem) {
                    var index = this.getIndex(prevItem);
                    if (index === -1) {
                        throw new Error("replace: The previous item does not exist");
                    }
                    this.setAt(item, index);
                }
            },
            {
                key: "setAt",
                value: function setAt(item, index) {
                    if (index >= 0 && index < this._items.length) {
                        if (Utils.isObjectLiteral(item)) {
                            var o = item;
                            item = this.createItem(o);
                            item.patch(o);
                        }
                        var currentIndex = this._items.indexOf(item);
                        if (currentIndex != -1) {
                            if (currentIndex !== index) {
                                var fromIndex = currentIndex;
                                if (fromIndex !== index) {
                                    this._items.splice(fromIndex, 1);
                                    this._items.splice(index, 0, item);
                                    this.onMove(item, fromIndex, index);
                                }
                            }
                        } else {
                            if (index < this._items.length) {
                                if (this._items[index].ref) {
                                    this._refs[this._items[index].ref] = undefined;
                                }
                            }
                            var prevItem = this._items[index];
                            this._items[index] = item;
                            if (item.ref) {
                                this._refs[item.ref] = item;
                            }
                            this.onSet(item, index, prevItem);
                        }
                    } else {
                        throw new Error("setAt: The index " + index + " is out of bounds " + this._items.length);
                    }
                }
            },
            {
                key: "getAt",
                value: function getAt(index) {
                    return this._items[index];
                }
            },
            {
                key: "getIndex",
                value: function getIndex(item) {
                    return this._items.indexOf(item);
                }
            },
            {
                key: "remove",
                value: function remove(item) {
                    var index = this._items.indexOf(item);
                    if (index !== -1) {
                        this.removeAt(index);
                    }
                }
            },
            {
                key: "removeAt",
                value: function removeAt(index) {
                    if (index >= 0 && index < this._items.length) {
                        var item = this._items[index];
                        if (item.ref) {
                            this._refs[item.ref] = undefined;
                        }
                        this._items.splice(index, 1);
                        this.onRemove(item, index);
                        return item;
                    } else {
                        throw new Error("removeAt: The index ".concat(index, " is out of bounds ").concat(this._items.length - 1));
                    }
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var n = this._items.length;
                    if (n) {
                        var prev = this._items;
                        this._items = [];
                        this._refs = {};
                        this.onSync(prev, [], []);
                    }
                }
            },
            {
                key: "a",
                value: function a(o) {
                    if (Utils.isObjectLiteral(o)) {
                        var c = this.createItem(o);
                        c.patch(o);
                        this.add(c);
                        return c;
                    } else if (Array.isArray(o)) {
                        for(var i = 0, n = o.length; i < n; i++){
                            this.a(o[i]);
                        }
                        return null;
                    } else if (this.isItem(o)) {
                        this.add(o);
                        return o;
                    }
                }
            },
            {
                key: "length",
                get: function get() {
                    return this._items.length;
                }
            },
            {
                key: "_getRefs",
                value: function _getRefs() {
                    return this._refs;
                }
            },
            {
                key: "getByRef",
                value: function getByRef(ref) {
                    return this._refs[ref];
                }
            },
            {
                key: "clearRef",
                value: function clearRef(ref) {
                    delete this._refs[ref];
                }
            },
            {
                key: "setRef",
                value: function setRef(ref, child) {
                    this._refs[ref] = child;
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    if (Utils.isObjectLiteral(settings)) {
                        this._setByObject(settings);
                    } else if (Array.isArray(settings)) {
                        this._setByArray(settings);
                    }
                }
            },
            {
                key: "_setByObject",
                value: function _setByObject(settings) {
                    var refs = this._getRefs();
                    var crefs = Object.keys(settings);
                    for(var i = 0, n = crefs.length; i < n; i++){
                        var cref = crefs[i];
                        var s = settings[cref];
                        var c = refs[cref];
                        if (!c) {
                            if (this.isItem(s)) {
                                s.ref = cref;
                                this.add(s);
                            } else {
                                c = this.createItem(s);
                                c.ref = cref;
                                c.patch(s);
                                this.add(c);
                            }
                        } else {
                            if (this.isItem(s)) {
                                if (c !== s) {
                                    var idx = this.getIndex(c);
                                    s.ref = cref;
                                    this.setAt(s, idx);
                                }
                            } else {
                                c.patch(s);
                            }
                        }
                    }
                }
            },
            {
                key: "_equalsArray",
                value: function _equalsArray(array) {
                    var same = true;
                    if (array.length === this._items.length) {
                        for(var i = 0, n = this._items.length; i < n && same; i++){
                            same = same && this._items[i] === array[i];
                        }
                    } else {
                        same = false;
                    }
                    return same;
                }
            },
            {
                key: "_setByArray",
                value: function _setByArray(array) {
                    if (this._equalsArray(array)) {
                        return;
                    }
                    for(var i = 0, n = this._items.length; i < n; i++){
                        this._items[i].marker = true;
                    }
                    var refs;
                    var newItems = [];
                    for(var i1 = 0, n1 = array.length; i1 < n1; i1++){
                        var s = array[i1];
                        if (this.isItem(s)) {
                            s.marker = false;
                            newItems.push(s);
                        } else {
                            var cref = s.ref;
                            var c = void 0;
                            if (cref) {
                                if (!refs) refs = this._getRefs();
                                c = refs[cref];
                            }
                            if (!c) {
                                c = this.createItem(s);
                            } else {
                                c.marker = false;
                            }
                            if (Utils.isObjectLiteral(s)) {
                                c.patch(s);
                            }
                            newItems.push(c);
                        }
                    }
                    this._setItems(newItems);
                }
            },
            {
                key: "_setItems",
                value: function _setItems(newItems) {
                    var prevItems = this._items;
                    this._items = newItems;
                    var removed = prevItems.filter(function(item) {
                        var m = item.marker;
                        delete item.marker;
                        return m;
                    });
                    var added = newItems.filter(function(item) {
                        return prevItems.indexOf(item) === -1;
                    });
                    if (removed.length || added.length) {
                        this._refs = {};
                        for(var i = 0, n = this._items.length; i < n; i++){
                            var ref = this._items[i].ref;
                            if (ref) {
                                this._refs[ref] = this._items[i];
                            }
                        }
                    }
                    this.onSync(removed, added, newItems);
                }
            },
            {
                key: "sort",
                value: function sort(f) {
                    var items = this._items.slice();
                    items.sort(f);
                    this._setByArray(items);
                }
            },
            {
                key: "onAdd",
                value: function onAdd(item, index) {}
            },
            {
                key: "onRemove",
                value: function onRemove(item, index) {}
            },
            {
                key: "onSync",
                value: function onSync(removed, added, order) {}
            },
            {
                key: "onSet",
                value: function onSet(item, index, prevItem) {}
            },
            {
                key: "onMove",
                value: function onMove(item, fromIndex, toIndex) {}
            },
            {
                key: "createItem",
                value: function createItem(object) {
                    throw new Error("ObjectList.createItem must create and return a new object");
                }
            },
            {
                key: "isItem",
                value: function isItem(object) {
                    return false;
                }
            },
            {
                key: "forEach",
                value: function forEach(f) {
                    this.get().forEach(f);
                }
            }
        ]);
        return ObjectList;
    }();
    var ElementChildList = /*#__PURE__*/ function(ObjectList) {
        _inherits._(ElementChildList, ObjectList);
        var _super = _create_super._(ElementChildList);
        function ElementChildList(element) {
            _class_call_check._(this, ElementChildList);
            var _this;
            _this = _super.call(this);
            _this._element = element;
            return _this;
        }
        _create_class._(ElementChildList, [
            {
                key: "_connectParent",
                value: function _connectParent(item) {
                    var prevParent = item.parent;
                    if (prevParent && prevParent !== this._element) {
                        var prevChildList = item.parent.childList;
                        var index = prevChildList.getIndex(item);
                        if (item.ref) {
                            prevChildList._refs[item.ref] = undefined;
                        }
                        prevChildList._items.splice(index, 1);
                        prevParent.core.removeChildAt(index);
                    }
                    item._setParent(this._element);
                }
            },
            {
                key: "onAdd",
                value: function onAdd(item, index) {
                    this._connectParent(item);
                    this._element.core.addChildAt(index, item.core);
                }
            },
            {
                key: "onRemove",
                value: function onRemove(item, index) {
                    item._setParent(null);
                    this._element.core.removeChildAt(index);
                }
            },
            {
                key: "onSync",
                value: function onSync(removed, added, order) {
                    for(var i = 0, n = removed.length; i < n; i++){
                        removed[i]._setParent(null);
                    }
                    for(var i1 = 0, n1 = added.length; i1 < n1; i1++){
                        this._connectParent(added[i1]);
                    }
                    var gc = function(i) {
                        return i.core;
                    };
                    this._element.core.syncChildren(removed.map(gc), added.map(gc), order.map(gc));
                }
            },
            {
                key: "onSet",
                value: function onSet(item, index, prevItem) {
                    prevItem._setParent(null);
                    this._connectParent(item);
                    this._element.core.setChildAt(index, item.core);
                }
            },
            {
                key: "onMove",
                value: function onMove(item, fromIndex, toIndex) {
                    this._element.core.moveChild(fromIndex, toIndex);
                }
            },
            {
                key: "createItem",
                value: function createItem(object) {
                    if (object.type) {
                        return new object.type(this._element.stage);
                    } else {
                        return this._element.stage.createElement();
                    }
                }
            },
            {
                key: "isItem",
                value: function isItem(object) {
                    return object.isElement;
                }
            }
        ]);
        return ElementChildList;
    }(ObjectList);
    var Element = /*#__PURE__*/ function() {
        function Element(stage) {
            _class_call_check._(this, Element);
            this.stage = stage;
            this.__id = Element.id++;
            this.__start();
            this._hasEventListeners = false;
            this.__core = new ElementCore(this);
            this.__ref = null;
            this.__attached = false;
            this.__enabled = false;
            this.__active = false;
            this.__parent = null;
            this.__texture = null;
            this.__displayedTexture = null;
            this.__tags = null;
            this.__treeTags = null;
            this.__tagRoot = false;
            this.__childList = null;
            this._w = 0;
            this._h = 0;
        }
        _create_class._(Element, [
            {
                key: "__start",
                value: function __start() {}
            },
            {
                key: "id",
                get: function get() {
                    return this.__id;
                }
            },
            {
                key: "ref",
                get: function get() {
                    return this.__ref;
                },
                set: function set(ref) {
                    if (this.__ref !== ref) {
                        var charcode = ref.charCodeAt(0);
                        if (!Utils.isUcChar(charcode)) {
                            this._throwError("Ref must start with an upper case character: " + ref);
                        }
                        if (this.__ref !== null) {
                            this.removeTag(this.__ref);
                            if (this.__parent) {
                                this.__parent.__childList.clearRef(this.__ref);
                            }
                        }
                        this.__ref = ref;
                        if (this.__ref) {
                            this._addTag(this.__ref);
                            if (this.__parent) {
                                this.__parent.__childList.setRef(this.__ref, this);
                            }
                        }
                    }
                }
            },
            {
                key: "core",
                get: function get() {
                    return this.__core;
                }
            },
            {
                key: "setAsRoot",
                value: function setAsRoot() {
                    this.__core.setAsRoot();
                    this._updateAttachedFlag();
                    this._updateEnabledFlag();
                }
            },
            {
                key: "isRoot",
                get: function get() {
                    return this.__core.isRoot;
                }
            },
            {
                key: "_setParent",
                value: function _setParent(parent) {
                    if (this.__parent === parent) return;
                    if (this.__parent) {
                        this._unsetTagsParent();
                    }
                    this.__parent = parent;
                    if (parent) {
                        this._setTagsParent();
                    }
                    this._updateAttachedFlag();
                    this._updateEnabledFlag();
                    this._updateCollision();
                    if (this.isRoot && parent) {
                        this._throwError("Root should not be added as a child! Results are unspecified!");
                    }
                }
            },
            {
                key: "getDepth",
                value: function getDepth() {
                    var depth = 0;
                    var p = this.__parent;
                    while(p){
                        depth++;
                        p = p.__parent;
                    }
                    return depth;
                }
            },
            {
                key: "getAncestor",
                value: function getAncestor(l) {
                    var p = this;
                    while(l > 0 && p.__parent){
                        p = p.__parent;
                        l--;
                    }
                    return p;
                }
            },
            {
                key: "getAncestors",
                value: function getAncestors() {
                    var a = [];
                    var p = this;
                    while(p){
                        a.push(p);
                        p = p.__parent;
                    }
                    return a;
                }
            },
            {
                key: "getAncestorAtDepth",
                value: function getAncestorAtDepth(depth) {
                    var levels = this.getDepth() - depth;
                    if (levels < 0) {
                        return null;
                    }
                    return this.getAncestor(levels);
                }
            },
            {
                key: "isAncestorOf",
                value: function isAncestorOf(c) {
                    var p = c;
                    while(p = p.parent){
                        if (this === p) {
                            return true;
                        }
                    }
                    return false;
                }
            },
            {
                key: "getSharedAncestor",
                value: function getSharedAncestor(c) {
                    var o1 = this;
                    var o2 = c;
                    var l1 = o1.getDepth();
                    var l2 = o2.getDepth();
                    if (l1 > l2) {
                        o1 = o1.getAncestor(l1 - l2);
                    } else if (l2 > l1) {
                        o2 = o2.getAncestor(l2 - l1);
                    }
                    do {
                        if (o1 === o2) {
                            return o1;
                        }
                        o1 = o1.__parent;
                        o2 = o2.__parent;
                    }while (o1 && o2);
                    return null;
                }
            },
            {
                key: "attached",
                get: function get() {
                    return this.__attached;
                }
            },
            {
                key: "enabled",
                get: function get() {
                    return this.__enabled;
                }
            },
            {
                key: "active",
                get: function get() {
                    return this.__active;
                }
            },
            {
                key: "_isAttached",
                value: function _isAttached() {
                    return this.__parent ? this.__parent.__attached : this.stage.root === this;
                }
            },
            {
                key: "_isEnabled",
                value: function _isEnabled() {
                    return this.__core.visible && this.__core.alpha > 0 && (this.__parent ? this.__parent.__enabled : this.stage.root === this);
                }
            },
            {
                key: "_isActive",
                value: function _isActive() {
                    return this._isEnabled() && this.withinBoundsMargin;
                }
            },
            {
                key: "_updateAttachedFlag",
                value: function _updateAttachedFlag() {
                    var newAttached = this._isAttached();
                    if (this.__attached !== newAttached) {
                        this.__attached = newAttached;
                        if (newAttached) {
                            this._onSetup();
                        }
                        var children = this._children.get();
                        if (children) {
                            var m = children.length;
                            if (m > 0) {
                                for(var i = 0; i < m; i++){
                                    children[i]._updateAttachedFlag();
                                }
                            }
                        }
                        if (newAttached) {
                            this._onAttach();
                        } else {
                            this._onDetach();
                        }
                    }
                }
            },
            {
                key: "_updateEnabledFlag",
                value: function _updateEnabledFlag() {
                    var newEnabled = this._isEnabled();
                    if (this.__enabled !== newEnabled) {
                        if (newEnabled) {
                            this._onEnabled();
                            this._setEnabledFlag();
                        } else {
                            this._onDisabled();
                            this._unsetEnabledFlag();
                        }
                        var children = this._children.get();
                        if (children) {
                            var m = children.length;
                            if (m > 0) {
                                for(var i = 0; i < m; i++){
                                    children[i]._updateEnabledFlag();
                                }
                            }
                        }
                    }
                }
            },
            {
                key: "_setEnabledFlag",
                value: function _setEnabledFlag() {
                    this.__enabled = true;
                    this._updateDimensions();
                    this._updateTextureCoords();
                    if (this.__texture) {
                        this.__texture.addElement(this);
                    }
                    if (this.withinBoundsMargin) {
                        this._setActiveFlag();
                    }
                    if (this.__core.shader) {
                        this.__core.shader.addElement(this.__core);
                    }
                }
            },
            {
                key: "_unsetEnabledFlag",
                value: function _unsetEnabledFlag() {
                    var _this = this;
                    if (this.__active) {
                        this._unsetActiveFlag();
                    }
                    if (this.__texture) {
                        this.__texture.removeElement(this);
                    }
                    if (this.__core.shader) {
                        this.__core.shader.removeElement(this.__core);
                    }
                    if (this._texturizer) {
                        this.texturizer.filters.forEach(function(filter) {
                            return filter.removeElement(_this.__core);
                        });
                    }
                    this.__enabled = false;
                }
            },
            {
                key: "_setActiveFlag",
                value: function _setActiveFlag() {
                    this.__active = true;
                    if (this.__texture) {
                        this.__texture.incActiveCount();
                    }
                    if (this.__texture) {
                        this._enableTexture();
                    }
                    this._onActive();
                }
            },
            {
                key: "_unsetActiveFlag",
                value: function _unsetActiveFlag() {
                    if (this.__texture) {
                        this.__texture.decActiveCount();
                    }
                    this.__active = false;
                    if (this.__texture) {
                        this._disableTexture();
                    }
                    if (this._hasTexturizer()) {
                        this.texturizer.deactivate();
                    }
                    this._onInactive();
                }
            },
            {
                key: "_onSetup",
                value: function _onSetup() {}
            },
            {
                key: "_onAttach",
                value: function _onAttach() {}
            },
            {
                key: "_onDetach",
                value: function _onDetach() {}
            },
            {
                key: "_onEnabled",
                value: function _onEnabled() {}
            },
            {
                key: "_onDisabled",
                value: function _onDisabled() {}
            },
            {
                key: "_onActive",
                value: function _onActive() {}
            },
            {
                key: "_onInactive",
                value: function _onInactive() {}
            },
            {
                key: "_onResize",
                value: function _onResize() {}
            },
            {
                key: "_getRenderWidth",
                value: function _getRenderWidth() {
                    if (this._w) {
                        return this._w;
                    } else if (this.__displayedTexture) {
                        return this.__displayedTexture.getRenderWidth();
                    } else if (this.__texture) {
                        return this.__texture.getRenderWidth();
                    } else {
                        return 0;
                    }
                }
            },
            {
                key: "_getRenderHeight",
                value: function _getRenderHeight() {
                    if (this._h) {
                        return this._h;
                    } else if (this.__displayedTexture) {
                        return this.__displayedTexture.getRenderHeight();
                    } else if (this.__texture) {
                        return this.__texture.getRenderHeight();
                    } else {
                        return 0;
                    }
                }
            },
            {
                key: "renderWidth",
                get: function get() {
                    if (this.__enabled) {
                        return this.__core.getRenderWidth();
                    } else {
                        return this._getRenderWidth();
                    }
                }
            },
            {
                key: "renderHeight",
                get: function get() {
                    if (this.__enabled) {
                        return this.__core.getRenderHeight();
                    } else {
                        return this._getRenderHeight();
                    }
                }
            },
            {
                key: "finalX",
                get: function get() {
                    return this.__core.x;
                }
            },
            {
                key: "finalY",
                get: function get() {
                    return this.__core.y;
                }
            },
            {
                key: "finalW",
                get: function get() {
                    return this.__core.w;
                }
            },
            {
                key: "finalH",
                get: function get() {
                    return this.__core.h;
                }
            },
            {
                key: "textureIsLoaded",
                value: function textureIsLoaded() {
                    return this.__texture && this.__texture.isLoaded();
                }
            },
            {
                key: "loadTexture",
                value: function loadTexture() {
                    if (this.__texture) {
                        this.__texture.load();
                        if (!this.__texture.isUsed() || !this._isEnabled()) {
                            this._updateDimensions();
                        }
                    }
                }
            },
            {
                key: "_enableTextureError",
                value: function _enableTextureError() {
                    var loadError = this.__texture.loadError;
                    if (loadError) {
                        this.emit("txError", loadError, this.__texture._source);
                    }
                }
            },
            {
                key: "_enableTexture",
                value: function _enableTexture() {
                    if (this.__texture.isLoaded()) {
                        this._setDisplayedTexture(this.__texture);
                    } else {
                        this._setDisplayedTexture(null);
                        this._enableTextureError();
                    }
                }
            },
            {
                key: "_disableTexture",
                value: function _disableTexture() {
                    this._setDisplayedTexture(null);
                }
            },
            {
                key: "texture",
                get: function get() {
                    return this.__texture;
                },
                set: function set(v) {
                    var texture;
                    if (Utils.isObjectLiteral(v)) {
                        if (v.type) {
                            texture = new v.type(this.stage);
                        } else {
                            texture = this.texture;
                        }
                        if (texture) {
                            Base.patchObject(texture, v);
                        }
                    } else if (!v) {
                        texture = null;
                    } else {
                        if (v.isTexture) {
                            texture = v;
                        } else if (v.isTextureSource) {
                            texture = new SourceTexture(this.stage);
                            texture.textureSource = v;
                        } else {
                            console.error("[Lightning] Please specify a texture type.");
                            return;
                        }
                    }
                    var prevTexture = this.__texture;
                    if (texture !== prevTexture) {
                        this.__texture = texture;
                        if (this.__texture) {
                            if (this.__enabled) {
                                this.__texture.addElement(this);
                                if (this.withinBoundsMargin) {
                                    if (this.__texture.isLoaded()) {
                                        this._setDisplayedTexture(this.__texture);
                                    } else {
                                        this._enableTextureError();
                                    }
                                }
                            }
                        } else {
                            this._setDisplayedTexture(null);
                        }
                        if (prevTexture && prevTexture !== this.__displayedTexture) {
                            prevTexture.removeElement(this);
                        }
                        this._updateDimensions();
                    }
                }
            },
            {
                key: "displayedTexture",
                get: function get() {
                    return this.__displayedTexture;
                }
            },
            {
                key: "_setDisplayedTexture",
                value: function _setDisplayedTexture(v) {
                    var prevTexture = this.__displayedTexture;
                    if (prevTexture && v !== prevTexture) {
                        if (this.__texture !== prevTexture) {
                            prevTexture.removeElement(this);
                        }
                    }
                    var prevSource = this.__core.displayedTextureSource ? this.__core.displayedTextureSource._source : null;
                    var sourceChanged = (v ? v._source : null) !== prevSource;
                    this.__displayedTexture = v;
                    this._updateDimensions();
                    if (this.__displayedTexture) {
                        if (sourceChanged) {
                            this._updateTextureCoords();
                            this.__core.setDisplayedTextureSource(this.__displayedTexture._source);
                        }
                    } else {
                        this.__core.setDisplayedTextureSource(null);
                    }
                    if (sourceChanged) {
                        if (this.__displayedTexture) {
                            this.emit("txLoaded", this.__displayedTexture);
                        } else {
                            this.emit("txUnloaded", this.__displayedTexture);
                        }
                    }
                }
            },
            {
                key: "onTextureSourceLoaded",
                value: function onTextureSourceLoaded() {
                    if (this.active) {
                        this._setDisplayedTexture(this.__texture);
                    }
                }
            },
            {
                key: "onTextureSourceLoadError",
                value: function onTextureSourceLoadError(e) {
                    this.emit("txError", e, this.__texture._source);
                }
            },
            {
                key: "forceRenderUpdate",
                value: function forceRenderUpdate() {
                    this.__core.setHasRenderUpdates(3);
                }
            },
            {
                key: "onDisplayedTextureClippingChanged",
                value: function onDisplayedTextureClippingChanged() {
                    this._updateDimensions();
                    this._updateTextureCoords();
                }
            },
            {
                key: "onPrecisionChanged",
                value: function onPrecisionChanged() {
                    this._updateDimensions();
                }
            },
            {
                key: "onDimensionsChanged",
                value: function onDimensionsChanged(w, h) {
                    if (this.texture instanceof TextTexture) {
                        this.texture.w = w;
                        this.texture.h = h;
                        this.w = w;
                        this.h = h;
                    }
                }
            },
            {
                key: "_updateDimensions",
                value: function _updateDimensions() {
                    var w = this._getRenderWidth();
                    var h = this._getRenderHeight();
                    var unknownSize = false;
                    if (!w || !h) {
                        if (!this.__displayedTexture && this.__texture) {
                            w = w || this.__texture.mw;
                            h = h || this.__texture.mh;
                            if ((!w || !h) && this.__texture.isAutosizeTexture()) {
                                unknownSize = true;
                            }
                        }
                    }
                    if (this.__core.setDimensions(w, h, unknownSize)) {
                        this._onResize();
                    }
                }
            },
            {
                key: "_updateTextureCoords",
                value: function _updateTextureCoords() {
                    if (this.displayedTexture && this.displayedTexture._source) {
                        var displayedTexture = this.displayedTexture;
                        var displayedTextureSource = this.displayedTexture._source;
                        var tx1 = 0, ty1 = 0, tx2 = 1.0, ty2 = 1.0;
                        if (displayedTexture.clipping) {
                            var w = displayedTextureSource.getRenderWidth();
                            var h = displayedTextureSource.getRenderHeight();
                            var iw, ih, rw, rh;
                            iw = 1 / w;
                            ih = 1 / h;
                            if (displayedTexture.pw) {
                                rw = displayedTexture.pw * iw;
                            } else {
                                rw = (w - displayedTexture.px) * iw;
                            }
                            if (displayedTexture.ph) {
                                rh = displayedTexture.ph * ih;
                            } else {
                                rh = (h - displayedTexture.py) * ih;
                            }
                            iw *= displayedTexture.px;
                            ih *= displayedTexture.py;
                            tx1 = iw;
                            ty1 = ih;
                            tx2 = tx2 * rw + iw;
                            ty2 = ty2 * rh + ih;
                            tx1 = Math.max(0, tx1);
                            ty1 = Math.max(0, ty1);
                            tx2 = Math.min(1, tx2);
                            ty2 = Math.min(1, ty2);
                        }
                        if (displayedTextureSource._flipTextureY) {
                            var tempty = ty2;
                            ty2 = ty1;
                            ty1 = tempty;
                        }
                        this.__core.setTextureCoords(tx1, ty1, tx2, ty2);
                    }
                }
            },
            {
                key: "getCornerPoints",
                value: function getCornerPoints() {
                    return this.__core.getCornerPoints();
                }
            },
            {
                key: "_unsetTagsParent",
                value: function _unsetTagsParent() {
                    var _this = this;
                    if (this.__tags) {
                        this.__tags.forEach(function(tag) {
                            var p = _this;
                            while(p = p.__parent){
                                var parentTreeTags = p.__treeTags.get(tag);
                                parentTreeTags.delete(_this);
                                if (p.__tagRoot) {
                                    break;
                                }
                            }
                        });
                    }
                    var tags = null;
                    var n = 0;
                    if (this.__treeTags) {
                        if (!this.__tagRoot) {
                            tags = Utils.iteratorToArray(this.__treeTags.keys());
                            n = tags.length;
                            if (n > 0) {
                                var _this1 = this, _loop = function(i) {
                                    var _loop = function() {
                                        var parentTreeTags = p.__treeTags.get(tags[i]);
                                        tagSet.forEach(function(comp) {
                                            parentTreeTags.delete(comp);
                                        });
                                        if (p.__tagRoot) {
                                            return "break";
                                        }
                                    };
                                    var tagSet = _this1.__treeTags.get(tags[i]);
                                    var p = _this1;
                                    while(p = p.__parent){
                                        var _ret = _loop();
                                        if (_ret === "break") break;
                                    }
                                };
                                for(var i = 0; i < n; i++)_loop(i);
                            }
                        }
                    }
                }
            },
            {
                key: "_setTagsParent",
                value: function _setTagsParent() {
                    var _this = this;
                    if (this.__tags) {
                        this.__tags.forEach(function(tag) {
                            var p = _this;
                            while(p = p.__parent){
                                if (!p.__treeTags) {
                                    p.__treeTags = new Map();
                                }
                                var s = p.__treeTags.get(tag);
                                if (!s) {
                                    s = new Set();
                                    p.__treeTags.set(tag, s);
                                }
                                s.add(_this);
                                if (p.__tagRoot) {
                                    break;
                                }
                            }
                        });
                    }
                    if (this.__treeTags && this.__treeTags.size) {
                        if (!this.__tagRoot) {
                            this.__treeTags.forEach(function(tagSet, tag) {
                                var _loop = function() {
                                    if (p.__tagRoot) ;
                                    if (!p.__treeTags) {
                                        p.__treeTags = new Map();
                                    }
                                    var s = p.__treeTags.get(tag);
                                    if (!s) {
                                        s = new Set();
                                        p.__treeTags.set(tag, s);
                                    }
                                    tagSet.forEach(function(comp) {
                                        s.add(comp);
                                    });
                                };
                                var p = _this;
                                while(!p.__tagRoot && (p = p.__parent))_loop();
                            });
                        }
                    }
                }
            },
            {
                key: "_getByTag",
                value: function _getByTag(tag) {
                    if (!this.__treeTags) {
                        return [];
                    }
                    var t = this.__treeTags.get(tag);
                    return t ? Utils.setToArray(t) : [];
                }
            },
            {
                key: "getTags",
                value: function getTags() {
                    return this.__tags ? this.__tags : [];
                }
            },
            {
                key: "setTags",
                value: function setTags(tags) {
                    tags = tags.reduce(function(acc, tag) {
                        return acc.concat(tag.split(" "));
                    }, []);
                    if (this.__ref) {
                        tags.push(this.__ref);
                    }
                    var i, n = tags.length;
                    var removes = [];
                    var adds = [];
                    for(i = 0; i < n; i++){
                        if (!this.hasTag(tags[i])) {
                            adds.push(tags[i]);
                        }
                    }
                    var currentTags = this.tags || [];
                    n = currentTags.length;
                    for(i = 0; i < n; i++){
                        if (tags.indexOf(currentTags[i]) == -1) {
                            removes.push(currentTags[i]);
                        }
                    }
                    for(i = 0; i < removes.length; i++){
                        this.removeTag(removes[i]);
                    }
                    for(i = 0; i < adds.length; i++){
                        this.addTag(adds[i]);
                    }
                }
            },
            {
                key: "addTag",
                value: function addTag(tag) {
                    if (tag.indexOf(" ") === -1) {
                        if (Utils.isUcChar(tag.charCodeAt(0))) {
                            this._throwError("Tag may not start with an upper case character.");
                        }
                        this._addTag(tag);
                    } else {
                        var tags = tag.split(" ");
                        for(var i = 0, m = tags.length; i < m; i++){
                            var _$tag = tags[i];
                            if (Utils.isUcChar(_$tag.charCodeAt(0))) {
                                this._throwError("Tag may not start with an upper case character.");
                            }
                            this._addTag(_$tag);
                        }
                    }
                }
            },
            {
                key: "_addTag",
                value: function _addTag(tag) {
                    if (!this.__tags) {
                        this.__tags = [];
                    }
                    if (this.__tags.indexOf(tag) === -1) {
                        this.__tags.push(tag);
                        var p = this.__parent;
                        if (p) {
                            do {
                                if (!p.__treeTags) {
                                    p.__treeTags = new Map();
                                }
                                var s = p.__treeTags.get(tag);
                                if (!s) {
                                    s = new Set();
                                    p.__treeTags.set(tag, s);
                                }
                                s.add(this);
                            }while (!p.__tagRoot && (p = p.__parent));
                        }
                    }
                }
            },
            {
                key: "removeTag",
                value: function removeTag(tag) {
                    var i = this.__tags.indexOf(tag);
                    if (i !== -1) {
                        this.__tags.splice(i, 1);
                        var p = this.__parent;
                        if (p) {
                            do {
                                var list = p.__treeTags.get(tag);
                                if (list) {
                                    list.delete(this);
                                }
                            }while (!p.__tagRoot && (p = p.__parent));
                        }
                    }
                }
            },
            {
                key: "hasTag",
                value: function hasTag(tag) {
                    return this.__tags && this.__tags.indexOf(tag) !== -1;
                }
            },
            {
                key: "_tag",
                value: function _tag(tag) {
                    if (tag.indexOf(".") !== -1) {
                        return this.mtag(tag)[0];
                    } else {
                        if (this.__treeTags) {
                            var t = this.__treeTags.get(tag);
                            if (t) {
                                var item = t.values().next();
                                return item ? item.value : undefined;
                            }
                        }
                    }
                }
            },
            {
                key: "tag",
                get: function get() {
                    return this._tag;
                },
                set: function set(t) {
                    this.tags = t;
                }
            },
            {
                key: "mtag",
                value: function mtag(tag) {
                    var idx = tag.indexOf(".");
                    if (idx >= 0) {
                        var parts = tag.split(".");
                        var res = this._getByTag(parts[0]);
                        var level = 1;
                        var c = parts.length;
                        while(res.length && level < c){
                            var resn = [];
                            for(var j = 0, n = res.length; j < n; j++){
                                resn = resn.concat(res[j]._getByTag(parts[level]));
                            }
                            res = resn;
                            level++;
                        }
                        return res;
                    } else {
                        return this._getByTag(tag);
                    }
                }
            },
            {
                key: "stag",
                value: function stag(tag, settings) {
                    var t = this.mtag(tag);
                    var n = t.length;
                    for(var i = 0; i < n; i++){
                        Base.patchObject(t[i], settings);
                    }
                }
            },
            {
                key: "tagRoot",
                get: function get() {
                    return this.__tagRoot;
                },
                set: function set(v) {
                    if (this.__tagRoot !== v) {
                        if (!v) {
                            this._setTagsParent();
                        } else {
                            this._unsetTagsParent();
                        }
                        this.__tagRoot = v;
                    }
                }
            },
            {
                key: "sel",
                value: function sel(path) {
                    var results = this.select(path);
                    if (results.length) {
                        return results[0];
                    } else {
                        return undefined;
                    }
                }
            },
            {
                key: "select",
                value: function select(path) {
                    if (path.indexOf(",") !== -1) {
                        var selectors = path.split(",");
                        var res = [];
                        for(var i = 0; i < selectors.length; i++){
                            res = res.concat(this._select(selectors[i]));
                        }
                        return res;
                    } else {
                        return this._select(path);
                    }
                }
            },
            {
                key: "_select",
                value: function _select(path) {
                    if (path === "") return [
                        this
                    ];
                    var pointIdx = path.indexOf(".");
                    var arrowIdx = path.indexOf(">");
                    if (pointIdx === -1 && arrowIdx === -1) {
                        return this.mtag(path);
                    }
                    var isRef;
                    if (arrowIdx === 0) {
                        isRef = true;
                        path = path.substr(1);
                    } else if (pointIdx === 0) {
                        isRef = false;
                        path = path.substr(1);
                    } else {
                        isRef = false;
                    }
                    return this._selectChilds(path, isRef);
                }
            },
            {
                key: "_selectChilds",
                value: function _selectChilds(path, isRef) {
                    var pointIdx = path.indexOf(".");
                    var arrowIdx = path.indexOf(">");
                    if (pointIdx === -1 && arrowIdx === -1) {
                        if (isRef) {
                            var ref = this.getByRef(path);
                            return ref ? [
                                ref
                            ] : [];
                        } else {
                            return this.mtag(path);
                        }
                    }
                    if (arrowIdx === -1 || pointIdx !== -1 && pointIdx < arrowIdx) {
                        var next;
                        var str = path.substr(0, pointIdx);
                        if (isRef) {
                            var ref1 = this.getByRef(str);
                            next = ref1 ? [
                                ref1
                            ] : [];
                        } else {
                            next = this.mtag(str);
                        }
                        var total = [];
                        var subPath = path.substr(pointIdx + 1);
                        for(var i = 0, n = next.length; i < n; i++){
                            total = total.concat(next[i]._selectChilds(subPath, false));
                        }
                        return total;
                    } else {
                        var next1;
                        var str1 = path.substr(0, arrowIdx);
                        if (isRef) {
                            var ref2 = this.getByRef(str1);
                            next1 = ref2 ? [
                                ref2
                            ] : [];
                        } else {
                            next1 = this.mtag(str1);
                        }
                        var total1 = [];
                        var subPath1 = path.substr(arrowIdx + 1);
                        for(var i1 = 0, n1 = next1.length; i1 < n1; i1++){
                            total1 = total1.concat(next1[i1]._selectChilds(subPath1, true));
                        }
                        return total1;
                    }
                }
            },
            {
                key: "getByRef",
                value: function getByRef(ref) {
                    return this.childList.getByRef(ref);
                }
            },
            {
                key: "getLocationString",
                value: function getLocationString() {
                    var i;
                    i = this.__parent ? this.__parent._children.getIndex(this) : "R";
                    var localTags = this.getTags();
                    var str = this.__parent ? this.__parent.getLocationString() : "";
                    if (this.ref) {
                        str += ":[" + i + "]" + this.ref;
                    } else if (localTags.length) {
                        str += ":[" + i + "]" + localTags.join(",");
                    } else {
                        str += ":[" + i + "]#" + this.id;
                    }
                    return str;
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var obj = this.getSettings();
                    return Element.getPrettyString(obj, "");
                }
            },
            {
                key: "getSettings",
                value: function getSettings() {
                    var settings = this.getNonDefaults();
                    var children = this._children.get();
                    if (children) {
                        var n = children.length;
                        if (n) {
                            var childArray = [];
                            var missing = false;
                            for(var i = 0; i < n; i++){
                                childArray.push(children[i].getSettings());
                                missing = missing || !children[i].ref;
                            }
                            if (!missing) {
                                settings.children = {};
                                childArray.forEach(function(child) {
                                    settings.children[child.ref] = child;
                                });
                            } else {
                                settings.children = childArray;
                            }
                        }
                    }
                    settings.id = this.id;
                    return settings;
                }
            },
            {
                key: "getNonDefaults",
                value: function getNonDefaults() {
                    var settings = {};
                    if (this.constructor !== Element) {
                        settings.type = this.constructor.name;
                    }
                    if (this.__ref) {
                        settings.ref = this.__ref;
                    }
                    if (this.__tags && this.__tags.length) {
                        settings.tags = this.__tags;
                    }
                    if (this.x !== 0) settings.x = this.x;
                    if (this.y !== 0) settings.y = this.y;
                    if (this.w !== 0) settings.w = this.w;
                    if (this.h !== 0) settings.h = this.h;
                    if (this.scaleX === this.scaleY) {
                        if (this.scaleX !== 1) settings.scale = this.scaleX;
                    } else {
                        if (this.scaleX !== 1) settings.scaleX = this.scaleX;
                        if (this.scaleY !== 1) settings.scaleY = this.scaleY;
                    }
                    if (this.pivotX === this.pivotY) {
                        if (this.pivotX !== 0.5) settings.pivot = this.pivotX;
                    } else {
                        if (this.pivotX !== 0.5) settings.pivotX = this.pivotX;
                        if (this.pivotY !== 0.5) settings.pivotY = this.pivotY;
                    }
                    if (this.mountX === this.mountY) {
                        if (this.mountX !== 0) settings.mount = this.mountX;
                    } else {
                        if (this.mountX !== 0) settings.mountX = this.mountX;
                        if (this.mountY !== 0) settings.mountY = this.mountY;
                    }
                    if (this.alpha !== 1) settings.alpha = this.alpha;
                    if (!this.visible) settings.visible = false;
                    if (this.rotation !== 0) settings.rotation = this.rotation;
                    if (this.colorUl === this.colorUr && this.colorBl === this.colorBr && this.colorUl === this.colorBl) {
                        if (this.colorUl !== 0xFFFFFFFF) settings.color = this.colorUl.toString(16);
                    } else {
                        if (this.colorUl !== 0xFFFFFFFF) settings.colorUl = this.colorUl.toString(16);
                        if (this.colorUr !== 0xFFFFFFFF) settings.colorUr = this.colorUr.toString(16);
                        if (this.colorBl !== 0xFFFFFFFF) settings.colorBl = this.colorBl.toString(16);
                        if (this.colorBr !== 0xFFFFFFFF) settings.colorBr = this.colorBr.toString(16);
                    }
                    if (this.zIndex) settings.zIndex = this.zIndex;
                    if (this.forceZIndexContext) settings.forceZIndexContext = true;
                    if (this.clipping) settings.clipping = this.clipping;
                    if (!this.clipbox) settings.clipbox = this.clipbox;
                    if (this.__texture) {
                        var tnd = this.__texture.getNonDefaults();
                        if (Object.keys(tnd).length) {
                            settings.texture = tnd;
                        }
                    }
                    if (this.shader && Utils.isFunction(this.shader.getNonDefaults)) {
                        var tnd1 = this.shader.getNonDefaults();
                        if (Object.keys(tnd1).length) {
                            settings.shader = tnd1;
                        }
                    }
                    if (this._hasTexturizer()) {
                        if (this.texturizer.enabled) {
                            settings.renderToTexture = this.texturizer.enabled;
                        }
                        if (this.texturizer.lazy) {
                            settings.renderToTextureLazy = this.texturizer.lazy;
                        }
                        if (this.texturizer.colorize) {
                            settings.colorizeResultTexture = this.texturizer.colorize;
                        }
                        if (this.texturizer.renderOffscreen) {
                            settings.renderOffscreen = this.texturizer.renderOffscreen;
                        }
                    }
                    return settings;
                }
            },
            {
                key: "withinBoundsMargin",
                get: function get() {
                    return this.__core._withinBoundsMargin;
                }
            },
            {
                key: "_enableWithinBoundsMargin",
                value: function _enableWithinBoundsMargin() {
                    if (this.__enabled) {
                        this._setActiveFlag();
                    }
                }
            },
            {
                key: "_disableWithinBoundsMargin",
                value: function _disableWithinBoundsMargin() {
                    if (this.__active) {
                        this._unsetActiveFlag();
                    }
                }
            },
            {
                key: "boundsMargin",
                get: function get() {
                    return this.__core.boundsMargin;
                },
                set: function set(v) {
                    if (!Array.isArray(v) && v !== null) {
                        throw new Error("boundsMargin should be an array of left-top-right-bottom values or null (inherit margin)");
                    }
                    this.__core.boundsMargin = v;
                }
            },
            {
                key: "x",
                get: function get() {
                    return this.__core.offsetX;
                },
                set: function set(v) {
                    this.__core.offsetX = v;
                }
            },
            {
                key: "y",
                get: function get() {
                    return this.__core.offsetY;
                },
                set: function set(v) {
                    this.__core.offsetY = v;
                }
            },
            {
                key: "w",
                get: function get() {
                    return this._w;
                },
                set: function set(v) {
                    if (Utils.isFunction(v)) {
                        this._w = 0;
                        this.__core.funcW = v;
                    } else {
                        v = Math.max(v, 0);
                        if (this._w !== v) {
                            this.__core.disableFuncW();
                            this._w = v;
                            this._updateDimensions();
                        }
                    }
                }
            },
            {
                key: "h",
                get: function get() {
                    return this._h;
                },
                set: function set(v) {
                    if (Utils.isFunction(v)) {
                        this._h = 0;
                        this.__core.funcH = v;
                    } else {
                        v = Math.max(v, 0);
                        if (this._h !== v) {
                            this.__core.disableFuncH();
                            this._h = v;
                            this._updateDimensions();
                        }
                    }
                }
            },
            {
                key: "collision",
                get: function get() {
                    return this._collision;
                },
                set: function set(v) {
                    this._collision = v;
                }
            },
            {
                key: "_updateCollision",
                value: function _updateCollision() {
                    if (this.collision && this.__parent && this.__parent.collision === undefined) {
                        this.__parent.collision = 2;
                    }
                }
            },
            {
                key: "scaleX",
                get: function get() {
                    return this.__core.scaleX;
                },
                set: function set(v) {
                    this.__core.scaleX = v;
                }
            },
            {
                key: "scaleY",
                get: function get() {
                    return this.__core.scaleY;
                },
                set: function set(v) {
                    this.__core.scaleY = v;
                }
            },
            {
                key: "scale",
                get: function get() {
                    return this.__core.scale;
                },
                set: function set(v) {
                    this.__core.scale = v;
                }
            },
            {
                key: "pivotX",
                get: function get() {
                    return this.__core.pivotX;
                },
                set: function set(v) {
                    this.__core.pivotX = v;
                }
            },
            {
                key: "pivotY",
                get: function get() {
                    return this.__core.pivotY;
                },
                set: function set(v) {
                    this.__core.pivotY = v;
                }
            },
            {
                key: "pivot",
                get: function get() {
                    return this.__core.pivot;
                },
                set: function set(v) {
                    this.__core.pivot = v;
                }
            },
            {
                key: "mountX",
                get: function get() {
                    return this.__core.mountX;
                },
                set: function set(v) {
                    this.__core.mountX = v;
                }
            },
            {
                key: "mountY",
                get: function get() {
                    return this.__core.mountY;
                },
                set: function set(v) {
                    this.__core.mountY = v;
                }
            },
            {
                key: "mount",
                get: function get() {
                    return this.__core.mount;
                },
                set: function set(v) {
                    this.__core.mount = v;
                }
            },
            {
                key: "rotation",
                get: function get() {
                    return this.__core.rotation;
                },
                set: function set(v) {
                    this.__core.rotation = v;
                }
            },
            {
                key: "alpha",
                get: function get() {
                    return this.__core.alpha;
                },
                set: function set(v) {
                    this.__core.alpha = v;
                }
            },
            {
                key: "visible",
                get: function get() {
                    return this.__core.visible;
                },
                set: function set(v) {
                    this.__core.visible = v;
                }
            },
            {
                key: "colorUl",
                get: function get() {
                    return this.__core.colorUl;
                },
                set: function set(v) {
                    this.__core.colorUl = v;
                }
            },
            {
                key: "colorUr",
                get: function get() {
                    return this.__core.colorUr;
                },
                set: function set(v) {
                    this.__core.colorUr = v;
                }
            },
            {
                key: "colorBl",
                get: function get() {
                    return this.__core.colorBl;
                },
                set: function set(v) {
                    this.__core.colorBl = v;
                }
            },
            {
                key: "colorBr",
                get: function get() {
                    return this.__core.colorBr;
                },
                set: function set(v) {
                    this.__core.colorBr = v;
                }
            },
            {
                key: "color",
                get: function get() {
                    return this.__core.colorUl;
                },
                set: function set(v) {
                    if (this.colorUl !== v || this.colorUr !== v || this.colorBl !== v || this.colorBr !== v) {
                        this.colorUl = v;
                        this.colorUr = v;
                        this.colorBl = v;
                        this.colorBr = v;
                    }
                }
            },
            {
                key: "colorTop",
                get: function get() {
                    return this.colorUl;
                },
                set: function set(v) {
                    if (this.colorUl !== v || this.colorUr !== v) {
                        this.colorUl = v;
                        this.colorUr = v;
                    }
                }
            },
            {
                key: "colorBottom",
                get: function get() {
                    return this.colorBl;
                },
                set: function set(v) {
                    if (this.colorBl !== v || this.colorBr !== v) {
                        this.colorBl = v;
                        this.colorBr = v;
                    }
                }
            },
            {
                key: "colorLeft",
                get: function get() {
                    return this.colorUl;
                },
                set: function set(v) {
                    if (this.colorUl !== v || this.colorBl !== v) {
                        this.colorUl = v;
                        this.colorBl = v;
                    }
                }
            },
            {
                key: "colorRight",
                get: function get() {
                    return this.colorUr;
                },
                set: function set(v) {
                    if (this.colorUr !== v || this.colorBr !== v) {
                        this.colorUr = v;
                        this.colorBr = v;
                    }
                }
            },
            {
                key: "zIndex",
                get: function get() {
                    return this.__core.zIndex;
                },
                set: function set(v) {
                    this.__core.zIndex = v;
                }
            },
            {
                key: "forceZIndexContext",
                get: function get() {
                    return this.__core.forceZIndexContext;
                },
                set: function set(v) {
                    this.__core.forceZIndexContext = v;
                }
            },
            {
                key: "clipping",
                get: function get() {
                    return this.__core.clipping;
                },
                set: function set(v) {
                    this.__core.clipping = v;
                }
            },
            {
                key: "clipbox",
                get: function get() {
                    return this.__core.clipbox;
                },
                set: function set(v) {
                    this.__core.clipbox = v;
                }
            },
            {
                key: "tags",
                get: function get() {
                    return this.getTags();
                },
                set: function set(v) {
                    if (!Array.isArray(v)) v = [
                        v
                    ];
                    this.setTags(v);
                }
            },
            {
                key: "t",
                set: function set(v) {
                    this.tags = v;
                }
            },
            {
                key: "_children",
                get: function get() {
                    if (!this.__childList) {
                        this.__childList = new ElementChildList(this, false);
                    }
                    return this.__childList;
                }
            },
            {
                key: "childList",
                get: function get() {
                    if (!this._allowChildrenAccess()) {
                        this._throwError("Direct access to children is not allowed in " + this.getLocationString());
                    }
                    return this._children;
                }
            },
            {
                key: "hasChildren",
                value: function hasChildren() {
                    return this._allowChildrenAccess() && this.__childList && this.__childList.length > 0;
                }
            },
            {
                key: "_allowChildrenAccess",
                value: function _allowChildrenAccess() {
                    return true;
                }
            },
            {
                key: "children",
                get: function get() {
                    return this.childList.get();
                },
                set: function set(children) {
                    this.childList.patch(children);
                }
            },
            {
                key: "add",
                value: function add(o) {
                    return this.childList.a(o);
                }
            },
            {
                key: "p",
                get: function get() {
                    return this.__parent;
                }
            },
            {
                key: "parent",
                get: function get() {
                    return this.__parent;
                }
            },
            {
                key: "src",
                get: function get() {
                    if (this.texture && this.texture instanceof ImageTexture) {
                        return this.texture._src;
                    } else {
                        return undefined;
                    }
                },
                set: function set(v) {
                    var texture = new ImageTexture(this.stage);
                    texture.src = v;
                    this.texture = texture;
                }
            },
            {
                key: "mw",
                set: function set(v) {
                    if (this.texture) {
                        this.texture.mw = v;
                        this._updateDimensions();
                    } else {
                        this._throwError("Please set mw after setting a texture.");
                    }
                }
            },
            {
                key: "mh",
                set: function set(v) {
                    if (this.texture) {
                        this.texture.mh = v;
                        this._updateDimensions();
                    } else {
                        this._throwError("Please set mh after setting a texture.");
                    }
                }
            },
            {
                key: "rect",
                get: function get() {
                    return this.texture === this.stage.rectangleTexture;
                },
                set: function set(v) {
                    if (v) {
                        this.texture = this.stage.rectangleTexture;
                    } else {
                        this.texture = null;
                    }
                }
            },
            {
                key: "enableTextTexture",
                value: function enableTextTexture() {
                    if (!this.texture || !(this.texture instanceof TextTexture)) {
                        this.texture = new TextTexture(this.stage);
                        if (!this.texture.w && !this.texture.h) {
                            this.texture.w = this.w;
                            this.texture.h = this.h;
                        }
                    }
                    return this.texture;
                }
            },
            {
                key: "text",
                get: function get() {
                    if (this.texture && this.texture instanceof TextTexture) {
                        return this.texture;
                    } else {
                        return null;
                    }
                },
                set: function set(v) {
                    if (!this.texture || !(this.texture instanceof TextTexture)) {
                        this.enableTextTexture();
                    }
                    if (Utils.isString(v)) {
                        this.texture.text = v;
                    } else {
                        this.texture.patch(v);
                    }
                }
            },
            {
                key: "onUpdate",
                set: function set(f) {
                    this.__core.onUpdate = f;
                }
            },
            {
                key: "onAfterCalcs",
                set: function set(f) {
                    this.__core.onAfterCalcs = f;
                }
            },
            {
                key: "onAfterUpdate",
                set: function set(f) {
                    this.__core.onAfterUpdate = f;
                }
            },
            {
                key: "forceUpdate",
                value: function forceUpdate() {
                    this.__core._setHasUpdates();
                }
            },
            {
                key: "shader",
                get: function get() {
                    return this.__core.shader;
                },
                set: function set(v) {
                    if (Utils.isObjectLiteral(v) && !v.type) {
                        if (this.shader) {
                            this.shader.patch(v);
                        }
                    } else {
                        var shader = Shader.create(this.stage, v);
                        if (this.__enabled && this.__core.shader) {
                            this.__core.shader.removeElement(this.__core);
                        }
                        this.__core.shader = shader;
                        if (this.__enabled && this.__core.shader) {
                            this.__core.shader.addElement(this.__core);
                        }
                    }
                }
            },
            {
                key: "_hasTexturizer",
                value: function _hasTexturizer() {
                    return !!this.__core._texturizer;
                }
            },
            {
                key: "renderToTexture",
                get: function get() {
                    return this.rtt;
                },
                set: function set(v) {
                    this.rtt = v;
                }
            },
            {
                key: "rtt",
                get: function get() {
                    return this._hasTexturizer() && this.texturizer.enabled;
                },
                set: function set(v) {
                    this.texturizer.enabled = v;
                }
            },
            {
                key: "rttLazy",
                get: function get() {
                    return this._hasTexturizer() && this.texturizer.lazy;
                },
                set: function set(v) {
                    this.texturizer.lazy = v;
                }
            },
            {
                key: "renderOffscreen",
                get: function get() {
                    return this._hasTexturizer() && this.texturizer.renderOffscreen;
                },
                set: function set(v) {
                    this.texturizer.renderOffscreen = v;
                }
            },
            {
                key: "colorizeResultTexture",
                get: function get() {
                    return this._hasTexturizer() && this.texturizer.colorize;
                },
                set: function set(v) {
                    this.texturizer.colorize = v;
                }
            },
            {
                key: "getTexture",
                value: function getTexture() {
                    return this.texturizer._getTextureSource();
                }
            },
            {
                key: "texturizer",
                get: function get() {
                    return this.__core.texturizer;
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    var paths = Object.keys(settings);
                    for(var i = 0, n = paths.length; i < n; i++){
                        var path = paths[i];
                        var v = settings[path];
                        var firstCharCode = path.charCodeAt(0);
                        if (Utils.isUcChar(firstCharCode)) {
                            var child = this.getByRef(path);
                            if (!child) {
                                if (v !== undefined) {
                                    var c = void 0;
                                    if (Utils.isObjectLiteral(v)) {
                                        c = this.childList.createItem(v);
                                        c.patch(v);
                                    } else if (Utils.isObject(v)) {
                                        c = v;
                                    }
                                    if (c.isElement) {
                                        c.ref = path;
                                    }
                                    this.childList.a(c);
                                }
                            } else {
                                if (v === undefined) {
                                    if (child.parent) {
                                        child.parent.childList.remove(child);
                                    }
                                } else if (Utils.isObjectLiteral(v)) {
                                    child.patch(v);
                                } else if (v.isElement) {
                                    v.ref = path;
                                    this.childList.replace(v, child);
                                } else {
                                    this._throwError("Unexpected value for path: " + path);
                                }
                            }
                        } else {
                            Base.patchObjectProperty(this, path, v);
                        }
                    }
                }
            },
            {
                key: "_throwError",
                value: function _throwError(message) {
                    throw new Error(this.constructor.name + " (" + this.getLocationString() + "): " + message);
                }
            },
            {
                key: "animation",
                value: function animation(settings) {
                    return this.stage.animations.createAnimation(this, settings);
                }
            },
            {
                key: "transition",
                value: function transition(property) {
                    var settings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    if (settings === null) {
                        return this._getTransition(property);
                    } else {
                        this._setTransition(property, settings);
                        return null;
                    }
                }
            },
            {
                key: "transitions",
                set: function set(object) {
                    var _this = this;
                    var keys = Object.keys(object);
                    keys.forEach(function(property) {
                        _this.transition(property, object[property]);
                    });
                }
            },
            {
                key: "smooth",
                set: function set(object) {
                    var _this = this;
                    var keys = Object.keys(object);
                    keys.forEach(function(property) {
                        var value = object[property];
                        if (Array.isArray(value)) {
                            _this.setSmooth(property, value[0], value[1]);
                        } else {
                            _this.setSmooth(property, value);
                        }
                    });
                }
            },
            {
                key: "fastForward",
                value: function fastForward(property) {
                    if (this._transitions) {
                        var t = this._transitions[property];
                        if (t && t.isTransition) {
                            t.finish();
                        }
                    }
                }
            },
            {
                key: "_getTransition",
                value: function _getTransition(property) {
                    if (!this._transitions) {
                        this._transitions = {};
                    }
                    var t = this._transitions[property];
                    if (!t) {
                        t = new Transition(this.stage.transitions, this.stage.transitions.defaultTransitionSettings, this, property);
                    } else if (t.isTransitionSettings) {
                        t = new Transition(this.stage.transitions, t, this, property);
                    }
                    this._transitions[property] = t;
                    return t;
                }
            },
            {
                key: "_setTransition",
                value: function _setTransition(property, settings) {
                    if (!settings) {
                        this._removeTransition(property);
                    } else {
                        if (Utils.isObjectLiteral(settings)) {
                            settings = this.stage.transitions.createSettings(settings);
                        }
                        if (!this._transitions) {
                            this._transitions = {};
                        }
                        var current = this._transitions[property];
                        if (current && current.isTransition) {
                            current.settings = settings;
                            return current;
                        } else {
                            this._transitions[property] = settings;
                        }
                    }
                }
            },
            {
                key: "_removeTransition",
                value: function _removeTransition(property) {
                    if (this._transitions) {
                        delete this._transitions[property];
                    }
                }
            },
            {
                key: "getSmooth",
                value: function getSmooth(property, v) {
                    var t = this._getTransition(property);
                    if (t && t.isAttached()) {
                        return t.targetValue;
                    } else {
                        return v;
                    }
                }
            },
            {
                key: "setSmooth",
                value: function setSmooth(property, v, settings) {
                    if (settings) {
                        this._setTransition(property, settings);
                    }
                    var t = this._getTransition(property);
                    t.start(v);
                    return t;
                }
            },
            {
                key: "flex",
                get: function get() {
                    return this.__core.flex;
                },
                set: function set(v) {
                    this.__core.flex = v;
                }
            },
            {
                key: "flexItem",
                get: function get() {
                    return this.__core.flexItem;
                },
                set: function set(v) {
                    this.__core.flexItem = v;
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    var ref = [
                        "".concat(this.constructor.name)
                    ];
                    var tree = {};
                    tree[ref] = {};
                    if (this.hasChildren()) {
                        Element.collectChildren(tree[ref], this.__childList);
                    } else {
                        tree[ref] = _object_spread._({}, Element.getProperties(this));
                    }
                    return tree;
                }
            }
        ], [
            {
                key: "getPrettyString",
                value: function getPrettyString(obj, indent) {
                    var children = obj.children;
                    delete obj.children;
                    var colorKeys = [
                        "color",
                        "colorUl",
                        "colorUr",
                        "colorBl",
                        "colorBr"
                    ];
                    var str = JSON.stringify(obj, function(k, v) {
                        if (colorKeys.indexOf(k) !== -1) {
                            return "COLOR[" + v.toString(16) + "]";
                        }
                        return v;
                    });
                    str = str.replace(/"COLOR\[([a-f0-9]{1,8})\]"/g, "0x$1");
                    if (children) {
                        var childStr = "";
                        if (Utils.isObjectLiteral(children)) {
                            var refs = Object.keys(children);
                            childStr = "";
                            for(var i = 0, n = refs.length; i < n; i++){
                                childStr += "\n".concat(indent, '  "').concat(refs[i], '":');
                                delete children[refs[i]].ref;
                                childStr += Element.getPrettyString(children[refs[i]], indent + "  ") + (i < n - 1 ? "," : "");
                            }
                            var isEmpty = str === "{}";
                            str = str.substr(0, str.length - 1) + (isEmpty ? "" : ",") + childStr + "\n" + indent + "}";
                        } else {
                            var n1 = children.length;
                            childStr = "[";
                            for(var i1 = 0; i1 < n1; i1++){
                                childStr += Element.getPrettyString(children[i1], indent + "  ") + (i1 < n1 - 1 ? "," : "") + "\n";
                            }
                            childStr += indent + "]}";
                            var isEmpty1 = str === "{}";
                            str = str.substr(0, str.length - 1) + (isEmpty1 ? "" : ",") + '"children":\n' + indent + childStr + "}";
                        }
                    }
                    return str;
                }
            },
            {
                key: "getGetter",
                value: function getGetter(propertyPath) {
                    var getter = Element.PROP_GETTERS.get(propertyPath);
                    if (!getter) {
                        getter = new Function("obj", "return obj." + propertyPath);
                        Element.PROP_GETTERS.set(propertyPath, getter);
                    }
                    return getter;
                }
            },
            {
                key: "getSetter",
                value: function getSetter(propertyPath) {
                    var setter = Element.PROP_SETTERS.get(propertyPath);
                    if (!setter) {
                        setter = new Function("obj", "v", "obj." + propertyPath + " = v");
                        Element.PROP_SETTERS.set(propertyPath, setter);
                    }
                    return setter;
                }
            },
            {
                key: "isColorProperty",
                value: function isColorProperty(property) {
                    return property.toLowerCase().indexOf("color") >= 0;
                }
            },
            {
                key: "getMerger",
                value: function getMerger(property) {
                    if (Element.isColorProperty(property)) {
                        return StageUtils.mergeColors;
                    } else {
                        return StageUtils.mergeNumbers;
                    }
                }
            },
            {
                key: "collectChildren",
                value: function collectChildren(tree, children) {
                    var childList = children;
                    for(var i = 0, j = childList.length; i < j; i++){
                        var element = childList.getAt(i);
                        var ref = "".concat(element.__ref || "Element-".concat(element.id));
                        var properties = this.getProperties(element);
                        tree[ref] = _object_spread._({}, properties);
                        if (element.hasChildren()) {
                            tree[ref].children = {};
                            this.collectChildren(tree[ref].children, element.__childList);
                        }
                    }
                }
            },
            {
                key: "getProperties",
                value: function getProperties(element) {
                    var props = {};
                    var list = [
                        "alpha",
                        "active",
                        "attached",
                        "boundsMargin",
                        "color",
                        "clipping",
                        "enabled",
                        "h",
                        "id",
                        "isComponent",
                        "mount",
                        "mountY",
                        "mountX",
                        "pivot",
                        "pivotX",
                        "pivotY",
                        "ref",
                        "renderOfScreen",
                        "renderToTexture",
                        "scale",
                        "scaleX",
                        "scaleY",
                        "state",
                        "tag",
                        "visible",
                        "w",
                        "x",
                        "y",
                        "zIndex",
                        "!!flex",
                        "!!flexItem",
                        "hasFocus()",
                        "hasFinalFocus()"
                    ];
                    var n = list.length;
                    while(n--){
                        var key = list[n];
                        var getBoolean = /^!{2}/;
                        var isFunction = /\(\)$/;
                        if (getBoolean.test(key)) {
                            key = key.substring(2, key.length);
                            props[key] = !!element[key];
                        } else if (isFunction.test(key)) {
                            key = key.substring(0, key.length - 2);
                            if (typeof element[key] === "function") {
                                props[key] = element[key]();
                            }
                        } else {
                            props[key] = element[key];
                        }
                    }
                    return _object_spread._({}, props, element.getNonDefaults());
                }
            }
        ]);
        return Element;
    }();
    EventEmitter.addAsMixin(Element);
    Element.prototype.isElement = 1;
    Element.id = 1;
    Element.PROP_GETTERS = new Map();
    Element.PROP_SETTERS = new Map();
    var StateMachine = /*#__PURE__*/ function() {
        function StateMachine() {
            _class_call_check._(this, StateMachine);
            StateMachine.setupStateMachine(this);
        }
        _create_class._(StateMachine, [
            {
                key: "fire",
                value: function fire(event) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    if (this._hasMethod(event)) {
                        return this[event].apply(this, _to_consumable_array._(args));
                    }
                }
            },
            {
                key: "_getState",
                value: function _getState() {
                    return this._state.__path;
                }
            },
            {
                key: "_inState",
                value: function _inState(statePath) {
                    var currentStatePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._state.__path;
                    var state = this._sm.getStateByPath(statePath);
                    var currentState = this._sm.getStateByPath(currentStatePath);
                    var level = state.__level;
                    var stateAtLevel = StateMachine._getStateAtLevel(currentState, level);
                    return stateAtLevel === state;
                }
            },
            {
                key: "_hasMember",
                value: function _hasMember(name) {
                    return !!this.constructor.prototype[name];
                }
            },
            {
                key: "_hasMethod",
                value: function _hasMethod(name) {
                    var member = this.constructor.prototype[name];
                    return !!member && typeof member === "function";
                }
            },
            {
                key: "_setState",
                value: function _setState(statePath, args) {
                    var setStateId = ++this._setStateCounter;
                    this._setStateId = setStateId;
                    if (this._state.__path !== statePath) {
                        var newState = this._sm._stateMap[statePath];
                        if (!newState) {
                            newState = this._sm.getStateByPath(statePath);
                        }
                        var prevState = this._state;
                        var hasDifferentEnterMethod = newState.prototype.$enter !== this._state.prototype.$enter;
                        var hasDifferentExitMethod = newState.prototype.$exit !== this._state.prototype.$exit;
                        if (hasDifferentEnterMethod || hasDifferentExitMethod) {
                            var sharedState = StateMachine._getSharedState(this._state, newState);
                            var context = {
                                newState: newState.__path,
                                prevState: prevState.__path,
                                sharedState: sharedState.__path
                            };
                            var sharedLevel = sharedState.__level;
                            if (hasDifferentExitMethod) {
                                var exitStates = StateMachine._getStatesUntilLevel(this._state, sharedLevel);
                                for(var i = 0, n = exitStates.length; i < n; i++){
                                    this.__setState(exitStates[i]);
                                    this._callExit(this._state, args, context);
                                    var stateChangeOverridden = this._setStateId !== setStateId;
                                    if (stateChangeOverridden) {
                                        return;
                                    }
                                }
                            }
                            if (hasDifferentEnterMethod) {
                                var enterStates = StateMachine._getStatesUntilLevel(newState, sharedLevel).reverse();
                                for(var i1 = 0, n1 = enterStates.length; i1 < n1; i1++){
                                    this.__setState(enterStates[i1]);
                                    this._callEnter(this._state, args, context);
                                    var stateChangeOverridden1 = this._setStateId !== setStateId;
                                    if (stateChangeOverridden1) {
                                        return;
                                    }
                                }
                            }
                        }
                        this.__setState(newState);
                        if (this._changedState) {
                            var context1 = {
                                newState: newState.__path,
                                prevState: prevState.__path
                            };
                            if (args) {
                                this._changedState.apply(this, [
                                    context1
                                ].concat(_to_consumable_array._(args)));
                            } else {
                                this._changedState(context1);
                            }
                        }
                        if (this._onStateChange) {
                            var context2 = {
                                newState: newState.__path,
                                prevState: prevState.__path
                            };
                            this._onStateChange(context2);
                        }
                    }
                }
            },
            {
                key: "_callEnter",
                value: function _callEnter(state) {
                    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], context = arguments.length > 2 ? arguments[2] : void 0;
                    var hasParent = !!state.__parent;
                    if (state.prototype.$enter) {
                        if (!hasParent || state.__parent.prototype.$enter !== state.prototype.$enter) {
                            state.prototype.$enter.apply(this, [
                                context
                            ].concat(_to_consumable_array._(args)));
                        }
                    }
                }
            },
            {
                key: "_callExit",
                value: function _callExit(state) {
                    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], context = arguments.length > 2 ? arguments[2] : void 0;
                    var hasParent = !!state.__parent;
                    if (state.prototype.$exit) {
                        if (!hasParent || state.__parent.prototype.$exit !== state.prototype.$exit) {
                            state.prototype.$exit.apply(this, [
                                context
                            ].concat(_to_consumable_array._(args)));
                        }
                    }
                }
            },
            {
                key: "__setState",
                value: function __setState(state) {
                    this._state = state;
                    this._stateIndex = state.__index;
                    this.constructor = state;
                }
            },
            {
                key: "_initStateMachine",
                value: function _initStateMachine() {
                    this._state = null;
                    this._stateIndex = 0;
                    this._setStateCounter = 0;
                    this._sm = this._routedType._sm;
                    this.__setState(this._sm.getStateByPath(""));
                    var context = {
                        newState: "",
                        prevState: undefined,
                        sharedState: undefined
                    };
                    this._callEnter(this._state, [], context);
                    this._onStateChange = undefined;
                }
            },
            {
                key: "_getMostSpecificHandledMember",
                value: function _getMostSpecificHandledMember(memberNames) {
                    var cur = this._state;
                    do {
                        for(var i = 0, n = memberNames.length; i < n; i++){
                            var memberName = memberNames[i];
                            if (!cur.__parent) {
                                if (cur.prototype[memberName]) {
                                    return memberName;
                                }
                            } else {
                                var alias = StateMachineType.getStateMemberAlias(cur.__path, memberName);
                                if (this[alias]) {
                                    return memberName;
                                }
                            }
                        }
                        cur = cur.__parent;
                    }while (cur);
                }
            }
        ], [
            {
                key: "setupStateMachine",
                value: function setupStateMachine(target) {
                    var targetConstructor = target.constructor;
                    var router = StateMachine.create(targetConstructor);
                    Object.setPrototypeOf(target, router.prototype);
                    target.constructor = targetConstructor;
                    target._initStateMachine();
                }
            },
            {
                key: "create",
                value: function create(type) {
                    if (!type.hasOwnProperty("_sm")) {
                        var stateMachineType = new StateMachineType(type);
                        type._sm = stateMachineType;
                    }
                    return type._sm.router;
                }
            },
            {
                key: "_getStatesUntilLevel",
                value: function _getStatesUntilLevel(state, level) {
                    var states = [];
                    while(state.__level > level){
                        states.push(state);
                        state = state.__parent;
                    }
                    return states;
                }
            },
            {
                key: "_getSharedState",
                value: function _getSharedState(state1, state2) {
                    var state1Array = StateMachine._getAncestorStates(state1);
                    var state2Array = StateMachine._getAncestorStates(state2);
                    var n = Math.min(state1Array.length, state2Array.length);
                    for(var i = 0; i < n; i++){
                        if (state1Array[i] !== state2Array[i]) {
                            return state1Array[i - 1];
                        }
                    }
                    return state1Array[n - 1];
                }
            },
            {
                key: "_getAncestorStates",
                value: function _getAncestorStates(state) {
                    var result = [];
                    do {
                        result.push(state);
                    }while (state = state.__parent);
                    return result.reverse();
                }
            },
            {
                key: "_getStateAtLevel",
                value: function _getStateAtLevel(state, level) {
                    if (level > state.__level) {
                        return undefined;
                    }
                    while(level < state.__level){
                        state = state.__parent;
                    }
                    return state;
                }
            }
        ]);
        return StateMachine;
    }();
    var StateMachineType = /*#__PURE__*/ function() {
        function StateMachineType(type) {
            _class_call_check._(this, StateMachineType);
            this._type = type;
            this._router = null;
            this.init();
        }
        _create_class._(StateMachineType, [
            {
                key: "router",
                get: function get() {
                    return this._router;
                }
            },
            {
                key: "init",
                value: function init() {
                    this._router = this._createRouter();
                    this._stateMap = this._getStateMap();
                    this._addStateMemberDelegatorsToRouter();
                }
            },
            {
                key: "_createRouter",
                value: function _createRouter() {
                    var type = this._type;
                    var router = /*#__PURE__*/ function(type1) {
                        _inherits._(StateMachineRouter, type1);
                        var _super = _create_super._(StateMachineRouter);
                        function StateMachineRouter() {
                            _class_call_check._(this, StateMachineRouter);
                            var _this;
                            _this = _super.call.apply(_super, [
                                this
                            ].concat(Array.prototype.slice.call(arguments)));
                            if (!_this.constructor.hasOwnProperty("_isRouter")) {
                                throw new Error("You need to extend ".concat(type.name, ".original instead of ").concat(type.name, "."));
                            }
                            return _this;
                        }
                        return StateMachineRouter;
                    }(type);
                    router._isRouter = true;
                    router.prototype._routedType = type;
                    router.original = type;
                    this._mixinStateMachineMethods(router);
                    return router;
                }
            },
            {
                key: "_mixinStateMachineMethods",
                value: function _mixinStateMachineMethods(router) {
                    var names = Object.getOwnPropertyNames(StateMachine.prototype);
                    for(var i = 0, n = names.length; i < n; i++){
                        var name = names[i];
                        if (name !== "constructor") {
                            var descriptor = Object.getOwnPropertyDescriptor(StateMachine.prototype, name);
                            Object.defineProperty(router.prototype, name, descriptor);
                        }
                    }
                }
            },
            {
                key: "_addStateMemberDelegatorsToRouter",
                value: function _addStateMemberDelegatorsToRouter() {
                    var _this = this;
                    var members = this._getAllMemberNames();
                    members.forEach(function(member) {
                        _this._addMemberRouter(member);
                    });
                }
            },
            {
                key: "_addMemberRouter",
                value: function _addMemberRouter(member) {
                    var _this = this;
                    var statePaths = Object.keys(this._stateMap);
                    var descriptors = [];
                    var aliases = [];
                    statePaths.forEach(function(statePath, index) {
                        var state = _this._stateMap[statePath];
                        var descriptor = _this._getDescriptor(state, member);
                        if (descriptor) {
                            descriptors[index] = descriptor;
                            var alias = StateMachineType.getStateMemberAlias(descriptor._source.__path, member);
                            aliases[index] = alias;
                            if (!_this._router.prototype.hasOwnProperty(alias)) {
                                Object.defineProperty(_this._router.prototype, alias, descriptor);
                            }
                        } else {
                            descriptors[index] = null;
                            aliases[index] = null;
                        }
                    });
                    var type = undefined;
                    descriptors.forEach(function(descriptor) {
                        if (descriptor) {
                            var descType = _this._getDescriptorType(descriptor);
                            if (type && type !== descType) {
                                console.warn("[Lightning] Member ".concat(member, " in ").concat(_this._type.name, " has inconsistent types."));
                                return;
                            }
                            type = descType;
                        }
                    });
                    switch(type){
                        case "method":
                            this._addMethodRouter(member, descriptors, aliases);
                            break;
                        case "getter":
                            this._addGetterSetterRouters(member);
                            break;
                        case "property":
                            console.warn("[Lightning] Fixed properties are not supported; please use a getter instead!");
                            break;
                    }
                }
            },
            {
                key: "_getDescriptor",
                value: function _getDescriptor(state, member) {
                    var isValid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
                        return true;
                    };
                    var type = state;
                    var curState = state;
                    do {
                        var descriptor = Object.getOwnPropertyDescriptor(type.prototype, member);
                        if (descriptor) {
                            if (isValid(descriptor)) {
                                descriptor._source = curState;
                                return descriptor;
                            }
                        }
                        type = Object.getPrototypeOf(type);
                        if (type && type.hasOwnProperty("__state")) {
                            curState = type;
                        }
                    }while (type && type.prototype);
                    return undefined;
                }
            },
            {
                key: "_getDescriptorType",
                value: function _getDescriptorType(descriptor) {
                    if (descriptor.get || descriptor.set) {
                        return "getter";
                    } else {
                        if (typeof descriptor.value === "function") {
                            return "method";
                        } else {
                            return "property";
                        }
                    }
                }
            },
            {
                key: "_addMethodRouter",
                value: function _addMethodRouter(member, descriptors, aliases) {
                    var code = [
                        "//@ sourceURL=StateMachineRouter.js",
                        "var i = this._stateIndex;"
                    ];
                    var cur = aliases[0];
                    var supportsSpread = StateMachineType._supportsSpread();
                    for(var i = 1, n = aliases.length; i < n; i++){
                        var alias = aliases[i];
                        if (alias !== cur) {
                            if (cur) {
                                if (supportsSpread) {
                                    code.push("if (i < ".concat(i, ') return this["').concat(cur, '"](...arguments); else'));
                                } else {
                                    code.push("if (i < ".concat(i, ') return this["').concat(cur, '"].apply(this, arguments); else'));
                                }
                            } else {
                                code.push("if (i < ".concat(i, ") return ; else"));
                            }
                        }
                        cur = alias;
                    }
                    if (cur) {
                        if (supportsSpread) {
                            code.push('return this["'.concat(cur, '"](...arguments);'));
                        } else {
                            code.push('return this["'.concat(cur, '"].apply(this, arguments);'));
                        }
                    } else {
                        code.push(";");
                    }
                    var functionBody = code.join("\n");
                    var router = new Function([], functionBody);
                    var descriptor = {
                        value: router
                    };
                    Object.defineProperty(this._router.prototype, member, descriptor);
                }
            },
            {
                key: "_addGetterSetterRouters",
                value: function _addGetterSetterRouters(member) {
                    var getter = this._getGetterRouter(member);
                    var setter = this._getSetterRouter(member);
                    var descriptor = {
                        get: getter,
                        set: setter
                    };
                    Object.defineProperty(this._router.prototype, member, descriptor);
                }
            },
            {
                key: "_getGetterRouter",
                value: function _getGetterRouter(member) {
                    var _this = this;
                    var statePaths = Object.keys(this._stateMap);
                    var descriptors = [];
                    var aliases = [];
                    statePaths.forEach(function(statePath, index) {
                        var state = _this._stateMap[statePath];
                        var descriptor = _this._getDescriptor(state, member, function(descriptor) {
                            return descriptor.get;
                        });
                        if (descriptor) {
                            descriptors[index] = descriptor;
                            var alias = StateMachineType.getStateMemberAlias(descriptor._source.__path, member);
                            aliases[index] = alias;
                            if (!_this._router.prototype.hasOwnProperty(alias)) {
                                Object.defineProperty(_this._router.prototype, alias, descriptor);
                            }
                        } else {
                            descriptors[index] = null;
                            aliases[index] = null;
                        }
                    });
                    var code = [
                        "//@ sourceURL=StateMachineRouter.js",
                        "var i = this._stateIndex;"
                    ];
                    var cur = aliases[0];
                    for(var i = 1, n = aliases.length; i < n; i++){
                        var alias = aliases[i];
                        if (alias !== cur) {
                            if (cur) {
                                code.push("if (i < ".concat(i, ') return this["').concat(cur, '"]; else'));
                            } else {
                                code.push("if (i < ".concat(i, ") return ; else"));
                            }
                        }
                        cur = alias;
                    }
                    if (cur) {
                        code.push('return this["'.concat(cur, '"];'));
                    } else {
                        code.push(";");
                    }
                    var functionBody = code.join("\n");
                    var router = new Function([], functionBody);
                    return router;
                }
            },
            {
                key: "_getSetterRouter",
                value: function _getSetterRouter(member) {
                    var _this = this;
                    var statePaths = Object.keys(this._stateMap);
                    var descriptors = [];
                    var aliases = [];
                    statePaths.forEach(function(statePath, index) {
                        var state = _this._stateMap[statePath];
                        var descriptor = _this._getDescriptor(state, member, function(descriptor) {
                            return descriptor.set;
                        });
                        if (descriptor) {
                            descriptors[index] = descriptor;
                            var alias = StateMachineType.getStateMemberAlias(descriptor._source.__path, member);
                            aliases[index] = alias;
                            if (!_this._router.prototype.hasOwnProperty(alias)) {
                                Object.defineProperty(_this._router.prototype, alias, descriptor);
                            }
                        } else {
                            descriptors[index] = null;
                            aliases[index] = null;
                        }
                    });
                    var code = [
                        "//@ sourceURL=StateMachineRouter.js",
                        "var i = this._stateIndex;"
                    ];
                    var cur = aliases[0];
                    for(var i = 1, n = aliases.length; i < n; i++){
                        var alias = aliases[i];
                        if (alias !== cur) {
                            if (cur) {
                                code.push("if (i < ".concat(i, ') this["').concat(cur, '"] = arg; else'));
                            } else {
                                code.push("if (i < ".concat(i, ") ; else"));
                            }
                        }
                        cur = alias;
                    }
                    if (cur) {
                        code.push('this["'.concat(cur, '"] = arg;'));
                    } else {
                        code.push(";");
                    }
                    var functionBody = code.join("\n");
                    var router = new Function([
                        "arg"
                    ], functionBody);
                    return router;
                }
            },
            {
                key: "_getAllMemberNames",
                value: function _getAllMemberNames() {
                    var _this = this;
                    var stateMap = this._stateMap;
                    var map = Object.keys(stateMap);
                    var members = new Set();
                    map.forEach(function(statePath) {
                        if (statePath === "") {
                            return;
                        }
                        var state = stateMap[statePath];
                        var names = _this._getStateMemberNames(state);
                        names.forEach(function(name) {
                            members.add(name);
                        });
                    });
                    return _to_consumable_array._(members);
                }
            },
            {
                key: "_getStateMemberNames",
                value: function _getStateMemberNames(state) {
                    var type = state;
                    var members = new Set();
                    var isRoot = this._type === state;
                    do {
                        var names = this._getStateMemberNamesForType(type);
                        names.forEach(function(name) {
                            members.add(name);
                        });
                        type = Object.getPrototypeOf(type);
                    }while (type && type.prototype && (!type.hasOwnProperty("__state") || isRoot));
                    return members;
                }
            },
            {
                key: "_getStateMemberNamesForType",
                value: function _getStateMemberNamesForType(type) {
                    var memberNames = Object.getOwnPropertyNames(type.prototype);
                    return memberNames.filter(function(memberName) {
                        return memberName !== "constructor" && !StateMachineType._isStateLocalMember(memberName);
                    });
                }
            },
            {
                key: "getStateByPath",
                value: function getStateByPath(statePath) {
                    if (this._stateMap[statePath]) {
                        return this._stateMap[statePath];
                    }
                    var parts = statePath.split(".");
                    while(parts.pop()){
                        var _$statePath = parts.join(".");
                        if (this._stateMap[_$statePath]) {
                            return this._stateMap[_$statePath];
                        }
                    }
                }
            },
            {
                key: "_getStateMap",
                value: function _getStateMap() {
                    if (!this._stateMap) {
                        this._stateMap = this._createStateMap();
                    }
                    return this._stateMap;
                }
            },
            {
                key: "_createStateMap",
                value: function _createStateMap() {
                    var stateMap = {};
                    this._addState(this._type, null, "", stateMap);
                    return stateMap;
                }
            },
            {
                key: "_addState",
                value: function _addState(state, parentState, name, stateMap) {
                    var _this = this;
                    state.__state = true;
                    state.__name = name;
                    this._addStaticStateProperty(state, parentState);
                    var parentPath = parentState ? parentState.__path : "";
                    var path = (parentPath ? parentPath + "." : "") + name;
                    state.__path = path;
                    state.__level = parentState ? parentState.__level + 1 : 0;
                    state.__parent = parentState;
                    state.__index = Object.keys(stateMap).length;
                    stateMap[path] = state;
                    var states = state._states;
                    if (states) {
                        var isInheritedFromParent = parentState && parentState._states === states;
                        if (!isInheritedFromParent) {
                            var subStates = state._states();
                            subStates.forEach(function(subState) {
                                var stateName = StateMachineType._getStateName(subState);
                                _this._addState(subState, state, stateName, stateMap);
                            });
                        }
                    }
                }
            },
            {
                key: "_addStaticStateProperty",
                value: function _addStaticStateProperty(state, parentState) {
                    if (parentState) {
                        var isClassStateLevel = parentState && !parentState.__parent;
                        if (isClassStateLevel) {
                            this._router[state.__name] = state;
                        } else {
                            parentState[state.__name] = state;
                        }
                    }
                }
            }
        ], [
            {
                key: "_supportsSpread",
                value: function _supportsSpread() {
                    if (this.__supportsSpread === undefined) {
                        this.__supportsSpread = false;
                        try {
                            var func = new Function("return [].concat(...arguments);");
                            func();
                            this.__supportsSpread = true;
                        } catch (e) {}
                    }
                    return this.__supportsSpread;
                }
            },
            {
                key: "getStateMemberAlias",
                value: function getStateMemberAlias(path, member) {
                    return "$" + (path ? path + "." : "") + member;
                }
            },
            {
                key: "_isStateLocalMember",
                value: function _isStateLocalMember(memberName) {
                    return memberName === "$enter" || memberName === "$exit";
                }
            },
            {
                key: "_getStateName",
                value: function _getStateName(state) {
                    var name = state.name;
                    var index = name.indexOf("$");
                    if (index > 0) {
                        return name.substr(0, index);
                    }
                    return name;
                }
            }
        ]);
        return StateMachineType;
    }();
    var Component = /*#__PURE__*/ function(Element1) {
        _inherits._(Component, Element1);
        var _super = _create_super._(Component);
        function Component(stage, properties) {
            _class_call_check._(this, Component);
            var _this;
            _this = _super.call(this, stage);
            _this.tagRoot = true;
            if (Utils.isObjectLiteral(properties)) {
                Object.assign(_assert_this_initialized._(_this), properties);
            }
            _this.__initialized = false;
            _this.__firstActive = false;
            _this.__firstEnable = false;
            _this.__signals = undefined;
            _this.__passSignals = undefined;
            _this.__construct();
            var func = _this.constructor.getTemplateFunc(_assert_this_initialized._(_this));
            func.f(_assert_this_initialized._(_this), func.a);
            _this._build();
            return _this;
        }
        _create_class._(Component, [
            {
                key: "__start",
                value: function __start() {
                    StateMachine.setupStateMachine(this);
                    this._onStateChange = Component.prototype.__onStateChange;
                }
            },
            {
                key: "state",
                get: function get() {
                    return this._getState();
                }
            },
            {
                key: "__onStateChange",
                value: function __onStateChange() {
                    if (this.application) {
                        this.application.updateFocusPath();
                    }
                }
            },
            {
                key: "_refocus",
                value: function _refocus() {
                    if (this.application) {
                        this.application.updateFocusPath();
                    }
                }
            },
            {
                key: "__bindProperty",
                value: function __bindProperty(propObj, targetObj, targetProp) {
                    var _this = this, _loop = function(i) {
                        var propName = propDependencies[i];
                        var func = propObj.__func ? propObj.__func : function(context) {
                            return context[propName];
                        };
                        if (!_this.hasOwnProperty(propName)) {
                            _this["__prop_bindings_".concat(propName)] = [
                                {
                                    __obj: obj,
                                    __prop: prop,
                                    __func: func
                                }
                            ];
                            Object.defineProperty(_this, propName, {
                                set: function(value) {
                                    _this1["__prop_".concat(propName)] = value;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = _this1["__prop_bindings_".concat(propName)][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _step_value = _step.value, __obj = _step_value.__obj, __prop = _step_value.__prop, __func = _step_value.__func;
                                            __obj[__prop] = __func(_this1);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                },
                                get: function() {
                                    return _this1["__prop_".concat(propName)];
                                }
                            });
                        } else {
                            _this["__prop_bindings_".concat(propName)].push({
                                __obj: obj,
                                __prop: prop,
                                __func: func
                            });
                        }
                    };
                    var _this1 = this;
                    var obj = targetObj;
                    var prop = targetProp;
                    var propDependencies = Array.isArray(propObj.__name) ? propObj.__name : [
                        propObj.__name
                    ];
                    for(var i = 0; i < propDependencies.length; i++)_loop(i);
                }
            },
            {
                key: "_onSetup",
                value: function _onSetup() {
                    if (!this.__initialized) {
                        this._setup();
                    }
                }
            },
            {
                key: "_setup",
                value: function _setup() {}
            },
            {
                key: "_onAttach",
                value: function _onAttach() {
                    if (!this.__initialized) {
                        this.__init();
                        this.__initialized = true;
                    }
                    this._attach();
                }
            },
            {
                key: "_attach",
                value: function _attach() {}
            },
            {
                key: "_onDetach",
                value: function _onDetach() {
                    this._detach();
                }
            },
            {
                key: "_detach",
                value: function _detach() {}
            },
            {
                key: "_onEnabled",
                value: function _onEnabled() {
                    if (!this.__firstEnable) {
                        this._firstEnable();
                        this.__firstEnable = true;
                    }
                    this._enable();
                }
            },
            {
                key: "_firstEnable",
                value: function _firstEnable() {}
            },
            {
                key: "_enable",
                value: function _enable() {}
            },
            {
                key: "_onDisabled",
                value: function _onDisabled() {
                    this._disable();
                }
            },
            {
                key: "_disable",
                value: function _disable() {}
            },
            {
                key: "_onActive",
                value: function _onActive() {
                    if (!this.__firstActive) {
                        this._firstActive();
                        this.__firstActive = true;
                    }
                    this._active();
                }
            },
            {
                key: "_firstActive",
                value: function _firstActive() {}
            },
            {
                key: "_active",
                value: function _active() {}
            },
            {
                key: "_onInactive",
                value: function _onInactive() {
                    this._inactive();
                }
            },
            {
                key: "_inactive",
                value: function _inactive() {}
            },
            {
                key: "application",
                get: function get() {
                    return this.stage.application;
                }
            },
            {
                key: "__construct",
                value: function __construct() {
                    this._construct();
                }
            },
            {
                key: "_construct",
                value: function _construct() {}
            },
            {
                key: "_build",
                value: function _build() {}
            },
            {
                key: "__init",
                value: function __init() {
                    this._init();
                }
            },
            {
                key: "_init",
                value: function _init() {}
            },
            {
                key: "_focus",
                value: function _focus(newTarget, prevTarget) {}
            },
            {
                key: "_unfocus",
                value: function _unfocus(newTarget) {}
            },
            {
                key: "_focusChange",
                value: function _focusChange(target, newTarget) {}
            },
            {
                key: "_getFocused",
                value: function _getFocused() {
                    return this;
                }
            },
            {
                key: "_setFocusSettings",
                value: function _setFocusSettings(settings) {}
            },
            {
                key: "_handleFocusSettings",
                value: function _handleFocusSettings(settings) {}
            },
            {
                key: "hasFinalFocus",
                value: function hasFinalFocus() {
                    var path = this.application._focusPath;
                    return path && path.length && path[path.length - 1] === this;
                }
            },
            {
                key: "hasFocus",
                value: function hasFocus() {
                    var path = this.application._focusPath;
                    return path && path.indexOf(this) >= 0;
                }
            },
            {
                key: "cparent",
                get: function get() {
                    return Component.getParent(this);
                }
            },
            {
                key: "seekAncestorByType",
                value: function seekAncestorByType(type) {
                    var c = this.cparent;
                    while(c){
                        if (c.constructor === type) {
                            return c;
                        }
                        c = c.cparent;
                    }
                }
            },
            {
                key: "getSharedAncestorComponent",
                value: function getSharedAncestorComponent(element) {
                    var ancestor = this.getSharedAncestor(element);
                    while(ancestor && !ancestor.isComponent){
                        ancestor = ancestor.parent;
                    }
                    return ancestor;
                }
            },
            {
                key: "signals",
                get: function get() {
                    return this.__signals;
                },
                set: function set(v) {
                    if (!Utils.isObjectLiteral(v)) {
                        this._throwError("Signals: specify an object with signal-to-fire mappings");
                    }
                    this.__signals = v;
                }
            },
            {
                key: "alterSignals",
                set: function set(v) {
                    if (!Utils.isObjectLiteral(v)) {
                        this._throwError("Signals: specify an object with signal-to-fire mappings");
                    }
                    if (!this.__signals) {
                        this.__signals = {};
                    }
                    for(var key in v){
                        var d = v[key];
                        if (d === undefined) {
                            delete this.__signals[key];
                        } else {
                            this.__signals[key] = v;
                        }
                    }
                }
            },
            {
                key: "passSignals",
                get: function get() {
                    return this.__passSignals || {};
                },
                set: function set(v) {
                    this.__passSignals = Object.assign(this.__passSignals || {}, v);
                }
            },
            {
                key: "alterPassSignals",
                set: function set(v) {
                    if (!Utils.isObjectLiteral(v)) {
                        this._throwError("Signals: specify an object with signal-to-fire mappings");
                    }
                    if (!this.__passSignals) {
                        this.__passSignals = {};
                    }
                    for(var key in v){
                        var d = v[key];
                        if (d === undefined) {
                            delete this.__passSignals[key];
                        } else {
                            this.__passSignals[key] = v;
                        }
                    }
                }
            },
            {
                key: "signal",
                value: function signal(event) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return this._signal(event, args);
                }
            },
            {
                key: "_signal",
                value: function _signal(event, args) {
                    var signalParent = this._getParentSignalHandler();
                    if (signalParent) {
                        if (this.__signals) {
                            var fireEvent = this.__signals[event];
                            if (fireEvent === false) {
                                return;
                            }
                            if (fireEvent) {
                                if (fireEvent === true) {
                                    fireEvent = event;
                                }
                                if (Utils.isFunction(fireEvent)) {
                                    return fireEvent.apply(void 0, _to_consumable_array._(args));
                                }
                                if (signalParent._hasMethod(fireEvent)) {
                                    var _signalParent;
                                    return (_signalParent = signalParent)[fireEvent].apply(_signalParent, _to_consumable_array._(args));
                                }
                            }
                        }
                        var passSignal = this.__passSignals && this.__passSignals[event];
                        if (passSignal) {
                            if (passSignal && passSignal !== true) {
                                event = passSignal;
                            }
                            return signalParent._signal(event, args);
                        }
                    }
                }
            },
            {
                key: "_getParentSignalHandler",
                value: function _getParentSignalHandler() {
                    return this.cparent ? this.cparent._getSignalHandler() : null;
                }
            },
            {
                key: "_getSignalHandler",
                value: function _getSignalHandler() {
                    if (this._signalProxy) {
                        return this.cparent ? this.cparent._getSignalHandler() : null;
                    }
                    return this;
                }
            },
            {
                key: "_signalProxy",
                get: function get() {
                    return false;
                }
            },
            {
                key: "fireAncestors",
                value: function fireAncestors(name) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    if (!name.startsWith("$")) {
                        throw new Error("Ancestor event name must be prefixed by dollar sign.");
                    }
                    var parent = this._getParentSignalHandler();
                    if (parent) {
                        return parent._doFireAncestors(name, args);
                    }
                }
            },
            {
                key: "_doFireAncestors",
                value: function _doFireAncestors(name, args) {
                    if (this._hasMethod(name)) {
                        return this.fire.apply(this, [
                            name
                        ].concat(_to_consumable_array._(args)));
                    } else {
                        var signalParent = this._getParentSignalHandler();
                        if (signalParent) {
                            return signalParent._doFireAncestors(name, args);
                        }
                    }
                }
            }
        ], [
            {
                key: "bindProp",
                value: function bindProp(name) {
                    var func = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    return {
                        __propertyBinding: true,
                        __name: name,
                        __func: func
                    };
                }
            },
            {
                key: "getTemplateFunc",
                value: function getTemplateFunc(ctx) {
                    var name = "_templateFunc";
                    var hasName = "__has" + name;
                    if (this[hasName] !== this) {
                        this[hasName] = this;
                        this[name] = this.parseTemplate(this._template(ctx));
                    }
                    return this[name];
                }
            },
            {
                key: "parseTemplate",
                value: function parseTemplate(obj) {
                    var context = {
                        loc: [],
                        store: [],
                        rid: 0
                    };
                    this.parseTemplateRec(obj, context, "element");
                    var code = context.loc.join(";\n");
                    var f = new Function("element", "store", code);
                    return {
                        f: f,
                        a: context.store
                    };
                }
            },
            {
                key: "parseTemplateRec",
                value: function parseTemplateRec(obj, context, cursor) {
                    var _this = this;
                    var store = context.store;
                    var loc = context.loc;
                    var keys = Object.keys(obj);
                    keys.forEach(function(key) {
                        var value = obj[key];
                        if (Utils.isUcChar(key.charCodeAt(0))) {
                            if (Utils.isObjectLiteral(value)) {
                                var childCursor = "r".concat(key.replace(/[^a-z0-9]/gi, "") + context.rid);
                                var type = value.type ? value.type : Element;
                                if (type === Element) {
                                    loc.push("var ".concat(childCursor, " = element.stage.createElement()"));
                                } else {
                                    store.push(type);
                                    loc.push("var ".concat(childCursor, " = new store[").concat(store.length - 1, "](").concat(cursor, ".stage)"));
                                }
                                loc.push("".concat(childCursor, '.ref = "').concat(key, '"'));
                                context.rid++;
                                _this.parseTemplateRec(value, context, childCursor);
                                loc.push("".concat(cursor, ".childList.add(").concat(childCursor, ")"));
                            } else if (Utils.isObject(value)) {
                                store.push(value);
                                loc.push("".concat(cursor, ".childList.add(store[").concat(store.length - 1, "])"));
                            }
                        } else {
                            if (key === "text") {
                                var propKey = cursor + "__text";
                                loc.push("var ".concat(propKey, " = ").concat(cursor, ".enableTextTexture()"));
                                if (value.__propertyBinding === true) {
                                    store.push(value);
                                    loc.push("element.__bindProperty(store[".concat(store.length - 1, "], ").concat(cursor, ', "').concat(key, '")'));
                                } else {
                                    _this.parseTemplatePropRec(value, context, propKey);
                                }
                            } else if (key === "shader" && Utils.isObjectLiteral(value)) {
                                var shaderCursor = "".concat(cursor, '["shader"]');
                                store.push(value);
                                loc.push("".concat(cursor, '["').concat(key, '"] = store[').concat(store.length - 1, "]"));
                                _this.parsePropertyBindings(value, context, shaderCursor);
                            } else if (key === "texture" && Utils.isObjectLiteral(value)) {
                                var propKey1 = cursor + "__texture";
                                var type1 = value.type;
                                if (type1) {
                                    store.push(type1);
                                    loc.push("var ".concat(propKey1, " = new store[").concat(store.length - 1, "](").concat(cursor, ".stage)"));
                                    _this.parseTemplatePropRec(value, context, propKey1);
                                    loc.push("".concat(cursor, '["').concat(key, '"] = ').concat(propKey1));
                                } else {
                                    loc.push("".concat(propKey1, " = ").concat(cursor, ".texture"));
                                    _this.parseTemplatePropRec(value, context, propKey1);
                                }
                            } else if (Utils.isObjectLiteral(value) && value.__propertyBinding === true) {
                                store.push(value);
                                loc.push("element.__bindProperty(store[".concat(store.length - 1, "], ").concat(cursor, ', "').concat(key, '")'));
                            } else {
                                if (Utils.isNumber(value)) {
                                    loc.push("".concat(cursor, '["').concat(key, '"] = ').concat(value));
                                } else if (Utils.isBoolean(value)) {
                                    loc.push("".concat(cursor, '["').concat(key, '"] = ').concat(value ? "true" : "false"));
                                } else if (Utils.isObject(value) || Array.isArray(value)) {
                                    store.push(value);
                                    loc.push("".concat(cursor, '["').concat(key, '"] = store[').concat(store.length - 1, "]"));
                                } else {
                                    loc.push("".concat(cursor, '["').concat(key, '"] = ').concat(JSON.stringify(value)));
                                }
                            }
                        }
                    });
                }
            },
            {
                key: "parseTemplatePropRec",
                value: function parseTemplatePropRec(obj, context, cursor) {
                    var store = context.store;
                    var loc = context.loc;
                    var keys = Object.keys(obj);
                    keys.forEach(function(key) {
                        if (key !== "type") {
                            var value = obj[key];
                            if (Utils.isNumber(value)) {
                                loc.push("".concat(cursor, '["').concat(key, '"] = ').concat(value));
                            } else if (Utils.isBoolean(value)) {
                                loc.push("".concat(cursor, '["').concat(key, '"] = ').concat(value ? "true" : "false"));
                            } else if (Utils.isObject(value) && value.__propertyBinding === true) {
                                store.push(value);
                                loc.push("element.__bindProperty(store[".concat(store.length - 1, "], ").concat(cursor, ', "').concat(key, '")'));
                            } else if (Utils.isObject(value) || Array.isArray(value)) {
                                store.push(value);
                                loc.push("".concat(cursor, '["').concat(key, '"] = store[').concat(store.length - 1, "]"));
                            } else {
                                loc.push("".concat(cursor, '["').concat(key, '"] = ').concat(JSON.stringify(value)));
                            }
                        }
                    });
                }
            },
            {
                key: "parsePropertyBindings",
                value: function parsePropertyBindings(obj, context, cursor) {
                    var store = context.store;
                    var loc = context.loc;
                    var keys = Object.keys(obj);
                    keys.forEach(function(key) {
                        if (key !== "type") {
                            var value = obj[key];
                            if (Utils.isObjectLiteral(value) && value.__propertyBinding === true) {
                                store.push(value);
                                loc.push("element.__bindProperty(store[".concat(store.length - 1, "], ").concat(cursor, ', "').concat(key, '")'));
                            }
                        }
                    });
                }
            },
            {
                key: "_template",
                value: function _template() {
                    return {};
                }
            },
            {
                key: "collectSubComponents",
                value: function collectSubComponents(subs, element) {
                    if (element.hasChildren()) {
                        var childList = element.__childList;
                        for(var i = 0, n = childList.length; i < n; i++){
                            var child = childList.getAt(i);
                            if (child.isComponent) {
                                subs.push(child);
                            } else {
                                Component.collectSubComponents(subs, child);
                            }
                        }
                    }
                }
            },
            {
                key: "getComponent",
                value: function getComponent(element) {
                    var parent = element;
                    while(parent && !parent.isComponent){
                        parent = parent.parent;
                    }
                    return parent;
                }
            },
            {
                key: "getParent",
                value: function getParent(element) {
                    return Component.getComponent(element.parent);
                }
            }
        ]);
        return Component;
    }(_wrap_native_super._(Element));
    Component.prototype.isComponent = true;
    var CoreQuadList = /*#__PURE__*/ function() {
        function CoreQuadList(ctx) {
            _class_call_check._(this, CoreQuadList);
            this.ctx = ctx;
            this.quadTextures = [];
            this.quadElements = [];
        }
        _create_class._(CoreQuadList, [
            {
                key: "length",
                get: function get() {
                    return this.quadTextures.length;
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this.quadTextures = [];
                    this.quadElements = [];
                    this.dataLength = 0;
                }
            },
            {
                key: "getElement",
                value: function getElement(index) {
                    return this.quadElements[index]._element;
                }
            },
            {
                key: "getElementCore",
                value: function getElementCore(index) {
                    return this.quadElements[index];
                }
            },
            {
                key: "getTexture",
                value: function getTexture(index) {
                    return this.quadTextures[index];
                }
            },
            {
                key: "getTextureWidth",
                value: function getTextureWidth(index) {
                    var nativeTexture = this.quadTextures[index];
                    if (nativeTexture.w) {
                        return nativeTexture.w;
                    } else {
                        return this.quadElements[index]._displayedTextureSource.w;
                    }
                }
            },
            {
                key: "getTextureHeight",
                value: function getTextureHeight(index) {
                    var nativeTexture = this.quadTextures[index];
                    if (nativeTexture.h) {
                        return nativeTexture.h;
                    } else {
                        return this.quadElements[index]._displayedTextureSource.h;
                    }
                }
            }
        ]);
        return CoreQuadList;
    }();
    var WebGLCoreQuadList = /*#__PURE__*/ function(CoreQuadList) {
        _inherits._(WebGLCoreQuadList, CoreQuadList);
        var _super = _create_super._(WebGLCoreQuadList);
        function WebGLCoreQuadList(ctx) {
            _class_call_check._(this, WebGLCoreQuadList);
            var _this;
            _this = _super.call(this, ctx);
            var byteSize = ctx.stage.getOption("bufferMemory");
            _this.dataLength = 0;
            _this.data = new ArrayBuffer(byteSize);
            _this.floats = new Float32Array(_this.data);
            _this.uints = new Uint32Array(_this.data);
            return _this;
        }
        _create_class._(WebGLCoreQuadList, [
            {
                key: "getAttribsDataByteOffset",
                value: function getAttribsDataByteOffset(index) {
                    return index * 80;
                }
            },
            {
                key: "getQuadContents",
                value: function getQuadContents() {
                    var floats = this.floats;
                    var uints = this.uints;
                    var lines = [];
                    for(var i = 1; i <= this.length; i++){
                        var str = "entry " + i + ": ";
                        for(var j = 0; j < 4; j++){
                            var b = i * 20 + j * 4;
                            str += floats[b] + "," + floats[b + 1] + ":" + floats[b + 2] + "," + floats[b + 3] + "[" + uints[b + 4].toString(16) + "] ";
                        }
                        lines.push(str);
                    }
                    return lines;
                }
            }
        ]);
        return WebGLCoreQuadList;
    }(CoreQuadList);
    var CoreQuadOperation = /*#__PURE__*/ function() {
        function CoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index) {
            _class_call_check._(this, CoreQuadOperation);
            this.ctx = ctx;
            this.shader = shader;
            this.shaderOwner = shaderOwner;
            this.renderTextureInfo = renderTextureInfo;
            this.scissor = scissor;
            this.index = index;
            this.length = 0;
        }
        _create_class._(CoreQuadOperation, [
            {
                key: "quads",
                get: function get() {
                    return this.ctx.renderState.quads;
                }
            },
            {
                key: "getTexture",
                value: function getTexture(index) {
                    return this.quads.getTexture(this.index + index);
                }
            },
            {
                key: "getElementCore",
                value: function getElementCore(index) {
                    return this.quads.getElementCore(this.index + index);
                }
            },
            {
                key: "getElement",
                value: function getElement(index) {
                    return this.quads.getElement(this.index + index);
                }
            },
            {
                key: "getElementWidth",
                value: function getElementWidth(index) {
                    return this.getElement(index).renderWidth;
                }
            },
            {
                key: "getElementHeight",
                value: function getElementHeight(index) {
                    return this.getElement(index).renderHeight;
                }
            },
            {
                key: "getTextureWidth",
                value: function getTextureWidth(index) {
                    return this.quads.getTextureWidth(this.index + index);
                }
            },
            {
                key: "getTextureHeight",
                value: function getTextureHeight(index) {
                    return this.quads.getTextureHeight(this.index + index);
                }
            },
            {
                key: "getRenderWidth",
                value: function getRenderWidth() {
                    if (this.renderTextureInfo) {
                        return this.renderTextureInfo.w;
                    } else {
                        return this.ctx.stage.w;
                    }
                }
            },
            {
                key: "getRenderHeight",
                value: function getRenderHeight() {
                    if (this.renderTextureInfo) {
                        return this.renderTextureInfo.h;
                    } else {
                        return this.ctx.stage.h;
                    }
                }
            }
        ]);
        return CoreQuadOperation;
    }();
    var WebGLCoreQuadOperation = /*#__PURE__*/ function(CoreQuadOperation) {
        _inherits._(WebGLCoreQuadOperation, CoreQuadOperation);
        var _super = _create_super._(WebGLCoreQuadOperation);
        function WebGLCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index) {
            _class_call_check._(this, WebGLCoreQuadOperation);
            var _this;
            _this = _super.call(this, ctx, shader, shaderOwner, renderTextureInfo, scissor, index);
            _this.extraAttribsDataByteOffset = 0;
            return _this;
        }
        _create_class._(WebGLCoreQuadOperation, [
            {
                key: "getAttribsDataByteOffset",
                value: function getAttribsDataByteOffset(index) {
                    return this.quads.getAttribsDataByteOffset(this.index + index);
                }
            },
            {
                key: "getNormalRenderTextureCoords",
                value: function getNormalRenderTextureCoords(x, y) {
                    var coords = this.shaderOwner.getRenderTextureCoords(x, y);
                    coords[0] /= this.getRenderWidth();
                    coords[1] /= this.getRenderHeight();
                    coords[0] = coords[0] * 2 - 1;
                    coords[1] = 1 - coords[1] * 2;
                    return coords;
                }
            },
            {
                key: "getProjection",
                value: function getProjection() {
                    if (this.renderTextureInfo === null) {
                        return this.ctx.renderExec._projection;
                    } else {
                        return this.renderTextureInfo.nativeTexture.projection;
                    }
                }
            }
        ]);
        return WebGLCoreQuadOperation;
    }(CoreQuadOperation);
    var CoreRenderExecutor = /*#__PURE__*/ function() {
        function CoreRenderExecutor(ctx) {
            _class_call_check._(this, CoreRenderExecutor);
            this.ctx = ctx;
            this.renderState = ctx.renderState;
            this.gl = this.ctx.stage.gl;
        }
        _create_class._(CoreRenderExecutor, [
            {
                key: "destroy",
                value: function destroy() {}
            },
            {
                key: "_reset",
                value: function _reset() {
                    this._bindRenderTexture(null);
                    this._setScissor(null);
                    this._clearRenderTexture();
                }
            },
            {
                key: "execute",
                value: function execute() {
                    this._reset();
                    var qops = this.renderState.quadOperations;
                    var i = 0, n = qops.length;
                    while(i < n){
                        this._processQuadOperation(qops[i]);
                        i++;
                    }
                }
            },
            {
                key: "_processQuadOperation",
                value: function _processQuadOperation(quadOperation) {
                    if (quadOperation.renderTextureInfo && quadOperation.renderTextureInfo.ignore) {
                        return;
                    }
                    this._setupQuadOperation(quadOperation);
                    this._execQuadOperation(quadOperation);
                }
            },
            {
                key: "_setupQuadOperation",
                value: function _setupQuadOperation(quadOperation) {}
            },
            {
                key: "_execQuadOperation",
                value: function _execQuadOperation(op) {
                    var nativeTexture = op.renderTextureInfo ? op.renderTextureInfo.nativeTexture : null;
                    if (this._renderTexture !== nativeTexture) {
                        this._bindRenderTexture(nativeTexture);
                    }
                    if (op.renderTextureInfo && !op.renderTextureInfo.cleared) {
                        this._setScissor(null);
                        this._clearRenderTexture();
                        op.renderTextureInfo.cleared = true;
                        this._setScissor(op.scissor);
                    } else {
                        this._setScissor(op.scissor);
                    }
                    this._renderQuadOperation(op);
                }
            },
            {
                key: "_renderQuadOperation",
                value: function _renderQuadOperation(op) {}
            },
            {
                key: "_bindRenderTexture",
                value: function _bindRenderTexture(renderTexture) {
                    this._renderTexture = renderTexture;
                }
            },
            {
                key: "_clearRenderTexture",
                value: function _clearRenderTexture(renderTexture) {}
            },
            {
                key: "_setScissor",
                value: function _setScissor(area) {}
            }
        ]);
        return CoreRenderExecutor;
    }();
    var WebGLCoreRenderExecutor = /*#__PURE__*/ function(CoreRenderExecutor) {
        _inherits._(WebGLCoreRenderExecutor, CoreRenderExecutor);
        var _super = _create_super._(WebGLCoreRenderExecutor);
        function WebGLCoreRenderExecutor(ctx) {
            _class_call_check._(this, WebGLCoreRenderExecutor);
            var _this;
            _this = _super.call(this, ctx);
            _this.gl = _this.ctx.stage.gl;
            _this.init();
            return _this;
        }
        _create_class._(WebGLCoreRenderExecutor, [
            {
                key: "init",
                value: function init() {
                    var gl = this.gl;
                    this._attribsBuffer = gl.createBuffer();
                    var maxQuads = Math.floor(this.renderState.quads.data.byteLength / 80);
                    var allIndices = new Uint16Array(maxQuads * 6);
                    for(var i = 0, j = 0; i < maxQuads; i += 6, j += 4){
                        allIndices[i] = j;
                        allIndices[i + 1] = j + 1;
                        allIndices[i + 2] = j + 2;
                        allIndices[i + 3] = j;
                        allIndices[i + 4] = j + 2;
                        allIndices[i + 5] = j + 3;
                    }
                    this._quadsBuffer = gl.createBuffer();
                    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._quadsBuffer);
                    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, allIndices, gl.STATIC_DRAW);
                    this._projection = new Float32Array([
                        2 / this.ctx.stage.coordsWidth,
                        -2 / this.ctx.stage.coordsHeight
                    ]);
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    _get._(_get_prototype_of._(WebGLCoreRenderExecutor.prototype), "destroy", this).call(this);
                    this.gl.deleteBuffer(this._attribsBuffer);
                    this.gl.deleteBuffer(this._quadsBuffer);
                }
            },
            {
                key: "_reset",
                value: function _reset() {
                    _get._(_get_prototype_of._(WebGLCoreRenderExecutor.prototype), "_reset", this).call(this);
                    var gl = this.gl;
                    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                    gl.enable(gl.BLEND);
                    gl.disable(gl.DEPTH_TEST);
                    this._stopShaderProgram();
                    this._setupBuffers();
                }
            },
            {
                key: "_setupBuffers",
                value: function _setupBuffers() {
                    var gl = this.gl;
                    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._quadsBuffer);
                    var element = new Float32Array(this.renderState.quads.data, 0, this.renderState.quads.dataLength);
                    gl.bindBuffer(gl.ARRAY_BUFFER, this._attribsBuffer);
                    gl.bufferData(gl.ARRAY_BUFFER, element, gl.DYNAMIC_DRAW);
                }
            },
            {
                key: "_setupQuadOperation",
                value: function _setupQuadOperation(quadOperation) {
                    _get._(_get_prototype_of._(WebGLCoreRenderExecutor.prototype), "_setupQuadOperation", this).call(this, quadOperation);
                    this._useShaderProgram(quadOperation.shader, quadOperation);
                }
            },
            {
                key: "_renderQuadOperation",
                value: function _renderQuadOperation(op) {
                    var shader = op.shader;
                    if (op.length || op.shader.addEmpty()) {
                        shader.beforeDraw(op);
                        shader.draw(op);
                        shader.afterDraw(op);
                    }
                }
            },
            {
                key: "_useShaderProgram",
                value: function _useShaderProgram(shader, operation) {
                    if (!shader.hasSameProgram(this._currentShaderProgram)) {
                        if (this._currentShaderProgram) {
                            this._currentShaderProgram.stopProgram();
                        }
                        shader.useProgram();
                        this._currentShaderProgram = shader;
                    }
                    shader.setupUniforms(operation);
                }
            },
            {
                key: "_stopShaderProgram",
                value: function _stopShaderProgram() {
                    if (this._currentShaderProgram) {
                        this._currentShaderProgram.stopProgram();
                        this._currentShaderProgram = null;
                    }
                }
            },
            {
                key: "_bindRenderTexture",
                value: function _bindRenderTexture(renderTexture) {
                    _get._(_get_prototype_of._(WebGLCoreRenderExecutor.prototype), "_bindRenderTexture", this).call(this, renderTexture);
                    var gl = this.gl;
                    if (!this._renderTexture) {
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                        gl.viewport(0, 0, this.ctx.stage.w, this.ctx.stage.h);
                    } else {
                        gl.bindFramebuffer(gl.FRAMEBUFFER, this._renderTexture.framebuffer);
                        gl.viewport(0, 0, this._renderTexture.w, this._renderTexture.h);
                    }
                }
            },
            {
                key: "_clearRenderTexture",
                value: function _clearRenderTexture() {
                    _get._(_get_prototype_of._(WebGLCoreRenderExecutor.prototype), "_clearRenderTexture", this).call(this);
                    var gl = this.gl;
                    if (!this._renderTexture) {
                        var glClearColor = this.ctx.stage.getClearColor();
                        if (glClearColor) {
                            gl.clearColor(glClearColor[0] * glClearColor[3], glClearColor[1] * glClearColor[3], glClearColor[2] * glClearColor[3], glClearColor[3]);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                        }
                    } else {
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                }
            },
            {
                key: "_setScissor",
                value: function _setScissor(area) {
                    _get._(_get_prototype_of._(WebGLCoreRenderExecutor.prototype), "_setScissor", this).call(this, area);
                    if (this._scissor === area) {
                        return;
                    }
                    this._scissor = area;
                    var gl = this.gl;
                    if (!area) {
                        gl.disable(gl.SCISSOR_TEST);
                    } else {
                        gl.enable(gl.SCISSOR_TEST);
                        var precision = this.ctx.stage.getRenderPrecision();
                        var y = area[1];
                        if (this._renderTexture === null) {
                            y = this.ctx.stage.h / precision - (area[1] + area[3]);
                        }
                        gl.scissor(Math.round(area[0] * precision), Math.round(y * precision), Math.round(area[2] * precision), Math.round(area[3] * precision));
                    }
                }
            }
        ]);
        return WebGLCoreRenderExecutor;
    }(CoreRenderExecutor);
    var CoreRenderState = /*#__PURE__*/ function() {
        function CoreRenderState(ctx) {
            _class_call_check._(this, CoreRenderState);
            this.ctx = ctx;
            this.stage = ctx.stage;
            this.defaultShader = this.stage.renderer.getDefaultShader(ctx);
            this.renderer = ctx.stage.renderer;
            this.quads = this.renderer.createCoreQuadList(ctx);
        }
        _create_class._(CoreRenderState, [
            {
                key: "reset",
                value: function reset() {
                    this._renderTextureInfo = null;
                    this._scissor = null;
                    this._shader = null;
                    this._shaderOwner = null;
                    this._realShader = null;
                    this._check = false;
                    this.quadOperations = [];
                    this._texturizer = null;
                    this._texturizerTemporary = false;
                    this._quadOperation = null;
                    this.quads.reset();
                    this._temporaryTexturizers = [];
                    this._isCachingTexturizer = false;
                }
            },
            {
                key: "length",
                get: function get() {
                    return this.quads.quadTextures.length;
                }
            },
            {
                key: "setShader",
                value: function setShader(shader, owner) {
                    if (this._shaderOwner !== owner || this._realShader !== shader) {
                        this._realShader = shader;
                        if (shader.useDefault()) {
                            shader = this.defaultShader;
                        }
                        if (this._shader !== shader || this._shaderOwner !== owner) {
                            this._shader = shader;
                            this._shaderOwner = owner;
                            this._check = true;
                        }
                    }
                }
            },
            {
                key: "renderTextureInfo",
                get: function get() {
                    return this._renderTextureInfo;
                }
            },
            {
                key: "setScissor",
                value: function setScissor(area) {
                    if (this._scissor !== area) {
                        if (area) {
                            this._scissor = area;
                        } else {
                            this._scissor = null;
                        }
                        this._check = true;
                    }
                }
            },
            {
                key: "getScissor",
                value: function getScissor() {
                    return this._scissor;
                }
            },
            {
                key: "setRenderTextureInfo",
                value: function setRenderTextureInfo(renderTextureInfo) {
                    if (this._renderTextureInfo !== renderTextureInfo) {
                        this._renderTextureInfo = renderTextureInfo;
                        this._scissor = null;
                        this._check = true;
                    }
                }
            },
            {
                key: "setTexturizer",
                value: function setTexturizer(texturizer) {
                    var cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    this._texturizer = texturizer;
                    this._cacheTexturizer = cache;
                }
            },
            {
                key: "isCachingTexturizer",
                get: function get() {
                    return this._isCachingTexturizer;
                },
                set: function set(v) {
                    this._isCachingTexturizer = v;
                }
            },
            {
                key: "addQuad",
                value: function addQuad(elementCore) {
                    if (!this._quadOperation) {
                        this._createQuadOperation();
                    } else if (this._check && this._hasChanges()) {
                        this._finishQuadOperation();
                        this._check = false;
                    }
                    var nativeTexture = null;
                    if (this._texturizer) {
                        nativeTexture = this._texturizer.getResultTexture();
                        if (!this._cacheTexturizer) {
                            this._temporaryTexturizers.push(this._texturizer);
                        }
                    }
                    if (!nativeTexture) {
                        nativeTexture = elementCore._displayedTextureSource.nativeTexture;
                    }
                    if (this._renderTextureInfo) {
                        if (this._shader === this.defaultShader && this._renderTextureInfo.empty) {
                            this._renderTextureInfo.nativeTexture = nativeTexture;
                            this._renderTextureInfo.offset = this.length;
                        } else {
                            this._renderTextureInfo.nativeTexture = null;
                        }
                        this._renderTextureInfo.empty = false;
                    }
                    this.quads.quadTextures.push(nativeTexture);
                    this.quads.quadElements.push(elementCore);
                    this._quadOperation.length++;
                    this.renderer.addQuad(this, this.quads, this.length - 1);
                }
            },
            {
                key: "finishedRenderTexture",
                value: function finishedRenderTexture() {
                    if (this._renderTextureInfo.nativeTexture) {
                        if (!this._isRenderTextureReusable()) {
                            this._renderTextureInfo.nativeTexture = null;
                        }
                    }
                }
            },
            {
                key: "_isRenderTextureReusable",
                value: function _isRenderTextureReusable() {
                    var offset = this._renderTextureInfo.offset;
                    return this.quads.quadTextures[offset].w === this._renderTextureInfo.w && this.quads.quadTextures[offset].h === this._renderTextureInfo.h && this.renderer.isRenderTextureReusable(this, this._renderTextureInfo);
                }
            },
            {
                key: "_hasChanges",
                value: function _hasChanges() {
                    var q = this._quadOperation;
                    if (this._shader !== q.shader) return true;
                    if (this._shaderOwner !== q.shaderOwner) return true;
                    if (this._renderTextureInfo !== q.renderTextureInfo) return true;
                    if (this._scissor !== q.scissor) {
                        if (this._scissor[0] !== q.scissor[0] || this._scissor[1] !== q.scissor[1] || this._scissor[2] !== q.scissor[2] || this._scissor[3] !== q.scissor[3]) {
                            return true;
                        }
                    }
                    return false;
                }
            },
            {
                key: "_finishQuadOperation",
                value: function _finishQuadOperation() {
                    var create = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                    if (this._quadOperation) {
                        if (this._quadOperation.length || this._shader.addEmpty()) {
                            if (!this._quadOperation.scissor || this._quadOperation.scissor[2] > 0 && this._quadOperation.scissor[3] > 0) {
                                this.quadOperations.push(this._quadOperation);
                            }
                        }
                        if (this._temporaryTexturizers.length) {
                            for(var i = 0, n = this._temporaryTexturizers.length; i < n; i++){
                                this._temporaryTexturizers[i].releaseRenderTexture();
                            }
                            this._temporaryTexturizers = [];
                        }
                        this._quadOperation = null;
                    }
                    if (create) {
                        this._createQuadOperation();
                    }
                }
            },
            {
                key: "_createQuadOperation",
                value: function _createQuadOperation() {
                    this._quadOperation = this.renderer.createCoreQuadOperation(this.ctx, this._shader, this._shaderOwner, this._renderTextureInfo, this._scissor, this.length);
                    this._check = false;
                }
            },
            {
                key: "finish",
                value: function finish() {
                    if (this._quadOperation) {
                        this._finishQuadOperation(false);
                    }
                    this.renderer.finishRenderState(this);
                }
            }
        ]);
        return CoreRenderState;
    }();
    var WebGLShaderProgram = /*#__PURE__*/ function() {
        function WebGLShaderProgram(vertexShaderSource, fragmentShaderSource) {
            _class_call_check._(this, WebGLShaderProgram);
            this.vertexShaderSource = vertexShaderSource;
            this.fragmentShaderSource = fragmentShaderSource;
            this._program = null;
            this._uniformLocations = new Map();
            this._attributeLocations = new Map();
            this._currentUniformValues = {};
        }
        _create_class._(WebGLShaderProgram, [
            {
                key: "compile",
                value: function compile(gl) {
                    if (this._program) return;
                    this.gl = gl;
                    this._program = gl.createProgram();
                    var glVertShader = this._glCompile(gl.VERTEX_SHADER, this.vertexShaderSource);
                    var glFragShader = this._glCompile(gl.FRAGMENT_SHADER, this.fragmentShaderSource);
                    gl.attachShader(this._program, glVertShader);
                    gl.attachShader(this._program, glFragShader);
                    gl.linkProgram(this._program);
                    if (!gl.getProgramParameter(this._program, gl.LINK_STATUS)) {
                        console.error("[Lightning] Error: Could not initialize shader.");
                        console.error("[Lightning] gl.VALIDATE_STATUS", gl.getProgramParameter(this._program, gl.VALIDATE_STATUS));
                        console.error("[Lightning] gl.getError()", gl.getError());
                        if (gl.getProgramInfoLog(this._program) !== "") {
                            console.warn("[Lightning] Warning: gl.getProgramInfoLog()", gl.getProgramInfoLog(this._program));
                        }
                        gl.deleteProgram(this._program);
                        this._program = null;
                    }
                    gl.deleteShader(glVertShader);
                    gl.deleteShader(glFragShader);
                }
            },
            {
                key: "_glCompile",
                value: function _glCompile(type, src) {
                    var shader = this.gl.createShader(type);
                    this.gl.shaderSource(shader, src);
                    this.gl.compileShader(shader);
                    if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
                        console.error("[Lightning]", this.constructor.name, "Type: " + (type === this.gl.VERTEX_SHADER ? "vertex shader" : "fragment shader"));
                        console.error("[Lightning]", this.gl.getShaderInfoLog(shader));
                        var idx = 0;
                        console.error("[Lightning]", "========== source ==========\n" + src.split("\n").map(function(line) {
                            return "" + ++idx + ": " + line;
                        }).join("\n"));
                        return null;
                    }
                    return shader;
                }
            },
            {
                key: "getUniformLocation",
                value: function getUniformLocation(name) {
                    var location = this._uniformLocations.get(name);
                    if (location === undefined) {
                        location = this.gl.getUniformLocation(this._program, name);
                        this._uniformLocations.set(name, location);
                    }
                    return location;
                }
            },
            {
                key: "getAttribLocation",
                value: function getAttribLocation(name) {
                    var location = this._attributeLocations.get(name);
                    if (location === undefined) {
                        location = this.gl.getAttribLocation(this._program, name);
                        this._attributeLocations.set(name, location);
                    }
                    return location;
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    if (this._program) {
                        this.gl.deleteProgram(this._program);
                        this._program = null;
                    }
                }
            },
            {
                key: "glProgram",
                get: function get() {
                    return this._program;
                }
            },
            {
                key: "compiled",
                get: function get() {
                    return !!this._program;
                }
            },
            {
                key: "_valueEquals",
                value: function _valueEquals(v1, v2) {
                    if (v1.length && v2.length) {
                        for(var i = 0, n = v1.length; i < n; i++){
                            if (v1[i] !== v2[i]) return false;
                        }
                        return true;
                    } else {
                        return v1 === v2;
                    }
                }
            },
            {
                key: "_valueClone",
                value: function _valueClone(v) {
                    if (v.length) {
                        return v.slice(0);
                    } else {
                        return v;
                    }
                }
            },
            {
                key: "setUniformValue",
                value: function setUniformValue(name, value, glFunction) {
                    var v = this._currentUniformValues[name];
                    if (v === undefined || !this._valueEquals(v, value)) {
                        var clonedValue = this._valueClone(value);
                        this._currentUniformValues[name] = clonedValue;
                        var loc = this.getUniformLocation(name);
                        if (loc) {
                            var isMatrix = glFunction === this.gl.uniformMatrix2fv || glFunction === this.gl.uniformMatrix3fv || glFunction === this.gl.uniformMatrix4fv;
                            if (isMatrix) {
                                glFunction.call(this.gl, loc, false, clonedValue);
                            } else {
                                glFunction.call(this.gl, loc, clonedValue);
                            }
                        }
                    }
                }
            }
        ]);
        return WebGLShaderProgram;
    }();
    var WebGLShader = /*#__PURE__*/ function(Shader) {
        _inherits._(WebGLShader, Shader);
        var _super = _create_super._(WebGLShader);
        function WebGLShader(ctx) {
            _class_call_check._(this, WebGLShader);
            var _this;
            _this = _super.call(this, ctx);
            var stage = ctx.stage;
            _this._program = stage.renderer.shaderPrograms.get(_this.constructor);
            if (!_this._program) {
                _this._program = new WebGLShaderProgram(_this.constructor.vertexShaderSource, _this.constructor.fragmentShaderSource);
                stage.renderer.shaderPrograms.set(_this.constructor, _this._program);
            }
            _this.gl = stage.gl;
            return _this;
        }
        _create_class._(WebGLShader, [
            {
                key: "glProgram",
                get: function get() {
                    return this._program.glProgram;
                }
            },
            {
                key: "_init",
                value: function _init() {
                    if (!this._initialized) {
                        this.initialize();
                        this._initialized = true;
                    }
                }
            },
            {
                key: "initialize",
                value: function initialize() {
                    this._program.compile(this.gl);
                }
            },
            {
                key: "initialized",
                get: function get() {
                    return this._initialized;
                }
            },
            {
                key: "_uniform",
                value: function _uniform(name) {
                    return this._program.getUniformLocation(name);
                }
            },
            {
                key: "_attrib",
                value: function _attrib(name) {
                    return this._program.getAttribLocation(name);
                }
            },
            {
                key: "_setUniform",
                value: function _setUniform(name, value, glFunction) {
                    this._program.setUniformValue(name, value, glFunction);
                }
            },
            {
                key: "useProgram",
                value: function useProgram() {
                    this._init();
                    this.gl.useProgram(this.glProgram);
                    this.beforeUsage();
                    this.enableAttribs();
                }
            },
            {
                key: "stopProgram",
                value: function stopProgram() {
                    this.afterUsage();
                    this.disableAttribs();
                }
            },
            {
                key: "hasSameProgram",
                value: function hasSameProgram(other) {
                    return other && (other === this || other._program === this._program);
                }
            },
            {
                key: "beforeUsage",
                value: function beforeUsage() {}
            },
            {
                key: "afterUsage",
                value: function afterUsage() {}
            },
            {
                key: "enableAttribs",
                value: function enableAttribs() {}
            },
            {
                key: "disableAttribs",
                value: function disableAttribs() {}
            },
            {
                key: "getExtraAttribBytesPerVertex",
                value: function getExtraAttribBytesPerVertex() {
                    return 0;
                }
            },
            {
                key: "getVertexAttribPointerOffset",
                value: function getVertexAttribPointerOffset(operation) {
                    return operation.extraAttribsDataByteOffset - operation.index * 4 * this.getExtraAttribBytesPerVertex();
                }
            },
            {
                key: "setExtraAttribsInBuffer",
                value: function setExtraAttribsInBuffer(operation) {}
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {}
            },
            {
                key: "_getProjection",
                value: function _getProjection(operation) {
                    return operation.getProjection();
                }
            },
            {
                key: "getFlipY",
                value: function getFlipY(operation) {
                    return this._getProjection(operation)[1] < 0;
                }
            },
            {
                key: "beforeDraw",
                value: function beforeDraw(operation) {}
            },
            {
                key: "draw",
                value: function draw(operation) {}
            },
            {
                key: "afterDraw",
                value: function afterDraw(operation) {}
            },
            {
                key: "cleanup",
                value: function cleanup() {
                    this._initialized = false;
                }
            }
        ]);
        return WebGLShader;
    }(Shader);
    var DefaultShader = /*#__PURE__*/ function(WebGLShader) {
        _inherits._(DefaultShader, WebGLShader);
        var _super = _create_super._(DefaultShader);
        function DefaultShader() {
            _class_call_check._(this, DefaultShader);
            return _super.apply(this, arguments);
        }
        _create_class._(DefaultShader, [
            {
                key: "enableAttribs",
                value: function enableAttribs() {
                    var gl = this.gl;
                    gl.vertexAttribPointer(this._attrib("aVertexPosition"), 2, gl.FLOAT, false, 20, 0);
                    gl.enableVertexAttribArray(this._attrib("aVertexPosition"));
                    if (this._attrib("aTextureCoord") !== -1) {
                        gl.vertexAttribPointer(this._attrib("aTextureCoord"), 2, gl.FLOAT, false, 20, 2 * 4);
                        gl.enableVertexAttribArray(this._attrib("aTextureCoord"));
                    }
                    if (this._attrib("aColor") !== -1) {
                        gl.vertexAttribPointer(this._attrib("aColor"), 4, gl.UNSIGNED_BYTE, true, 20, 4 * 4);
                        gl.enableVertexAttribArray(this._attrib("aColor"));
                    }
                }
            },
            {
                key: "disableAttribs",
                value: function disableAttribs() {
                    var gl = this.gl;
                    gl.disableVertexAttribArray(this._attrib("aVertexPosition"));
                    if (this._attrib("aTextureCoord") !== -1) {
                        gl.disableVertexAttribArray(this._attrib("aTextureCoord"));
                    }
                    if (this._attrib("aColor") !== -1) {
                        gl.disableVertexAttribArray(this._attrib("aColor"));
                    }
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    this._setUniform("projection", this._getProjection(operation), this.gl.uniform2fv, false);
                }
            },
            {
                key: "draw",
                value: function draw(operation) {
                    var gl = this.gl;
                    var length = operation.length;
                    if (length) {
                        var glTexture = operation.getTexture(0);
                        var pos = 0;
                        for(var i = 0; i < length; i++){
                            var tx = operation.getTexture(i);
                            if (glTexture !== tx) {
                                gl.bindTexture(gl.TEXTURE_2D, glTexture);
                                gl.drawElements(gl.TRIANGLES, 6 * (i - pos), gl.UNSIGNED_SHORT, (pos + operation.index) * 6 * 2);
                                glTexture = tx;
                                pos = i;
                            }
                        }
                        if (pos < length) {
                            gl.bindTexture(gl.TEXTURE_2D, glTexture);
                            gl.drawElements(gl.TRIANGLES, 6 * (length - pos), gl.UNSIGNED_SHORT, (pos + operation.index) * 6 * 2);
                        }
                    }
                }
            }
        ]);
        return DefaultShader;
    }(_wrap_native_super._(WebGLShader));
    DefaultShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    DefaultShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    void main(void){\n        gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor;\n    }\n";
    var Renderer = /*#__PURE__*/ function() {
        function Renderer(stage) {
            _class_call_check._(this, Renderer);
            this.stage = stage;
            this._defaultShader = undefined;
        }
        _create_class._(Renderer, [
            {
                key: "gc",
                value: function gc(aggressive) {}
            },
            {
                key: "destroy",
                value: function destroy() {}
            },
            {
                key: "getDefaultShader",
                value: function getDefaultShader() {
                    var ctx = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.stage.ctx;
                    if (!this._defaultShader) {
                        this._defaultShader = this._createDefaultShader(ctx);
                    }
                    return this._defaultShader;
                }
            },
            {
                key: "_createDefaultShader",
                value: function _createDefaultShader(ctx) {}
            },
            {
                key: "isValidShaderType",
                value: function isValidShaderType(shaderType) {
                    return shaderType.prototype instanceof this._getShaderBaseType();
                }
            },
            {
                key: "createShader",
                value: function createShader(ctx, settings) {
                    var shaderType = settings.type;
                    if (!this.isValidShaderType(shaderType)) {
                        var convertedShaderType = this._getShaderAlternative(shaderType);
                        if (!convertedShaderType) {
                            console.warn("[Lightning] Shader has no implementation for render target: " + shaderType.name);
                            return this._createDefaultShader(ctx);
                        }
                        return new convertedShaderType(ctx);
                    } else {
                        var shader = new shaderType(ctx);
                        Base.patchObject(this, settings);
                        return shader;
                    }
                }
            },
            {
                key: "_getShaderBaseType",
                value: function _getShaderBaseType() {}
            },
            {
                key: "_getShaderAlternative",
                value: function _getShaderAlternative(shaderType) {
                    return this.getDefaultShader();
                }
            },
            {
                key: "copyRenderTexture",
                value: function copyRenderTexture(renderTexture, nativeTexture, options) {
                    console.warn("[Lightning] copyRenderTexture not supported by renderer");
                }
            }
        ]);
        return Renderer;
    }();
    var WebGLRenderer = /*#__PURE__*/ function(Renderer) {
        _inherits._(WebGLRenderer, Renderer);
        var _super = _create_super._(WebGLRenderer);
        function WebGLRenderer(stage) {
            _class_call_check._(this, WebGLRenderer);
            var _this;
            _this = _super.call(this, stage);
            _this.shaderPrograms = new Map();
            _this._compressedTextureExtensions = {
                astc: stage.gl.getExtension("WEBGL_compressed_texture_astc"),
                etc1: stage.gl.getExtension("WEBGL_compressed_texture_etc1"),
                s3tc: stage.gl.getExtension("WEBGL_compressed_texture_s3tc"),
                pvrtc: stage.gl.getExtension("WEBGL_compressed_texture_pvrtc")
            };
            return _this;
        }
        _create_class._(WebGLRenderer, [
            {
                key: "getCompressedTextureExtensions",
                value: function getCompressedTextureExtensions() {
                    return this._compressedTextureExtensions;
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    this.shaderPrograms.forEach(function(shaderProgram) {
                        return shaderProgram.destroy();
                    });
                }
            },
            {
                key: "_createDefaultShader",
                value: function _createDefaultShader(ctx) {
                    return new DefaultShader(ctx);
                }
            },
            {
                key: "_getShaderBaseType",
                value: function _getShaderBaseType() {
                    return WebGLShader;
                }
            },
            {
                key: "_getShaderAlternative",
                value: function _getShaderAlternative(shaderType) {
                    return shaderType.getWebGL && shaderType.getWebGL();
                }
            },
            {
                key: "createCoreQuadList",
                value: function createCoreQuadList(ctx) {
                    return new WebGLCoreQuadList(ctx);
                }
            },
            {
                key: "createCoreQuadOperation",
                value: function createCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index) {
                    return new WebGLCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index);
                }
            },
            {
                key: "createCoreRenderExecutor",
                value: function createCoreRenderExecutor(ctx) {
                    return new WebGLCoreRenderExecutor(ctx);
                }
            },
            {
                key: "createCoreRenderState",
                value: function createCoreRenderState(ctx) {
                    return new CoreRenderState(ctx);
                }
            },
            {
                key: "createRenderTexture",
                value: function createRenderTexture(w, h, pw, ph) {
                    var gl = this.stage.gl;
                    var glTexture = gl.createTexture();
                    gl.bindTexture(gl.TEXTURE_2D, glTexture);
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, pw, ph, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    glTexture.params = {};
                    glTexture.params[gl.TEXTURE_MAG_FILTER] = gl.LINEAR;
                    glTexture.params[gl.TEXTURE_MIN_FILTER] = gl.LINEAR;
                    glTexture.params[gl.TEXTURE_WRAP_S] = gl.CLAMP_TO_EDGE;
                    glTexture.params[gl.TEXTURE_WRAP_T] = gl.CLAMP_TO_EDGE;
                    glTexture.options = {
                        format: gl.RGBA,
                        internalFormat: gl.RGBA,
                        type: gl.UNSIGNED_BYTE
                    };
                    glTexture.framebuffer = gl.createFramebuffer();
                    glTexture.projection = new Float32Array([
                        2 / w,
                        2 / h
                    ]);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, glTexture.framebuffer);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, glTexture, 0);
                    return glTexture;
                }
            },
            {
                key: "freeRenderTexture",
                value: function freeRenderTexture(glTexture) {
                    var gl = this.stage.gl;
                    gl.deleteFramebuffer(glTexture.framebuffer);
                    gl.deleteTexture(glTexture);
                }
            },
            {
                key: "_getBytesPerPixel",
                value: function _getBytesPerPixel(fmt, type) {
                    var gl = this.stage.gl;
                    if (fmt === gl.RGBA) {
                        switch(type){
                            case gl.UNSIGNED_BYTE:
                                return 4;
                            case gl.UNSIGNED_SHORT_4_4_4_4:
                                return 2;
                            case gl.UNSIGNED_SHORT_5_5_5_1:
                                return 2;
                            default:
                                throw new Error("Invalid type specified for GL_RGBA format");
                        }
                    } else if (fmt === gl.RGB) {
                        switch(type){
                            case gl.UNSIGNED_BYTE:
                                return 3;
                            case gl.UNSIGNED_BYTE_5_6_5:
                                return 2;
                            default:
                                throw new Error("Invalid type specified for GL_RGB format");
                        }
                    } else {
                        throw new Error("Invalid format specified in call to _getBytesPerPixel()");
                    }
                }
            },
            {
                key: "uploadTextureSource",
                value: function uploadTextureSource(textureSource, options) {
                    var gl = this.stage.gl;
                    var source = options.source;
                    var compressed = false;
                    if (options.renderInfo) {
                        compressed = options.renderInfo.compressed || false;
                    }
                    var format = {
                        premultiplyAlpha: true,
                        hasAlpha: true
                    };
                    if (options && options.hasOwnProperty("premultiplyAlpha")) {
                        format.premultiplyAlpha = options.premultiplyAlpha;
                    }
                    if (options && options.hasOwnProperty("flipBlueRed")) {
                        format.flipBlueRed = options.flipBlueRed;
                    }
                    if (options && options.hasOwnProperty("hasAlpha")) {
                        format.hasAlpha = options.hasAlpha;
                    }
                    if (!format.hasAlpha) {
                        format.premultiplyAlpha = false;
                    }
                    format.texParams = options.texParams || {};
                    format.texOptions = options.texOptions || {};
                    var glTexture = gl.createTexture();
                    gl.bindTexture(gl.TEXTURE_2D, glTexture);
                    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, format.premultiplyAlpha);
                    if (Utils.isNode) {
                        gl.pixelStorei(gl.UNPACK_FLIP_BLUE_RED, !!format.flipBlueRed);
                    }
                    var texParams = format.texParams;
                    if (!texParams[gl.TEXTURE_MAG_FILTER]) texParams[gl.TEXTURE_MAG_FILTER] = gl.LINEAR;
                    if (!texParams[gl.TEXTURE_MIN_FILTER]) texParams[gl.TEXTURE_MIN_FILTER] = gl.LINEAR;
                    if (!texParams[gl.TEXTURE_WRAP_S]) texParams[gl.TEXTURE_WRAP_S] = gl.CLAMP_TO_EDGE;
                    if (!texParams[gl.TEXTURE_WRAP_T]) texParams[gl.TEXTURE_WRAP_T] = gl.CLAMP_TO_EDGE;
                    Object.keys(texParams).forEach(function(key) {
                        var value = texParams[key];
                        gl.texParameteri(gl.TEXTURE_2D, parseInt(key), value);
                    });
                    if (compressed) {
                        this.stage.platform.uploadCompressedGlTexture(gl, textureSource, source);
                        return glTexture;
                    }
                    var texOptions = format.texOptions;
                    texOptions.format = texOptions.format || (format.hasAlpha ? gl.RGBA : gl.RGB);
                    texOptions.type = texOptions.type || gl.UNSIGNED_BYTE;
                    texOptions.internalFormat = texOptions.internalFormat || texOptions.format;
                    if (options && options.imageRef) {
                        texOptions.imageRef = options.imageRef;
                    }
                    this.stage.platform.uploadGlTexture(gl, textureSource, source, texOptions);
                    glTexture.params = Utils.cloneObjShallow(texParams);
                    glTexture.options = Utils.cloneObjShallow(texOptions);
                    glTexture.bytesPerPixel = this._getBytesPerPixel(texOptions.format, texOptions.type);
                    return glTexture;
                }
            },
            {
                key: "freeTextureSource",
                value: function freeTextureSource(textureSource) {
                    this.stage.gl.deleteTexture(textureSource.nativeTexture);
                }
            },
            {
                key: "addQuad",
                value: function addQuad(renderState, quads, index) {
                    var offset = index * 20;
                    var elementCore = quads.quadElements[index];
                    var r = elementCore._renderContext;
                    var floats = renderState.quads.floats;
                    var uints = renderState.quads.uints;
                    var mca = StageUtils.mergeColorAlpha;
                    if (r.tb !== 0 || r.tc !== 0) {
                        floats[offset++] = r.px;
                        floats[offset++] = r.py;
                        floats[offset++] = elementCore._ulx;
                        floats[offset++] = elementCore._uly;
                        uints[offset++] = mca(elementCore._colorUl, r.alpha);
                        floats[offset++] = r.px + elementCore._w * r.ta;
                        floats[offset++] = r.py + elementCore._w * r.tc;
                        floats[offset++] = elementCore._brx;
                        floats[offset++] = elementCore._uly;
                        uints[offset++] = mca(elementCore._colorUr, r.alpha);
                        floats[offset++] = r.px + elementCore._w * r.ta + elementCore._h * r.tb;
                        floats[offset++] = r.py + elementCore._w * r.tc + elementCore._h * r.td;
                        floats[offset++] = elementCore._brx;
                        floats[offset++] = elementCore._bry;
                        uints[offset++] = mca(elementCore._colorBr, r.alpha);
                        floats[offset++] = r.px + elementCore._h * r.tb;
                        floats[offset++] = r.py + elementCore._h * r.td;
                        floats[offset++] = elementCore._ulx;
                        floats[offset++] = elementCore._bry;
                        uints[offset] = mca(elementCore._colorBl, r.alpha);
                    } else {
                        var cx = r.px + elementCore._w * r.ta;
                        var cy = r.py + elementCore._h * r.td;
                        floats[offset++] = r.px;
                        floats[offset++] = r.py;
                        floats[offset++] = elementCore._ulx;
                        floats[offset++] = elementCore._uly;
                        uints[offset++] = mca(elementCore._colorUl, r.alpha);
                        floats[offset++] = cx;
                        floats[offset++] = r.py;
                        floats[offset++] = elementCore._brx;
                        floats[offset++] = elementCore._uly;
                        uints[offset++] = mca(elementCore._colorUr, r.alpha);
                        floats[offset++] = cx;
                        floats[offset++] = cy;
                        floats[offset++] = elementCore._brx;
                        floats[offset++] = elementCore._bry;
                        uints[offset++] = mca(elementCore._colorBr, r.alpha);
                        floats[offset++] = r.px;
                        floats[offset++] = cy;
                        floats[offset++] = elementCore._ulx;
                        floats[offset++] = elementCore._bry;
                        uints[offset] = mca(elementCore._colorBl, r.alpha);
                    }
                }
            },
            {
                key: "isRenderTextureReusable",
                value: function isRenderTextureReusable(renderState, renderTextureInfo) {
                    var offset = renderState._renderTextureInfo.offset * 80 / 4;
                    var floats = renderState.quads.floats;
                    var uints = renderState.quads.uints;
                    return floats[offset] === 0 && floats[offset + 1] === 0 && floats[offset + 2] === 0 && floats[offset + 3] === 0 && uints[offset + 4] === 0xFFFFFFFF && floats[offset + 5] === renderTextureInfo.w && floats[offset + 6] === 0 && floats[offset + 7] === 1 && floats[offset + 8] === 0 && uints[offset + 9] === 0xFFFFFFFF && floats[offset + 10] === renderTextureInfo.w && floats[offset + 11] === renderTextureInfo.h && floats[offset + 12] === 1 && floats[offset + 13] === 1 && uints[offset + 14] === 0xFFFFFFFF && floats[offset + 15] === 0 && floats[offset + 16] === renderTextureInfo.h && floats[offset + 17] === 0 && floats[offset + 18] === 1 && uints[offset + 19] === 0xFFFFFFFF;
                }
            },
            {
                key: "finishRenderState",
                value: function finishRenderState(renderState) {
                    var offset = renderState.length * 80;
                    for(var i = 0, n = renderState.quadOperations.length; i < n; i++){
                        renderState.quadOperations[i].extraAttribsDataByteOffset = offset;
                        var extra = renderState.quadOperations[i].shader.getExtraAttribBytesPerVertex() * 4 * renderState.quadOperations[i].length;
                        offset += extra;
                        if (extra) {
                            renderState.quadOperations[i].shader.setExtraAttribsInBuffer(renderState.quadOperations[i], renderState.quads);
                        }
                    }
                    renderState.quads.dataLength = offset;
                }
            },
            {
                key: "copyRenderTexture",
                value: function copyRenderTexture(renderTexture, nativeTexture, options) {
                    var gl = this.stage.gl;
                    gl.bindTexture(gl.TEXTURE_2D, nativeTexture);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, renderTexture.framebuffer);
                    var precision = renderTexture.precision;
                    gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, precision * (options.sx || 0), precision * (options.sy || 0), precision * (options.x || 0), precision * (options.y || 0), precision * (options.w || renderTexture.ow), precision * (options.h || renderTexture.oh));
                }
            }
        ]);
        return WebGLRenderer;
    }(Renderer);
    var C2dCoreQuadList = /*#__PURE__*/ function(CoreQuadList) {
        _inherits._(C2dCoreQuadList, CoreQuadList);
        var _super = _create_super._(C2dCoreQuadList);
        function C2dCoreQuadList(ctx) {
            _class_call_check._(this, C2dCoreQuadList);
            var _this;
            _this = _super.call(this, ctx);
            _this.renderContexts = [];
            _this.modes = [];
            return _this;
        }
        _create_class._(C2dCoreQuadList, [
            {
                key: "setRenderContext",
                value: function setRenderContext(index, v) {
                    this.renderContexts[index] = v;
                }
            },
            {
                key: "setSimpleTc",
                value: function setSimpleTc(index, v) {
                    if (v) {
                        this.modes[index] |= 1;
                    } else {
                        this.modes[index] -= this.modes[index] & 1;
                    }
                }
            },
            {
                key: "setWhite",
                value: function setWhite(index, v) {
                    if (v) {
                        this.modes[index] |= 2;
                    } else {
                        this.modes[index] -= this.modes[index] & 2;
                    }
                }
            },
            {
                key: "getRenderContext",
                value: function getRenderContext(index) {
                    return this.renderContexts[index];
                }
            },
            {
                key: "getSimpleTc",
                value: function getSimpleTc(index) {
                    return this.modes[index] & 1;
                }
            },
            {
                key: "getWhite",
                value: function getWhite(index) {
                    return this.modes[index] & 2;
                }
            }
        ]);
        return C2dCoreQuadList;
    }(CoreQuadList);
    var C2dCoreQuadOperation = /*#__PURE__*/ function(CoreQuadOperation) {
        _inherits._(C2dCoreQuadOperation, CoreQuadOperation);
        var _super = _create_super._(C2dCoreQuadOperation);
        function C2dCoreQuadOperation() {
            _class_call_check._(this, C2dCoreQuadOperation);
            return _super.apply(this, arguments);
        }
        _create_class._(C2dCoreQuadOperation, [
            {
                key: "getRenderContext",
                value: function getRenderContext(index) {
                    return this.quads.getRenderContext(this.index + index);
                }
            },
            {
                key: "getSimpleTc",
                value: function getSimpleTc(index) {
                    return this.quads.getSimpleTc(this.index + index);
                }
            },
            {
                key: "getWhite",
                value: function getWhite(index) {
                    return this.quads.getWhite(this.index + index);
                }
            }
        ]);
        return C2dCoreQuadOperation;
    }(CoreQuadOperation);
    var C2dCoreRenderExecutor = /*#__PURE__*/ function(CoreRenderExecutor) {
        _inherits._(C2dCoreRenderExecutor, CoreRenderExecutor);
        var _super = _create_super._(C2dCoreRenderExecutor);
        function C2dCoreRenderExecutor() {
            _class_call_check._(this, C2dCoreRenderExecutor);
            return _super.apply(this, arguments);
        }
        _create_class._(C2dCoreRenderExecutor, [
            {
                key: "init",
                value: function init() {
                    this._mainRenderTexture = this.ctx.stage.getCanvas();
                }
            },
            {
                key: "_renderQuadOperation",
                value: function _renderQuadOperation(op) {
                    var shader = op.shader;
                    if (op.length || op.shader.addEmpty()) {
                        var target = this._renderTexture || this._mainRenderTexture;
                        shader.beforeDraw(op, target);
                        shader.draw(op, target);
                        shader.afterDraw(op, target);
                    }
                }
            },
            {
                key: "_clearRenderTexture",
                value: function _clearRenderTexture() {
                    var ctx = this._getContext();
                    var clearColor = [
                        0,
                        0,
                        0,
                        0
                    ];
                    if (this._mainRenderTexture.ctx === ctx) {
                        clearColor = this.ctx.stage.getClearColor();
                    }
                    var renderTexture = ctx.canvas;
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    if (!clearColor[0] && !clearColor[1] && !clearColor[2] && !clearColor[3]) {
                        ctx.clearRect(0, 0, renderTexture.width, renderTexture.height);
                    } else {
                        ctx.fillStyle = StageUtils.getRgbaStringFromArray(clearColor);
                        ctx.globalCompositeOperation = "copy";
                        ctx.beginPath();
                        ctx.rect(0, 0, renderTexture.width, renderTexture.height);
                        ctx.closePath();
                        ctx.fill();
                        ctx.globalCompositeOperation = "source-over";
                    }
                }
            },
            {
                key: "_getContext",
                value: function _getContext() {
                    if (this._renderTexture) {
                        return this._renderTexture.ctx;
                    } else {
                        return this._mainRenderTexture.ctx;
                    }
                }
            },
            {
                key: "_restoreContext",
                value: function _restoreContext() {
                    var ctx = this._getContext();
                    ctx.restore();
                    ctx.save();
                    ctx._scissor = null;
                }
            },
            {
                key: "_setScissor",
                value: function _setScissor(area) {
                    var ctx = this._getContext();
                    if (!C2dCoreRenderExecutor._equalScissorAreas(ctx.canvas, ctx._scissor, area)) {
                        this._restoreContext();
                        var precision = this.ctx.stage.getRenderPrecision();
                        if (area) {
                            ctx.beginPath();
                            ctx.rect(Math.round(area[0] * precision), Math.round(area[1] * precision), Math.round(area[2] * precision), Math.round(area[3] * precision));
                            ctx.closePath();
                            ctx.clip();
                        }
                        ctx._scissor = area;
                    }
                }
            }
        ], [
            {
                key: "_equalScissorAreas",
                value: function _equalScissorAreas(canvas, area, current) {
                    if (!area) {
                        area = [
                            0,
                            0,
                            canvas.width,
                            canvas.height
                        ];
                    }
                    if (!current) {
                        current = [
                            0,
                            0,
                            canvas.width,
                            canvas.height
                        ];
                    }
                    return Utils.equalValues(area, current);
                }
            }
        ]);
        return C2dCoreRenderExecutor;
    }(CoreRenderExecutor);
    var C2dShader = /*#__PURE__*/ function(Shader) {
        _inherits._(C2dShader, Shader);
        var _super = _create_super._(C2dShader);
        function C2dShader() {
            _class_call_check._(this, C2dShader);
            return _super.apply(this, arguments);
        }
        _create_class._(C2dShader, [
            {
                key: "beforeDraw",
                value: function beforeDraw(operation) {}
            },
            {
                key: "draw",
                value: function draw(operation) {}
            },
            {
                key: "afterDraw",
                value: function afterDraw(operation) {}
            }
        ]);
        return C2dShader;
    }(Shader);
    var DefaultShader$1 = /*#__PURE__*/ function(C2dShader) {
        _inherits._(DefaultShader$1, C2dShader);
        var _super = _create_super._(DefaultShader$1);
        function DefaultShader$1(ctx) {
            _class_call_check._(this, DefaultShader$1);
            var _this;
            _this = _super.call(this, ctx);
            _this._rectangleTexture = ctx.stage.rectangleTexture.source.nativeTexture;
            _this._tintManager = _this.ctx.stage.renderer.tintManager;
            return _this;
        }
        _create_class._(DefaultShader$1, [
            {
                key: "draw",
                value: function draw(operation, target) {
                    var ctx = target.ctx;
                    var length = operation.length;
                    for(var i = 0; i < length; i++){
                        var tx = operation.getTexture(i);
                        var vc = operation.getElementCore(i);
                        var rc = operation.getRenderContext(i);
                        var white = operation.getWhite(i);
                        var stc = operation.getSimpleTc(i);
                        var precision = this.ctx.stage.getRenderPrecision();
                        ctx.setTransform(rc.ta * precision, rc.tc * precision, rc.tb * precision, rc.td * precision, rc.px * precision, rc.py * precision);
                        var rect = tx === this._rectangleTexture;
                        var info = {
                            operation: operation,
                            target: target,
                            index: i,
                            rect: rect
                        };
                        if (rect) {
                            if (white) {
                                ctx.fillStyle = "white";
                            } else {
                                this._setColorGradient(ctx, vc);
                            }
                            ctx.globalAlpha = rc.alpha;
                            this._beforeDrawEl(info);
                            ctx.fillRect(0, 0, vc.w, vc.h);
                            this._afterDrawEl(info);
                            ctx.globalAlpha = 1.0;
                        } else {
                            ctx.globalAlpha = rc.alpha;
                            this._beforeDrawEl(info);
                            var sourceX = stc ? 0 : vc._ulx * tx.w;
                            var sourceY = stc ? 0 : vc._uly * tx.h;
                            var sourceW = (stc ? 1 : vc._brx - vc._ulx) * tx.w;
                            var sourceH = (stc ? 1 : vc._bry - vc._uly) * tx.h;
                            var colorize = !white;
                            if (colorize) {
                                var color = vc._colorUl;
                                if (vc._colorUl !== vc._colorUr || vc._colorUr !== vc._colorBl || vc._colorBr !== vc._colorBl) {
                                    color = StageUtils.mergeMultiColorsEqual([
                                        vc._colorUl,
                                        vc._colorUr,
                                        vc._colorBl,
                                        vc._colorBr
                                    ]);
                                }
                                var alpha = (color / 16777216 | 0) / 255.0;
                                ctx.globalAlpha *= alpha;
                                var rgb = color & 0x00FFFFFF;
                                var tintTexture = this._tintManager.getTintTexture(tx, rgb);
                                ctx.fillStyle = "white";
                                ctx.drawImage(tintTexture, sourceX, sourceY, sourceW, sourceH, 0, 0, vc.w, vc.h);
                            } else {
                                ctx.fillStyle = "white";
                                ctx.drawImage(tx, sourceX, sourceY, sourceW, sourceH, 0, 0, vc.w, vc.h);
                            }
                            this._afterDrawEl(info);
                            ctx.globalAlpha = 1.0;
                        }
                    }
                }
            },
            {
                key: "_setColorGradient",
                value: function _setColorGradient(ctx, vc) {
                    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : vc.w, h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : vc.h, transparency = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
                    var color = vc._colorUl;
                    var gradient;
                    if (vc._colorUl === vc._colorUr) {
                        if (vc._colorBl === vc._colorBr) {
                            if (vc._colorUl === vc.colorBl) ;
                            else {
                                gradient = ctx.createLinearGradient(0, 0, 0, h);
                                if (transparency) {
                                    gradient.addColorStop(0, StageUtils.getRgbaString(vc._colorUl));
                                    gradient.addColorStop(1, StageUtils.getRgbaString(vc._colorBl));
                                } else {
                                    gradient.addColorStop(0, StageUtils.getRgbString(vc._colorUl));
                                    gradient.addColorStop(1, StageUtils.getRgbString(vc._colorBl));
                                }
                            }
                        }
                    } else {
                        if (vc._colorUl === vc._colorBl && vc._colorUr === vc._colorBr) {
                            gradient = ctx.createLinearGradient(0, 0, w, 0);
                            if (transparency) {
                                gradient.addColorStop(0, StageUtils.getRgbaString(vc._colorUl));
                                gradient.addColorStop(1, StageUtils.getRgbaString(vc._colorBr));
                            } else {
                                gradient.addColorStop(0, StageUtils.getRgbString(vc._colorUl));
                                gradient.addColorStop(1, StageUtils.getRgbString(vc._colorBr));
                            }
                        }
                    }
                    if (gradient) {
                        ctx.fillStyle = gradient;
                    } else {
                        ctx.fillStyle = transparency ? StageUtils.getRgbaString(color) : StageUtils.getRgbString(color);
                    }
                }
            },
            {
                key: "_beforeDrawEl",
                value: function _beforeDrawEl(info) {}
            },
            {
                key: "_afterDrawEl",
                value: function _afterDrawEl(info) {}
            }
        ]);
        return DefaultShader$1;
    }(C2dShader);
    var C2dTextureTintManager = /*#__PURE__*/ function() {
        function C2dTextureTintManager(stage) {
            _class_call_check._(this, C2dTextureTintManager);
            this.stage = stage;
            this._usedMemory = 0;
            this._cachedNativeTextures = new Set();
        }
        _create_class._(C2dTextureTintManager, [
            {
                key: "destroy",
                value: function destroy() {
                    this.gc(true);
                }
            },
            {
                key: "_addMemoryUsage",
                value: function _addMemoryUsage(delta) {
                    this._usedMemory += delta;
                    this.stage.addMemoryUsage(delta);
                }
            },
            {
                key: "delete",
                value: function _delete(nativeTexture) {
                    if (this._hasCache(nativeTexture)) {
                        var cache = this._getCache(nativeTexture);
                        var prevMemUsage = cache.memoryUsage;
                        cache.clear();
                        this._cachedNativeTextures.delete(nativeTexture);
                        this._addMemoryUsage(cache.memoryUsage - prevMemUsage);
                    }
                }
            },
            {
                key: "getTintTexture",
                value: function getTintTexture(nativeTexture, color) {
                    var frame = this.stage.frameCounter;
                    this._cachedNativeTextures.add(nativeTexture);
                    var cache = this._getCache(nativeTexture);
                    var item = cache.get(color);
                    item.lf = frame;
                    if (item.tx) {
                        if (nativeTexture.update > item.u) {
                            this._tintTexture(item.tx, nativeTexture, color);
                        }
                        return item.tx;
                    } else {
                        var before = cache.memoryUsage;
                        var target = cache.reuseTexture(frame);
                        if (target) {
                            target.ctx.clearRect(0, 0, target.width, target.height);
                        } else {
                            target = document.createElement("canvas");
                            target.width = nativeTexture.w;
                            target.height = nativeTexture.h;
                            target.ctx = target.getContext("2d");
                        }
                        this._tintTexture(target, nativeTexture, color);
                        cache.set(color, target, frame);
                        var after = cache.memoryUsage;
                        if (after !== before) {
                            this._addMemoryUsage(after - before);
                        }
                        return target;
                    }
                }
            },
            {
                key: "_tintTexture",
                value: function _tintTexture(target, source, color) {
                    var col = color.toString(16);
                    while(col.length < 6){
                        col = "0" + col;
                    }
                    target.ctx.fillStyle = "#" + col;
                    target.ctx.globalCompositeOperation = "copy";
                    target.ctx.fillRect(0, 0, source.w, source.h);
                    target.ctx.globalCompositeOperation = "multiply";
                    target.ctx.drawImage(source, 0, 0, source.w, source.h, 0, 0, target.width, target.height);
                    target.ctx.globalCompositeOperation = "destination-in";
                    target.ctx.drawImage(source, 0, 0, source.w, source.h, 0, 0, target.width, target.height);
                }
            },
            {
                key: "_hasCache",
                value: function _hasCache(nativeTexture) {
                    return !!nativeTexture._tintCache;
                }
            },
            {
                key: "_getCache",
                value: function _getCache(nativeTexture) {
                    if (!nativeTexture._tintCache) {
                        nativeTexture._tintCache = new C2dTintCache(nativeTexture);
                    }
                    return nativeTexture._tintCache;
                }
            },
            {
                key: "gc",
                value: function gc() {
                    var aggressive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    var _this = this;
                    var frame = this.stage.frameCounter;
                    var delta = 0;
                    this._cachedNativeTextures.forEach(function(texture) {
                        var cache = _this._getCache(texture);
                        if (aggressive) {
                            delta += cache.memoryUsage;
                            cache.clear();
                        } else {
                            var before = cache.memoryUsage;
                            cache.cleanup(frame);
                            cache.releaseBlancoTextures();
                            delta += cache.memoryUsage - before;
                        }
                    });
                    if (aggressive) {
                        this._cachedNativeTextures.clear();
                    }
                    if (delta) {
                        this._addMemoryUsage(delta);
                    }
                }
            }
        ]);
        return C2dTextureTintManager;
    }();
    var C2dTintCache = /*#__PURE__*/ function() {
        function C2dTintCache(nativeTexture) {
            _class_call_check._(this, C2dTintCache);
            this._tx = nativeTexture;
            this._colors = new Map();
            this._blancoTextures = null;
            this._lastCleanupFrame = 0;
            this._memTextures = 0;
        }
        _create_class._(C2dTintCache, [
            {
                key: "memoryUsage",
                get: function get() {
                    return this._memTextures * this._tx.w * this._tx.h;
                }
            },
            {
                key: "releaseBlancoTextures",
                value: function releaseBlancoTextures() {
                    this._memTextures -= this._blancoTextures.length;
                    this._blancoTextures = [];
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this._blancoTextures = null;
                    this._colors.clear();
                    this._memTextures = 0;
                }
            },
            {
                key: "get",
                value: function get(color) {
                    var item = this._colors.get(color);
                    if (!item) {
                        item = {
                            lf: -1,
                            tx: undefined,
                            u: -1
                        };
                        this._colors.set(color, item);
                    }
                    return item;
                }
            },
            {
                key: "set",
                value: function set(color, texture, frame) {
                    var item = this.get(color);
                    item.lf = frame;
                    item.tx = texture;
                    item.u = frame;
                    this._memTextures++;
                }
            },
            {
                key: "cleanup",
                value: function cleanup(frame) {
                    var _this = this;
                    if (this._lastCleanupFrame !== frame) {
                        this._blancoTextures = [];
                        this._colors.forEach(function(item, color) {
                            if (item.lf < frame - 1) {
                                if (item.tx) {
                                    _this._blancoTextures.push(item.tx);
                                }
                                _this._colors.delete(color);
                            }
                        });
                        this._lastCleanupFrame = frame;
                    }
                }
            },
            {
                key: "reuseTexture",
                value: function reuseTexture(frame) {
                    this.cleanup(frame);
                    if (this._blancoTextures && this._blancoTextures.length) {
                        this._memTextures--;
                        return this._blancoTextures.pop();
                    }
                }
            }
        ]);
        return C2dTintCache;
    }();
    var C2dRenderer = /*#__PURE__*/ function(Renderer) {
        _inherits._(C2dRenderer, Renderer);
        var _super = _create_super._(C2dRenderer);
        function C2dRenderer(stage) {
            _class_call_check._(this, C2dRenderer);
            var _this;
            _this = _super.call(this, stage);
            _this.tintManager = new C2dTextureTintManager(stage);
            _this.setupC2d(_this.stage.c2d.canvas);
            return _this;
        }
        _create_class._(C2dRenderer, [
            {
                key: "destroy",
                value: function destroy() {
                    this.tintManager.destroy();
                }
            },
            {
                key: "_createDefaultShader",
                value: function _createDefaultShader(ctx) {
                    return new DefaultShader$1(ctx);
                }
            },
            {
                key: "_getShaderBaseType",
                value: function _getShaderBaseType() {
                    return C2dShader;
                }
            },
            {
                key: "_getShaderAlternative",
                value: function _getShaderAlternative(shaderType) {
                    return shaderType.getC2d && shaderType.getC2d();
                }
            },
            {
                key: "createCoreQuadList",
                value: function createCoreQuadList(ctx) {
                    return new C2dCoreQuadList(ctx);
                }
            },
            {
                key: "createCoreQuadOperation",
                value: function createCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index) {
                    return new C2dCoreQuadOperation(ctx, shader, shaderOwner, renderTextureInfo, scissor, index);
                }
            },
            {
                key: "createCoreRenderExecutor",
                value: function createCoreRenderExecutor(ctx) {
                    return new C2dCoreRenderExecutor(ctx);
                }
            },
            {
                key: "createCoreRenderState",
                value: function createCoreRenderState(ctx) {
                    return new CoreRenderState(ctx);
                }
            },
            {
                key: "createRenderTexture",
                value: function createRenderTexture(w, h, pw, ph) {
                    var canvas = document.createElement("canvas");
                    canvas.width = pw;
                    canvas.height = ph;
                    this.setupC2d(canvas);
                    return canvas;
                }
            },
            {
                key: "freeRenderTexture",
                value: function freeRenderTexture(nativeTexture) {
                    this.tintManager.delete(nativeTexture);
                }
            },
            {
                key: "gc",
                value: function gc(aggressive) {
                    this.tintManager.gc(aggressive);
                }
            },
            {
                key: "uploadTextureSource",
                value: function uploadTextureSource(textureSource, options) {
                    if (options.source.buffer) {
                        var canvas = document.createElement("canvas");
                        canvas.width = options.w;
                        canvas.height = options.h;
                        var imageData = new ImageData(new Uint8ClampedArray(options.source.buffer), options.w, options.h);
                        canvas.getContext("2d").putImageData(imageData, 0, 0);
                        return canvas;
                    }
                    return options.source;
                }
            },
            {
                key: "freeTextureSource",
                value: function freeTextureSource(textureSource) {
                    this.tintManager.delete(textureSource.nativeTexture);
                }
            },
            {
                key: "addQuad",
                value: function addQuad(renderState, quads, index) {
                    var elementCore = quads.quadElements[index];
                    quads.setRenderContext(index, elementCore._renderContext);
                    quads.setWhite(index, elementCore.isWhite());
                    quads.setSimpleTc(index, elementCore.hasSimpleTexCoords());
                }
            },
            {
                key: "isRenderTextureReusable",
                value: function isRenderTextureReusable(renderState, renderTextureInfo) {
                    return false;
                }
            },
            {
                key: "finishRenderState",
                value: function finishRenderState(renderState) {}
            },
            {
                key: "setupC2d",
                value: function setupC2d(canvas) {
                    var ctx = canvas.getContext("2d");
                    canvas.ctx = ctx;
                    ctx._scissor = null;
                    canvas.ctx.save();
                }
            }
        ]);
        return C2dRenderer;
    }(Renderer);
    var SparkShader = /*#__PURE__*/ function(WebGLShader) {
        _inherits._(SparkShader, WebGLShader);
        var _super = _create_super._(SparkShader);
        function SparkShader() {
            _class_call_check._(this, SparkShader);
            return _super.apply(this, arguments);
        }
        _create_class._(SparkShader, [
            {
                key: "enableAttribs",
                value: function enableAttribs() {
                    var gl = this.gl;
                    gl.vertexAttribPointer(this._attrib("aVertexPosition"), 2, gl.FLOAT, false, 20, 0);
                    gl.enableVertexAttribArray(this._attrib("aVertexPosition"));
                    if (this._attrib("aTextureCoord") !== -1) {
                        gl.vertexAttribPointer(this._attrib("aTextureCoord"), 2, gl.FLOAT, false, 20, 2 * 4);
                        gl.enableVertexAttribArray(this._attrib("aTextureCoord"));
                    }
                    if (this._attrib("aColor") !== -1) {
                        gl.vertexAttribPointer(this._attrib("aColor"), 4, gl.UNSIGNED_BYTE, true, 20, 4 * 4);
                        gl.enableVertexAttribArray(this._attrib("aColor"));
                    }
                }
            },
            {
                key: "disableAttribs",
                value: function disableAttribs() {
                    var gl = this.gl;
                    gl.disableVertexAttribArray(this._attrib("aVertexPosition"));
                    if (this._attrib("aTextureCoord") !== -1) {
                        gl.disableVertexAttribArray(this._attrib("aTextureCoord"));
                    }
                    if (this._attrib("aColor") !== -1) {
                        gl.disableVertexAttribArray(this._attrib("aColor"));
                    }
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    this._setUniform("projection", this._getProjection(operation), this.gl.uniform2fv, false);
                }
            },
            {
                key: "draw",
                value: function draw(operation) {
                    var gl = this.gl;
                    var length = operation.length;
                    if (length) {
                        var glTexture = operation.getTexture(0);
                        var pos = 0;
                        for(var i = 0; i < length; i++){
                            var tx = operation.getTexture(i);
                            if (glTexture !== tx) {
                                if (glTexture.options && glTexture.options.imageRef) {
                                    var elementPostion = i > 0 ? i - 1 : i;
                                    var precision = this.ctx.stage.getOption("precision");
                                    var vc = operation.getElementCore(elementPostion);
                                    this.ctx.stage.platform.paint(gl, glTexture.options.imageRef, vc._worldContext.px * precision, vc._worldContext.py * precision, vc._colorUl, vc);
                                } else {
                                    gl.bindTexture(gl.TEXTURE_2D, glTexture);
                                    gl.drawElements(gl.TRIANGLES, 6 * (i - pos), gl.UNSIGNED_SHORT, (pos + operation.index) * 6 * 2);
                                }
                                glTexture = tx;
                                pos = i;
                            }
                        }
                        if (pos < length) {
                            if (glTexture.options && glTexture.options.imageRef) {
                                var precision1 = this.ctx.stage.getOption("precision");
                                var vc1 = operation.getElementCore(pos);
                                this.ctx.stage.platform.paint(gl, glTexture.options.imageRef, vc1._worldContext.px * precision1, vc1._worldContext.py * precision1, vc1._colorUl, vc1);
                            } else {
                                gl.bindTexture(gl.TEXTURE_2D, glTexture);
                                gl.drawElements(gl.TRIANGLES, 6 * (length - pos), gl.UNSIGNED_SHORT, (pos + operation.index) * 6 * 2);
                            }
                        }
                    }
                }
            }
        ]);
        return SparkShader;
    }(_wrap_native_super._(WebGLShader));
    SparkShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    SparkShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    void main(void){\n        gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor;\n    }\n";
    var SparkRenderer = /*#__PURE__*/ function(WebGLRenderer) {
        _inherits._(SparkRenderer, WebGLRenderer);
        var _super = _create_super._(SparkRenderer);
        function SparkRenderer(stage) {
            _class_call_check._(this, SparkRenderer);
            return _super.call(this, stage);
        }
        _create_class._(SparkRenderer, [
            {
                key: "_createDefaultShader",
                value: function _createDefaultShader(ctx) {
                    return new SparkShader(ctx);
                }
            },
            {
                key: "createCoreRenderExecutor",
                value: function createCoreRenderExecutor(ctx) {
                    __webpack_require__.g.beginDrawing();
                    var ret = _get._(_get_prototype_of._(SparkRenderer.prototype), "createCoreRenderExecutor", this).call(this, ctx);
                    __webpack_require__.g.endDrawing();
                    return ret;
                }
            }
        ]);
        return SparkRenderer;
    }(WebGLRenderer);
    var ImageWorker = /*#__PURE__*/ function() {
        function ImageWorker() {
            var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            _class_call_check._(this, ImageWorker);
            this._items = new Map();
            this._id = 0;
            this._initWorker();
        }
        _create_class._(ImageWorker, [
            {
                key: "destroy",
                value: function destroy() {
                    if (this._worker) {
                        this._worker.terminate();
                    }
                }
            },
            {
                key: "_initWorker",
                value: function _initWorker() {
                    var _this = this;
                    var code = "(".concat(createWorker.toString(), ")()");
                    var blob = new Blob([
                        code.replace('"use strict";', "")
                    ]);
                    var blobURL = (window.URL ? URL : webkitURL).createObjectURL(blob, {
                        type: "application/javascript; charset=utf-8"
                    });
                    this._worker = new Worker(blobURL);
                    this._worker.postMessage({
                        type: "config",
                        config: {
                            path: window.location.href,
                            protocol: window.location.protocol
                        }
                    });
                    this._worker.onmessage = function(e) {
                        if (e.data && e.data.id) {
                            var id = e.data.id;
                            var item = _this._items.get(id);
                            if (item) {
                                if (e.data.type == "data") {
                                    _this.finish(item, e.data.info);
                                } else {
                                    _this.error(item, e.data.info);
                                }
                            }
                        }
                    };
                }
            },
            {
                key: "create",
                value: function create(src) {
                    var id = ++this._id;
                    var item = new ImageWorkerImage(this, id, src);
                    this._items.set(id, item);
                    this._worker.postMessage({
                        type: "add",
                        id: id,
                        src: src
                    });
                    return item;
                }
            },
            {
                key: "cancel",
                value: function cancel(image) {
                    this._worker.postMessage({
                        type: "cancel",
                        id: image.id
                    });
                    this._items.delete(image.id);
                }
            },
            {
                key: "error",
                value: function error(image, info) {
                    image.error(info);
                    this._items.delete(image.id);
                }
            },
            {
                key: "finish",
                value: function finish(image, info) {
                    image.load(info);
                    this._items.delete(image.id);
                }
            }
        ]);
        return ImageWorker;
    }();
    var ImageWorkerImage = /*#__PURE__*/ function() {
        function ImageWorkerImage(manager, id, src) {
            _class_call_check._(this, ImageWorkerImage);
            this._manager = manager;
            this._id = id;
            this._src = src;
            this._onError = null;
            this._onLoad = null;
        }
        _create_class._(ImageWorkerImage, [
            {
                key: "id",
                get: function get() {
                    return this._id;
                }
            },
            {
                key: "src",
                get: function get() {
                    return this._src;
                }
            },
            {
                key: "onError",
                set: function set(f) {
                    this._onError = f;
                }
            },
            {
                key: "onLoad",
                set: function set(f) {
                    this._onLoad = f;
                }
            },
            {
                key: "cancel",
                value: function cancel() {
                    this._manager.cancel(this);
                }
            },
            {
                key: "load",
                value: function load(info) {
                    if (this._onLoad) {
                        this._onLoad(info);
                    }
                }
            },
            {
                key: "error",
                value: function error(info) {
                    if (this._onError) {
                        this._onError(info);
                    }
                }
            }
        ]);
        return ImageWorkerImage;
    }();
    var createWorker = function createWorker() {
        function ImageWorkerServer() {
            this.items = new Map();
            var t = this;
            onmessage = function onmessage1(e) {
                t._receiveMessage(e);
            };
        }
        ImageWorkerServer.isPathAbsolute = function(path) {
            return /^(?:\/|[a-z]+:\/\/)/.test(path) || path.substr(0, 5) == "data:";
        };
        ImageWorkerServer.prototype._receiveMessage = function(e) {
            if (e.data.type === "config") {
                this.config = e.data.config;
                var base = this.config.path;
                var hasHashPath = /#.*?\//;
                if (hasHashPath.test(base)) {
                    base = base.replace(/#.*$/, "");
                }
                var parts = base.split("/");
                parts.pop();
                this._relativeBase = parts.join("/") + "/";
            } else if (e.data.type === "add") {
                this.add(e.data.id, e.data.src);
            } else if (e.data.type === "cancel") {
                this.cancel(e.data.id);
            }
        };
        ImageWorkerServer.prototype.add = function(id, src) {
            if (!ImageWorkerServer.isPathAbsolute(src)) {
                src = this._relativeBase + src;
            }
            if (src.substr(0, 2) === "//") {
                src = this.config.protocol + src;
            }
            var item = new ImageWorkerServerItem(id, src);
            var t = this;
            item.onFinish = function(result) {
                t.finish(item, result);
            };
            item.onError = function(info) {
                t.error(item, info);
            };
            this.items.set(id, item);
            item.start();
        };
        ImageWorkerServer.prototype.cancel = function(id) {
            var item = this.items.get(id);
            if (item) {
                item.cancel();
                this.items.delete(id);
            }
        };
        ImageWorkerServer.prototype.finish = function(item, param) {
            var imageBitmap = param.imageBitmap, hasAlphaChannel = param.hasAlphaChannel;
            postMessage({
                type: "data",
                id: item.id,
                info: {
                    imageBitmap: imageBitmap,
                    hasAlphaChannel: hasAlphaChannel
                }
            }, [
                imageBitmap
            ]);
            this.items.delete(item.id);
        };
        ImageWorkerServer.prototype.error = function(item, param) {
            var type = param.type, message = param.message;
            postMessage({
                type: "error",
                id: item.id,
                info: {
                    type: type,
                    message: message
                }
            });
            this.items.delete(item.id);
        };
        ImageWorkerServer.isWPEBrowser = function() {
            return navigator.userAgent.indexOf("WPE") !== -1;
        };
        function ImageWorkerServerItem(id, src) {
            this._onError = undefined;
            this._onFinish = undefined;
            this._id = id;
            this._src = src;
            this._xhr = undefined;
            this._mimeType = undefined;
            this._canceled = false;
        }
        Object.defineProperty(ImageWorkerServerItem.prototype, "id", {
            get: function get() {
                return this._id;
            }
        });
        Object.defineProperty(ImageWorkerServerItem.prototype, "onFinish", {
            get: function get() {
                return this._onFinish;
            },
            set: function set(f) {
                this._onFinish = f;
            }
        });
        Object.defineProperty(ImageWorkerServerItem.prototype, "onError", {
            get: function get() {
                return this._onError;
            },
            set: function set(f) {
                this._onError = f;
            }
        });
        ImageWorkerServerItem.prototype.start = function() {
            this._xhr = new XMLHttpRequest();
            this._xhr.open("GET", this._src, true);
            this._xhr.responseType = "blob";
            var t = this;
            this._xhr.onerror = function(oEvent) {
                t.error({
                    type: "connection",
                    message: "Connection error"
                });
            };
            this._xhr.onload = function(oEvent) {
                var blob = t._xhr.response;
                t._mimeType = blob.type;
                t._createImageBitmap(blob);
            };
            this._xhr.send();
        };
        ImageWorkerServerItem.prototype._createImageBitmap = function(blob) {
            var t = this;
            createImageBitmap(blob, {
                premultiplyAlpha: "premultiply",
                colorSpaceConversion: "none",
                imageOrientation: "none"
            }).then(function(imageBitmap) {
                t.finish({
                    imageBitmap: imageBitmap,
                    hasAlphaChannel: t._hasAlphaChannel()
                });
            }).catch(function(e) {
                t.error({
                    type: "parse",
                    message: "Error parsing image data"
                });
            });
        };
        ImageWorkerServerItem.prototype._hasAlphaChannel = function() {
            if (ImageWorkerServer.isWPEBrowser()) {
                return true;
            } else {
                return this._mimeType.indexOf("image/png") !== -1;
            }
        };
        ImageWorkerServerItem.prototype.cancel = function() {
            if (this._canceled) return;
            if (this._xhr) {
                this._xhr.abort();
            }
            this._canceled = true;
        };
        ImageWorkerServerItem.prototype.error = function(type, message) {
            if (!this._canceled && this._onError) {
                this._onError({
                    type: type,
                    message: message
                });
            }
        };
        ImageWorkerServerItem.prototype.finish = function(info) {
            if (!this._canceled && this._onFinish) {
                this._onFinish(info);
            }
        };
        var worker = new ImageWorkerServer();
    };
    var WebPlatform = /*#__PURE__*/ function() {
        function WebPlatform() {
            _class_call_check._(this, WebPlatform);
        }
        _create_class._(WebPlatform, [
            {
                key: "init",
                value: function init(stage) {
                    this.stage = stage;
                    this._looping = false;
                    this._awaitingLoop = false;
                    this._loopHandler = null;
                    this._idleLoopCounter = 0;
                    this._idleLoopDelay = 60;
                    if (this.stage.getOption("useImageWorker")) {
                        if (!window.createImageBitmap || !window.Worker) {
                            console.warn("[Lightning] Can't use image worker because browser does not have createImageBitmap and Web Worker support");
                        } else {
                            this._imageWorker = new ImageWorker();
                        }
                    }
                    this._registerVisibilityChangeHandler();
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    if (this._imageWorker) {
                        this._imageWorker.destroy();
                    }
                    this._removeKeyHandler();
                    this._removeClickHandler();
                    this._removeHoverHandler();
                    this._removeScrollWheelHandler();
                    this._removeVisibilityChangeHandler();
                }
            },
            {
                key: "startLoop",
                value: function startLoop() {
                    this._looping = true;
                    if (!this._awaitingLoop) {
                        this.loop();
                    }
                }
            },
            {
                key: "stopLoop",
                value: function stopLoop() {
                    this._looping = false;
                }
            },
            {
                key: "switchLoop",
                value: function switchLoop() {
                    var _this = this;
                    if (this._idleLoopCounter < this._idleLoopDelay) {
                        this._idleLoopCounter++;
                        return;
                    }
                    if (!this.stage.ctx.hasRenderUpdates()) {
                        this.stopLoop();
                        this._loopHandler = setInterval(function() {
                            _this.stage.updateFrame();
                            _this.stage.idleFrame();
                            if (_this.stage.ctx.hasRenderUpdates()) {
                                clearInterval(_this._loopHandler);
                                _this.startLoop();
                            }
                        }, 1000 / 60);
                    } else {
                        this._idleLoopCounter = 0;
                    }
                }
            },
            {
                key: "loop",
                value: function loop() {
                    var self1 = this;
                    var lp = function lp1() {
                        self1._awaitingLoop = false;
                        if (self1._looping) {
                            self1.stage.updateFrame();
                            if (self1.stage.getOption("pauseRafLoopOnIdle")) {
                                self1.switchLoop();
                            }
                            self1.stage.renderFrame();
                            requestAnimationFrame(lp);
                            self1._awaitingLoop = true;
                        }
                    };
                    requestAnimationFrame(lp);
                }
            },
            {
                key: "uploadCompressedGlTexture",
                value: function uploadCompressedGlTexture(gl, textureSource, source, options) {
                    var view = !source.pvr ? new DataView(source.mipmaps[0]) : source.mipmaps[0];
                    gl.compressedTexImage2D(gl.TEXTURE_2D, 0, source.glInternalFormat, source.pixelWidth, source.pixelHeight, 0, view);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                }
            },
            {
                key: "uploadGlTexture",
                value: function uploadGlTexture(gl, textureSource, source, options) {
                    if (source instanceof ImageData || source instanceof HTMLImageElement || source instanceof HTMLVideoElement || window.ImageBitmap && source instanceof ImageBitmap) {
                        gl.texImage2D(gl.TEXTURE_2D, 0, options.internalFormat, options.format, options.type, source);
                    } else if (source instanceof HTMLCanvasElement) {
                        if (Utils.isZiggo || this.stage.getOption("forceTxCanvasSource")) {
                            gl.texImage2D(gl.TEXTURE_2D, 0, options.internalFormat, options.format, options.type, source);
                        } else if (source.width > 0 && source.height > 0) {
                            var ctx = source.getContext("2d");
                            gl.texImage2D(gl.TEXTURE_2D, 0, options.internalFormat, options.format, options.type, ctx.getImageData(0, 0, source.width, source.height));
                        }
                    } else {
                        gl.texImage2D(gl.TEXTURE_2D, 0, options.internalFormat, textureSource.w, textureSource.h, 0, options.format, options.type, source);
                    }
                }
            },
            {
                key: "handleKtxLoad",
                value: function handleKtxLoad(cb, src) {
                    var self1 = this;
                    return function() {
                        var arraybuffer = this.response;
                        var view = new DataView(arraybuffer);
                        var targetIdentifier = 3632701469;
                        if (targetIdentifier !== view.getUint32(0) + view.getUint32(4) + view.getUint32(8)) {
                            cb("Parsing failed: identifier ktx mismatch:", src);
                        }
                        var littleEndian = view.getUint32(12) === 16909060 ? true : false;
                        var data = {
                            glType: view.getUint32(16, littleEndian),
                            glTypeSize: view.getUint32(20, littleEndian),
                            glFormat: view.getUint32(24, littleEndian),
                            glInternalFormat: view.getUint32(28, littleEndian),
                            glBaseInternalFormat: view.getUint32(32, littleEndian),
                            pixelWidth: view.getUint32(36, littleEndian),
                            pixelHeight: view.getUint32(40, littleEndian),
                            pixelDepth: view.getUint32(44, littleEndian),
                            numberOfArrayElements: view.getUint32(48, littleEndian),
                            numberOfFaces: view.getUint32(52, littleEndian),
                            numberOfMipmapLevels: view.getUint32(56, littleEndian),
                            bytesOfKeyValueData: view.getUint32(60, littleEndian),
                            kvps: [],
                            mipmaps: [],
                            get width () {
                                return this.pixelWidth;
                            },
                            get height () {
                                return this.pixelHeight;
                            }
                        };
                        var props = function(obj) {
                            var p = [];
                            for(var v in obj){
                                p.push(obj[v]);
                            }
                            return p;
                        };
                        var formats = Object.values(self1.stage.renderer.getCompressedTextureExtensions()).filter(function(obj) {
                            return obj != null;
                        }).map(function(obj) {
                            return props(obj);
                        }).reduce(function(prev, current) {
                            return prev.concat(current);
                        });
                        if (!formats.includes(data.glInternalFormat)) {
                            console.warn("[Lightning] Unrecognized texture extension format:", src, data.glInternalFormat, self1.stage.renderer.getCompressedTextureExtensions());
                        }
                        var offset = 64;
                        offset += data.bytesOfKeyValueData;
                        for(var i = 0; i < data.numberOfMipmapLevels; i++){
                            var imageSize = view.getUint32(offset);
                            offset += 4;
                            data.mipmaps.push(view.buffer.slice(offset, imageSize));
                            offset += imageSize;
                        }
                        cb(null, {
                            source: data,
                            renderInfo: {
                                src: src,
                                compressed: true
                            }
                        });
                    };
                }
            },
            {
                key: "handlePvrLoad",
                value: function handlePvrLoad(cb, src) {
                    return function() {
                        var pvrHeaderLength = 13;
                        var pvrFormatEtc1 = 0x8D64;
                        var pvrWidth = 7;
                        var pvrHeight = 6;
                        var pvrMipmapCount = 11;
                        var pvrMetadata = 12;
                        var arrayBuffer = this.response;
                        var header = new Int32Array(arrayBuffer, 0, pvrHeaderLength);
                        var dataOffset = header[pvrMetadata] + 52;
                        var pvrtcData = new Uint8Array(arrayBuffer, dataOffset);
                        var data = {
                            glInternalFormat: pvrFormatEtc1,
                            pixelWidth: header[pvrWidth],
                            pixelHeight: header[pvrHeight],
                            numberOfMipmapLevels: header[pvrMipmapCount],
                            mipmaps: [],
                            pvr: true,
                            get width () {
                                return this.pixelWidth;
                            },
                            get height () {
                                return this.pixelHeight;
                            }
                        };
                        var offset = 0;
                        var width = data.pixelWidth;
                        var height = data.pixelHeight;
                        for(var i = 0; i < data.numberOfMipmapLevels; i++){
                            var level = (width + 3 >> 2) * (height + 3 >> 2) * 8;
                            var view = new Uint8Array(arrayBuffer, pvrtcData.byteOffset + offset, level);
                            data.mipmaps.push(view);
                            offset += level;
                            width = width >> 1;
                            height = height >> 1;
                        }
                        cb(null, {
                            source: data,
                            renderInfo: {
                                src: src,
                                compressed: true
                            }
                        });
                    };
                }
            },
            {
                key: "loadSrcTexture",
                value: function loadSrcTexture(param, cb) {
                    var src = param.src, hasAlpha = param.hasAlpha;
                    var cancelCb = undefined;
                    var isPng = src.indexOf(".png") >= 0 || src.substr(0, 21) == "data:image/png;base64";
                    var isKtx = src.indexOf(".ktx") >= 0;
                    var isPvr = src.indexOf(".pvr") >= 0;
                    if (isKtx || isPvr) {
                        var request = new XMLHttpRequest();
                        request.addEventListener("load", isKtx ? this.handleKtxLoad(cb, src) : this.handlePvrLoad(cb, src));
                        request.open("GET", src);
                        request.responseType = "arraybuffer";
                        request.send();
                        cancelCb = function cancelCb() {
                            request.abort();
                        };
                    } else if (this._imageWorker) {
                        var image = this._imageWorker.create(src);
                        image.onError = function(err) {
                            return cb("Image load error");
                        };
                        image.onLoad = function(param) {
                            var imageBitmap = param.imageBitmap, hasAlphaChannel = param.hasAlphaChannel;
                            cb(null, {
                                source: imageBitmap,
                                renderInfo: {
                                    src: src,
                                    compressed: false
                                },
                                hasAlpha: hasAlphaChannel,
                                premultiplyAlpha: true
                            });
                        };
                        cancelCb = function cancelCb() {
                            image.cancel();
                        };
                    } else {
                        var image1 = new Image();
                        if (!(src.substr(0, 5) == "data:") && !Utils.isPS4) {
                            image1.crossOrigin = "Anonymous";
                        }
                        image1.onerror = function(err) {
                            if (image1.src) {
                                return cb("Image load error");
                            }
                        };
                        image1.onload = function() {
                            cb(null, {
                                source: image1,
                                renderInfo: {
                                    src: src,
                                    compressed: false
                                },
                                hasAlpha: isPng || hasAlpha
                            });
                        };
                        image1.src = src;
                        cancelCb = function cancelCb() {
                            image1.onerror = null;
                            image1.onload = null;
                            image1.removeAttribute("src");
                        };
                    }
                    return cancelCb;
                }
            },
            {
                key: "createWebGLContext",
                value: function createWebGLContext(w, h) {
                    var canvas = this.stage.getOption("canvas") || document.createElement("canvas");
                    if (w && h) {
                        canvas.width = w;
                        canvas.height = h;
                    }
                    var opts = {
                        alpha: true,
                        antialias: false,
                        premultipliedAlpha: true,
                        stencil: true,
                        preserveDrawingBuffer: false
                    };
                    var gl = canvas.getContext("webgl", opts) || canvas.getContext("experimental-webgl", opts);
                    if (!gl) {
                        throw new Error("This browser does not support webGL.");
                    }
                    return gl;
                }
            },
            {
                key: "createCanvasContext",
                value: function createCanvasContext(w, h) {
                    var canvas = this.stage.getOption("canvas") || document.createElement("canvas");
                    if (w && h) {
                        canvas.width = w;
                        canvas.height = h;
                    }
                    var c2d = canvas.getContext("2d");
                    if (!c2d) {
                        throw new Error("This browser does not support 2d canvas.");
                    }
                    return c2d;
                }
            },
            {
                key: "getHrTime",
                value: function getHrTime() {
                    return window.performance ? window.performance.now() : new Date().getTime();
                }
            },
            {
                key: "getDrawingCanvas",
                value: function getDrawingCanvas() {
                    return document.createElement("canvas");
                }
            },
            {
                key: "getTextureOptionsForDrawingCanvas",
                value: function getTextureOptionsForDrawingCanvas(canvas) {
                    var options = {};
                    options.source = canvas;
                    return options;
                }
            },
            {
                key: "nextFrame",
                value: function nextFrame(changes) {}
            },
            {
                key: "registerKeydownHandler",
                value: function registerKeydownHandler(keyhandler) {
                    this._keydownListener = function(e) {
                        keyhandler(e);
                    };
                    window.addEventListener("keydown", this._keydownListener);
                }
            },
            {
                key: "registerKeyupHandler",
                value: function registerKeyupHandler(keyhandler) {
                    this._keyupListener = function(e) {
                        keyhandler(e);
                    };
                    window.addEventListener("keyup", this._keyupListener);
                }
            },
            {
                key: "_removeKeyHandler",
                value: function _removeKeyHandler() {
                    if (this._keydownListener) {
                        window.removeEventListener("keydown", this._keydownListener);
                    }
                    if (this._keyupListener) {
                        window.removeEventListener("keyup", this._keyupListener);
                    }
                }
            },
            {
                key: "registerClickHandler",
                value: function registerClickHandler(clickHandler) {
                    this._clickListener = function(e) {
                        clickHandler(e);
                    };
                    window.addEventListener("mousedown", this._clickListener);
                }
            },
            {
                key: "_removeClickHandler",
                value: function _removeClickHandler() {
                    if (this._clickListener) {
                        window.removeEventListener("mousedown", this._clickListener);
                    }
                }
            },
            {
                key: "registerHoverHandler",
                value: function registerHoverHandler(hoverHandler) {
                    this._hoverListener = function(e) {
                        hoverHandler(e);
                    };
                    window.addEventListener("mousemove", this._hoverListener);
                }
            },
            {
                key: "_removeHoverHandler",
                value: function _removeHoverHandler() {
                    if (this._hoverListener) {
                        window.removeEventListener("mousemove", this._hoverListener);
                    }
                }
            },
            {
                key: "registerScrollWheelHandler",
                value: function registerScrollWheelHandler(registerScrollWheelHandler) {
                    this._scrollWheelListener = function(e) {
                        registerScrollWheelHandler(e);
                    };
                    window.addEventListener("wheel", this._scrollWheelListener);
                }
            },
            {
                key: "_removeScrollWheelHandler",
                value: function _removeScrollWheelHandler() {
                    if (this._scrollWheelListener) {
                        window.removeEventListener("wheel", this._scrollWheelListener);
                    }
                }
            },
            {
                key: "_registerVisibilityChangeHandler",
                value: function _registerVisibilityChangeHandler() {
                    var _this = this;
                    this._visibilityChangeHandler = function() {
                        if (document.visibilityState === "visible") {
                            _this.stage.root.core.setHasRenderUpdates(2);
                            _this.stage.renderFrame();
                        }
                    };
                    document.addEventListener("visibilitychange", this._visibilityChangeHandler);
                }
            },
            {
                key: "_removeVisibilityChangeHandler",
                value: function _removeVisibilityChangeHandler() {
                    if (this._visibilityChangeHandler) {
                        document.removeEventListener("visibilitychange", this._visibilityChangeHandler);
                    }
                }
            }
        ]);
        return WebPlatform;
    }();
    var PlatformLoader = /*#__PURE__*/ function() {
        function PlatformLoader() {
            _class_call_check._(this, PlatformLoader);
        }
        _create_class._(PlatformLoader, null, [
            {
                key: "load",
                value: function load(options) {
                    if (options.platform) {
                        return options.platform;
                    } else {
                        return WebPlatform;
                    }
                }
            }
        ]);
        return PlatformLoader;
    }();
    var Utils$1 = /*#__PURE__*/ function() {
        function Utils$1() {
            _class_call_check._(this, Utils$1);
        }
        _create_class._(Utils$1, null, [
            {
                key: "isFunction",
                value: function isFunction(value) {
                    return typeof value === "function";
                }
            },
            {
                key: "isNumber",
                value: function isNumber(value) {
                    return typeof value === "number";
                }
            },
            {
                key: "isInteger",
                value: function isInteger(value) {
                    return typeof value === "number" && value % 1 === 0;
                }
            },
            {
                key: "isBoolean",
                value: function isBoolean(value) {
                    return value === true || value === false;
                }
            },
            {
                key: "isString",
                value: function isString(value) {
                    return typeof value == "string";
                }
            },
            {
                key: "isObject",
                value: function isObject(value) {
                    var type = typeof value === "undefined" ? "undefined" : _type_of._(value);
                    return !!value && (type == "object" || type == "function");
                }
            },
            {
                key: "isPlainObject",
                value: function isPlainObject(value) {
                    var type = typeof value === "undefined" ? "undefined" : _type_of._(value);
                    return !!value && type == "object";
                }
            },
            {
                key: "isObjectLiteral",
                value: function isObjectLiteral(value) {
                    return typeof value === "object" && value && value.constructor === Object;
                }
            },
            {
                key: "getArrayIndex",
                value: function getArrayIndex(index, arr) {
                    return Utils$1.getModuloIndex(index, arr.length);
                }
            },
            {
                key: "equalValues",
                value: function equalValues(v1, v2) {
                    if ((typeof v1 === "undefined" ? "undefined" : _type_of._(v1)) !== (typeof v2 === "undefined" ? "undefined" : _type_of._(v2))) return false;
                    if (Utils$1.isObjectLiteral(v1)) {
                        return Utils$1.isObjectLiteral(v2) && Utils$1.equalObjectLiterals(v1, v2);
                    } else if (Array.isArray(v1)) {
                        return Array.isArray(v2) && Utils$1.equalArrays(v1, v2);
                    } else {
                        return v1 === v2;
                    }
                }
            },
            {
                key: "equalObjectLiterals",
                value: function equalObjectLiterals(obj1, obj2) {
                    var keys1 = Object.keys(obj1);
                    var keys2 = Object.keys(obj2);
                    if (keys1.length !== keys2.length) {
                        return false;
                    }
                    for(var i = 0, n = keys1.length; i < n; i++){
                        var k1 = keys1[i];
                        var k2 = keys2[i];
                        if (k1 !== k2) {
                            return false;
                        }
                        var v1 = obj1[k1];
                        var v2 = obj2[k2];
                        if (!Utils$1.equalValues(v1, v2)) {
                            return false;
                        }
                    }
                    return true;
                }
            },
            {
                key: "equalArrays",
                value: function equalArrays(v1, v2) {
                    if (v1.length !== v2.length) {
                        return false;
                    }
                    for(var i = 0, n = v1.length; i < n; i++){
                        if (!this.equalValues(v1[i], v2[i])) {
                            return false;
                        }
                    }
                    return true;
                }
            }
        ]);
        return Utils$1;
    }();
    var WebGLState = /*#__PURE__*/ function() {
        function WebGLState(id, gl) {
            _class_call_check._(this, WebGLState);
            this._id = id;
            this._gl = gl;
            this._program = undefined;
            this._buffers = new Map();
            this._framebuffers = new Map();
            this._renderbuffers = new Map();
            this._vertexAttribs = new Array(16);
            this._nonDefaultFlags = new Set();
            this._settings = new Map();
            this._textures = new Array(8);
            this._maxTexture = 0;
            this._activeTexture = gl.TEXTURE0;
            this._pixelStorei = new Array(5);
        }
        _create_class._(WebGLState, [
            {
                key: "_getDefaultFlag",
                value: function _getDefaultFlag(cap) {
                    return cap === this._gl.DITHER;
                }
            },
            {
                key: "setFlag",
                value: function setFlag(cap, v) {
                    var def = this._getDefaultFlag(cap);
                    if (v === def) {
                        return this._nonDefaultFlags.delete(cap);
                    } else {
                        if (!this._nonDefaultFlags.has(cap)) {
                            this._nonDefaultFlags.add(cap);
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            },
            {
                key: "setBuffer",
                value: function setBuffer(target, buffer) {
                    var change = this._buffers.get(target) !== buffer;
                    this._buffers.set(target, buffer);
                    if (change && target === this._gl.ARRAY_BUFFER) {
                        this._vertexAttribs = [];
                    }
                    return change;
                }
            },
            {
                key: "setFramebuffer",
                value: function setFramebuffer(target, buffer) {
                    var change = this._framebuffers.get(target) !== buffer;
                    this._framebuffers.set(target, buffer);
                    return change;
                }
            },
            {
                key: "setRenderbuffer",
                value: function setRenderbuffer(target, buffer) {
                    var change = this._renderbuffers.get(target) !== buffer;
                    this._renderbuffers.set(target, buffer);
                    return change;
                }
            },
            {
                key: "setProgram",
                value: function setProgram(program) {
                    var change = this._program !== program;
                    this._program = program;
                    return change;
                }
            },
            {
                key: "setSetting",
                value: function setSetting(func, v) {
                    var s = this._settings.get(func);
                    var change = !s || !Utils$1.equalValues(s, v);
                    this._settings.set(func, v);
                    return change;
                }
            },
            {
                key: "disableVertexAttribArray",
                value: function disableVertexAttribArray(index) {
                    var va = this._vertexAttribs[index];
                    if (va && va[5]) {
                        va[5] = false;
                        return true;
                    }
                    return false;
                }
            },
            {
                key: "enableVertexAttribArray",
                value: function enableVertexAttribArray(index) {
                    var va = this._vertexAttribs[index];
                    if (va) {
                        if (!va[0]) {
                            va[0] = true;
                            return true;
                        }
                    } else {
                        this._vertexAttribs[index] = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            true
                        ];
                        return true;
                    }
                    return false;
                }
            },
            {
                key: "vertexAttribPointer",
                value: function vertexAttribPointer(index, props) {
                    var va = this._vertexAttribs[index];
                    var equal = false;
                    if (va) {
                        equal = va[0] === props[0] && va[1] === props[1] && va[2] === props[2] && va[3] === props[3] && va[4] === props[4];
                    }
                    if (equal) {
                        return false;
                    } else {
                        props[5] = va ? va[5] : false;
                        return true;
                    }
                }
            },
            {
                key: "setActiveTexture",
                value: function setActiveTexture(texture) {
                    var changed = this._activeTexture !== texture;
                    this._activeTexture = texture;
                    return changed;
                }
            },
            {
                key: "bindTexture",
                value: function bindTexture(target, texture) {
                    var activeIndex = WebGLState._getTextureIndex(this._activeTexture);
                    this._maxTexture = Math.max(this._maxTexture, activeIndex + 1);
                    var current = this._textures[activeIndex];
                    var targetIndex = WebGLState._getTextureTargetIndex(target);
                    if (current) {
                        if (current[targetIndex] === texture) {
                            return false;
                        }
                        current[targetIndex] = texture;
                        return true;
                    } else {
                        if (texture) {
                            this._textures[activeIndex] = [];
                            this._textures[activeIndex][targetIndex] = texture;
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            },
            {
                key: "setPixelStorei",
                value: function setPixelStorei(pname, param) {
                    var i = WebGLState._getPixelStoreiIndex(pname);
                    var change = !Utils$1.equalValues(this._pixelStorei[i], param);
                    this._pixelStorei[i] = param;
                    return change;
                }
            },
            {
                key: "migrate",
                value: function migrate(s) {
                    var t = this;
                    this._migrateFlags(t, s);
                    if (s._program !== t._program) {
                        this._gl._useProgram(s._program);
                    }
                    this._migrateFramebuffers(t, s);
                    this._migrateRenderbuffers(t, s);
                    var buffersChanged = this._migrateBuffers(t, s);
                    this._migrateAttributes(t, s, buffersChanged);
                    this._migrateFlags(t, s);
                    this._migrateSettings(t, s);
                    this._migratePixelStorei(t, s);
                    this._migrateTextures(t, s);
                }
            },
            {
                key: "_migratePixelStorei",
                value: function _migratePixelStorei(t, s) {
                    for(var i = 0, n = t._pixelStorei.length; i < n; i++){
                        if (t._pixelStorei[i] !== s._pixelStorei[i]) {
                            var value = s._pixelStorei[i] !== undefined ? s._pixelStorei[i] : WebGLState._getDefaultPixelStoreiByIndex(i);
                            this._gl._pixelStorei(WebGLState._getPixelStoreiByIndex(i), value);
                        }
                    }
                }
            },
            {
                key: "_migrateTextures",
                value: function _migrateTextures(t, s) {
                    var max = Math.max(t._maxTexture, s._maxTexture);
                    var activeTexture = t._activeTexture;
                    for(var i = 0; i < max; i++){
                        var sTargets = s._textures[i];
                        var tTargets = t._textures[i];
                        var textureNumb = WebGLState._getTextureByIndex(i);
                        var targetMax = Math.max(tTargets ? tTargets.length : 0, sTargets ? sTargets.length : 0);
                        for(var j = 0, n = targetMax; j < n; j++){
                            var target = WebGLState._getTextureTargetByIndex(j);
                            if (activeTexture !== textureNumb) {
                                this._gl._activeTexture(textureNumb);
                                activeTexture = textureNumb;
                            }
                            var texture = sTargets && sTargets[j] || null;
                            this._gl._bindTexture(target, texture);
                        }
                    }
                    if (s._activeTexture !== activeTexture) {
                        this._gl._activeTexture(s._activeTexture);
                    }
                }
            },
            {
                key: "_migrateBuffers",
                value: function _migrateBuffers(t, s) {
                    var _this = this;
                    s._buffers.forEach(function(framebuffer, target) {
                        if (t._buffers.get(target) !== framebuffer) {
                            _this._gl._bindBuffer(target, framebuffer);
                        }
                    });
                    t._buffers.forEach(function(buffer, target) {
                        var b = s._buffers.get(target);
                        if (b === undefined) {
                            _this._gl._bindBuffer(target, null);
                        }
                    });
                    return s._buffers.get(this._gl.ARRAY_BUFFER) !== t._buffers.get(this._gl.ARRAY_BUFFER);
                }
            },
            {
                key: "_migrateFramebuffers",
                value: function _migrateFramebuffers(t, s) {
                    var _this = this;
                    s._framebuffers.forEach(function(framebuffer, target) {
                        if (t._framebuffers.get(target) !== framebuffer) {
                            _this._gl._bindFramebuffer(target, framebuffer);
                        }
                    });
                    t._framebuffers.forEach(function(framebuffer, target) {
                        var fb = s._framebuffers.get(target);
                        if (fb === undefined) {
                            _this._gl._bindFramebuffer(target, null);
                        }
                    });
                }
            },
            {
                key: "_migrateRenderbuffers",
                value: function _migrateRenderbuffers(t, s) {
                    var _this = this;
                    s._renderbuffers.forEach(function(renderbuffer, target) {
                        if (t._renderbuffers.get(target) !== renderbuffer) {
                            _this._gl._bindRenderbuffer(target, renderbuffer);
                        }
                    });
                    t._renderbuffers.forEach(function(renderbuffer, target) {
                        var fb = s._renderbuffers.get(target);
                        if (fb === undefined) {
                            _this._gl._bindRenderbuffer(target, null);
                        }
                    });
                }
            },
            {
                key: "_migrateAttributes",
                value: function _migrateAttributes(t, s, buffersChanged) {
                    var _this = this;
                    if (!buffersChanged) {
                        t._vertexAttribs.forEach(function(attrib, index) {
                            if (!s._vertexAttribs[index]) {
                                _this._gl._disableVertexAttribArray(index);
                            }
                        });
                        s._vertexAttribs.forEach(function(attrib, index) {
                            _this._gl._vertexAttribPointer(index, attrib[0], attrib[1], attrib[2], attrib[4]);
                            if (attrib[5]) {
                                _this._gl._enableVertexAttribArray(index);
                            } else {
                                _this._gl._disableVertexAttribArray(index);
                            }
                        });
                    } else {
                        s._vertexAttribs.forEach(function(attrib, index) {
                            if (attrib[0]) {
                                _this._gl._vertexAttribPointer(index, attrib[0], attrib[1], attrib[2], attrib[3], attrib[4]);
                            }
                            if (attrib[5]) {
                                _this._gl._enableVertexAttribArray(index);
                            }
                        });
                    }
                }
            },
            {
                key: "_migrateSettings",
                value: function _migrateSettings(t, s) {
                    var _this = this;
                    var defaults = this.constructor.getDefaultSettings();
                    t._settings.forEach(function(value, func) {
                        var name = func.name || func.xname;
                        if (!s._settings.has(func)) {
                            var args = defaults.get(name);
                            if (Utils$1.isFunction(args)) {
                                args = args(_this._gl);
                            }
                            s._settings.set(func, args);
                            func.apply(_this._gl, args);
                        }
                    });
                    s._settings.forEach(function(value, func) {
                        var tValue = t._settings.get(func);
                        if (!tValue || !Utils$1.equalValues(tValue, value)) {
                            func.apply(_this._gl, value);
                        }
                    });
                }
            },
            {
                key: "_migrateFlags",
                value: function _migrateFlags(t, s) {
                    var _this = this;
                    t._nonDefaultFlags.forEach(function(setting) {
                        if (!s._nonDefaultFlags.has(setting)) {
                            if (_this._getDefaultFlag(setting)) {
                                _this._gl._enable(setting);
                            } else {
                                _this._gl._disable(setting);
                            }
                        }
                    });
                    s._nonDefaultFlags.forEach(function(setting) {
                        if (!t._nonDefaultFlags.has(setting)) {
                            if (_this._getDefaultFlag(setting)) {
                                _this._gl._disable(setting);
                            } else {
                                _this._gl._enable(setting);
                            }
                        }
                    });
                }
            }
        ], [
            {
                key: "getDefaultSettings",
                value: function getDefaultSettings() {
                    if (!this._defaultSettings) {
                        this._defaultSettings = new Map();
                        var d = this._defaultSettings;
                        var g = WebGLRenderingContext.prototype;
                        d.set("viewport", function(gl) {
                            return [
                                0,
                                0,
                                gl.canvas.width,
                                gl.canvas.height
                            ];
                        });
                        d.set("scissor", function(gl) {
                            return [
                                0,
                                0,
                                gl.canvas.width,
                                gl.canvas.height
                            ];
                        });
                        d.set("blendColor", [
                            0,
                            0,
                            0,
                            0
                        ]);
                        d.set("blendEquation", [
                            g.FUNC_ADD
                        ]);
                        d.set("blendEquationSeparate", [
                            g.FUNC_ADD,
                            g.FUNC_ADD
                        ]);
                        d.set("blendFunc", [
                            g.ONE,
                            g.ZERO
                        ]);
                        d.set("blendFuncSeparate", [
                            g.ONE,
                            g.ZERO,
                            g.ONE,
                            g.ZERO
                        ]);
                        d.set("clearColor", [
                            0,
                            0,
                            0,
                            0
                        ]);
                        d.set("clearDepth", [
                            1
                        ]);
                        d.set("clearStencil", [
                            0
                        ]);
                        d.set("colorMask", [
                            true,
                            true,
                            true,
                            true
                        ]);
                        d.set("cullFace", [
                            g.BACK
                        ]);
                        d.set("depthFunc", [
                            g.LESS
                        ]);
                        d.set("depthMask", [
                            true
                        ]);
                        d.set("depthRange", [
                            0,
                            1
                        ]);
                        d.set("frontFace", [
                            g.CCW
                        ]);
                        d.set("lineWidth", [
                            1
                        ]);
                        d.set("polygonOffset", [
                            0,
                            0
                        ]);
                        d.set("sampleCoverage", [
                            1,
                            false
                        ]);
                        d.set("stencilFunc", [
                            g.ALWAYS,
                            0,
                            1
                        ]);
                        d.set("_stencilFuncSeparateFront", [
                            g.ALWAYS,
                            0,
                            1
                        ]);
                        d.set("_stencilFuncSeparateBack", [
                            g.ALWAYS,
                            0,
                            1
                        ]);
                        d.set("_stencilFuncSeparateFrontAndBack", [
                            g.ALWAYS,
                            0,
                            1
                        ]);
                        d.set("stencilMask", [
                            1
                        ]);
                        d.set("_stencilMaskSeparateFront", [
                            1
                        ]);
                        d.set("_stencilMaskSeparateBack", [
                            1
                        ]);
                        d.set("_stencilMaskSeparateFrontAndBack", [
                            1
                        ]);
                        d.set("stencilOp", [
                            g.KEEP,
                            g.KEEP,
                            g.KEEP
                        ]);
                        d.set("_stencilOpSeparateFront", [
                            g.KEEP,
                            g.KEEP,
                            g.KEEP
                        ]);
                        d.set("_stencilOpSeparateBack", [
                            g.KEEP,
                            g.KEEP,
                            g.KEEP
                        ]);
                        d.set("_stencilOpSeparateFrontAndBack", [
                            g.KEEP,
                            g.KEEP,
                            g.KEEP
                        ]);
                        d.set("vertexAttrib1f", []);
                        d.set("vertexAttrib1fv", []);
                        d.set("vertexAttrib2f", []);
                        d.set("vertexAttrib2fv", []);
                        d.set("vertexAttrib3f", []);
                        d.set("vertexAttrib3fv", []);
                        d.set("vertexAttrib4f", []);
                        d.set("vertexAttrib4fv", []);
                    }
                    return this._defaultSettings;
                }
            },
            {
                key: "_getTextureTargetIndex",
                value: function _getTextureTargetIndex(target) {
                    switch(target){
                        case 0x0DE1:
                            return 0;
                        case 0x8513:
                            return 1;
                        default:
                            throw new Error("Unknown texture target: " + target);
                    }
                }
            },
            {
                key: "_getTextureTargetByIndex",
                value: function _getTextureTargetByIndex(index) {
                    if (!this._textureTargetIndices) {
                        this._textureTargetIndices = [
                            0x0DE1,
                            0x8513
                        ];
                    }
                    return this._textureTargetIndices[index];
                }
            },
            {
                key: "_getTextureIndex",
                value: function _getTextureIndex(index) {
                    return index - 0x84C0;
                }
            },
            {
                key: "_getTextureByIndex",
                value: function _getTextureByIndex(index) {
                    return index + 0x84C0;
                }
            },
            {
                key: "_getPixelStoreiIndex",
                value: function _getPixelStoreiIndex(pname) {
                    switch(pname){
                        case 0x0D05:
                            return 0;
                        case 0x0CF5:
                            return 1;
                        case 0x9240:
                            return 2;
                        case 0x9241:
                            return 3;
                        case 0x9243:
                            return 4;
                        case 0x9245:
                            return 5;
                        default:
                            throw new Error("Unknown pixelstorei: " + pname);
                    }
                }
            },
            {
                key: "_getPixelStoreiByIndex",
                value: function _getPixelStoreiByIndex(index) {
                    if (!this._pixelStoreiIndices) {
                        this._pixelStoreiIndices = [
                            0x0D05,
                            0x0CF5,
                            0x9240,
                            0x9241,
                            0x9243
                        ];
                    }
                    return this._pixelStoreiIndices[index];
                }
            },
            {
                key: "_getDefaultPixelStoreiByIndex",
                value: function _getDefaultPixelStoreiByIndex(index) {
                    if (!this._pixelStoreiDefaults) {
                        this._pixelStoreiDefaults = [
                            4,
                            4,
                            false,
                            false,
                            WebGLRenderingContext.prototype.BROWSER_DEFAULT_WEBGL
                        ];
                    }
                    return this._pixelStoreiDefaults[index];
                }
            }
        ]);
        return WebGLState;
    }();
    var WebGLStateManager = /*#__PURE__*/ function() {
        function WebGLStateManager() {
            _class_call_check._(this, WebGLStateManager);
        }
        _create_class._(WebGLStateManager, [
            {
                key: "_initStateManager",
                value: function _initStateManager() {
                    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default";
                    this._states = {};
                    this._state = this._getState(id);
                }
            },
            {
                key: "_getState",
                value: function _getState(id) {
                    if (!this._states[id]) {
                        this._states[id] = new WebGLState(id, this);
                    }
                    return this._states[id];
                }
            },
            {
                key: "switchState",
                value: function switchState() {
                    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default";
                    if (this._state._id !== id) {
                        var newState = this._getState(id);
                        this._state.migrate(newState);
                        this._state = newState;
                    }
                }
            },
            {
                key: "$useProgram",
                value: function $useProgram(program) {
                    if (this._state.setProgram(program)) this._useProgram(program);
                }
            },
            {
                key: "$bindBuffer",
                value: function $bindBuffer(target, fb) {
                    if (this._state.setBuffer(target, fb)) this._bindBuffer(target, fb);
                }
            },
            {
                key: "$bindFramebuffer",
                value: function $bindFramebuffer(target, fb) {
                    if (this._state.setFramebuffer(target, fb)) this._bindFramebuffer(target, fb);
                }
            },
            {
                key: "$bindRenderbuffer",
                value: function $bindRenderbuffer(target, fb) {
                    if (this._state.setRenderbuffer(target, fb)) this._bindRenderbuffer(target, fb);
                }
            },
            {
                key: "$enable",
                value: function $enable(cap) {
                    if (this._state.setFlag(cap, true)) this._enable(cap);
                }
            },
            {
                key: "$disable",
                value: function $disable(cap) {
                    if (this._state.setFlag(cap, false)) this._disable(cap);
                }
            },
            {
                key: "$viewport",
                value: function $viewport(x, y, w, h) {
                    if (this._state.setSetting(this._viewport, [
                        x,
                        y,
                        w,
                        h
                    ])) this._viewport(x, y, w, h);
                }
            },
            {
                key: "$scissor",
                value: function $scissor(x, y, w, h) {
                    if (this._state.setSetting(this._scissor, [
                        x,
                        y,
                        w,
                        h
                    ])) this._scissor(x, y, w, h);
                }
            },
            {
                key: "$disableVertexAttribArray",
                value: function $disableVertexAttribArray(index) {
                    if (this._state.disableVertexAttribArray(index)) this._disableVertexAttribArray(index);
                }
            },
            {
                key: "$enableVertexAttribArray",
                value: function $enableVertexAttribArray(index) {
                    if (this._state.enableVertexAttribArray(index)) this._enableVertexAttribArray(index);
                }
            },
            {
                key: "$vertexAttribPointer",
                value: function $vertexAttribPointer(index, size, type, normalized, stride, offset) {
                    if (this._state.vertexAttribPointer(index, [
                        size,
                        type,
                        normalized,
                        stride,
                        offset
                    ])) this._vertexAttribPointer(index, size, type, normalized, stride, offset);
                }
            },
            {
                key: "$activeTexture",
                value: function $activeTexture(texture) {
                    if (this._state.setActiveTexture(texture)) this._activeTexture(texture);
                }
            },
            {
                key: "$bindTexture",
                value: function $bindTexture(target, texture) {
                    if (this._state.bindTexture(target, texture)) this._bindTexture(target, texture);
                }
            },
            {
                key: "$pixelStorei",
                value: function $pixelStorei(pname, param) {
                    if (this._state.setPixelStorei(pname, param)) {
                        this._pixelStorei(pname, param);
                    }
                }
            },
            {
                key: "$stencilFuncSeparate",
                value: function $stencilFuncSeparate(face, func, ref, mask) {
                    var f;
                    switch(face){
                        case this.FRONT:
                            f = this._stencilFuncSeparateFront;
                            break;
                        case this.BACK:
                            f = this._stencilFuncSeparateBack;
                            break;
                        case this.FRONT_AND_BACK:
                            f = this._stencilFuncSeparateFrontAndBack;
                            break;
                    }
                    if (this._state.setSetting(f, [
                        func,
                        ref,
                        mask
                    ])) f.apply(this, [
                        func,
                        ref,
                        mask
                    ]);
                }
            },
            {
                key: "_stencilFuncSeparateFront",
                value: function _stencilFuncSeparateFront(func, ref, mask) {
                    this._stencilFuncSeparate(this.FRONT, func, ref, mask);
                }
            },
            {
                key: "_stencilFuncSeparateBack",
                value: function _stencilFuncSeparateBack(func, ref, mask) {
                    this._stencilFuncSeparate(this.BACK, func, ref, mask);
                }
            },
            {
                key: "_stencilFuncSeparateFrontAndBack",
                value: function _stencilFuncSeparateFrontAndBack(func, ref, mask) {
                    this._stencilFuncSeparate(this.FRONT_AND_BACK, func, ref, mask);
                }
            },
            {
                key: "$stencilMaskSeparate",
                value: function $stencilMaskSeparate(face, mask) {
                    var f;
                    switch(face){
                        case this.FRONT:
                            f = this._stencilMaskSeparateFront;
                            break;
                        case this.BACK:
                            f = this._stencilMaskSeparateBack;
                            break;
                        case this.FRONT_AND_BACK:
                            f = this._stencilMaskSeparateFrontAndBack;
                            break;
                    }
                    if (this._state.setSetting(f, [
                        mask
                    ])) f.apply(this, [
                        mask
                    ]);
                }
            },
            {
                key: "_stencilMaskSeparateFront",
                value: function _stencilMaskSeparateFront(mask) {
                    this._stencilMaskSeparate(this.FRONT, mask);
                }
            },
            {
                key: "_stencilMaskSeparateBack",
                value: function _stencilMaskSeparateBack(mask) {
                    this._stencilMaskSeparate(this.BACK, mask);
                }
            },
            {
                key: "_stencilMaskSeparateFrontAndBack",
                value: function _stencilMaskSeparateFrontAndBack(mask) {
                    this._stencilMaskSeparate(this.FRONT_AND_BACK, mask);
                }
            },
            {
                key: "$stencilOpSeparate",
                value: function $stencilOpSeparate(face, fail, zfail, zpass) {
                    var f;
                    switch(face){
                        case this.FRONT:
                            f = this._stencilOpSeparateFront;
                            break;
                        case this.BACK:
                            f = this._stencilOpSeparateBack;
                            break;
                        case this.FRONT_AND_BACK:
                            f = this._stencilOpSeparateFrontAndBack;
                            break;
                    }
                    if (this._state.setSetting(f, [
                        fail,
                        zfail,
                        zpass
                    ])) f.apply(this, [
                        fail,
                        zfail,
                        zpass
                    ]);
                }
            },
            {
                key: "_stencilOpSeparateFront",
                value: function _stencilOpSeparateFront(fail, zfail, zpass) {
                    this._stencilOpSeparate(this.FRONT, fail, zfail, zpass);
                }
            },
            {
                key: "_stencilOpSeparateBack",
                value: function _stencilOpSeparateBack(fail, zfail, zpass) {
                    this._stencilOpSeparate(this.BACK, fail, zfail, zpass);
                }
            },
            {
                key: "_stencilOpSeparateFrontAndBack",
                value: function _stencilOpSeparateFrontAndBack(fail, zfail, zpass) {
                    this._stencilOpSeparate(this.FRONT_AND_BACK, fail, zfail, zpass);
                }
            },
            {
                key: "$blendColor",
                value: function $blendColor(red, green, blue, alpha) {
                    if (this._state.setSetting(this._blendColor, [
                        red,
                        green,
                        blue,
                        alpha
                    ])) this._blendColor(red, green, blue, alpha);
                }
            },
            {
                key: "$blendEquation",
                value: function $blendEquation(mode) {
                    if (this._state.setSetting(this._blendEquation, [
                        mode
                    ])) this._blendEquation(mode);
                }
            },
            {
                key: "$blendEquationSeparate",
                value: function $blendEquationSeparate(modeRGB, modeAlpha) {
                    if (this._state.setSetting(this._blendEquationSeparate, [
                        modeRGB,
                        modeAlpha
                    ])) this._blendEquationSeparate(modeRGB, modeAlpha);
                }
            },
            {
                key: "$blendFunc",
                value: function $blendFunc(sfactor, dfactor) {
                    if (this._state.setSetting(this._blendFunc, [
                        sfactor,
                        dfactor
                    ])) this._blendFunc(sfactor, dfactor);
                }
            },
            {
                key: "$blendFuncSeparate",
                value: function $blendFuncSeparate(srcRGB, dstRGB, srcAlpha, dstAlpha) {
                    if (this._state.setSetting(this._blendFuncSeparate, [
                        srcRGB,
                        dstRGB,
                        srcAlpha,
                        dstAlpha
                    ])) this._blendFuncSeparate(srcRGB, dstRGB, srcAlpha, dstAlpha);
                }
            },
            {
                key: "$clearColor",
                value: function $clearColor(red, green, blue, alpha) {
                    if (this._state.setSetting(this._clearColor, [
                        red,
                        green,
                        blue,
                        alpha
                    ])) this._clearColor(red, green, blue, alpha);
                }
            },
            {
                key: "$clearDepth",
                value: function $clearDepth(depth) {
                    if (this._state.setSetting(this._clearDepth, [
                        depth
                    ])) this._clearDepth(depth);
                }
            },
            {
                key: "$clearStencil",
                value: function $clearStencil(s) {
                    if (this._state.setSetting(this._clearStencil, [
                        s
                    ])) this._clearStencil(s);
                }
            },
            {
                key: "$colorMask",
                value: function $colorMask(red, green, blue, alpha) {
                    if (this._state.setSetting(this._colorMask, [
                        red,
                        green,
                        blue,
                        alpha
                    ])) this._colorMask(red, green, blue, alpha);
                }
            },
            {
                key: "$cullFace",
                value: function $cullFace(mode) {
                    if (this._state.setSetting(this._cullFace, [
                        mode
                    ])) this._cullFace(mode);
                }
            },
            {
                key: "$depthFunc",
                value: function $depthFunc(func) {
                    if (this._state.setSetting(this._depthFunc, [
                        func
                    ])) this._depthFunc(func);
                }
            },
            {
                key: "$depthMask",
                value: function $depthMask(flag) {
                    if (this._state.setSetting(this._depthMask, [
                        flag
                    ])) this._depthMask(flag);
                }
            },
            {
                key: "$depthRange",
                value: function $depthRange(zNear, zFar) {
                    if (this._state.setSetting(this._depthRange, [
                        zNear,
                        zFar
                    ])) this._depthRange(zNear, zFar);
                }
            },
            {
                key: "$frontFace",
                value: function $frontFace(mode) {
                    if (this._state.setSetting(this._frontFace, [
                        mode
                    ])) this._frontFace(mode);
                }
            },
            {
                key: "$lineWidth",
                value: function $lineWidth(width) {
                    if (this._state.setSetting(this._lineWidth, [
                        width
                    ])) this._lineWidth(width);
                }
            },
            {
                key: "$polygonOffset",
                value: function $polygonOffset(factor, units) {
                    if (this._state.setSetting(this._polygonOffset, [
                        factor,
                        units
                    ])) this._polygonOffset(factor, units);
                }
            },
            {
                key: "$sampleCoverage",
                value: function $sampleCoverage(value, invert) {
                    if (this._state.setSetting(this._sampleCoverage, [
                        value,
                        invert
                    ])) this._sampleCoverage(value, invert);
                }
            },
            {
                key: "$stencilFunc",
                value: function $stencilFunc(func, ref, mask) {
                    if (this._state.setSetting(this._stencilFunc, [
                        func,
                        ref,
                        mask
                    ])) this._stencilFunc(func, ref, mask);
                }
            },
            {
                key: "$stencilMask",
                value: function $stencilMask(mask) {
                    if (this._state.setSetting(this._stencilMask, [
                        mask
                    ])) this._stencilMask(mask);
                }
            },
            {
                key: "$stencilOp",
                value: function $stencilOp(fail, zfail, zpass) {
                    if (this._state.setSetting(this._stencilOp, [
                        fail,
                        zfail,
                        zpass
                    ])) this._stencilOp(fail, zfail, zpass);
                }
            },
            {
                key: "$vertexAttrib1f",
                value: function $vertexAttrib1f(indx, x) {
                    if (this._state.setSetting(this._vertexAttrib1f, [
                        indx,
                        x
                    ])) this._vertexAttrib1f(indx, x);
                }
            },
            {
                key: "$vertexAttrib1fv",
                value: function $vertexAttrib1fv(indx, values) {
                    if (this._state.setSetting(this._vertexAttrib1fv, [
                        indx,
                        values
                    ])) this._vertexAttrib1fv(indx, values);
                }
            },
            {
                key: "$vertexAttrib2f",
                value: function $vertexAttrib2f(indx, x, y) {
                    if (this._state.setSetting(this._vertexAttrib2f, [
                        indx,
                        x,
                        y
                    ])) this._vertexAttrib2f(indx, x, y);
                }
            },
            {
                key: "$vertexAttrib2fv",
                value: function $vertexAttrib2fv(indx, values) {
                    if (this._state.setSetting(this._vertexAttrib2fv, [
                        indx,
                        values
                    ])) this._vertexAttrib2fv(indx, values);
                }
            },
            {
                key: "$vertexAttrib3f",
                value: function $vertexAttrib3f(indx, x, y, z) {
                    if (this._state.setSetting(this._vertexAttrib3f, [
                        indx,
                        x,
                        y,
                        z
                    ])) this._vertexAttrib3f(indx, x, y, z);
                }
            },
            {
                key: "$vertexAttrib3fv",
                value: function $vertexAttrib3fv(indx, values) {
                    if (this._state.setSetting(this._vertexAttrib3fv, [
                        indx,
                        values
                    ])) this._vertexAttrib3fv(indx, values);
                }
            },
            {
                key: "$vertexAttrib4f",
                value: function $vertexAttrib4f(indx, x, y, z, w) {
                    if (this._state.setSetting(this._vertexAttrib4f, [
                        indx,
                        x,
                        y,
                        z,
                        w
                    ])) this._vertexAttrib4f(indx, x, y, z, w);
                }
            },
            {
                key: "$vertexAttrib4fv",
                value: function $vertexAttrib4fv(indx, values) {
                    if (this._state.setSetting(this._vertexAttrib4fv, [
                        indx,
                        values
                    ])) this._vertexAttrib4fv(indx, values);
                }
            }
        ], [
            {
                key: "enable",
                value: function enable(gl) {
                    var id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
                    var names = Object.getOwnPropertyNames(WebGLStateManager.prototype);
                    var WebGLRenderingContextProto = gl.__proto__;
                    names.forEach(function(name) {
                        if (name !== "constructor") {
                            var method = WebGLStateManager.prototype[name];
                            if (name.charAt(0) === "$") {
                                name = name.substr(1);
                            }
                            if (gl[name] !== method) {
                                if (gl[name]) {
                                    if (!gl[name].name) {
                                        gl[name].xname = name;
                                    }
                                    gl["_" + name] = gl[name];
                                }
                                gl[name] = method;
                            }
                        }
                    });
                    WebGLStateManager.prototype._initStateManager.call(gl, id);
                    return gl;
                }
            }
        ]);
        return WebGLStateManager;
    }();
    var TextureManager = /*#__PURE__*/ function() {
        function TextureManager(stage) {
            _class_call_check._(this, TextureManager);
            this.stage = stage;
            this._usedMemory = 0;
            this._uploadedTextureSources = [];
            this.textureSourceHashmap = new Map();
        }
        _create_class._(TextureManager, [
            {
                key: "usedMemory",
                get: function get() {
                    return this._usedMemory;
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    for(var i = 0, n = this._uploadedTextureSources.length; i < n; i++){
                        this._nativeFreeTextureSource(this._uploadedTextureSources[i]);
                    }
                    this.textureSourceHashmap.clear();
                    this._usedMemory = 0;
                }
            },
            {
                key: "getReusableTextureSource",
                value: function getReusableTextureSource(id) {
                    return this.textureSourceHashmap.get(id);
                }
            },
            {
                key: "getTextureSource",
                value: function getTextureSource(func, id) {
                    var textureSource = id ? this.textureSourceHashmap.get(id) : null;
                    if (!textureSource) {
                        textureSource = new TextureSource(this, func);
                        if (id) {
                            textureSource.lookupId = id;
                            this.textureSourceHashmap.set(id, textureSource);
                        }
                    }
                    return textureSource;
                }
            },
            {
                key: "uploadTextureSource",
                value: function uploadTextureSource(textureSource, options) {
                    if (textureSource.isLoaded()) return;
                    this._addMemoryUsage(textureSource.w * textureSource.h);
                    var nativeTexture = this._nativeUploadTextureSource(textureSource, options);
                    textureSource._nativeTexture = nativeTexture;
                    nativeTexture.w = textureSource.w;
                    nativeTexture.h = textureSource.h;
                    nativeTexture.update = this.stage.frameCounter;
                    this._uploadedTextureSources.push(textureSource);
                    this.addToLookupMap(textureSource);
                    this._updateVramUsage(textureSource, 1);
                }
            },
            {
                key: "_addMemoryUsage",
                value: function _addMemoryUsage(delta) {
                    this._usedMemory += delta;
                    this.stage.addMemoryUsage(delta);
                }
            },
            {
                key: "_updateVramUsage",
                value: function _updateVramUsage(textureSource, sign) {
                    var nativeTexture = textureSource.nativeTexture;
                    var usage;
                    if (!Stage.isWebglSupported()) return;
                    if (!textureSource.isLoaded()) return;
                    if (!nativeTexture.hasOwnProperty("bytesPerPixel") || isNaN(nativeTexture.bytesPerPixel)) return;
                    usage = sign * (textureSource.w * textureSource.h * nativeTexture.bytesPerPixel);
                    this.stage.addVramUsage(usage, textureSource.hasAlpha);
                }
            },
            {
                key: "addToLookupMap",
                value: function addToLookupMap(textureSource) {
                    var lookupId = textureSource.lookupId;
                    if (lookupId) {
                        if (!this.textureSourceHashmap.has(lookupId)) {
                            this.textureSourceHashmap.set(lookupId, textureSource);
                        }
                    }
                }
            },
            {
                key: "gc",
                value: function gc() {
                    this.freeUnusedTextureSources();
                    this._cleanupLookupMap();
                }
            },
            {
                key: "freeUnusedTextureSources",
                value: function freeUnusedTextureSources() {
                    var remainingTextureSources = [];
                    for(var i = 0, n = this._uploadedTextureSources.length; i < n; i++){
                        var ts = this._uploadedTextureSources[i];
                        if (ts.allowCleanup()) {
                            this._freeManagedTextureSource(ts);
                        } else {
                            remainingTextureSources.push(ts);
                        }
                    }
                    this._uploadedTextureSources = remainingTextureSources;
                    this._cleanupLookupMap();
                }
            },
            {
                key: "_freeManagedTextureSource",
                value: function _freeManagedTextureSource(textureSource) {
                    if (textureSource.isLoaded()) {
                        this._nativeFreeTextureSource(textureSource);
                        this._addMemoryUsage(-textureSource.w * textureSource.h);
                        this._updateVramUsage(textureSource, -1);
                    }
                    textureSource.loadingSince = null;
                }
            },
            {
                key: "_cleanupLookupMap",
                value: function _cleanupLookupMap() {
                    var _this = this;
                    this.textureSourceHashmap.forEach(function(textureSource, lookupId) {
                        if (!(textureSource.isLoaded() || textureSource.isLoading()) && !textureSource.isUsed()) {
                            _this.textureSourceHashmap.delete(lookupId);
                        }
                    });
                }
            },
            {
                key: "freeTextureSource",
                value: function freeTextureSource(textureSource) {
                    var index = this._uploadedTextureSources.indexOf(textureSource);
                    var managed = index !== -1;
                    if (textureSource.isLoaded()) {
                        if (managed) {
                            this._addMemoryUsage(-textureSource.w * textureSource.h);
                            this._uploadedTextureSources.splice(index, 1);
                        }
                        this._nativeFreeTextureSource(textureSource);
                    }
                    textureSource.loadingSince = null;
                }
            },
            {
                key: "_nativeUploadTextureSource",
                value: function _nativeUploadTextureSource(textureSource, options) {
                    return this.stage.renderer.uploadTextureSource(textureSource, options);
                }
            },
            {
                key: "_nativeFreeTextureSource",
                value: function _nativeFreeTextureSource(textureSource) {
                    this.stage.renderer.freeTextureSource(textureSource);
                    textureSource.clearNativeTexture();
                }
            }
        ]);
        return TextureManager;
    }();
    var TextureThrottler = /*#__PURE__*/ function() {
        function TextureThrottler(stage) {
            var _this = this;
            _class_call_check._(this, TextureThrottler);
            this.stage = stage;
            this.genericCancelCb = function(textureSource) {
                _this._remove(textureSource);
            };
            this._sources = [];
            this._data = [];
        }
        _create_class._(TextureThrottler, [
            {
                key: "destroy",
                value: function destroy() {
                    this._sources = [];
                    this._data = [];
                }
            },
            {
                key: "processSome",
                value: function processSome() {
                    if (this._sources.length) {
                        var start = Date.now();
                        do {
                            this._processItem();
                        }while (this._sources.length && Date.now() - start < TextureThrottler.MAX_UPLOAD_TIME_PER_FRAME);
                    }
                }
            },
            {
                key: "_processItem",
                value: function _processItem() {
                    var source = this._sources.pop();
                    var data = this._data.pop();
                    if (source.isLoading()) {
                        source.processLoadedSource(data);
                    }
                }
            },
            {
                key: "add",
                value: function add(textureSource, data) {
                    this._sources.push(textureSource);
                    this._data.push(data);
                }
            },
            {
                key: "_remove",
                value: function _remove(textureSource) {
                    var index = this._sources.indexOf(textureSource);
                    if (index >= 0) {
                        this._sources.splice(index, 1);
                        this._data.splice(index, 1);
                    }
                }
            }
        ]);
        return TextureThrottler;
    }();
    TextureThrottler.MAX_UPLOAD_TIME_PER_FRAME = 10;
    var CoreContext = /*#__PURE__*/ function() {
        function CoreContext(stage) {
            _class_call_check._(this, CoreContext);
            this.stage = stage;
            this.root = null;
            this.updateTreeOrder = 0;
            this.renderState = this.stage.renderer.createCoreRenderState(this);
            this.renderExec = this.stage.renderer.createCoreRenderExecutor(this);
            this.renderExec.init();
            this._usedMemory = 0;
            this._renderTexturePool = [];
            this._renderTextureId = 1;
            this._zSorts = [];
            this.renderToTextureCount = 0;
        }
        _create_class._(CoreContext, [
            {
                key: "usedMemory",
                get: function get() {
                    return this._usedMemory;
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    var _this = this;
                    this._renderTexturePool.forEach(function(texture) {
                        return _this._freeRenderTexture(texture);
                    });
                    this._usedMemory = 0;
                }
            },
            {
                key: "hasRenderUpdates",
                value: function hasRenderUpdates() {
                    return !!this.root._parent._hasRenderUpdates;
                }
            },
            {
                key: "render",
                value: function render() {
                    this.root._parent._hasRenderUpdates = 0;
                    this._render();
                }
            },
            {
                key: "update",
                value: function update() {
                    this._update();
                    if (this.root._hasUpdates) {
                        this._update();
                    }
                    this._performForcedZSorts();
                }
            },
            {
                key: "_performForcedZSorts",
                value: function _performForcedZSorts() {
                    var n = this._zSorts.length;
                    if (n) {
                        for(var i = 0, n1 = this._zSorts.length; i < n1; i++){
                            if (this._zSorts[i].zSort) {
                                this._zSorts[i].sortZIndexedChildren();
                            }
                        }
                        this._zSorts = [];
                    }
                }
            },
            {
                key: "_update",
                value: function _update() {
                    this.updateTreeOrder = 0;
                    this.root.update();
                }
            },
            {
                key: "_render",
                value: function _render() {
                    var debugFrame = this.stage.getOption("debugFrame");
                    this._fillRenderState();
                    if (this.stage.getOption("readPixelsBeforeDraw")) {
                        this._readPixels();
                    }
                    this._performRender();
                    if (debugFrame) {
                        console.log("[Lightning] RTT Renders in frame: ".concat(this.renderToTextureCount));
                    }
                    if (this.stage.getOption("readPixelsAfterDraw") && this.renderToTextureCount >= this.stage.getOption("readPixelsAfterDrawThreshold")) {
                        if (debugFrame) {
                            console.log("[Lightning] readPixelsAfterDraw behavior triggered");
                        }
                        this._readPixels();
                    }
                    this.renderToTextureCount = 0;
                }
            },
            {
                key: "_readPixels",
                value: function _readPixels() {
                    var pixels = new Uint8Array(4);
                    var gl = this.stage.gl;
                    gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
                }
            },
            {
                key: "_fillRenderState",
                value: function _fillRenderState() {
                    this.renderState.reset();
                    this.root.render();
                    this.renderState.finish();
                }
            },
            {
                key: "_performRender",
                value: function _performRender() {
                    this.renderExec.execute();
                }
            },
            {
                key: "_addMemoryUsage",
                value: function _addMemoryUsage(delta) {
                    this._usedMemory += delta;
                    this.stage.addMemoryUsage(delta);
                }
            },
            {
                key: "allocateRenderTexture",
                value: function allocateRenderTexture(w, h) {
                    var prec = this.stage.getRenderPrecision();
                    var pw = Math.max(1, Math.round(w * prec));
                    var ph = Math.max(1, Math.round(h * prec));
                    var n = this._renderTexturePool.length;
                    for(var i = n - 1; i >= 0; i--){
                        var texture = this._renderTexturePool[i];
                        if (texture.w === pw && texture.h === ph && texture.update !== this.stage.frameCounter) {
                            texture.f = this.stage.frameCounter;
                            this._renderTexturePool.splice(i, 1);
                            return texture;
                        }
                    }
                    var texture1 = this._createRenderTexture(w, h, pw, ph);
                    texture1.precision = prec;
                    return texture1;
                }
            },
            {
                key: "releaseRenderTexture",
                value: function releaseRenderTexture(texture) {
                    this._renderTexturePool.push(texture);
                }
            },
            {
                key: "freeUnusedRenderTextures",
                value: function freeUnusedRenderTextures() {
                    var maxAge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 60;
                    var _this = this;
                    var limit = this.stage.frameCounter - maxAge;
                    this._renderTexturePool = this._renderTexturePool.filter(function(texture) {
                        if (texture.f <= limit) {
                            _this._freeRenderTexture(texture);
                            return false;
                        }
                        return true;
                    });
                }
            },
            {
                key: "_createRenderTexture",
                value: function _createRenderTexture(w, h, pw, ph) {
                    this._addMemoryUsage(pw * ph);
                    var texture = this.stage.renderer.createRenderTexture(w, h, pw, ph);
                    texture.id = this._renderTextureId++;
                    texture.f = this.stage.frameCounter;
                    texture.ow = w;
                    texture.oh = h;
                    texture.w = pw;
                    texture.h = ph;
                    return texture;
                }
            },
            {
                key: "_freeRenderTexture",
                value: function _freeRenderTexture(nativeTexture) {
                    this.stage.renderer.freeRenderTexture(nativeTexture);
                    this._addMemoryUsage(-nativeTexture.w * nativeTexture.h);
                }
            },
            {
                key: "copyRenderTexture",
                value: function copyRenderTexture(renderTexture, nativeTexture, options) {
                    this.stage.renderer.copyRenderTexture(renderTexture, nativeTexture, options);
                }
            },
            {
                key: "forceZSort",
                value: function forceZSort(elementCore) {
                    this._zSorts.push(elementCore);
                }
            }
        ]);
        return CoreContext;
    }();
    var TransitionSettings = /*#__PURE__*/ function() {
        function TransitionSettings(stage) {
            _class_call_check._(this, TransitionSettings);
            this.stage = stage;
            this._timingFunction = "ease";
            this._timingFunctionImpl = StageUtils.getTimingFunction(this._timingFunction);
            this.delay = 0;
            this.duration = 0.2;
            this.merger = null;
        }
        _create_class._(TransitionSettings, [
            {
                key: "timingFunction",
                get: function get() {
                    return this._timingFunction;
                },
                set: function set(v) {
                    this._timingFunction = v;
                    this._timingFunctionImpl = StageUtils.getTimingFunction(v);
                }
            },
            {
                key: "timingFunctionImpl",
                get: function get() {
                    return this._timingFunctionImpl;
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    Base.patchObject(this, settings);
                }
            }
        ]);
        return TransitionSettings;
    }();
    TransitionSettings.prototype.isTransitionSettings = true;
    var TransitionManager = /*#__PURE__*/ function() {
        function TransitionManager(stage) {
            var _this = this;
            _class_call_check._(this, TransitionManager);
            this.stage = stage;
            this.stage.on("frameStart", function() {
                return _this.progress();
            });
            this.active = new Set();
            this.defaultTransitionSettings = new TransitionSettings(this.stage);
        }
        _create_class._(TransitionManager, [
            {
                key: "progress",
                value: function progress() {
                    if (this.active.size) {
                        var dt = this.stage.dt;
                        var filter = false;
                        this.active.forEach(function(a) {
                            a.progress(dt);
                            if (!a.isRunning()) {
                                filter = true;
                            }
                        });
                        if (filter) {
                            this.active = new Set(_to_consumable_array._(this.active).filter(function(t) {
                                return t.isRunning();
                            }));
                        }
                    }
                }
            },
            {
                key: "createSettings",
                value: function createSettings(settings) {
                    var transitionSettings = new TransitionSettings();
                    Base.patchObject(transitionSettings, settings);
                    return transitionSettings;
                }
            },
            {
                key: "addActive",
                value: function addActive(transition) {
                    this.active.add(transition);
                }
            },
            {
                key: "removeActive",
                value: function removeActive(transition) {
                    this.active.delete(transition);
                }
            }
        ]);
        return TransitionManager;
    }();
    var MultiSpline = /*#__PURE__*/ function() {
        function MultiSpline() {
            _class_call_check._(this, MultiSpline);
            this._clear();
        }
        _create_class._(MultiSpline, [
            {
                key: "_clear",
                value: function _clear() {
                    this._p = [];
                    this._pe = [];
                    this._idp = [];
                    this._f = [];
                    this._v = [];
                    this._lv = [];
                    this._sm = [];
                    this._s = [];
                    this._ve = [];
                    this._sme = [];
                    this._se = [];
                    this._length = 0;
                }
            },
            {
                key: "parse",
                value: function parse(rgba, def) {
                    var i, n;
                    if (!Utils.isObjectLiteral(def)) {
                        def = {
                            0: def
                        };
                    }
                    var defaultSmoothness = 0.5;
                    var items = [];
                    for(var key in def){
                        if (def.hasOwnProperty(key)) {
                            var obj = def[key];
                            if (!Utils.isObjectLiteral(obj)) {
                                obj = {
                                    v: obj
                                };
                            }
                            var p = parseFloat(key);
                            if (key === "sm") {
                                defaultSmoothness = obj.v;
                            } else if (!isNaN(p) && p >= 0 && p <= 2) {
                                obj.p = p;
                                obj.f = Utils.isFunction(obj.v);
                                obj.lv = obj.f ? obj.v(0, 0) : obj.v;
                                items.push(obj);
                            }
                        }
                    }
                    items = items.sort(function(a, b) {
                        return a.p - b.p;
                    });
                    n = items.length;
                    for(i = 0; i < n; i++){
                        var last = i === n - 1;
                        if (!items[i].hasOwnProperty("pe")) {
                            items[i].pe = last ? items[i].p <= 1 ? 1 : 2 : items[i + 1].p;
                        } else {
                            var max = i < n - 1 ? items[i + 1].p : 1;
                            if (items[i].pe > max) {
                                items[i].pe = max;
                            }
                        }
                        if (items[i].pe === items[i].p) {
                            items[i].idp = 0;
                        } else {
                            items[i].idp = 1 / (items[i].pe - items[i].p);
                        }
                    }
                    for(i = 0; i < n; i++){
                        if (!items[i].hasOwnProperty("sm")) {
                            items[i].sm = defaultSmoothness;
                        }
                        if (!items[i].hasOwnProperty("s")) {
                            if (i === 0 || i === n - 1 || items[i].p === 1) {
                                items[i].s = rgba ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : 0;
                            } else {
                                var pi = items[i - 1];
                                var ni = items[i + 1];
                                if (pi.p === ni.p) {
                                    items[i].s = rgba ? [
                                        0,
                                        0,
                                        0,
                                        0
                                    ] : 0;
                                } else {
                                    if (rgba) {
                                        var nc = MultiSpline.getRgbaComponents(ni.lv);
                                        var pc = MultiSpline.getRgbaComponents(pi.lv);
                                        var d = 1 / (ni.p - pi.p);
                                        items[i].s = [
                                            d * (nc[0] - pc[0]),
                                            d * (nc[1] - pc[1]),
                                            d * (nc[2] - pc[2]),
                                            d * (nc[3] - pc[3])
                                        ];
                                    } else {
                                        items[i].s = (ni.lv - pi.lv) / (ni.p - pi.p);
                                    }
                                }
                            }
                        }
                    }
                    for(i = 0; i < n - 1; i++){
                        if (!items[i].f) {
                            var last1 = i === n - 1;
                            if (!items[i].hasOwnProperty("ve")) {
                                items[i].ve = last1 ? items[i].lv : items[i + 1].lv;
                            }
                            if (Utils.isNumber(items[i].v) && Utils.isNumber(items[i].lv)) {
                                if (!items[i].hasOwnProperty("sme")) {
                                    items[i].sme = last1 ? defaultSmoothness : items[i + 1].sm;
                                }
                                if (!items[i].hasOwnProperty("se")) {
                                    items[i].se = last1 ? rgba ? [
                                        0,
                                        0,
                                        0,
                                        0
                                    ] : 0 : items[i + 1].s;
                                }
                                if (rgba) {
                                    items[i].v = MultiSpline.getSplineRgbaValueFunction(items[i].v, items[i].ve, items[i].p, items[i].pe, items[i].sm, items[i].sme, items[i].s, items[i].se);
                                } else {
                                    items[i].v = MultiSpline.getSplineValueFunction(items[i].v, items[i].ve, items[i].p, items[i].pe, items[i].sm, items[i].sme, items[i].s, items[i].se);
                                }
                                items[i].f = true;
                            }
                        }
                    }
                    if (this.length) {
                        this._clear();
                    }
                    for(i = 0, n = items.length; i < n; i++){
                        this._add(items[i]);
                    }
                }
            },
            {
                key: "_add",
                value: function _add(item) {
                    this._p.push(item.p || 0);
                    this._pe.push(item.pe || 0);
                    this._idp.push(item.idp || 0);
                    this._f.push(item.f || false);
                    this._v.push(item.hasOwnProperty("v") ? item.v : 0);
                    this._lv.push(item.lv || 0);
                    this._sm.push(item.sm || 0);
                    this._s.push(item.s || 0);
                    this._ve.push(item.ve || 0);
                    this._sme.push(item.sme || 0);
                    this._se.push(item.se || 0);
                    this._length++;
                }
            },
            {
                key: "_getItem",
                value: function _getItem(p) {
                    var n = this._length;
                    if (!n) {
                        return -1;
                    }
                    if (p < this._p[0]) {
                        return 0;
                    }
                    for(var i = 0; i < n; i++){
                        if (this._p[i] <= p && p < this._pe[i]) {
                            return i;
                        }
                    }
                    return n - 1;
                }
            },
            {
                key: "getValue",
                value: function getValue(p) {
                    var i = this._getItem(p);
                    if (i === -1) {
                        return undefined;
                    } else {
                        if (this._f[i]) {
                            var o = Math.min(1, Math.max(0, (p - this._p[i]) * this._idp[i]));
                            return this._v[i](o);
                        } else {
                            return this._v[i];
                        }
                    }
                }
            },
            {
                key: "length",
                get: function get() {
                    return this._length;
                }
            }
        ], [
            {
                key: "getRgbaComponents",
                value: function getRgbaComponents(argb) {
                    var r = (argb / 65536 | 0) % 256;
                    var g = (argb / 256 | 0) % 256;
                    var b = argb % 256;
                    var a = argb / 16777216 | 0;
                    return [
                        r,
                        g,
                        b,
                        a
                    ];
                }
            },
            {
                key: "getSplineValueFunction",
                value: function getSplineValueFunction(v1, v2, p1, p2, o1, i2, s1, s2) {
                    var dp = p2 - p1;
                    s1 *= dp;
                    s2 *= dp;
                    var helpers = MultiSpline.getSplineHelpers(v1, v2, o1, i2, s1, s2);
                    if (!helpers) {
                        return function(p) {
                            if (p === 0) return v1;
                            if (p === 1) return v2;
                            return v2 * p + v1 * (1 - p);
                        };
                    } else {
                        return function(p) {
                            if (p === 0) return v1;
                            if (p === 1) return v2;
                            return MultiSpline.calculateSpline(helpers, p);
                        };
                    }
                }
            },
            {
                key: "getSplineRgbaValueFunction",
                value: function getSplineRgbaValueFunction(v1, v2, p1, p2, o1, i2, s1, s2) {
                    var dp = p2 - p1;
                    s1[0] *= dp;
                    s1[1] *= dp;
                    s1[2] *= dp;
                    s1[3] *= dp;
                    s2[0] *= dp;
                    s2[1] *= dp;
                    s2[2] *= dp;
                    s2[3] *= dp;
                    var cv1 = MultiSpline.getRgbaComponents(v1);
                    var cv2 = MultiSpline.getRgbaComponents(v2);
                    var helpers = [
                        MultiSpline.getSplineHelpers(cv1[0], cv2[0], o1, i2, s1[0], s2[0]),
                        MultiSpline.getSplineHelpers(cv1[1], cv2[1], o1, i2, s1[1], s2[1]),
                        MultiSpline.getSplineHelpers(cv1[2], cv2[2], o1, i2, s1[2], s2[2]),
                        MultiSpline.getSplineHelpers(cv1[3], cv2[3], o1, i2, s1[3], s2[3])
                    ];
                    if (!helpers[0]) {
                        return function(p) {
                            if (p === 0) return v1;
                            if (p === 1) return v2;
                            return MultiSpline.mergeColors(v2, v1, p);
                        };
                    } else {
                        return function(p) {
                            if (p === 0) return v1;
                            if (p === 1) return v2;
                            return MultiSpline.getArgbNumber([
                                Math.min(255, MultiSpline.calculateSpline(helpers[0], p)),
                                Math.min(255, MultiSpline.calculateSpline(helpers[1], p)),
                                Math.min(255, MultiSpline.calculateSpline(helpers[2], p)),
                                Math.min(255, MultiSpline.calculateSpline(helpers[3], p))
                            ]);
                        };
                    }
                }
            },
            {
                key: "getSplineHelpers",
                value: function getSplineHelpers(v1, v2, o1, i2, s1, s2) {
                    if (!o1 && !i2) {
                        return null;
                    }
                    var csx = o1;
                    var csy = v1 + s1 * o1;
                    var cex = 1 - i2;
                    var cey = v2 - s2 * i2;
                    var xa = 3 * csx - 3 * cex + 1;
                    var xb = -6 * csx + 3 * cex;
                    var xc = 3 * csx;
                    var ya = 3 * csy - 3 * cey + v2 - v1;
                    var yb = 3 * (cey + v1) - 6 * csy;
                    var yc = 3 * (csy - v1);
                    var yd = v1;
                    return [
                        xa,
                        xb,
                        xc,
                        ya,
                        yb,
                        yc,
                        yd
                    ];
                }
            },
            {
                key: "calculateSpline",
                value: function calculateSpline(helpers, p) {
                    var xa = helpers[0];
                    var xb = helpers[1];
                    var xc = helpers[2];
                    var ya = helpers[3];
                    var yb = helpers[4];
                    var yc = helpers[5];
                    var yd = helpers[6];
                    if (xa === -2 && ya === -2 && xc === 0 && yc === 0) {
                        return p;
                    }
                    var t = 0.5, cbx, dx;
                    for(var it = 0; it < 20; it++){
                        cbx = t * (t * (t * xa + xb) + xc);
                        dx = p - cbx;
                        if (dx > -1e-8 && dx < 1e-8) {
                            return t * (t * (t * ya + yb) + yc) + yd;
                        }
                        var cbxd = t * (t * (3 * xa) + 2 * xb) + xc;
                        if (cbxd > 1e-10 && cbxd < 1e-10) {
                            break;
                        }
                        t += dx / cbxd;
                    }
                    var minT = 0;
                    var maxT = 1;
                    for(var it1 = 0; it1 < 20; it1++){
                        t = 0.5 * (minT + maxT);
                        cbx = t * (t * (t * xa + xb) + xc);
                        dx = p - cbx;
                        if (dx > -1e-8 && dx < 1e-8) {
                            return t * (t * (t * ya + yb) + yc) + yd;
                        }
                        if (dx < 0) {
                            maxT = t;
                        } else {
                            minT = t;
                        }
                    }
                    return t;
                }
            },
            {
                key: "mergeColors",
                value: function mergeColors(c1, c2, p) {
                    var r1 = (c1 / 65536 | 0) % 256;
                    var g1 = (c1 / 256 | 0) % 256;
                    var b1 = c1 % 256;
                    var a1 = c1 / 16777216 | 0;
                    var r2 = (c2 / 65536 | 0) % 256;
                    var g2 = (c2 / 256 | 0) % 256;
                    var b2 = c2 % 256;
                    var a2 = c2 / 16777216 | 0;
                    var r = r1 * p + r2 * (1 - p);
                    var g = g1 * p + g2 * (1 - p);
                    var b = b1 * p + b2 * (1 - p);
                    var a = a1 * p + a2 * (1 - p);
                    return Math.round(a) * 16777216 + Math.round(r) * 65536 + Math.round(g) * 256 + Math.round(b);
                }
            },
            {
                key: "getArgbNumber",
                value: function getArgbNumber(rgba) {
                    rgba[0] = Math.max(0, Math.min(255, rgba[0]));
                    rgba[1] = Math.max(0, Math.min(255, rgba[1]));
                    rgba[2] = Math.max(0, Math.min(255, rgba[2]));
                    rgba[3] = Math.max(0, Math.min(255, rgba[3]));
                    var v = ((rgba[3] | 0) << 24) + ((rgba[0] | 0) << 16) + ((rgba[1] | 0) << 8) + (rgba[2] | 0);
                    if (v < 0) {
                        v = 0xFFFFFFFF + v + 1;
                    }
                    return v;
                }
            }
        ]);
        return MultiSpline;
    }();
    var AnimationActionSettings = /*#__PURE__*/ function() {
        function AnimationActionSettings(animationSettings) {
            _class_call_check._(this, AnimationActionSettings);
            this.animationSettings = animationSettings;
            this._selector = "";
            this._items = new MultiSpline();
            this._props = [];
            this._propSetters = [];
            this._resetValue = undefined;
            this._hasResetValue = false;
            this._hasColorProperty = undefined;
        }
        _create_class._(AnimationActionSettings, [
            {
                key: "getResetValue",
                value: function getResetValue() {
                    if (this._hasResetValue) {
                        return this._resetValue;
                    } else {
                        return this._items.getValue(0);
                    }
                }
            },
            {
                key: "apply",
                value: function apply(element, p, factor) {
                    var elements = this.getAnimatedElements(element);
                    var v = this._items.getValue(p);
                    if (v === undefined || !elements.length) {
                        return;
                    }
                    if (factor !== 1) {
                        var sv = this.getResetValue();
                        if (Utils.isNumber(v) && Utils.isNumber(sv)) {
                            if (this.hasColorProperty()) {
                                v = StageUtils.mergeColors(v, sv, factor);
                            } else {
                                v = StageUtils.mergeNumbers(v, sv, factor);
                            }
                        }
                    }
                    var n = this._propSetters.length;
                    var m = elements.length;
                    for(var j = 0; j < m; j++){
                        for(var i = 0; i < n; i++){
                            this._propSetters[i](elements[j], v);
                        }
                    }
                }
            },
            {
                key: "getAnimatedElements",
                value: function getAnimatedElements(element) {
                    return element.select(this._selector);
                }
            },
            {
                key: "reset",
                value: function reset(element) {
                    var elements = this.getAnimatedElements(element);
                    var v = this.getResetValue();
                    if (v === undefined || !elements.length) {
                        return;
                    }
                    var n = this._propSetters.length;
                    var m = elements.length;
                    for(var j = 0; j < m; j++){
                        for(var i = 0; i < n; i++){
                            this._propSetters[i](elements[j], v);
                        }
                    }
                }
            },
            {
                key: "selector",
                set: function set(v) {
                    this._selector = v;
                }
            },
            {
                key: "t",
                set: function set(v) {
                    this.selector = v;
                }
            },
            {
                key: "resetValue",
                get: function get() {
                    return this._resetValue;
                },
                set: function set(v) {
                    this._resetValue = v;
                    this._hasResetValue = v !== undefined;
                }
            },
            {
                key: "rv",
                set: function set(v) {
                    this.resetValue = v;
                }
            },
            {
                key: "value",
                set: function set(v) {
                    this._items.parse(this.hasColorProperty(), v);
                }
            },
            {
                key: "v",
                set: function set(v) {
                    this.value = v;
                }
            },
            {
                key: "properties",
                set: function set(v) {
                    var _this = this;
                    if (!Array.isArray(v)) {
                        v = [
                            v
                        ];
                    }
                    this._props = [];
                    v.forEach(function(prop) {
                        _this._props.push(prop);
                        _this._propSetters.push(Element.getSetter(prop));
                    });
                }
            },
            {
                key: "property",
                set: function set(v) {
                    this._hasColorProperty = undefined;
                    this.properties = v;
                }
            },
            {
                key: "p",
                set: function set(v) {
                    this.properties = v;
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    Base.patchObject(this, settings);
                }
            },
            {
                key: "hasColorProperty",
                value: function hasColorProperty() {
                    if (this._hasColorProperty === undefined) {
                        this._hasColorProperty = this._props.length ? Element.isColorProperty(this._props[0]) : false;
                    }
                    return this._hasColorProperty;
                }
            }
        ]);
        return AnimationActionSettings;
    }();
    AnimationActionSettings.prototype.isAnimationActionSettings = true;
    var AnimationSettings = /*#__PURE__*/ function() {
        function AnimationSettings() {
            _class_call_check._(this, AnimationSettings);
            this._actions = [];
            this.delay = 0;
            this.duration = 1;
            this.repeat = 0;
            this.repeatOffset = 0;
            this.repeatDelay = 0;
            this.autostop = false;
            this.stopMethod = AnimationSettings.STOP_METHODS.FADE;
            this._stopTimingFunction = "ease";
            this._stopTimingFunctionImpl = StageUtils.getTimingFunction(this._stopTimingFunction);
            this.stopDuration = 0;
            this.stopDelay = 0;
        }
        _create_class._(AnimationSettings, [
            {
                key: "actions",
                get: function get() {
                    return this._actions;
                },
                set: function set(v) {
                    this._actions = [];
                    for(var i = 0, n = v.length; i < n; i++){
                        var e = v[i];
                        if (!e.isAnimationActionSettings) {
                            var aas = new AnimationActionSettings(this);
                            aas.patch(e);
                            this._actions.push(aas);
                        } else {
                            this._actions.push(e);
                        }
                    }
                }
            },
            {
                key: "apply",
                value: function apply(element, p) {
                    var factor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
                    this._actions.forEach(function(action) {
                        action.apply(element, p, factor);
                    });
                }
            },
            {
                key: "reset",
                value: function reset(element) {
                    this._actions.forEach(function(action) {
                        action.reset(element);
                    });
                }
            },
            {
                key: "stopTimingFunction",
                get: function get() {
                    return this._stopTimingFunction;
                },
                set: function set(v) {
                    this._stopTimingFunction = v;
                    this._stopTimingFunctionImpl = StageUtils.getTimingFunction(v);
                }
            },
            {
                key: "stopTimingFunctionImpl",
                get: function get() {
                    return this._stopTimingFunctionImpl;
                }
            },
            {
                key: "patch",
                value: function patch(settings) {
                    Base.patchObject(this, settings);
                }
            }
        ]);
        return AnimationSettings;
    }();
    AnimationSettings.STOP_METHODS = {
        FADE: "fade",
        REVERSE: "reverse",
        FORWARD: "forward",
        IMMEDIATE: "immediate",
        ONETOTWO: "onetotwo"
    };
    var Animation = /*#__PURE__*/ function(EventEmitter) {
        _inherits._(Animation, EventEmitter);
        var _super = _create_super._(Animation);
        function Animation(manager, settings, element) {
            _class_call_check._(this, Animation);
            var _this;
            _this = _super.call(this);
            _this.manager = manager;
            _this._settings = settings;
            _this._element = element;
            _this._state = Animation.STATES.IDLE;
            _this._p = 0;
            _this._delayLeft = 0;
            _this._repeatsLeft = 0;
            _this._stopDelayLeft = 0;
            _this._stopP = 0;
            return _this;
        }
        _create_class._(Animation, [
            {
                key: "start",
                value: function start() {
                    if (this._element && this._element.attached) {
                        this._p = 0;
                        this._delayLeft = this.settings.delay;
                        this._repeatsLeft = this.settings.repeat;
                        this._state = Animation.STATES.PLAYING;
                        this.emit("start");
                        this.checkActive();
                    } else {
                        console.warn("[Lightning] Element must be attached before starting animation");
                    }
                }
            },
            {
                key: "play",
                value: function play() {
                    if (this._state === Animation.STATES.PAUSED) {
                        this._state = Animation.STATES.PLAYING;
                        this.checkActive();
                        this.emit("resume");
                    } else if (this._state == Animation.STATES.STOPPING && this.settings.stopMethod == AnimationSettings.STOP_METHODS.REVERSE) {
                        this._state = Animation.STATES.PLAYING;
                        this.emit("stopContinue");
                    } else if (this._state != Animation.STATES.PLAYING && this._state != Animation.STATES.FINISHED) {
                        this.start();
                    }
                }
            },
            {
                key: "pause",
                value: function pause() {
                    if (this._state === Animation.STATES.PLAYING) {
                        this._state = Animation.STATES.PAUSED;
                        this.emit("pause");
                    }
                }
            },
            {
                key: "replay",
                value: function replay() {
                    if (this._state == Animation.STATES.FINISHED) {
                        this.start();
                    } else {
                        this.play();
                    }
                }
            },
            {
                key: "skipDelay",
                value: function skipDelay() {
                    this._delayLeft = 0;
                    this._stopDelayLeft = 0;
                }
            },
            {
                key: "finish",
                value: function finish() {
                    if (this._state === Animation.STATES.PLAYING) {
                        this._delayLeft = 0;
                        this._p = 1;
                    } else if (this._state === Animation.STATES.STOPPING) {
                        this._stopDelayLeft = 0;
                        this._p = 0;
                    }
                }
            },
            {
                key: "stop",
                value: function stop() {
                    if (this._state === Animation.STATES.STOPPED || this._state === Animation.STATES.IDLE) return;
                    this._stopDelayLeft = this.settings.stopDelay || 0;
                    if (this.settings.stopMethod === AnimationSettings.STOP_METHODS.IMMEDIATE && !this._stopDelayLeft || this._delayLeft > 0) {
                        this._state = Animation.STATES.STOPPING;
                        this.emit("stop");
                    } else {
                        if (this.settings.stopMethod === AnimationSettings.STOP_METHODS.FADE) {
                            this._stopP = 0;
                        }
                        this._state = Animation.STATES.STOPPING;
                        this.emit("stop");
                    }
                    this.checkActive();
                }
            },
            {
                key: "stopNow",
                value: function stopNow() {
                    if (this._state !== Animation.STATES.STOPPED || this._state !== Animation.STATES.IDLE) {
                        this._state = Animation.STATES.STOPPING;
                        this._p = 0;
                        this.emit("stop");
                        this.reset();
                        this._state = Animation.STATES.STOPPED;
                        this.emit("stopFinish");
                    }
                }
            },
            {
                key: "isPaused",
                value: function isPaused() {
                    return this._state === Animation.STATES.PAUSED;
                }
            },
            {
                key: "isPlaying",
                value: function isPlaying() {
                    return this._state === Animation.STATES.PLAYING;
                }
            },
            {
                key: "isStopping",
                value: function isStopping() {
                    return this._state === Animation.STATES.STOPPING;
                }
            },
            {
                key: "isFinished",
                value: function isFinished() {
                    return this._state === Animation.STATES.FINISHED;
                }
            },
            {
                key: "checkActive",
                value: function checkActive() {
                    if (this.isActive()) {
                        this.manager.addActive(this);
                    }
                }
            },
            {
                key: "isActive",
                value: function isActive() {
                    return (this._state == Animation.STATES.PLAYING || this._state == Animation.STATES.STOPPING) && this._element && this._element.attached;
                }
            },
            {
                key: "progress",
                value: function progress(dt) {
                    if (!this._element) return;
                    this._progress(dt);
                    this.apply();
                }
            },
            {
                key: "_progress",
                value: function _progress(dt) {
                    if (this._state == Animation.STATES.STOPPING) {
                        this._stopProgress(dt);
                        return;
                    }
                    if (this._state != Animation.STATES.PLAYING) {
                        return;
                    }
                    if (this._delayLeft > 0) {
                        this._delayLeft -= dt;
                        if (this._delayLeft < 0) {
                            dt = -this._delayLeft;
                            this._delayLeft = 0;
                            this.emit("delayEnd");
                        } else {
                            return;
                        }
                    }
                    if (this.settings.duration === 0) {
                        this._p = 1;
                    } else if (this.settings.duration > 0) {
                        this._p += dt / this.settings.duration;
                    }
                    if (this._p >= 1) {
                        if (this.settings.repeat == -1 || this._repeatsLeft > 0) {
                            if (this._repeatsLeft > 0) {
                                this._repeatsLeft--;
                            }
                            this._p = this.settings.repeatOffset;
                            this.emit("progress", this._p);
                            if (this.settings.repeatDelay) {
                                this._delayLeft = this.settings.repeatDelay;
                            }
                            this.emit("repeat", this._repeatsLeft);
                        } else {
                            this._p = 1;
                            this.emit("progress", this._p);
                            this._state = Animation.STATES.FINISHED;
                            this.emit("finish");
                            if (this.settings.autostop) {
                                this.stop();
                            }
                        }
                    } else {
                        this.emit("progress", this._p);
                    }
                }
            },
            {
                key: "_stopProgress",
                value: function _stopProgress(dt) {
                    var duration = this._getStopDuration();
                    if (this._stopDelayLeft > 0) {
                        this._stopDelayLeft -= dt;
                        if (this._stopDelayLeft < 0) {
                            dt = -this._stopDelayLeft;
                            this._stopDelayLeft = 0;
                            this.emit("stopDelayEnd");
                        } else {
                            return;
                        }
                    }
                    if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.IMMEDIATE) {
                        this._state = Animation.STATES.STOPPED;
                        this.emit("stopFinish");
                    } else if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.REVERSE) {
                        if (duration === 0) {
                            this._p = 0;
                        } else if (duration > 0) {
                            this._p -= dt / duration;
                        }
                        if (this._p <= 0) {
                            this._p = 0;
                            this._state = Animation.STATES.STOPPED;
                            this.emit("stopFinish");
                        }
                    } else if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.FADE) {
                        this._progressStopTransition(dt);
                        if (this._stopP >= 1) {
                            this._p = 0;
                            this._state = Animation.STATES.STOPPED;
                            this.emit("stopFinish");
                        }
                    } else if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.ONETOTWO) {
                        if (this._p < 2) {
                            if (duration === 0) {
                                this._p = 2;
                            } else if (duration > 0) {
                                if (this._p < 1) {
                                    this._p += dt / this.settings.duration;
                                } else {
                                    this._p += dt / duration;
                                }
                            }
                            if (this._p >= 2) {
                                this._p = 2;
                                this._state = Animation.STATES.STOPPED;
                                this.emit("stopFinish");
                            } else {
                                this.emit("progress", this._p);
                            }
                        }
                    } else if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.FORWARD) {
                        if (this._p < 1) {
                            if (this.settings.duration == 0) {
                                this._p = 1;
                            } else {
                                this._p += dt / this.settings.duration;
                            }
                            if (this._p >= 1) {
                                if (this.settings.stopMethod == AnimationSettings.STOP_METHODS.FORWARD) {
                                    this._p = 1;
                                    this._state = Animation.STATES.STOPPED;
                                    this.emit("stopFinish");
                                } else {
                                    if (this._repeatsLeft > 0) {
                                        this._repeatsLeft--;
                                        this._p = 0;
                                        this.emit("repeat", this._repeatsLeft);
                                    } else {
                                        this._p = 1;
                                        this._state = Animation.STATES.STOPPED;
                                        this.emit("stopFinish");
                                    }
                                }
                            } else {
                                this.emit("progress", this._p);
                            }
                        }
                    }
                }
            },
            {
                key: "_progressStopTransition",
                value: function _progressStopTransition(dt) {
                    if (this._stopP < 1) {
                        if (this._stopDelayLeft > 0) {
                            this._stopDelayLeft -= dt;
                            if (this._stopDelayLeft < 0) {
                                dt = -this._stopDelayLeft;
                                this._stopDelayLeft = 0;
                                this.emit("delayEnd");
                            } else {
                                return;
                            }
                        }
                        var duration = this._getStopDuration();
                        if (duration == 0) {
                            this._stopP = 1;
                        } else {
                            this._stopP += dt / duration;
                        }
                        if (this._stopP >= 1) {
                            this._stopP = 1;
                        }
                    }
                }
            },
            {
                key: "_getStopDuration",
                value: function _getStopDuration() {
                    return this.settings.stopDuration || this.settings.duration;
                }
            },
            {
                key: "apply",
                value: function apply() {
                    if (this._state === Animation.STATES.STOPPED) {
                        this.reset();
                    } else {
                        var factor = 1;
                        if (this._state === Animation.STATES.STOPPING && this.settings.stopMethod === AnimationSettings.STOP_METHODS.FADE) {
                            factor = 1 - this.settings.stopTimingFunctionImpl(this._stopP);
                        }
                        this._settings.apply(this._element, this._p, factor);
                    }
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this._settings.reset(this._element);
                }
            },
            {
                key: "state",
                get: function get() {
                    return this._state;
                }
            },
            {
                key: "p",
                get: function get() {
                    return this._p;
                }
            },
            {
                key: "delayLeft",
                get: function get() {
                    return this._delayLeft;
                }
            },
            {
                key: "element",
                get: function get() {
                    return this._element;
                }
            },
            {
                key: "frame",
                get: function get() {
                    return Math.round(this._p * this._settings.duration * 60);
                }
            },
            {
                key: "settings",
                get: function get() {
                    return this._settings;
                }
            }
        ]);
        return Animation;
    }(EventEmitter);
    Animation.STATES = {
        IDLE: 0,
        PLAYING: 1,
        STOPPING: 2,
        STOPPED: 3,
        FINISHED: 4,
        PAUSED: 5
    };
    var AnimationManager = /*#__PURE__*/ function() {
        function AnimationManager(stage) {
            var _this = this;
            _class_call_check._(this, AnimationManager);
            this.stage = stage;
            this.stage.on("frameStart", function() {
                return _this.progress();
            });
            this.active = new Set();
        }
        _create_class._(AnimationManager, [
            {
                key: "progress",
                value: function progress() {
                    if (this.active.size) {
                        var dt = this.stage.dt;
                        var filter = false;
                        this.active.forEach(function(a) {
                            if (a.isActive()) {
                                a.progress(dt);
                            } else {
                                filter = true;
                            }
                        });
                        if (filter) {
                            this.active = new Set(_to_consumable_array._(this.active).filter(function(t) {
                                return t.isActive();
                            }));
                        }
                    }
                }
            },
            {
                key: "createAnimation",
                value: function createAnimation(element, settings) {
                    if (Utils.isObjectLiteral(settings)) {
                        settings = this.createSettings(settings);
                    }
                    return new Animation(this, settings, element);
                }
            },
            {
                key: "createSettings",
                value: function createSettings(settings) {
                    var animationSettings = new AnimationSettings();
                    Base.patchObject(animationSettings, settings);
                    return animationSettings;
                }
            },
            {
                key: "addActive",
                value: function addActive(transition) {
                    this.active.add(transition);
                }
            }
        ]);
        return AnimationManager;
    }();
    var RectangleTexture = /*#__PURE__*/ function(Texture) {
        _inherits._(RectangleTexture, Texture);
        var _super = _create_super._(RectangleTexture);
        function RectangleTexture() {
            _class_call_check._(this, RectangleTexture);
            return _super.apply(this, arguments);
        }
        _create_class._(RectangleTexture, [
            {
                key: "_getLookupId",
                value: function _getLookupId() {
                    return "__whitepix";
                }
            },
            {
                key: "_getSourceLoader",
                value: function _getSourceLoader() {
                    return function(cb) {
                        var whitePixel = new Uint8Array([
                            255,
                            255,
                            255,
                            255
                        ]);
                        cb(null, {
                            source: whitePixel,
                            w: 1,
                            h: 1,
                            permanent: true
                        });
                    };
                }
            },
            {
                key: "isAutosizeTexture",
                value: function isAutosizeTexture() {
                    return false;
                }
            }
        ]);
        return RectangleTexture;
    }(Texture);
    var Stage = /*#__PURE__*/ function(EventEmitter) {
        _inherits._(Stage, EventEmitter);
        var _super = _create_super._(Stage);
        function Stage() {
            var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            _class_call_check._(this, Stage);
            var _this;
            _this = _super.call(this);
            _this._setOptions(options);
            _this._usedMemory = 0;
            _this._lastGcFrame = 0;
            _this._usedVramAlpha = 0;
            _this._usedVramNonAlpha = 0;
            var platformType = Stage.platform ? Stage.platform : PlatformLoader.load(options);
            _this.platform = new platformType();
            if (_this.platform.init) {
                _this.platform.init(_assert_this_initialized._(_this));
            }
            _this.gl = null;
            _this.c2d = null;
            var context = _this.getOption("context");
            if (context) {
                if (context.useProgram) {
                    _this.gl = context;
                } else {
                    _this.c2d = context;
                }
            } else {
                if (Utils.isWeb && (!Stage.isWebglSupported() || _this.getOption("canvas2d"))) {
                    _this.c2d = _this.platform.createCanvasContext(_this.getOption("w"), _this.getOption("h"));
                } else {
                    _this.gl = _this.platform.createWebGLContext(_this.getOption("w"), _this.getOption("h"));
                }
            }
            if (_this.gl) {
                WebGLStateManager.enable(_this.gl, "lightning");
            }
            _this._mode = _this.gl ? 0 : 1;
            if (_this.getCanvas()) {
                _this._options.w = _this.getCanvas().width;
                _this._options.h = _this.getCanvas().height;
            }
            if (_this._mode === 0) {
                if (Utils.isSpark) {
                    _this._renderer = new SparkRenderer(_assert_this_initialized._(_this));
                } else {
                    _this._renderer = new WebGLRenderer(_assert_this_initialized._(_this));
                }
            } else {
                _this._renderer = new C2dRenderer(_assert_this_initialized._(_this));
            }
            _this.setClearColor(_this.getOption("clearColor"));
            _this.frameCounter = 0;
            _this.transitions = new TransitionManager(_assert_this_initialized._(_this));
            _this.animations = new AnimationManager(_assert_this_initialized._(_this));
            _this.textureManager = new TextureManager(_assert_this_initialized._(_this));
            _this.textureThrottler = new TextureThrottler(_assert_this_initialized._(_this));
            _this.startTime = 0;
            _this.currentTime = 0;
            _this.dt = 0;
            _this.rectangleTexture = new RectangleTexture(_assert_this_initialized._(_this));
            _this.rectangleTexture.load();
            _this.rectangleTexture.source.permanent = true;
            _this.ctx = new CoreContext(_assert_this_initialized._(_this));
            _this._updateSourceTextures = new Set();
            return _this;
        }
        _create_class._(Stage, [
            {
                key: "renderer",
                get: function get() {
                    return this._renderer;
                }
            },
            {
                key: "mode",
                get: function get() {
                    return this._mode;
                }
            },
            {
                key: "isWebgl",
                value: function isWebgl() {
                    return this.mode === 0;
                }
            },
            {
                key: "isC2d",
                value: function isC2d() {
                    return this.mode === 1;
                }
            },
            {
                key: "getOption",
                value: function getOption(name) {
                    return this._options[name];
                }
            },
            {
                key: "_setOptions",
                value: function _setOptions(o) {
                    var _this = this;
                    this._options = {};
                    var opt = function(name, def) {
                        var value = o[name];
                        if (value === undefined) {
                            _this._options[name] = def;
                        } else {
                            _this._options[name] = value;
                        }
                    };
                    opt("canvas", null);
                    opt("context", null);
                    opt("w", 1920);
                    opt("h", 1080);
                    opt("srcBasePath", null);
                    opt("memoryPressure", 24e6);
                    opt("bufferMemory", 2e6);
                    opt("textRenderIssueMargin", 0);
                    opt("fontSharp", {
                        precision: 0.6666666667,
                        fontSize: 24
                    });
                    opt("clearColor", [
                        0,
                        0,
                        0,
                        0
                    ]);
                    opt("defaultFontFace", "sans-serif");
                    opt("fixedDt", 0);
                    opt("useImageWorker", true);
                    opt("autostart", true);
                    opt("precision", 1);
                    opt("canvas2d", false);
                    opt("platform", null);
                    opt("readPixelsBeforeDraw", false);
                    opt("readPixelsAfterDraw", false);
                    opt("readPixelsAfterDrawThreshold", 0);
                    opt("debugFrame", false);
                    opt("forceTxCanvasSource", false);
                    opt("pauseRafLoopOnIdle", false);
                }
            },
            {
                key: "setApplication",
                value: function setApplication(app) {
                    this.application = app;
                }
            },
            {
                key: "init",
                value: function init() {
                    if (this.application.getOption("debug") && this.platform._imageWorker) {
                        console.log("[Lightning] Using image worker!");
                    }
                    if (this.application.getOption("debug") && this.c2d) {
                        console.log("[Lightning] Using canvas2d renderer");
                    }
                    this.application.setAsRoot();
                    if (this.getOption("autostart")) {
                        this.platform.startLoop();
                    }
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    this.platform.stopLoop();
                    this.platform.destroy();
                    this.ctx.destroy();
                    this.textureManager.destroy();
                    this._renderer.destroy();
                }
            },
            {
                key: "stop",
                value: function stop() {
                    this.platform.stopLoop();
                }
            },
            {
                key: "resume",
                value: function resume() {
                    this.platform.startLoop();
                }
            },
            {
                key: "root",
                get: function get() {
                    return this.application;
                }
            },
            {
                key: "getCanvas",
                value: function getCanvas() {
                    return this._mode ? this.c2d.canvas : this.gl.canvas;
                }
            },
            {
                key: "getRenderPrecision",
                value: function getRenderPrecision() {
                    return this._options.precision;
                }
            },
            {
                key: "addUpdateSourceTexture",
                value: function addUpdateSourceTexture(texture) {
                    if (this._updatingFrame) {
                        texture._performUpdateSource();
                    } else {
                        this._updateSourceTextures.add(texture);
                    }
                }
            },
            {
                key: "removeUpdateSourceTexture",
                value: function removeUpdateSourceTexture(texture) {
                    if (this._updateSourceTextures) {
                        this._updateSourceTextures.delete(texture);
                    }
                }
            },
            {
                key: "hasUpdateSourceTexture",
                value: function hasUpdateSourceTexture(texture) {
                    return this._updateSourceTextures && this._updateSourceTextures.has(texture);
                }
            },
            {
                key: "_performUpdateSource",
                value: function _performUpdateSource() {
                    if (this._updateSourceTextures.size) {
                        this._updateSourceTextures.forEach(function(texture) {
                            texture._performUpdateSource();
                        });
                        this._updateSourceTextures = new Set();
                    }
                }
            },
            {
                key: "_calculateDt",
                value: function _calculateDt() {
                    this.startTime = this.currentTime;
                    this.currentTime = this.platform.getHrTime();
                    if (this._options.fixedDt) {
                        this.dt = this._options.fixedDt;
                    } else {
                        this.dt = !this.startTime ? .02 : .001 * (this.currentTime - this.startTime);
                    }
                }
            },
            {
                key: "updateFrame",
                value: function updateFrame() {
                    this._calculateDt();
                    this.emit("frameStart");
                    this._performUpdateSource();
                    this.emit("update");
                }
            },
            {
                key: "idleFrame",
                value: function idleFrame() {
                    this.textureThrottler.processSome();
                    this.emit("frameEnd");
                    this.frameCounter++;
                }
            },
            {
                key: "renderFrame",
                value: function renderFrame() {
                    var changes = this.ctx.hasRenderUpdates();
                    this.textureThrottler.processSome();
                    if (changes) {
                        this._updatingFrame = true;
                        this.ctx.update();
                        this.ctx.render();
                        this._updatingFrame = false;
                    }
                    this.platform.nextFrame(changes);
                    this.emit("frameEnd");
                    this.frameCounter++;
                }
            },
            {
                key: "isUpdatingFrame",
                value: function isUpdatingFrame() {
                    return this._updatingFrame;
                }
            },
            {
                key: "drawFrame",
                value: function drawFrame() {
                    this.updateFrame();
                    this.renderFrame();
                }
            },
            {
                key: "forceRenderUpdate",
                value: function forceRenderUpdate() {
                    if (this.root) {
                        this.root.core._parent.setHasRenderUpdates(1);
                    }
                }
            },
            {
                key: "setClearColor",
                value: function setClearColor(clearColor) {
                    this.forceRenderUpdate();
                    if (clearColor === null) {
                        this._clearColor = null;
                    } else if (Array.isArray(clearColor)) {
                        this._clearColor = clearColor;
                    } else {
                        this._clearColor = StageUtils.getRgbaComponentsNormalized(clearColor);
                    }
                }
            },
            {
                key: "getClearColor",
                value: function getClearColor() {
                    return this._clearColor;
                }
            },
            {
                key: "createElement",
                value: function createElement(settings) {
                    if (settings) {
                        return this.element(settings);
                    } else {
                        return new Element(this);
                    }
                }
            },
            {
                key: "createShader",
                value: function createShader(settings) {
                    return Shader.create(this, settings);
                }
            },
            {
                key: "element",
                value: function element(settings) {
                    if (settings.isElement) return settings;
                    var element;
                    if (settings.type) {
                        element = new settings.type(this);
                    } else {
                        element = new Element(this);
                    }
                    element.patch(settings);
                    return element;
                }
            },
            {
                key: "c",
                value: function c(settings) {
                    return this.element(settings);
                }
            },
            {
                key: "w",
                get: function get() {
                    return this._options.w;
                }
            },
            {
                key: "h",
                get: function get() {
                    return this._options.h;
                }
            },
            {
                key: "coordsWidth",
                get: function get() {
                    return this.w / this._options.precision;
                }
            },
            {
                key: "coordsHeight",
                get: function get() {
                    return this.h / this._options.precision;
                }
            },
            {
                key: "addMemoryUsage",
                value: function addMemoryUsage(delta) {
                    this._usedMemory += delta;
                    if (this._lastGcFrame !== this.frameCounter) {
                        if (this._usedMemory > this.getOption("memoryPressure")) {
                            this.gc(false);
                            if (this._usedMemory > this.getOption("memoryPressure") - 2e6) {
                                this.gc(true);
                            }
                        }
                    }
                }
            },
            {
                key: "usedMemory",
                get: function get() {
                    return this._usedMemory;
                }
            },
            {
                key: "addVramUsage",
                value: function addVramUsage(delta, alpha) {
                    if (alpha) {
                        this._usedVramAlpha += delta;
                    } else {
                        this._usedVramNonAlpha += delta;
                    }
                }
            },
            {
                key: "usedVramAlpha",
                get: function get() {
                    return this._usedVramAlpha;
                }
            },
            {
                key: "usedVramNonAlpha",
                get: function get() {
                    return this._usedVramNonAlpha;
                }
            },
            {
                key: "usedVram",
                get: function get() {
                    return this._usedVramAlpha + this._usedVramNonAlpha;
                }
            },
            {
                key: "gc",
                value: function gc(aggressive) {
                    if (this._lastGcFrame !== this.frameCounter) {
                        this._lastGcFrame = this.frameCounter;
                        var memoryUsageBefore = this._usedMemory;
                        this.gcTextureMemory(aggressive);
                        this.gcRenderTextureMemory(aggressive);
                        this.renderer.gc(aggressive);
                        if (this.application.getOption("debug")) {
                            console.log("[Lightning] GC".concat(aggressive ? "[aggressive]" : "", "! Frame ").concat(this._lastGcFrame, " Freed ").concat(((memoryUsageBefore - this._usedMemory) / 1e6).toFixed(2), "MP from GPU memory. Remaining: ").concat((this._usedMemory / 1e6).toFixed(2), "MP"));
                            var other = this._usedMemory - this.textureManager.usedMemory - this.ctx.usedMemory;
                            console.log("[Lightning] Textures: ".concat((this.textureManager.usedMemory / 1e6).toFixed(2), "MP, Render Textures: ").concat((this.ctx.usedMemory / 1e6).toFixed(2), "MP, Renderer caches: ").concat((other / 1e6).toFixed(2), "MP"));
                        }
                    }
                }
            },
            {
                key: "gcTextureMemory",
                value: function gcTextureMemory() {
                    var aggressive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    if (aggressive && this.ctx.root.visible) {
                        this.ctx.root.visible = false;
                        this.textureManager.gc();
                        this.ctx.root.visible = true;
                    } else {
                        this.textureManager.gc();
                    }
                }
            },
            {
                key: "gcRenderTextureMemory",
                value: function gcRenderTextureMemory() {
                    var aggressive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                    if (aggressive && this.root.visible) {
                        this.root.visible = false;
                        this.ctx.freeUnusedRenderTextures(0);
                        this.root.visible = true;
                    } else {
                        this.ctx.freeUnusedRenderTextures(0);
                    }
                }
            },
            {
                key: "getDrawingCanvas",
                value: function getDrawingCanvas() {
                    return this.platform.getDrawingCanvas();
                }
            },
            {
                key: "update",
                value: function update() {
                    this.ctx.update();
                }
            },
            {
                key: "addServiceProvider",
                value: function addServiceProvider(serviceprovider) {
                    if (Utils.isSpark) {
                        this.platform.addServiceProvider(serviceprovider);
                    }
                }
            },
            {
                key: "getChildrenByPosition",
                value: function getChildrenByPosition(x, y) {
                    var children = [];
                    this.root.core.update();
                    this.root.core.collectAtCoord(x, y, children);
                    return children;
                }
            }
        ], [
            {
                key: "isWebglSupported",
                value: function isWebglSupported() {
                    if (Utils.isNode) {
                        return true;
                    }
                    try {
                        return !!window.WebGLRenderingContext;
                    } catch (e) {
                        return false;
                    }
                }
            }
        ]);
        return Stage;
    }(EventEmitter);
    var Application = /*#__PURE__*/ function(Component1) {
        _inherits._(Application, Component1);
        var _super = _create_super._(Application);
        function Application() {
            var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, properties = arguments.length > 1 ? arguments[1] : void 0;
            _class_call_check._(this, Application);
            var _this;
            Application._temp_options = options;
            Application.booting = true;
            var stage = new Stage(options.stage);
            _this = _super.call(this, stage, properties);
            Application.booting = false;
            _this.__updateFocusCounter = 0;
            _this.__keypressTimers = new Map();
            _this.__hoveredChild = null;
            _this.stage.init();
            _this.updateFocusSettings();
            _this.__keymap = _this.getOption("keys");
            if (_this.__keymap) {
                _this.stage.platform.registerKeydownHandler(function(e) {
                    _this._receiveKeydown(e);
                });
                _this.stage.platform.registerKeyupHandler(function(e) {
                    _this._receiveKeyup(e);
                });
            }
            if (_this.getOption("enablePointer")) {
                _this.stage.platform.registerClickHandler(function(e) {
                    _this._receiveClick(e);
                });
                _this.stage.platform.registerHoverHandler(function(e) {
                    _this._receiveHover(e);
                });
                _this.stage.platform.registerScrollWheelHandler(function(e) {
                    _this._recieveScrollWheel(e);
                });
                _this.cursor = "default";
            }
            return _this;
        }
        _create_class._(Application, [
            {
                key: "getOption",
                value: function getOption(name) {
                    return this.__options[name];
                }
            },
            {
                key: "_setOptions",
                value: function _setOptions(o) {
                    var _this = this;
                    this.__options = {};
                    var opt = function(name, def) {
                        var value = o[name];
                        if (value === undefined) {
                            _this.__options[name] = def;
                        } else {
                            _this.__options[name] = value;
                        }
                    };
                    opt("debug", false);
                    opt("keys", {
                        38: "Up",
                        40: "Down",
                        37: "Left",
                        39: "Right",
                        13: "Enter",
                        8: "Back",
                        27: "Exit"
                    });
                    opt("enablePointer", false);
                }
            },
            {
                key: "__construct",
                value: function __construct() {
                    this.stage.setApplication(this);
                    this._setOptions(Application._temp_options);
                    delete Application._temp_options;
                    _get._(_get_prototype_of._(Application.prototype), "__construct", this).call(this);
                }
            },
            {
                key: "__init",
                value: function __init() {
                    _get._(_get_prototype_of._(Application.prototype), "__init", this).call(this);
                    this.__updateFocus();
                }
            },
            {
                key: "updateFocusPath",
                value: function updateFocusPath() {
                    this.__updateFocus();
                }
            },
            {
                key: "__updateFocus",
                value: function __updateFocus() {
                    var notOverridden = this.__updateFocusRec();
                    if (!Application.booting && notOverridden) {
                        this.updateFocusSettings();
                    }
                }
            },
            {
                key: "__updateFocusRec",
                value: function __updateFocusRec() {
                    var updateFocusId = ++this.__updateFocusCounter;
                    this.__updateFocusId = updateFocusId;
                    var newFocusPath = this.__getFocusPath();
                    var newFocusedComponent = newFocusPath[newFocusPath.length - 1];
                    var prevFocusedComponent = this._focusPath ? this._focusPath[this._focusPath.length - 1] : undefined;
                    if (!prevFocusedComponent) {
                        this._focusPath = [];
                        for(var i = 0, n = newFocusPath.length; i < n; i++){
                            this._focusPath.push(newFocusPath[i]);
                            this._focusPath[i]._focus(newFocusedComponent, undefined);
                            var focusOverridden = this.__updateFocusId !== updateFocusId;
                            if (focusOverridden) {
                                return false;
                            }
                        }
                        return true;
                    } else {
                        var m = Math.min(this._focusPath.length, newFocusPath.length);
                        var index;
                        for(index = 0; index < m; index++){
                            if (this._focusPath[index] !== newFocusPath[index]) {
                                break;
                            }
                        }
                        if (this._focusPath.length !== newFocusPath.length || index !== newFocusPath.length) {
                            if (this.getOption("debug")) {
                                console.log("[Lightning] Focus changed: " + newFocusedComponent.getLocationString());
                            }
                            for(var i1 = this._focusPath.length - 1; i1 >= index; i1--){
                                var unfocusedElement = this._focusPath.pop();
                                unfocusedElement._unfocus(newFocusedComponent, prevFocusedComponent);
                                var focusOverridden1 = this.__updateFocusId !== updateFocusId;
                                if (focusOverridden1) {
                                    return false;
                                }
                            }
                            for(var i2 = index, n1 = newFocusPath.length; i2 < n1; i2++){
                                this._focusPath.push(newFocusPath[i2]);
                                this._focusPath[i2]._focus(newFocusedComponent, prevFocusedComponent);
                                var focusOverridden2 = this.__updateFocusId !== updateFocusId;
                                if (focusOverridden2) {
                                    return false;
                                }
                            }
                            for(var i3 = 0; i3 < index; i3++){
                                this._focusPath[i3]._focusChange(newFocusedComponent, prevFocusedComponent);
                            }
                        }
                    }
                    return true;
                }
            },
            {
                key: "updateFocusSettings",
                value: function updateFocusSettings() {
                    var focusedComponent = this._focusPath[this._focusPath.length - 1];
                    var focusSettings = {};
                    var defaultSetFocusSettings = Component.prototype._setFocusSettings;
                    for(var i = 0, n = this._focusPath.length; i < n; i++){
                        if (this._focusPath[i]._setFocusSettings !== defaultSetFocusSettings) {
                            this._focusPath[i]._setFocusSettings(focusSettings);
                        }
                    }
                    var defaultHandleFocusSettings = Component.prototype._handleFocusSettings;
                    for(var i1 = 0, n1 = this._focusPath.length; i1 < n1; i1++){
                        if (this._focusPath[i1]._handleFocusSettings !== defaultHandleFocusSettings) {
                            this._focusPath[i1]._handleFocusSettings(focusSettings, this.__prevFocusSettings, focusedComponent);
                        }
                    }
                    this.__prevFocusSettings = focusSettings;
                }
            },
            {
                key: "_handleFocusSettings",
                value: function _handleFocusSettings(settings, prevSettings, focused, prevFocused) {}
            },
            {
                key: "__getFocusPath",
                value: function __getFocusPath() {
                    var path = [
                        this
                    ];
                    var current = this;
                    do {
                        var nextFocus = current._getFocused();
                        if (!nextFocus || nextFocus === current) {
                            break;
                        }
                        var ptr = nextFocus.cparent;
                        if (ptr === current) {
                            path.push(nextFocus);
                        } else {
                            var newParts = [
                                nextFocus
                            ];
                            do {
                                if (!ptr) {
                                    current._throwError("Return value for _getFocused must be an attached descendant component but its '" + nextFocus.getLocationString() + "'");
                                }
                                newParts.push(ptr);
                                ptr = ptr.cparent;
                            }while (ptr !== current);
                            for(var i = 0, n = newParts.length; i < n; i++){
                                path.push(newParts[n - i - 1]);
                            }
                        }
                        current = nextFocus;
                    }while (true);
                    return path;
                }
            },
            {
                key: "focusPath",
                get: function get() {
                    return this._focusPath;
                }
            },
            {
                key: "focusTopDownEvent",
                value: function focusTopDownEvent(events) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var path = this.focusPath;
                    var n = path.length;
                    for(var i = 0; i < n; i++){
                        var event = path[i]._getMostSpecificHandledMember(events);
                        if (event !== undefined) {
                            var _path_i;
                            var returnValue = (_path_i = path[i])[event].apply(_path_i, _to_consumable_array._(args));
                            if (returnValue !== false) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
            },
            {
                key: "focusBottomUpEvent",
                value: function focusBottomUpEvent(events) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var path = this.focusPath;
                    var n = path.length;
                    for(var i = n - 1; i >= 0; i--){
                        var event = path[i]._getMostSpecificHandledMember(events);
                        if (event !== undefined) {
                            var _path_i;
                            var returnValue = (_path_i = path[i])[event].apply(_path_i, _to_consumable_array._(args));
                            if (returnValue !== false) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
            },
            {
                key: "_receiveKeydown",
                value: function _receiveKeydown(e) {
                    var obj = e;
                    var key = this.__keymap[e.keyCode];
                    var path = this.focusPath;
                    var keys;
                    if (key) {
                        keys = Array.isArray(key) ? key : [
                            key
                        ];
                    }
                    if (keys) {
                        for(var i = 0, n = keys.length; i < n; i++){
                            var hasTimer = this.__keypressTimers.has(keys[i]);
                            if (path[path.length - 1].longpress && hasTimer) {
                                return;
                            }
                            if (!this.stage.application.focusTopDownEvent([
                                "_capture".concat(keys[i]),
                                "_captureKey"
                            ], obj)) {
                                this.stage.application.focusBottomUpEvent([
                                    "_handle".concat(keys[i]),
                                    "_handleKey"
                                ], obj);
                            }
                        }
                    } else {
                        if (!this.stage.application.focusTopDownEvent([
                            "_captureKey"
                        ], obj)) {
                            this.stage.application.focusBottomUpEvent([
                                "_handleKey"
                            ], obj);
                        }
                    }
                    this.updateFocusPath();
                    var consumer = path[path.length - 1];
                    if (keys && consumer.longpress) {
                        for(var i1 = 0, n1 = keys.length; i1 < n1; i1++){
                            this._startLongpressTimer(keys[i1], consumer);
                        }
                    }
                }
            },
            {
                key: "_receiveKeyup",
                value: function _receiveKeyup(e) {
                    var obj = e;
                    var key = this.__keymap[e.keyCode];
                    var keys;
                    if (key) {
                        keys = Array.isArray(key) ? key : [
                            key
                        ];
                    }
                    if (keys) {
                        for(var i = 0, n = keys.length; i < n; i++){
                            if (!this.stage.application.focusTopDownEvent([
                                "_capture".concat(keys[i], "Release"),
                                "_captureKeyRelease"
                            ], obj)) {
                                this.stage.application.focusBottomUpEvent([
                                    "_handle".concat(keys[i], "Release"),
                                    "_handleKeyRelease"
                                ], obj);
                            }
                        }
                    } else {
                        if (!this.stage.application.focusTopDownEvent([
                            "_captureKeyRelease"
                        ], obj)) {
                            this.stage.application.focusBottomUpEvent([
                                "_handleKeyRelease"
                            ], obj);
                        }
                    }
                    this.updateFocusPath();
                    if (keys) {
                        for(var i1 = 0, n1 = keys.length; i1 < n1; i1++){
                            if (this.__keypressTimers.has(keys[i1])) {
                                clearTimeout(this.__keypressTimers.get(keys[i1]));
                                this.__keypressTimers.delete(keys[i1]);
                            }
                        }
                    }
                }
            },
            {
                key: "_startLongpressTimer",
                value: function _startLongpressTimer(key, element) {
                    var _this = this;
                    var config = element.longpress;
                    var lookup = key.toLowerCase();
                    if (config[lookup]) {
                        var timeout = config[lookup];
                        if (!Utils.isNumber(timeout)) {
                            element._throwError("config value for longpress must be a number");
                        } else {
                            this.__keypressTimers.set(key, setTimeout(function() {
                                if (!_this.stage.application.focusTopDownEvent([
                                    "_capture".concat(key, "Long"),
                                    "_captureKey"
                                ], {})) {
                                    _this.stage.application.focusBottomUpEvent([
                                        "_handle".concat(key, "Long"),
                                        "_handleKey"
                                    ], {});
                                }
                                _this.__keypressTimers.delete(key);
                            }, timeout || 500));
                        }
                    }
                    return;
                }
            },
            {
                key: "_recieveScrollWheel",
                value: function _recieveScrollWheel(e) {
                    var obj = e;
                    var clientX = obj.clientX, clientY = obj.clientY;
                    if (clientX <= this.stage.w && clientY <= this.stage.h) {
                        if (!this.fireTopDownScrollWheelHandler("_captureScroll", obj)) {
                            this.fireBottomUpScrollWheelHandler("_handleScroll", obj);
                        }
                    }
                }
            },
            {
                key: "fireTopDownScrollWheelHandler",
                value: function fireTopDownScrollWheelHandler(event, obj) {
                    var children = this.stage.application.children;
                    var affected = this._findChildren([], children).reverse();
                    var n = affected.length;
                    while(n--){
                        var child = affected[n];
                        if (child && child[event]) {
                            child._captureScroll(obj);
                            return true;
                        }
                    }
                    return false;
                }
            },
            {
                key: "fireBottomUpScrollWheelHandler",
                value: function fireBottomUpScrollWheelHandler(event, obj) {
                    var clientX = obj.clientX, clientY = obj.clientY;
                    var target = this._getTargetChild(clientX, clientY);
                    var child = target;
                    while(child !== null){
                        if (child && child[event]) {
                            child._handleScroll(obj);
                            return true;
                        }
                        child = child.parent;
                    }
                    return false;
                }
            },
            {
                key: "_receiveClick",
                value: function _receiveClick(e) {
                    var obj = e;
                    var clientX = obj.clientX, clientY = obj.clientY;
                    if (clientX <= this.stage.w && clientY <= this.stage.h) {
                        this.stage.application.fireBottomUpClickHandler(obj);
                    }
                }
            },
            {
                key: "fireBottomUpClickHandler",
                value: function fireBottomUpClickHandler(obj) {
                    var clientX = obj.clientX, clientY = obj.clientY;
                    var target = this._getTargetChild(clientX, clientY);
                    var child = target;
                    while(child !== null){
                        if (child && child["_handleClick"]) {
                            child._handleClick(target);
                            break;
                        }
                        child = child.parent;
                    }
                }
            },
            {
                key: "_receiveHover",
                value: function _receiveHover(e) {
                    var obj = e;
                    var clientX = obj.clientX, clientY = obj.clientY;
                    if (clientX <= this.stage.w && clientY <= this.stage.h) {
                        this.stage.application.fireBottomUpHoverHandler(obj);
                    }
                }
            },
            {
                key: "fireBottomUpHoverHandler",
                value: function fireBottomUpHoverHandler(obj) {
                    var clientX = obj.clientX, clientY = obj.clientY;
                    var target = this._getTargetChild(clientX, clientY);
                    if (target !== this.__hoveredChild) {
                        var hoveredBranch = new Set();
                        var newHoveredBranch = new Set();
                        if (target) {
                            newHoveredBranch = new Set(target.getAncestors());
                        }
                        if (this.__hoveredChild) {
                            hoveredBranch = new Set(this.__hoveredChild.getAncestors());
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _to_consumable_array._(hoveredBranch).filter(function(e) {
                                    return !newHoveredBranch.has(e);
                                })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var elem = _step.value;
                                    var c = Component.getComponent(elem);
                                    if (c["_handleUnhover"]) {
                                        c._handleUnhover(elem);
                                    }
                                    if (elem.parent && elem.parent.cursor) {
                                        this.stage.getCanvas().style.cursor = elem.parent.cursor;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        this.__hoveredChild = target;
                        var diffBranch = _to_consumable_array._(newHoveredBranch).filter(function(e) {
                            return !hoveredBranch.has(e);
                        });
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = diffBranch[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var elem1 = _step1.value;
                                var c1 = Component.getComponent(elem1);
                                if (c1["_handleHover"]) {
                                    c1._handleHover(elem1);
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var lastElement = diffBranch[0];
                        if (lastElement && lastElement.cursor) {
                            this.stage.getCanvas().style.cursor = lastElement.cursor;
                        }
                        if (diffBranch.length === 0 && target) {
                            var c2 = Component.getComponent(target);
                            if (c2["_handleHover"]) {
                                c2._handleHover(target);
                            }
                        }
                    }
                }
            },
            {
                key: "_getTargetChild",
                value: function _getTargetChild(clientX, clientY) {
                    var children = this.stage.application.children;
                    var affected = this._findChildren([], children);
                    var hoverableChildren = this._withinClickableRange(affected, clientX, clientY);
                    hoverableChildren.sort(function(a, b) {
                        if (a.zIndex > b.zIndex) {
                            return 1;
                        } else if (a.zIndex < b.zIndex) {
                            return -1;
                        } else {
                            return a.id > b.id ? 1 : -1;
                        }
                    });
                    if (hoverableChildren.length) {
                        return hoverableChildren.slice(-1)[0];
                    } else {
                        return null;
                    }
                }
            },
            {
                key: "_findChildren",
                value: function _findChildren(bucket, children) {
                    var n = children.length;
                    while(n--){
                        var child = children[n];
                        if (child.__active && child.collision) {
                            if (child.collision === true) {
                                bucket.push(child);
                            }
                            if (child.hasChildren()) {
                                this._findChildren(bucket, child.children);
                            }
                        }
                    }
                    return bucket;
                }
            },
            {
                key: "_withinClickableRange",
                value: function _withinClickableRange(affectedChildren, cursorX, cursorY) {
                    var _this = this, _loop = function() {
                        var child = affectedChildren[n];
                        var precision = _this.stage.getRenderPrecision();
                        var ctx = child.core._worldContext;
                        var cx = ctx.px * precision;
                        var cy = ctx.py * precision;
                        var cw = child.finalW * ctx.ta * precision;
                        var ch = child.finalH * ctx.td * precision;
                        if (cx > _this.stage.w || cy > _this.stage.h) {
                            return "continue";
                        }
                        if (child.parent.core._scissor) {
                            var scissor = child.parent.core._scissor.map(function(v) {
                                return v * precision;
                            });
                            if (!_this._testCollision.apply(_this, [
                                cursorX,
                                cursorY
                            ].concat(_to_consumable_array._(scissor)))) return "continue";
                        }
                        if (_this._testCollision(cursorX, cursorY, cx, cy, cw, ch)) {
                            candidates.push(child);
                        }
                    };
                    var n = affectedChildren.length;
                    var candidates = [];
                    while(n--)_loop();
                    return candidates;
                }
            },
            {
                key: "_testCollision",
                value: function _testCollision(px, py, cx, cy, cw, ch) {
                    if (px >= cx && px <= cx + cw && py >= cy && py <= cy + ch) {
                        return true;
                    }
                    return false;
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    if (!this._destroyed) {
                        this._destroy();
                        this.stage.destroy();
                        this._destroyed = true;
                    }
                }
            },
            {
                key: "_destroy",
                value: function _destroy() {
                    this.stage.setApplication(undefined);
                    this._updateAttachedFlag();
                    this._updateEnabledFlag();
                    if (this.__keypressTimers.size) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.__keypressTimers.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var timer = _step.value;
                                clearTimeout(timer);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.__keypressTimers.clear();
                    }
                }
            },
            {
                key: "getCanvas",
                value: function getCanvas() {
                    return this.stage.getCanvas();
                }
            }
        ]);
        return Application;
    }(Component);
    var StaticCanvasTexture = /*#__PURE__*/ function(Texture) {
        _inherits._(StaticCanvasTexture, Texture);
        var _super = _create_super._(StaticCanvasTexture);
        function StaticCanvasTexture(stage) {
            _class_call_check._(this, StaticCanvasTexture);
            var _this;
            _this = _super.call(this, stage);
            _this._factory = undefined;
            _this._lookupId = undefined;
            return _this;
        }
        _create_class._(StaticCanvasTexture, [
            {
                key: "content",
                set: function set(param) {
                    var factory = param.factory, _param_lookupId = param.lookupId, lookupId = _param_lookupId === void 0 ? undefined : _param_lookupId;
                    this._factory = factory;
                    this._lookupId = lookupId;
                    this._changed();
                }
            },
            {
                key: "_getIsValid",
                value: function _getIsValid() {
                    return !!this._factory;
                }
            },
            {
                key: "_getLookupId",
                value: function _getLookupId() {
                    return this._lookupId;
                }
            },
            {
                key: "_getSourceLoader",
                value: function _getSourceLoader() {
                    var _this = this;
                    var f = this._factory;
                    return function(cb) {
                        return f(function(err, canvas) {
                            if (err) {
                                return cb(err);
                            }
                            cb(null, _this.stage.platform.getTextureOptionsForDrawingCanvas(canvas));
                        }, _this.stage);
                    };
                }
            }
        ]);
        return StaticCanvasTexture;
    }(Texture);
    var Tools = /*#__PURE__*/ function() {
        function Tools() {
            _class_call_check._(this, Tools);
        }
        _create_class._(Tools, null, [
            {
                key: "getCanvasTexture",
                value: function getCanvasTexture(canvasFactory, lookupId) {
                    return {
                        type: StaticCanvasTexture,
                        content: {
                            factory: canvasFactory,
                            lookupId: lookupId
                        }
                    };
                }
            },
            {
                key: "getRoundRect",
                value: function getRoundRect(w, h, radius, strokeWidth, strokeColor, fill, fillColor) {
                    var _this = this;
                    if (!Array.isArray(radius)) {
                        radius = [
                            radius,
                            radius,
                            radius,
                            radius
                        ];
                    }
                    var factory = function(cb, stage) {
                        if (Utils.isSpark) {
                            stage.platform.createRoundRect(cb, stage, w, h, radius, strokeWidth, strokeColor, fill, fillColor);
                        } else {
                            cb(null, _this.createRoundRect(stage, w, h, radius, strokeWidth, strokeColor, fill, fillColor));
                        }
                    };
                    var id = "rect" + [
                        w,
                        h,
                        strokeWidth,
                        strokeColor,
                        fill ? 1 : 0,
                        fillColor
                    ].concat(radius).join(",");
                    return Tools.getCanvasTexture(factory, id);
                }
            },
            {
                key: "createRoundRect",
                value: function createRoundRect(stage, w, h, radius, strokeWidth, strokeColor, fill, fillColor) {
                    if (fill === undefined) fill = true;
                    if (strokeWidth === undefined) strokeWidth = 0;
                    var canvas = stage.platform.getDrawingCanvas();
                    var ctx = canvas.getContext("2d");
                    ctx.imageSmoothingEnabled = true;
                    canvas.width = w + strokeWidth + 2;
                    canvas.height = h + strokeWidth + 2;
                    ctx.beginPath();
                    var x = 0.5 * strokeWidth + 1, y = 0.5 * strokeWidth + 1;
                    ctx.moveTo(x + radius[0], y);
                    ctx.lineTo(x + w - radius[1], y);
                    ctx.arcTo(x + w, y, x + w, y + radius[1], radius[1]);
                    ctx.lineTo(x + w, y + h - radius[2]);
                    ctx.arcTo(x + w, y + h, x + w - radius[2], y + h, radius[2]);
                    ctx.lineTo(x + radius[3], y + h);
                    ctx.arcTo(x, y + h, x, y + h - radius[3], radius[3]);
                    ctx.lineTo(x, y + radius[0]);
                    ctx.arcTo(x, y, x + radius[0], y, radius[0]);
                    ctx.closePath();
                    if (fill) {
                        if (Utils.isNumber(fillColor)) {
                            ctx.fillStyle = StageUtils.getRgbaString(fillColor);
                        } else {
                            ctx.fillStyle = "white";
                        }
                        ctx.fill();
                    }
                    if (strokeWidth) {
                        if (Utils.isNumber(strokeColor)) {
                            ctx.strokeStyle = StageUtils.getRgbaString(strokeColor);
                        } else {
                            ctx.strokeStyle = "white";
                        }
                        ctx.lineWidth = strokeWidth;
                        ctx.stroke();
                    }
                    return canvas;
                }
            },
            {
                key: "getShadowRect",
                value: function getShadowRect(w, h) {
                    var radius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, blur = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 5, margin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : blur * 2;
                    var _this = this;
                    if (!Array.isArray(radius)) {
                        radius = [
                            radius,
                            radius,
                            radius,
                            radius
                        ];
                    }
                    var factory = function(cb, stage) {
                        if (Utils.isSpark) {
                            stage.platform.createShadowRect(cb, stage, w, h, radius, blur, margin);
                        } else {
                            cb(null, _this.createShadowRect(stage, w, h, radius, blur, margin));
                        }
                    };
                    var id = "shadow" + [
                        w,
                        h,
                        blur,
                        margin
                    ].concat(radius).join(",");
                    return Tools.getCanvasTexture(factory, id);
                }
            },
            {
                key: "createShadowRect",
                value: function createShadowRect(stage, w, h, radius, blur, margin) {
                    var canvas = stage.platform.getDrawingCanvas();
                    var ctx = canvas.getContext("2d");
                    ctx.imageSmoothingEnabled = true;
                    canvas.width = w + margin * 2;
                    canvas.height = h + margin * 2;
                    ctx.globalAlpha = 0.01;
                    ctx.fillRect(0, 0, 0.01, 0.01);
                    ctx.globalAlpha = 1.0;
                    ctx.shadowColor = StageUtils.getRgbaString(0xFFFFFFFF);
                    ctx.fillStyle = StageUtils.getRgbaString(0xFFFFFFFF);
                    ctx.shadowBlur = blur;
                    ctx.shadowOffsetX = w + 10 + margin;
                    ctx.shadowOffsetY = margin;
                    ctx.beginPath();
                    var x = -(w + 10);
                    var y = 0;
                    ctx.moveTo(x + radius[0], y);
                    ctx.lineTo(x + w - radius[1], y);
                    ctx.arcTo(x + w, y, x + w, y + radius[1], radius[1]);
                    ctx.lineTo(x + w, y + h - radius[2]);
                    ctx.arcTo(x + w, y + h, x + w - radius[2], y + h, radius[2]);
                    ctx.lineTo(x + radius[3], y + h);
                    ctx.arcTo(x, y + h, x, y + h - radius[3], radius[3]);
                    ctx.lineTo(x, y + radius[0]);
                    ctx.arcTo(x, y, x + radius[0], y, radius[0]);
                    ctx.closePath();
                    ctx.fill();
                    return canvas;
                }
            },
            {
                key: "getSvgTexture",
                value: function getSvgTexture(url, w, h) {
                    var _this = this;
                    var factory = function(cb, stage) {
                        if (Utils.isSpark) {
                            stage.platform.createSvg(cb, stage, url, w, h);
                        } else {
                            _this.createSvg(cb, stage, url, w, h);
                        }
                    };
                    var id = "svg" + [
                        w,
                        h,
                        url
                    ].join(",");
                    return Tools.getCanvasTexture(factory, id);
                }
            },
            {
                key: "createSvg",
                value: function createSvg(cb, stage, url, w, h) {
                    var canvas = stage.platform.getDrawingCanvas();
                    var ctx = canvas.getContext("2d");
                    ctx.imageSmoothingEnabled = true;
                    var img = new Image();
                    img.onload = function() {
                        canvas.width = w;
                        canvas.height = h;
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        cb(null, canvas);
                    };
                    img.onError = function(err) {
                        cb(err);
                    };
                    if (!Utils.isPS4) {
                        img.crossOrigin = "Anonymous";
                    }
                    img.src = url;
                }
            }
        ]);
        return Tools;
    }();
    var ObjMerger = /*#__PURE__*/ function() {
        function ObjMerger() {
            _class_call_check._(this, ObjMerger);
        }
        _create_class._(ObjMerger, null, [
            {
                key: "isMf",
                value: function isMf(f) {
                    return Utils.isFunction(f) && f.__mf;
                }
            },
            {
                key: "mf",
                value: function mf(f) {
                    f.__mf = true;
                    return f;
                }
            },
            {
                key: "merge",
                value: function merge(a, b) {
                    var aks = Object.keys(a);
                    var bks = Object.keys(b);
                    if (!bks.length) {
                        return a;
                    }
                    var ai = {};
                    var bi = {};
                    for(var i = 0, n = bks.length; i < n; i++){
                        var key = bks[i];
                        ai[key] = -1;
                        bi[key] = i;
                    }
                    for(var i1 = 0, n1 = aks.length; i1 < n1; i1++){
                        var key1 = aks[i1];
                        ai[key1] = i1;
                        if (bi[key1] === undefined) {
                            bi[key1] = -1;
                        }
                    }
                    var aksl = aks.length;
                    var result = {};
                    for(var i2 = 0, n2 = bks.length; i2 < n2; i2++){
                        var key2 = bks[i2];
                        var aIndex = ai[key2];
                        var curIndex = aIndex;
                        while(--curIndex >= 0){
                            var akey = aks[curIndex];
                            if (bi[akey] !== -1) {
                                break;
                            }
                        }
                        while(++curIndex < aIndex){
                            var akey1 = aks[curIndex];
                            result[akey1] = a[akey1];
                        }
                        var bv = b[key2];
                        var av = a[key2];
                        var r = void 0;
                        if (this.isMf(bv)) {
                            r = bv(av);
                        } else {
                            if (!Utils.isObjectLiteral(av) || !Utils.isObjectLiteral(bv)) {
                                r = bv;
                            } else {
                                r = ObjMerger.merge(av, bv);
                            }
                        }
                        if (r !== undefined) {
                            result[key2] = r;
                        }
                    }
                    var curIndex1 = aksl;
                    while(--curIndex1 >= 0){
                        var akey2 = aks[curIndex1];
                        if (bi[akey2] !== -1) {
                            break;
                        }
                    }
                    while(++curIndex1 < aksl){
                        var akey3 = aks[curIndex1];
                        result[akey3] = a[akey3];
                    }
                    return result;
                }
            }
        ]);
        return ObjMerger;
    }();
    var ObjectListProxy = /*#__PURE__*/ function(ObjectList) {
        _inherits._(ObjectListProxy, ObjectList);
        var _super = _create_super._(ObjectListProxy);
        function ObjectListProxy(target) {
            _class_call_check._(this, ObjectListProxy);
            var _this;
            _this = _super.call(this);
            _this._target = target;
            return _this;
        }
        _create_class._(ObjectListProxy, [
            {
                key: "onAdd",
                value: function onAdd(item, index) {
                    this._target.addAt(item, index);
                }
            },
            {
                key: "onRemove",
                value: function onRemove(item, index) {
                    this._target.removeAt(index);
                }
            },
            {
                key: "onSync",
                value: function onSync(removed, added, order) {
                    this._target._setByArray(order);
                }
            },
            {
                key: "onSet",
                value: function onSet(item, index) {
                    this._target.setAt(item, index);
                }
            },
            {
                key: "onMove",
                value: function onMove(item, fromIndex, toIndex) {
                    this._target.setAt(item, toIndex);
                }
            },
            {
                key: "createItem",
                value: function createItem(object) {
                    return this._target.createItem(object);
                }
            },
            {
                key: "isItem",
                value: function isItem(object) {
                    return this._target.isItem(object);
                }
            }
        ]);
        return ObjectListProxy;
    }(ObjectList);
    var ObjectListWrapper = /*#__PURE__*/ function(ObjectListProxy) {
        _inherits._(ObjectListWrapper, ObjectListProxy);
        var _super = _create_super._(ObjectListWrapper);
        function ObjectListWrapper(target, wrap) {
            _class_call_check._(this, ObjectListWrapper);
            var _this;
            _this = _super.call(this, target);
            _this._wrap = wrap;
            return _this;
        }
        _create_class._(ObjectListWrapper, [
            {
                key: "wrap",
                value: function wrap(item) {
                    var wrapper = this._wrap(item);
                    item._wrapper = wrapper;
                    return wrapper;
                }
            },
            {
                key: "onAdd",
                value: function onAdd(item, index) {
                    item = this.wrap(item);
                    _get._(_get_prototype_of._(ObjectListWrapper.prototype), "onAdd", this).call(this, item, index);
                }
            },
            {
                key: "onRemove",
                value: function onRemove(item, index) {
                    _get._(_get_prototype_of._(ObjectListWrapper.prototype), "onRemove", this).call(this, item, index);
                }
            },
            {
                key: "onSync",
                value: function onSync(removed, added, order) {
                    var _this = this;
                    added.forEach(function(a) {
                        return _this.wrap(a);
                    });
                    order = order.map(function(a) {
                        return a._wrapper;
                    });
                    _get._(_get_prototype_of._(ObjectListWrapper.prototype), "onSync", this).call(this, removed, added, order);
                }
            },
            {
                key: "onSet",
                value: function onSet(item, index) {
                    item = this.wrap(item);
                    _get._(_get_prototype_of._(ObjectListWrapper.prototype), "onSet", this).call(this, item, index);
                }
            },
            {
                key: "onMove",
                value: function onMove(item, fromIndex, toIndex) {
                    _get._(_get_prototype_of._(ObjectListWrapper.prototype), "onMove", this).call(this, item, fromIndex, toIndex);
                }
            }
        ]);
        return ObjectListWrapper;
    }(ObjectListProxy);
    var NoiseTexture = /*#__PURE__*/ function(Texture) {
        _inherits._(NoiseTexture, Texture);
        var _super = _create_super._(NoiseTexture);
        function NoiseTexture() {
            _class_call_check._(this, NoiseTexture);
            return _super.apply(this, arguments);
        }
        _create_class._(NoiseTexture, [
            {
                key: "_getLookupId",
                value: function _getLookupId() {
                    return "__noise";
                }
            },
            {
                key: "_getSourceLoader",
                value: function _getSourceLoader() {
                    var gl = this.stage.gl;
                    return function(cb) {
                        var noise = new Uint8Array(128 * 128 * 4);
                        for(var i = 0; i < 128 * 128 * 4; i += 4){
                            var v = Math.floor(Math.random() * 256);
                            noise[i] = v;
                            noise[i + 1] = v;
                            noise[i + 2] = v;
                            noise[i + 3] = 255;
                        }
                        var texParams = {};
                        if (gl) {
                            texParams[gl.TEXTURE_WRAP_S] = gl.REPEAT;
                            texParams[gl.TEXTURE_WRAP_T] = gl.REPEAT;
                            texParams[gl.TEXTURE_MIN_FILTER] = gl.NEAREST;
                            texParams[gl.TEXTURE_MAG_FILTER] = gl.NEAREST;
                        }
                        cb(null, {
                            source: noise,
                            w: 128,
                            h: 128,
                            texParams: texParams
                        });
                    };
                }
            }
        ]);
        return NoiseTexture;
    }(Texture);
    var HtmlTexture = /*#__PURE__*/ function(Texture) {
        _inherits._(HtmlTexture, Texture);
        var _super = _create_super._(HtmlTexture);
        function HtmlTexture(stage) {
            _class_call_check._(this, HtmlTexture);
            var _this;
            _this = _super.call(this, stage);
            _this._htmlElement = undefined;
            _this._scale = 1;
            return _this;
        }
        _create_class._(HtmlTexture, [
            {
                key: "htmlElement",
                get: function get() {
                    return this._htmlElement;
                },
                set: function set(v) {
                    this._htmlElement = v;
                    this._changed();
                }
            },
            {
                key: "scale",
                get: function get() {
                    return this._scale;
                },
                set: function set(v) {
                    this._scale = v;
                    this._changed();
                }
            },
            {
                key: "html",
                get: function get() {
                    return this._htmlElement.innerHTML;
                },
                set: function set(v) {
                    if (!v) {
                        this.htmlElement = undefined;
                    } else {
                        var d = document.createElement("div");
                        d.innerHTML = "<div>" + v + "</div>";
                        this.htmlElement = d.firstElementChild;
                    }
                }
            },
            {
                key: "_getIsValid",
                value: function _getIsValid() {
                    return this.htmlElement;
                }
            },
            {
                key: "_getLookupId",
                value: function _getLookupId() {
                    return this._scale + ":" + this._htmlElement.innerHTML;
                }
            },
            {
                key: "_getSourceLoader",
                value: function _getSourceLoader() {
                    var htmlElement = this._htmlElement;
                    var scale = this._scale;
                    return function(cb) {
                        if (!window.html2canvas) {
                            return cb(new Error("Please include html2canvas (https://html2canvas.hertzen.com/)"));
                        }
                        var area = HtmlTexture.getPreloadArea();
                        area.appendChild(htmlElement);
                        html2canvas(htmlElement, {
                            backgroundColor: null,
                            scale: scale
                        }).then(function(canvas) {
                            area.removeChild(htmlElement);
                            if (canvas.height === 0) {
                                return cb(new Error("Canvas height is 0"));
                            }
                            cb(null, {
                                source: canvas,
                                width: canvas.width,
                                height: canvas.height
                            });
                        }).catch(function(e) {
                            console.error("[Lightning]", e);
                        });
                    };
                }
            }
        ], [
            {
                key: "getPreloadArea",
                value: function getPreloadArea() {
                    if (!this._preloadArea) {
                        this._preloadArea = document.createElement("div");
                        if (this._preloadArea.attachShadow) {
                            this._preloadArea.attachShadow({
                                mode: "closed"
                            });
                        }
                        this._preloadArea.style.opacity = 0;
                        this._preloadArea.style.pointerEvents = "none";
                        this._preloadArea.style.position = "fixed";
                        this._preloadArea.style.display = "block";
                        this._preloadArea.style.top = "100vh";
                        this._preloadArea.style.overflow = "hidden";
                        document.body.appendChild(this._preloadArea);
                    }
                    return this._preloadArea;
                }
            }
        ]);
        return HtmlTexture;
    }(Texture);
    var StaticTexture = /*#__PURE__*/ function(Texture) {
        _inherits._(StaticTexture, Texture);
        var _super = _create_super._(StaticTexture);
        function StaticTexture(stage, options) {
            _class_call_check._(this, StaticTexture);
            var _this;
            _this = _super.call(this, stage);
            _this._options = options;
            return _this;
        }
        _create_class._(StaticTexture, [
            {
                key: "options",
                get: function get() {
                    return this._options;
                },
                set: function set(v) {
                    if (this._options !== v) {
                        this._options = v;
                        this._changed();
                    }
                }
            },
            {
                key: "_getIsValid",
                value: function _getIsValid() {
                    return !!this._options;
                }
            },
            {
                key: "_getSourceLoader",
                value: function _getSourceLoader() {
                    var _this = this;
                    return function(cb) {
                        cb(null, _this._options);
                    };
                }
            }
        ]);
        return StaticTexture;
    }(Texture);
    var ListComponent = /*#__PURE__*/ function(Component) {
        _inherits._(ListComponent, Component);
        var _super = _create_super._(ListComponent);
        function ListComponent(stage) {
            _class_call_check._(this, ListComponent);
            var _this;
            _this = _super.call(this, stage);
            _this._wrapper = _get._((_assert_this_initialized._(_this), _get_prototype_of._(ListComponent.prototype)), "_children", _this).a({});
            _this._reloadVisibleElements = false;
            _this._visibleItems = new Set();
            _this._index = 0;
            _this._started = false;
            _this._scrollTransitionSettings = _this.stage.transitions.createSettings({});
            _this._itemSize = 100;
            _this._viewportScrollOffset = 0;
            _this._itemScrollOffset = 0;
            _this._roll = false;
            _this._rollMin = 0;
            _this._rollMax = 0;
            _this._progressAnimation = null;
            _this._invertDirection = false;
            _this._horizontal = true;
            _this.itemList = new ListItems(_assert_this_initialized._(_this));
            return _this;
        }
        _create_class._(ListComponent, [
            {
                key: "_allowChildrenAccess",
                value: function _allowChildrenAccess() {
                    return false;
                }
            },
            {
                key: "items",
                get: function get() {
                    return this.itemList.get();
                },
                set: function set(children) {
                    this.itemList.patch(children);
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this = this;
                    this._wrapper.transition(this.property, this._scrollTransitionSettings);
                    this._scrollTransition = this._wrapper.transition(this.property);
                    this._scrollTransition.on("progress", function(p) {
                        return _this.update();
                    });
                    this.setIndex(0, true, true);
                    this._started = true;
                    this.update();
                }
            },
            {
                key: "setIndex",
                value: function setIndex(index) {
                    var immediate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, closest = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                    var nElements = this.length;
                    if (!nElements) return;
                    this.emit("unfocus", this.getElement(this.realIndex), this._index, this.realIndex);
                    if (closest) {
                        var offset = Utils.getModuloIndex(index, nElements);
                        var o = Utils.getModuloIndex(this.index, nElements);
                        var diff = offset - o;
                        if (diff > 0.5 * nElements) {
                            diff -= nElements;
                        } else if (diff < -0.5 * nElements) {
                            diff += nElements;
                        }
                        this._index += diff;
                    } else {
                        this._index = index;
                    }
                    if (this._roll || this.viewportSize > this._itemSize * nElements) {
                        this._index = Utils.getModuloIndex(this._index, nElements);
                    }
                    var direction = this._horizontal ^ this._invertDirection ? -1 : 1;
                    var value = direction * this._index * this._itemSize;
                    if (this._roll) {
                        var min, max, scrollDelta;
                        if (direction == 1) {
                            max = (nElements - 1) * this._itemSize;
                            scrollDelta = this._viewportScrollOffset * this.viewportSize - this._itemScrollOffset * this._itemSize;
                            max -= scrollDelta;
                            min = this.viewportSize - (this._itemSize + scrollDelta);
                            if (this._rollMin) min -= this._rollMin;
                            if (this._rollMax) max += this._rollMax;
                            value = Math.max(Math.min(value, max), min);
                        } else {
                            max = nElements * this._itemSize - this.viewportSize;
                            scrollDelta = this._viewportScrollOffset * this.viewportSize - this._itemScrollOffset * this._itemSize;
                            max += scrollDelta;
                            var min1 = scrollDelta;
                            if (this._rollMin) min1 -= this._rollMin;
                            if (this._rollMax) max += this._rollMax;
                            value = Math.min(Math.max(-max, value), -min1);
                        }
                    }
                    this._scrollTransition.start(value);
                    if (immediate) {
                        this._scrollTransition.finish();
                    }
                    this.emit("focus", this.getElement(this.realIndex), this._index, this.realIndex);
                }
            },
            {
                key: "getAxisPosition",
                value: function getAxisPosition() {
                    var target = -this._scrollTransition._targetValue;
                    var direction = this._horizontal ^ this._invertDirection ? -1 : 1;
                    var value = -direction * this._index * this._itemSize;
                    return this._viewportScrollOffset * this.viewportSize + (value - target);
                }
            },
            {
                key: "update",
                value: function update() {
                    if (!this._started) return;
                    var nElements = this.length;
                    if (!nElements) return;
                    var direction = this._horizontal ^ this._invertDirection ? -1 : 1;
                    var v = this._horizontal ? this._wrapper.x : this._wrapper.y;
                    var viewportSize = this.viewportSize;
                    var scrollDelta = this._viewportScrollOffset * viewportSize - this._itemScrollOffset * this._itemSize;
                    v += scrollDelta;
                    var s, e, ps, pe;
                    if (direction == -1) {
                        s = Math.floor(-v / this._itemSize);
                        ps = 1 - (-v / this._itemSize - s);
                        e = Math.floor((viewportSize - v) / this._itemSize);
                        pe = (viewportSize - v) / this._itemSize - e;
                    } else {
                        s = Math.ceil(v / this._itemSize);
                        ps = 1 + v / this._itemSize - s;
                        e = Math.ceil((v - viewportSize) / this._itemSize);
                        pe = e - (v - viewportSize) / this._itemSize;
                    }
                    if (this._roll || viewportSize > this._itemSize * nElements) {
                        if (e >= nElements) {
                            e = nElements - 1;
                            pe = 1;
                        }
                        if (s >= nElements) {
                            s = nElements - 1;
                            ps = 1;
                        }
                        if (e <= -1) {
                            e = 0;
                            pe = 1;
                        }
                        if (s <= -1) {
                            s = 0;
                            ps = 1;
                        }
                    }
                    var offset = -direction * s * this._itemSize;
                    var item;
                    for(var index = s; direction == -1 ? index <= e : index >= e; direction == -1 ? index++ : index--){
                        var realIndex = Utils.getModuloIndex(index, nElements);
                        var element = this.getElement(realIndex);
                        item = element.parent;
                        this._visibleItems.delete(item);
                        if (this._horizontal) {
                            item.x = offset + scrollDelta;
                        } else {
                            item.y = offset + scrollDelta;
                        }
                        var wasVisible = item.visible;
                        item.visible = true;
                        if (!wasVisible || this._reloadVisibleElements) {
                            this.emit("visible", index, realIndex);
                        }
                        if (this._progressAnimation) {
                            var p = 1;
                            if (index == s) {
                                p = ps;
                            } else if (index == e) {
                                p = pe;
                            }
                            this._progressAnimation.apply(element, p);
                        }
                        offset += this._itemSize;
                    }
                    var self1 = this;
                    this._visibleItems.forEach(function(invisibleItem) {
                        invisibleItem.visible = false;
                        self1._visibleItems.delete(invisibleItem);
                    });
                    for(var index1 = s; direction == -1 ? index1 <= e : index1 >= e; direction == -1 ? index1++ : index1--){
                        var realIndex1 = Utils.getModuloIndex(index1, nElements);
                        this._visibleItems.add(this.getWrapper(realIndex1));
                    }
                    this._reloadVisibleElements = false;
                }
            },
            {
                key: "setPrevious",
                value: function setPrevious() {
                    this.setIndex(this._index - 1);
                }
            },
            {
                key: "setNext",
                value: function setNext() {
                    this.setIndex(this._index + 1);
                }
            },
            {
                key: "getWrapper",
                value: function getWrapper(index) {
                    return this._wrapper.children[index];
                }
            },
            {
                key: "getElement",
                value: function getElement(index) {
                    var e = this._wrapper.children[index];
                    return e ? e.children[0] : null;
                }
            },
            {
                key: "reload",
                value: function reload() {
                    this._reloadVisibleElements = true;
                    this.update();
                }
            },
            {
                key: "element",
                get: function get() {
                    var e = this._wrapper.children[this.realIndex];
                    return e ? e.children[0] : null;
                }
            },
            {
                key: "length",
                get: function get() {
                    return this._wrapper.children.length;
                }
            },
            {
                key: "property",
                get: function get() {
                    return this._horizontal ? "x" : "y";
                }
            },
            {
                key: "viewportSize",
                get: function get() {
                    return this._horizontal ? this.w : this.h;
                }
            },
            {
                key: "index",
                get: function get() {
                    return this._index;
                }
            },
            {
                key: "realIndex",
                get: function get() {
                    return Utils.getModuloIndex(this._index, this.length);
                }
            },
            {
                key: "itemSize",
                get: function get() {
                    return this._itemSize;
                },
                set: function set(v) {
                    this._itemSize = v;
                    this.update();
                }
            },
            {
                key: "viewportScrollOffset",
                get: function get() {
                    return this._viewportScrollOffset;
                },
                set: function set(v) {
                    this._viewportScrollOffset = v;
                    this.update();
                }
            },
            {
                key: "itemScrollOffset",
                get: function get() {
                    return this._itemScrollOffset;
                },
                set: function set(v) {
                    this._itemScrollOffset = v;
                    this.update();
                }
            },
            {
                key: "scrollTransitionSettings",
                get: function get() {
                    return this._scrollTransitionSettings;
                },
                set: function set(v) {
                    this._scrollTransitionSettings.patch(v);
                }
            },
            {
                key: "scrollTransition",
                get: function get() {
                    return this._scrollTransition;
                },
                set: function set(v) {
                    this._scrollTransitionSettings.patch(v);
                }
            },
            {
                key: "progressAnimation",
                get: function get() {
                    return this._progressAnimation;
                },
                set: function set(v) {
                    if (Utils.isObjectLiteral(v)) {
                        this._progressAnimation = this.stage.animations.createSettings(v);
                    } else {
                        this._progressAnimation = v;
                    }
                    this.update();
                }
            },
            {
                key: "roll",
                get: function get() {
                    return this._roll;
                },
                set: function set(v) {
                    this._roll = v;
                    this.update();
                }
            },
            {
                key: "rollMin",
                get: function get() {
                    return this._rollMin;
                },
                set: function set(v) {
                    this._rollMin = v;
                    this.update();
                }
            },
            {
                key: "rollMax",
                get: function get() {
                    return this._rollMax;
                },
                set: function set(v) {
                    this._rollMax = v;
                    this.update();
                }
            },
            {
                key: "invertDirection",
                get: function get() {
                    return this._invertDirection;
                },
                set: function set(v) {
                    if (!this._started) {
                        this._invertDirection = v;
                    }
                }
            },
            {
                key: "horizontal",
                get: function get() {
                    return this._horizontal;
                },
                set: function set(v) {
                    if (v !== this._horizontal) {
                        if (!this._started) {
                            this._horizontal = v;
                        }
                    }
                }
            }
        ]);
        return ListComponent;
    }(Component);
    var ListItems = /*#__PURE__*/ function(ObjectListWrapper) {
        _inherits._(ListItems, ObjectListWrapper);
        var _super = _create_super._(ListItems);
        function ListItems(list) {
            _class_call_check._(this, ListItems);
            var _this;
            var wrap = function(item) {
                var parent = item.stage.createElement();
                parent.add(item);
                parent.visible = false;
                return parent;
            };
            _this = _super.call(this, list._wrapper._children, wrap);
            _this.list = list;
            return _this;
        }
        _create_class._(ListItems, [
            {
                key: "onAdd",
                value: function onAdd(item, index) {
                    _get._(_get_prototype_of._(ListItems.prototype), "onAdd", this).call(this, item, index);
                    this.checkStarted(index);
                }
            },
            {
                key: "checkStarted",
                value: function checkStarted(index) {
                    this.list._reloadVisibleElements = true;
                    if (!this.list._started) {
                        this.list.start();
                    } else {
                        if (this.list.length === 1) {
                            this.list.setIndex(0, true, true);
                        } else {
                            if (this.list._index >= this.list.length) {
                                this.list.setIndex(0);
                            }
                        }
                        this.list.update();
                    }
                }
            },
            {
                key: "onRemove",
                value: function onRemove(item, index) {
                    _get._(_get_prototype_of._(ListItems.prototype), "onRemove", this).call(this, item, index);
                    var ri = this.list.realIndex;
                    if (ri === index) {
                        if (ri === this.list.length) {
                            ri--;
                        }
                        if (ri >= 0) {
                            this.list.setIndex(ri);
                        }
                    } else if (ri > index) {
                        this.list.setIndex(ri - 1);
                    }
                    this.list._reloadVisibleElements = true;
                }
            },
            {
                key: "onSet",
                value: function onSet(item, index) {
                    _get._(_get_prototype_of._(ListItems.prototype), "onSet", this).call(this, item, index);
                    this.checkStarted(index);
                }
            },
            {
                key: "onSync",
                value: function onSync(removed, added, order) {
                    _get._(_get_prototype_of._(ListItems.prototype), "onSync", this).call(this, removed, added, order);
                    this.checkStarted(0);
                }
            },
            {
                key: "_signalProxy",
                get: function get() {
                    return true;
                }
            }
        ]);
        return ListItems;
    }(ObjectListWrapper);
    var LinearBlurShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(LinearBlurShader, DefaultShader);
        var _super = _create_super._(LinearBlurShader);
        function LinearBlurShader(context) {
            _class_call_check._(this, LinearBlurShader);
            var _this;
            _this = _super.call(this, context);
            _this._direction = new Float32Array([
                1,
                0
            ]);
            _this._kernelRadius = 1;
            return _this;
        }
        _create_class._(LinearBlurShader, [
            {
                key: "x",
                get: function get() {
                    return this._direction[0];
                },
                set: function set(v) {
                    this._direction[0] = v;
                    this.redraw();
                }
            },
            {
                key: "y",
                get: function get() {
                    return this._direction[1];
                },
                set: function set(v) {
                    this._direction[1] = v;
                    this.redraw();
                }
            },
            {
                key: "kernelRadius",
                get: function get() {
                    return this._kernelRadius;
                },
                set: function set(v) {
                    this._kernelRadius = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._kernelRadius === 0;
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(LinearBlurShader.prototype), "setupUniforms", this).call(this, operation);
                    this._setUniform("direction", this._direction, this.gl.uniform2fv);
                    this._setUniform("kernelRadius", this._kernelRadius, this.gl.uniform1i);
                    var w = operation.getRenderWidth();
                    var h = operation.getRenderHeight();
                    this._setUniform("resolution", new Float32Array([
                        w,
                        h
                    ]), this.gl.uniform2fv);
                }
            }
        ]);
        return LinearBlurShader;
    }(DefaultShader);
    LinearBlurShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    uniform vec2 resolution;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform vec2 direction;\n    uniform int kernelRadius;\n    \n    vec4 blur1(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n        vec4 color = vec4(0.0);\n        vec2 off1 = vec2(1.3333333333333333) * direction;\n        color += texture2D(image, uv) * 0.29411764705882354;\n        color += texture2D(image, uv + (off1 / resolution)) * 0.35294117647058826;\n        color += texture2D(image, uv - (off1 / resolution)) * 0.35294117647058826;\n        return color; \n    }\n    \n    vec4 blur2(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n        vec4 color = vec4(0.0);\n        vec2 off1 = vec2(1.3846153846) * direction;\n        vec2 off2 = vec2(3.2307692308) * direction;\n        color += texture2D(image, uv) * 0.2270270270;\n        color += texture2D(image, uv + (off1 / resolution)) * 0.3162162162;\n        color += texture2D(image, uv - (off1 / resolution)) * 0.3162162162;\n        color += texture2D(image, uv + (off2 / resolution)) * 0.0702702703;\n        color += texture2D(image, uv - (off2 / resolution)) * 0.0702702703;\n        return color;\n    }\n    \n    vec4 blur3(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {\n        vec4 color = vec4(0.0);\n        vec2 off1 = vec2(1.411764705882353) * direction;\n        vec2 off2 = vec2(3.2941176470588234) * direction;\n        vec2 off3 = vec2(5.176470588235294) * direction;\n        color += texture2D(image, uv) * 0.1964825501511404;\n        color += texture2D(image, uv + (off1 / resolution)) * 0.2969069646728344;\n        color += texture2D(image, uv - (off1 / resolution)) * 0.2969069646728344;\n        color += texture2D(image, uv + (off2 / resolution)) * 0.09447039785044732;\n        color += texture2D(image, uv - (off2 / resolution)) * 0.09447039785044732;\n        color += texture2D(image, uv + (off3 / resolution)) * 0.010381362401148057;\n        color += texture2D(image, uv - (off3 / resolution)) * 0.010381362401148057;\n        return color;\n    }    \n\n    void main(void){\n        if (kernelRadius == 1) {\n            gl_FragColor = blur1(uSampler, vTextureCoord, resolution, direction) * vColor;\n        } else if (kernelRadius == 2) {\n            gl_FragColor = blur2(uSampler, vTextureCoord, resolution, direction) * vColor;\n        } else {\n            gl_FragColor = blur3(uSampler, vTextureCoord, resolution, direction) * vColor;\n        }\n    }\n";
    var BoxBlurShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(BoxBlurShader, DefaultShader);
        var _super = _create_super._(BoxBlurShader);
        function BoxBlurShader() {
            _class_call_check._(this, BoxBlurShader);
            return _super.apply(this, arguments);
        }
        _create_class._(BoxBlurShader, [
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(BoxBlurShader.prototype), "setupUniforms", this).call(this, operation);
                    var dx = 1.0 / operation.getTextureWidth(0);
                    var dy = 1.0 / operation.getTextureHeight(0);
                    this._setUniform("stepTextureCoord", new Float32Array([
                        dx,
                        dy
                    ]), this.gl.uniform2fv);
                }
            }
        ]);
        return BoxBlurShader;
    }(DefaultShader);
    BoxBlurShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    uniform vec2 stepTextureCoord;\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec4 vColor;\n    varying vec2 vTextureCoordUl;\n    varying vec2 vTextureCoordUr;\n    varying vec2 vTextureCoordBl;\n    varying vec2 vTextureCoordBr;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoordUl = aTextureCoord - stepTextureCoord;\n        vTextureCoordBr = aTextureCoord + stepTextureCoord;\n        vTextureCoordUr = vec2(vTextureCoordBr.x, vTextureCoordUl.y);\n        vTextureCoordBl = vec2(vTextureCoordUl.x, vTextureCoordBr.y);\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    BoxBlurShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoordUl;\n    varying vec2 vTextureCoordUr;\n    varying vec2 vTextureCoordBl;\n    varying vec2 vTextureCoordBr;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    void main(void){\n        vec4 color = 0.25 * (texture2D(uSampler, vTextureCoordUl) + texture2D(uSampler, vTextureCoordUr) + texture2D(uSampler, vTextureCoordBl) + texture2D(uSampler, vTextureCoordBr));\n        gl_FragColor = color * vColor;\n    }\n";
    var BlurShader = /*#__PURE__*/ function(DefaultShader$1) {
        _inherits._(BlurShader, DefaultShader$1);
        var _super = _create_super._(BlurShader);
        function BlurShader(context) {
            _class_call_check._(this, BlurShader);
            var _this;
            _this = _super.call(this, context);
            _this._kernelRadius = 1;
            return _this;
        }
        _create_class._(BlurShader, [
            {
                key: "kernelRadius",
                get: function get() {
                    return this._kernelRadius;
                },
                set: function set(v) {
                    this._kernelRadius = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._amount === 0;
                }
            },
            {
                key: "_beforeDrawEl",
                value: function _beforeDrawEl(param) {
                    var target = param.target;
                    target.ctx.filter = "blur(" + this._kernelRadius + "px)";
                }
            },
            {
                key: "_afterDrawEl",
                value: function _afterDrawEl(param) {
                    var target = param.target;
                    target.ctx.filter = "none";
                }
            }
        ]);
        return BlurShader;
    }(DefaultShader$1);
    var FastBlurComponent = /*#__PURE__*/ function(Component) {
        _inherits._(FastBlurComponent, Component);
        var _super = _create_super._(FastBlurComponent);
        function FastBlurComponent() {
            _class_call_check._(this, FastBlurComponent);
            return _super.apply(this, arguments);
        }
        _create_class._(FastBlurComponent, [
            {
                key: "wrap",
                get: function get() {
                    return this.tag("Wrap");
                }
            },
            {
                key: "content",
                get: function get() {
                    return this.wrap.content;
                },
                set: function set(v) {
                    return this.wrap.content = v;
                }
            },
            {
                key: "padding",
                set: function set(v) {
                    this.wrap._paddingX = v;
                    this.wrap._paddingY = v;
                    this.wrap._updateBlurSize();
                }
            },
            {
                key: "paddingX",
                set: function set(v) {
                    this.wrap._paddingX = v;
                    this.wrap._updateBlurSize();
                }
            },
            {
                key: "paddingY",
                set: function set(v) {
                    this.wrap._paddingY = v;
                    this.wrap._updateBlurSize();
                }
            },
            {
                key: "amount",
                get: function get() {
                    return this.wrap.amount;
                },
                set: function set(v) {
                    return this.wrap.amount = v;
                }
            },
            {
                key: "_onResize",
                value: function _onResize() {
                    this.wrap.w = this.renderWidth;
                    this.wrap.h = this.renderHeight;
                }
            },
            {
                key: "_signalProxy",
                get: function get() {
                    return true;
                }
            },
            {
                key: "_build",
                value: function _build() {
                    this.patch({
                        Wrap: {
                            type: this.stage.gl ? WebGLFastBlurComponent : C2dFastBlurComponent
                        }
                    });
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    return {};
                }
            }
        ]);
        return FastBlurComponent;
    }(Component);
    var C2dFastBlurComponent = /*#__PURE__*/ function(Component) {
        _inherits._(C2dFastBlurComponent, Component);
        var _super = _create_super._(C2dFastBlurComponent);
        function C2dFastBlurComponent(stage) {
            _class_call_check._(this, C2dFastBlurComponent);
            var _this;
            _this = _super.call(this, stage);
            _this._textwrap = _this.sel("Textwrap");
            _this._wrapper = _this.sel("Textwrap>Content");
            _this._amount = 0;
            _this._paddingX = 0;
            _this._paddingY = 0;
            return _this;
        }
        _create_class._(C2dFastBlurComponent, [
            {
                key: "content",
                get: function get() {
                    return this.sel("Textwrap>Content");
                },
                set: function set(v) {
                    this.sel("Textwrap>Content").patch(v, true);
                }
            },
            {
                key: "padding",
                set: function set(v) {
                    this._paddingX = v;
                    this._paddingY = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "paddingX",
                set: function set(v) {
                    this._paddingX = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "paddingY",
                set: function set(v) {
                    this._paddingY = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "_updateBlurSize",
                value: function _updateBlurSize() {
                    var w = this.renderWidth;
                    var h = this.renderHeight;
                    var paddingX = this._paddingX;
                    var paddingY = this._paddingY;
                    this._wrapper.x = paddingX;
                    this._textwrap.x = -paddingX;
                    this._wrapper.y = paddingY;
                    this._textwrap.y = -paddingY;
                    this._textwrap.w = w + paddingX * 2;
                    this._textwrap.h = h + paddingY * 2;
                }
            },
            {
                key: "amount",
                get: function get() {
                    return this._amount;
                },
                set: function set(v) {
                    this._amount = v;
                    this._textwrap.shader.kernelRadius = C2dFastBlurComponent._amountToKernelRadius(v);
                }
            },
            {
                key: "_signalProxy",
                get: function get() {
                    return true;
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    return {
                        forceZIndexContext: true,
                        rtt: true,
                        Textwrap: {
                            shader: {
                                type: BlurShader
                            },
                            Content: {}
                        }
                    };
                }
            },
            {
                key: "getSpline",
                value: function getSpline() {
                    if (!this._multiSpline) {
                        this._multiSpline = new MultiSpline();
                        this._multiSpline.parse(false, {
                            0: 0,
                            0.25: 1.5,
                            0.5: 5.5,
                            0.75: 18,
                            1: 39
                        });
                    }
                    return this._multiSpline;
                }
            },
            {
                key: "_amountToKernelRadius",
                value: function _amountToKernelRadius(v) {
                    return C2dFastBlurComponent.getSpline().getValue(Math.min(1, v * 0.25));
                }
            }
        ]);
        return C2dFastBlurComponent;
    }(Component);
    var WebGLFastBlurComponent = /*#__PURE__*/ function(Component) {
        _inherits._(WebGLFastBlurComponent, Component);
        var _super = _create_super._(WebGLFastBlurComponent);
        function WebGLFastBlurComponent(stage) {
            _class_call_check._(this, WebGLFastBlurComponent);
            var _this;
            _this = _super.call(this, stage);
            _this._textwrap = _this.sel("Textwrap");
            _this._wrapper = _this.sel("Textwrap>Content");
            _this._layers = _this.sel("Layers");
            _this._output = _this.sel("Result");
            _this._amount = 0;
            _this._paddingX = 0;
            _this._paddingY = 0;
            return _this;
        }
        _create_class._(WebGLFastBlurComponent, [
            {
                key: "_signalProxy",
                get: function get() {
                    return true;
                }
            },
            {
                key: "_buildLayers",
                value: function _buildLayers() {
                    var _this = this;
                    var filterShaderSettings = [
                        {
                            x: 1,
                            y: 0,
                            kernelRadius: 1
                        },
                        {
                            x: 0,
                            y: 1,
                            kernelRadius: 1
                        },
                        {
                            x: 1.5,
                            y: 0,
                            kernelRadius: 1
                        },
                        {
                            x: 0,
                            y: 1.5,
                            kernelRadius: 1
                        }
                    ];
                    var filterShaders = filterShaderSettings.map(function(s) {
                        var shader = Shader.create(_this.stage, Object.assign({
                            type: LinearBlurShader
                        }, s));
                        return shader;
                    });
                    this._setLayerTexture(this.getLayerContents(0), this._textwrap.getTexture(), []);
                    this._setLayerTexture(this.getLayerContents(1), this.getLayer(0).getTexture(), [
                        filterShaders[0],
                        filterShaders[1]
                    ]);
                    this._setLayerTexture(this.getLayerContents(2), this.getLayer(1).getTexture(), [
                        filterShaders[0],
                        filterShaders[1],
                        filterShaders[2],
                        filterShaders[3]
                    ]);
                    this._setLayerTexture(this.getLayerContents(3), this.getLayer(2).getTexture(), [
                        filterShaders[0],
                        filterShaders[1],
                        filterShaders[2],
                        filterShaders[3]
                    ]);
                }
            },
            {
                key: "_setLayerTexture",
                value: function _setLayerTexture(element, texture, steps) {
                    if (!steps.length) {
                        element.texture = texture;
                    } else {
                        var step = steps.pop();
                        var child = element.stage.c({
                            rtt: true,
                            shader: step
                        });
                        this._setLayerTexture(child, texture, steps);
                        element.childList.add(child);
                    }
                    return element;
                }
            },
            {
                key: "content",
                get: function get() {
                    return this.sel("Textwrap>Content");
                },
                set: function set(v) {
                    this.sel("Textwrap>Content").patch(v, true);
                }
            },
            {
                key: "padding",
                set: function set(v) {
                    this._paddingX = v;
                    this._paddingY = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "paddingX",
                set: function set(v) {
                    this._paddingX = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "paddingY",
                set: function set(v) {
                    this._paddingY = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "getLayer",
                value: function getLayer(i) {
                    return this._layers.sel("L" + i);
                }
            },
            {
                key: "getLayerContents",
                value: function getLayerContents(i) {
                    return this.getLayer(i).sel("Content");
                }
            },
            {
                key: "_onResize",
                value: function _onResize() {
                    this._updateBlurSize();
                }
            },
            {
                key: "_updateBlurSize",
                value: function _updateBlurSize() {
                    var w = this.renderWidth;
                    var h = this.renderHeight;
                    var paddingX = this._paddingX;
                    var paddingY = this._paddingY;
                    var fw = w + paddingX * 2;
                    var fh = h + paddingY * 2;
                    this._textwrap.w = fw;
                    this._wrapper.x = paddingX;
                    this.getLayer(0).w = this.getLayerContents(0).w = fw / 2;
                    this.getLayer(1).w = this.getLayerContents(1).w = fw / 4;
                    this.getLayer(2).w = this.getLayerContents(2).w = fw / 8;
                    this.getLayer(3).w = this.getLayerContents(3).w = fw / 16;
                    this._output.x = -paddingX;
                    this._textwrap.x = -paddingX;
                    this._output.w = fw;
                    this._textwrap.h = fh;
                    this._wrapper.y = paddingY;
                    this.getLayer(0).h = this.getLayerContents(0).h = fh / 2;
                    this.getLayer(1).h = this.getLayerContents(1).h = fh / 4;
                    this.getLayer(2).h = this.getLayerContents(2).h = fh / 8;
                    this.getLayer(3).h = this.getLayerContents(3).h = fh / 16;
                    this._output.y = -paddingY;
                    this._textwrap.y = -paddingY;
                    this._output.h = fh;
                    this.w = w;
                    this.h = h;
                }
            },
            {
                key: "amount",
                get: function get() {
                    return this._amount;
                },
                set: function set(v) {
                    this._amount = v;
                    this._update();
                }
            },
            {
                key: "_update",
                value: function _update() {
                    var v = Math.min(4, Math.max(0, this._amount));
                    if (v === 0) {
                        this._textwrap.renderToTexture = false;
                        this._output.shader.otherTextureSource = null;
                        this._output.visible = false;
                    } else {
                        this._textwrap.renderToTexture = true;
                        this._output.visible = true;
                        this.getLayer(0).visible = v > 0;
                        this.getLayer(1).visible = v > 1;
                        this.getLayer(2).visible = v > 2;
                        this.getLayer(3).visible = v > 3;
                        if (v <= 1) {
                            this._output.texture = this._textwrap.getTexture();
                            this._output.shader.otherTextureSource = this.getLayer(0).getTexture();
                            this._output.shader.a = v;
                        } else if (v <= 2) {
                            this._output.texture = this.getLayer(0).getTexture();
                            this._output.shader.otherTextureSource = this.getLayer(1).getTexture();
                            this._output.shader.a = v - 1;
                        } else if (v <= 3) {
                            this._output.texture = this.getLayer(1).getTexture();
                            this._output.shader.otherTextureSource = this.getLayer(2).getTexture();
                            this._output.shader.a = v - 2;
                        } else if (v <= 4) {
                            this._output.texture = this.getLayer(2).getTexture();
                            this._output.shader.otherTextureSource = this.getLayer(3).getTexture();
                            this._output.shader.a = v - 3;
                        }
                    }
                }
            },
            {
                key: "shader",
                set: function set(s) {
                    _set._(_get_prototype_of._(WebGLFastBlurComponent.prototype), "shader", s, this, true);
                    if (!this.renderToTexture) {
                        console.warn("[Lightning] Please enable renderToTexture to use with a shader.");
                    }
                }
            },
            {
                key: "_firstActive",
                value: function _firstActive() {
                    this._buildLayers();
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    var onUpdate = function onUpdate(element, elementCore) {
                        if (elementCore._recalc & 2 + 128) {
                            var w = elementCore.w;
                            var h = elementCore.h;
                            var cur = elementCore;
                            do {
                                cur = cur._children[0];
                                cur._element.w = w;
                                cur._element.h = h;
                            }while (cur._children);
                        }
                    };
                    return {
                        Textwrap: {
                            rtt: true,
                            forceZIndexContext: true,
                            renderOffscreen: true,
                            Content: {}
                        },
                        Layers: {
                            L0: {
                                rtt: true,
                                onUpdate: onUpdate,
                                renderOffscreen: true,
                                visible: false,
                                Content: {
                                    shader: {
                                        type: BoxBlurShader
                                    }
                                }
                            },
                            L1: {
                                rtt: true,
                                onUpdate: onUpdate,
                                renderOffscreen: true,
                                visible: false,
                                Content: {
                                    shader: {
                                        type: BoxBlurShader
                                    }
                                }
                            },
                            L2: {
                                rtt: true,
                                onUpdate: onUpdate,
                                renderOffscreen: true,
                                visible: false,
                                Content: {
                                    shader: {
                                        type: BoxBlurShader
                                    }
                                }
                            },
                            L3: {
                                rtt: true,
                                onUpdate: onUpdate,
                                renderOffscreen: true,
                                visible: false,
                                Content: {
                                    shader: {
                                        type: BoxBlurShader
                                    }
                                }
                            }
                        },
                        Result: {
                            shader: {
                                type: FastBlurOutputShader
                            },
                            visible: false
                        }
                    };
                }
            }
        ]);
        return WebGLFastBlurComponent;
    }(Component);
    var FastBlurOutputShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(FastBlurOutputShader, DefaultShader);
        var _super = _create_super._(FastBlurOutputShader);
        function FastBlurOutputShader(ctx) {
            _class_call_check._(this, FastBlurOutputShader);
            var _this;
            _this = _super.call(this, ctx);
            _this._a = 0;
            _this._otherTextureSource = null;
            return _this;
        }
        _create_class._(FastBlurOutputShader, [
            {
                key: "a",
                get: function get() {
                    return this._a;
                },
                set: function set(v) {
                    this._a = v;
                    this.redraw();
                }
            },
            {
                key: "otherTextureSource",
                set: function set(v) {
                    this._otherTextureSource = v;
                    this.redraw();
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(FastBlurOutputShader.prototype), "setupUniforms", this).call(this, operation);
                    this._setUniform("a", this._a, this.gl.uniform1f);
                    this._setUniform("uSampler2", 1, this.gl.uniform1i);
                }
            },
            {
                key: "beforeDraw",
                value: function beforeDraw(operation) {
                    var glTexture = this._otherTextureSource ? this._otherTextureSource.nativeTexture : null;
                    var gl = this.gl;
                    gl.activeTexture(gl.TEXTURE1);
                    gl.bindTexture(gl.TEXTURE_2D, glTexture);
                    gl.activeTexture(gl.TEXTURE0);
                }
            }
        ]);
        return FastBlurOutputShader;
    }(DefaultShader);
    FastBlurOutputShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform sampler2D uSampler2;\n    uniform float a;\n    void main(void){\n        if (a == 1.0) {\n            gl_FragColor = texture2D(uSampler2, vTextureCoord) * vColor;\n        } else {\n            gl_FragColor = ((1.0 - a) * texture2D(uSampler, vTextureCoord) + (a * texture2D(uSampler2, vTextureCoord))) * vColor;\n        }\n    }\n";
    var BloomComponent = /*#__PURE__*/ function(Component) {
        _inherits._(BloomComponent, Component);
        var _super = _create_super._(BloomComponent);
        function BloomComponent(stage) {
            _class_call_check._(this, BloomComponent);
            var _this;
            _this = _super.call(this, stage);
            _this._textwrap = _this.sel("Textwrap");
            _this._wrapper = _this.sel("Textwrap.Content");
            _this._layers = _this.sel("Layers");
            _this._amount = 0;
            _this._paddingX = 0;
            _this._paddingY = 0;
            return _this;
        }
        _create_class._(BloomComponent, [
            {
                key: "_signalProxy",
                get: function get() {
                    return true;
                }
            },
            {
                key: "_build",
                value: function _build() {
                    var _this = this;
                    var filterShaderSettings = [
                        {
                            x: 1,
                            y: 0,
                            kernelRadius: 3
                        },
                        {
                            x: 0,
                            y: 1,
                            kernelRadius: 3
                        },
                        {
                            x: 1.5,
                            y: 0,
                            kernelRadius: 3
                        },
                        {
                            x: 0,
                            y: 1.5,
                            kernelRadius: 3
                        }
                    ];
                    var filterShaders = filterShaderSettings.map(function(s) {
                        var shader = _this.stage.createShader(Object.assign({
                            type: LinearBlurShader
                        }, s));
                        return shader;
                    });
                    this._setLayerTexture(this.getLayerContents(0), this._textwrap.getTexture(), []);
                    this._setLayerTexture(this.getLayerContents(1), this.getLayer(0).getTexture(), [
                        filterShaders[0],
                        filterShaders[1]
                    ]);
                    this._setLayerTexture(this.getLayerContents(2), this.getLayer(1).getTexture(), [
                        filterShaders[0],
                        filterShaders[1],
                        filterShaders[2],
                        filterShaders[3]
                    ]);
                    this._setLayerTexture(this.getLayerContents(3), this.getLayer(2).getTexture(), [
                        filterShaders[0],
                        filterShaders[1],
                        filterShaders[2],
                        filterShaders[3]
                    ]);
                }
            },
            {
                key: "_setLayerTexture",
                value: function _setLayerTexture(element, texture, steps) {
                    if (!steps.length) {
                        element.texture = texture;
                    } else {
                        var step = steps.pop();
                        var child = element.stage.c({
                            rtt: true,
                            shader: step
                        });
                        this._setLayerTexture(child, texture, steps);
                        element.childList.add(child);
                    }
                    return element;
                }
            },
            {
                key: "content",
                get: function get() {
                    return this.sel("Textwrap.Content");
                },
                set: function set(v) {
                    this.sel("Textwrap.Content").patch(v);
                }
            },
            {
                key: "padding",
                set: function set(v) {
                    this._paddingX = v;
                    this._paddingY = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "paddingX",
                set: function set(v) {
                    this._paddingX = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "paddingY",
                set: function set(v) {
                    this._paddingY = v;
                    this._updateBlurSize();
                }
            },
            {
                key: "getLayer",
                value: function getLayer(i) {
                    return this._layers.sel("L" + i);
                }
            },
            {
                key: "getLayerContents",
                value: function getLayerContents(i) {
                    return this.getLayer(i).sel("Content");
                }
            },
            {
                key: "_onResize",
                value: function _onResize() {
                    this._updateBlurSize();
                }
            },
            {
                key: "_updateBlurSize",
                value: function _updateBlurSize() {
                    var w = this.renderWidth;
                    var h = this.renderHeight;
                    var paddingX = this._paddingX;
                    var paddingY = this._paddingY;
                    var fw = w + paddingX * 2;
                    var fh = h + paddingY * 2;
                    this._textwrap.w = fw;
                    this._wrapper.x = paddingX;
                    this.getLayer(0).w = this.getLayerContents(0).w = fw / 2;
                    this.getLayer(1).w = this.getLayerContents(1).w = fw / 4;
                    this.getLayer(2).w = this.getLayerContents(2).w = fw / 8;
                    this.getLayer(3).w = this.getLayerContents(3).w = fw / 16;
                    this._textwrap.x = -paddingX;
                    this._textwrap.h = fh;
                    this._wrapper.y = paddingY;
                    this.getLayer(0).h = this.getLayerContents(0).h = fh / 2;
                    this.getLayer(1).h = this.getLayerContents(1).h = fh / 4;
                    this.getLayer(2).h = this.getLayerContents(2).h = fh / 8;
                    this.getLayer(3).h = this.getLayerContents(3).h = fh / 16;
                    this._textwrap.y = -paddingY;
                    this.w = w;
                    this.h = h;
                }
            },
            {
                key: "amount",
                get: function get() {
                    return this._amount;
                },
                set: function set(v) {
                    this._amount = v;
                    this._update();
                }
            },
            {
                key: "_update",
                value: function _update() {
                    var v = Math.min(4, Math.max(0, this._amount));
                    if (v > 0) {
                        this.getLayer(0).visible = v > 0;
                        this.getLayer(1).visible = v > 1;
                        this.getLayer(2).visible = v > 2;
                        this.getLayer(3).visible = v > 3;
                    }
                }
            },
            {
                key: "shader",
                set: function set(s) {
                    _set._(_get_prototype_of._(BloomComponent.prototype), "shader", s, this, true);
                    if (!this.renderToTexture) {
                        console.warn("[Lightning] Please enable renderToTexture to use with a shader.");
                    }
                }
            },
            {
                key: "_firstActive",
                value: function _firstActive() {
                    this._build();
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    var onUpdate = function onUpdate(element, elementCore) {
                        if (elementCore._recalc & 2 + 128) {
                            var w = elementCore.w;
                            var h = elementCore.h;
                            var cur = elementCore;
                            do {
                                cur = cur._children[0];
                                cur._element.w = w;
                                cur._element.h = h;
                            }while (cur._children);
                        }
                    };
                    return {
                        Textwrap: {
                            rtt: true,
                            forceZIndexContext: true,
                            renderOffscreen: true,
                            BloomBase: {
                                shader: {
                                    type: BloomBaseShader
                                },
                                Content: {}
                            }
                        },
                        Layers: {
                            L0: {
                                rtt: true,
                                onUpdate: onUpdate,
                                scale: 2,
                                pivot: 0,
                                visible: false,
                                Content: {
                                    shader: {
                                        type: BoxBlurShader
                                    }
                                }
                            },
                            L1: {
                                rtt: true,
                                onUpdate: onUpdate,
                                scale: 4,
                                pivot: 0,
                                visible: false,
                                Content: {
                                    shader: {
                                        type: BoxBlurShader
                                    }
                                }
                            },
                            L2: {
                                rtt: true,
                                onUpdate: onUpdate,
                                scale: 8,
                                pivot: 0,
                                visible: false,
                                Content: {
                                    shader: {
                                        type: BoxBlurShader
                                    }
                                }
                            },
                            L3: {
                                rtt: true,
                                onUpdate: onUpdate,
                                scale: 16,
                                pivot: 0,
                                visible: false,
                                Content: {
                                    shader: {
                                        type: BoxBlurShader
                                    }
                                }
                            }
                        }
                    };
                }
            }
        ]);
        return BloomComponent;
    }(Component);
    var BloomBaseShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(BloomBaseShader, DefaultShader);
        var _super = _create_super._(BloomBaseShader);
        function BloomBaseShader() {
            _class_call_check._(this, BloomBaseShader);
            return _super.apply(this, arguments);
        }
        return BloomBaseShader;
    }(DefaultShader);
    BloomBaseShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n        float m = max(max(color.r, color.g), color.b);\n        float c = max(0.0, (m - 0.80)) * 5.0;\n        color = color * c;\n        gl_FragColor = color;\n    }\n";
    var SmoothScaleComponent = /*#__PURE__*/ function(Component) {
        _inherits._(SmoothScaleComponent, Component);
        var _super = _create_super._(SmoothScaleComponent);
        function SmoothScaleComponent(stage) {
            _class_call_check._(this, SmoothScaleComponent);
            var _this;
            _this = _super.call(this, stage);
            _this._smoothScale = 1;
            _this._iterations = 0;
            return _this;
        }
        _create_class._(SmoothScaleComponent, [
            {
                key: "content",
                get: function get() {
                    return this.tag("Content");
                },
                set: function set(v) {
                    this.tag("Content").patch(v, true);
                }
            },
            {
                key: "smoothScale",
                get: function get() {
                    return this._smoothScale;
                },
                set: function set(v) {
                    if (this._smoothScale !== v) {
                        var its = 0;
                        while(v < 0.5 && its < 12){
                            its++;
                            v = v * 2;
                        }
                        this.scale = v;
                        this._setIterations(its);
                        this._smoothScale = v;
                    }
                }
            },
            {
                key: "_setIterations",
                value: function _setIterations(its) {
                    if (this._iterations !== its) {
                        var scalers = this.sel("Scale").childList;
                        var content = this.sel("ContentWrap");
                        while(scalers.length < its){
                            var first = scalers.length === 0;
                            var texture = first ? content.getTexture() : scalers.last.getTexture();
                            scalers.a({
                                rtt: true,
                                renderOffscreen: true,
                                texture: texture
                            });
                        }
                        SmoothScaleComponent._updateDimensions(this.tag("ContentWrap"), true);
                        var useScalers = its > 0;
                        this.patch({
                            ContentWrap: {
                                renderToTexture: useScalers
                            },
                            Scale: {
                                visible: useScalers
                            }
                        });
                        for(var i = 0, n = scalers.length; i < n; i++){
                            scalers.getAt(i).patch({
                                visible: i < its,
                                renderOffscreen: i !== its - 1
                            });
                        }
                        this._iterations = its;
                    }
                }
            },
            {
                key: "_signalProxy",
                get: function get() {
                    return true;
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    return {
                        ContentWrap: {
                            renderOffscreen: true,
                            forceZIndexContext: true,
                            onAfterUpdate: SmoothScaleComponent._updateDimensions,
                            Content: {}
                        },
                        Scale: {
                            visible: false
                        }
                    };
                }
            },
            {
                key: "_updateDimensions",
                value: function _updateDimensions(contentWrap, force) {
                    var content = contentWrap.children[0];
                    var w = content.renderWidth;
                    var h = content.renderHeight;
                    if (w !== contentWrap.w || h !== contentWrap.h || force) {
                        contentWrap.w = w;
                        contentWrap.h = h;
                        var scalers = contentWrap.parent.tag("Scale").children;
                        for(var i = 0, n = scalers.length; i < n; i++){
                            w = w * 0.5;
                            h = h * 0.5;
                            scalers[i].w = w;
                            scalers[i].h = h;
                        }
                    }
                }
            }
        ]);
        return SmoothScaleComponent;
    }(Component);
    var BorderComponent = /*#__PURE__*/ function(Component) {
        _inherits._(BorderComponent, Component);
        var _super = _create_super._(BorderComponent);
        function BorderComponent(stage) {
            _class_call_check._(this, BorderComponent);
            var _this;
            _this = _super.call(this, stage);
            _this._borderTop = _this.tag("Top");
            _this._borderRight = _this.tag("Right");
            _this._borderBottom = _this.tag("Bottom");
            _this._borderLeft = _this.tag("Left");
            _this.onAfterUpdate = function(element) {
                var content = element.childList.first;
                var w = element.core.w || content.renderWidth;
                var h = element.core.h || content.renderHeight;
                element._borderTop.w = w;
                element._borderBottom.y = h;
                element._borderBottom.w = w;
                element._borderLeft.h = h + element._borderTop.h + element._borderBottom.h;
                element._borderLeft.y = -element._borderTop.h;
                element._borderRight.x = w;
                element._borderRight.h = h + element._borderTop.h + element._borderBottom.h;
                element._borderRight.y = -element._borderTop.h;
            };
            _this.borderWidth = 1;
            return _this;
        }
        _create_class._(BorderComponent, [
            {
                key: "_signalProxy",
                get: function get() {
                    return true;
                }
            },
            {
                key: "content",
                get: function get() {
                    return this.sel("Content");
                },
                set: function set(v) {
                    this.sel("Content").patch(v, true);
                }
            },
            {
                key: "borderWidth",
                get: function get() {
                    return this.borderWidthTop;
                },
                set: function set(v) {
                    this.borderWidthTop = v;
                    this.borderWidthRight = v;
                    this.borderWidthBottom = v;
                    this.borderWidthLeft = v;
                }
            },
            {
                key: "borderWidthTop",
                get: function get() {
                    return this._borderTop.h;
                },
                set: function set(v) {
                    this._borderTop.h = v;
                    this._borderTop.visible = v > 0;
                }
            },
            {
                key: "borderWidthRight",
                get: function get() {
                    return this._borderRight.w;
                },
                set: function set(v) {
                    this._borderRight.w = v;
                    this._borderRight.visible = v > 0;
                }
            },
            {
                key: "borderWidthBottom",
                get: function get() {
                    return this._borderBottom.h;
                },
                set: function set(v) {
                    this._borderBottom.h = v;
                    this._borderBottom.visible = v > 0;
                }
            },
            {
                key: "borderWidthLeft",
                get: function get() {
                    return this._borderLeft.w;
                },
                set: function set(v) {
                    this._borderLeft.w = v;
                    this._borderLeft.visible = v > 0;
                }
            },
            {
                key: "colorBorder",
                get: function get() {
                    return this.colorBorderTop;
                },
                set: function set(v) {
                    this.colorBorderTop = v;
                    this.colorBorderRight = v;
                    this.colorBorderBottom = v;
                    this.colorBorderLeft = v;
                }
            },
            {
                key: "colorBorderTop",
                get: function get() {
                    return this._borderTop.color;
                },
                set: function set(v) {
                    this._borderTop.color = v;
                }
            },
            {
                key: "colorBorderRight",
                get: function get() {
                    return this._borderRight.color;
                },
                set: function set(v) {
                    this._borderRight.color = v;
                }
            },
            {
                key: "colorBorderBottom",
                get: function get() {
                    return this._borderBottom.color;
                },
                set: function set(v) {
                    this._borderBottom.color = v;
                }
            },
            {
                key: "colorBorderLeft",
                get: function get() {
                    return this._borderLeft.color;
                },
                set: function set(v) {
                    this._borderLeft.color = v;
                }
            },
            {
                key: "borderTop",
                get: function get() {
                    return this._borderTop;
                },
                set: function set(settings) {
                    this.borderTop.patch(settings);
                }
            },
            {
                key: "borderRight",
                get: function get() {
                    return this._borderRight;
                },
                set: function set(settings) {
                    this.borderRight.patch(settings);
                }
            },
            {
                key: "borderBottom",
                get: function get() {
                    return this._borderBottom;
                },
                set: function set(settings) {
                    this.borderBottom.patch(settings);
                }
            },
            {
                key: "borderLeft",
                get: function get() {
                    return this._borderLeft;
                },
                set: function set(settings) {
                    this.borderLeft.patch(settings);
                }
            },
            {
                key: "borders",
                set: function set(settings) {
                    this.borderTop = settings;
                    this.borderLeft = settings;
                    this.borderBottom = settings;
                    this.borderRight = settings;
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    return {
                        Content: {},
                        Borders: {
                            Top: {
                                rect: true,
                                visible: false,
                                mountY: 1
                            },
                            Right: {
                                rect: true,
                                visible: false
                            },
                            Bottom: {
                                rect: true,
                                visible: false
                            },
                            Left: {
                                rect: true,
                                visible: false,
                                mountX: 1
                            }
                        }
                    };
                }
            }
        ]);
        return BorderComponent;
    }(Component);
    var WebGLGrayscaleShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(WebGLGrayscaleShader, DefaultShader);
        var _super = _create_super._(WebGLGrayscaleShader);
        function WebGLGrayscaleShader(context) {
            _class_call_check._(this, WebGLGrayscaleShader);
            var _this;
            _this = _super.call(this, context);
            _this._amount = 1;
            return _this;
        }
        _create_class._(WebGLGrayscaleShader, [
            {
                key: "amount",
                get: function get() {
                    return this._amount;
                },
                set: function set(v) {
                    this._amount = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._amount === 0;
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(WebGLGrayscaleShader.prototype), "setupUniforms", this).call(this, operation);
                    this._setUniform("amount", this._amount, this.gl.uniform1f);
                }
            }
        ], [
            {
                key: "getC2d",
                value: function getC2d() {
                    return C2dGrayscaleShader;
                }
            }
        ]);
        return WebGLGrayscaleShader;
    }(DefaultShader);
    WebGLGrayscaleShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform float amount;\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n        float grayness = 0.2 * color.r + 0.6 * color.g + 0.2 * color.b;\n        gl_FragColor = vec4(amount * vec3(grayness, grayness, grayness) + (1.0 - amount) * color.rgb, color.a);\n    }\n";
    var C2dGrayscaleShader = /*#__PURE__*/ function(DefaultShader$1) {
        _inherits._(C2dGrayscaleShader, DefaultShader$1);
        var _super = _create_super._(C2dGrayscaleShader);
        function C2dGrayscaleShader(context) {
            _class_call_check._(this, C2dGrayscaleShader);
            var _this;
            _this = _super.call(this, context);
            _this._amount = 1;
            return _this;
        }
        _create_class._(C2dGrayscaleShader, [
            {
                key: "amount",
                get: function get() {
                    return this._amount;
                },
                set: function set(v) {
                    this._amount = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._amount === 0;
                }
            },
            {
                key: "_beforeDrawEl",
                value: function _beforeDrawEl(param) {
                    var target = param.target;
                    target.ctx.filter = "grayscale(" + this._amount + ")";
                }
            },
            {
                key: "_afterDrawEl",
                value: function _afterDrawEl(param) {
                    var target = param.target;
                    target.ctx.filter = "none";
                }
            }
        ], [
            {
                key: "getWebGL",
                value: function getWebGL() {
                    return WebGLGrayscaleShader;
                }
            }
        ]);
        return C2dGrayscaleShader;
    }(DefaultShader$1);
    var DitheringShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(DitheringShader, DefaultShader);
        var _super = _create_super._(DitheringShader);
        function DitheringShader(ctx) {
            _class_call_check._(this, DitheringShader);
            var _this;
            _this = _super.call(this, ctx);
            _this._noiseTexture = new NoiseTexture(ctx.stage);
            _this._graining = 1 / 256;
            _this._random = false;
            return _this;
        }
        _create_class._(DitheringShader, [
            {
                key: "graining",
                set: function set(v) {
                    this._graining = v;
                    this.redraw();
                }
            },
            {
                key: "random",
                set: function set(v) {
                    this._random = v;
                    this.redraw();
                }
            },
            {
                key: "setExtraAttribsInBuffer",
                value: function setExtraAttribsInBuffer(operation) {
                    this._noiseTexture.load();
                    var offset = operation.extraAttribsDataByteOffset / 4;
                    var floats = operation.quads.floats;
                    var length = operation.length;
                    for(var i = 0; i < length; i++){
                        var brx = operation.getElementWidth(i) / this._noiseTexture.getRenderWidth();
                        var bry = operation.getElementHeight(i) / this._noiseTexture.getRenderHeight();
                        var ulx = 0;
                        var uly = 0;
                        if (this._random) {
                            ulx = Math.random();
                            uly = Math.random();
                            brx += ulx;
                            bry += uly;
                            if (Math.random() < 0.5) {
                                var t = ulx;
                                ulx = brx;
                                brx = t;
                            }
                            if (Math.random() < 0.5) {
                                var t1 = uly;
                                uly = bry;
                                bry = t1;
                            }
                        }
                        floats[offset] = ulx;
                        floats[offset + 1] = uly;
                        floats[offset + 2] = brx;
                        floats[offset + 3] = uly;
                        floats[offset + 4] = brx;
                        floats[offset + 5] = bry;
                        floats[offset + 6] = ulx;
                        floats[offset + 7] = bry;
                        offset += 8;
                    }
                }
            },
            {
                key: "beforeDraw",
                value: function beforeDraw(operation) {
                    var gl = this.gl;
                    gl.vertexAttribPointer(this._attrib("aNoiseTextureCoord"), 2, gl.FLOAT, false, 8, this.getVertexAttribPointerOffset(operation));
                    var glTexture = this._noiseTexture.source.nativeTexture;
                    gl.activeTexture(gl.TEXTURE1);
                    gl.bindTexture(gl.TEXTURE_2D, glTexture);
                    gl.activeTexture(gl.TEXTURE0);
                }
            },
            {
                key: "getExtraAttribBytesPerVertex",
                value: function getExtraAttribBytesPerVertex() {
                    return 8;
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(DitheringShader.prototype), "setupUniforms", this).call(this, operation);
                    this._setUniform("uNoiseSampler", 1, this.gl.uniform1i);
                    this._setUniform("graining", 2 * this._graining, this.gl.uniform1f);
                }
            },
            {
                key: "enableAttribs",
                value: function enableAttribs() {
                    _get._(_get_prototype_of._(DitheringShader.prototype), "enableAttribs", this).call(this);
                    var gl = this.gl;
                    gl.enableVertexAttribArray(this._attrib("aNoiseTextureCoord"));
                }
            },
            {
                key: "disableAttribs",
                value: function disableAttribs() {
                    _get._(_get_prototype_of._(DitheringShader.prototype), "disableAttribs", this).call(this);
                    var gl = this.gl;
                    gl.disableVertexAttribArray(this._attrib("aNoiseTextureCoord"));
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._graining === 0;
                }
            },
            {
                key: "afterDraw",
                value: function afterDraw(operation) {
                    if (this._random) {
                        this.redraw();
                    }
                }
            }
        ]);
        return DitheringShader;
    }(DefaultShader);
    DitheringShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec2 aNoiseTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec2 vNoiseTextureCoord;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vNoiseTextureCoord = aNoiseTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    DitheringShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec2 vNoiseTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform sampler2D uNoiseSampler;\n    uniform float graining;\n    void main(void){\n        vec4 noise = texture2D(uNoiseSampler, vNoiseTextureCoord);\n        vec4 color = texture2D(uSampler, vTextureCoord);\n        gl_FragColor = (color * vColor) + graining * (noise.r - 0.5);\n    }\n";
    var CircularPushShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(CircularPushShader, DefaultShader);
        var _super = _create_super._(CircularPushShader);
        function CircularPushShader(ctx) {
            _class_call_check._(this, CircularPushShader);
            var _this;
            _this = _super.call(this, ctx);
            _this._inputValue = 0;
            _this._maxDerivative = 0.01;
            _this._normalizedValue = 0;
            _this._offset = 0;
            _this._amount = 0.1;
            _this._aspectRatio = 1;
            _this._offsetX = 0;
            _this._offsetY = 0;
            _this.buckets = 100;
            return _this;
        }
        _create_class._(CircularPushShader, [
            {
                key: "aspectRatio",
                get: function get() {
                    return this._aspectRatio;
                },
                set: function set(v) {
                    this._aspectRatio = v;
                    this.redraw();
                }
            },
            {
                key: "offsetX",
                get: function get() {
                    return this._offsetX;
                },
                set: function set(v) {
                    this._offsetX = v;
                    this.redraw();
                }
            },
            {
                key: "offsetY",
                get: function get() {
                    return this._offsetY;
                },
                set: function set(v) {
                    this._offsetY = v;
                    this.redraw();
                }
            },
            {
                key: "amount",
                get: function get() {
                    return this._amount;
                },
                set: function set(v) {
                    this._amount = v;
                    this.redraw();
                }
            },
            {
                key: "inputValue",
                get: function get() {
                    return this._inputValue;
                },
                set: function set(v) {
                    this._inputValue = v;
                }
            },
            {
                key: "maxDerivative",
                get: function get() {
                    return this._maxDerivative;
                },
                set: function set(v) {
                    this._maxDerivative = v;
                }
            },
            {
                key: "buckets",
                get: function get() {
                    return this._buckets;
                },
                set: function set(v) {
                    if (v > 100) {
                        console.warn("[Lightning] CircularPushShader: supports max 100 buckets");
                        v = 100;
                    }
                    this._buckets = v;
                    this._values = new Uint8Array(this._getValues(v));
                    this.redraw();
                }
            },
            {
                key: "_getValues",
                value: function _getValues(n) {
                    var v = [];
                    for(var i = 0; i < n; i++){
                        v.push(this._inputValue);
                    }
                    return v;
                }
            },
            {
                key: "progress",
                value: function progress(o) {
                    this._offset += o * this._buckets;
                    var full = Math.floor(this._offset);
                    this._offset -= full;
                    this._shiftBuckets(full);
                    this.redraw();
                }
            },
            {
                key: "_shiftBuckets",
                value: function _shiftBuckets(n) {
                    for(var i = this._buckets - 1; i >= 0; i--){
                        var targetIndex = i - n;
                        if (targetIndex < 0) {
                            this._normalizedValue = Math.min(this._normalizedValue + this._maxDerivative, Math.max(this._normalizedValue - this._maxDerivative, this._inputValue));
                            this._values[i] = 255 * this._normalizedValue;
                        } else {
                            this._values[i] = this._values[targetIndex];
                        }
                    }
                }
            },
            {
                key: "offset",
                set: function set(v) {
                    this._offset = v;
                    this.redraw();
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(CircularPushShader.prototype), "setupUniforms", this).call(this, operation);
                    this._setUniform("aspectRatio", this._aspectRatio, this.gl.uniform1f);
                    this._setUniform("offsetX", this._offsetX, this.gl.uniform1f);
                    this._setUniform("offsetY", this._offsetY, this.gl.uniform1f);
                    this._setUniform("amount", this._amount, this.gl.uniform1f);
                    this._setUniform("offset", this._offset, this.gl.uniform1f);
                    this._setUniform("buckets", this._buckets, this.gl.uniform1f);
                    this._setUniform("uValueSampler", 1, this.gl.uniform1i);
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._amount === 0;
                }
            },
            {
                key: "beforeDraw",
                value: function beforeDraw(operation) {
                    var gl = this.gl;
                    gl.activeTexture(gl.TEXTURE1);
                    if (!this._valuesTexture) {
                        this._valuesTexture = gl.createTexture();
                        gl.bindTexture(gl.TEXTURE_2D, this._valuesTexture);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                        if (Utils.isNode) {
                            gl.pixelStorei(gl.UNPACK_FLIP_BLUE_RED, false);
                        }
                        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
                    } else {
                        gl.bindTexture(gl.TEXTURE_2D, this._valuesTexture);
                    }
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.ALPHA, this._buckets, 1, 0, gl.ALPHA, gl.UNSIGNED_BYTE, this._values);
                    gl.activeTexture(gl.TEXTURE0);
                }
            },
            {
                key: "cleanup",
                value: function cleanup() {
                    if (this._valuesTexture) {
                        this.gl.deleteTexture(this._valuesTexture);
                    }
                }
            }
        ]);
        return CircularPushShader;
    }(DefaultShader);
    CircularPushShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    uniform float offsetX;\n    uniform float offsetY;\n    uniform float aspectRatio;\n    varying vec2 vTextureCoord;\n    varying vec2 vPos;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vPos = vTextureCoord * 2.0 - 1.0;\n        vPos.y = vPos.y * aspectRatio;\n        vPos.y = vPos.y + offsetY;\n        vPos.x = vPos.x + offsetX;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    CircularPushShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec2 vPos;\n    uniform float amount;\n    uniform float offset;\n    uniform float values[100];\n    uniform float buckets;\n    uniform sampler2D uSampler;\n    uniform sampler2D uValueSampler;\n    void main(void){\n        float l = length(vPos);\n        float m = (l * buckets * 0.678 - offset) / buckets;\n        float f = texture2D(uValueSampler, vec2(m, 0.0)).a * amount;\n        vec2 unit = vPos / l;\n        gl_FragColor = texture2D(uSampler, vTextureCoord - f * unit) * vColor;\n    }\n";
    var InversionShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(InversionShader, DefaultShader);
        var _super = _create_super._(InversionShader);
        function InversionShader(context) {
            _class_call_check._(this, InversionShader);
            var _this;
            _this = _super.call(this, context);
            _this._amount = 1;
            return _this;
        }
        _create_class._(InversionShader, [
            {
                key: "amount",
                get: function get() {
                    return this._amount;
                },
                set: function set(v) {
                    this._amount = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._amount === 0;
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(InversionShader.prototype), "setupUniforms", this).call(this, operation);
                    this._setUniform("amount", this._amount, this.gl.uniform1f);
                }
            }
        ]);
        return InversionShader;
    }(DefaultShader);
    InversionShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform float amount;\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord);\n        color.rgb = color.rgb * (1.0 - amount) + amount * (1.0 * color.a - color.rgb); \n        gl_FragColor = color * vColor;\n    }\n";
    var OutlineShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(OutlineShader, DefaultShader);
        var _super = _create_super._(OutlineShader);
        function OutlineShader(ctx) {
            _class_call_check._(this, OutlineShader);
            var _this;
            _this = _super.call(this, ctx);
            _this._width = 5;
            _this._col = 0xFFFFFFFF;
            _this._color = [
                1,
                1,
                1,
                1
            ];
            return _this;
        }
        _create_class._(OutlineShader, [
            {
                key: "width",
                set: function set(v) {
                    this._width = v;
                    this.redraw();
                }
            },
            {
                key: "color",
                get: function get() {
                    return this._col;
                },
                set: function set(v) {
                    if (this._col !== v) {
                        var col = StageUtils.getRgbaComponentsNormalized(v);
                        col[0] = col[0] * col[3];
                        col[1] = col[1] * col[3];
                        col[2] = col[2] * col[3];
                        this._color = col;
                        this.redraw();
                        this._col = v;
                    }
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._width === 0 || this._col[3] === 0;
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(OutlineShader.prototype), "setupUniforms", this).call(this, operation);
                    var gl = this.gl;
                    this._setUniform("color", new Float32Array(this._color), gl.uniform4fv);
                }
            },
            {
                key: "enableAttribs",
                value: function enableAttribs() {
                    _get._(_get_prototype_of._(OutlineShader.prototype), "enableAttribs", this).call(this);
                    this.gl.enableVertexAttribArray(this._attrib("aCorner"));
                }
            },
            {
                key: "disableAttribs",
                value: function disableAttribs() {
                    _get._(_get_prototype_of._(OutlineShader.prototype), "disableAttribs", this).call(this);
                    this.gl.disableVertexAttribArray(this._attrib("aCorner"));
                }
            },
            {
                key: "setExtraAttribsInBuffer",
                value: function setExtraAttribsInBuffer(operation) {
                    var offset = operation.extraAttribsDataByteOffset / 4;
                    var floats = operation.quads.floats;
                    var length = operation.length;
                    for(var i = 0; i < length; i++){
                        var elementCore = operation.getElementCore(i);
                        var ddw = this._width / elementCore.w;
                        var dw = ddw / (1 - 2 * ddw);
                        var ddh = this._width / elementCore.h;
                        var dh = ddh / (1 - 2 * ddh);
                        floats[offset] = -dw;
                        floats[offset + 1] = -dh;
                        floats[offset + 2] = 1 + dw;
                        floats[offset + 3] = -dh;
                        floats[offset + 4] = 1 + dw;
                        floats[offset + 5] = 1 + dh;
                        floats[offset + 6] = -dw;
                        floats[offset + 7] = 1 + dh;
                        offset += 8;
                    }
                }
            },
            {
                key: "beforeDraw",
                value: function beforeDraw(operation) {
                    var gl = this.gl;
                    gl.vertexAttribPointer(this._attrib("aCorner"), 2, gl.FLOAT, false, 8, this.getVertexAttribPointerOffset(operation));
                }
            },
            {
                key: "getExtraAttribBytesPerVertex",
                value: function getExtraAttribBytesPerVertex() {
                    return 8;
                }
            }
        ]);
        return OutlineShader;
    }(DefaultShader);
    OutlineShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    attribute vec2 aCorner;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec2 vCorner;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vCorner = aCorner;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    OutlineShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec2 vCorner;\n    uniform vec4 color;\n    uniform sampler2D uSampler;\n    void main(void){\n        vec2 m = min(vCorner, 1.0 - vCorner);\n        float value = step(0.0, min(m.x, m.y));\n        gl_FragColor = mix(color, texture2D(uSampler, vTextureCoord) * vColor, value);\n    }\n";
    var PixelateShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(PixelateShader, DefaultShader);
        var _super = _create_super._(PixelateShader);
        function PixelateShader(ctx) {
            _class_call_check._(this, PixelateShader);
            var _this;
            _this = _super.call(this, ctx);
            _this._size = new Float32Array([
                4,
                4
            ]);
            return _this;
        }
        _create_class._(PixelateShader, [
            {
                key: "x",
                get: function get() {
                    return this._size[0];
                },
                set: function set(v) {
                    this._size[0] = v;
                    this.redraw();
                }
            },
            {
                key: "y",
                get: function get() {
                    return this._size[1];
                },
                set: function set(v) {
                    this._size[1] = v;
                    this.redraw();
                }
            },
            {
                key: "size",
                get: function get() {
                    return this._size[0];
                },
                set: function set(v) {
                    this._size[0] = v;
                    this._size[1] = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._size[0] === 0 && this._size[1] === 0;
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(PixelateShader.prototype), "setupUniforms", this).call(this, operation);
                    var gl = this.gl;
                    this._setUniform("size", new Float32Array(this._size), gl.uniform2fv);
                }
            },
            {
                key: "getExtraAttribBytesPerVertex",
                value: function getExtraAttribBytesPerVertex() {
                    return 8;
                }
            },
            {
                key: "enableAttribs",
                value: function enableAttribs() {
                    _get._(_get_prototype_of._(PixelateShader.prototype), "enableAttribs", this).call(this);
                    this.gl.enableVertexAttribArray(this._attrib("aTextureRes"));
                }
            },
            {
                key: "disableAttribs",
                value: function disableAttribs() {
                    _get._(_get_prototype_of._(PixelateShader.prototype), "disableAttribs", this).call(this);
                    this.gl.disableVertexAttribArray(this._attrib("aTextureRes"));
                }
            },
            {
                key: "setExtraAttribsInBuffer",
                value: function setExtraAttribsInBuffer(operation) {
                    var offset = operation.extraAttribsDataByteOffset / 4;
                    var floats = operation.quads.floats;
                    var length = operation.length;
                    for(var i = 0; i < length; i++){
                        var w = operation.quads.getTextureWidth(operation.index + i);
                        var h = operation.quads.getTextureHeight(operation.index + i);
                        floats[offset] = w;
                        floats[offset + 1] = h;
                        floats[offset + 2] = w;
                        floats[offset + 3] = h;
                        floats[offset + 4] = w;
                        floats[offset + 5] = h;
                        floats[offset + 6] = w;
                        floats[offset + 7] = h;
                        offset += 8;
                    }
                }
            },
            {
                key: "beforeDraw",
                value: function beforeDraw(operation) {
                    var gl = this.gl;
                    gl.vertexAttribPointer(this._attrib("aTextureRes"), 2, gl.FLOAT, false, this.getExtraAttribBytesPerVertex(), this.getVertexAttribPointerOffset(operation));
                }
            }
        ], [
            {
                key: "getWebGLImpl",
                value: function getWebGLImpl() {
                    return WebGLPixelateShaderImpl;
                }
            }
        ]);
        return PixelateShader;
    }(DefaultShader);
    PixelateShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    attribute vec2 aTextureRes;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec2 vTextureRes;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        vTextureRes = aTextureRes;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    PixelateShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec2 vTextureRes;\n\n    uniform vec2 size;\n    uniform sampler2D uSampler;\n    \n    vec2 mapCoord( vec2 coord )\n    {\n        coord *= vTextureRes.xy;\n        return coord;\n    }\n    \n    vec2 unmapCoord( vec2 coord )\n    {\n        coord /= vTextureRes.xy;\n        return coord;\n    }\n    \n    vec2 pixelate(vec2 coord, vec2 size)\n    {\n        return floor( coord / size ) * size;\n    }\n    \n    void main(void)\n    {\n        vec2 coord = mapCoord(vTextureCoord);\n        coord = pixelate(coord, size);\n        coord = unmapCoord(coord);\n        gl_FragColor = texture2D(uSampler, coord) * vColor;\n    }\n";
    var RadialFilterShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(RadialFilterShader, DefaultShader);
        var _super = _create_super._(RadialFilterShader);
        function RadialFilterShader(context) {
            _class_call_check._(this, RadialFilterShader);
            var _this;
            _this = _super.call(this, context);
            _this._radius = 0;
            _this._cutoff = 1;
            return _this;
        }
        _create_class._(RadialFilterShader, [
            {
                key: "radius",
                get: function get() {
                    return this._radius;
                },
                set: function set(v) {
                    this._radius = v;
                    this.redraw();
                }
            },
            {
                key: "cutoff",
                get: function get() {
                    return this._cutoff;
                },
                set: function set(v) {
                    this._cutoff = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._radius === 0;
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(RadialFilterShader.prototype), "setupUniforms", this).call(this, operation);
                    this._setUniform("radius", 2 * (this._radius - 0.5) / operation.getRenderWidth(), this.gl.uniform1f);
                    this._setUniform("cutoff", 0.5 * operation.getRenderWidth() / this._cutoff, this.gl.uniform1f);
                }
            }
        ]);
        return RadialFilterShader;
    }(DefaultShader);
    RadialFilterShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 pos;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n        pos = gl_Position.xy;\n    }\n";
    RadialFilterShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec2 pos;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform float radius;\n    uniform float cutoff;\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord);\n        float f = max(0.0, min(1.0, 1.0 - (length(pos) - radius) * cutoff));\n        gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor * f;\n    }\n";
    var RoundedRectangleShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(RoundedRectangleShader, DefaultShader);
        var _super = _create_super._(RoundedRectangleShader);
        function RoundedRectangleShader(context) {
            _class_call_check._(this, RoundedRectangleShader);
            var _this;
            _this = _super.call(this, context);
            _this._blend = 0;
            _this._radius = [
                1,
                1,
                1,
                1
            ];
            _this._stroke = 0;
            _this._fc = 0x00ffffff;
            _this._fillColor = _this._getNormalizedColor(0xffffffff);
            _this._strokeColor = _this._getNormalizedColor(0x00ffffff);
            return _this;
        }
        _create_class._(RoundedRectangleShader, [
            {
                key: "blend",
                set: function set(p) {
                    this._blend = Math.min(Math.max(p, 0), 1);
                }
            },
            {
                key: "radius",
                get: function get() {
                    return this._radius;
                },
                set: function set(v) {
                    if (Array.isArray(v)) {
                        if (v.length === 2) {
                            this._radius = [
                                v[0],
                                v[1],
                                v[0],
                                v[1]
                            ];
                        } else if (v.length === 3) {
                            this._radius = [
                                v[0],
                                v[1],
                                v[2],
                                this._radius[3]
                            ];
                        } else if (v.length === 4) {
                            this._radius = v;
                        } else {
                            this._radius = [
                                v[0],
                                v[0],
                                v[0],
                                v[0]
                            ];
                        }
                    } else {
                        this._radius = [
                            v,
                            v,
                            v,
                            v
                        ];
                    }
                    this.redraw();
                }
            },
            {
                key: "topLeft",
                get: function get() {
                    return this._radius[0];
                },
                set: function set(num) {
                    this._radius[0] = num;
                    this.redraw();
                }
            },
            {
                key: "topRight",
                get: function get() {
                    return this._radius[1];
                },
                set: function set(num) {
                    this._radius[1] = num;
                    this.redraw();
                }
            },
            {
                key: "bottomRight",
                get: function get() {
                    return this._radius[2];
                },
                set: function set(num) {
                    this._radius[2] = num;
                    this.redraw();
                }
            },
            {
                key: "bottomLeft",
                get: function get() {
                    return this._radius[4];
                },
                set: function set(num) {
                    this._radius[3] = num;
                    this.redraw();
                }
            },
            {
                key: "strokeColor",
                get: function get() {
                    return this._sc;
                },
                set: function set(argb) {
                    this._sc = argb;
                    this._strokeColor = this._getNormalizedColor(argb);
                    this.redraw();
                }
            },
            {
                key: "fillColor",
                get: function get() {
                    return this._fc;
                },
                set: function set(argb) {
                    this._fc = argb;
                    this._fillColor = this._getNormalizedColor(argb);
                    this.redraw();
                }
            },
            {
                key: "stroke",
                get: function get() {
                    return this._stroke;
                },
                set: function set(num) {
                    this._stroke = num;
                    this.redraw();
                }
            },
            {
                key: "_getNormalizedColor",
                value: function _getNormalizedColor(color) {
                    var col = StageUtils.getRgbaComponentsNormalized(color);
                    col[0] *= col[3];
                    col[1] *= col[3];
                    col[2] *= col[3];
                    return new Float32Array(col);
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(RoundedRectangleShader.prototype), "setupUniforms", this).call(this, operation);
                    var owner = operation.shaderOwner;
                    var renderPrecision = this.ctx.stage.getRenderPrecision();
                    var _radius = this._radius.map(function(r) {
                        return (r + 0.5) * renderPrecision;
                    });
                    this._setUniform("radius", new Float32Array(_radius), this.gl.uniform4fv);
                    this._setUniform("alpha", operation.getElementCore(0).renderContext.alpha, this.gl.uniform1f);
                    this._setUniform("blend", this._blend, this.gl.uniform1f);
                    this._setUniform("strokeColor", this._strokeColor, this.gl.uniform4fv);
                    this._setUniform("fillColor", this._fillColor, this.gl.uniform4fv);
                    this._setUniform("stroke", this._stroke * renderPrecision, this.gl.uniform1f);
                    this._setUniform("resolution", new Float32Array([
                        owner._w * renderPrecision,
                        owner._h * renderPrecision
                    ]), this.gl.uniform2fv);
                }
            }
        ]);
        return RoundedRectangleShader;
    }(DefaultShader);
    RoundedRectangleShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    void main(void){\n        gl_Position = vec4(aVertexPosition.x * projection.x - 1.0, aVertexPosition.y * -abs(projection.y) + 1.0, 0.0, 1.0);\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    RoundedRectangleShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n\n    #define PI 3.14159265359\n\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec4 radius;\n    uniform float stroke;\n    uniform vec4 strokeColor;\n    uniform vec4 fillColor;\n    uniform float alpha;\n    uniform float fill;\n    uniform float blend;\n    \n    float boxDist(vec2 p, vec2 size, float radius){\n        size -= vec2(radius);\n        vec2 d = abs(p) - size;\n        return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - radius;\n    }\n    \n    float fillMask(float dist){\n        return clamp(-dist, 0.0, 1.0);\n    }\n    \n    float innerBorderMask(float dist, float width){\n        float alpha1 = clamp(dist + width, 0.0, 1.0);\n        float alpha2 = clamp(dist, 0.0, 1.0);\n        return alpha1 - alpha2;\n    }\n\n    void main() {\n        vec2 halfRes = 0.5 * resolution.xy;\n        float r = 0.0;\n        if (vTextureCoord.x < 0.5 && vTextureCoord.y < 0.5) {\n            r = radius[0];\n        } else if (vTextureCoord.x >= 0.5 && vTextureCoord.y < 0.5) {\n            r = radius[1];\n        } else if (vTextureCoord.x >= 0.5 && vTextureCoord.y >= 0.5) {\n            r = radius[2];\n        } else {\n            r = radius[3];\n        }\n        \n        float b = boxDist(vTextureCoord.xy * resolution - halfRes, halfRes - 0.005, r);\n        vec4 tex = texture2D(uSampler, vTextureCoord) * vColor;\n        vec4 blend = mix(vec4(1.0) * alpha, tex, blend);     \n        vec4 layer1 = mix(vec4(0.0), tex * fillColor, fillMask(b));\n        gl_FragColor = mix(layer1, blend * strokeColor, innerBorderMask(b, stroke));\n    }\n";
    var FadeOutShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(FadeOutShader, DefaultShader);
        var _super = _create_super._(FadeOutShader);
        function FadeOutShader(context) {
            _class_call_check._(this, FadeOutShader);
            var _this;
            _this = _super.call(this, context);
            _this._fade = [
                0,
                0,
                0,
                0
            ];
            return _this;
        }
        _create_class._(FadeOutShader, [
            {
                key: "top",
                get: function get() {
                    return this._fade[0];
                },
                set: function set(num) {
                    this._fade[0] = num;
                    this.redraw();
                }
            },
            {
                key: "right",
                get: function get() {
                    return this._fade[1];
                },
                set: function set(num) {
                    this._fade[1] = num;
                    this.redraw();
                }
            },
            {
                key: "bottom",
                get: function get() {
                    return this._fade[2];
                },
                set: function set(num) {
                    this._fade[2] = num;
                    this.redraw();
                }
            },
            {
                key: "left",
                get: function get() {
                    return this._fade[3];
                },
                set: function set(num) {
                    this._fade[3] = num;
                    this.redraw();
                }
            },
            {
                key: "fade",
                get: function get() {
                    return this._fade;
                },
                set: function set(v) {
                    if (Array.isArray(v)) {
                        if (v.length === 2) {
                            this._fade = [
                                v[0],
                                v[1],
                                v[0],
                                v[1]
                            ];
                        } else if (v.length === 3) {
                            this._fade = [
                                v[0],
                                v[1],
                                v[2],
                                this._fade[3]
                            ];
                        } else if (v.length === 4) {
                            this._fade = v;
                        } else {
                            this._fade = [
                                v[0],
                                v[0],
                                v[0],
                                v[0]
                            ];
                        }
                    } else {
                        this._fade = [
                            v,
                            v,
                            v,
                            v
                        ];
                    }
                    this.redraw();
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(FadeOutShader.prototype), "setupUniforms", this).call(this, operation);
                    var owner = operation.shaderOwner;
                    var renderPrecision = this.ctx.stage.getRenderPrecision();
                    var fade = this._fade.map(function(f) {
                        return f * renderPrecision;
                    });
                    this._setUniform("fade", new Float32Array(fade), this.gl.uniform4fv);
                    this._setUniform("resolution", new Float32Array([
                        owner._w * renderPrecision,
                        owner._h * renderPrecision
                    ]), this.gl.uniform2fv);
                }
            }
        ]);
        return FadeOutShader;
    }(DefaultShader);
    FadeOutShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec4 fade;\n    \n    void main() {\n        vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n        vec2 halfRes = 0.5 * resolution.xy;\n        vec2 point = vTextureCoord.xy * resolution.xy;\n        \n        vec2 pos1;\n        vec2 pos2;\n        vec2 d;\n        float c;\n        float t = 0.0;\n             \n        if(fade[0] > 0.0) {\n            pos1 = vec2(point.x, point.y);\n            pos2 = vec2(point.x, point.y + fade[0]);\n            d = pos2 - pos1;\n            c = dot(pos1, d) / dot(d, d);\n            t = smoothstep(0.0, 1.0, clamp(c, 0.0, 1.0));\n            color = mix(vec4(0.0), color, t);\n        }\n        \n        if(fade[1] > 0.0) {\n            vec2 pos1 = vec2(point.x - resolution.x - fade[1], vTextureCoord.y);\n            vec2 pos2 = vec2(point.x - resolution.x, vTextureCoord.y);\n            d = pos1 - pos2;\n            c = dot(pos2, d) / dot(d, d);\n            t = smoothstep(0.0, 1.0, clamp(c, 0.0, 1.0));\n            color = mix(vec4(0.0), color, t);\n        }\n        \n        if(fade[2] > 0.0) {\n            vec2 pos1 = vec2(vTextureCoord.x, point.y - resolution.y - fade[2]);\n            vec2 pos2 = vec2(vTextureCoord.x, point.y - resolution.y);\n            d = pos1 - pos2;\n            c = dot(pos2, d) / dot(d, d);\n            t = smoothstep(0.0, 1.0, clamp(c, 0.0, 1.0));\n            color = mix(vec4(0.0), color, t);\n        }\n        \n        if(fade[3] > 0.0) {\n            pos1 = vec2(point.x, point.y);\n            pos2 = vec2(point.x + fade[3], point.y);\n            d = pos2 - pos1;\n            c = dot(pos1, d) / dot(d, d);\n            t = smoothstep(0.0, 1.0, clamp(c, 0.0, 1.0));\n            color = mix(vec4(0.0), color, t);\n        }\n        \n        gl_FragColor = color;\n    }\n";
    var VignetteShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(VignetteShader, DefaultShader);
        var _super = _create_super._(VignetteShader);
        function VignetteShader(context) {
            _class_call_check._(this, VignetteShader);
            var _this;
            _this = _super.call(this, context);
            _this._magnitude = 1.3;
            _this._intensity = 0.7;
            _this._pivot = [
                0.5,
                0.5
            ];
            return _this;
        }
        _create_class._(VignetteShader, [
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(VignetteShader.prototype), "setupUniforms", this).call(this, operation);
                    this._setUniform("magnitude", this._magnitude, this.gl.uniform1f);
                    this._setUniform("intensity", this._intensity, this.gl.uniform1f);
                    this._setUniform("pivot", new Float32Array(this._pivot), this.gl.uniform2fv);
                    this.redraw();
                }
            },
            {
                key: "pivot",
                set: function set(v) {
                    if (Array.isArray(v)) {
                        this._pivot = v;
                    } else {
                        this._pivot = [
                            v,
                            v
                        ];
                    }
                    this.redraw();
                }
            },
            {
                key: "pivotX",
                get: function get() {
                    return this._pivot[0];
                },
                set: function set(v) {
                    this._pivot[0] = v;
                    this.redraw();
                }
            },
            {
                key: "pivotY",
                get: function get() {
                    return this._pivot[1];
                },
                set: function set(v) {
                    this._pivot[1] = v;
                    this.redraw();
                }
            },
            {
                key: "intensity",
                get: function get() {
                    return this._intensity;
                },
                set: function set(v) {
                    this._intensity = v;
                    this.redraw();
                }
            },
            {
                key: "magnitude",
                get: function get() {
                    return this._magnitude;
                },
                set: function set(v) {
                    this._magnitude = v;
                    this.redraw();
                }
            }
        ]);
        return VignetteShader;
    }(DefaultShader);
    VignetteShader.vertexShaderSource = DefaultShader.vertexShaderSource;
    VignetteShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n\n    uniform float magnitude;\n    uniform float intensity;\n    uniform vec2 pivot;\n\n    void main() {\n        vec2 uv = vTextureCoord.xy - pivot + vec2(0.5);\n        uv.x = clamp(uv.x, 0.0, 1.0);\n        uv.y = clamp(uv.y, 0.0, 1.0);\n   \n        uv *=  1.00 - uv.yx;\n        float vig = uv.x * uv.y * 25.0 * intensity;\n        vig = pow(vig, 0.45 * magnitude);\n        vec4 fragColor = vec4(vig) * vColor;\n        gl_FragColor = texture2D(uSampler, vTextureCoord) * fragColor;\n\n    }\n";
    var SpinnerShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(SpinnerShader, DefaultShader);
        var _super = _create_super._(SpinnerShader);
        function SpinnerShader(ctx) {
            _class_call_check._(this, SpinnerShader);
            var _this;
            _this = _super.call(this, ctx);
            _this._radius = 100;
            _this._width = 50;
            _this._period = 1;
            _this._angle = 0.5;
            _this._smooth = 0.005;
            _this._color = 0xffffffff;
            _this._backgroundColor = 0xff000000;
            _this._time = Date.now();
            return _this;
        }
        _create_class._(SpinnerShader, [
            {
                key: "radius",
                set: function set(v) {
                    this._radius = v;
                    this.redraw();
                }
            },
            {
                key: "width",
                set: function set(v) {
                    this._width = v;
                    this.redraw();
                }
            },
            {
                key: "period",
                set: function set(v) {
                    this._period = v;
                    this.redraw();
                }
            },
            {
                key: "angle",
                set: function set(v) {
                    this._angle = v;
                    this.redraw();
                }
            },
            {
                key: "smooth",
                set: function set(v) {
                    this._smooth = v;
                    this.redraw();
                }
            },
            {
                key: "color",
                set: function set(v) {
                    this._color = v;
                    this.redraw();
                }
            },
            {
                key: "backgroundColor",
                set: function set(v) {
                    this._backgroundColor = v;
                    this.redraw();
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(SpinnerShader.prototype), "setupUniforms", this).call(this, operation);
                    var owner = operation.shaderOwner;
                    this._setUniform("iTime", Date.now() - this._time, this.gl.uniform1f);
                    var renderPrecision = this.ctx.stage.getRenderPrecision();
                    this._setUniform("radius", this._radius * renderPrecision, this.gl.uniform1f);
                    this._setUniform("width", this._width * renderPrecision, this.gl.uniform1f);
                    this._setUniform("period", this._period, this.gl.uniform1f);
                    this._setUniform("angle", this._angle, this.gl.uniform1f);
                    this._setUniform("smooth", this._smooth, this.gl.uniform1f);
                    this._setUniform("color", new Float32Array(StageUtils.getRgbaComponentsNormalized(this._color)), this.gl.uniform4fv);
                    this._setUniform("backgroundColor", new Float32Array(StageUtils.getRgbaComponentsNormalized(this._backgroundColor)), this.gl.uniform4fv);
                    this._setUniform("resolution", new Float32Array([
                        owner._w * renderPrecision,
                        owner._h * renderPrecision
                    ]), this.gl.uniform2fv);
                    this.redraw();
                }
            }
        ]);
        return SpinnerShader;
    }(DefaultShader);
    SpinnerShader.vertexShaderSource = DefaultShader.vertexShaderSource;
    SpinnerShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n\n    uniform float iTime;\n    uniform float radius;\n    uniform float width;\n    uniform float period;\n    uniform float angle;\n    uniform float smooth;\n    uniform vec2 resolution;\n\n    uniform vec4 color;\n    uniform vec4 backgroundColor;\n\n    float ratio = resolution.y / resolution.x;\n\n    vec2 transpose_pos(vec2 pos) {\n        if (ratio < 1.) {\n            float diff = 0.5 - pos.x;\n            pos.x = 0.5 - diff / ratio;\n        } else {\n            float diff = 0.5 - pos.y;\n            pos.y = 0.5 - diff * ratio;\n        }\n        return pos;\n    }\n\n    float get_angle(vec2 pos) {\n        pos = transpose_pos(pos);\n        float a = atan(pos.y - 0.5, pos.x - 0.5);\n        a = (1.0+a/3.14159)/2.0;\n        \n        return a;\n    }\n\n    float dist(vec2 pos1, vec2 pos2) {\n        pos1 = transpose_pos(pos1);\n        return distance(pos1, pos2);\n    }\n\n    void main()\n    {\n        vec2 fragCoord = vTextureCoord;\n        vec4 fragColor = vColor;\n        \n        vec2 st = vTextureCoord;\n        float pct = dist(st, vec2(0.5));\n\n        float a = get_angle(st);\n        float t = iTime / 1000.0 / period;\n\n        float inner = max((radius - width) / resolution.x, (radius - width) / resolution.y);\n        float outer = max(radius / resolution.x, radius / resolution.y);\n\n        float x1 = mod(t, 1.0);\n        float x2 = mod(t + angle, 1.0);\n\n        if (x1 < x2) {\n            if (a > x1 && a < x2) {\n                float val = (1.0 - (x2 - a) / angle) * smoothstep(0.0, 3. * smooth, (x2 - a));\n                fragColor = mix(backgroundColor, color, val);\n            } else {\n                fragColor = backgroundColor;\n            }\n        } else {\n            if (a < x2) {\n                float val = (1.0 - (x2 - a) / angle) * smoothstep(0.0, 3. * smooth, (x2 - a));\n                fragColor = mix(backgroundColor, color, val);\n            } else if (a > x1) {\n                float val = (1.0 - (1.0 + x2 - a) / angle) * smoothstep(0.0, 3. * smooth, (1.0 + x2 - a));\n                fragColor = mix(backgroundColor, color, val);\n            } else {\n                fragColor = backgroundColor;\n            }\n        }\n\n        float s = smoothstep(inner, inner + smooth + 0.00001, pct) * (1.0 - smoothstep(outer, outer + smooth + 0.00001, pct));\n        gl_FragColor = texture2D(uSampler, fragCoord) * vColor * (1. - s * fragColor.a) + fragColor * s;\n    }\n";
    var HoleShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(HoleShader, DefaultShader);
        var _super = _create_super._(HoleShader);
        function HoleShader(context) {
            _class_call_check._(this, HoleShader);
            var _this;
            _this = _super.call(this, context);
            _this._x = 0;
            _this._y = 0;
            _this._w = 0;
            _this._h = 0;
            _this._radius = 0;
            return _this;
        }
        _create_class._(HoleShader, [
            {
                key: "x",
                get: function get() {
                    return this._x;
                },
                set: function set(v) {
                    this._x = v;
                    this.redraw();
                }
            },
            {
                key: "y",
                get: function get() {
                    return this._y;
                },
                set: function set(v) {
                    this._y = v;
                    this.redraw();
                }
            },
            {
                key: "w",
                get: function get() {
                    return this._w;
                },
                set: function set(v) {
                    this._w = v;
                    this.redraw();
                }
            },
            {
                key: "h",
                get: function get() {
                    return this._h;
                },
                set: function set(v) {
                    this._h = v;
                    this.redraw();
                }
            },
            {
                key: "radius",
                get: function get() {
                    return this._radius;
                },
                set: function set(v) {
                    this._radius = v;
                    this.redraw();
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(HoleShader.prototype), "setupUniforms", this).call(this, operation);
                    var owner = operation.shaderOwner;
                    var renderPrecision = this.ctx.stage.getRenderPrecision();
                    this._setUniform("x", this._x * renderPrecision, this.gl.uniform1f);
                    this._setUniform("y", this._y * renderPrecision, this.gl.uniform1f);
                    this._setUniform("w", this._w * renderPrecision, this.gl.uniform1f);
                    this._setUniform("h", this._h * renderPrecision, this.gl.uniform1f);
                    this._setUniform("radius", (this._radius + .5) * renderPrecision, this.gl.uniform1f);
                    this._setUniform("resolution", new Float32Array([
                        owner._w * renderPrecision,
                        owner._h * renderPrecision
                    ]), this.gl.uniform2fv);
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._x === 0 && this._y === 0 && this._w === 0 && this._h === 0;
                }
            }
        ]);
        return HoleShader;
    }(DefaultShader);
    HoleShader.vertexShaderSource = DefaultShader.vertexShaderSource;
    HoleShader.fragmentShaderSource = "\n   #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform float x;\n    uniform float y;\n    uniform float w;\n    uniform float h;\n    uniform vec2 resolution;\n    uniform float radius;\n\n    float roundBox(vec2 p, vec2 b, float r) {\n        float d = length(max(abs(p)-b+r, 0.1))-r;\n        return smoothstep(1.0, 0.0, d);\n    }\n\n    void main(void){\n        vec4 color = texture2D(uSampler, vTextureCoord);\n        vec2 pos = vTextureCoord.xy * resolution - vec2(x, y) - vec2(w, h) / 2.0;\n        vec2 size = vec2(w, h) / 2.0;\n        float b = roundBox(pos, size, radius);\n        gl_FragColor = mix(color, vec4(0.0), b);\n    }\n";
    var RadialGradientShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(RadialGradientShader, DefaultShader);
        var _super = _create_super._(RadialGradientShader);
        function RadialGradientShader(context) {
            _class_call_check._(this, RadialGradientShader);
            var _this;
            _this = _super.call(this, context);
            _this._pivot = [
                0,
                0
            ];
            _this._ic = 0xffffffff;
            _this._normalizedIC = _this._getNormalizedColor(_this._ic);
            _this._oc = 0x00ffffff;
            _this._normalizedOC = _this._getNormalizedColor(_this._oc);
            _this._radius = 0;
            return _this;
        }
        _create_class._(RadialGradientShader, [
            {
                key: "radiusX",
                get: function get() {
                    return this._radius;
                },
                set: function set(v) {
                    this.radius = v;
                }
            },
            {
                key: "radiusY",
                get: function get() {
                    return this._radiusY;
                },
                set: function set(v) {
                    this._radiusY = v;
                    this.redraw();
                }
            },
            {
                key: "radius",
                set: function set(v) {
                    this._radius = v;
                    this.redraw();
                }
            },
            {
                key: "innerColor",
                get: function get() {
                    return this._ic;
                },
                set: function set(argb) {
                    this._ic = argb;
                    this._normalizedIC = this._getNormalizedColor(argb);
                    this.redraw();
                }
            },
            {
                key: "outerColor",
                get: function get() {
                    return this._ic;
                },
                set: function set(argb) {
                    this._oc = argb;
                    this._normalizedOC = this._getNormalizedColor(argb);
                    this.redraw();
                }
            },
            {
                key: "color",
                get: function get() {
                    return this.innerColor;
                },
                set: function set(argb) {
                    this.innerColor = argb;
                }
            },
            {
                key: "x",
                set: function set(f) {
                    this._x = f;
                    this.redraw();
                }
            },
            {
                key: "y",
                set: function set(f) {
                    this._y = f;
                    this.redraw();
                }
            },
            {
                key: "pivot",
                get: function get() {
                    return this._pivot[0];
                },
                set: function set(v) {
                    if (Array.isArray(v) && v.length === 2) {
                        this._pivot = v;
                    } else if (Array.isArray(v)) {
                        this._pivot = [
                            v[0],
                            v[1] || v[0]
                        ];
                    } else {
                        this._pivot = [
                            v,
                            v
                        ];
                    }
                    this.redraw();
                }
            },
            {
                key: "pivotY",
                get: function get() {
                    return this._pivot[1];
                },
                set: function set(f) {
                    this._pivot[1] = f;
                    this.redraw();
                }
            },
            {
                key: "pivotX",
                get: function get() {
                    return this._pivot[0];
                },
                set: function set(f) {
                    this._pivot[0] = f;
                    this.redraw();
                }
            },
            {
                key: "_getNormalizedColor",
                value: function _getNormalizedColor(color) {
                    var col = StageUtils.getRgbaComponentsNormalized(color);
                    col[0] *= col[3];
                    col[1] *= col[3];
                    col[2] *= col[3];
                    return new Float32Array(col);
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(RadialGradientShader.prototype), "setupUniforms", this).call(this, operation);
                    var owner = operation.shaderOwner;
                    if (this._x) {
                        this._pivot[0] = this._x / owner.w;
                    }
                    if (this._y) {
                        this._pivot[1] = this._y / owner.h;
                    }
                    if (this._radius === 0) {
                        this._radius = owner.w * 0.5;
                    }
                    this._setUniform("innerColor", this._normalizedIC, this.gl.uniform4fv);
                    this._setUniform("fill", StageUtils.getRgbaComponentsNormalized(this._oc)[3], this.gl.uniform1f);
                    this._setUniform("outerColor", this._normalizedOC, this.gl.uniform4fv);
                    this._setUniform("pivot", new Float32Array(this._pivot), this.gl.uniform2fv);
                    this._setUniform("resolution", new Float32Array([
                        owner._w,
                        owner._h
                    ]), this.gl.uniform2fv);
                    this._setUniform("alpha", operation.getElementCore(0).renderContext.alpha, this.gl.uniform1f);
                    this._setUniform("radius", this._radius, this.gl.uniform1f);
                    this._setUniform("radiusY", this._radiusY || this._radius, this.gl.uniform1f);
                }
            }
        ]);
        return RadialGradientShader;
    }(DefaultShader);
    RadialGradientShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    \n    #define PI 3.14159265359\n    \n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec2 pivot;\n    uniform vec4 innerColor;\n    uniform vec4 outerColor;\n    uniform float radius;\n    uniform float radiusY;\n    uniform float alpha;\n    uniform float fill;\n    uniform float aspectRatio;\n    \n    void main() {\n        vec2 point = vTextureCoord.xy * resolution;\n        vec2 projection = vec2(pivot.x * resolution.x, pivot.y * resolution.y);\n        float d = length((point - projection) / vec2(radius * 2.0, radiusY * 2.0));\n        vec4 color = mix(texture2D(uSampler, vTextureCoord) * vColor, outerColor * alpha, fill);\n        gl_FragColor = mix(innerColor * alpha, color, smoothstep(0.0, 1.0, d));\n    }\n";
    var Light3dShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(Light3dShader, DefaultShader);
        var _super = _create_super._(Light3dShader);
        function Light3dShader(ctx) {
            _class_call_check._(this, Light3dShader);
            var _this;
            _this = _super.call(this, ctx);
            _this._strength = 0.5;
            _this._ambient = 0.5;
            _this._fudge = 0.4;
            _this._rx = 0;
            _this._ry = 0;
            _this._z = 0;
            _this._pivotX = NaN;
            _this._pivotY = NaN;
            _this._pivotZ = 0;
            _this._lightY = 0;
            _this._lightZ = 0;
            return _this;
        }
        _create_class._(Light3dShader, [
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(Light3dShader.prototype), "setupUniforms", this).call(this, operation);
                    var vr = operation.shaderOwner;
                    var element = vr.element;
                    var pivotX = isNaN(this._pivotX) ? element.pivotX * vr.w : this._pivotX;
                    var pivotY = isNaN(this._pivotY) ? element.pivotY * vr.h : this._pivotY;
                    var coords = vr.getRenderTextureCoords(pivotX, pivotY);
                    var rz = -Math.atan2(vr._renderContext.tc, vr._renderContext.ta);
                    var gl = this.gl;
                    this._setUniform("pivot", new Float32Array([
                        coords[0],
                        coords[1],
                        this._pivotZ
                    ]), gl.uniform3fv);
                    this._setUniform("rot", new Float32Array([
                        this._rx,
                        this._ry,
                        rz
                    ]), gl.uniform3fv);
                    this._setUniform("z", this._z, gl.uniform1f);
                    this._setUniform("lightY", this.lightY, gl.uniform1f);
                    this._setUniform("lightZ", this.lightZ, gl.uniform1f);
                    this._setUniform("strength", this._strength, gl.uniform1f);
                    this._setUniform("ambient", this._ambient, gl.uniform1f);
                    this._setUniform("fudge", this._fudge, gl.uniform1f);
                }
            },
            {
                key: "strength",
                get: function get() {
                    return this._strength;
                },
                set: function set(v) {
                    this._strength = v;
                    this.redraw();
                }
            },
            {
                key: "ambient",
                get: function get() {
                    return this._ambient;
                },
                set: function set(v) {
                    this._ambient = v;
                    this.redraw();
                }
            },
            {
                key: "fudge",
                get: function get() {
                    return this._fudge;
                },
                set: function set(v) {
                    this._fudge = v;
                    this.redraw();
                }
            },
            {
                key: "rx",
                get: function get() {
                    return this._rx;
                },
                set: function set(v) {
                    this._rx = v;
                    this.redraw();
                }
            },
            {
                key: "ry",
                get: function get() {
                    return this._ry;
                },
                set: function set(v) {
                    this._ry = v;
                    this.redraw();
                }
            },
            {
                key: "z",
                get: function get() {
                    return this._z;
                },
                set: function set(v) {
                    this._z = v;
                    this.redraw();
                }
            },
            {
                key: "pivotX",
                get: function get() {
                    return this._pivotX;
                },
                set: function set(v) {
                    this._pivotX = v + 1;
                    this.redraw();
                }
            },
            {
                key: "pivotY",
                get: function get() {
                    return this._pivotY;
                },
                set: function set(v) {
                    this._pivotY = v + 1;
                    this.redraw();
                }
            },
            {
                key: "lightY",
                get: function get() {
                    return this._lightY;
                },
                set: function set(v) {
                    this._lightY = v;
                    this.redraw();
                }
            },
            {
                key: "pivotZ",
                get: function get() {
                    return this._pivotZ;
                },
                set: function set(v) {
                    this._pivotZ = v;
                    this.redraw();
                }
            },
            {
                key: "lightZ",
                get: function get() {
                    return this._lightZ;
                },
                set: function set(v) {
                    this._lightZ = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._rx === 0 && this._ry === 0 && this._z === 0 && this._strength === 0 && this._ambient === 1;
                }
            }
        ]);
        return Light3dShader;
    }(DefaultShader);
    Light3dShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform float fudge;\n    uniform float strength;\n    uniform float ambient;\n    uniform float z;\n    uniform float lightY;\n    uniform float lightZ;\n    uniform vec3 pivot;\n    uniform vec3 rot;\n    varying vec3 pos;\n\n    void main(void) {\n        pos = vec3(aVertexPosition.xy, z);\n        \n        pos -= pivot;\n        \n        // Undo XY rotation\n        mat2 iRotXy = mat2( cos(rot.z), sin(rot.z), \n                           -sin(rot.z), cos(rot.z));\n        pos.xy = iRotXy * pos.xy;\n        \n        // Perform 3d rotations\n        gl_Position.x = cos(rot.x) * pos.x - sin(rot.x) * pos.z;\n        gl_Position.y = pos.y;\n        gl_Position.z = sin(rot.x) * pos.x + cos(rot.x) * pos.z;\n        \n        pos.x = gl_Position.x;\n        pos.y = cos(rot.y) * gl_Position.y - sin(rot.y) * gl_Position.z;\n        pos.z = sin(rot.y) * gl_Position.y + cos(rot.y) * gl_Position.z;\n        \n        // Redo XY rotation\n        iRotXy[0][1] = -iRotXy[0][1];\n        iRotXy[1][0] = -iRotXy[1][0];\n        pos.xy = iRotXy * pos.xy; \n\n        // Undo translate to pivot position\n        pos.xyz += pivot;\n\n        pos = vec3(pos.x * projection.x - 1.0, pos.y * -abs(projection.y) + 1.0, pos.z * projection.x);\n        \n        // Set depth perspective\n        float perspective = 1.0 + fudge * pos.z;\n\n        pos.z += lightZ * projection.x;\n\n        // Map coords to gl coordinate space.\n        // Set z to 0 because we don't want to perform z-clipping\n        gl_Position = vec4(pos.xy, 0.0, perspective);\n\n        // Correct light source position.\n        pos.y += lightY * abs(projection.y);\n\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        \n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    Light3dShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    varying vec3 pos;\n    uniform sampler2D uSampler;\n    uniform float ambient;\n    uniform float strength;\n    void main(void){\n        vec4 rgba = texture2D(uSampler, vTextureCoord);\n        float d = length(pos);\n        float n = 1.0 / max(0.1, d);\n        rgba.rgb = rgba.rgb * (strength * n + ambient);\n        gl_FragColor = rgba * vColor;\n    }\n";
    var PerspectiveShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(PerspectiveShader, DefaultShader);
        var _super = _create_super._(PerspectiveShader);
        function PerspectiveShader(ctx) {
            _class_call_check._(this, PerspectiveShader);
            var _this;
            _this = _super.call(this, ctx);
            _this._fudge = 0.2;
            _this._rx = 0;
            _this._ry = 0;
            _this._z = 1.0;
            return _this;
        }
        _create_class._(PerspectiveShader, [
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(PerspectiveShader.prototype), "setupUniforms", this).call(this, operation);
                    var vr = operation.shaderOwner;
                    var element = vr.element;
                    var pivotX = element.pivotX * vr.w;
                    var pivotY = element.pivotY * vr.h;
                    var coords = vr.getRenderTextureCoords(pivotX, pivotY);
                    var rz = -Math.atan2(vr._renderContext.tc, vr._renderContext.ta);
                    var gl = this.gl;
                    this._setUniform("pivot", new Float32Array([
                        coords[0],
                        coords[1],
                        0
                    ]), gl.uniform3fv);
                    this._setUniform("rot", new Float32Array([
                        this._rx,
                        this._ry,
                        rz
                    ]), gl.uniform3fv);
                    this._setUniform("z", this._z, gl.uniform1f);
                    this._setUniform("fudge", this._fudge, gl.uniform1f);
                }
            },
            {
                key: "fudge",
                get: function get() {
                    return this._fudge;
                },
                set: function set(v) {
                    this._fudge = v;
                    this.redraw();
                }
            },
            {
                key: "rx",
                get: function get() {
                    return this._rx;
                },
                set: function set(v) {
                    this._rx = v;
                    this.redraw();
                }
            },
            {
                key: "ry",
                get: function get() {
                    return this._ry;
                },
                set: function set(v) {
                    this._ry = v;
                    this.redraw();
                }
            },
            {
                key: "z",
                get: function get() {
                    return this._z;
                },
                set: function set(v) {
                    this._z = v;
                    this.redraw();
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._rx === 0 && this._ry === 0 && this._z === 0;
                }
            }
        ]);
        return PerspectiveShader;
    }(DefaultShader);
    PerspectiveShader.vertexShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    attribute vec2 aVertexPosition;\n    attribute vec2 aTextureCoord;\n    attribute vec4 aColor;\n    uniform vec2 projection;\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n\n    uniform float z;\n    uniform vec3 pivot;\n    uniform vec3 rot;\n    varying vec3 pos;\n\n    void main(void) {\n        pos = vec3(aVertexPosition.xy, z);\n        \n        pos -= pivot;\n        \n        // Undo XY rotation\n        mat2 iRotXy = mat2( cos(rot.z), sin(rot.z), \n                           -sin(rot.z), cos(rot.z));\n        pos.xy = iRotXy * pos.xy;\n        \n        // Perform 3d rotations\n        gl_Position.x = cos(rot.x) * pos.x - sin(rot.x) * pos.z;\n        gl_Position.y = pos.y;\n        gl_Position.z = sin(rot.x) * pos.x + cos(rot.x) * pos.z;\n        \n        pos.x = gl_Position.x;\n        pos.y = cos(rot.y) * gl_Position.y - sin(rot.y) * gl_Position.z;\n        pos.z = sin(rot.y) * gl_Position.y + cos(rot.y) * gl_Position.z;\n        \n        // Redo XY rotation\n        iRotXy[0][1] = -iRotXy[0][1];\n        iRotXy[1][0] = -iRotXy[1][0];\n        pos.xy = iRotXy * pos.xy; \n\n        // Undo translate to pivot position\n        pos.xyz += pivot;\n\n        pos = vec3(pos.x * projection.x - 1.0, pos.y * -abs(projection.y) + 1.0, pos.z * projection.x);\n        \n        // Map coords to gl coordinate space.\n        // Set z to 0 because we don't want to perform z-clipping\n        gl_Position = vec4(pos.xy, 0.0, z);\n\n        vTextureCoord = aTextureCoord;\n        vColor = aColor;\n        \n        gl_Position.y = -sign(projection.y) * gl_Position.y;\n    }\n";
    PerspectiveShader.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n\n    uniform vec3 rot;\n    uniform float fudge;\n\n    void main(void) {\n        vec2 coords = vTextureCoord;\n\n        coords.xy -= vec2(0.5);\n        coords.y = coords.y + (sign(rot[0]) * 0.5 - coords.x) * sin(rot[0]) * fudge * coords.y;\n        coords.x = coords.x + (sign(rot[1]) * 0.5 - coords.y) * sin(rot[1]) * fudge * coords.x;\n        coords.xy += vec2(0.5);\n\n        if (coords.x < 0.0 || coords.x > 1.0 || coords.y < 0.0 || coords.y > 1.0) {\n            gl_FragColor = vec4(0.0);\n        } else {\n            gl_FragColor = texture2D(uSampler, coords) * vColor;\n        }\n    }\n";
    var MagnifierShader = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(MagnifierShader, DefaultShader);
        var _super = _create_super._(MagnifierShader);
        function MagnifierShader(context) {
            _class_call_check._(this, MagnifierShader);
            var _this;
            _this = _super.call(this, context);
            _this._x = 0;
            _this._y = 0;
            _this._w = 0;
            _this._h = 0;
            _this._radius = 0;
            _this._magnification = 0.6;
            return _this;
        }
        _create_class._(MagnifierShader, [
            {
                key: "x",
                get: function get() {
                    return this._x;
                },
                set: function set(v) {
                    this._x = v;
                    this.redraw();
                }
            },
            {
                key: "y",
                get: function get() {
                    return this._y;
                },
                set: function set(v) {
                    this._y = v;
                    this.redraw();
                }
            },
            {
                key: "w",
                get: function get() {
                    return this._w;
                },
                set: function set(v) {
                    this._w = v;
                    this.redraw();
                }
            },
            {
                key: "h",
                get: function get() {
                    return this._h;
                },
                set: function set(v) {
                    this._h = v;
                    this.redraw();
                }
            },
            {
                key: "magnification",
                get: function get() {
                    return this._magnification;
                },
                set: function set(v) {
                    this._magnification = v;
                    this.redraw();
                }
            },
            {
                key: "radius",
                get: function get() {
                    return this._radius;
                },
                set: function set(v) {
                    this._radius = v;
                    this.redraw();
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(MagnifierShader.prototype), "setupUniforms", this).call(this, operation);
                    var owner = operation.shaderOwner;
                    var renderPrecision = this.ctx.stage.getRenderPrecision();
                    this._setUniform("x", this._x * renderPrecision, this.gl.uniform1f);
                    this._setUniform("y", this._y * renderPrecision, this.gl.uniform1f);
                    this._setUniform("w", this._w * renderPrecision, this.gl.uniform1f);
                    this._setUniform("h", this._h * renderPrecision, this.gl.uniform1f);
                    this._setUniform("magnification", this._magnification, this.gl.uniform1f);
                    this._setUniform("radius", (this._radius + 0.5) * renderPrecision, this.gl.uniform1f);
                    this._setUniform("resolution", new Float32Array([
                        owner._w * renderPrecision,
                        owner._h * renderPrecision
                    ]), this.gl.uniform2fv);
                }
            },
            {
                key: "useDefault",
                value: function useDefault() {
                    return this._w === 0 && this._h === 0;
                }
            }
        ]);
        return MagnifierShader;
    }(DefaultShader);
    MagnifierShader.vertexShaderSource = DefaultShader.vertexShaderSource;
    MagnifierShader.fragmentShaderSource = "\n	  #ifdef GL_ES\n		# ifdef GL_FRAGMENT_PRECISION_HIGH\n		precision highp float;\n		# else\n		precision lowp float;\n		# endif\n	  #endif\n\n	  varying vec2 vTextureCoord;\n	  varying vec4 vColor;\n	  uniform sampler2D uSampler;\n	  uniform float x;\n	  uniform float y;\n	  uniform float w;\n	  uniform float h;\n	  uniform vec2 resolution;\n	  uniform float radius;\n	  uniform float magnification;\n  \n	  float roundBox(vec2 p, vec2 b, float r) {\n		  float d = length(max(abs(p)-b+r, 0.1))-r;\n		  return smoothstep(1.0, 0.0, d);\n	  }\n\n	  float inside(vec2 v) {\n		vec2 s = step(vec2(0.0, 0.0), v) - step(vec2(1.0, 1.0), v);\n		return s.x * s.y;   \n      }\n  \n	  void main(void) {\n		vec4 color = texture2D(uSampler, vTextureCoord);\n		vec2 pos = vTextureCoord.xy * resolution - vec2(x, y) - vec2(w, h) / 2.0;\n		vec2 size = vec2(w, h) / 2.0;\n		float b = roundBox(pos, size, radius);\n		vec2 pos2 = (vTextureCoord.xy * magnification * resolution + vec2(x, y) * magnification) / resolution;\n		gl_FragColor = mix(color, texture2D(uSampler, pos2) * inside(pos2), b) * vColor;\n	  }\n  ";
    var SpinnerShader2 = /*#__PURE__*/ function(DefaultShader) {
        _inherits._(SpinnerShader2, DefaultShader);
        var _super = _create_super._(SpinnerShader2);
        function SpinnerShader2(context) {
            _class_call_check._(this, SpinnerShader2);
            var _this;
            _this = _super.call(this, context);
            _this._period = 1;
            _this._stroke = 0;
            _this._showDot = true;
            _this._clockwise = true;
            _this._bc = 0xff000000;
            _this._normalizedBC = _this._getNormalizedColor(_this._bc);
            _this._c = 0xffffffff;
            _this._normalizedC = _this._getNormalizedColor(_this._c);
            return _this;
        }
        _create_class._(SpinnerShader2, [
            {
                key: "radius",
                set: function set(v) {
                    if (v === 0) {
                        v = 1;
                    }
                    this._radius = v;
                }
            },
            {
                key: "stroke",
                get: function get() {
                    return this._stroke;
                },
                set: function set(value) {
                    this._stroke = Math.abs(value);
                }
            },
            {
                key: "color",
                get: function get() {
                    return this._c;
                },
                set: function set(argb) {
                    this._c = argb;
                    this._normalizedC = this._getNormalizedColor(argb);
                }
            },
            {
                key: "backgroundColor",
                get: function get() {
                    return this._sc;
                },
                set: function set(argb) {
                    this._bc = argb;
                    this._normalizedBC = this._getNormalizedColor(argb);
                }
            },
            {
                key: "showDot",
                get: function get() {
                    return this._showDot;
                },
                set: function set(bool) {
                    this._showDot = bool;
                }
            },
            {
                key: "clockwise",
                get: function get() {
                    return this._clockwise;
                },
                set: function set(bool) {
                    this._clockwise = bool;
                }
            },
            {
                key: "period",
                get: function get() {
                    return this._period;
                },
                set: function set(v) {
                    this._period = v;
                }
            },
            {
                key: "_getNormalizedColor",
                value: function _getNormalizedColor(color) {
                    var col = StageUtils.getRgbaComponentsNormalized(color);
                    col[0] *= col[3];
                    col[1] *= col[3];
                    col[2] *= col[3];
                    return new Float32Array(col);
                }
            },
            {
                key: "setupUniforms",
                value: function setupUniforms(operation) {
                    _get._(_get_prototype_of._(SpinnerShader2.prototype), "setupUniforms", this).call(this, operation);
                    var owner = operation.shaderOwner;
                    var radius = this._radius || owner._w / 2;
                    if (this._stroke === 0) {
                        this._stroke = radius * 0.33;
                    }
                    this._setUniform("resolution", new Float32Array([
                        owner._w,
                        owner._h
                    ]), this.gl.uniform2fv);
                    this._setUniform("color", this._normalizedC, this.gl.uniform4fv);
                    this._setUniform("backgroundColor", this._normalizedBC, this.gl.uniform4fv);
                    this._setUniform("stroke", this._stroke, this.gl.uniform1f);
                    this._setUniform("radius", radius, this.gl.uniform1f);
                    this._setUniform("direction", this._clockwise ? -1 : 1, this.gl.uniform1f);
                    this._setUniform("showDot", !!this._showDot, this.gl.uniform1f);
                    this._setUniform("time", Date.now() - SpinnerShader2.spinSync, this.gl.uniform1f);
                    this._setUniform("period", this._period, this.gl.uniform1f);
                    this._setUniform("alpha", operation.getElementCore(0).renderContext.alpha, this.gl.uniform1f);
                    if (this._sc !== this._bc || this._stroke !== radius * 0.5) {
                        this.redraw();
                    }
                }
            }
        ]);
        return SpinnerShader2;
    }(DefaultShader);
    SpinnerShader2.spinSync = Date.now();
    SpinnerShader2.fragmentShaderSource = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n    \n    #define PI 3.14159265359\n    \n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    \n    uniform sampler2D uSampler;\n    uniform vec2 resolution;\n    uniform vec4 color;\n    uniform vec4 backgroundColor;\n    uniform float direction;\n    uniform float radius;\n    uniform float time;\n    uniform float stroke;\n    uniform float showDot;\n    uniform float period;\n    uniform float alpha;\n    \n    float circleDist(vec2 p, float radius){\n        return length(p) - radius;\n    }\n    \n    float fillMask(float dist){\n        return clamp(-dist, 0.0, 1.0);\n    }\n    \n    void main() {\n        vec2 halfRes = 0.5 * resolution.xy;\n        vec2 center = vTextureCoord.xy * resolution - halfRes;\n        \n        float c = max(-circleDist(center, radius - stroke), circleDist(center, radius));\n        float rot = -(time / 1000.0 / period) * 6.0 * direction;\n        center *= mat2(cos(rot), sin(rot), -sin(rot), cos(rot));\n        \n        float a = direction * atan(center.x, center.y) * PI * 0.05 + 0.45;\n        \n        float strokeRad = stroke * 0.5;\n        a = mix(a, max(a, fillMask(circleDist(vec2(center.x, center.y + (radius - strokeRad)), strokeRad))), showDot);\n        vec4 base = mix(vec4(0.0), backgroundColor * alpha, fillMask(c));\n        gl_FragColor = mix(base, color * alpha, fillMask(c) * a);\n    }\n";
    var lightning = {
        Application: Application,
        Component: Component,
        Base: Base,
        Utils: Utils,
        StageUtils: StageUtils,
        Element: Element,
        Tools: Tools,
        Stage: Stage,
        ElementCore: ElementCore,
        ElementTexturizer: ElementTexturizer,
        Texture: Texture,
        EventEmitter: EventEmitter,
        shaders: {
            Grayscale: WebGLGrayscaleShader,
            BoxBlur: BoxBlurShader,
            Dithering: DitheringShader,
            CircularPush: CircularPushShader,
            Inversion: InversionShader,
            LinearBlur: LinearBlurShader,
            Outline: OutlineShader,
            Pixelate: PixelateShader,
            RadialFilter: RadialFilterShader,
            RoundedRectangle: RoundedRectangleShader,
            Spinner2: SpinnerShader2,
            FadeOut: FadeOutShader,
            Hole: HoleShader,
            Vignette: VignetteShader,
            Spinner: SpinnerShader,
            RadialGradient: RadialGradientShader,
            Light3d: Light3dShader,
            Perspective: PerspectiveShader,
            Magnifier: MagnifierShader,
            WebGLShader: WebGLShader,
            WebGLDefaultShader: DefaultShader,
            C2dShader: C2dShader,
            C2dDefaultShader: DefaultShader$1,
            c2d: {
                Grayscale: C2dGrayscaleShader,
                Blur: BlurShader
            }
        },
        textures: {
            RectangleTexture: RectangleTexture,
            NoiseTexture: NoiseTexture,
            TextTexture: TextTexture,
            ImageTexture: ImageTexture,
            HtmlTexture: HtmlTexture,
            StaticTexture: StaticTexture,
            StaticCanvasTexture: StaticCanvasTexture,
            SourceTexture: SourceTexture
        },
        components: {
            FastBlurComponent: FastBlurComponent,
            BloomComponent: BloomComponent,
            SmoothScaleComponent: SmoothScaleComponent,
            BorderComponent: BorderComponent,
            ListComponent: ListComponent
        },
        tools: {
            ObjMerger: ObjMerger,
            ObjectListProxy: ObjectListProxy,
            ObjectListWrapper: ObjectListWrapper
        }
    };
    if (Utils.isWeb) {
        window.lng = lightning;
    }
    return lightning;
});


/***/ }),

/***/ 29956:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Accessibility: function() {
        return _Accessibility.default;
    },
    Ads: function() {
        return _Ads.default;
    },
    AppData: function() {
        return _Application.AppData;
    },
    Application: function() {
        return _Application.default;
    },
    AudioPlayer: function() {
        return _AudioPlayer.default;
    },
    Colors: function() {
        return _Colors.default;
    },
    Img: function() {
        return _Img.default;
    },
    Keyboard: function() {
        return _Keyboard.default;
    },
    Language: function() {
        return _Language.default;
    },
    Launch: function() {
        return _Launch.default;
    },
    Lightning: function() {
        return _Lightning.default;
    },
    Locale: function() {
        return _Locale.default;
    },
    Log: function() {
        return _Log.default;
    },
    MediaPlayer: function() {
        return _MediaPlayer.default;
    },
    Metadata: function() {
        return _Metadata.default;
    },
    Metrics: function() {
        return _Metrics.default;
    },
    Pin: function() {
        return _Pin.default;
    },
    Profile: function() {
        return _Profile.default;
    },
    Purchase: function() {
        return _Purchase.default;
    },
    Registry: function() {
        return _Registry.default;
    },
    Router: function() {
        return _Router.default;
    },
    Settings: function() {
        return _Settings.default;
    },
    Storage: function() {
        return _Storage.default;
    },
    Subtitles: function() {
        return _Subtitles.default;
    },
    TV: function() {
        return _TV.default;
    },
    Utils: function() {
        return _Utils.default;
    },
    VideoPlayer: function() {
        return _VideoPlayer.default;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
var _Accessibility = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73434));
var _Ads = /*#__PURE__*/ _interop_require_default._(__webpack_require__(60214));
var _Application = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(92010));
var _AudioPlayer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70842));
var _Colors = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34713));
var _Img = /*#__PURE__*/ _interop_require_default._(__webpack_require__(93277));
var _Keyboard = /*#__PURE__*/ _interop_require_default._(__webpack_require__(33828));
var _Launch = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47450));
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var _Locale = /*#__PURE__*/ _interop_require_default._(__webpack_require__(13279));
var _Language = /*#__PURE__*/ _interop_require_default._(__webpack_require__(57643));
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _MediaPlayer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73901));
var _Metrics = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83417));
var _Pin = /*#__PURE__*/ _interop_require_default._(__webpack_require__(68751));
var _Profile = /*#__PURE__*/ _interop_require_default._(__webpack_require__(18166));
var _Purchase = /*#__PURE__*/ _interop_require_default._(__webpack_require__(59183));
var _Registry = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8604));
var _Router = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6078));
var _Settings = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52452));
var _Storage = /*#__PURE__*/ _interop_require_default._(__webpack_require__(58684));
var _TV = /*#__PURE__*/ _interop_require_default._(__webpack_require__(5669));
var _Utils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50509));
var _VideoPlayer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(89944));
var _Metadata = /*#__PURE__*/ _interop_require_default._(__webpack_require__(60787));
var _Subtitles = /*#__PURE__*/ _interop_require_default._(__webpack_require__(27277));


/***/ }),

/***/ 90548:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* global SpeechSynthesisErrorEvent */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
function flattenStrings() {
    var series = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var flattenedSeries = [];
    for(var i = 0; i < series.length; i++){
        if (typeof series[i] === "string" && !series[i].includes("PAUSE-")) {
            flattenedSeries.push(series[i]);
        } else {
            break;
        }
    }
    // add a "word boundary" to ensure the Announcer doesn't automatically try to
    // interpret strings that look like dates but are not actually dates
    // for example, if "Rising Sun" and "1993" are meant to be two separate lines,
    // when read together, "Sun 1993" is interpretted as "Sunday 1993"
    return [
        flattenedSeries.join(",\b ")
    ].concat(series.slice(i));
}
function delay(pause) {
    return new Promise(function(resolve) {
        setTimeout(resolve, pause);
    });
}
/**
 * Speak a string
 *
 * @param {string} phrase Phrase to speak
 * @param {SpeechSynthesisUtterance[]} utterances An array which the new SpeechSynthesisUtterance instance representing this utterance will be appended
 * @return {Promise<void>} Promise resolved when the utterance has finished speaking, and rejected if there's an error
 */ function speak(phrase, utterances) {
    var lang = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en-US";
    var synth = window.speechSynthesis;
    return new Promise(function(resolve, reject) {
        var utterance = new SpeechSynthesisUtterance(phrase);
        utterance.lang = lang;
        utterance.onend = function() {
            resolve();
        };
        utterance.onerror = function(e) {
            reject(e);
        };
        utterances.push(utterance);
        synth.speak(utterance);
    });
}
function speakSeries(series, lang) {
    var root = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var synth = window.speechSynthesis;
    var remainingPhrases = flattenStrings(Array.isArray(series) ? series : [
        series
    ]);
    var nestedSeriesResults = [];
    /*
    We hold this array of SpeechSynthesisUtterances in order to prevent them from being
    garbage collected prematurely on STB hardware which can cause the 'onend' events of
    utterances to not fire consistently.
  */ var utterances = [];
    var active = true;
    var seriesChain = _async_to_generator._(function() {
        var phrase, pause, totalRetries, retriesLeft, e, seriesResult, seriesResult1;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        ,
                        23,
                        24
                    ]);
                    _state.label = 1;
                case 1:
                    if (!(active && remainingPhrases.length)) return [
                        3,
                        22
                    ];
                    return [
                        4,
                        Promise.resolve(remainingPhrases.shift())
                    ];
                case 2:
                    phrase = _state.sent();
                    if (!!active) return [
                        3,
                        3
                    ];
                    // Exit
                    // Need to check this after the await in case it was cancelled in between
                    return [
                        3,
                        22
                    ];
                case 3:
                    if (!(typeof phrase === "string" && phrase.includes("PAUSE-"))) return [
                        3,
                        5
                    ];
                    // Pause it
                    pause = phrase.split("PAUSE-")[1] * 1000;
                    if (isNaN(pause)) {
                        pause = 0;
                    }
                    return [
                        4,
                        delay(pause)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        21
                    ];
                case 5:
                    if (!(typeof phrase === "string" && phrase.length)) return [
                        3,
                        17
                    ];
                    // Speak it
                    totalRetries = 3;
                    retriesLeft = totalRetries;
                    _state.label = 6;
                case 6:
                    if (!(active && retriesLeft > 0)) return [
                        3,
                        16
                    ];
                    _state.label = 7;
                case 7:
                    _state.trys.push([
                        7,
                        9,
                        ,
                        15
                    ]);
                    return [
                        4,
                        speak(phrase, utterances, lang)
                    ];
                case 8:
                    _state.sent();
                    retriesLeft = 0;
                    return [
                        3,
                        15
                    ];
                case 9:
                    e = _state.sent();
                    if (!(e instanceof SpeechSynthesisErrorEvent)) return [
                        3,
                        13
                    ];
                    if (!(e.error === "network")) return [
                        3,
                        11
                    ];
                    retriesLeft--;
                    console.warn("Speech synthesis network error. Retries left: ".concat(retriesLeft));
                    return [
                        4,
                        delay(500 * (totalRetries - retriesLeft))
                    ];
                case 10:
                    _state.sent();
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (e.error === "canceled" || e.error === "interrupted") {
                        // Cancel or interrupt error (ignore)
                        retriesLeft = 0;
                    } else {
                        throw new Error("SpeechSynthesisErrorEvent: ".concat(e.error));
                    }
                    _state.label = 12;
                case 12:
                    return [
                        3,
                        14
                    ];
                case 13:
                    throw e;
                case 14:
                    return [
                        3,
                        15
                    ];
                case 15:
                    return [
                        3,
                        6
                    ];
                case 16:
                    return [
                        3,
                        21
                    ];
                case 17:
                    if (!(typeof phrase === "function")) return [
                        3,
                        19
                    ];
                    seriesResult = speakSeries(phrase(), lang, false);
                    nestedSeriesResults.push(seriesResult);
                    return [
                        4,
                        seriesResult.series
                    ];
                case 18:
                    _state.sent();
                    return [
                        3,
                        21
                    ];
                case 19:
                    if (!Array.isArray(phrase)) return [
                        3,
                        21
                    ];
                    // Speak it (recursively)
                    seriesResult1 = speakSeries(phrase, lang, false);
                    nestedSeriesResults.push(seriesResult1);
                    return [
                        4,
                        seriesResult1.series
                    ];
                case 20:
                    _state.sent();
                    _state.label = 21;
                case 21:
                    return [
                        3,
                        1
                    ];
                case 22:
                    return [
                        3,
                        24
                    ];
                case 23:
                    active = false;
                    return [
                        7
                    ];
                case 24:
                    return [
                        2
                    ];
            }
        });
    })();
    return {
        series: seriesChain,
        get active () {
            return active;
        },
        append: function(toSpeak) {
            remainingPhrases.push(toSpeak);
        },
        cancel: function() {
            if (!active) {
                return;
            }
            if (root) {
                synth.cancel();
            }
            nestedSeriesResults.forEach(function(nestedSeriesResults) {
                nestedSeriesResults.cancel();
            });
            active = false;
        }
    };
}
var currentSeries;
function _default(toSpeak, lang) {
    currentSeries && currentSeries.cancel();
    currentSeries = speakSeries(toSpeak, lang);
    return currentSeries;
}


/***/ }),

/***/ 50858:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
var _Speech = /*#__PURE__*/ _interop_require_default._(__webpack_require__(90548));
var _utils = __webpack_require__(5904);
var resetFocusPathTimer;
var prevFocusPath = [];
var currentlySpeaking;
var voiceOutDisabled = false;
var fiveMinutes = 300000;
function onFocusChangeCore() {
    var focusPath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (!Announcer.enabled) {
        return;
    }
    var loaded = focusPath.every(function(elm) {
        return !elm.loading;
    });
    var focusDiff = focusPath.filter(function(elm) {
        return !prevFocusPath.includes(elm);
    });
    resetFocusPathTimer();
    if (!loaded) {
        Announcer.onFocusChange();
        return;
    }
    prevFocusPath = focusPath.slice(0);
    var toAnnounceText = [];
    var toAnnounce = focusDiff.reduce(function(acc, elm) {
        if (elm.announce) {
            acc.push([
                (0, _utils.getElmName)(elm),
                "Announce",
                elm.announce
            ]);
            toAnnounceText.push(elm.announce);
        } else if (elm.title) {
            acc.push([
                (0, _utils.getElmName)(elm),
                "Title",
                elm.title
            ]);
            toAnnounceText.push(elm.title);
        }
        return acc;
    }, []);
    focusDiff.reverse().reduce(function(acc, elm) {
        if (elm.announceContext) {
            acc.push([
                (0, _utils.getElmName)(elm),
                "Context",
                elm.announceContext
            ]);
            toAnnounceText.push(elm.announceContext);
        } else {
            acc.push([
                (0, _utils.getElmName)(elm),
                "No Context",
                ""
            ]);
        }
        return acc;
    }, toAnnounce);
    if (Announcer.debug) {
        console.table(toAnnounce);
    }
    if (toAnnounceText.length) {
        return Announcer.speak(toAnnounceText.reduce(function(acc, val) {
            return acc.concat(val);
        }, []));
    }
}
function textToSpeech(toSpeak) {
    if (voiceOutDisabled) {
        return;
    }
    return currentlySpeaking = (0, _Speech.default)(toSpeak);
}
var Announcer = {
    enabled: true,
    debug: false,
    cancel: function cancel() {
        currentlySpeaking && currentlySpeaking.cancel();
    },
    clearPrevFocus: function clearPrevFocus() {
        var depth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        prevFocusPath = prevFocusPath.slice(0, depth);
        resetFocusPathTimer();
    },
    speak: function speak(text) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_append = _ref.append, append = _ref_append === void 0 ? false : _ref_append, _ref_notification = _ref.notification, notification = _ref_notification === void 0 ? false : _ref_notification;
        if (Announcer.enabled) {
            Announcer.onFocusChange.flush();
            if (append && currentlySpeaking && currentlySpeaking.active) {
                currentlySpeaking.append(text);
            } else {
                Announcer.cancel();
                textToSpeech(text);
            }
            if (notification) {
                voiceOutDisabled = true;
                currentlySpeaking.series.finally(function() {
                    voiceOutDisabled = false;
                    Announcer.refresh();
                });
            }
        }
        return currentlySpeaking;
    },
    setupTimers: function setupTimers() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_focusDebounce = _ref.focusDebounce, focusDebounce = _ref_focusDebounce === void 0 ? 400 : _ref_focusDebounce, _ref_focusChangeTimeout = _ref.focusChangeTimeout, focusChangeTimeout = _ref_focusChangeTimeout === void 0 ? fiveMinutes : _ref_focusChangeTimeout;
        Announcer.onFocusChange = (0, _utils.debounce)(onFocusChangeCore, focusDebounce);
        resetFocusPathTimer = (0, _utils.debounce)(function() {
            // Reset focus path for full announce
            prevFocusPath = [];
        }, focusChangeTimeout);
    }
};
Announcer.setupTimers();
var _default = Announcer;


/***/ }),

/***/ 5904:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Code from: https://github.com/jashkenas/underscore is
 * Copyright (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
 * Licensed under the MIT License based off:
 * http://unscriptable.com/2009/03/20/debouncing-javascript-methods/ which is:
 * Copyright (c) 2007-2009 unscriptable.com and John M. Hann
 * Licensed under the MIT License (with X11 advertising exception)
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    debounce: function() {
        return debounce;
    },
    getElmName: function() {
        return getElmName;
    }
});
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
function getElmName(elm) {
    return elm.ref || elm.constructor.name;
}
function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) {
            timeout = setTimeout(later, wait - last);
        } else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function debounced() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}


/***/ }),

/***/ 73434:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _shaders = __webpack_require__(95229);
var _Announcer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50858));
var _default = {
    Announcer: _Announcer.default,
    colorshift: function(component) {
        var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
            brightness: 50,
            contrast: 50,
            gamma: 50
        };
        config = _object_spread._({}, {
            brightness: 50,
            contrast: 50,
            gamma: 50
        }, config);
        var shader = type && (0, _shaders.colorshiftShader)(type);
        if (shader) {
            _Log.default.info("Accessibility Colorshift", type, config);
            component.rtt = true;
            component.shader = _object_spread._({
                type: shader
            }, config);
        } else {
            _Log.default.info("Accessibility Colorshift", "Disabled");
            component.rtt = false;
            component.shader = null;
        }
    }
};


/***/ }),

/***/ 41001:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return ColorShift;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var ColorShift = /*#__PURE__*/ function(_Lightning_shaders_WebGLDefaultShader) {
    "use strict";
    _inherits._(ColorShift, _Lightning_shaders_WebGLDefaultShader);
    var _super = _create_super._(ColorShift);
    function ColorShift() {
        _class_call_check._(this, ColorShift);
        return _super.apply(this, arguments);
    }
    _create_class._(ColorShift, [
        {
            key: "brightness",
            set: function set(v) {
                this._brightness = (v - 50) / 100;
                this.redraw();
            }
        },
        {
            key: "contrast",
            set: function set(v) {
                this._contrast = (v + 50) / 100;
                this.redraw();
            }
        },
        {
            key: "gamma",
            set: function set(v) {
                this._gamma = (v + 50) / 100;
                this.redraw();
            }
        },
        {
            key: "setupUniforms",
            value: function setupUniforms(operation) {
                _get._(_get_prototype_of._(ColorShift.prototype), "setupUniforms", this).call(this, operation);
                var gl = this.gl;
                this._setUniform("colorAdjust", [
                    this._brightness || 0.0,
                    this._contrast || 1.0,
                    this._gamma || 1.0
                ], gl.uniform3fv);
            }
        }
    ]);
    return ColorShift;
}(_Lightning.default.shaders.WebGLDefaultShader);
ColorShift.before = "\n    #ifdef GL_ES\n    # ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp float;\n    # else\n    precision lowp float;\n    # endif\n    #endif\n        \n    varying vec2 vTextureCoord;\n    varying vec4 vColor;\n    uniform sampler2D uSampler;\n    uniform vec3 colorAdjust;\n    \n    const mat3 RGBtoOpponentMat = mat3(0.2814, -0.0971, -0.0930, 0.6938, 0.1458,-0.2529, 0.0638, -0.0250, 0.4665);\n    const mat3 OpponentToRGBMat = mat3(1.1677, 0.9014, 0.7214, -6.4315, 2.5970, 0.1257, -0.5044, 0.0159, 2.0517);    \n";
ColorShift.after = "    \n    vec3 brightnessContrast(vec3 value, float brightness, float contrast)\n    {\n        return (value - 0.5) * contrast + 0.5 + brightness;\n    }   \n    \n    vec3 updateGamma(vec3 value, float param)\n    {\n        return vec3(pow(abs(value.r), param),pow(abs(value.g), param),pow(abs(value.b), param));\n    } \n       \n    void main(void){\n        vec4 fragColor = texture2D(uSampler, vTextureCoord);        \n        vec4 color = filter(fragColor) * vColor;       \n        \n        vec3 bc = brightnessContrast(color.rgb,colorAdjust[0],colorAdjust[1]);        \n        vec3 ga = updateGamma(bc.rgb, colorAdjust[2]);  \n              \n        gl_FragColor = vec4(ga.rgb, color.a);          \n    }    \n";


/***/ }),

/***/ 69225:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return DeuteranopiaShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
var _ColorShift = /*#__PURE__*/ _interop_require_default._(__webpack_require__(41001));
var DeuteranopiaShader = /*#__PURE__*/ function(ColorShift) {
    "use strict";
    _inherits._(DeuteranopiaShader, ColorShift);
    var _super = _create_super._(DeuteranopiaShader);
    function DeuteranopiaShader() {
        _class_call_check._(this, DeuteranopiaShader);
        return _super.apply(this, arguments);
    }
    return DeuteranopiaShader;
}(_ColorShift.default);
DeuteranopiaShader.fragmentShaderSource = "\n    ".concat(_ColorShift.default.before, "\n    vec4 vision(vec4 color)\n    {\n        vec4 r = vec4( 0.43,  0.72, -0.15, 0.0 );\n        vec4 g = vec4( 0.34,  0.57,  0.09, 0.0 );\n        vec4 b = vec4(-0.02,  0.03,  1.00, 0.0 );\n       \n        return vec4(dot(color, r), dot(color, g), dot(color, b), color.a);	\n    }\n       \n    vec4 filter( vec4 color )\n    {   \n        vec3 opponentColor = RGBtoOpponentMat * vec3(color.r, color.g, color.b);\n        opponentColor.x -= opponentColor.y * 1.5; \n        vec3 rgbColor = OpponentToRGBMat * opponentColor;\n        return vision(vec4(rgbColor.r, rgbColor.g, rgbColor.b, color.a));    \n    }\n    ").concat(_ColorShift.default.after, "    \n");


/***/ }),

/***/ 71354:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return MonochromacyShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var _ColorShift = /*#__PURE__*/ _interop_require_default._(__webpack_require__(41001));
var MonochromacyShader = /*#__PURE__*/ function(ColorShift) {
    "use strict";
    _inherits._(MonochromacyShader, ColorShift);
    var _super = _create_super._(MonochromacyShader);
    function MonochromacyShader() {
        _class_call_check._(this, MonochromacyShader);
        return _super.apply(this, arguments);
    }
    return MonochromacyShader;
}(_ColorShift.default);
MonochromacyShader.fragmentShaderSource = "\n    ".concat(_ColorShift.default.before, "\n    vec4 filter( vec4 color )\n    {   \n        float grey = dot(color.rgb, vec3(0.299, 0.587, 0.114));\n        return vec4(vec3(grey, grey, grey), 1.0 ); \n    }\n    ").concat(_ColorShift.default.after, "\n");


/***/ }),

/***/ 54374:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return NeutralShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
var _ColorShift = /*#__PURE__*/ _interop_require_default._(__webpack_require__(41001));
var NeutralShader = /*#__PURE__*/ function(ColorShift) {
    "use strict";
    _inherits._(NeutralShader, ColorShift);
    var _super = _create_super._(NeutralShader);
    function NeutralShader() {
        _class_call_check._(this, NeutralShader);
        return _super.apply(this, arguments);
    }
    return NeutralShader;
}(_ColorShift.default);
NeutralShader.fragmentShaderSource = "\n    ".concat(_ColorShift.default.before, "\n    vec4 filter( vec4 color )\n    {\n        return color;\n    }\n    ").concat(_ColorShift.default.after, "\n");


/***/ }),

/***/ 9878:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return ProtanopiaShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _ColorShift = /*#__PURE__*/ _interop_require_default._(__webpack_require__(41001));
var ProtanopiaShader = /*#__PURE__*/ function(ColorShift) {
    "use strict";
    _inherits._(ProtanopiaShader, ColorShift);
    var _super = _create_super._(ProtanopiaShader);
    function ProtanopiaShader() {
        _class_call_check._(this, ProtanopiaShader);
        return _super.apply(this, arguments);
    }
    return ProtanopiaShader;
}(_ColorShift.default);
ProtanopiaShader.fragmentShaderSource = "\n    ".concat(_ColorShift.default.before, "    \n    vec4 vision(vec4 color)\n    {\n        vec4 r = vec4( 0.20,  0.99, -0.19, 0.0);\n        vec4 g = vec4( 0.16,  0.79,  0.04, 0.0);\n        vec4 b = vec4( 0.01, -0.01,  1.00, 0.0);\n       \n        return vec4(dot(color, r), dot(color, g), dot(color, b), color.a);	\n    }\n    \n    vec4 filter( vec4 color )\n    {   \n        vec3 opponentColor = RGBtoOpponentMat * vec3(color.r, color.g, color.b);\n        opponentColor.x -= opponentColor.y * 1.5; \n        vec3 rgbColor = OpponentToRGBMat * opponentColor;\n        return vision(vec4(rgbColor.r, rgbColor.g, rgbColor.b, color.a));      \n    }    \n    ").concat(_ColorShift.default.after, " \n");


/***/ }),

/***/ 68562:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return TritanopiaShader;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
var _ColorShift = /*#__PURE__*/ _interop_require_default._(__webpack_require__(41001));
var TritanopiaShader = /*#__PURE__*/ function(ColorShift) {
    "use strict";
    _inherits._(TritanopiaShader, ColorShift);
    var _super = _create_super._(TritanopiaShader);
    function TritanopiaShader() {
        _class_call_check._(this, TritanopiaShader);
        return _super.apply(this, arguments);
    }
    return TritanopiaShader;
}(_ColorShift.default);
TritanopiaShader.fragmentShaderSource = "\n    ".concat(_ColorShift.default.before, "    \n    vec4 vision(vec4 color)\n    {\n        vec4 r = vec4( 0.97,  0.11, -0.08, 0.0 );\n        vec4 g = vec4( 0.02,  0.82,  0.16, 0.0 );\n        vec4 b = vec4(-0.06,  0.88,  0.18, 0.0 );\n       \n        return vec4(dot(color, r), dot(color, g), dot(color, b), color.a);	\n    }   \n    \n    vec4 filter( vec4 color )\n    {   \n        vec3 opponentColor = RGBtoOpponentMat * vec3(color.r, color.g, color.b);\n        opponentColor.x -= ((3.0 * opponentColor.z) - opponentColor.y) * 0.25;\n        vec3 rgbColor = OpponentToRGBMat * opponentColor;\n        return vision(vec4(rgbColor.r, rgbColor.g, rgbColor.b, color.a));\n    }   \n    ").concat(_ColorShift.default.after, " \n");


/***/ }),

/***/ 95229:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "colorshiftShader", ({
    enumerable: true,
    get: function() {
        return colorshiftShader;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _ProtanopiaShader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(9878));
var _DeuteranopiaShader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(69225));
var _TritanopiaShader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(68562));
var _NormalShader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54374));
var _MonochromacyShader = /*#__PURE__*/ _interop_require_default._(__webpack_require__(71354));
var colorshiftShader = function(type) {
    var shadersMap = {
        normal: _NormalShader.default,
        monochromacy: _MonochromacyShader.default,
        deuteranopia: _DeuteranopiaShader.default,
        tritanopia: _TritanopiaShader.default,
        protanopia: _ProtanopiaShader.default
    };
    type = typeof type === "string" && type.toLowerCase() || null;
    return Object.keys(shadersMap).indexOf(type) > -1 ? shadersMap[type] : false;
};


/***/ }),

/***/ 60214:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initAds: function() {
        return initAds;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _sdk = __webpack_require__(42976);
var consumer;
var getAds = function() {
    // todo: enable some default ads during development, maybe from the settings.json
    return Promise.resolve({
        prerolls: [],
        midrolls: [],
        postrolls: []
    });
};
var initAds = function(config) {
    if (config.getAds) {
        getAds = config.getAds;
    }
};
var state = {
    active: false
};
var playSlot = function() {
    var slot = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return slot.reduce(function(promise, ad) {
        return promise.then(function() {
            return playAd(ad);
        });
    }, Promise.resolve(null));
};
var playAd = function(ad) {
    return new Promise(function(resolve) {
        if (state.active === false) {
            _Log.default.info("Ad", "Skipping add due to inactive state");
            return resolve();
        }
        // is it safe to rely on videoplayer plugin already created the video tag?
        var videoEl = document.getElementsByTagName("video")[0];
        videoEl.style.display = "block";
        videoEl.style.visibility = "visible";
        videoEl.src = (0, _sdk.mediaUrl)(ad.url);
        videoEl.load();
        var timeEvents = null;
        var timeout;
        var cleanup = function() {
            // remove all listeners
            Object.keys(handlers).forEach(function(handler) {
                return videoEl.removeEventListener(handler, handlers[handler]);
            });
            resolve();
        };
        var handlers = {
            play: function() {
                _Log.default.info("Ad", "Play ad", ad.url);
                fireOnConsumer("Play", ad);
                sendBeacon(ad.callbacks, "defaultImpression");
            },
            ended: function() {
                fireOnConsumer("Ended", ad);
                sendBeacon(ad.callbacks, "complete");
                cleanup();
            },
            timeupdate: function() {
                if (!timeEvents && videoEl.duration) {
                    // calculate when to fire the time based events (now that duration is known)
                    timeEvents = {
                        firstQuartile: videoEl.duration / 4,
                        midPoint: videoEl.duration / 2,
                        thirdQuartile: videoEl.duration / 4 * 3
                    };
                    _Log.default.info("Ad", "Calculated quartiles times", {
                        timeEvents: timeEvents
                    });
                }
                if (timeEvents && timeEvents.firstQuartile && videoEl.currentTime >= timeEvents.firstQuartile) {
                    fireOnConsumer("FirstQuartile", ad);
                    delete timeEvents.firstQuartile;
                    sendBeacon(ad.callbacks, "firstQuartile");
                }
                if (timeEvents && timeEvents.midPoint && videoEl.currentTime >= timeEvents.midPoint) {
                    fireOnConsumer("MidPoint", ad);
                    delete timeEvents.midPoint;
                    sendBeacon(ad.callbacks, "midPoint");
                }
                if (timeEvents && timeEvents.thirdQuartile && videoEl.currentTime >= timeEvents.thirdQuartile) {
                    fireOnConsumer("ThirdQuartile", ad);
                    delete timeEvents.thirdQuartile;
                    sendBeacon(ad.callbacks, "thirdQuartile");
                }
            },
            stalled: function() {
                fireOnConsumer("Stalled", ad);
                timeout = setTimeout(function() {
                    cleanup();
                }, 5000) // make timeout configurable
                ;
            },
            canplay: function() {
                timeout && clearTimeout(timeout);
            },
            error: function() {
                fireOnConsumer("Error", ad);
                cleanup();
            },
            // this doesn't work reliably on sky box, moved logic to timeUpdate event
            // loadedmetadata() {
            //   // calculate when to fire the time based events (now that duration is known)
            //   timeEvents = {
            //     firstQuartile: videoEl.duration / 4,
            //     midPoint: videoEl.duration / 2,
            //     thirdQuartile: (videoEl.duration / 4) * 3,
            //   }
            // },
            abort: function() {
                cleanup();
            }
        };
        // add all listeners
        Object.keys(handlers).forEach(function(handler) {
            return videoEl.addEventListener(handler, handlers[handler]);
        });
        videoEl.play();
    });
};
var sendBeacon = function(callbacks, event) {
    if (callbacks && callbacks[event]) {
        _Log.default.info("Ad", "Sending beacon", event, callbacks[event]);
        return callbacks[event].reduce(function(promise, url) {
            return promise.then(function() {
                return fetch(url)// always resolve, also in case of a fetch error (so we don't block firing the rest of the beacons for this event)
                // note: for fetch failed http responses don't throw an Error :)
                .then(function(response) {
                    if (response.status === 200) {
                        fireOnConsumer("Beacon" + event + "Sent");
                    } else {
                        fireOnConsumer("Beacon" + event + "Failed" + response.status);
                    }
                    Promise.resolve(null);
                }).catch(function() {
                    Promise.resolve(null);
                });
            });
        }, Promise.resolve(null));
    } else {
        _Log.default.info("Ad", "No callback found for " + event);
    }
};
var fireOnConsumer = function(event, args) {
    if (consumer) {
        consumer.fire("$ad" + event, args);
        consumer.fire("$adEvent", event, args);
    }
};
var _default = {
    get: function(config, videoPlayerConsumer) {
        if (config.enabled === false) {
            return Promise.resolve({
                prerolls: function() {
                    return Promise.resolve();
                }
            });
        }
        consumer = videoPlayerConsumer;
        return new Promise(function(resolve) {
            _Log.default.info("Ad", "Starting session");
            getAds(config).then(function(ads) {
                _Log.default.info("Ad", "API result", ads);
                resolve({
                    prerolls: function() {
                        if (ads.preroll) {
                            state.active = true;
                            fireOnConsumer("PrerollSlotImpression", ads);
                            sendBeacon(ads.preroll.callbacks, "slotImpression");
                            return playSlot(ads.preroll.ads).then(function() {
                                fireOnConsumer("PrerollSlotEnd", ads);
                                sendBeacon(ads.preroll.callbacks, "slotEnd");
                                state.active = false;
                            });
                        }
                        return Promise.resolve();
                    },
                    midrolls: function() {
                        return Promise.resolve();
                    },
                    postrolls: function() {
                        return Promise.resolve();
                    }
                });
            });
        });
    },
    cancel: function() {
        _Log.default.info("Ad", "Cancel Ad");
        state.active = false;
    },
    stop: function() {
        _Log.default.info("Ad", "Stop Ad");
        state.active = false;
        // fixme: duplication
        var videoEl = document.getElementsByTagName("video")[0];
        videoEl.pause();
        videoEl.removeAttribute("src");
    }
};


/***/ }),

/***/ 92010:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AppData: function() {
        return AppData;
    },
    AppInstance: function() {
        return AppInstance;
    },
    default: function() {
        return _default;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _Accessibility = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73434));
var _deepmerge = /*#__PURE__*/ _interop_require_default._(__webpack_require__(12454));
var _isplainobject = __webpack_require__(83056);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var _Locale = /*#__PURE__*/ _interop_require_default._(__webpack_require__(13279));
var _Metrics = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83417));
var _VersionLabel = /*#__PURE__*/ _interop_require_default._(__webpack_require__(14806));
var _FpsCounter = /*#__PURE__*/ _interop_require_default._(__webpack_require__(5244));
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _Settings = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52452));
var _Language = __webpack_require__(57643);
var _Utils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50509));
var _Registry = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8604));
var _Colors = __webpack_require__(34713);
var _packagejson = /*#__PURE__*/ _interop_require_default._(__webpack_require__(62950));
var AppInstance;
var AppData;
var defaultOptions = {
    stage: {
        w: 1920,
        h: 1080,
        precision: 1,
        clearColor: 0x00000000,
        canvas2d: false
    },
    debug: false,
    defaultFontFace: "RobotoRegular",
    keys: {
        8: "Back",
        13: "Enter",
        27: "Menu",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        174: "ChannelDown",
        175: "ChannelUp",
        178: "Stop",
        250: "PlayPause",
        191: "Search",
        409: "Search"
    }
};
var customFontFaces = [];
var fontLoader = function(fonts, store) {
    return new Promise(function(resolve, reject) {
        fonts.map(function(param) {
            var family = param.family, url = param.url, urls = param.urls, descriptors = param.descriptors;
            return function() {
                var src = urls ? urls.map(function(url) {
                    return "url(" + url + ")";
                }) : "url(" + url + ")";
                var fontFace = new FontFace(family, src, descriptors || {});
                store.push(fontFace);
                _Log.default.info("Loading font", family);
                document.fonts.add(fontFace);
                return fontFace.load();
            };
        }).reduce(function(promise, method) {
            return promise.then(function() {
                return method();
            });
        }, Promise.resolve(null)).then(resolve).catch(reject);
    });
};
function _default(App, appData, platformSettings) {
    var width = platformSettings.width, height = platformSettings.height;
    if (width && height) {
        defaultOptions.stage["w"] = width;
        defaultOptions.stage["h"] = height;
        defaultOptions.stage["precision"] = width / 1920;
    }
    // support for 720p browser
    if (!width && !height && window.innerHeight === 720) {
        defaultOptions.stage["w"] = 1280;
        defaultOptions.stage["h"] = 720;
        defaultOptions.stage["precision"] = 1280 / 1920;
    }
    return /*#__PURE__*/ function(_Lightning_Application) {
        "use strict";
        _inherits._(Application, _Lightning_Application);
        var _super = _create_super._(Application);
        function Application(options) {
            _class_call_check._(this, Application);
            var _this;
            var config = (0, _deepmerge.default)(defaultOptions, options, {
                isMergeableObject: _isplainobject.isPlainObject
            });
            _this = _super.call(this, config);
            _this.config = config;
            return _this;
        }
        _create_class._(Application, [
            {
                key: "colorshift",
                value: function colorshift() {
                    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    _Accessibility.default.colorshift(this, type, config);
                }
            },
            {
                key: "keymapping",
                get: function get() {
                    return this.stage.application.config.keys;
                }
            },
            {
                /**
     * This function overrides the default keymap with the latest keymap.
     * @param customKeyMap
     * @param keepDuplicates
     */ key: "overrideKeyMap",
                value: function overrideKeyMap(customKeyMap) {
                    var keepDuplicates = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var baseKeyMap = this.stage.application.config.keys;
                    Object.keys(customKeyMap).reduce(function(keymapping, key) {
                        // prevent duplicate values to exist in final keymapping (i.e. 2 keys triggering 'Back')
                        if (!keepDuplicates) {
                            Object.keys(baseKeyMap).forEach(function(baseKey) {
                                if (baseKey != key && baseKeyMap[baseKey] == customKeyMap[key]) {
                                    delete keymapping[baseKey];
                                }
                            });
                        }
                        keymapping[key] = customKeyMap[key];
                        return keymapping;
                    }, baseKeyMap);
                    return baseKeyMap;
                }
            },
            {
                key: "_setup",
                value: function _setup() {
                    var _this = this;
                    Promise.all([
                        this.loadFonts(App.config && App.config.fonts || App.getFonts && App.getFonts() || []),
                        // to be deprecated
                        _Locale.default.load(App.config && App.config.locale || App.getLocale && App.getLocale()),
                        App.language && this.loadLanguage(App.language()),
                        App.colors && this.loadColors(App.colors())
                    ]).then(function() {
                        _Metrics.default.app.loaded();
                        _this.w = _this.config.stage.w / _this.config.stage.precision;
                        _this.h = _this.config.stage.h / _this.config.stage.precision;
                        AppData = appData;
                        AppInstance = _this.stage.c({
                            ref: "App",
                            type: App,
                            zIndex: 1,
                            forceZIndexContext: !!platformSettings.showVersion || !!platformSettings.showFps
                        });
                        _this.childList.a(AppInstance);
                        _this._refocus();
                        _Log.default.info("App version", _this.config.version);
                        _Log.default.info("SDK version", _packagejson.default.version);
                        if (platformSettings.showVersion) {
                            _this.childList.a({
                                ref: "VersionLabel",
                                type: _VersionLabel.default,
                                version: _this.config.version,
                                sdkVersion: _packagejson.default.version,
                                zIndex: 1
                            });
                        }
                        if (platformSettings.showFps) {
                            _this.childList.a({
                                ref: "FpsCounter",
                                type: _FpsCounter.default,
                                zIndex: 1
                            });
                        }
                        _get._(_get_prototype_of._(Application.prototype), "_setup", _this).call(_this);
                    }).catch(console.error);
                }
            },
            {
                key: "_handleBack",
                value: function _handleBack() {
                    this.closeApp();
                }
            },
            {
                key: "_handleExit",
                value: function _handleExit() {
                    this.closeApp();
                }
            },
            {
                key: "closeApp",
                value: function closeApp() {
                    _Log.default.info("Signaling App Close");
                    if (platformSettings.onClose && typeof platformSettings.onClose === "function") {
                        var _platformSettings;
                        (_platformSettings = platformSettings).onClose.apply(_platformSettings, arguments);
                    } else {
                        this.close();
                    }
                }
            },
            {
                key: "close",
                value: function close() {
                    _Log.default.info("Closing App");
                    _Settings.default.clearSubscribers();
                    _Registry.default.clear();
                    this.childList.remove(this.tag("App"));
                    this.cleanupFonts();
                    // force texture garbage collect
                    this.stage.gc();
                    this.destroy();
                }
            },
            {
                key: "loadFonts",
                value: function loadFonts(fonts) {
                    return platformSettings.fontLoader && typeof platformSettings.fontLoader === "function" ? platformSettings.fontLoader(fonts, customFontFaces) : fontLoader(fonts, customFontFaces);
                }
            },
            {
                key: "cleanupFonts",
                value: function cleanupFonts() {
                    if ("delete" in document.fonts) {
                        customFontFaces.forEach(function(fontFace) {
                            _Log.default.info("Removing font", fontFace.family);
                            document.fonts.delete(fontFace);
                        });
                    } else {
                        _Log.default.info("No support for removing manually-added fonts");
                    }
                }
            },
            {
                key: "loadLanguage",
                value: function loadLanguage(config) {
                    var file = _Utils.default.asset("translations.json");
                    var language = config;
                    if (typeof language === "object") {
                        language = config.language || null;
                        file = config.file || file;
                    }
                    return (0, _Language.initLanguage)(file, language);
                }
            },
            {
                key: "loadColors",
                value: function loadColors(config) {
                    var file = _Utils.default.asset("colors.json");
                    if (config && (typeof config === "string" || typeof config === "object")) {
                        file = config;
                    }
                    return (0, _Colors.initColors)(file);
                }
            },
            {
                key: "focus",
                set: function set(v) {
                    this._focussed = v;
                    this._refocus();
                }
            },
            {
                key: "_getFocused",
                value: function _getFocused() {
                    return this._focussed || this.tag("App");
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    return {
                        w: 1920,
                        h: 1080
                    };
                }
            }
        ]);
        return Application;
    }(_Lightning.default.Application);
}


/***/ }),

/***/ 70842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return AudioPlayer;
    }
}));
var _class_call_check = __webpack_require__(67818);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
var AudioPlayer = function AudioPlayer() {
    "use strict";
    _class_call_check._(this, AudioPlayer);
};


/***/ }),

/***/ 34713:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initColors: function() {
        return initColors;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
var _fetchJson = /*#__PURE__*/ _interop_require_default._(__webpack_require__(88528));
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _utils = __webpack_require__(4937);
var colors = {
    white: "#ffffff",
    black: "#000000",
    red: "#ff0000",
    green: "#00ff00",
    blue: "#0000ff",
    yellow: "#feff00",
    cyan: "#00feff",
    magenta: "#ff00ff"
};
var normalizedColors = {
};
var addColors = function(colorsToAdd, value) {
    if ((0, _utils.isObject)(colorsToAdd)) {
        // clean up normalizedColors if they exist in the to be added colors
        Object.keys(colorsToAdd).forEach(function(color) {
            return cleanUpNormalizedColors(color);
        });
        colors = Object.assign({}, colors, colorsToAdd);
    } else if ((0, _utils.isString)(colorsToAdd) && value) {
        cleanUpNormalizedColors(colorsToAdd);
        colors[colorsToAdd] = value;
    }
};
var cleanUpNormalizedColors = function(color) {
    for(var c in normalizedColors){
        if (c.indexOf(color) > -1) {
            delete normalizedColors[c];
        }
    }
};
var initColors = function(file) {
    return new Promise(function(resolve, reject) {
        if (typeof file === "object") {
            addColors(file);
            return resolve();
        }
        (0, _fetchJson.default)(file).then(function(json) {
            addColors(json);
            return resolve();
        }).catch(function() {
            var error = "Colors file " + file + " not found";
            _Log.default.error(error);
            return reject(error);
        });
    });
};
var normalizeColorToARGB = function(color) {
    var targetColor = normalizedColors[color] || colors[color] || color;
    if (!targetColor) {
        targetColor = color;
    }
    var check = /^#([0-9A-F]{3}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
    if ((0, _utils.isString)(targetColor) && check.test(targetColor)) {
        var hex = check.exec(targetColor)[1];
        if (hex.length === 3) {
            hex = hex.split("").map(function(value) {
                return value + value;
            }).join("");
        }
        targetColor = (hex.length === 8 ? "0x".concat(hex) : "0xff".concat(hex)) * 1;
    }
    if (!normalizedColors[color]) {
        normalizedColors[color] = targetColor;
    }
    return targetColor || 0xffffffff;
};
var _default = function(color) {
    return Color.generate(color);
};
var Color = {
    color: null,
    generate: function generate() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.color;
        if (normalizedColors[value]) {
            this.color = normalizedColors[value];
        } else {
            this.color = normalizeColorToARGB(value);
        }
        return this;
    },
    get: function() {
        return this.color;
    },
    alpha: function alpha(percentage) {
        this.color = (0, _utils.calculateAlpha)(this.color, Math.abs(percentage));
        return this;
    },
    darker: function(percentage) {
        var hsl = (0, _utils.argbToHSLA)(this.color);
        hsl.l = hsl.l * (1 - percentage);
        this.color = (0, _utils.hslaToARGB)(hsl);
        return this;
    },
    lighter: function(percentage) {
        var hsl = (0, _utils.argbToHSLA)(this.color);
        hsl.l = hsl.l + (1 - hsl.l) * percentage;
        this.color = (0, _utils.hslaToARGB)(hsl);
        return this;
    },
    saturation: function(percentage) {
        var hsl = (0, _utils.argbToHSLA)(this.color);
        hsl.s = percentage;
        this.color = (0, _utils.hslaToARGB)(hsl);
        return this;
    },
    lightness: function(percentage) {
        var hsl = (0, _utils.argbToHSLA)(this.color);
        hsl.l = percentage;
        this.color = (0, _utils.hslaToARGB)(hsl);
        return this;
    },
    hue: function(degrees) {
        var hsl = (0, _utils.argbToHSLA)(this.color);
        hsl.h = degrees;
        this.color = (0, _utils.hslaToARGB)(hsl);
        return this;
    },
    mix: function(argb, p) {
        this.color = (0, _utils.mergeColors)(this.color, argb, p);
        return this;
    }
};


/***/ }),

/***/ 4937:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    argbToHSLA: function() {
        return argbToHSLA;
    },
    argbToHsva: function() {
        return argbToHsva;
    },
    calculateAlpha: function() {
        return calculateAlpha;
    },
    getRgbaComponents: function() {
        return getRgbaComponents;
    },
    hslaToARGB: function() {
        return hslaToARGB;
    },
    hsvaToArgb: function() {
        return hsvaToArgb;
    },
    isObject: function() {
        return isObject;
    },
    isString: function() {
        return isString;
    },
    limitWithinRange: function() {
        return limitWithinRange;
    },
    mergeColorAlpha: function() {
        return mergeColorAlpha;
    },
    mergeColors: function() {
        return mergeColors;
    }
});
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var isObject = function(v) {
    return typeof v === "object" && v !== null;
};
var isString = function(v) {
    return typeof v === "string";
};
var getRgbaComponents = function(argb) {
    return {
        r: (argb / 65536 | 0) % 256,
        g: (argb / 256 | 0) % 256,
        b: argb * 1 % 256,
        a: argb / 16777216 | 0
    };
};
var limitWithinRange = function(num, min, max) {
    return Math.min(Math.max(num, min), max);
};
var mergeColors = function(c1, c2, p) {
    var r1 = (c1 / 65536 | 0) % 256;
    var g1 = (c1 / 256 | 0) % 256;
    var b1 = c1 % 256;
    var a1 = c1 / 16777216 | 0;
    var r2 = (c2 / 65536 | 0) % 256;
    var g2 = (c2 / 256 | 0) % 256;
    var b2 = c2 % 256;
    var a2 = c2 / 16777216 | 0;
    var r = r1 * p + r2 * (1 - p);
    var g = g1 * p + g2 * (1 - p);
    var b = b1 * p + b2 * (1 - p);
    var a = a1 * p + a2 * (1 - p);
    return Math.round(a) * 16777216 + Math.round(r) * 65536 + Math.round(g) * 256 + Math.round(b);
};
var calculateAlpha = function(argb, p) {
    if (p > 1) {
        p /= 100;
    } else if (p < 0) {
        p = 0;
    }
    var r = (argb / 65536 | 0) % 256;
    var g = (argb / 256 | 0) % 256;
    var b = argb % 256;
    return (r << 16) + (g << 8) + b + (Math.round(p * 255) | 0) * 16777216;
};
var mergeColorAlpha = function(c, alpha) {
    var a = (c / 16777216 | 0) * alpha | 0;
    return ((c >> 16 & 0xff) * a / 255 & 0xff) + ((c & 0xff00) * a / 255 & 0xff00) + (((c & 0xff) << 16) * a / 255 & 0xff0000) + (a << 24);
};
var getArgbNumber = function(rgba) {
    rgba[0] = Math.max(0, Math.min(255, rgba[0]));
    rgba[1] = Math.max(0, Math.min(255, rgba[1]));
    rgba[2] = Math.max(0, Math.min(255, rgba[2]));
    rgba[3] = Math.max(0, Math.min(255, rgba[3]));
    var v = ((rgba[3] | 0) << 24) + ((rgba[0] | 0) << 16) + ((rgba[1] | 0) << 8) + (rgba[2] | 0);
    if (v < 0) {
        v = 0xffffffff + v + 1;
    }
    return v;
};
var argbToHsva = function(argb) {
    var color = getRgbaComponents(argb);
    var r = color.r / 255;
    var g = color.g / 255;
    var b = color.b / 255;
    var h = 0;
    var s = 0;
    var cMax = Math.max(r, g, b);
    var cMin = Math.min(r, g, b);
    var delta = cMax - cMin;
    //calculate hue
    if (delta < 0.00001) {
        h = 0;
    } else if (cMax !== 0 || cMin !== 0) {
        if (r === cMax) {
            h = (60 * ((g - b) / delta) + 360) % 360;
        } else if (g === cMax) {
            h = (60 * ((b - r) / delta) + 120) % 360;
        } else if (b === cMax) {
            h = (60 * ((r - g) / delta) + 240) % 360;
        }
    }
    //calc saturation
    if (cMax > 0) {
        s = delta / cMax;
    }
    return {
        h: h,
        s: s,
        v: cMax,
        a: color.a / 255
    };
};
var hsvaToArgb = function(color) {
    var h = color.h;
    var c = color.v * color.s;
    var m = color.v - c;
    var x = c * (1.0 - Math.abs(h / 60 % 2 - 1));
    var r = 0;
    var g = 0;
    var b = 0;
    if (0 <= h && h < 60) {
        r = c;
        g = x;
    } else if (60 <= h && h < 120) {
        r = x;
        g = c;
    } else if (120 <= h && h < 180) {
        g = c;
        b = x;
    } else if (180 <= h && h < 240) {
        g = x;
        b = c;
    } else if (240 <= h && h < 300) {
        r = x;
        b = c;
    } else if (300 <= h && h < 360) {
        r = c;
        b = x;
    }
    r = Math.round((r + m) * 255.0);
    g = Math.round((g + m) * 255.0);
    b = Math.round((b + m) * 255.0);
    return getArgbNumber([
        r,
        g,
        b,
        color.a * 255
    ]);
};
var argbToHSLA = function(argb) {
    var col = getRgbaComponents(argb);
    var r = col.r / 255;
    var g = col.g / 255;
    var b = col.b / 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (min + max) * 0.5;
    if (l > 0) {
        var maxMin = max - min;
        if (maxMin > 0) {
            var r2 = (max - r) / maxMin;
            var g2 = (max - g) / maxMin;
            var b2 = (max - b) / maxMin;
            if (l < 0.5) {
                s = max + min;
            } else {
                s = 2 - max - min;
            }
            if (r === max && g === min) {
                h = 5.0 + b2;
            } else if (r === max) {
                h = 1.0 - g2;
            } else if (g === max && b === min) {
                h = 1.0 + r2;
            } else if (g === max) {
                h = 3.0 - b2;
            } else if (b === max) {
                h = 3.0 + g2;
            } else {
                h = 5.0 - r2;
            }
            h = h / 6;
        }
    }
    return {
        h: h % 1,
        s: s,
        l: l,
        a: col.a
    };
};
var hslaToARGB = function(hsla) {
    var r = 1;
    var g = 1;
    var b = 1;
    var h = hsla.h;
    var s = hsla.s;
    var l = hsla.l;
    if (h < 0) {
        h += 1;
    }
    var max = 0;
    if (l <= 0.5) {
        max = l * (1.0 + s);
    } else {
        max = l + s - l * s;
    }
    if (max > 0) {
        h *= 6.0;
        var min = l + l - max;
        var minMax = (max - min) / max;
        var sextant = Math.floor(h);
        var fract = h - sextant;
        var minMaxFract = max * minMax * fract;
        var mid1 = min + minMaxFract;
        var mid2 = max - minMaxFract;
        if (sextant === 0) {
            r = max;
            g = mid1;
            b = min;
        }
        if (sextant === 1) {
            r = mid2;
            g = max;
            b = min;
        }
        if (sextant === 2) {
            r = min;
            g = max;
            b = mid1;
        }
        if (sextant === 3) {
            r = min;
            g = mid2;
            b = max;
        }
        if (sextant === 4) {
            r = mid1;
            g = min;
            b = max;
        }
        if (sextant === 5) {
            r = max;
            g = min;
            b = mid2;
        }
    }
    return getArgbNumber([
        Math.floor(r * 255),
        Math.floor(g * 255),
        Math.floor(b * 255),
        hsla.a
    ]);
};


/***/ }),

/***/ 5244:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return FpsIndicator;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var _Settings = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52452));
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var FpsIndicator = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(FpsIndicator, _Lightning_Component);
    var _super = _create_super._(FpsIndicator);
    function FpsIndicator() {
        _class_call_check._(this, FpsIndicator);
        return _super.apply(this, arguments);
    }
    _create_class._(FpsIndicator, [
        {
            key: "_setup",
            value: function _setup() {
                var _this = this;
                this.config = _object_spread._({}, {
                    log: false,
                    interval: 500,
                    threshold: 1
                }, _Settings.default.get("platform", "showFps"));
                this.fps = 0;
                this.lastFps = this.fps - this.config.threshold;
                var fpsCalculator = function() {
                    _this.fps = ~~(1 / _this.stage.dt);
                };
                this.stage.on("frameStart", fpsCalculator);
                this.stage.off("framestart", fpsCalculator);
                this.interval = setInterval(this.showFps.bind(this), this.config.interval);
            }
        },
        {
            key: "_firstActive",
            value: function _firstActive() {
                this.showFps();
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                clearInterval(this.interval);
            }
        },
        {
            key: "showFps",
            value: function showFps() {
                if (Math.abs(this.lastFps - this.fps) <= this.config.threshold) return;
                this.lastFps = this.fps;
                // green
                var bgColor = 0xff008000;
                // orange
                if (this.fps <= 40 && this.fps > 20) bgColor = 0xffffa500;
                else if (this.fps <= 20) bgColor = 0xffff0000;
                this.tag("Background").setSmooth("color", bgColor);
                this.tag("Counter").text = "".concat(this.fps);
                this.config.log && _Log.default.info("FPS", this.fps);
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    rect: true,
                    color: 0xffffffff,
                    texture: _Lightning.default.Tools.getRoundRect(80, 80, 40),
                    h: 80,
                    w: 80,
                    x: 100,
                    y: 100,
                    mount: 1,
                    Background: {
                        x: 3,
                        y: 3,
                        texture: _Lightning.default.Tools.getRoundRect(72, 72, 36),
                        color: 0xff008000
                    },
                    Counter: {
                        w: function(w) {
                            return w;
                        },
                        h: function(h) {
                            return h;
                        },
                        y: 10,
                        text: {
                            fontSize: 32,
                            textAlign: "center"
                        }
                    },
                    Text: {
                        w: function(w) {
                            return w;
                        },
                        h: function(h) {
                            return h;
                        },
                        y: 48,
                        text: {
                            fontSize: 15,
                            textAlign: "center",
                            text: "FPS"
                        }
                    }
                };
            }
        }
    ]);
    return FpsIndicator;
}(_Lightning.default.Component);


/***/ }),

/***/ 55998:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return ScaledImageTexture;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var ScaledImageTexture = /*#__PURE__*/ function(_Lightning_textures_ImageTexture) {
    "use strict";
    _inherits._(ScaledImageTexture, _Lightning_textures_ImageTexture);
    var _super = _create_super._(ScaledImageTexture);
    function ScaledImageTexture(stage) {
        _class_call_check._(this, ScaledImageTexture);
        var _this;
        _this = _super.call(this, stage);
        _this._scalingOptions = undefined;
        return _this;
    }
    _create_class._(ScaledImageTexture, [
        {
            key: "options",
            set: function set(options) {
                this.resizeMode = this._scalingOptions = options;
            }
        },
        {
            key: "_getLookupId",
            value: function _getLookupId() {
                return "".concat(this._src, "-").concat(this._scalingOptions.type, "-").concat(this._scalingOptions.w, "-").concat(this._scalingOptions.h);
            }
        },
        {
            key: "getNonDefaults",
            value: function getNonDefaults() {
                var obj = _get._(_get_prototype_of._(ScaledImageTexture.prototype), "getNonDefaults", this).call(this);
                if (this._src) {
                    obj.src = this._src;
                }
                return obj;
            }
        }
    ]);
    return ScaledImageTexture;
}(_Lightning.default.textures.ImageTexture);


/***/ }),

/***/ 93277:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
var _Utils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50509));
var _Settings = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52452));
var _ScaledImageTexture = /*#__PURE__*/ _interop_require_default._(__webpack_require__(55998));
var _default = function(imageUrl, options) {
    var imageServerUrl = _Settings.default.get("platform", "imageServerUrl");
    // make and return ScaledImageTexture
    var make = function(options) {
        // local asset, wrap it in Utils.asset()
        if (!/^(?:https?:)?\/\//i.test(imageUrl) && !imageUrl.includes("data:image/png;base64")) {
            imageUrl = _Utils.default.asset(imageUrl);
        }
        // only pass to image server if imageServerUrl is configured
        // and if the asset isn't local to the app (i.e. has same origin)
        if (imageServerUrl && imageUrl.indexOf(window.location.origin) === -1) {
            imageUrl = _Utils.default.ensureUrlWithProtocol(imageServerUrl + "?" + _Utils.default.makeQueryString(imageUrl, options));
        } else {
            // Lightning will handle the resizing and has only 2 flavours (cover and contain)
            if (options.type !== "cover") {
                if (options.type === "crop") options.type = "cover";
                else options.type = "contain";
            }
        }
        return {
            type: _ScaledImageTexture.default,
            src: imageUrl,
            options: options
        };
    };
    // merge options with default
    var setOptions = function(options) {
        options = _object_spread._({}, {
            type: "contain",
            w: 0,
            h: 0
        }, options);
        var imageQuality = Math.max(0.1, Math.min(1, (parseFloat(_Settings.default.get("platform", "image.quality")) || 100) / 100));
        options.w = options.w * imageQuality;
        options.h = options.h * imageQuality;
        return options;
    };
    // if options are passed, return scaled image right away
    if (options) {
        return make(setOptions(options));
    }
    // otherwise return 'chained' functions
    return {
        // official api
        exact: function(w, h) {
            return make(setOptions({
                type: "exact",
                w: w,
                h: h
            }));
        },
        landscape: function(w) {
            return make(setOptions({
                type: "landscape",
                w: w
            }));
        },
        portrait: function(h) {
            return make(setOptions({
                type: "portrait",
                h: h
            }));
        },
        cover: function(w, h) {
            return make(setOptions({
                type: "cover",
                w: w,
                h: h
            }));
        },
        contain: function(w, h) {
            return make(setOptions({
                type: "contain",
                w: w,
                h: h
            }));
        },
        original: function() {
            return make(setOptions({
                type: "contain"
            }));
        }
    };
};


/***/ }),

/***/ 33828:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
var _default = {};


/***/ }),

/***/ 57643:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initLanguage: function() {
        return initLanguage;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _fetchJson = /*#__PURE__*/ _interop_require_default._(__webpack_require__(88528));
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _Utils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(50509));
var meta = {};
var translations = {};
var language = null;
var dictionary = null;
var initLanguage = function(file) {
    var language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return new Promise(function(resolve, reject) {
        (0, _fetchJson.default)(file).then(function(json) {
            setTranslations(json);
            // set language (directly or in a promise)
            typeof language === "object" && "then" in language && typeof language.then === "function" ? language.then(function(lang) {
                return setLanguage(lang).then(resolve).catch(reject);
            }).catch(function(e) {
                _Log.default.error(e);
                reject(e);
            }) : setLanguage(language).then(resolve).catch(reject);
        }).catch(function() {
            var error = "Language file " + file + " not found";
            _Log.default.error(error);
            reject(error);
        });
    });
};
var setTranslations = function(obj) {
    if ("meta" in obj) {
        meta = _object_spread._({}, obj.meta);
        delete obj.meta;
    }
    translations = obj;
};
var getLanguage = function() {
    return language;
};
var setLanguage = function(lng) {
    language = null;
    dictionary = null;
    return new Promise(function(resolve, reject) {
        if (lng in translations) {
            language = lng;
        } else {
            if ("map" in meta && lng in meta.map && meta.map[lng] in translations) {
                language = meta.map[lng];
            } else if ("default" in meta && meta.default in translations) {
                var error = "Translations for Language " + language + " not found. Using default language " + meta.default;
                _Log.default.warn(error);
                language = meta.default;
            } else {
                var error1 = "Translations for Language " + language + " not found.";
                _Log.default.error(error1);
                reject(error1);
            }
        }
        if (language) {
            _Log.default.info("Setting language to", language);
            var translationsObj = translations[language];
            if (typeof translationsObj === "object") {
                dictionary = translationsObj;
                resolve();
            } else if (typeof translationsObj === "string") {
                var url = _Utils.default.asset(translationsObj);
                (0, _fetchJson.default)(url).then(function(json) {
                    // save the translations for this language (to prevent loading twice)
                    translations[language] = json;
                    dictionary = json;
                    resolve();
                }).catch(function(e) {
                    var error = "Error while fetching " + url;
                    _Log.default.error(error, e);
                    reject(error);
                });
            }
        }
    });
};
var _default = {
    translate: function(key) {
        var replacements = Array.prototype.slice.call(arguments).slice(1);
        // no replacements so just translated string
        if (replacements.length === 0) {
            return dictionary && dictionary[key] || key;
        } else {
            if (replacements.length === 1 && typeof replacements[0] === "object") {
                replacements = replacements.pop();
            }
            return Object.keys(// maps array input to an object {0: 'item1', 1: 'item2'}
            Array.isArray(replacements) ? Object.assign({}, replacements) : replacements).reduce(function(text, replacementKey) {
                return text.replace(new RegExp("{\\s?" + replacementKey + "\\s?}", "g"), replacements[replacementKey]);
            }, dictionary && dictionary[key] || key);
        }
    },
    translations: function(obj) {
        setTranslations(obj);
    },
    set: function(language) {
        return setLanguage(language);
    },
    get: function() {
        return getLanguage();
    },
    available: function() {
        var languageKeys = Object.keys(translations);
        return languageKeys.map(function(key) {
            return {
                code: key,
                name: meta.names && meta.names[key] || key
            };
        });
    }
};


/***/ }),

/***/ 47450:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ApplicationInstance: function() {
        return ApplicationInstance;
    },
    default: function() {
        return _default;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _Utils = __webpack_require__(50509);
var _sdk = __webpack_require__(42976);
var _Settings = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(52452));
var _MediaPlayer = __webpack_require__(73901);
var _Storage = __webpack_require__(58684);
var _Ads = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(60214));
var _Router = __webpack_require__(6078);
var _Application = /*#__PURE__*/ _interop_require_default._(__webpack_require__(92010));
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var ApplicationInstance;
var _default = function(App, appSettings, platformSettings, appData) {
    (0, _Settings.initSettings)(appSettings, platformSettings);
    (0, _Utils.initUtils)(platformSettings);
    (0, _sdk.initMetadata)(appSettings);
    (0, _Storage.initStorage)();
    // Initialize plugins
    if (platformSettings.plugins) {
        platformSettings.plugins.profile && (0, _sdk.initProfile)(platformSettings.plugins.profile);
        platformSettings.plugins.metrics && (0, _sdk.initMetrics)(platformSettings.plugins.metrics);
        platformSettings.plugins.mediaPlayer && (0, _MediaPlayer.initMediaPlayer)(platformSettings.plugins.mediaPlayer);
        platformSettings.plugins.mediaPlayer && (0, _sdk.initVideoPlayer)(platformSettings.plugins.mediaPlayer);
        platformSettings.plugins.ads && (0, _Ads.initAds)(platformSettings.plugins.ads);
        platformSettings.plugins.router && (0, _Router.initRouter)(platformSettings.plugins.router);
        platformSettings.plugins.tv && (0, _sdk.initTV)(platformSettings.plugins.tv);
        platformSettings.plugins.purchase && (0, _sdk.initPurchase)(platformSettings.plugins.purchase);
        platformSettings.plugins.pin && (0, _sdk.initPin)(platformSettings.plugins.pin);
    }
    var app = (0, _Application.default)(App, appData, platformSettings);
    _sdk.initLightningSdkPlugin.log = _Log.default;
    _sdk.initLightningSdkPlugin.settings = _Settings.default;
    _sdk.initLightningSdkPlugin.ads = _Ads.default;
    _sdk.initLightningSdkPlugin.lightning = _Lightning.default;
    ApplicationInstance = new app(appSettings);
    _sdk.initLightningSdkPlugin.appInstance = ApplicationInstance;
    return ApplicationInstance;
};


/***/ }),

/***/ 72661:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _core = /*#__PURE__*/ _interop_require_default._(__webpack_require__(37791));
var _default = _core.default;


/***/ }),

/***/ 13279:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple module for localization of strings.
 *
 * How to use:
 * 1. Create localization file with following JSON format:
 * {
 *   "en" :{
 *     "how": "How do you want your egg today?",
 *     "boiledEgg": "Boiled egg",
 *     "softBoiledEgg": "Soft-boiled egg",
 *     "choice": "How to choose the egg",
 *     "buyQuestion": "I'd like to buy {0} eggs, {1} dollars each."
 *   },
 *
 *   "it": {
 *     "how": "Come vuoi il tuo uovo oggi?",
 *     "boiledEgg": "Uovo sodo",
 *     "softBoiledEgg": "Uovo alla coque",
 *     "choice": "Come scegliere l'uovo",
 *     "buyQuestion": "Mi piacerebbe comprare {0} uova, {1} dollari ciascuna."
 *   }
 * }
 *
 * 2. Use Locale's module load method, specifying path to your localization file and set chosen language, e.g.:
 *    > Locale.load('static/locale/locale.json');
 *    > Locale.setLanguage('en');
 *
 * 3. Use localization strings:
 *    > console.log(Locale.tr.how);
 *    How do you want your egg today?
 *    > console.log(Locale.tr.boiledEgg);
 *    Boiled egg
 *
 * 4. String formatting
 *    > console.log(Locale.tr.buyQuestion.format(10, 0.5));
 *    I'd like to buy 10 eggs, 0.5 dollars each.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var warned = false;
var deprecated = function() {
    var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (force === true || warned === false) {
        console.warn([
            "The 'Locale'-plugin in the Lightning-SDK is deprecated and will be removed in future releases.",
            "Please consider using the new 'Language'-plugin instead.",
            "https://rdkcentral.github.io/Lightning-SDK/#/plugins/language"
        ].join("\n\n"));
    }
    warned = true;
};
var Locale = /*#__PURE__*/ function() {
    "use strict";
    function Locale() {
        _class_call_check._(this, Locale);
        this.__enabled = false;
    }
    _create_class._(Locale, [
        {
            key: "load",
            value: /**
   * Loads translation object from external json file.
   *
   * @param {String} path Path to resource.
   * @return {Promise}
   */ function load(path) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.__enabled) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    fetch(path).then(function(resp) {
                                        return resp.json();
                                    }).then(function(resp) {
                                        _this.loadFromObject(resp);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Sets language used by module.
   *
   * @param {String} lang
   */ key: "setLanguage",
            value: function setLanguage(lang) {
                deprecated();
                this.__enabled = true;
                this.language = lang;
            }
        },
        {
            key: "tr",
            get: /**
   * Returns reference to translation object for current language.
   *
   * @return {Object}
   */ function get() {
                deprecated(true);
                return this.__trObj[this.language];
            }
        },
        {
            /**
   * Loads translation object from existing object (binds existing object).
   *
   * @param {Object} trObj
   */ key: "loadFromObject",
            value: function loadFromObject(trObj) {
                deprecated();
                var fallbackLanguage = "en";
                if (Object.keys(trObj).indexOf(this.language) === -1) {
                    _Log.default.warn("No translations found for: " + this.language);
                    if (Object.keys(trObj).indexOf(fallbackLanguage) > -1) {
                        _Log.default.warn("Using fallback language: " + fallbackLanguage);
                        this.language = fallbackLanguage;
                    } else {
                        var error = "No translations found for fallback language: " + fallbackLanguage;
                        _Log.default.error(error);
                        throw Error(error);
                    }
                }
                this.__trObj = trObj;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.values(this.__trObj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var lang = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = Object.keys(lang)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var str = _step1.value;
                                lang[str] = new LocalizedString(lang[str]);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return Locale;
}();
/**
 * Extended string class used for localization.
 */ var LocalizedString = /*#__PURE__*/ function(String1) {
    "use strict";
    _inherits._(LocalizedString, String1);
    var _super = _create_super._(LocalizedString);
    function LocalizedString() {
        _class_call_check._(this, LocalizedString);
        return _super.apply(this, arguments);
    }
    _create_class._(LocalizedString, [
        {
            /**
   * Returns formatted LocalizedString.
   * Replaces each placeholder value (e.g. {0}, {1}) with corresponding argument.
   *
   * E.g.:
   * > new LocalizedString('{0} and {1} and {0}').format('A', 'B');
   * A and B and A
   *
   * @param  {...any} args List of arguments for placeholders.
   */ key: "format",
            value: function format() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var sub = args.reduce(function(string, arg, index) {
                    return string.split("{".concat(index, "}")).join(arg);
                }, this);
                return new LocalizedString(sub);
            }
        }
    ]);
    return LocalizedString;
}(_wrap_native_super._(String));
var _default = new Locale();


/***/ }),

/***/ 85889:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
var _Settings = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52452));
var prepLog = function(type, args) {
    var colors = {
        Info: "green",
        Debug: "gray",
        Warn: "orange",
        Error: "red"
    };
    args = Array.from(args);
    return [
        "%c" + (args.length > 1 && typeof args[0] === "string" ? args.shift() : type),
        "background-color: " + colors[type] + "; color: white; padding: 2px 4px; border-radius: 2px",
        args
    ];
};
var _default = {
    info: function() {
        _Settings.default.get("platform", "log") && console.log.apply(console, prepLog("Info", arguments));
    },
    debug: function() {
        _Settings.default.get("platform", "log") && console.debug.apply(console, prepLog("Debug", arguments));
    },
    error: function() {
        _Settings.default.get("platform", "log") && console.error.apply(console, prepLog("Error", arguments));
    },
    warn: function() {
        _Settings.default.get("platform", "log") && console.warn.apply(console, prepLog("Warn", arguments));
    }
};


/***/ }),

/***/ 73901:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return Mediaplayer;
    },
    initMediaPlayer: function() {
        return initMediaPlayer;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var _Metrics = /*#__PURE__*/ _interop_require_default._(__webpack_require__(83417));
var _Settings = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52452));
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var events = [
    "timeupdate",
    "error",
    "ended",
    "loadeddata",
    "canplay",
    "play",
    "playing",
    "pause",
    "loadstart",
    "seeking",
    "seeked",
    "encrypted"
];
var mediaUrl = function(url) {
    return url;
};
var initMediaPlayer = function(config) {
    if (config.mediaUrl) {
        mediaUrl = config.mediaUrl;
    }
};
var Mediaplayer = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(Mediaplayer, _Lightning_Component);
    var _super = _create_super._(Mediaplayer);
    function Mediaplayer() {
        _class_call_check._(this, Mediaplayer);
        return _super.apply(this, arguments);
    }
    _create_class._(Mediaplayer, [
        {
            key: "_construct",
            value: function _construct() {
                this._skipRenderToTexture = false;
                this._metrics = null;
                this._textureMode = _Settings.default.get("platform", "textureMode") || false;
                _Log.default.info("Texture mode: " + this._textureMode);
                console.warn([
                    "The 'MediaPlayer'-plugin in the Lightning-SDK is deprecated and will be removed in future releases.",
                    "Please consider using the new 'VideoPlayer'-plugin instead.",
                    "https://rdkcentral.github.io/Lightning-SDK/#/plugins/videoplayer"
                ].join("\n\n"));
            }
        },
        {
            key: "skipRenderToTexture",
            set: function set(v) {
                this._skipRenderToTexture = v;
            }
        },
        {
            key: "textureMode",
            get: function get() {
                return this._textureMode;
            }
        },
        {
            key: "videoView",
            get: function get() {
                return this.tag("Video");
            }
        },
        {
            key: "_init",
            value: function _init() {
                //re-use videotag if already there
                var videoEls = document.getElementsByTagName("video");
                if (videoEls && videoEls.length > 0) this.videoEl = videoEls[0];
                else {
                    this.videoEl = document.createElement("video");
                    this.videoEl.setAttribute("id", "video-player");
                    this.videoEl.style.position = "absolute";
                    this.videoEl.style.zIndex = "1";
                    this.videoEl.style.display = "none";
                    this.videoEl.setAttribute("width", "100%");
                    this.videoEl.setAttribute("height", "100%");
                    this.videoEl.style.visibility = this.textureMode ? "hidden" : "visible";
                    document.body.appendChild(this.videoEl);
                }
                if (this.textureMode && !this._skipRenderToTexture) {
                    this._createVideoTexture();
                }
                this.eventHandlers = [];
            }
        },
        {
            key: "_registerListeners",
            value: function _registerListeners() {
                var _this = this;
                events.forEach(function(event) {
                    var handler = function(e) {
                        if (_this._metrics && _this._metrics[event] && typeof _this._metrics[event] === "function") {
                            _this._metrics[event]({
                                currentTime: _this.videoEl.currentTime
                            });
                        }
                        _this.fire(event, {
                            videoElement: _this.videoEl,
                            event: e
                        });
                    };
                    _this.eventHandlers.push(handler);
                    _this.videoEl.addEventListener(event, handler);
                });
            }
        },
        {
            key: "_deregisterListeners",
            value: function _deregisterListeners() {
                var _this = this;
                _Log.default.info("Deregistering event listeners MediaPlayer");
                events.forEach(function(event, index) {
                    _this.videoEl.removeEventListener(event, _this.eventHandlers[index]);
                });
                this.eventHandlers = [];
            }
        },
        {
            key: "_attach",
            value: function _attach() {
                this._registerListeners();
            }
        },
        {
            key: "_detach",
            value: function _detach() {
                this._deregisterListeners();
                this.close();
            }
        },
        {
            key: "_createVideoTexture",
            value: function _createVideoTexture() {
                var stage = this.stage;
                var gl = stage.gl;
                var glTexture = gl.createTexture();
                gl.bindTexture(gl.TEXTURE_2D, glTexture);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                this.videoTexture.options = {
                    source: glTexture,
                    w: this.videoEl.width,
                    h: this.videoEl.height
                };
            }
        },
        {
            key: "_startUpdatingVideoTexture",
            value: function _startUpdatingVideoTexture() {
                var _this = this;
                if (this.textureMode && !this._skipRenderToTexture) {
                    var stage = this.stage;
                    if (!this._updateVideoTexture) {
                        this._updateVideoTexture = function() {
                            if (_this.videoTexture.options.source && _this.videoEl.videoWidth && _this.active) {
                                var gl = stage.gl;
                                var currentTime = new Date().getTime();
                                // When BR2_PACKAGE_GST1_PLUGINS_BAD_PLUGIN_DEBUGUTILS is not set in WPE, webkitDecodedFrameCount will not be available.
                                // We'll fallback to fixed 30fps in this case.
                                var frameCount = _this.videoEl.webkitDecodedFrameCount;
                                var mustUpdate = frameCount ? _this._lastFrame !== frameCount : _this._lastTime < currentTime - 30;
                                if (mustUpdate) {
                                    _this._lastTime = currentTime;
                                    _this._lastFrame = frameCount;
                                    try {
                                        gl.bindTexture(gl.TEXTURE_2D, _this.videoTexture.options.source);
                                        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
                                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, _this.videoEl);
                                        _this._lastFrame = _this.videoEl.webkitDecodedFrameCount;
                                        _this.videoTextureView.visible = true;
                                        _this.videoTexture.options.w = _this.videoEl.videoWidth;
                                        _this.videoTexture.options.h = _this.videoEl.videoHeight;
                                        var expectedAspectRatio = _this.videoTextureView.w / _this.videoTextureView.h;
                                        var realAspectRatio = _this.videoEl.videoWidth / _this.videoEl.videoHeight;
                                        if (expectedAspectRatio > realAspectRatio) {
                                            _this.videoTextureView.scaleX = realAspectRatio / expectedAspectRatio;
                                            _this.videoTextureView.scaleY = 1;
                                        } else {
                                            _this.videoTextureView.scaleY = expectedAspectRatio / realAspectRatio;
                                            _this.videoTextureView.scaleX = 1;
                                        }
                                    } catch (e) {
                                        _Log.default.error("texImage2d video", e);
                                        _this._stopUpdatingVideoTexture();
                                        _this.videoTextureView.visible = false;
                                    }
                                    _this.videoTexture.source.forceRenderUpdate();
                                }
                            }
                        };
                    }
                    if (!this._updatingVideoTexture) {
                        stage.on("frameStart", this._updateVideoTexture);
                        this._updatingVideoTexture = true;
                    }
                }
            }
        },
        {
            key: "_stopUpdatingVideoTexture",
            value: function _stopUpdatingVideoTexture() {
                if (this.textureMode) {
                    var stage = this.stage;
                    stage.removeListener("frameStart", this._updateVideoTexture);
                    this._updatingVideoTexture = false;
                    this.videoTextureView.visible = false;
                    if (this.videoTexture.options.source) {
                        var gl = stage.gl;
                        gl.bindTexture(gl.TEXTURE_2D, this.videoTexture.options.source);
                        gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                }
            }
        },
        {
            key: "updateSettings",
            value: function updateSettings() {
                var settings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                // The Component that 'consumes' the media player.
                this._consumer = settings.consumer;
                if (this._consumer && this._consumer.getMediaplayerSettings) {
                    // Allow consumer to add settings.
                    settings = Object.assign(settings, this._consumer.getMediaplayerSettings());
                }
                if (!_Lightning.default.Utils.equalValues(this._stream, settings.stream)) {
                    if (settings.stream && settings.stream.keySystem) {
                        navigator.requestMediaKeySystemAccess(settings.stream.keySystem.id, settings.stream.keySystem.config).then(function(keySystemAccess) {
                            return keySystemAccess.createMediaKeys();
                        }).then(function(createdMediaKeys) {
                            return _this.videoEl.setMediaKeys(createdMediaKeys);
                        }).then(function() {
                            if (settings.stream && settings.stream.src) _this.open(settings.stream.src);
                        }).catch(function() {
                            console.error("Failed to set up MediaKeys");
                        });
                    } else if (settings.stream && settings.stream.src) {
                        // This is here to be backwards compatible, will be removed
                        // in future sdk release
                        if (_Settings.default.get("app", "hls")) {
                            if (!window.Hls) {
                                window.Hls = /*#__PURE__*/ function() {
                                    function Hls() {
                                        _class_call_check._(this, Hls);
                                    }
                                    _create_class._(Hls, null, [
                                        {
                                            key: "isSupported",
                                            value: function isSupported() {
                                                console.warn("hls-light not included");
                                                return false;
                                            }
                                        }
                                    ]);
                                    return Hls;
                                }();
                            }
                            if (window.Hls.isSupported()) {
                                if (!this._hls) this._hls = new window.Hls({
                                    liveDurationInfinity: true
                                });
                                this._hls.loadSource(settings.stream.src);
                                this._hls.attachMedia(this.videoEl);
                                this.videoEl.style.display = "block";
                            }
                        } else {
                            this.open(settings.stream.src);
                        }
                    } else {
                        this.close();
                    }
                    this._stream = settings.stream;
                }
                this._setHide(settings.hide);
                this._setVideoArea(settings.videoPos);
            }
        },
        {
            key: "_setHide",
            value: function _setHide(hide) {
                if (this.textureMode) {
                    this.tag("Video").setSmooth("alpha", hide ? 0 : 1);
                } else {
                    this.videoEl.style.visibility = hide ? "hidden" : "visible";
                }
            }
        },
        {
            key: "open",
            value: function open(url) {
                var settings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    hide: false,
                    videoPosition: null
                };
                var _this = this;
                // prep the media url to play depending on platform (mediaPlayerplugin)
                url = mediaUrl(url);
                this._metrics = _Metrics.default.media(url);
                _Log.default.info("Playing stream", url);
                if (this.application.noVideo) {
                    _Log.default.info("noVideo option set, so ignoring: " + url);
                    return;
                }
                // close the video when opening same url as current (effectively reloading)
                if (this.videoEl.getAttribute("src") === url) {
                    this.close();
                }
                this.videoEl.setAttribute("src", url);
                // force hide, then force show (in next tick!)
                // (fixes comcast playback rollover issue)
                this.videoEl.style.visibility = "hidden";
                this.videoEl.style.display = "none";
                setTimeout(function() {
                    _this.videoEl.style.display = "block";
                    _this.videoEl.style.visibility = "visible";
                });
                this._setHide(settings.hide);
                this._setVideoArea(settings.videoPosition || [
                    0,
                    0,
                    1920,
                    1080
                ]);
            }
        },
        {
            key: "close",
            value: function close() {
                // We need to pause first in order to stop sound.
                this.videoEl.pause();
                this.videoEl.removeAttribute("src");
                // force load to reset everything without errors
                this.videoEl.load();
                this._clearSrc();
                this.videoEl.style.display = "none";
            }
        },
        {
            key: "playPause",
            value: function playPause() {
                if (this.isPlaying()) {
                    this.doPause();
                } else {
                    this.doPlay();
                }
            }
        },
        {
            key: "muted",
            get: function get() {
                return this.videoEl.muted;
            },
            set: function set(v) {
                this.videoEl.muted = v;
            }
        },
        {
            key: "loop",
            get: function get() {
                return this.videoEl.loop;
            },
            set: function set(v) {
                this.videoEl.loop = v;
            }
        },
        {
            key: "isPlaying",
            value: function isPlaying() {
                return this._getState() === "Playing";
            }
        },
        {
            key: "doPlay",
            value: function doPlay() {
                this.videoEl.play();
            }
        },
        {
            key: "doPause",
            value: function doPause() {
                this.videoEl.pause();
            }
        },
        {
            key: "reload",
            value: function reload() {
                var url = this.videoEl.getAttribute("src");
                this.close();
                this.videoEl.src = url;
            }
        },
        {
            key: "getPosition",
            value: function getPosition() {
                return Promise.resolve(this.videoEl.currentTime);
            }
        },
        {
            key: "setPosition",
            value: function setPosition(pos) {
                this.videoEl.currentTime = pos;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return Promise.resolve(this.videoEl.duration);
            }
        },
        {
            key: "seek",
            value: function seek(time) {
                var absolute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (absolute) {
                    this.videoEl.currentTime = time;
                } else {
                    this.videoEl.currentTime += time;
                }
            }
        },
        {
            key: "videoTextureView",
            get: function get() {
                return this.tag("Video").tag("VideoTexture");
            }
        },
        {
            key: "videoTexture",
            get: function get() {
                return this.videoTextureView.texture;
            }
        },
        {
            key: "_setVideoArea",
            value: function _setVideoArea(videoPos) {
                if (_Lightning.default.Utils.equalValues(this._videoPos, videoPos)) {
                    return;
                }
                this._videoPos = videoPos;
                if (this.textureMode) {
                    this.videoTextureView.patch({
                        smooth: {
                            x: videoPos[0],
                            y: videoPos[1],
                            w: videoPos[2] - videoPos[0],
                            h: videoPos[3] - videoPos[1]
                        }
                    });
                } else {
                    var precision = this.stage.getRenderPrecision();
                    this.videoEl.style.left = Math.round(videoPos[0] * precision) + "px";
                    this.videoEl.style.top = Math.round(videoPos[1] * precision) + "px";
                    this.videoEl.style.width = Math.round((videoPos[2] - videoPos[0]) * precision) + "px";
                    this.videoEl.style.height = Math.round((videoPos[3] - videoPos[1]) * precision) + "px";
                }
            }
        },
        {
            key: "_fireConsumer",
            value: function _fireConsumer(event, args) {
                if (this._consumer) {
                    this._consumer.fire(event, args);
                }
            }
        },
        {
            key: "_equalInitData",
            value: function _equalInitData(buf1, buf2) {
                if (!buf1 || !buf2) return false;
                if (buf1.byteLength != buf2.byteLength) return false;
                var dv1 = new Int8Array(buf1);
                var dv2 = new Int8Array(buf2);
                for(var i = 0; i != buf1.byteLength; i++)if (dv1[i] != dv2[i]) return false;
                return true;
            }
        },
        {
            key: "error",
            value: function error(args) {
                this._fireConsumer("$mediaplayerError", args);
                this._setState("");
                return "";
            }
        },
        {
            key: "loadeddata",
            value: function loadeddata(args) {
                this._fireConsumer("$mediaplayerLoadedData", args);
            }
        },
        {
            key: "play",
            value: function play(args) {
                this._fireConsumer("$mediaplayerPlay", args);
            }
        },
        {
            key: "playing",
            value: function playing(args) {
                this._fireConsumer("$mediaplayerPlaying", args);
                this._setState("Playing");
            }
        },
        {
            key: "canplay",
            value: function canplay(args) {
                this.videoEl.play();
                this._fireConsumer("$mediaplayerStart", args);
            }
        },
        {
            key: "loadstart",
            value: function loadstart(args) {
                this._fireConsumer("$mediaplayerLoad", args);
            }
        },
        {
            key: "seeked",
            value: function seeked() {
                this._fireConsumer("$mediaplayerSeeked", {
                    currentTime: this.videoEl.currentTime,
                    duration: this.videoEl.duration || 1
                });
            }
        },
        {
            key: "seeking",
            value: function seeking() {
                this._fireConsumer("$mediaplayerSeeking", {
                    currentTime: this.videoEl.currentTime,
                    duration: this.videoEl.duration || 1
                });
            }
        },
        {
            key: "durationchange",
            value: function durationchange(args) {
                this._fireConsumer("$mediaplayerDurationChange", args);
            }
        },
        {
            key: "encrypted",
            value: function encrypted(args) {
                var video = args.videoElement;
                var event = args.event;
                // FIXME: Double encrypted events need to be properly filtered by Gstreamer
                if (video.mediaKeys && !this._equalInitData(this._previousInitData, event.initData)) {
                    this._previousInitData = event.initData;
                    this._fireConsumer("$mediaplayerEncrypted", args);
                }
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Video: {
                        VideoWrap: {
                            VideoTexture: {
                                visible: false,
                                pivot: 0.5,
                                texture: {
                                    type: _Lightning.default.textures.StaticTexture,
                                    options: {}
                                }
                            }
                        }
                    }
                };
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Playing, _this);
                        var _super = _create_super._(Playing);
                        function Playing() {
                            _class_call_check._(this, Playing);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Playing, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this._startUpdatingVideoTexture();
                                }
                            },
                            {
                                key: "$exit",
                                value: function $exit() {
                                    this._stopUpdatingVideoTexture();
                                }
                            },
                            {
                                key: "timeupdate",
                                value: function timeupdate() {
                                    this._fireConsumer("$mediaplayerProgress", {
                                        currentTime: this.videoEl.currentTime,
                                        duration: this.videoEl.duration || 1
                                    });
                                }
                            },
                            {
                                key: "ended",
                                value: function ended(args) {
                                    this._fireConsumer("$mediaplayerEnded", args);
                                    this._setState("");
                                }
                            },
                            {
                                key: "pause",
                                value: function pause(args) {
                                    this._fireConsumer("$mediaplayerPause", args);
                                    this._setState("Playing.Paused");
                                }
                            },
                            {
                                key: "_clearSrc",
                                value: function _clearSrc() {
                                    this._fireConsumer("$mediaplayerStop", {});
                                    this._setState("");
                                }
                            }
                        ], [
                            {
                                key: "_states",
                                value: function _states() {
                                    return [
                                        /*#__PURE__*/ function(_this) {
                                            _inherits._(Paused, _this);
                                            var _super = _create_super._(Paused);
                                            function Paused() {
                                                _class_call_check._(this, Paused);
                                                return _super.apply(this, arguments);
                                            }
                                            return Paused;
                                        }(this)
                                    ];
                                }
                            }
                        ]);
                        return Playing;
                    }(this)
                ];
            }
        }
    ]);
    return Mediaplayer;
}(_Lightning.default.Component);


/***/ }),

/***/ 60787:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _sdk = __webpack_require__(42976);
var _default = _sdk.Metadata;


/***/ }),

/***/ 83417:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
var _sdk = __webpack_require__(42976);
var _default = _sdk.Metrics;


/***/ }),

/***/ 68751:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
var _sdk = __webpack_require__(42976);
var _default = _sdk.Pin;


/***/ }),

/***/ 18166:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
var _sdk = __webpack_require__(42976);
var _default = _sdk.Profile;


/***/ }),

/***/ 59183:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
var _sdk = __webpack_require__(42976);
var _default = _sdk.Purchase;


/***/ }),

/***/ 8604:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var registry = {
    eventListeners: [],
    timeouts: [],
    intervals: [],
    targets: []
};
var _default = {
    // Timeouts
    setTimeout: function(cb, timeout) {
        for(var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            params[_key - 2] = arguments[_key];
        }
        var timeoutId = setTimeout(function() {
            registry.timeouts = registry.timeouts.filter(function(id) {
                return id !== timeoutId;
            });
            cb.apply(null, params);
        }, timeout, params);
        _Log.default.info("Set Timeout", "ID: " + timeoutId);
        registry.timeouts.push(timeoutId);
        return timeoutId;
    },
    clearTimeout: function(timeoutId) {
        if (registry.timeouts.indexOf(timeoutId) > -1) {
            registry.timeouts = registry.timeouts.filter(function(id) {
                return id !== timeoutId;
            });
            _Log.default.info("Clear Timeout", "ID: " + timeoutId);
            clearTimeout(timeoutId);
        } else {
            _Log.default.error("Clear Timeout", "ID " + timeoutId + " not found");
        }
    },
    clearTimeouts: function() {
        var _this = this;
        registry.timeouts.forEach(function(timeoutId) {
            _this.clearTimeout(timeoutId);
        });
    },
    // Intervals
    setInterval: function(cb, interval) {
        for(var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            params[_key - 2] = arguments[_key];
        }
        var intervalId = setInterval(function() {
            registry.intervals.filter(function(id) {
                return id !== intervalId;
            });
            cb.apply(null, params);
        }, interval, params);
        _Log.default.info("Set Interval", "ID: " + intervalId);
        registry.intervals.push(intervalId);
        return intervalId;
    },
    clearInterval: function(intervalId) {
        if (registry.intervals.indexOf(intervalId) > -1) {
            registry.intervals = registry.intervals.filter(function(id) {
                return id !== intervalId;
            });
            _Log.default.info("Clear Interval", "ID: " + intervalId);
            clearInterval(intervalId);
        } else {
            _Log.default.error("Clear Interval", "ID " + intervalId + " not found");
        }
    },
    clearIntervals: function() {
        var _this = this;
        registry.intervals.forEach(function(intervalId) {
            _this.clearInterval(intervalId);
        });
    },
    // Event listeners
    addEventListener: function(target, event, handler) {
        target.addEventListener(event, handler);
        var targetIndex = registry.targets.indexOf(target) > -1 ? registry.targets.indexOf(target) : registry.targets.push(target) - 1;
        registry.eventListeners[targetIndex] = registry.eventListeners[targetIndex] || {};
        registry.eventListeners[targetIndex][event] = registry.eventListeners[targetIndex][event] || [];
        registry.eventListeners[targetIndex][event].push(handler);
        _Log.default.info("Add eventListener", "Target:", target, "Event: " + event, "Handler:", handler.toString());
    },
    removeEventListener: function(target, event, handler) {
        var targetIndex = registry.targets.indexOf(target);
        if (targetIndex > -1 && registry.eventListeners[targetIndex] && registry.eventListeners[targetIndex][event] && registry.eventListeners[targetIndex][event].indexOf(handler) > -1) {
            registry.eventListeners[targetIndex][event] = registry.eventListeners[targetIndex][event].filter(function(fn) {
                return fn !== handler;
            });
            _Log.default.info("Remove eventListener", "Target:", target, "Event: " + event, "Handler:", handler.toString());
            target.removeEventListener(event, handler);
            // remove key from event listeners object when no events are registered for that event
            Object.keys(registry.eventListeners[targetIndex]).forEach(function(event) {
                if (registry.eventListeners[targetIndex][event].length === 0) {
                    delete registry.eventListeners[targetIndex][event];
                }
            });
            // remove reference to the target when target has no event listeners registered
            if (Object.keys(registry.eventListeners[targetIndex]).length === 0) {
                registry.targets.splice(targetIndex, 1);
                registry.eventListeners.splice(targetIndex, 1);
            }
        } else {
            _Log.default.error("Remove eventListener", "Not found", "Target", target, "Event: " + event, "Handler", handler.toString());
        }
    },
    // if `event` is omitted, removes all registered event listeners for target
    // if `target` is also omitted, removes all registered event listeners
    removeEventListeners: function(target, event) {
        var _this = this;
        if (target && event) {
            var targetIndex = registry.targets.indexOf(target);
            if (targetIndex > -1) {
                registry.eventListeners[targetIndex][event].forEach(function(handler) {
                    _this.removeEventListener(target, event, handler);
                });
            }
        } else if (target) {
            var targetIndex1 = registry.targets.indexOf(target);
            if (targetIndex1 > -1) {
                Object.keys(registry.eventListeners[targetIndex1]).forEach(function(_event) {
                    _this.removeEventListeners(target, _event);
                });
            }
        } else {
            Object.keys(registry.eventListeners).forEach(function(targetIndex) {
                _this.removeEventListeners(registry.targets[targetIndex]);
            });
        }
    },
    // Clear everything (to be called upon app close for proper cleanup)
    clear: function() {
        this.clearTimeouts();
        this.clearIntervals();
        this.removeEventListeners();
        registry.eventListeners = [];
        registry.timeouts = [];
        registry.intervals = [];
        registry.targets = [];
    }
};


/***/ }),

/***/ 57632:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "RoutedApp", ({
    enumerable: true,
    get: function() {
        return RoutedApp;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var _index = /*#__PURE__*/ _interop_require_default._(__webpack_require__(6078));
var _router = __webpack_require__(69611);
var _helpers = __webpack_require__(73137);
var RoutedApp = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(RoutedApp, _Lightning_Component);
    var _super = _create_super._(RoutedApp);
    function RoutedApp() {
        _class_call_check._(this, RoutedApp);
        return _super.apply(this, arguments);
    }
    _create_class._(RoutedApp, [
        {
            key: "pages",
            get: /**
   * Return location where pages need to be stored
   */ function get() {
                return this.tag("Pages");
            }
        },
        {
            key: "widgets",
            get: /**
   * Tell router where widgets are stored
   */ function get() {
                return this.tag("Widgets");
            }
        },
        {
            /**
   * we MUST register _handleBack method so the Router
   * can override it
   * @private
   */ key: "_handleBack",
            value: function _handleBack() {}
        },
        {
            /**
   * We MUST return Router.activePage() so the new Page
   * can listen to the remote-control.
   */ key: "_getFocused",
            value: function _getFocused() {
                return _index.default.getActivePage();
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    Pages: {
                        forceZIndexContext: true
                    },
                    /**
       * This is a default Loading page that will be made visible
       * during data-provider on() you CAN override in child-class
       */ Loading: {
                        rect: true,
                        w: 1920,
                        h: 1080,
                        color: 0xff000000,
                        visible: false,
                        zIndex: 99,
                        Label: {
                            mount: 0.5,
                            x: 960,
                            y: 540,
                            text: {
                                text: "Loading.."
                            }
                        }
                    }
                };
            }
        },
        {
            key: "_states",
            value: function _states() {
                return [
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Loading, _this);
                        var _super = _create_super._(Loading);
                        function Loading() {
                            _class_call_check._(this, Loading);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Loading, [
                            {
                                key: "$enter",
                                value: function $enter() {
                                    this.tag("Loading").visible = true;
                                }
                            },
                            {
                                key: "$exit",
                                value: function $exit() {
                                    this.tag("Loading").visible = false;
                                }
                            }
                        ]);
                        return Loading;
                    }(this),
                    /*#__PURE__*/ function(_this) {
                        _inherits._(Widgets, _this);
                        var _super = _create_super._(Widgets);
                        function Widgets() {
                            _class_call_check._(this, Widgets);
                            return _super.apply(this, arguments);
                        }
                        _create_class._(Widgets, [
                            {
                                key: "$enter",
                                value: function $enter(args, widget) {
                                    // store widget reference
                                    this._widget = widget;
                                    // since it's possible that this behaviour
                                    // is non-remote driven we force a recalculation
                                    // of the focuspath
                                    this._refocus();
                                }
                            },
                            {
                                key: "_getFocused",
                                value: function _getFocused() {
                                    // we delegate focus to selected widget
                                    // so it can consume remotecontrol presses
                                    return this._widget;
                                }
                            },
                            {
                                // if we want to widget to widget focus delegation
                                key: "reload",
                                value: function reload(widget) {
                                    this._widget = widget;
                                    this._refocus();
                                }
                            },
                            {
                                key: "_handleKey",
                                value: function _handleKey() {
                                    var restoreFocus = _router.routerConfig.get("autoRestoreRemote");
                                    /**
           * The Router used to delegate focus back to the page instance on
           * every unhandled key. This is barely usefull in any situation
           * so for now we offer the option to explicity turn that behaviour off
           * so we don't don't introduce a breaking change.
           */ if (!(0, _helpers.isBoolean)(restoreFocus) || restoreFocus === true) {
                                        _index.default.focusPage();
                                    }
                                }
                            }
                        ]);
                        return Widgets;
                    }(this)
                ];
            }
        }
    ]);
    return RoutedApp;
}(_Lightning.default.Component);


/***/ }),

/***/ 6078:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    // export API
    default: function() {
        return _default;
    },
    getResumeHash: function() {
        return getResumeHash;
    },
    initRouter: function() {
        return initRouter;
    },
    navigate: function() {
        return navigate;
    },
    navigateQueue: function() {
        return navigateQueue;
    },
    step: function() {
        return step;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
var _helpers = __webpack_require__(73137);
var _router = __webpack_require__(69611);
var _widgets = __webpack_require__(11303);
var _history = __webpack_require__(90134);
var _route = __webpack_require__(61035);
var _loader = __webpack_require__(66237);
var _regex = __webpack_require__(51422);
var _base = __webpack_require__(57632);
var _Registry = /*#__PURE__*/ _interop_require_default._(__webpack_require__(8604));
var navigateQueue = new Map();
var forcedHash = "";
var resumeHash = "";
/**
 * Start routing the app
 * @param config - route config object
 * @param instance - instance of the app
 */ var startRouter = function(config, instance) {
    (0, _router.bootRouter)(config, instance);
    registerListener();
    start();
};
// start translating url
var start = function() {
    var hash = (getHash() || "").replace(/^#/, "");
    var bootKey = "$";
    var params = (0, _helpers.getQueryStringParams)(hash);
    var bootRequest = (0, _router.getBootRequest)();
    var rootHash = (0, _router.getRootHash)();
    var isDirectLoad = hash.indexOf(bootKey) !== -1;
    // prevent direct reload of wildcard routes
    // expect bootComponent
    if (_regex.isWildcard.test(hash) && hash !== bootKey) {
        hash = "";
    }
    // store resume point for manual resume
    resumeHash = isDirectLoad ? rootHash : hash || rootHash;
    var ready = function() {
        if (!hash && rootHash) {
            if ((0, _helpers.isString)(rootHash)) {
                navigate(rootHash);
            } else if ((0, _helpers.isFunction)(rootHash)) {
                rootHash().then(function(res) {
                    if ((0, _helpers.isObject)(res)) {
                        navigate(res.path, res.params);
                    } else {
                        navigate(res);
                    }
                });
            }
        } else {
            queue(hash);
            handleHashChange().then(function() {
                _router.app._refocus();
            }).catch(function(e) {
                console.error(e);
            });
        }
    };
    if ((0, _router.routeExists)(bootKey)) {
        if (hash && !isDirectLoad) {
            if (!(0, _route.getRouteByHash)(hash)) {
                navigate("*", {
                    failedHash: hash
                });
                return;
            }
        }
        navigate(bootKey, {
            resume: resumeHash,
            reload: bootKey === hash
        }, false);
    } else if ((0, _helpers.isFunction)(bootRequest)) {
        bootRequest(params).then(function() {
            ready();
        }).catch(function(e) {
            handleBootError(e);
        });
    } else {
        ready();
    }
};
var handleBootError = function(e) {
    if ((0, _router.routeExists)("!")) {
        navigate("!", {
            request: {
                error: e
            }
        });
    } else {
        console.error(e);
    }
};
var navigate = function(url) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, store = arguments.length > 2 ? arguments[2] : void 0;
    if ((0, _helpers.isObject)(url)) {
        url = (0, _route.getHashByName)(url);
        if (!url) {
            return;
        }
    }
    var hash = getHash();
    if (!(0, _router.mustUpdateLocationHash)() && forcedHash) {
        hash = forcedHash;
    }
    if (hash.replace(/^#/, "") !== url) {
        // push request in the queue
        queue(url, args, store);
        if ((0, _router.mustUpdateLocationHash)()) {
            setHash(url);
        } else {
            forcedHash = url;
            handleHashChange(url).then(function() {
                _router.app._refocus();
            }).catch(function(e) {
                console.error(e);
            });
        }
    } else if (args.reload) {
        // push request in the queue
        queue(url, args, store);
        handleHashChange(url).then(function() {
            _router.app._refocus();
        }).catch(function(e) {
            console.error(e);
        });
    }
};
var queue = function(hash) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, store = arguments.length > 2 ? arguments[2] : void 0;
    hash = (0, _helpers.cleanHash)(hash);
    if (!navigateQueue.has(hash)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = navigateQueue.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var request = _step.value;
                request.cancel();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var request1 = (0, _route.createRequest)(hash, args, store);
        navigateQueue.set(decodeURIComponent(hash), request1);
        return request1;
    }
    return false;
};
/**
 * Handle change of hash
 * @param override
 * @returns {Promise<void>}
 */ var handleHashChange = function() {
    var _ref = _async_to_generator._(function(override) {
        var hash, queueId, request, route, result, store;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    hash = (0, _helpers.cleanHash)(override || getHash());
                    queueId = decodeURIComponent(hash);
                    request = navigateQueue.get(queueId);
                    // handle hash updated manually
                    if (!request && !navigateQueue.size) {
                        request = queue(hash);
                    }
                    route = (0, _route.getRouteByHash)(hash);
                    if (!route) {
                        if ((0, _router.routeExists)("*")) {
                            navigate("*", {
                                failedHash: hash
                            });
                        } else {
                            console.error("Unable to navigate to: ".concat(hash));
                        }
                        return [
                            2
                        ];
                    }
                    // update current processed request
                    request.hash = hash;
                    request.route = route;
                    return [
                        4,
                        (0, _router.beforeEachRoute)((0, _router.getActiveHash)(), request)
                    ];
                case 1:
                    result = _state.sent();
                    if (!(result && route.beforeNavigate)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        route.beforeNavigate((0, _router.getActiveHash)(), request)
                    ];
                case 2:
                    result = _state.sent();
                    _state.label = 3;
                case 3:
                    if ((0, _helpers.isBoolean)(result)) {
                        // only if resolve value is explicitly true
                        // we continue the current route request
                        if (result) {
                            return [
                                2,
                                resolveHashChange(request)
                            ];
                        }
                    } else {
                        // if navigation guard didn't return true
                        // we cancel the current request
                        request.cancel();
                        navigateQueue.delete(queueId);
                        if ((0, _helpers.isString)(result)) {
                            navigate(result);
                        } else if ((0, _helpers.isObject)(result)) {
                            store = true;
                            if ((0, _helpers.isBoolean)(result.store)) {
                                store = result.store;
                            }
                            navigate(result.path, result.params, store);
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function handleHashChange(override) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Continue processing the hash change if not blocked
 * by global or local hook
 * @param request - {}
 */ var resolveHashChange = function(request) {
    var hash = request.hash;
    var route = request.route;
    var queueId = decodeURIComponent(hash);
    // store last requested hash so we can
    // prevent a route that resolved later
    // from displaying itself
    (0, _router.setLastHash)(hash);
    if (route.path) {
        var component = (0, _router.getComponent)(route.path);
        // if a hook is provided for the current route
        if ((0, _helpers.isFunction)(route.hook)) {
            var urlParams = (0, _route.getValuesFromHash)(hash, route.path);
            var params = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = urlParams.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    params[key] = urlParams.get(key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            route.hook(_router.app, _object_spread._({}, params));
        }
        // if there is a component attached to the route
        if (component) {
            // force page to root state to prevent shared state issues
            var activePage = (0, _router.getActivePage)();
            if (activePage) {
                var keepAlive = (0, _route.keepActivePageAlive)((0, _router.getActiveRoute)(), request);
                if (activePage && route.path === (0, _router.getActiveRoute)() && !keepAlive) {
                    activePage._setState("");
                }
            }
            if ((0, _helpers.isPage)(component, _router.stage)) {
                (0, _loader.load)(request).then(function() {
                    _router.app._refocus();
                    navigateQueue.delete(queueId);
                });
            } else {
                // of the component is not a constructor
                // or a Component instance we can assume
                // that it's a dynamic import
                component().then(function(contents) {
                    return contents.default;
                }).then(function(module) {
                    (0, _router.storeComponent)(route.path, module);
                    return (0, _loader.load)(request);
                }).then(function() {
                    _router.app._refocus();
                    navigateQueue.delete(queueId);
                });
            }
        } else {
            navigateQueue.delete(queueId);
        }
    }
};
var step = function() {
    var level = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (!level || isNaN(level)) {
        return false;
    }
    var history = (0, _history.getHistory)();
    // for now we only support negative numbers
    level = Math.abs(level);
    //Check whether we have any history avaialble or not
    if (history.length) {
        // for now we only support history back
        var route = history.splice(history.length - level, level)[0];
        // store changed history
        (0, _history.setHistory)(history);
        var _obj;
        return navigate(route.hash, (_obj = {}, _define_property._(_obj, _helpers.symbols.backtrack, true), _define_property._(_obj, _helpers.symbols.historyState, route.state), _obj), false);
    } else if (_router.routerConfig.get("backtrack")) {
        var hashLastPart = /(\/:?[\w%\s-]+)$/;
        var hash = (0, _regex.stripRegex)(getHash());
        var floor = (0, _route.getFloor)(hash);
        // test if we got deep-linked
        if (floor > 1) {
            while(floor--){
                // strip of last part
                hash = hash.replace(hashLastPart, "");
                // if we have a configured route
                // we navigate to it
                if ((0, _route.getRouteByHash)(hash)) {
                    return navigate(hash, _define_property._({}, _helpers.symbols.backtrack, true), false);
                }
            }
        }
    }
    // we can't step back past the amount
    // of history entries
    if (level > history.length) {
        if ((0, _helpers.isFunction)(_router.app._handleAppClose)) {
            return _router.app._handleAppClose();
        }
        return _router.app.application.closeApp();
    }
    return false;
};
/**
 * Resume Router's page loading process after
 * the BootComponent became visible;
 */ var resume = function() {
    if ((0, _helpers.isString)(resumeHash)) {
        navigate(resumeHash, false);
        resumeHash = "";
    } else if ((0, _helpers.isFunction)(resumeHash)) {
        resumeHash().then(function(res) {
            resumeHash = "";
            if ((0, _helpers.isObject)(res)) {
                navigate(res.path, res.params);
            } else {
                navigate(res);
            }
        });
    } else {
        console.warn("[Router]: resume() called but no hash found");
    }
};
/**
 * Force reload active hash
 */ var reload = function() {
    if (!isNavigating()) {
        var hash = (0, _router.getActiveHash)();
        navigate(hash, {
            reload: true
        }, false);
    }
};
/**
 * Query if the Router is still processing a Request
 * @returns {boolean}
 */ var isNavigating = function() {
    if (navigateQueue.size) {
        var isProcessing = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = navigateQueue.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var request = _step.value;
                if (!request.isCancelled) {
                    isProcessing = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return isProcessing;
    }
    return false;
};
var getResumeHash = function() {
    return resumeHash;
};
/**
 * By default we return the location hash
 * @returns {string}
 */ var getHash = function() {
    return document.location.hash;
};
/**
 * Update location hash
 * @param url
 */ var setHash = function(url) {
    document.location.hash = url;
};
var initRouter = function(config) {
    if (config.getHash) {
        getHash = config.getHash;
    }
    if (config.setHash) {
        setHash = config.setHash;
    }
};
/**
 * On hash change we start processing
 */ var registerListener = function() {
    _Registry.default.addEventListener(window, "hashchange", /*#__PURE__*/ _async_to_generator._(function() {
        var e;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0, _router.mustUpdateLocationHash)()) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        handleHashChange()
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    console.error(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }));
};
/**
 * Navigate to root hash
 */ var root = function() {
    var rootHash = (0, _router.getRootHash)();
    if ((0, _helpers.isString)(rootHash)) {
        navigate(rootHash);
    } else if ((0, _helpers.isFunction)(rootHash)) {
        rootHash().then(function(res) {
            if ((0, _helpers.isObject)(res)) {
                navigate(res.path, res.params);
            } else {
                navigate(res);
            }
        });
    }
};
var deletePage = function(param) {
    (0, _router.deleteCurrentInstance)(param);
};
var _default = {
    startRouter: startRouter,
    navigate: navigate,
    resume: resume,
    step: step,
    go: step,
    back: step.bind(null, -1),
    activePage: _router.getActivePage,
    getActivePage: function() {
        // warning
        return (0, _router.getActivePage)();
    },
    deletePage: deletePage,
    getActiveRoute: _router.getActiveRoute,
    getActiveHash: _router.getActiveHash,
    focusWidget: _widgets.focusWidget,
    getActiveWidget: _widgets.getActiveWidget,
    restoreFocus: _widgets.restoreFocus,
    isNavigating: isNavigating,
    getHistory: _history.getHistory,
    setHistory: _history.setHistory,
    getHistoryState: _history.getHistoryState,
    replaceHistoryState: _history.replaceHistoryState,
    getQueryStringParams: _helpers.getQueryStringParams,
    reload: reload,
    symbols: _helpers.symbols,
    App: _base.RoutedApp,
    // keep backwards compatible
    focusPage: _widgets.restoreFocus,
    root: root,
    /**
   * Deprecated api methods
   */ setupRoutes: function() {
        console.warn("Router: setupRoutes is deprecated, consolidate your configuration");
        console.warn("https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration");
    },
    on: function() {
        console.warn("Router.on() is deprecated, consolidate your configuration");
        console.warn("https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration");
    },
    before: function() {
        console.warn("Router.before() is deprecated, consolidate your configuration");
        console.warn("https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration");
    },
    after: function() {
        console.warn("Router.after() is deprecated, consolidate your configuration");
        console.warn("https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration");
    }
};


/***/ }),

/***/ 53942:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Request;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _helpers = __webpack_require__(73137);
var _register = __webpack_require__(36116);
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var Request = /*#__PURE__*/ function() {
    "use strict";
    function Request() {
        var hash = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", navArgs = arguments.length > 1 ? arguments[1] : void 0, storeCaller = arguments.length > 2 ? arguments[2] : void 0;
        _class_call_check._(this, Request);
        /**
     * Hash we navigate to
     * @type {string}
     * @private
     */ this._hash = hash;
        /**
     * Do we store previous hash in history
     * @type {boolean}
     * @private
     */ this._storeCaller = storeCaller;
        /**
     * Request and navigate data
     * @type {Map}
     * @private
     */ this._register = new Map();
        /**
     * Flag if the instance is created due to
     * this request
     * @type {boolean}
     * @private
     */ this._isCreated = false;
        /**
     * Flag if the instance is shared between
     * previous and current request
     * @type {boolean}
     * @private
     */ this._isSharedInstance = false;
        /**
     * Flag if the request has been cancelled
     * @type {boolean}
     * @private
     */ this._cancelled = false;
        /**
     * if instance is shared between requests we copy state object
     * from instance before the new request overrides state
     * @type {null}
     * @private
     */ this._copiedHistoryState = null;
        // if there are arguments attached to navigate()
        // we store them in new request
        if ((0, _helpers.isObject)(navArgs)) {
            this._register = (0, _register.createRegister)(navArgs);
        } else if ((0, _helpers.isBoolean)(navArgs)) {
            // if second navigate() argument is explicitly
            // set to false we prevent the calling page
            // from ending up in history
            this._storeCaller = navArgs;
        }
        // @todo: remove because we can simply check
        // ._storeCaller property
        this._register.set(_helpers.symbols.store, this._storeCaller);
    }
    _create_class._(Request, [
        {
            key: "cancel",
            value: function cancel() {
                _Log.default.debug("[router]:", "cancelled ".concat(this._hash));
                this._cancelled = true;
            }
        },
        {
            key: "url",
            get: function get() {
                return this._hash;
            }
        },
        {
            key: "register",
            get: function get() {
                return this._register;
            }
        },
        {
            key: "hash",
            get: function get() {
                return this._hash;
            },
            set: function set(args) {
                this._hash = args;
            }
        },
        {
            key: "route",
            get: function get() {
                return this._route;
            },
            set: function set(args) {
                this._route = args;
            }
        },
        {
            key: "provider",
            get: function get() {
                return this._provider;
            },
            set: function set(args) {
                this._provider = args;
            }
        },
        {
            key: "providerType",
            get: function get() {
                return this._providerType;
            },
            set: function set(args) {
                this._providerType = args;
            }
        },
        {
            key: "page",
            get: function get() {
                return this._page;
            },
            set: function set(args) {
                this._page = args;
            }
        },
        {
            key: "isCreated",
            get: function get() {
                return this._isCreated;
            },
            set: function set(args) {
                this._isCreated = args;
            }
        },
        {
            key: "isSharedInstance",
            get: function get() {
                return this._isSharedInstance;
            },
            set: function set(args) {
                this._isSharedInstance = args;
            }
        },
        {
            key: "isCancelled",
            get: function get() {
                return this._cancelled;
            }
        },
        {
            key: "copiedHistoryState",
            get: function get() {
                return this._copiedHistoryState;
            },
            set: function set(v) {
                this._copiedHistoryState = v;
            }
        }
    ]);
    return Request;
}();


/***/ }),

/***/ 58646:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return Route;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
var _helpers = __webpack_require__(73137);
var Route = /*#__PURE__*/ function() {
    "use strict";
    function Route() {
        var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check._(this, Route);
        // keep backwards compatible
        var type = [
            "on",
            "before",
            "after"
        ].reduce(function(acc, type) {
            return (0, _helpers.isFunction)(config[type]) ? type : acc;
        }, undefined);
        this._cfg = config;
        if (type) {
            this._provider = {
                type: type,
                request: config[type]
            };
        }
    }
    _create_class._(Route, [
        {
            key: "path",
            get: function get() {
                return this._cfg.path;
            }
        },
        {
            key: "name",
            get: function get() {
                return this._cfg.name;
            }
        },
        {
            key: "component",
            get: function get() {
                return this._cfg.component;
            }
        },
        {
            key: "options",
            get: function get() {
                return this._cfg.options;
            }
        },
        {
            key: "widgets",
            get: function get() {
                return this._cfg.widgets;
            }
        },
        {
            key: "cache",
            get: function get() {
                return this._cfg.cache;
            }
        },
        {
            key: "hook",
            get: function get() {
                return this._cfg.hook;
            }
        },
        {
            key: "beforeNavigate",
            get: function get() {
                return this._cfg.beforeNavigate;
            }
        },
        {
            key: "provider",
            get: function get() {
                return this._provider;
            }
        }
    ]);
    return Route;
}();


/***/ }),

/***/ 16181:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _define_property = __webpack_require__(21228);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
var fade = function(i, o) {
    return new Promise(function(resolve) {
        i.patch({
            alpha: 0,
            visible: true,
            smooth: {
                alpha: [
                    1,
                    {
                        duration: 0.5,
                        delay: 0.1
                    }
                ]
            }
        });
        // resolve on y finish
        i.transition("alpha").on("finish", function() {
            if (o) {
                o.visible = false;
            }
            resolve();
        });
    });
};
var crossFade = function(i, o) {
    return new Promise(function(resolve) {
        i.patch({
            alpha: 0,
            visible: true,
            smooth: {
                alpha: [
                    1,
                    {
                        duration: 0.5,
                        delay: 0.1
                    }
                ]
            }
        });
        if (o) {
            o.patch({
                smooth: {
                    alpha: [
                        0,
                        {
                            duration: 0.5,
                            delay: 0.3
                        }
                    ]
                }
            });
        }
        // resolve on y finish
        i.transition("alpha").on("finish", function() {
            resolve();
        });
    });
};
var moveOnAxes = function(axis, direction, i, o) {
    var bounds = axis === "x" ? 1920 : 1080;
    return new Promise(function(resolve) {
        var _obj;
        i.patch((_obj = {}, _define_property._(_obj, "".concat(axis), direction ? bounds * -1 : bounds), _define_property._(_obj, "visible", true), _define_property._(_obj, "smooth", _define_property._({}, "".concat(axis), [
            0,
            {
                duration: 0.4,
                delay: 0.2
            }
        ])), _obj));
        // out is optional
        if (o) {
            var _obj1;
            o.patch((_obj1 = {}, _define_property._(_obj1, "".concat(axis), 0), _define_property._(_obj1, "smooth", _define_property._({}, "".concat(axis), [
                direction ? bounds : bounds * -1,
                {
                    duration: 0.4,
                    delay: 0.2
                }
            ])), _obj1));
        }
        // resolve on y finish
        i.transition(axis).on("finish", function() {
            resolve();
        });
    });
};
var up = function(i, o) {
    return moveOnAxes("y", 0, i, o);
};
var down = function(i, o) {
    return moveOnAxes("y", 1, i, o);
};
var left = function(i, o) {
    return moveOnAxes("x", 0, i, o);
};
var right = function(i, o) {
    return moveOnAxes("x", 1, i, o);
};
var _default = {
    fade: fade,
    crossFade: crossFade,
    up: up,
    down: down,
    left: left,
    right: right
};


/***/ }),

/***/ 590:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "createComponent", ({
    enumerable: true,
    get: function() {
        return createComponent;
    }
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var _widgets = __webpack_require__(11303);
var createComponent = function(stage, type) {
    return stage.c({
        type: type,
        visible: false,
        widgets: (0, _widgets.getReferences)()
    });
};


/***/ }),

/***/ 73529:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _helpers = __webpack_require__(73137);
var _default = function(page) {
    var events = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!(0, _helpers.isArray)(events)) {
        events = [
            events
        ];
    }
    events.forEach(function(e) {
        var event = "_on".concat((0, _helpers.ucfirst)(e));
        if ((0, _helpers.isFunction)(page[event])) {
            page[event](params);
        }
    });
};


/***/ }),

/***/ 73137:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cleanHash: function() {
        return cleanHash;
    },
    getConfigMap: function() {
        return getConfigMap;
    },
    getQueryStringParams: function() {
        return getQueryStringParams;
    },
    incorrectParams: function() {
        return incorrectParams;
    },
    isArray: function() {
        return isArray;
    },
    isBoolean: function() {
        return isBoolean;
    },
    isComponentConstructor: function() {
        return isComponentConstructor;
    },
    isFunction: function() {
        return isFunction;
    },
    isObject: function() {
        return isObject;
    },
    isPage: function() {
        return isPage;
    },
    isPromise: function() {
        return isPromise;
    },
    isString: function() {
        return isString;
    },
    objectToQueryString: function() {
        return objectToQueryString;
    },
    symbols: function() {
        return symbols;
    },
    ucfirst: function() {
        return ucfirst;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var _Settings = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52452));
var _router = __webpack_require__(69611);
var _index = __webpack_require__(6078);
var isFunction = function(v) {
    return typeof v === "function";
};
var isObject = function(v) {
    return typeof v === "object" && v !== null;
};
var isBoolean = function(v) {
    return typeof v === "boolean";
};
var isPage = function(v) {
    if (v instanceof _Lightning.default.Element || isComponentConstructor(v)) {
        return true;
    }
    return false;
};
var isComponentConstructor = function(type) {
    return type.prototype && "isComponent" in type.prototype;
};
var isArray = function(v) {
    return Array.isArray(v);
};
var ucfirst = function(v) {
    return "".concat(v.charAt(0).toUpperCase()).concat(v.slice(1));
};
var isString = function(v) {
    return typeof v === "string";
};
var isPromise = function(method) {
    var result;
    if (isFunction(method)) {
        try {
            result = method.apply(null);
        } catch (e) {
            result = e;
        }
    } else {
        result = method;
    }
    return isObject(result) && isFunction(result.then);
};
var cleanHash = function() {
    var hash = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return hash.replace(/^#/, "").replace(/\/+$/, "");
};
var getConfigMap = function() {
    var routerSettings = _Settings.default.get("platform", "router");
    var isObj = isObject(routerSettings);
    return [
        "backtrack",
        "gcOnUnload",
        "destroyOnHistoryBack",
        "lazyCreate",
        "lazyDestroy",
        "reuseInstance",
        "autoRestoreRemote",
        "numberNavigation",
        "updateHash",
        "storeSameHash"
    ].reduce(function(config, key) {
        config.set(key, isObj ? routerSettings[key] : _Settings.default.get("platform", key));
        return config;
    }, new Map());
};
var incorrectParams = function(cb, route) {
    var isIncorrect = /^\w*?\s?\(\s?\{.*?\}\s?\)/i;
    if (isIncorrect.test(cb.toString())) {
        console.warn([
            "DEPRECATION: The data-provider for route: ".concat(route, " is not correct."),
            '"page" is no longer a property of the params object but is now the first function parameter: ',
            "https://github.com/rdkcentral/Lightning-SDK/blob/feature/router/docs/plugins/router/dataproviding.md#data-providing",
            "It's supported for now but will be removed in a future release."
        ].join("\n"));
        return true;
    }
    return false;
};
var getQueryStringParams = function() {
    var hash = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _router.getActiveHash)();
    var resumeHash = (0, _index.getResumeHash)();
    if ((hash === "$" || !hash) && resumeHash) {
        if (isString(resumeHash)) {
            hash = resumeHash;
        }
    }
    var parse = "";
    var getQuery = /([?&].*)/;
    var matches = getQuery.exec(hash);
    var params = {};
    if (document.location && document.location.search) {
        parse = document.location.search;
    }
    if (matches && matches.length) {
        var hashParams = matches[1];
        if (parse) {
            // if location.search is not empty we
            // remove the leading ? to create a
            // valid string
            hashParams = hashParams.replace(/^\?/, "");
            // we parse hash params last so they we can always
            // override search params with hash params
            parse = "".concat(parse, "&").concat(hashParams);
        } else {
            parse = hashParams;
        }
    }
    if (parse) {
        var urlParams = new URLSearchParams(parse);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = urlParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array._(_step.value, 2), key = _step_value[0], value = _step_value[1];
                params[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return params;
    } else {
        return false;
    }
};
var objectToQueryString = function(obj) {
    if (!isObject(obj)) {
        return "";
    }
    return "?" + Object.keys(obj).map(function(key) {
        return "".concat(key, "=").concat(obj[key]);
    }).join("&");
};
var symbols = {
    route: Symbol("route"),
    hash: Symbol("hash"),
    store: Symbol("store"),
    fromHistory: Symbol("fromHistory"),
    expires: Symbol("expires"),
    resume: Symbol("resume"),
    backtrack: Symbol("backtrack"),
    historyState: Symbol("historyState"),
    queryParams: Symbol("queryParams")
};


/***/ }),

/***/ 90134:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getHistory: function() {
        return getHistory;
    },
    getHistoryState: function() {
        return getHistoryState;
    },
    replaceHistoryState: function() {
        return replaceHistoryState;
    },
    setHistory: function() {
        return setHistory;
    },
    updateHistory: function() {
        return updateHistory;
    }
});
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
var _router = __webpack_require__(69611);
var _route = __webpack_require__(61035);
var _helpers = __webpack_require__(73137);
/**
 * Simple flat array that holds the visited hashes + state Object
 * so the router can navigate back to them
 * @type {Array}
 */ var history = [];
var updateHistory = function(request) {
    var hash = (0, _router.getActiveHash)();
    if (!hash) {
        return;
    }
    // navigate storage flag
    var register = request.register;
    var forceNavigateStore = register.get(_helpers.symbols.store);
    // test preventStorage on route configuration
    var activeRoute = (0, _route.getRouteByHash)(hash);
    var preventStorage = (0, _route.getOption)(activeRoute.options, "preventStorage");
    // we give prio to navigate storage flag
    var store = (0, _helpers.isBoolean)(forceNavigateStore) ? forceNavigateStore : !preventStorage;
    if (store) {
        var toStore = hash.replace(/^\//, "");
        var location = locationInHistory(toStore);
        var stateObject = getStateObject((0, _router.getActivePage)(), request);
        var routerConfig = (0, _router.getRouterConfig)();
        // store hash if it's not a part of history or flag for
        // storage of same hash is true
        if (location === -1 || routerConfig.get("storeSameHash")) {
            history.push({
                hash: toStore,
                state: stateObject
            });
        } else {
            // if we visit the same route we want to sync history
            var prev = history.splice(location, 1)[0];
            history.push({
                hash: prev.hash,
                state: stateObject
            });
        }
    }
};
var locationInHistory = function(hash) {
    for(var i = 0; i < history.length; i++){
        if (history[i].hash === hash) {
            return i;
        }
    }
    return -1;
};
var getHistoryState = function(hash) {
    var state = null;
    if (history.length) {
        // if no hash is provided we get the last
        // pushed history record
        if (!hash) {
            var record = history[history.length - 1];
            // could be null
            state = record.state;
        } else {
            if (locationInHistory(hash) !== -1) {
                var record1 = history[locationInHistory(hash)];
                state = record1.state;
            }
        }
    }
    return state;
};
var replaceHistoryState = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, hash = arguments.length > 1 ? arguments[1] : void 0;
    if (!history.length) {
        return;
    }
    var location = hash ? locationInHistory(hash) : history.length - 1;
    if (location !== -1 && (0, _helpers.isObject)(state)) {
        history[location].state = state;
    }
};
var getStateObject = function(page, request) {
    // if the new request shared instance with the
    // previous request we used the copied state object
    if (request.isSharedInstance) {
        if (request.copiedHistoryState) {
            return request.copiedHistoryState;
        }
    } else if (page && (0, _helpers.isFunction)(page.historyState)) {
        return page.historyState();
    }
    return null;
};
var getHistory = function() {
    return history.slice(0);
};
var setHistory = function() {
    var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if ((0, _helpers.isArray)(arr)) {
        history = arr;
    }
};


/***/ }),

/***/ 66237:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    load: function() {
        return load;
    },
    mustReuse: function() {
        return mustReuse;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _router = __webpack_require__(69611);
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _helpers = __webpack_require__(73137);
var _provider = __webpack_require__(84098);
var _components = __webpack_require__(590);
var _transition = __webpack_require__(29796);
var _widgets = __webpack_require__(11303);
var _emit = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73529));
var _route = __webpack_require__(61035);
var _index = __webpack_require__(6078);
var _history = __webpack_require__(90134);
var _regex = __webpack_require__(51422);
var load = function() {
    var _ref = _async_to_generator._(function(request) {
        var expired, request1, route;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    expired = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        loader(request)
                    ];
                case 2:
                    request = _state.sent();
                    if (!(request && !request.isCancelled)) return [
                        3,
                        5
                    ];
                    // in case of on() providing we need to reset
                    // app state;
                    if (_router.app.state === "Loading") {
                        if ((0, _router.getPreviousState)() === "Widgets") {
                            _router.app._setState("Widgets", [
                                (0, _widgets.getActiveWidget)()
                            ]);
                        } else {
                            _router.app._setState("");
                        }
                    }
                    if (!(!request.isSharedInstance && !request.isCancelled)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, _transition.executeTransition)(request.page, (0, _router.getActivePage)())
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    expired = true;
                    _state.label = 6;
                case 6:
                    // on expired we only cleanup
                    if (expired || request.isCancelled) {
                        _Log.default.debug("[router]:", "Rejected ".concat(request.hash, " because route to ").concat((0, _router.getLastHash)(), " started"));
                        if (request.isCreated && !request.isSharedInstance) {
                            // remove from render-tree
                            _router.pagesHost.remove(request.page);
                        }
                    } else {
                        (0, _router.onRequestResolved)(request);
                        // resolve promise
                        return [
                            2,
                            request.page
                        ];
                    }
                    return [
                        3,
                        8
                    ];
                case 7:
                    request1 = _state.sent();
                    if (!request1.route) {
                        console.error(request1);
                    } else if (!expired) {
                        // @todo: revisit
                        route = request1.route;
                        // clean up history if modifier is set
                        if ((0, _route.getOption)(route.options, "clearHistory")) {
                            (0, _history.setHistory)([]);
                        } else if (!_regex.isWildcard.test(route.path)) {
                            (0, _history.updateHistory)(request1);
                        }
                        if (request1.isCreated && !request1.isSharedInstance) {
                            // remove from render-tree
                            _router.pagesHost.remove(request1.page);
                        }
                        handleError(request1);
                    }
                    return [
                        3,
                        8
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function load(request) {
        return _ref.apply(this, arguments);
    };
}();
var loader = function() {
    var _ref = _async_to_generator._(function(request) {
        var route, hash, register, type, isConstruct, provide, currentRoute, _getProvider, loadType, provider, e;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    route = request.route;
                    hash = request.hash;
                    register = request.register;
                    // todo: grab from Route instance
                    type = (0, _router.getComponent)(route.path);
                    isConstruct = (0, _helpers.isComponentConstructor)(type);
                    provide = false;
                    // if it's an instance bt we're not coming back from
                    // history we test if we can re-use this instance
                    if (!isConstruct && !register.get(_helpers.symbols.backtrack)) {
                        if (!mustReuse(route)) {
                            type = type.constructor;
                            isConstruct = true;
                        }
                    }
                    // If page is Lightning Component instance
                    if (!isConstruct) {
                        request.page = type;
                        // if we have have a data route for current page
                        if ((0, _provider.hasProvider)(route.path)) {
                            if ((0, _provider.isPageExpired)(type) || type[_helpers.symbols.hash] !== hash) {
                                provide = true;
                            }
                        }
                        currentRoute = (0, _router.getActivePage)() && (0, _router.getActivePage)()[_helpers.symbols.route];
                        // if the new route is equal to the current route it means that both
                        // route share the Component instance and stack location / since this case
                        // is conflicting with the way before() and after() loading works we flag it,
                        // and check platform settings in we want to re-use instance
                        if (route.path === currentRoute) {
                            request.isSharedInstance = true;
                            // since we're re-using the instance we must attach
                            // historyState to the request to prevent it from
                            // being overridden.
                            if ((0, _helpers.isFunction)(request.page.historyState)) {
                                request.copiedHistoryState = request.page.historyState();
                            }
                        }
                    } else {
                        request.page = (0, _components.createComponent)(_router.stage, type);
                        _router.pagesHost.a(request.page);
                        // test if need to request data provider
                        if ((0, _provider.hasProvider)(route.path)) {
                            provide = true;
                        }
                        request.isCreated = true;
                    }
                    // we store hash and route as properties on the page instance
                    // that way we can easily calculate new behaviour on page reload
                    request.page[_helpers.symbols.hash] = hash;
                    request.page[_helpers.symbols.route] = route.path;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    if (!provide) return [
                        3,
                        3
                    ];
                    // extract attached data-provider for route
                    // we're processing
                    _getProvider = (0, _provider.getProvider)(route), loadType = _getProvider.type, provider = _getProvider.provider;
                    // update running request
                    request.provider = provider;
                    request.providerType = loadType;
                    return [
                        4,
                        _provider.dataHooks[loadType](request)
                    ];
                case 2:
                    _state.sent();
                    // we early exit if the current request is expired
                    if (hash !== (0, _router.getLastHash)()) {
                        return [
                            2,
                            false
                        ];
                    } else {
                        if (request.providerType !== "after") {
                            (0, _emit.default)(request.page, "dataProvided");
                        }
                        // resolve promise
                        return [
                            2,
                            request
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    (0, _provider.addPersistData)(request);
                    return [
                        2,
                        request
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    request.error = e;
                    return [
                        2,
                        Promise.reject(request)
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function loader(request) {
        return _ref.apply(this, arguments);
    };
}();
var handleError = function(request) {
    if (request && request.error) {
        console.error(request.error);
    } else if (request) {
        _Log.default.error(request);
    }
    if (request.page && (0, _router.routeExists)("!")) {
        (0, _index.navigate)("!", {
            request: request
        }, false);
    }
};
var mustReuse = function(route) {
    var opt = (0, _route.getOption)(route.options, "reuseInstance");
    var config = _router.routerConfig.get("reuseInstance");
    // route always has final decision
    if ((0, _helpers.isBoolean)(opt)) {
        return opt;
    }
    return !((0, _helpers.isBoolean)(config) && config === false);
};


/***/ }),

/***/ 84098:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    addPersistData: function() {
        return addPersistData;
    },
    dataHooks: function() {
        return dataHooks;
    },
    getProvider: function() {
        return getProvider;
    },
    hasProvider: function() {
        return hasProvider;
    },
    isPageExpired: function() {
        return isPageExpired;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _sliced_to_array = __webpack_require__(28966);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var _helpers = __webpack_require__(73137);
var _router = __webpack_require__(69611);
var _route = __webpack_require__(61035);
var _emit = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73529));
var dataHooks = {
    on: function(request) {
        (0, _router.setPreviousState)(_router.app.state || "");
        _router.app._setState("Loading");
        return execProvider(request);
    },
    before: function(request) {
        return execProvider(request);
    },
    after: function(request) {
        try {
            execProvider(request, true);
        } catch (e) {
        // for now we fail silently
        }
        return Promise.resolve();
    }
};
var execProvider = function(request, emitProvided) {
    var route = request.route;
    var provider = route.provider;
    var expires = route.cache ? route.cache * 1000 : 0;
    var params = addPersistData(request);
    return provider.request(request.page, _object_spread._({}, params)).then(function() {
        request.page[_helpers.symbols.expires] = Date.now() + expires;
        if (emitProvided) {
            (0, _emit.default)(request.page, "dataProvided");
        }
    }).catch(function(e) {
        request.page[_helpers.symbols.expires] = Date.now();
        throw e;
    });
};
var addPersistData = function(param) {
    var page = param.page, route = param.route, hash = param.hash, _param_register = param.register, register = _param_register === void 0 ? new Map() : _param_register;
    var urlValues = (0, _route.getValuesFromHash)(hash, route.path);
    var queryParams = (0, _helpers.getQueryStringParams)(hash);
    var pageData = new Map(_to_consumable_array._(urlValues).concat(_to_consumable_array._(register)));
    var params = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // make dynamic url data available to the page
        // as instance properties
        for(var _iterator = pageData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array._(_step.value, 2), name = _step_value[0], value = _step_value[1];
            params[name] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (queryParams) {
        params[_helpers.symbols.queryParams] = queryParams;
    }
    // check navigation register for persistent data
    if (register.size) {
        var obj = {};
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = register[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value1 = _sliced_to_array._(_step1.value, 2), k = _step_value1[0], v = _step_value1[1];
                obj[k] = v;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        page.persist = obj;
    }
    // make url data and persist data available
    // via params property
    page.params = params;
    (0, _emit.default)(page, [
        "urlParams"
    ], params);
    return params;
};
var isPageExpired = function(page) {
    if (!page[_helpers.symbols.expires]) {
        return false;
    }
    var expires = page[_helpers.symbols.expires];
    var now = Date.now();
    return now >= expires;
};
var hasProvider = function(path) {
    if ((0, _router.routeExists)(path)) {
        var record = _router.routes.get(path);
        return !!record.provider;
    }
    return false;
};
var getProvider = function(route) {
    // @todo: fix, route already is passed in
    if ((0, _router.routeExists)(route.path)) {
        var provider = _router.routes.get(route.path).provider;
        return {
            type: provider.type,
            provider: provider.request
        };
    }
};


/***/ }),

/***/ 51422:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    hasLookupId: function() {
        return hasLookupId;
    },
    hasRegex: function() {
        return hasRegex;
    },
    isNamedGroup: function() {
        return isNamedGroup;
    },
    isWildcard: function() {
        return isWildcard;
    },
    stripRegex: function() {
        return stripRegex;
    }
});
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
var hasRegex = /\{\/(.*?)\/([igm]{0,3})\}/g;
var isWildcard = /^[!*$]$/;
var hasLookupId = /\/:\w+?@@([0-9]+?)@@/;
var isNamedGroup = /^\/:/;
var stripRegex = function(route) {
    var char = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "R";
    // if route is part regular expressed we replace
    // the regular expression for a character to
    // simplify floor calculation and backtracking
    if (hasRegex.test(route)) {
        route = route.replace(hasRegex, char);
    }
    return route;
};


/***/ }),

/***/ 36116:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a local request register
 * @param flags
 * @returns {Map<any, any>}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "createRegister", ({
    enumerable: true,
    get: function() {
        return createRegister;
    }
}));
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
var createRegister = function(flags) {
    var reg = new Map();
    _to_consumable_array._(Object.keys(flags)).concat(_to_consumable_array._(Object.getOwnPropertySymbols(flags))).forEach(function(key) {
        reg.set(key, flags[key]);
    });
    return reg;
};


/***/ }),

/***/ 61035:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createRequest: function() {
        return createRequest;
    },
    createRoute: function() {
        return createRoute;
    },
    getFloor: function() {
        return getFloor;
    },
    getHashByName: function() {
        return getHashByName;
    },
    getOption: function() {
        return getOption;
    },
    getRouteByHash: function() {
        return getRouteByHash;
    },
    getValuesFromHash: function() {
        return getValuesFromHash;
    },
    keepActivePageAlive: function() {
        return keepActivePageAlive;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var _regex = __webpack_require__(51422);
var _router = __webpack_require__(69611);
var _Request = /*#__PURE__*/ _interop_require_default._(__webpack_require__(53942));
var _Route = /*#__PURE__*/ _interop_require_default._(__webpack_require__(58646));
var _helpers = __webpack_require__(73137);
var getFloor = function(route) {
    return (0, _regex.stripRegex)(route).split("/").length;
};
/**
 * return all stored routes that live on the same floor
 * @param floor
 * @returns {Array}
 */ var getRoutesByFloor = function(floor) {
    var matches = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // simple filter of level candidates
        for(var _iterator = _router.routes.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array._(_step.value, 1), route = _step_value[0];
            if (getFloor(route) === floor) {
                matches.push(route);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return matches;
};
var getRouteByHash = function(hash) {
    // @todo: clean up on handleHash
    hash = hash.replace(/^#/, "");
    var getUrlParts = /(\/?:?[^/]+)/g;
    // grab possible candidates from stored routes
    var candidates = getRoutesByFloor(getFloor(hash));
    // break hash down in chunks
    var hashParts = hash.match(getUrlParts) || [];
    // to simplify the route matching and prevent look around
    // in our getUrlParts regex we get the regex part from
    // route candidate and store them so that we can reference
    // them when we perform the actual regex against hash
    var regexStore = [];
    var matches = candidates.filter(function(route) {
        var isMatching = true;
        // replace regex in route with lookup id => @@{storeId}@@
        if (_regex.hasRegex.test(route)) {
            var regMatches = route.match(_regex.hasRegex);
            if (regMatches && regMatches.length) {
                route = regMatches.reduce(function(fullRoute, regex) {
                    var lookupId = regexStore.length;
                    fullRoute = fullRoute.replace(regex, "@@".concat(lookupId, "@@"));
                    regexStore.push(regex.substring(1, regex.length - 1));
                    return fullRoute;
                }, route);
            }
        }
        var routeParts = route.match(getUrlParts) || [];
        for(var i = 0, j = routeParts.length; i < j; i++){
            var routePart = routeParts[i];
            var hashPart = hashParts[i];
            // Since we support catch-all and regex driven name groups
            // we first test for regex lookup id and see if the regex
            // matches the value from the hash
            if (_regex.hasLookupId.test(routePart)) {
                var routeMatches = _regex.hasLookupId.exec(routePart);
                var storeId = routeMatches[1];
                var routeRegex = regexStore[storeId];
                // split regex and modifiers so we can use both
                // to create a new RegExp
                // eslint-disable-next-line
                var regMatches1 = /\/([^\/]+)\/([igm]{0,3})/.exec(routeRegex);
                if (regMatches1 && regMatches1.length) {
                    var expression = regMatches1[1];
                    var modifiers = regMatches1[2];
                    var regex = new RegExp("^/".concat(expression, "$"), modifiers);
                    if (!regex.test(hashPart)) {
                        isMatching = false;
                    }
                }
            } else if (_regex.isNamedGroup.test(routePart)) {
                continue;
            } else if (hashPart && routePart.toLowerCase() !== hashPart.toLowerCase()) {
                isMatching = false;
            }
        }
        return isMatching;
    });
    if (matches.length) {
        if (matches.indexOf(hash) !== -1) {
            var match = matches[matches.indexOf(hash)];
            return _router.routes.get(match);
        } else {
            // we give prio to static routes over dynamic
            matches = matches.sort(function(a) {
                return _regex.isNamedGroup.test(a) ? -1 : 1;
            });
            // would be strange if this fails
            // but still we test
            if ((0, _router.routeExists)(matches[0])) {
                return _router.routes.get(matches[0]);
            }
        }
    }
    return false;
};
var getValuesFromHash = function() {
    var hash = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", path = arguments.length > 1 ? arguments[1] : void 0;
    // replace the regex definition from the route because
    // we already did the matching part
    path = (0, _regex.stripRegex)(path, "");
    var getUrlParts = /(\/?:?[\w%\s:.-]+)/g;
    var hashParts = hash.match(getUrlParts) || [];
    var routeParts = path.match(getUrlParts) || [];
    var getNamedGroup = /^\/:([\w-]+)\/?/;
    return routeParts.reduce(function(storage, value, index) {
        var match = getNamedGroup.exec(value);
        if (match && match.length) {
            storage.set(match[1], decodeURIComponent(hashParts[index].replace(/^\//, "")));
        }
        return storage;
    }, new Map());
};
var getOption = function(stack, prop) {
    // eslint-disable-next-line
    if (stack && stack.hasOwnProperty(prop)) {
        return stack[prop];
    }
// we explicitly return undefined since we're testing
// for explicit test values
};
var createRoute = function(config) {
    // we need to provide a bit of additional logic
    // for the bootComponent
    if (config.path === "$") {
        var options = {
            preventStorage: true
        };
        if ((0, _helpers.isObject)(config.options)) {
            options = _object_spread._({}, config.options, options);
        }
        config.options = options;
        // if configured add reference to bootRequest
        // as router after provider
        if (_router.bootRequest) {
            config.after = _router.bootRequest;
        }
    }
    return new _Route.default(config);
};
var createRequest = function(url, args, store) {
    return new _Request.default(url, args, store);
};
var getHashByName = function(obj) {
    if (!obj.to && !obj.name) {
        return false;
    }
    var route = getRouteByName(obj.to || obj.name);
    var hasDynamicGroup = /\/:([\w-]+)\/?/;
    var hash = route;
    // if route contains dynamic group
    // we replace them with the provided params
    if (hasDynamicGroup.test(route)) {
        if (obj.params) {
            var keys = Object.keys(obj.params);
            hash = keys.reduce(function(acc, key) {
                return acc.replace(":".concat(key), obj.params[key]);
            }, route);
        }
        if (obj.query) {
            return "".concat(hash).concat((0, _helpers.objectToQueryString)(obj.query));
        }
    }
    return hash;
};
var getRouteByName = function(name) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = _router.routes.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array._(_step.value, 2), path = _step_value[0], route = _step_value[1];
            if (route.name === name) {
                return path;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
var keepActivePageAlive = function(route, request) {
    if ((0, _helpers.isString)(route)) {
        var routes = (0, _router.getRoutes)();
        if (routes.has(route)) {
            route = routes.get(route);
        } else {
            return false;
        }
    }
    var register = request.register;
    var routeOptions = route.options;
    if (register.has("keepAlive")) {
        return register.get("keepAlive");
    } else if (routeOptions && routeOptions.keepAlive) {
        return routeOptions.keepAlive;
    }
    return false;
};


/***/ }),

/***/ 69611:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    afterEachRoute: function() {
        return afterEachRoute;
    },
    app: function() {
        return app;
    },
    application: function() {
        return application;
    },
    beforeEachRoute: function() {
        return beforeEachRoute;
    },
    bootRequest: function() {
        return bootRequest;
    },
    bootRouter: function() {
        return bootRouter;
    },
    components: function() {
        return components;
    },
    deleteCurrentInstance: function() {
        return deleteCurrentInstance;
    },
    getActiveHash: function() {
        return getActiveHash;
    },
    getActivePage: function() {
        return getActivePage;
    },
    getActiveRoute: function() {
        return getActiveRoute;
    },
    getBootRequest: function() {
        return getBootRequest;
    },
    getComponent: function() {
        return getComponent;
    },
    getLastHash: function() {
        return getLastHash;
    },
    getPreviousState: function() {
        return getPreviousState;
    },
    getRootHash: function() {
        return getRootHash;
    },
    getRouterConfig: function() {
        return getRouterConfig;
    },
    getRoutes: function() {
        return getRoutes;
    },
    mustUpdateLocationHash: function() {
        return mustUpdateLocationHash;
    },
    onRequestResolved: function() {
        return onRequestResolved;
    },
    pagesHost: function() {
        return pagesHost;
    },
    routeExists: function() {
        return routeExists;
    },
    routerConfig: function() {
        return routerConfig;
    },
    routes: function() {
        return routes;
    },
    setActiveHash: function() {
        return setActiveHash;
    },
    setActivePage: function() {
        return setActivePage;
    },
    setLastHash: function() {
        return setLastHash;
    },
    setPreviousState: function() {
        return setPreviousState;
    },
    stage: function() {
        return stage;
    },
    storeComponent: function() {
        return storeComponent;
    },
    updateHash: function() {
        return updateHash;
    },
    widgetsHost: function() {
        return widgetsHost;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
var _helpers = __webpack_require__(73137);
var _index = __webpack_require__(6078);
var _route = __webpack_require__(61035);
var _components = __webpack_require__(590);
var _Log = /*#__PURE__*/ _interop_require_default._(__webpack_require__(85889));
var _regex = __webpack_require__(51422);
var _emit = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73529));
var _widgets = __webpack_require__(11303);
var _history = __webpack_require__(90134);
var _Application = __webpack_require__(92010);
var application;
var app;
var pagesHost;
var stage;
var routerConfig;
var widgetsHost;
/**
 * Hash we point the browser to when we boot the app
 * and there is no deep-link provided
 * @type {string|Function}
 */ var rootHash;
var bootRequest;
var updateHash = true;
var beforeEachRoute = function() {
    var _ref = _async_to_generator._(function(from, to) {
        return _ts_generator._(this, function(_state) {
            return [
                2,
                true
            ];
        });
    });
    return function beforeEachRoute(from, to) {
        return _ref.apply(this, arguments);
    };
}();
var afterEachRoute = function() {};
var routes = new Map();
var components = new Map();
/**
 * Flag if router has been initialised
 * @type {boolean}
 */ var initialised = false;
/**
 * Current page being rendered on screen
 * @type {null}
 */ var activePage = null;
var activeHash;
var activeRoute;
/**
 *  During the process of a navigation request a new
 *  request can start, to prevent unwanted behaviour
 *  the navigate()-method stores the last accepted hash
 *  so we can invalidate any prior requests
 */ var lastAcceptedHash;
/**
 * With on()-data providing behaviour the Router forced the App
 * in a Loading state. When the data-provider resolves we want to
 * change the state back to where we came from
 */ var previousState;
var mixin = function(app) {
    // by default the Router Baseclass provides the component
    // reference in which we store our pages
    if (app.pages) {
        pagesHost = app.pages.childList;
    }
    // if the app is using widgets we grab refs
    // and hide all the widgets
    if (app.widgets && app.widgets.children) {
        widgetsHost = app.widgets.childList;
        // hide all widgets on boot
        widgetsHost.forEach(function(w) {
            return w.visible = false;
        });
    }
    app._handleBack = function(e) {
        (0, _index.step)(-1);
        e.preventDefault();
    };
};
var bootRouter = function(config, instance) {
    var appInstance = config.appInstance, routes = config.routes;
    // if instance is provided and it's and Lightning Component instance
    if (instance && (0, _helpers.isPage)(instance)) {
        app = instance;
    }
    if (!app) {
        app = appInstance || _Application.AppInstance;
    }
    application = app.application;
    pagesHost = application.childList;
    stage = app.stage;
    routerConfig = (0, _helpers.getConfigMap)();
    mixin(app);
    if ((0, _helpers.isArray)(routes)) {
        setup(config);
    } else if ((0, _helpers.isFunction)(routes)) {
        console.warn("[Router]: Calling Router.route() directly is deprecated.");
        console.warn("Use object config: https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration");
    }
};
var setup = function(config) {
    if (!initialised) {
        init(config);
    }
    config.routes.forEach(function(r) {
        var path = (0, _helpers.cleanHash)(r.path);
        if (!routeExists(path)) {
            var route = (0, _route.createRoute)(r);
            routes.set(path, route);
            // if route has a configured component property
            // we store it in a different map to simplify
            // the creating and destroying per route
            if (route.component) {
                var type = route.component;
                if ((0, _helpers.isComponentConstructor)(type)) {
                    if (!routerConfig.get("lazyCreate")) {
                        type = (0, _components.createComponent)(stage, type);
                        pagesHost.a(type);
                    }
                }
                components.set(path, type);
            }
        } else {
            console.error("".concat(path, " already exists in routes configuration"));
        }
    });
};
var init = function(config) {
    rootHash = config.root;
    if ((0, _helpers.isFunction)(config.boot)) {
        bootRequest = config.boot;
    }
    if ((0, _helpers.isBoolean)(config.updateHash)) {
        updateHash = config.updateHash;
    }
    if ((0, _helpers.isFunction)(config.beforeEachRoute)) {
        beforeEachRoute = config.beforeEachRoute;
    }
    if ((0, _helpers.isFunction)(config.afterEachRoute)) {
        afterEachRoute = config.afterEachRoute;
    }
    if (config.bootComponent) {
        console.warn("[Router]: Boot Component is now available as a special router: https://rdkcentral.github.io/Lightning-SDK/#/plugins/router/configuration?id=special-routes");
        console.warn("[Router]: setting { bootComponent } property will be deprecated in a future release");
        if ((0, _helpers.isPage)(config.bootComponent)) {
            config.routes.push({
                path: "$",
                component: config.bootComponent,
                // we try to assign the bootRequest as after data-provider
                // so it will behave as any other component
                after: bootRequest || null,
                options: {
                    preventStorage: true
                }
            });
        } else {
            console.error("[Router]: ".concat(config.bootComponent, " is not a valid boot component"));
        }
    }
    config.routes.forEach(function(item) {
        // replacing regexes with 'R' to avoid issues with pattern matching below
        var strippedPath = (0, _regex.stripRegex)(item.path);
        // Pattern to identify the last path of the route
        // It should start with "/:" + any word  and ends with "?"
        // It should be the last path of the route
        // valid => /player/:asset/:assetId? (:assetId is optional)
        // invalid => /player/:asset/:assetId?/test (:assetId? is not an optional path)
        // invalid => /player/:asset?/:assetId? (second path is not considered as an optional path)
        var pattern = RegExp(".*\\/:.*?\\?$", "u");
        if (pattern.test(strippedPath)) {
            var optionalPath = item.path.substring(0, item.path.lastIndexOf("/"));
            var originalPath = item.path.substring(0, item.path.lastIndexOf("?"));
            item.path = originalPath;
            //Create another entry with the optional path
            var optionalItem = _object_spread._({}, item);
            optionalItem.path = optionalPath;
            config.routes.push(optionalItem);
        }
    });
    initialised = true;
};
var storeComponent = function(route, type) {
    if (components.has(route)) {
        components.set(route, type);
    }
};
var getComponent = function(route) {
    if (components.has(route)) {
        return components.get(route);
    }
    return null;
};
var deleteCurrentInstance = function(route) {
    if (components.has(route) && pagesHost.getIndex(components.get(route)) !== -1) {
        pagesHost.remove(components.get(route));
        storeComponent(route, components.get(route)._routedType || components.get(route).constructor);
    }
};
var mustUpdateLocationHash = function() {
    if (!routerConfig || !routerConfig.size) {
        return false;
    }
    // we need support to either turn change hash off
    // per platform or per app
    var updateConfig = routerConfig.get("updateHash");
    return !((0, _helpers.isBoolean)(updateConfig) && !updateConfig || (0, _helpers.isBoolean)(updateHash) && !updateHash);
};
var onRequestResolved = function(request) {
    var hash = request.hash;
    var route = request.route;
    var register = request.register;
    var page = request.page;
    // clean up history if modifier is set
    if ((0, _route.getOption)(route.options, "clearHistory")) {
        (0, _history.setHistory)([]);
    } else if (hash && !_regex.isWildcard.test(route.path)) {
        (0, _history.updateHistory)(request);
    }
    // we only update the stackLocation if a route
    // is not expired before it resolves
    storeComponent(route.path, page);
    if (request.isSharedInstance || !request.isCreated) {
        (0, _emit.default)(page, "changed");
    } else if (request.isCreated) {
        (0, _emit.default)(page, "mounted");
    }
    // only update widgets if we have a host
    if (widgetsHost) {
        (0, _widgets.updateWidgets)(route.widgets, page);
    }
    // we want to clean up if there is an
    // active page that is not being shared
    // between current and previous route
    if (getActivePage() && !request.isSharedInstance) {
        cleanUp(activePage, request);
    }
    // provide history object to active page
    if (register.get(_helpers.symbols.historyState) && (0, _helpers.isFunction)(page.historyState)) {
        page.historyState(register.get(_helpers.symbols.historyState));
    }
    setActivePage(page);
    activeHash = request.hash;
    activeRoute = route.path;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // cleanup all cancelled requests
        for(var _iterator = _index.navigateQueue.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$request = _step.value;
            if (_$request.isCancelled && _$request.hash) {
                _index.navigateQueue.delete(_$request.hash);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    afterEachRoute(request);
    _Log.default.info("[route]:", route.path);
    _Log.default.info("[hash]:", hash);
};
var cleanUp = function(page, request) {
    var route = activeRoute;
    var register = request.register;
    var lazyDestroy = routerConfig.get("lazyDestroy");
    var destroyOnBack = routerConfig.get("destroyOnHistoryBack");
    var keepAlive = register.get("keepAlive");
    var isFromHistory = register.get(_helpers.symbols.backtrack);
    var doCleanup = false;
    // if this request is executed due to a step back in history
    // and we have configured to destroy active page when we go back
    // in history or lazyDestory is enabled
    if (isFromHistory && (destroyOnBack || lazyDestroy)) {
        doCleanup = true;
    }
    // clean up if lazyDestroy is enabled and the keepAlive flag
    // in navigation register is false
    if (lazyDestroy && !keepAlive) {
        doCleanup = true;
    }
    // if the current and new request share the same route blueprint
    if (activeRoute === request.route.path) {
        doCleanup = true;
    }
    if (doCleanup) {
        // grab original class constructor if
        // statemachine routed else store constructor
        storeComponent(route, page._routedType || page.constructor);
        // actual remove of page from memory
        pagesHost.remove(page);
        // force texture gc() if configured
        // so we can cleanup textures in the same tick
        if (routerConfig.get("gcOnUnload")) {
            stage.gc();
        }
    } else {
        // If we're not removing the page we need to
        // reset it's properties
        page.patch({
            x: 0,
            y: 0,
            scale: 1,
            visible: false,
            alpha: 1
        });
    }
};
var getActiveHash = function() {
    return activeHash;
};
var setActiveHash = function(hash) {
    activeHash = hash;
};
var setActivePage = function(page) {
    activePage = page;
};
var getActivePage = function() {
    return activePage;
};
var getActiveRoute = function() {
    return activeRoute;
};
var getLastHash = function() {
    return lastAcceptedHash;
};
var setLastHash = function(hash) {
    lastAcceptedHash = hash;
};
var setPreviousState = function(state) {
    previousState = state;
};
var getPreviousState = function() {
    return previousState;
};
var routeExists = function(key) {
    return routes.has(key);
};
var getRootHash = function() {
    return rootHash;
};
var getBootRequest = function() {
    return bootRequest;
};
var getRouterConfig = function() {
    return routerConfig;
};
var getRoutes = function() {
    return routes;
};


/***/ }),

/***/ 29796:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "executeTransition", ({
    enumerable: true,
    get: function() {
        return executeTransition;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var _router = __webpack_require__(69611);
var _helpers = __webpack_require__(73137);
var _transitions = /*#__PURE__*/ _interop_require_default._(__webpack_require__(16181));
var executeTransition = function(pageIn) {
    var pageOut = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var transition = pageIn.pageTransition || pageIn.easing;
    var hasCustomTransitions = !!(pageIn.smoothIn || pageIn.smoothInOut || transition);
    var transitionsDisabled = (0, _router.getRouterConfig)().get("disableTransitions");
    if (pageIn.easing) {
        console.warn("easing() method is deprecated and will be removed. Use pageTransition()");
    }
    // default behaviour is a visibility toggle
    if (!hasCustomTransitions || transitionsDisabled) {
        pageIn.visible = true;
        if (pageOut) {
            pageOut.visible = false;
        }
        return Promise.resolve();
    }
    if (transition) {
        var type;
        try {
            type = transition.call(pageIn, pageIn, pageOut);
        } catch (e) {
            type = "crossFade";
        }
        if ((0, _helpers.isPromise)(type)) {
            return type;
        }
        if ((0, _helpers.isString)(type)) {
            var fn = _transitions.default[type];
            if (fn) {
                return fn(pageIn, pageOut);
            }
        }
        // keep backwards compatible for now
        if (pageIn.smoothIn) {
            // provide a smooth function that resolves itself
            // on transition finish
            var smooth = function(p, v) {
                var args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return new Promise(function(resolve) {
                    pageIn.visible = true;
                    pageIn.setSmooth(p, v, args);
                    pageIn.transition(p).on("finish", function() {
                        resolve();
                    });
                });
            };
            return pageIn.smoothIn({
                pageIn: pageIn,
                smooth: smooth
            });
        }
    }
    return _transitions.default.crossFade(pageIn, pageOut);
};


/***/ }),

/***/ 11303:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    focusWidget: function() {
        return focusWidget;
    },
    getActiveWidget: function() {
        return getActiveWidget;
    },
    getReferences: function() {
        return getReferences;
    },
    handleRemote: function() {
        return handleRemote;
    },
    restoreFocus: function() {
        return restoreFocus;
    },
    setActiveWidget: function() {
        return setActiveWidget;
    },
    updateWidgets: function() {
        return updateWidgets;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _router = __webpack_require__(69611);
var _helpers = __webpack_require__(73137);
var _emit = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73529));
var activeWidget = null;
var getReferences = function() {
    if (!_router.widgetsHost) {
        return;
    }
    return _router.widgetsHost.get().reduce(function(storage, widget) {
        var key = widget.ref.toLowerCase();
        storage[key] = widget;
        return storage;
    }, {});
};
var updateWidgets = function(widgets, page) {
    // force lowercase lookup
    var configured = (widgets || []).map(function(ref) {
        return ref.toLowerCase();
    });
    _router.widgetsHost.forEach(function(widget) {
        widget.visible = configured.indexOf(widget.ref.toLowerCase()) !== -1;
        if (widget.visible) {
            (0, _emit.default)(widget, [
                "activated"
            ], page);
        }
    });
    if (_router.app.state === "Widgets" && activeWidget && !activeWidget.visible) {
        _router.app._setState("");
    }
};
var getWidgetByName = function(name) {
    name = (0, _helpers.ucfirst)(name);
    return _router.widgetsHost.getByRef(name) || false;
};
var focusWidget = function(name) {
    var widget = getWidgetByName(name);
    if (widget) {
        setActiveWidget(widget);
        // if app is already in 'Widgets' state we can assume that
        // focus has been delegated from one widget to another so
        // we need to set the new widget reference and trigger a
        // new focus calculation of Lightning's focuspath
        if (_router.app.state === "Widgets") {
            _router.app.reload(activeWidget);
        } else {
            _router.app._setState("Widgets", [
                activeWidget
            ]);
        }
    }
};
var handleRemote = function(type, name) {
    if (type === "widget") {
        focusWidget(name);
    } else if (type === "page") {
        restoreFocus();
    }
};
var restoreFocus = function() {
    activeWidget = null;
    _router.app._setState("");
};
var getActiveWidget = function() {
    return activeWidget;
};
var setActiveWidget = function(instance) {
    activeWidget = instance;
};


/***/ }),

/***/ 52452:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initSettings: function() {
        return initSettings;
    }
});
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var settings = {};
var subscribers = {};
var initSettings = function(appSettings, platformSettings) {
    settings["app"] = appSettings;
    settings["platform"] = platformSettings;
    settings["user"] = {};
};
var publish = function(key, value) {
    subscribers[key] && subscribers[key].forEach(function(subscriber) {
        return subscriber(value);
    });
};
var dotGrab = function() {
    var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, key = arguments.length > 1 ? arguments[1] : void 0;
    if (obj === null) return undefined;
    var keys = key.split(".");
    for(var i = 0; i < keys.length; i++){
        obj = obj[keys[i]] = obj[keys[i]] !== undefined ? obj[keys[i]] : {};
    }
    return typeof obj === "object" && obj !== null ? Object.keys(obj).length ? obj : undefined : obj;
};
var _default = {
    get: function(type, key) {
        var fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
        var val = dotGrab(settings[type], key);
        return val !== undefined ? val : fallback;
    },
    has: function(type, key) {
        return !!this.get(type, key);
    },
    set: function(key, value) {
        settings["user"][key] = value;
        publish(key, value);
    },
    subscribe: function(key, callback) {
        subscribers[key] = subscribers[key] || [];
        subscribers[key].push(callback);
    },
    unsubscribe: function(key, callback) {
        if (callback) {
            var index = subscribers[key] && subscribers[key].findIndex(function(cb) {
                return cb === callback;
            });
            index > -1 && subscribers[key].splice(index, 1);
        } else {
            if (key in subscribers) {
                subscribers[key] = [];
            }
        }
    },
    clearSubscribers: function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.getOwnPropertyNames(subscribers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                delete subscribers[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
};


/***/ }),

/***/ 58684:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initStorage: function() {
        return initStorage;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
var _Settings = /*#__PURE__*/ _interop_require_default._(__webpack_require__(52452));
var _localCookie = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32573));
var namespace;
var lc;
var initStorage = function() {
    namespace = _Settings.default.get("platform", "id");
    // todo: pass options (for example to force the use of cookies)
    lc = new _localCookie.default();
};
var namespacedKey = function(key) {
    return namespace ? [
        namespace,
        key
    ].join(".") : key;
};
var _default = {
    get: function(key) {
        try {
            return JSON.parse(lc.getItem(namespacedKey(key)));
        } catch (e) {
            return null;
        }
    },
    set: function(key, value) {
        try {
            lc.setItem(namespacedKey(key), JSON.stringify(value));
            return true;
        } catch (e) {
            return false;
        }
    },
    remove: function(key) {
        lc.removeItem(namespacedKey(key));
    },
    clear: function() {
        if (namespace) {
            lc.keys().forEach(function(key) {
                // remove the item if in the namespace
                key.indexOf(namespace + ".") === 0 ? lc.removeItem(key) : null;
            });
        } else {
            lc.clear();
        }
    }
};


/***/ }),

/***/ 80390:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return SubtitleComponent;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var SubtitleComponent = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(SubtitleComponent, _Lightning_Component);
    var _super = _create_super._(SubtitleComponent);
    function SubtitleComponent() {
        _class_call_check._(this, SubtitleComponent);
        return _super.apply(this, arguments);
    }
    _create_class._(SubtitleComponent, [
        {
            key: "_init",
            value: function _init() {
                var _this = this;
                this._textTextureDefaults = new _Lightning.default.textures.TextTexture(this.stage).cloneArgs();
                this.tag("Text").on("txLoaded", function(param) {
                    var _source = param._source;
                    _this.w = _source.w + _this.tag("Text").x * 2;
                    _this.h = _source.h;
                    _this.position();
                });
            }
        },
        {
            key: "textFormat",
            get: function get() {
                var textTag = this.tag("Text").text;
                return {
                    fontFace: textTag.fontFace || "sans-serif",
                    fontSize: textTag.fontSize,
                    lineHeight: textTag.lineHeight,
                    textAlign: textTag.textAlign,
                    wordWrap: true,
                    maxLines: textTag.maxLines
                };
            }
        },
        {
            key: "show",
            value: function show() {
                this.visible = true;
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.visible = false;
            }
        },
        {
            key: "position",
            value: function position() {
                this.x = this._calculateX(this.xPos);
                this.y = this._calculateY(this.yPos);
            }
        },
        {
            key: "viewportW",
            get: function get() {
                return this._viewportW || this.application.finalW;
            },
            set: function set(v) {
                this._viewportW = v;
                this.x = this._calculateX(this.xPos);
            }
        },
        {
            key: "viewportH",
            get: function get() {
                return this._viewportH || this.application.finalH;
            },
            set: function set(v) {
                this._viewportH = v;
                this.y = this._calculateY(this.yPos);
            }
        },
        {
            key: "_calculateX",
            value: function _calculateX(x) {
                if (x === "center") {
                    x = (this.viewportW - this.finalW) / 2;
                } else if (x === "left") {
                    x = 60;
                } else if (x === "right") {
                    x = this.viewportW - this.finalW - 60;
                }
                return x;
            }
        },
        {
            key: "xPos",
            get: function get() {
                return this._x || "center";
            },
            set: function set(v) {
                this._x = v;
                this.x = this._calculateX(v);
            }
        },
        {
            key: "_calculateY",
            value: function _calculateY(y) {
                if (y === "center") {
                    return (this.viewportH - this.finalH) / 2;
                } else if (y === "top") {
                    return 60;
                } else if (y === "bottom") {
                    return this.viewportH - this.finalH - 60;
                }
                return y;
            }
        },
        {
            key: "yPos",
            get: function get() {
                return this._y || "bottom";
            },
            set: function set(v) {
                this._y = v;
                this.y = this._calculateY(v);
            }
        },
        {
            key: "fontFamily",
            set: function set(v) {
                this.tag("Text").text.fontFace = v;
            }
        },
        {
            key: "fontSize",
            set: function set(v) {
                this.tag("Text").text.fontSize = v;
                this.tag("Text").text.lineHeight = v * 1.3;
            }
        },
        {
            key: "fontColor",
            set: function set(v) {
                this.tag("Text").color = v;
            }
        },
        {
            key: "backgroundColor",
            set: function set(v) {
                this.color = v;
            }
        },
        {
            key: "_defineBreakpoint",
            value: function _defineBreakpoint(text, breakpoint) {
                if (breakpoint >= this.maxWidth) return this.maxWidth;
                var info = _Lightning.default.textures.TextTexture.renderer(this.stage, this.stage.platform.getDrawingCanvas(), _object_spread_props._(_object_spread._({}, this._textTextureDefaults, this.textFormat, {
                    wordWrapWidth: breakpoint
                }), {
                    text: text
                }))._calculateRenderInfo();
                if (info.width <= breakpoint && info.lines.length <= 2) {
                    return breakpoint;
                } else {
                    return this._defineBreakpoint(text, breakpoint * 1.25);
                }
            }
        },
        {
            key: "text",
            set: function set(v) {
                this.alpha = 0;
                if (v && v.length) {
                    var breakpoint = this._defineBreakpoint(v, 640);
                    this.tag("Text").text.wordWrapWidth = breakpoint;
                    this.tag("Text").text = v;
                    this.alpha = 1;
                }
            }
        },
        {
            key: "textAlign",
            set: function set(v) {
                this._textAlign = v;
                this.tag("Text").text.textAlign = v;
            }
        },
        {
            key: "maxWidth",
            get: function get() {
                return (this._maxWidth || 1200) - this.tag("Text").x * 2;
            },
            set: function set(v) {
                this._maxWidth = v;
            }
        },
        {
            key: "maxLines",
            set: function set(v) {
                this.tag("Text").text.maxLines = v;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    visible: false,
                    rect: true,
                    color: 0x90000000,
                    shader: {
                        type: _Lightning.default.shaders.RoundedRectangle,
                        radius: 5
                    },
                    Text: {
                        y: 5,
                        x: 20,
                        text: {
                            textColor: 0xffffffff,
                            fontSize: 38,
                            lineHeight: 38 * 1.4,
                            textAlign: "center",
                            wordWrap: true,
                            maxLines: 3,
                            shadow: true,
                            shadowColor: 0xff333333
                        }
                    }
                };
            }
        }
    ]);
    return SubtitleComponent;
}(_Lightning.default.Component);


/***/ }),

/***/ 27277:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _Application = __webpack_require__(92010);
var _SubtitleComponent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(80390));
var subtitlesComponent;
var getOrCreateSubtitlesComponent = function() {
    return subtitlesComponent ? subtitlesComponent : subtitlesComponent = _Application.AppInstance.application.tag("Subtitles") || _Application.AppInstance.application.childList.a(_Application.AppInstance.stage.c({
        ref: "Subtitles",
        type: _SubtitleComponent.default,
        forceZIndexContext: true,
        zIndex: 2
    }));
};
var _default = {
    show: function() {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.show();
    },
    hide: function() {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.hide();
    },
    styles: function(v) {
        var _this = this;
        Object.keys(v).forEach(function(key) {
            if (key in _this && typeof _this[key] === "function") {
                _this[key](v[key]);
            }
        });
    },
    fontFamily: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.fontFamily = v;
    },
    fontSize: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.fontSize = v;
    },
    fontColor: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.fontColor = v;
    },
    backgroundColor: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.backgroundColor = v;
    },
    textAlign: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.textAlign = v;
    },
    textAlignVertical: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.textAlignVertical = v;
    },
    viewport: function(w, h) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.viewportW = w;
        subtitles.viewportH = h;
    },
    position: function(x, y) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.xPos = x;
        subtitles.yPos = y;
    },
    maxWidth: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.maxWidth = v;
    },
    maxLines: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.maxLines = v;
    },
    text: function(v) {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.text = v;
    },
    clear: function() {
        var subtitles = getOrCreateSubtitlesComponent();
        subtitles.text = "";
    }
};


/***/ }),

/***/ 5669:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
var _sdk = __webpack_require__(42976);
var _default = _sdk.TV;


/***/ }),

/***/ 50509:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    cleanUpPathName: function() {
        return cleanUpPathName;
    },
    default: function() {
        return _default;
    },
    ensureUrlWithProtocol: function() {
        return ensureUrlWithProtocol;
    },
    initUtils: function() {
        return initUtils;
    },
    makeFullStaticPath: function() {
        return makeFullStaticPath;
    }
});
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var basePath;
var proxyUrl;
var initUtils = function(config) {
    basePath = ensureUrlWithProtocol(makeFullStaticPath(window.location.pathname, config.path || "/"));
    if (config.proxyUrl) {
        proxyUrl = ensureUrlWithProtocol(config.proxyUrl);
    }
};
var _default = {
    asset: function(relPath) {
        return basePath + relPath;
    },
    proxyUrl: function(url) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return proxyUrl ? proxyUrl + "?" + makeQueryString(url, options) : url;
    },
    makeQueryString: function() {
        return makeQueryString.apply(void 0, arguments);
    },
    // since imageworkers don't work without protocol
    ensureUrlWithProtocol: function() {
        return ensureUrlWithProtocol.apply(void 0, arguments);
    }
};
var ensureUrlWithProtocol = function(url) {
    if (/^\/[^/]/i.test(url) && /^(?:file:)/i.test(window.location.protocol)) {
        return window.location.protocol + "//" + url;
    }
    if (/^\/\//.test(url)) {
        return window.location.protocol + url;
    }
    if (!/^(?:https?:)/i.test(url)) {
        return window.location.origin + url;
    }
    return url;
};
var makeFullStaticPath = function() {
    var pathname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", path = arguments.length > 1 ? arguments[1] : void 0;
    // ensure path has traling slash
    path = path.charAt(path.length - 1) !== "/" ? path + "/" : path;
    // if path is URL, we assume it's already the full static path, so we just return it
    if (/^(?:https?:)?(?:\/\/)/.test(path)) {
        return path;
    }
    if (path.charAt(0) === "/") {
        return path;
    } else {
        // cleanup the pathname (i.e. remove possible index.html)
        pathname = cleanUpPathName(pathname);
        // remove possible leading dot from path
        path = path.charAt(0) === "." ? path.substr(1) : path;
        // ensure path has leading slash
        path = path.charAt(0) !== "/" ? "/" + path : path;
        return pathname + path;
    }
};
var cleanUpPathName = function(pathname) {
    if (pathname.slice(-1) === "/") return pathname.slice(0, -1);
    var parts = pathname.split("/");
    if (parts[parts.length - 1].indexOf(".") > -1) parts.pop();
    return parts.join("/");
};
var makeQueryString = function(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "url";
    // add operator as an option
    options.operator = "metrological" // Todo: make this configurable (via url?)
    ;
    // add type (= url or qr) as an option, with url as the value
    options[type] = url;
    return Object.keys(options).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent("" + options[key]);
    }).join("&");
};


/***/ }),

/***/ 14806:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return VersionLabel;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
var _Lightning = /*#__PURE__*/ _interop_require_default._(__webpack_require__(72661));
var VersionLabel = /*#__PURE__*/ function(_Lightning_Component) {
    "use strict";
    _inherits._(VersionLabel, _Lightning_Component);
    var _super = _create_super._(VersionLabel);
    function VersionLabel() {
        _class_call_check._(this, VersionLabel);
        return _super.apply(this, arguments);
    }
    _create_class._(VersionLabel, [
        {
            key: "_firstActive",
            value: function _firstActive() {
                this.tag("Text").text = "APP - v".concat(this.version, "\nSDK - v").concat(this.sdkVersion);
                this.tag("Text").loadTexture();
                this.w = this.tag("Text").renderWidth + 40;
                this.h = this.tag("Text").renderHeight + 5;
            }
        }
    ], [
        {
            key: "_template",
            value: function _template() {
                return {
                    rect: true,
                    color: 0xbb0078ac,
                    h: 40,
                    w: 100,
                    x: function(w) {
                        return w - 50;
                    },
                    y: function(h) {
                        return h - 50;
                    },
                    mount: 1,
                    Text: {
                        w: function(w) {
                            return w;
                        },
                        h: function(h) {
                            return h;
                        },
                        y: 5,
                        x: 20,
                        text: {
                            fontSize: 22,
                            lineHeight: 26
                        }
                    }
                };
            }
        }
    ]);
    return VersionLabel;
}(_Lightning.default.Component);


/***/ }),

/***/ 89944:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
var _sdk = __webpack_require__(42976);
var _default = _sdk.VideoPlayer;


/***/ }),

/***/ 88528:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var _default = function(file) {
    return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                // file protocol returns 0
                // http(s) protocol returns 200
                if (xhr.status === 0 || xhr.status === 200) resolve(JSON.parse(xhr.responseText));
                else reject(xhr.statusText);
            }
        };
        xhr.open("GET", file);
        xhr.send(null);
    });
};


/***/ }),

/***/ 55573:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
window.attachInspector = function(param) {
    var Application = param.Application, Element = param.Element, ElementCore = param.ElementCore, Stage = param.Stage, Component = param.Component, ElementTexturizer = param.ElementTexturizer, Texture = param.Texture;
    var isAlreadyAttached = window.hasOwnProperty("mutationCounter");
    if (isAlreadyAttached) {
        return;
    }
    window.mutationCounter = 0;
    window.mutatingChildren = false;
    var observer = new MutationObserver(function(mutations) {
        var fa = [
            "x",
            "y",
            "w",
            "h",
            "alpha",
            "mountX",
            "mountY",
            "pivotX",
            "pivotY",
            "scaleX",
            "scaleY",
            "rotation",
            "visible",
            "clipping",
            "rect",
            "colorUl",
            "colorUr",
            "colorBl",
            "colorBr",
            "color",
            "borderWidthLeft",
            "borderWidthRight",
            "borderWidthTop",
            "borderWidthBottom",
            "borderWidth",
            "borderColorLeft",
            "borderColorRight",
            "borderColorTop",
            "borderColorBottom",
            "borderColor",
            "zIndex",
            "forceZIndexContext",
            "renderToTexture",
            "renderToTextureLazy",
            "renderOffscreen",
            "colorizeResultTexture",
            "texture"
        ];
        var fac = fa.map(function(v) {
            return v.toLowerCase();
        });
        mutations.forEach(function(mutation) {
            if (mutation.type == "childList") {
                var node = mutation.target;
                var c = mutation.target.element;
            }
            if (mutation.type == "attributes" && mutation.attributeName !== "style" && mutation.attributeName !== "class") {
                var n = mutation.attributeName.toLowerCase();
                var c = mutation.target.element;
                if (c.__ignore_attrib_changes === window.mutationCounter) {
                    // Ignore attribute changes that were caused by actual value modifications by js.
                    return;
                }
                var v = mutation.target.getAttribute(mutation.attributeName);
                if (n.startsWith("texture-")) {
                    if (c.displayedTexture) {
                        var att = n.substr(8).split("_");
                        var camelCaseAtt = att[0] + att.slice(1).map(function(a) {
                            return a.substr(0, 1).toUpperCase() + a.substr(1).toLowerCase();
                        }).join();
                        c.displayedTexture[camelCaseAtt] = v;
                    }
                    return;
                }
                var index = fac.indexOf(n);
                if (index !== -1) {
                    var rn = fa[index];
                    var pv;
                    try {
                        if (v === null) {
                            switch(rn){
                                case "pivotX":
                                case "pivotY":
                                    pv = 0.5;
                                    break;
                                case "alpha":
                                case "scaleX":
                                case "scaleY":
                                    pv = 1;
                                    break;
                                case "visible":
                                    pv = true;
                                    break;
                                case "clipping":
                                    pv = false;
                                    break;
                                case "rect":
                                    pv = false;
                                    break;
                                case "zIndex":
                                    pv = 0;
                                    break;
                                case "forceZIndexContext":
                                    pv = false;
                                    break;
                                case "color":
                                    pv = 0xffffffff;
                                    break;
                                case "colorUl":
                                case "colorUr":
                                case "colorBl":
                                case "colorBr":
                                    if (mutation.target.hasAttribute("color")) {
                                        // This may happen when the separate values are combined.
                                        return;
                                    }
                                    pv = 0xffffffff;
                                    break;
                                case "renderToTexture":
                                    pv = false;
                                    break;
                                case "renderToTextureLazy":
                                    pv = false;
                                    break;
                                case "renderOffscreen":
                                    pv = false;
                                    break;
                                case "colorizeResultTexture":
                                    pv = false;
                                    break;
                                default:
                                    pv = 0;
                            }
                        } else {
                            switch(rn){
                                case "color":
                                case "colorUl":
                                case "colorUr":
                                case "colorBl":
                                case "colorBr":
                                    pv = parseInt(v, 16);
                                    break;
                                case "visible":
                                case "clipping":
                                case "rect":
                                case "forceZIndexContext":
                                case "renderToTexture":
                                case "renderToTextureLazy":
                                case "renderOffscreen":
                                case "colorizeResultTexture":
                                    pv = v === "true";
                                    break;
                                case "texture":
                                    pv = JSON.parse(v);
                                    break;
                                default:
                                    pv = parseFloat(v);
                                    if (isNaN(pv)) throw "e";
                            }
                        }
                        var fv;
                        switch(rn){
                            case "color":
                                var f = [
                                    "colorUl",
                                    "colorUr",
                                    "colorBl",
                                    "colorBr"
                                ].map(function(q) {
                                    return mutation.target.hasAttribute(q);
                                });
                                if (!f[0]) c["colorUl"] = pv;
                                if (!f[1]) c["colorUr"] = pv;
                                if (!f[2]) c["colorBl"] = pv;
                                if (!f[3]) c["colorBr"] = pv;
                                break;
                            default:
                                c[rn] = pv;
                        }
                    // Set final value, not the transitioned value.
                    } catch (e) {
                        console.error("Bad (ignored) attribute value", rn);
                    }
                }
            }
        });
        window.mutationCounter++;
    });
    ElementCore.prototype.dhtml = function() {
        return this._element.dhtml();
    };
    Element.prototype.dhtml = function() {
        if (!this.debugElement) {
            this.debugElement = document.createElement("DIV");
            this.debugElement.setAttribute("type", this.constructor.name);
            this.debugElement.element = this;
            this.debugElement.style.position = "absolute";
            this.debugElement.id = "" + this.id;
            observer.observe(this.debugElement, {
                attributes: true
            });
        }
        if (this.stage.root === this && !this.dhtml_root) {
            // Root element.
            var root = document.createElement("DIV");
            document.body.appendChild(root);
            var self = this;
            var updateRootStyleFromCanvas = function updateRootStyleFromCanvas(bcr) {
                root.style.left = bcr.left + "px";
                root.style.top = bcr.top + "px";
                root.style.width = Math.ceil(bcr.width / self.stage.getRenderPrecision()) + "px";
                root.style.height = Math.ceil(bcr.height / self.stage.getRenderPrecision()) + "px";
                root.style.transformOrigin = "0 0 0";
                root.style.transform = "scale(" + self.stage.getRenderPrecision() + "," + self.stage.getRenderPrecision() + ")";
            };
            if (window.ResizeObserver != null) {
                var resize_ob = new ResizeObserver(function(entries) {
                    updateRootStyleFromCanvas(entries[0].target.getBoundingClientRect());
                });
                // start observing for resize
                resize_ob.observe(this.stage.getCanvas());
            } else {
                setTimeout(function() {
                    updateRootStyleFromCanvas(self.stage.getCanvas().getBoundingClientRect());
                }, 1000);
            }
            root.style.position = "absolute";
            root.style.overflow = "hidden";
            root.style.zIndex = "65535";
            root.appendChild(this.debugElement);
            this.dhtml_root = root;
        }
        return this.debugElement;
    };
    var oElement = Element;
    var oSetParent = oElement.prototype._setParent;
    Element.prototype._setParent = function(parent) {
        var prevParent = this.parent;
        oSetParent.apply(this, arguments);
        if (!window.mutatingChildren) {
            if (parent && parent.dhtml) {
                var index = parent._children.getIndex(this);
                if (index == parent._children.get().length - 1) {
                    parent.dhtml().appendChild(this.dhtml());
                } else {
                    parent.dhtml().insertBefore(this.dhtml(), parent.dhtml().children[index]);
                }
            } else {
                if (prevParent && prevParent.dhtml) {
                    prevParent.dhtml().removeChild(this.dhtml());
                }
            }
        }
    };
    var oInit = Stage.prototype.init;
    Stage.prototype.init = function() {
        oInit.apply(this, arguments);
        // Apply stage scaling.
        this.root.core.updateDebugTransforms();
    };
    var oAddTag = oElement.prototype.addTag;
    Element.prototype.addTag = function(tag) {
        oAddTag.apply(this, arguments);
        if (tag) {
            this.dhtml().classList.add(tag);
        }
    };
    var oRemoveTag = oElement.prototype.removeTag;
    Element.prototype.removeTag = function(tag) {
        oRemoveTag.apply(this, arguments);
        if (tag) {
            this.dhtml().classList.remove(tag);
        }
    };
    // Change an attribute due to new value inputs.
    var val = function val(c, n, v, dv) {
        if (c._element) {
            c = c._element;
        }
        if (v == dv) {
            if (c.dhtmlRemoveAttribute) {
                c.dhtmlRemoveAttribute(n);
            }
        } else {
            if (c.dhtmlSetAttribute) {
                c.dhtmlSetAttribute(n, v);
            }
        }
    };
    var valStrict = function valStrict(c, n, v, dv) {
        if (c._element) {
            c = c._element;
        }
        if (v === dv) {
            if (c.dhtmlRemoveAttribute) {
                c.dhtmlRemoveAttribute(n);
            }
        } else {
            if (c.dhtmlSetAttribute) {
                c.dhtmlSetAttribute(n, v);
            }
        }
    };
    Element.prototype.dhtmlRemoveAttribute = function() {
        // We don't want the attribute listeners to be called during the next observer cycle.
        this.__ignore_attrib_changes = window.mutationCounter;
        this.dhtml().removeAttribute.apply(this.dhtml(), arguments);
    };
    Element.prototype.dhtmlSetAttribute = function() {
        this.__ignore_attrib_changes = window.mutationCounter;
        this.dhtml().setAttribute.apply(this.dhtml(), arguments);
    };
    if (typeof Component !== "undefined") {
        Object.defineProperty(Component.prototype, "_state", {
            get: function get() {
                return this.__state;
            },
            set: function set(v) {
                if (this.__state !== v) {
                    if (this.__state !== null) {
                        val(this, "state", v ? v.__path : "", "");
                    }
                    this.__state = v;
                }
            }
        });
    }
    Element.prototype.$ref = Element.prototype.__ref;
    Object.defineProperty(Element.prototype, "__ref", {
        get: function get() {
            return this.$ref;
        },
        set: function set(v) {
            if (this.$ref !== v) {
                val(this, "ref", v, null);
                this.$ref = v;
            }
        }
    });
    ElementCore.prototype.$x = ElementCore.prototype._x;
    Object.defineProperty(ElementCore.prototype, "_x", {
        get: function get() {
            return this.$x;
        },
        set: function set(v) {
            if (this.$x !== v) {
                val(this, "x", v, 0);
                this.$x = v;
                this.updateLeft();
            }
        }
    });
    ElementCore.prototype.$y = ElementCore.prototype._y;
    Object.defineProperty(ElementCore.prototype, "_y", {
        get: function get() {
            return this.$y;
        },
        set: function set(v) {
            if (this.$y !== v) {
                val(this, "y", v, 0);
                this.$y = v;
                this.updateTop();
            }
        }
    });
    Element.prototype.$w = Element.prototype._w;
    Object.defineProperty(Element.prototype, "_w", {
        get: function get() {
            return this.$w;
        },
        set: function set(v) {
            if (this.$w !== v) {
                val(this, "w", v, 0);
                this.$w = v;
            }
        }
    });
    Element.prototype.$h = Element.prototype._h;
    Object.defineProperty(Element.prototype, "_h", {
        get: function get() {
            return this.$h;
        },
        set: function set(v) {
            if (this.$h !== v) {
                val(this, "h", v, 0);
                this.$h = v;
            }
        }
    });
    ElementCore.prototype.updateLeft = function() {
        var mx = this._mountX * this._w;
        var x = this._x - mx;
        this.dhtml().style.left = x + "px";
    };
    ElementCore.prototype.updateTop = function() {
        var my = this._mountY * this._h;
        var y = this._y - my;
        this.dhtml().style.top = y + "px";
    };
    ElementCore.prototype.__w = 0;
    Object.defineProperty(ElementCore.prototype, "_w", {
        get: function get() {
            return this.__w;
        },
        set: function set(v) {
            this.__w = v;
            this.dhtml().style.width = v + "px";
            this.updateLeft();
        }
    });
    ElementCore.prototype.__h = 0;
    Object.defineProperty(ElementCore.prototype, "_h", {
        get: function get() {
            return this.__h;
        },
        set: function set(v) {
            this.__h = v;
            this.dhtml().style.height = v + "px";
            this.updateTop();
        }
    });
    ElementCore.prototype.$alpha = 1;
    Object.defineProperty(ElementCore.prototype, "_alpha", {
        get: function get() {
            return this.$alpha;
        },
        set: function set(v) {
            if (this.$alpha !== v) {
                val(this, "alpha", v, 1);
                this.$alpha = v;
                this.dhtml().style.opacity = v;
                this.dhtml().style.display = this.$visible && this.$alpha ? "block" : "none";
            }
        }
    });
    ElementCore.prototype.$visible = true;
    Object.defineProperty(ElementCore.prototype, "_visible", {
        get: function get() {
            return this.$visible;
        },
        set: function set(v) {
            if (this.$visible !== v) {
                val(this, "visible", v, true);
                this.$visible = v;
                this.dhtml().style.visibility = v ? "visible" : "hidden";
                this.dhtml().style.display = this.$visible && this.$alpha ? "block" : "none";
            }
        }
    });
    ElementCore.prototype.$rotation = 0;
    Object.defineProperty(ElementCore.prototype, "_rotation", {
        get: function get() {
            return this.$rotation;
        },
        set: function set(v) {
            if (this.$rotation !== v) {
                val(this, "rotation", v, 0);
                this.$rotation = v;
                this.updateDebugTransforms();
            }
        }
    });
    ElementCore.prototype.$scaleX = 1;
    Object.defineProperty(ElementCore.prototype, "_scaleX", {
        get: function get() {
            return this.$scaleX;
        },
        set: function set(v) {
            if (this.$scaleX !== v) {
                val(this, "scaleX", v, 1);
                this.$scaleX = v;
                this.updateDebugTransforms();
            }
        }
    });
    ElementCore.prototype.$scaleY = 1;
    Object.defineProperty(ElementCore.prototype, "_scaleY", {
        get: function get() {
            return this.$scaleY;
        },
        set: function set(v) {
            if (this.$scaleY !== v) {
                val(this, "scaleY", v, 1);
                this.$scaleY = v;
                this.updateDebugTransforms();
            }
        }
    });
    ElementCore.prototype.$pivotX = 0.5;
    Object.defineProperty(ElementCore.prototype, "_pivotX", {
        get: function get() {
            return this.$pivotX;
        },
        set: function set(v) {
            if (this.$pivotX !== v) {
                val(this, "pivotX", v, 0.5);
                this.$pivotX = v;
                this.updateDebugTransforms();
            }
        }
    });
    ElementCore.prototype.$pivotY = 0.5;
    Object.defineProperty(ElementCore.prototype, "_pivotY", {
        get: function get() {
            return this.$pivotY;
        },
        set: function set(v) {
            if (this.$pivotY !== v) {
                val(this, "pivotY", v, 0.5);
                this.$pivotY = v;
                this.updateDebugTransforms();
            }
        }
    });
    ElementCore.prototype.$mountX = 0;
    Object.defineProperty(ElementCore.prototype, "_mountX", {
        get: function get() {
            return this.$mountX;
        },
        set: function set(v) {
            if (this.$mountX !== v) {
                val(this, "mountX", v, 0);
                this.$mountX = v;
                this.updateLeft();
            }
        }
    });
    ElementCore.prototype.$mountY = 0;
    Object.defineProperty(ElementCore.prototype, "_mountY", {
        get: function get() {
            return this.$mountY;
        },
        set: function set(v) {
            if (this.$mountY !== v) {
                val(this, "mountY", v, 0);
                this.$mountY = v;
                this.updateTop();
            }
        }
    });
    ElementCore.prototype.__zIndex = 0;
    Object.defineProperty(ElementCore.prototype, "_zIndex", {
        get: function get() {
            return this.__zIndex;
        },
        set: function set(v) {
            if (this.__zIndex !== v) {
                val(this, "zIndex", v, 0);
                this.__zIndex = v;
                if (this.__zIndex || v) {
                    this.dhtml().style.zIndex = v;
                }
            }
        }
    });
    ElementCore.prototype.__forceZIndexContext = false;
    Object.defineProperty(ElementCore.prototype, "_forceZIndexContext", {
        get: function get() {
            return this.__forceZIndexContext;
        },
        set: function set(v) {
            if (this.__forceZIndexContext !== v) {
                val(this, "forceZIndexContext", v, false);
                this.__forceZIndexContext = v;
            }
        }
    });
    ElementCore.prototype.__clipping = false;
    Object.defineProperty(ElementCore.prototype, "_clipping", {
        get: function get() {
            return this.__clipping;
        },
        set: function set(v) {
            if (this.__clipping !== v) {
                val(this, "clipping", v, false);
                this.__clipping = v;
                var nv = v ? "hidden" : "visible";
                if (v || !v && this.dhtml().style.overflow == "hidden") {
                    this.dhtml().style.overflow = nv;
                }
            }
        }
    });
    ElementCore.prototype.__withinBoundsMargin = false;
    Object.defineProperty(ElementCore.prototype, "_withinBoundsMargin", {
        get: function get() {
            return this.__withinBoundsMargin;
        },
        set: function set(v) {
            if (this.__withinBoundsMargin !== v) {
                val(this, "withinBoundsMargin", v, false);
                this.__withinBoundsMargin = v;
            }
        }
    });
    ElementCore.prototype.__colorUl = 0xFFFFFFFF;
    Object.defineProperty(ElementCore.prototype, "_colorUl", {
        get: function get() {
            return this.__colorUl;
        },
        set: function set(v) {
            if (this.__colorUl !== v) {
                val(this, "colorUl", v.toString(16), "ffffffff");
                this.__colorUl = v;
                checkColors(this);
            }
        }
    });
    ElementCore.prototype.__colorUr = 0xFFFFFFFF;
    Object.defineProperty(ElementCore.prototype, "_colorUr", {
        get: function get() {
            return this.__colorUr;
        },
        set: function set(v) {
            if (this.__colorUr !== v) {
                val(this, "colorUr", v.toString(16), "ffffffff");
                this.__colorUr = v;
                checkColors(this);
            }
        }
    });
    ElementCore.prototype.__colorBl = 0xFFFFFFFF;
    Object.defineProperty(ElementCore.prototype, "_colorBl", {
        get: function get() {
            return this.__colorBl;
        },
        set: function set(v) {
            if (this.__colorBl !== v) {
                val(this, "colorBl", v.toString(16), "ffffffff");
                this.__colorBl = v;
                checkColors(this);
            }
        }
    });
    ElementCore.prototype.__colorBr = 0xFFFFFFFF;
    Object.defineProperty(ElementCore.prototype, "_colorBr", {
        get: function get() {
            return this.__colorBr;
        },
        set: function set(v) {
            if (this.__colorBr !== v) {
                val(this, "colorBr", v.toString(16), "ffffffff");
                this.__colorBr = v;
                checkColors(this);
            }
        }
    });
    Element.prototype.$texture = null;
    Object.defineProperty(Element.prototype, "__texture", {
        get: function get() {
            return this.$texture;
        },
        set: function set(v) {
            this.$texture = v;
            val(this, "rect", this.rect, false);
            val(this, "src", this.src, null);
        }
    });
    Element.prototype.$testId = null;
    Object.defineProperty(Element.prototype, "testId", {
        get: function get() {
            return this.$testId;
        },
        set: function set(v) {
            if (this.$testId !== v) {
                this.$testId = v;
                val(this, "data-testid", v, null);
            }
        }
    });
    var checkColors = function checkColors(elementRenderer) {
        var element = elementRenderer._element;
        if (elementRenderer._colorBr === undefined) {
            // Element initialization.
            return;
        }
        if (elementRenderer._colorUl === elementRenderer._colorUr && elementRenderer._colorUl === elementRenderer._colorBl && elementRenderer._colorUl === elementRenderer._colorBr) {
            if (elementRenderer._colorUl !== 0xffffffff) {
                element.dhtmlSetAttribute("color", elementRenderer._colorUl.toString(16));
            } else {
                element.dhtmlRemoveAttribute("color");
            }
            element.dhtmlRemoveAttribute("colorul");
            element.dhtmlRemoveAttribute("colorur");
            element.dhtmlRemoveAttribute("colorbl");
            element.dhtmlRemoveAttribute("colorbr");
        } else {
            val(element, "colorUr", elementRenderer.colorUr.toString(16), "ffffffff");
            val(element, "colorUl", elementRenderer.colorUl.toString(16), "ffffffff");
            val(element, "colorBr", elementRenderer.colorBr.toString(16), "ffffffff");
            val(element, "colorBl", elementRenderer.colorBl.toString(16), "ffffffff");
            element.dhtmlRemoveAttribute("color");
        }
    };
    ElementTexturizer.prototype.__enabled = false;
    Object.defineProperty(ElementTexturizer.prototype, "_enabled", {
        get: function get() {
            return this.__enabled;
        },
        set: function set(v) {
            if (this.__enabled !== v) {
                val(this, "renderToTexture", v, false);
                this.__enabled = v;
            }
        }
    });
    ElementTexturizer.prototype.__lazy = false;
    Object.defineProperty(ElementTexturizer.prototype, "_lazy", {
        get: function get() {
            return this.__lazy;
        },
        set: function set(v) {
            if (this.__lazy !== v) {
                val(this, "renderToTextureLazy", v, false);
                this.__lazy = v;
            }
        }
    });
    ElementTexturizer.prototype.__colorize = false;
    Object.defineProperty(ElementTexturizer.prototype, "_colorize", {
        get: function get() {
            return this.__colorize;
        },
        set: function set(v) {
            if (this.__colorize !== v) {
                val(this, "colorizeResultTexture", v, false);
                this.__colorize = v;
            }
        }
    });
    ElementTexturizer.prototype.__renderOffscreen = false;
    Object.defineProperty(ElementTexturizer.prototype, "_renderOffscreen", {
        get: function get() {
            return this.__renderOffscreen;
        },
        set: function set(v) {
            if (this.__renderOffscreen !== v) {
                val(this, "renderOffscreen", v, false);
                this.__renderOffscreen = v;
            }
        }
    });
    ElementCore.prototype.updateDebugTransforms = function() {
        var stage = this._element.stage;
        if (this._pivotX !== 0.5 || this._pivotY !== 0.5) {
            this.dhtml().style.transformOrigin = this._pivotX * 100 + "% " + this._pivotY * 100 + "%";
        } else if (this.dhtml().style.transformOrigin) {
            this.dhtml().style.transformOrigin = "50% 50%";
        }
        var r = this._rotation;
        var sx = this._scaleX;
        var sy = this._scaleY;
        if (sx !== undefined && sy !== undefined && this._element.id === 0) {
            // Root element: must be scaled.
            if (stage.options.w !== stage.options.renderWidth || stage.options.h !== stage.options.renderHeight) {
                sx *= stage.options.w / stage.options.renderWidth;
                sy *= stage.options.h / stage.options.renderHeight;
            }
        }
        var parts = [];
        if (r) parts.push("rotate(" + r + "rad)");
        if (sx !== undefined && sy !== undefined && (sx !== 1 || sy !== 1)) parts.push("scale(" + sx + ", " + sy + ")");
        this.dhtml().style.transform = parts.join(" ");
    };
    var updateTextureAttribs = function updateTextureAttribs(element) {
        if (element.texture) {
            var nonDefaults = element.texture.getNonDefaults();
            var keys = Object.keys(nonDefaults);
            keys.forEach(function(key) {
                var f = "";
                for(var i = 0, n = key.length; i < n; i++){
                    var c = key.charAt(i);
                    if (c !== c.toLowerCase()) {
                        f += "_" + c.toLowerCase();
                    } else {
                        f += c;
                    }
                }
                valStrict(element, "texture-".concat(f), nonDefaults[key], false);
            });
        }
    };
    var _performUpdateSource = Texture.prototype._performUpdateSource;
    Texture.prototype._performUpdateSource = function() {
        _performUpdateSource.apply(this, arguments);
        this.elements.forEach(function(v) {
            updateTextureAttribs(v);
        });
    };
    var _setDisplayedTexture = Element.prototype._setDisplayedTexture;
    Element.prototype._setDisplayedTexture = function() {
        _setDisplayedTexture.apply(this, arguments);
        updateTextureAttribs(this);
    };
    var _updateFocus = Application.prototype.__updateFocus;
    Application.prototype.__updateFocus = function() {
        var prev = this._focusPath && this._focusPath.length ? this._focusPath[this._focusPath.length - 1] : null;
        _updateFocus.apply(this, arguments);
        var focused = this._focusPath && this._focusPath.length ? this._focusPath[this._focusPath.length - 1] : null;
        if (prev != focused) {
            if (prev) {
                val(prev, "focused", false, false);
            }
            if (focused) {
                val(focused, "focused", true, false);
            }
        }
    };
};
if (window.lng) {
    // Automatically attach inspector if lng was already loaded.
    attachInspector(lng);
}


/***/ }),

/***/ 62950:
/***/ ((module) => {

module.exports = JSON.parse('{"name":"@lightningjs/sdk","version":"5.5.5","license":"Apache-2.0","types":"index.d.ts","scripts":{"postinstall":"node ./scripts/postinstall.js","lint":"eslint \'**/*.js\'","release":"npm publish --access public","typedoc":"typedoc --tsconfig tsconfig.typedoc.json","tsd":"tsd"},"lint-staged":{"*.js":["eslint --fix"],"src/startApp.js":["rollup -c ./rollup.config.js"]},"husky":{"hooks":{"pre-commit":"lint-staged"}},"dependencies":{"@babel/polyfill":"^7.11.5","@lightningjs/core":"^2.15.0","@metrological/sdk":"^1.0.2","@michieljs/execute-as-promise":"^1.0.0","deepmerge":"^4.2.2","is-plain-object":"^5.0.0","localcookies":"^2.0.0","shelljs":"^0.8.5","url-polyfill":"^1.1.10","whatwg-fetch":"^3.0.0"},"devDependencies":{"@babel/core":"^7.11.6","@babel/plugin-transform-parameters":"^7.10.5 ","@babel/plugin-transform-spread":"^7.11.0","@babel/preset-env":"^7.11.5","babel-eslint":"^10.1.0","eslint":"^7.10.0","eslint-config-prettier":"^6.12.0","eslint-plugin-prettier":"^3.1.4","husky":"^4.3.0","lint-staged":"^10.4.0","prettier":"^1.19.1","rollup":"^1.32.1","rollup-plugin-babel":"^4.4.0","tsd":"^0.22.0","typedoc":"^0.23.9"},"repository":{"type":"git","url":"git@github.com:rdkcentral/Lightning-SDK.git"},"bugs":{"url":"https://github.com/rdkcentral/Lightning-SDK/issues"}}');

/***/ })

}]);